const E = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    _ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    T = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    e = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    A = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    N = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    I = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    R = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    a = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    O = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    S = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    C = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    n = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    D = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    L = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    m = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    l = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    u = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    P = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    U = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    M = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    v = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    F = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    G = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    H = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    Y = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    t = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    V = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    o = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    B = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    r = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    s = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    i = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    W = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    c = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    K = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    d = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    p = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    y = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    X = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    Q = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    b = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    f = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    g = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    J = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    h = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    Z = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    j = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    x = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    k = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    w = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    z = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    q = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    $ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    EE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    _E = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    TE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    eE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    AE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    NE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    IE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    RE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    aE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    OE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    SE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    CE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    nE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    DE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    LE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    mE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    lE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    uE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    PE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    UE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    ME = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    vE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    FE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    GE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    HE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    YE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    tE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    VE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    oE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    BE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    rE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    sE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    iE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    WE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    cE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    KE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    dE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    pE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    yE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    XE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    QE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    bE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    fE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    gE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    JE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    hE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    ZE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    jE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    xE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    kE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    wE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    zE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    qE = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    $E = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    E_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    __ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    T_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    e_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    A_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    N_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    I_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    R_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    a_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    O_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    S_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    C_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    n_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    D_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    L_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    m_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    l_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    u_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    P_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    U_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    M_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    v_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    F_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    G_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    H_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    Y_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    t_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    V_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    o_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    B_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    r_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    s_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    i_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    W_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    c_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    K_ = /* @__PURE__ */ Object.freeze(
        /* @__PURE__ */ Object.defineProperty(
            {
                __proto__: null,
            },
            Symbol.toStringTag,
            { value: 'Module' }
        )
    ),
    d_ = {
        ADDED: { name: 'ADDED', value: 1 },
        ATTEMPTED_TO_ADD: { name: 'ATTEMPTED_TO_ADD', value: 3 },
        ATTEMPTED_TO_REMOVE: { name: 'ATTEMPTED_TO_REMOVE', value: 4 },
        REMOVED: { name: 'REMOVED', value: 2 },
    },
    p_ = { RULE_CONDITION: { name: 'RULE_CONDITION' }, RULE_EFFECT: { name: 'RULE_EFFECT' } },
    y_ = { ADD: { name: 'ADD' }, REPLACE: { name: 'REPLACE' }, UPDATE: { name: 'UPDATE' } },
    X_ = {
        ADDED_ATTACHMENT: { name: 'ADDED_ATTACHMENT', value: 137 },
        ADDITIONAL_CFS_CHANGED: { name: 'ADDITIONAL_CFS_CHANGED', value: 81 },
        ASSIGNED_BACKUP_UNITS: { name: 'ASSIGNED_BACKUP_UNITS', value: 7 },
        ASSIGNED_NEW_PRIMARY_UNIT: { name: 'ASSIGNED_NEW_PRIMARY_UNIT', value: 6 },
        ASSIGNED_TEMPORARY_UNIT: { name: 'ASSIGNED_TEMPORARY_UNIT', value: 59 },
        BOLO_CREATED: { name: 'BOLO_CREATED', value: 119 },
        BOLO_NARRATIVE_CREATED: { name: 'BOLO_NARRATIVE_CREATED', value: 123 },
        BOLO_NARRATIVE_DELETED: { name: 'BOLO_NARRATIVE_DELETED', value: 124 },
        BOLO_NARRATIVE_PINNED: { name: 'BOLO_NARRATIVE_PINNED', value: 145 },
        BOLO_NARRATIVE_UNPINNED: { name: 'BOLO_NARRATIVE_UNPINNED', value: 146 },
        BOLO_NARRATIVE_UPDATED: { name: 'BOLO_NARRATIVE_UPDATED', value: 141 },
        BOLO_PERSON_EDITED: { name: 'BOLO_PERSON_EDITED', value: 121 },
        BOLO_UPDATED: { name: 'BOLO_UPDATED', value: 120 },
        BOLO_VEHICLE_EDITED: { name: 'BOLO_VEHICLE_EDITED', value: 122 },
        CLEARED_EVENT: { name: 'CLEARED_EVENT', value: 24 },
        CLEARED_UNIT_LOCATION: { name: 'CLEARED_UNIT_LOCATION', value: 33 },
        CLEAR_UNIT_TIMER: { name: 'CLEAR_UNIT_TIMER', value: 66 },
        CREATED_HELD_EVENT: { name: 'CREATED_HELD_EVENT', value: 60 },
        CREATE_EVENT_ADD_TOWED_VEHICLE: { name: 'CREATE_EVENT_ADD_TOWED_VEHICLE', value: 21 },
        CREATE_UNIT_TIMER: { name: 'CREATE_UNIT_TIMER', value: 69 },
        DELETED_ATTACHMENT: { name: 'DELETED_ATTACHMENT', value: 138 },
        DEX_HIT_RETURNED_FOR_EVENT: { name: 'DEX_HIT_RETURNED_FOR_EVENT', value: 55 },
        DEX_RESULT_RETURNED_FOR_EVENT: { name: 'DEX_RESULT_RETURNED_FOR_EVENT', value: 54 },
        DISPOSITION_ADDITIONAL_ADDED: { name: 'DISPOSITION_ADDITIONAL_ADDED', value: 128 },
        DISPOSITION_ADDITIONAL_REMOVED: { name: 'DISPOSITION_ADDITIONAL_REMOVED', value: 129 },
        DISPOSITION_COMMENT_ADDED: { name: 'DISPOSITION_COMMENT_ADDED', value: 130 },
        DISPOSITION_COMMENT_REMOVED: { name: 'DISPOSITION_COMMENT_REMOVED', value: 131 },
        DISPOSITION_COMMENT_UPDATED: { name: 'DISPOSITION_COMMENT_UPDATED', value: 132 },
        DISPOSITION_PRIMARY_ADDED: { name: 'DISPOSITION_PRIMARY_ADDED', value: 125 },
        DISPOSITION_PRIMARY_REMOVED: { name: 'DISPOSITION_PRIMARY_REMOVED', value: 126 },
        DISPOSITION_PRIMARY_UPDATED: { name: 'DISPOSITION_PRIMARY_UPDATED', value: 127 },
        DRAFT_EVENT_COPY: { name: 'DRAFT_EVENT_COPY', value: 108 },
        EDIT_EVENT_ADD_DRUGS: { name: 'EDIT_EVENT_ADD_DRUGS', value: 113 },
        EDIT_EVENT_ADD_FIREARM: { name: 'EDIT_EVENT_ADD_FIREARM', value: 110 },
        EDIT_EVENT_ADD_OTHER_ITEM: { name: 'EDIT_EVENT_ADD_OTHER_ITEM', value: 116 },
        EDIT_EVENT_DELETE_DRUGS: { name: 'EDIT_EVENT_DELETE_DRUGS', value: 115 },
        EDIT_EVENT_DELETE_FIREARM: { name: 'EDIT_EVENT_DELETE_FIREARM', value: 112 },
        EDIT_EVENT_DELETE_OTHER_ITEM: { name: 'EDIT_EVENT_DELETE_OTHER_ITEM', value: 118 },
        EDIT_EVENT_DELETE_TOWED_VEHICLE: { name: 'EDIT_EVENT_DELETE_TOWED_VEHICLE', value: 23 },
        EDIT_EVENT_UPDATE_DRUGS: { name: 'EDIT_EVENT_UPDATE_DRUGS', value: 114 },
        EDIT_EVENT_UPDATE_FIREARM: { name: 'EDIT_EVENT_UPDATE_FIREARM', value: 111 },
        EDIT_EVENT_UPDATE_OTHER_ITEM: { name: 'EDIT_EVENT_UPDATE_OTHER_ITEM', value: 117 },
        EDIT_EVENT_UPDATE_TOWED_VEHICLE: { name: 'EDIT_EVENT_UPDATE_TOWED_VEHICLE', value: 22 },
        EVENT_ADDITIONAL_RADIO_CHANNEL_ADDED: {
            name: 'EVENT_ADDITIONAL_RADIO_CHANNEL_ADDED',
            value: 77,
        },
        EVENT_ADDITIONAL_RADIO_CHANNEL_CHANGED: {
            name: 'EVENT_ADDITIONAL_RADIO_CHANNEL_CHANGED',
            value: 79,
        },
        EVENT_ADDITIONAL_RADIO_CHANNEL_REMOVED: {
            name: 'EVENT_ADDITIONAL_RADIO_CHANNEL_REMOVED',
            value: 78,
        },
        EVENT_ADD_NARRATIVE: { name: 'EVENT_ADD_NARRATIVE', value: 14 },
        EVENT_ADD_NARRATIVE_HIGH_PRIORITY: { name: 'EVENT_ADD_NARRATIVE_HIGH_PRIORITY', value: 52 },
        EVENT_ADD_VEHICLE: { name: 'EVENT_ADD_VEHICLE', value: 18 },
        EVENT_ASSOCIATED: { name: 'EVENT_ASSOCIATED', value: 82 },
        EVENT_CREATED: { name: 'EVENT_CREATED', value: 40 },
        EVENT_DELETE_NARRATIVE: { name: 'EVENT_DELETE_NARRATIVE', value: 56 },
        EVENT_DELETE_VEHICLE: { name: 'EVENT_DELETE_VEHICLE', value: 20 },
        EVENT_EDIT_NARRATIVE: { name: 'EVENT_EDIT_NARRATIVE', value: 142 },
        EVENT_EDIT_VEHICLE: { name: 'EVENT_EDIT_VEHICLE', value: 19 },
        EVENT_HELD_TOW_VEHICLE: { name: 'EVENT_HELD_TOW_VEHICLE', value: 139 },
        EVENT_INFO_EDITED: { name: 'EVENT_INFO_EDITED', value: 48 },
        EVENT_INITIAL_NARRATIVE: { name: 'EVENT_INITIAL_NARRATIVE', value: 41 },
        EVENT_INVOLVED_PERSON_ADD: { name: 'EVENT_INVOLVED_PERSON_ADD', value: 97 },
        EVENT_INVOLVED_PERSON_DELETE: { name: 'EVENT_INVOLVED_PERSON_DELETE', value: 98 },
        EVENT_INVOLVED_PERSON_EDIT: { name: 'EVENT_INVOLVED_PERSON_EDIT', value: 99 },
        EVENT_LABEL_CHANGED: { name: 'EVENT_LABEL_CHANGED', value: 84 },
        EVENT_LINKED: { name: 'EVENT_LINKED', value: 43 },
        EVENT_PIN_NARRATIVE: { name: 'EVENT_PIN_NARRATIVE', value: 143 },
        EVENT_PRIMARY_RADIO_CHANNEL_CHANGED: {
            name: 'EVENT_PRIMARY_RADIO_CHANNEL_CHANGED',
            value: 80,
        },
        EVENT_REACTIVATED: { name: 'EVENT_REACTIVATED', value: 42 },
        EVENT_RELEASED_TOW_VEHICLE: { name: 'EVENT_RELEASED_TOW_VEHICLE', value: 140 },
        EVENT_REPORTING_PERSON_ADD: { name: 'EVENT_REPORTING_PERSON_ADD', value: 37 },
        EVENT_REPORTING_PERSON_DELETE: { name: 'EVENT_REPORTING_PERSON_DELETE', value: 38 },
        EVENT_REPORTING_PERSON_EDIT: { name: 'EVENT_REPORTING_PERSON_EDIT', value: 49 },
        EVENT_REPORTING_PERSON_EDIT_CAD_ENTITIES: {
            name: 'EVENT_REPORTING_PERSON_EDIT_CAD_ENTITIES',
            value: 39,
        },
        EVENT_REPORTING_PERSON_EDIT_RMS_ENTITIES: {
            name: 'EVENT_REPORTING_PERSON_EDIT_RMS_ENTITIES',
            value: 44,
        },
        EVENT_UNASSOCIATED: { name: 'EVENT_UNASSOCIATED', value: 83 },
        EVENT_UNLINKED: { name: 'EVENT_UNLINKED', value: 57 },
        EVENT_UNPIN_NARRATIVE: { name: 'EVENT_UNPIN_NARRATIVE', value: 144 },
        GEOFENCE_ACTIVATION: { name: 'GEOFENCE_ACTIVATION', value: 104 },
        GEOFENCE_ASSOCIATED_TO_EVENT: { name: 'GEOFENCE_ASSOCIATED_TO_EVENT', value: 101 },
        GEOFENCE_DEACTIVATION: { name: 'GEOFENCE_DEACTIVATION', value: 103 },
        GEOFENCE_PRIMARY_EVENT_CHANGED: { name: 'GEOFENCE_PRIMARY_EVENT_CHANGED', value: 91 },
        GEOFENCE_RULE_MANUALLY_CLEARED: { name: 'GEOFENCE_RULE_MANUALLY_CLEARED', value: 95 },
        GEOFENCE_RULE_MODIFIED: { name: 'GEOFENCE_RULE_MODIFIED', value: 94 },
        GEOFENCE_UNIT_ACTION: { name: 'GEOFENCE_UNIT_ACTION', value: 102 },
        GEO_BUFFER_ZONE_CREATED: { name: 'GEO_BUFFER_ZONE_CREATED', value: 90 },
        GEO_OBJECT_CREATED: { name: 'GEO_OBJECT_CREATED', value: 86 },
        GEO_OBJECT_MANUALLY_CLEARED: { name: 'GEO_OBJECT_MANUALLY_CLEARED', value: 96 },
        GEO_OBJECT_NAME_CHANGED: { name: 'GEO_OBJECT_NAME_CHANGED', value: 87 },
        GEO_OBJECT_PLACEMENT_CHANGED: { name: 'GEO_OBJECT_PLACEMENT_CHANGED', value: 88 },
        GEO_OBJECT_SCHEDULE_CHANGED: { name: 'GEO_OBJECT_SCHEDULE_CHANGED', value: 89 },
        GEO_OBJECT_STYLE_CHANGED: { name: 'GEO_OBJECT_STYLE_CHANGED', value: 92 },
        NO_ACCEPTED_UNITS_FOR_AED: { name: 'NO_ACCEPTED_UNITS_FOR_AED', value: 74 },
        NO_AVAILABLE_UNITS_FOR_AED: { name: 'NO_AVAILABLE_UNITS_FOR_AED', value: 73 },
        PREEMPTED_UNIT: { name: 'PREEMPTED_UNIT', value: 62 },
        PRIMARY_UNIT_TYPE_CHANGED: { name: 'PRIMARY_UNIT_TYPE_CHANGED', value: 85 },
        RADIO_TRAFFIC: { name: 'RADIO_TRAFFIC', value: 64 },
        RELEASED_HELD_UNIT: { name: 'RELEASED_HELD_UNIT', value: 61 },
        RELINQUISHED_AED_UNIT: { name: 'RELINQUISHED_AED_UNIT', value: 71 },
        RESET_UNIT_TIMER: { name: 'RESET_UNIT_TIMER', value: 67 },
        RESET_UNIT_TIMER_TO: { name: 'RESET_UNIT_TIMER_TO', value: 68 },
        RFA_ACTION: { name: 'RFA_ACTION', value: 107 },
        RFA_TIMEOUT: { name: 'RFA_TIMEOUT', value: 106 },
        RULE_ADDED_TO_GEOFENCE: { name: 'RULE_ADDED_TO_GEOFENCE', value: 93 },
        SCHEDULED_EVENT_ACTIVATED: { name: 'SCHEDULED_EVENT_ACTIVATED', value: 70 },
        SCHEDULED_EVENT_CREATION_INFO: { name: 'SCHEDULED_EVENT_CREATION_INFO', value: 105 },
        SELF_INITIATED_EVENT: { name: 'SELF_INITIATED_EVENT', value: 25 },
        SELF_INITIATE_ADD_INVOLVED_PERSON: {
            name: 'SELF_INITIATE_ADD_INVOLVED_PERSON',
            value: 100,
        },
        SELF_INITIATE_ADD_REPORTING_PERSON: {
            name: 'SELF_INITIATE_ADD_REPORTING_PERSON',
            value: 17,
        },
        SWAP_UNIT: { name: 'SWAP_UNIT', value: 65 },
        UNIT_ASSIGNED_TO_NON_EVENT_STATUS: { name: 'UNIT_ASSIGNED_TO_NON_EVENT_STATUS', value: 10 },
        UNIT_EMERGENCY_CREATED: { name: 'UNIT_EMERGENCY_CREATED', value: 133 },
        UNIT_EMERGENCY_RESOLVED: { name: 'UNIT_EMERGENCY_RESOLVED', value: 134 },
        UNIT_END_SHIFT: { name: 'UNIT_END_SHIFT', value: 16 },
        UNIT_EQUIPMENT_CHANGED: { name: 'UNIT_EQUIPMENT_CHANGED', value: 76 },
        UNIT_LOCATION_CHANGED: { name: 'UNIT_LOCATION_CHANGED', value: 11 },
        UNIT_LOCATION_COMMENTS_EDITED: { name: 'UNIT_LOCATION_COMMENTS_EDITED', value: 12 },
        UNIT_NOTES_CHANGED: { name: 'UNIT_NOTES_CHANGED', value: 75 },
        UNIT_PERSONNEL_CHANGED: { name: 'UNIT_PERSONNEL_CHANGED', value: 32 },
        UNIT_PUT_ON_DIRECTED_PATROL: { name: 'UNIT_PUT_ON_DIRECTED_PATROL', value: 2 },
        UNIT_PUT_ON_PATROL: { name: 'UNIT_PUT_ON_PATROL', value: 34 },
        UNIT_PUT_ON_SPECIAL_ASSIGNMENT: { name: 'UNIT_PUT_ON_SPECIAL_ASSIGNMENT', value: 4 },
        UNIT_PUT_ON_TRANSPORT: { name: 'UNIT_PUT_ON_TRANSPORT', value: 5 },
        UNIT_PUT_ON_VIRTUAL_PATROL: { name: 'UNIT_PUT_ON_VIRTUAL_PATROL', value: 3 },
        UNIT_STAFF_COUNT_CHANGED: { name: 'UNIT_STAFF_COUNT_CHANGED', value: 109 },
        UNIT_START_SHIFT: { name: 'UNIT_START_SHIFT', value: 15 },
        UNIT_VEHICLE_CHANGED: { name: 'UNIT_VEHICLE_CHANGED', value: 13 },
        UPDATED_CALL_FOR_SERVICE_FOR_EVENT: {
            name: 'UPDATED_CALL_FOR_SERVICE_FOR_EVENT',
            value: 26,
        },
        UPDATED_DISPATCH_AREA_OF_EVENT: { name: 'UPDATED_DISPATCH_AREA_OF_EVENT', value: 45 },
        UPDATED_DISPATCH_AREA_OF_UNIT: { name: 'UPDATED_DISPATCH_AREA_OF_UNIT', value: 46 },
        UPDATED_DISPATCH_AREA_OWNERSHIP: { name: 'UPDATED_DISPATCH_AREA_OWNERSHIP', value: 47 },
        UPDATED_LOCATION_NOTES: { name: 'UPDATED_LOCATION_NOTES', value: 72 },
        UPDATED_LOCATION_OF_EVENT: { name: 'UPDATED_LOCATION_OF_EVENT', value: 27 },
        UPDATED_ORIGIN_OF_EVENT: { name: 'UPDATED_ORIGIN_OF_EVENT', value: 28 },
        UPDATED_PRIORITY_OF_EVENT: { name: 'UPDATED_PRIORITY_OF_EVENT', value: 29 },
        UPDATED_QUEUE_FOR_EVENT: { name: 'UPDATED_QUEUE_FOR_EVENT', value: 30 },
        UPDATED_RISK_OF_EVENT: { name: 'UPDATED_RISK_OF_EVENT', value: 31 },
        UPDATED_UNIT_BEAT: { name: 'UPDATED_UNIT_BEAT', value: 53 },
        UPDATED_UNIT_COMMENTS: { name: 'UPDATED_UNIT_COMMENTS', value: 58 },
        UPDATED_UNIT_STATION: { name: 'UPDATED_UNIT_STATION', value: 50 },
        USER_ACKNOWLEDGED_UNIT_EMERGENCY: { name: 'USER_ACKNOWLEDGED_UNIT_EMERGENCY', value: 135 },
        USER_CHANGED_UNIT_EVENT_RELATED_STATUS: {
            name: 'USER_CHANGED_UNIT_EVENT_RELATED_STATUS',
            value: 8,
        },
        USER_EXPORTED_DEX_RESULTS: { name: 'USER_EXPORTED_DEX_RESULTS', value: 136 },
        USER_GENERATED_REN: { name: 'USER_GENERATED_REN', value: 1 },
        USER_MADE_DEX_INQUIRY: { name: 'USER_MADE_DEX_INQUIRY', value: 51 },
        USER_RELEASED_UNIT: { name: 'USER_RELEASED_UNIT', value: 9 },
        USER_UPDATED_PATROL: { name: 'USER_UPDATED_PATROL', value: 35 },
        USER_UPDATED_SPECIAL_ASSIGNMENT: { name: 'USER_UPDATED_SPECIAL_ASSIGNMENT', value: 36 },
    },
    Q_ = {
        HIGH_PRIORITY_UPDATE: { name: 'HIGH_PRIORITY_UPDATE', value: 2 },
        STANDARD_UPDATE: { name: 'STANDARD_UPDATE', value: 1 },
    },
    b_ = {
        EVENTS_CFS_CHANGED: { name: 'EVENTS_CFS_CHANGED', value: 5 },
        EVENTS_LOCATION_CHANGED: { name: 'EVENTS_LOCATION_CHANGED', value: 6 },
        PRIMARY_UNIT_ON_EVENT: { name: 'PRIMARY_UNIT_ON_EVENT', value: 1 },
        UNIT_RELEASED: { name: 'UNIT_RELEASED', value: 4 },
        UNIT_REPLACED: { name: 'UNIT_REPLACED', value: 3 },
        UNIT_STATE_CHANGE: { name: 'UNIT_STATE_CHANGE', value: 2 },
    },
    f_ = {
        LINKED_ADDITIONAL_INFO: { name: 'LINKED_ADDITIONAL_INFO', value: 4 },
        LINKED_NARRATIVE: { name: 'LINKED_NARRATIVE', value: 3 },
        PRO_QA: { name: 'PRO_QA', value: 5 },
        PRO_QA_COMMENT: { name: 'PRO_QA_COMMENT', value: 8 },
        PRO_QA_CRITICAL: { name: 'PRO_QA_CRITICAL', value: 10 },
        PRO_QA_DESC_INFO: { name: 'PRO_QA_DESC_INFO', value: 6 },
        PRO_QA_KEY_QUESTION: { name: 'PRO_QA_KEY_QUESTION', value: 7 },
        PRO_QA_SCRIPT: { name: 'PRO_QA_SCRIPT', value: 9 },
        PRO_QA_UPDATE: { name: 'PRO_QA_UPDATE', value: 11 },
        PRO_QA_URGENT: { name: 'PRO_QA_URGENT', value: 12 },
        SYSTEM: { name: 'SYSTEM', value: 2 },
        USER: { name: 'USER', value: 1 },
    },
    g_ = {
        ACCEPTABLE: { name: 'ACCEPTABLE' },
        LEGACY: { name: 'LEGACY' },
        OUTDATED_NEW_APP: { name: 'OUTDATED_NEW_APP' },
    },
    J_ = {
        NOT_ENOUGH_AVAILABLE_UNITS: { name: 'NOT_ENOUGH_AVAILABLE_UNITS', value: 2 },
        NOT_TRIGGERED: { name: 'NOT_TRIGGERED', value: 1 },
        NO_ACCEPTED_UNITS: { name: 'NO_ACCEPTED_UNITS', value: 3 },
    },
    h_ = {
        ACCEPTING: { name: 'ACCEPTING' },
        ATTEMPTING: { name: 'ATTEMPTING' },
        FAILED: { name: 'FAILED' },
        SUCCESS: { name: 'SUCCESS' },
    },
    Z_ = {
        ACKNOWLEDGED: { name: 'ACKNOWLEDGED', value: 2 },
        EVENT_CLEARED: { name: 'EVENT_CLEARED', value: 3 },
        REQUESTED: { name: 'REQUESTED', value: 1 },
    },
    j_ = { ADDITIONAL: { name: 'ADDITIONAL', value: 2 }, PRIMARY: { name: 'PRIMARY', value: 1 } },
    x_ = { UNIT_PILL_CLASSIC: { name: 'UNIT_PILL_CLASSIC', value: 1 } },
    k_ = { RAPIDSOS: { name: 'RAPIDSOS', value: 1 }, TELSTRA: { name: 'TELSTRA', value: 2 } },
    w_ = {
        BAIL_REASON: { name: 'BAIL_REASON', value: 'E_FILE_DECISION_BAIL_REASON' },
        CONDITION_IMPOSED_REASON: {
            name: 'CONDITION_IMPOSED_REASON',
            value: 'E_FILE_DECISION_CONDITION_IMPOSED_REASON',
        },
    },
    z_ = { COURT: { name: 'COURT', value: 'COURT' }, POLICE: { name: 'POLICE', value: 'POLICE' } },
    q_ = {
        MERGE: { name: 'MERGE', value: 'MERGE' },
        MODIFY_FILE_BUILD: { name: 'MODIFY_FILE_BUILD', value: 'MODIFY_FILE_BUILD' },
        SPLIT: { name: 'SPLIT', value: 'SPLIT' },
        START_FILE_BUILD: { name: 'START_FILE_BUILD', value: 'START_FILE_BUILD' },
        STOP_FILE_BUILD: { name: 'STOP_FILE_BUILD', value: 'STOP_FILE_BUILD' },
    },
    $_ = {
        APP: { name: 'APP', value: 'APP' },
        FIN: { name: 'FIN', value: 'FIN' },
        LIV: { name: 'LIV', value: 'LIV' },
        MON: { name: 'MON', value: 'MON' },
    },
    ET = {
        CH_CREATED: { name: 'CH_CREATED', value: 'CH_CREATED' },
        CM01: { name: 'CM01', value: 'CM01' },
        CM02: { name: 'CM02', value: 'CM02' },
        CM03: { name: 'CM03', value: 'CM03' },
        DM01_POST: { name: 'DM01_POST', value: 'DM01_POST' },
        DM01_PRE: { name: 'DM01_PRE', value: 'DM01_PRE' },
        FM01: { name: 'FM01', value: 'FM01' },
        FM02: { name: 'FM02', value: 'FM02' },
        FM03: { name: 'FM03', value: 'FM03' },
        LM01: { name: 'LM01', value: 'LM01' },
        LM02: { name: 'LM02', value: 'LM02' },
        LM03: { name: 'LM03', value: 'LM03' },
        LM04: { name: 'LM04', value: 'LM04' },
        LM04U: { name: 'LM04U', value: 'LM04U' },
        LM04U_POST: { name: 'LM04U_POST', value: 'LM04U_POST' },
        LM04_POST: { name: 'LM04_POST', value: 'LM04_POST' },
        LM05: { name: 'LM05', value: 'LM05' },
        LM06: { name: 'LM06', value: 'LM06' },
        LM07: { name: 'LM07', value: 'LM07' },
        LM07_FROM: { name: 'LM07_FROM', value: 'LM07_FROM' },
        LM08: { name: 'LM08', value: 'LM08' },
        WM01: { name: 'WM01', value: 'WM01' },
        WM01U: { name: 'WM01U', value: 'WM01U' },
        WM01U_POST: { name: 'WM01U_POST', value: 'WM01U_POST' },
        WM01_POST: { name: 'WM01_POST', value: 'WM01_POST' },
    },
    _T = {
        ALCOHOL_METHOD: { name: 'ALCOHOL_METHOD', value: 'E_FILE_ALCOHOL_METHOD' },
        OFFENSE_LOCATION_FORCE_STATION_CODE: {
            name: 'OFFENSE_LOCATION_FORCE_STATION_CODE',
            value: 'E_FILE_OFFENSE_LOCATION_FORCE_STATION_CODE',
        },
    },
    TT = {
        BETWEEN: { name: 'BETWEEN', value: 'BETWEEN' },
        ON: { name: 'ON', value: 'ON' },
        ON_OR_ABOUT: { name: 'ON_OR_ABOUT', value: 'ON_OR_ABOUT' },
        ON_OR_BEFORE: { name: 'ON_OR_BEFORE', value: 'ON_OR_BEFORE' },
    },
    eT = {
        CASE_DOCUMENT: { name: 'CASE_DOCUMENT', value: 'CASE_DOCUMENT' },
        COURT_HEARING_CREATED: { name: 'COURT_HEARING_CREATED', value: 'COURT_HEARING_CREATED' },
        DEFENDANT: { name: 'DEFENDANT', value: 'DEFENDANT' },
        EXHIBIT: { name: 'EXHIBIT', value: 'EXHIBIT' },
        FULL_FILE_SEND: { name: 'FULL_FILE_SEND', value: 'FULL_FILE_SEND' },
        INVOLVED_OFFICER: { name: 'INVOLVED_OFFICER', value: 'INVOLVED_OFFICER' },
        INVOLVED_PROFILE: { name: 'INVOLVED_PROFILE', value: 'INVOLVED_PROFILE' },
        PRE_CHARGE_DECISION: { name: 'PRE_CHARGE_DECISION', value: 'PRE_CHARGE_DECISION' },
        SEND_TO_CPS: { name: 'SEND_TO_CPS', value: 'SEND_TO_CPS' },
        SPLIT_MERGE_SYNCHRONIZATION: {
            name: 'SPLIT_MERGE_SYNCHRONIZATION',
            value: 'SPLIT_MERGE_SYNCHRONIZATION',
        },
        WITNESS_STATEMENT: { name: 'WITNESS_STATEMENT', value: 'WITNESS_STATEMENT' },
    },
    AT = {
        CONTACT_INFO_UPDATE: { name: 'CONTACT_INFO_UPDATE', value: 'CONTACT_INFO_UPDATE' },
        DELETION: { name: 'DELETION', value: 'DELETION' },
    },
    NT = {
        NONE: { name: 'NONE', value: 'NONE' },
        PROPERTY_INVOLVED: { name: 'PROPERTY_INVOLVED', value: 'PROPERTY_INVOLVED' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    IT = {
        COMPLETED: { name: 'COMPLETED', value: 'COMPLETED' },
        ERROR: { name: 'ERROR', value: 'ERROR' },
        IN_PROGRESS: { name: 'IN_PROGRESS', value: 'IN_PROGRESS' },
    },
    RT = {
        NUMBER_1: { name: 'NUMBER_1', value: 1 },
        NUMBER_2: { name: 'NUMBER_2', value: 2 },
        NUMBER_3: { name: 'NUMBER_3', value: 3 },
        NUMBER_4: { name: 'NUMBER_4', value: 4 },
    },
    aT = {
        AUTH: { name: 'AUTH', value: 4 },
        CAD: { name: 'CAD', value: 2 },
        DEX: { name: 'DEX', value: 3 },
        RMS: { name: 'RMS', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    OT = { CAD: { name: 'CAD', value: 1 }, FR: { name: 'FR', value: 2 } },
    ST = {
        CAD: { name: 'CAD' },
        CAD_NEXT: { name: 'CAD_NEXT' },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER' },
        FIRST_RESPONDER_NEXT: { name: 'FIRST_RESPONDER_NEXT' },
    },
    CT = { DEPARTMENT: { name: 'DEPARTMENT' }, GLOBAL: { name: 'GLOBAL' }, USER: { name: 'USER' } },
    nT = {
        DEFAULT: { name: 'DEFAULT', value: 1 },
        FINAL: { name: 'FINAL', value: 4 },
        SUPERVISOR: { name: 'SUPERVISOR', value: 2 },
        SUPERVISOR2: { name: 'SUPERVISOR2', value: 3 },
    },
    DT = {
        APPROVED: { name: 'APPROVED', value: 4 },
        APPROVED2: { name: 'APPROVED2', value: 5 },
        APPROVED3: { name: 'APPROVED3', value: 6 },
        APPROVED4: { name: 'APPROVED4', value: 7 },
        COMPLETED: { name: 'COMPLETED', value: 8 },
        DRAFT: { name: 'DRAFT', value: 1 },
        REJECTED: { name: 'REJECTED', value: 2 },
        SUBMITTED: { name: 'SUBMITTED', value: 3 },
    },
    LT = {
        APPROVED: { name: 'APPROVED', value: 4 },
        DRAFT: { name: 'DRAFT', value: 1 },
        REJECTED: { name: 'REJECTED', value: 2 },
        SUBMITTED: { name: 'SUBMITTED', value: 3 },
    },
    mT = { ROLE: { name: 'ROLE', value: 'ROLE' }, USER: { name: 'USER', value: 'USER' } },
    lT = {
        CREATE: { name: 'CREATE', value: 2 },
        DELETE: { name: 'DELETE', value: 3 },
        FILE_SCAN_FAILED: { name: 'FILE_SCAN_FAILED', value: 4 },
        UPDATE: { name: 'UPDATE', value: 1 },
    },
    uT = {
        EVENT_CREATION: { name: 'EVENT_CREATION', value: 1 },
        LOCATION_CHANGE: { name: 'LOCATION_CHANGE', value: 2 },
    },
    PT = {
        ACTIVE_DATE: { name: 'ACTIVE_DATE' },
        ATTRIBUTE_CODE: { name: 'ATTRIBUTE_CODE' },
        ATTRIBUTE_NAME: { name: 'ATTRIBUTE_NAME' },
        ATTRIBUTE_TYPE: { name: 'ATTRIBUTE_TYPE' },
        CODE_1: { name: 'CODE_1' },
        CODE_2: { name: 'CODE_2' },
        CODE_3: { name: 'CODE_3' },
        CODE_TYPE_1: { name: 'CODE_TYPE_1' },
        CODE_TYPE_2: { name: 'CODE_TYPE_2' },
        CODE_TYPE_3: { name: 'CODE_TYPE_3' },
        CODE_TYPE_SOURCE_1: { name: 'CODE_TYPE_SOURCE_1' },
        CODE_TYPE_SOURCE_2: { name: 'CODE_TYPE_SOURCE_2' },
        CODE_TYPE_SOURCE_3: { name: 'CODE_TYPE_SOURCE_3' },
        EXPIRATION_DATE: { name: 'EXPIRATION_DATE' },
        IS_DEFAULT: { name: 'IS_DEFAULT' },
        IS_ENABLED: { name: 'IS_ENABLED' },
        IS_NONE: { name: 'IS_NONE' },
        IS_OTHER: { name: 'IS_OTHER' },
        PARENT_ATTRIBUTE_CODE: { name: 'PARENT_ATTRIBUTE_CODE' },
        PARENT_ATTRIBUTE_NAME: { name: 'PARENT_ATTRIBUTE_NAME' },
        PARENT_ATTRIBUTE_TYPE: { name: 'PARENT_ATTRIBUTE_TYPE' },
    },
    UT = {
        DISPLAY_ABBREVIATION: { name: 'DISPLAY_ABBREVIATION' },
        DISPLAY_ABBREVIATION_AND_DISPLAY_VALUE: { name: 'DISPLAY_ABBREVIATION_AND_DISPLAY_VALUE' },
        DISPLAY_VALUE: { name: 'DISPLAY_VALUE' },
    },
    MT = {
        ARCHIVED: { name: 'ARCHIVED', value: 'ARCHIVED' },
        DISABLED: { name: 'DISABLED', value: 'DISABLED' },
        ENABLED: { name: 'ENABLED', value: 'ENABLED' },
    },
    vT = {
        ABUSE_TYPE: { name: 'ABUSE_TYPE', value: 432 },
        ACTION_AT_SCENE: { name: 'ACTION_AT_SCENE', value: 685 },
        ACTION_AT_SCENE_CATEGORY: { name: 'ACTION_AT_SCENE_CATEGORY', value: 706 },
        ADDITIONAL_OTHER_INFORMATION: { name: 'ADDITIONAL_OTHER_INFORMATION', value: 686 },
        ADMIN_PATROL: { name: 'ADMIN_PATROL', value: 362 },
        ADVISED_RIGHTS_RESPONSE: { name: 'ADVISED_RIGHTS_RESPONSE', value: 220 },
        AGENCY_TYPE: { name: 'AGENCY_TYPE', value: 324 },
        AGENCY_TYPE_GLOBAL: { name: 'AGENCY_TYPE_GLOBAL', value: 323 },
        AGGRAVATED_ASSAULT_CIRCUMSTANCE: { name: 'AGGRAVATED_ASSAULT_CIRCUMSTANCE', value: 37 },
        ALARM_LEVEL: { name: 'ALARM_LEVEL', value: 439 },
        ANIMAL_CRUELTY_CATEGORY: { name: 'ANIMAL_CRUELTY_CATEGORY', value: 4 },
        ANIMAL_SPECIES: { name: 'ANIMAL_SPECIES', value: 753 },
        ARRESTEE_WAS_ARMED_WITH: { name: 'ARRESTEE_WAS_ARMED_WITH', value: 205 },
        ARRESTING_AGENCY: { name: 'ARRESTING_AGENCY', value: 208 },
        ARRESTING_AGENCY_GLOBAL: { name: 'ARRESTING_AGENCY_GLOBAL', value: 212 },
        ARREST_ARRESTEE_SUSPECTED_USING: { name: 'ARREST_ARRESTEE_SUSPECTED_USING', value: 618 },
        ARREST_BASED_ON: { name: 'ARREST_BASED_ON', value: 442 },
        ARREST_DISPOSITION: { name: 'ARREST_DISPOSITION', value: 62 },
        ARREST_DISPOSITION_GLOBAL: { name: 'ARREST_DISPOSITION_GLOBAL', value: 200 },
        ARREST_STATISTICS: { name: 'ARREST_STATISTICS', value: 222 },
        ARREST_STATUS: { name: 'ARREST_STATUS', value: 646 },
        ARREST_TACTICS: { name: 'ARREST_TACTICS', value: 221 },
        ARREST_TYPE: { name: 'ARREST_TYPE', value: 263 },
        ARREST_TYPE_GLOBAL: { name: 'ARREST_TYPE_GLOBAL', value: 262 },
        ARTICLE_CATEGORY: { name: 'ARTICLE_CATEGORY', value: 765 },
        ARTICLE_TYPE_CODE: { name: 'ARTICLE_TYPE_CODE', value: 766 },
        BEHAVIORAL_CHARACTERISTIC: { name: 'BEHAVIORAL_CHARACTERISTIC', value: 128 },
        BEHAVIORAL_CHARACTERISTIC_GROUP: { name: 'BEHAVIORAL_CHARACTERISTIC_GROUP', value: 127 },
        BEHAVIORAL_CRISIS_DISPOSITION: { name: 'BEHAVIORAL_CRISIS_DISPOSITION', value: 394 },
        BEHAVIORAL_CRISIS_TECHNIQUES_USED: {
            name: 'BEHAVIORAL_CRISIS_TECHNIQUES_USED',
            value: 414,
        },
        BIAS_MOTIVATION: { name: 'BIAS_MOTIVATION', value: 8 },
        BIAS_MOTIVATION_CATEGORY: { name: 'BIAS_MOTIVATION_CATEGORY', value: 9 },
        BODY_PART: { name: 'BODY_PART', value: 56 },
        BOLO_CATEGORY: { name: 'BOLO_CATEGORY', value: 596 },
        BOLO_LABEL: { name: 'BOLO_LABEL', value: 738 },
        BOLO_LABEL_PRIORITY_GLOBAL: { name: 'BOLO_LABEL_PRIORITY_GLOBAL', value: 743 },
        BRANCH: { name: 'BRANCH', value: 115 },
        BUILD: { name: 'BUILD', value: 23 },
        BULLETIN_TYPE: { name: 'BULLETIN_TYPE', value: 261 },
        BULLETIN_TYPE_GLOBAL: { name: 'BULLETIN_TYPE_GLOBAL', value: 264 },
        BUREAU: { name: 'BUREAU', value: 80 },
        CAD_CALL_INPUT: { name: 'CAD_CALL_INPUT', value: 304 },
        CAD_EVENT_TYPE: { name: 'CAD_EVENT_TYPE', value: 244 },
        CAD_SECONDARY_EVENT_TYPE: { name: 'CAD_SECONDARY_EVENT_TYPE', value: 245 },
        CALL_TAKER_STATION: { name: 'CALL_TAKER_STATION', value: 361 },
        CAMPUS_VICTIM_CLASSIFICATION_DRUG_TYPE: {
            name: 'CAMPUS_VICTIM_CLASSIFICATION_DRUG_TYPE',
            value: 726,
        },
        CASE_ROLE_GLOBAL: { name: 'CASE_ROLE_GLOBAL', value: 134 },
        CASE_STATUS: { name: 'CASE_STATUS', value: 270 },
        CASE_STATUS_GLOBAL: { name: 'CASE_STATUS_GLOBAL', value: 129 },
        CAUTION: { name: 'CAUTION', value: 51 },
        CFS_PRIORITY: { name: 'CFS_PRIORITY', value: 303 },
        CFS_PRIORITY_GLOBAL: { name: 'CFS_PRIORITY_GLOBAL', value: 302 },
        CHARGE_STATUS: { name: 'CHARGE_STATUS', value: 640 },
        CITATION_CHARGE_RESULT: { name: 'CITATION_CHARGE_RESULT', value: 645 },
        CITATION_STATISTICS: { name: 'CITATION_STATISTICS', value: 381 },
        CITATION_TYPE: { name: 'CITATION_TYPE', value: 380 },
        CITIZENSHIP: { name: 'CITIZENSHIP', value: 45 },
        CLOTHING_TYPE: { name: 'CLOTHING_TYPE', value: 93 },
        COMMUNITY_INFORMATION_DISPOSITION: {
            name: 'COMMUNITY_INFORMATION_DISPOSITION',
            value: 309,
        },
        COMMUNITY_INFORMATION_OBTAINED_FROM: {
            name: 'COMMUNITY_INFORMATION_OBTAINED_FROM',
            value: 243,
        },
        COMMUNITY_INFORMATION_REASON_FOR_REPORT: {
            name: 'COMMUNITY_INFORMATION_REASON_FOR_REPORT',
            value: 315,
        },
        COMMUNITY_INFORMATION_STATISTICS: { name: 'COMMUNITY_INFORMATION_STATISTICS', value: 242 },
        COMPLAINT_OUTCOME: { name: 'COMPLAINT_OUTCOME', value: 824 },
        CONSENT_TYPE: { name: 'CONSENT_TYPE', value: 651 },
        CONTACT_INITIATION_TYPE: { name: 'CONTACT_INITIATION_TYPE', value: 819 },
        CONTRIBUTING_FACTORS_CATEGORY: { name: 'CONTRIBUTING_FACTORS_CATEGORY', value: 698 },
        COPLOGIC_CUSTOM_FIELD_MAPPING: { name: 'COPLOGIC_CUSTOM_FIELD_MAPPING', value: 389 },
        COUNTY_CODE: { name: 'COUNTY_CODE', value: 680 },
        COURT_CASE_PLACE_DETAINED_AT: { name: 'COURT_CASE_PLACE_DETAINED_AT', value: 318 },
        COURT_CODE: { name: 'COURT_CODE', value: 607 },
        COURT_CODE_GLOBAL: { name: 'COURT_CODE_GLOBAL', value: 606 },
        COURT_TYPE: { name: 'COURT_TYPE', value: 265 },
        COURT_TYPE_GLOBAL: { name: 'COURT_TYPE_GLOBAL', value: 118 },
        COURT_UNIT: { name: 'COURT_UNIT', value: 669 },
        CRASH_CONTRIBUTING_FACTOR: { name: 'CRASH_CONTRIBUTING_FACTOR', value: 734 },
        CRASH_FIXED_OBJECT_TYPE: { name: 'CRASH_FIXED_OBJECT_TYPE', value: 736 },
        CRASH_MUNICIPALITY_CODE: { name: 'CRASH_MUNICIPALITY_CODE', value: 735 },
        CRIME_CATEGORY_COMMITTED: { name: 'CRIME_CATEGORY_COMMITTED', value: 822 },
        CRIME_CATEGORY_SUSPECTED: { name: 'CRIME_CATEGORY_SUSPECTED', value: 821 },
        CRIMINAL_ACTIVITY_CATEGORY: { name: 'CRIMINAL_ACTIVITY_CATEGORY', value: 3 },
        CUSTOM_REPORT_CLASSIFICATION: { name: 'CUSTOM_REPORT_CLASSIFICATION', value: 246 },
        CYBER_CRIME_CATEGORY: { name: 'CYBER_CRIME_CATEGORY', value: 705 },
        DELETION_REASON: { name: 'DELETION_REASON', value: 763 },
        DELETION_REASON_GLOBAL: { name: 'DELETION_REASON_GLOBAL', value: 764 },
        DETENTION_NON_FILING_REASON_CODE: { name: 'DETENTION_NON_FILING_REASON_CODE', value: 718 },
        DETENTION_NON_FILING_TYPE: { name: 'DETENTION_NON_FILING_TYPE', value: 717 },
        DEX_EXPANDED_NAME_SEARCH_CODE: { name: 'DEX_EXPANDED_NAME_SEARCH_CODE', value: 739 },
        DEX_INQUIRY_PURPOSE_CODE: { name: 'DEX_INQUIRY_PURPOSE_CODE', value: 741 },
        DEX_WARRANT_TYPE: { name: 'DEX_WARRANT_TYPE', value: 418 },
        DIRECTED_PATROL: { name: 'DIRECTED_PATROL', value: 316 },
        DIRECTION_OF_ENTRY_1: { name: 'DIRECTION_OF_ENTRY_1', value: 664 },
        DIRECTION_OF_ENTRY_2: { name: 'DIRECTION_OF_ENTRY_2', value: 665 },
        DISPATCH_GROUP: { name: 'DISPATCH_GROUP', value: 396 },
        DISTRACTION_FRAUD_ACTIVITY: { name: 'DISTRACTION_FRAUD_ACTIVITY', value: 700 },
        DISTRACTION_FRAUD_ACTIVITY_CATEGORY: {
            name: 'DISTRACTION_FRAUD_ACTIVITY_CATEGORY',
            value: 699,
        },
        DIVISION: { name: 'DIVISION', value: 64 },
        DL_TYPE: { name: 'DL_TYPE', value: 47 },
        DNA_SAMPLE_TYPE: { name: 'DNA_SAMPLE_TYPE', value: 783 },
        DRIVER_LICENSE_ENDORSEMENT: { name: 'DRIVER_LICENSE_ENDORSEMENT', value: 135 },
        DRUGS_DATA_SOURCE: { name: 'DRUGS_DATA_SOURCE', value: 647 },
        DRUG_INVOLVEMENT: { name: 'DRUG_INVOLVEMENT', value: 712 },
        DRUG_MEASUREMENT: { name: 'DRUG_MEASUREMENT', value: 5 },
        DRUG_PRECURSOR_TYPE: { name: 'DRUG_PRECURSOR_TYPE', value: 728 },
        DRUG_TYPE: { name: 'DRUG_TYPE', value: 730 },
        EDUCATION_LEVEL: { name: 'EDUCATION_LEVEL', value: 325 },
        EMPLOYEE_TYPE: { name: 'EMPLOYEE_TYPE', value: 340 },
        ENTRY_POINT: { name: 'ENTRY_POINT', value: 589 },
        EQUIPMENT_TYPE: { name: 'EQUIPMENT_TYPE', value: 310 },
        ETHNICITY: { name: 'ETHNICITY', value: 6 },
        EVENT_CLEARING_DISPOSITION: { name: 'EVENT_CLEARING_DISPOSITION', value: 319 },
        EVENT_CLEARING_DISPOSITION_TYPE_GLOBAL: {
            name: 'EVENT_CLEARING_DISPOSITION_TYPE_GLOBAL',
            value: 609,
        },
        EVENT_COMMUNICATION_TYPE: { name: 'EVENT_COMMUNICATION_TYPE', value: 357 },
        EVENT_COMMUNICATION_TYPE_GLOBAL: { name: 'EVENT_COMMUNICATION_TYPE_GLOBAL', value: 356 },
        EVENT_ORIGIN: { name: 'EVENT_ORIGIN', value: 333 },
        EVENT_ORIGIN_GLOBAL: { name: 'EVENT_ORIGIN_GLOBAL', value: 332 },
        EVENT_STATISTICS: { name: 'EVENT_STATISTICS', value: 218 },
        EVENT_STATUS: { name: 'EVENT_STATUS', value: 335 },
        EVENT_STATUS_GLOBAL: { name: 'EVENT_STATUS_GLOBAL', value: 334 },
        EVIDENCE_FACILITY: { name: 'EVIDENCE_FACILITY', value: 326 },
        EVIDENCE_FACILITY_GLOBAL: { name: 'EVIDENCE_FACILITY_GLOBAL', value: 359 },
        EXHIBITING_BEHAVIOR: { name: 'EXHIBITING_BEHAVIOR', value: 413 },
        EXPORT_RELEASED_TO: { name: 'EXPORT_RELEASED_TO', value: 379 },
        EXTENDED_OFFENSE_SUSPECTED_ALCOHOL_USE: {
            name: 'EXTENDED_OFFENSE_SUSPECTED_ALCOHOL_USE',
            value: 713,
        },
        EXTERNAL_RECORD_SOURCE: { name: 'EXTERNAL_RECORD_SOURCE', value: 392 },
        EXTERNAL_STATUS: { name: 'EXTERNAL_STATUS', value: 586 },
        EYE_COLOR: { name: 'EYE_COLOR', value: 36 },
        E_FILE_ALCOHOL_METHOD: { name: 'E_FILE_ALCOHOL_METHOD', value: 747 },
        E_FILE_ANTICIPATED_PLEA: { name: 'E_FILE_ANTICIPATED_PLEA', value: 784 },
        E_FILE_BAIL_DENIAL_REASON: { name: 'E_FILE_BAIL_DENIAL_REASON', value: 781 },
        E_FILE_BAIL_TYPE: { name: 'E_FILE_BAIL_TYPE', value: 815 },
        E_FILE_BAIL_TYPE_GLOBAL: { name: 'E_FILE_BAIL_TYPE_GLOBAL', value: 814 },
        E_FILE_CLASSIFICATION: { name: 'E_FILE_CLASSIFICATION', value: 670 },
        E_FILE_COURT_BAIL_CONDITION_TYPE: { name: 'E_FILE_COURT_BAIL_CONDITION_TYPE', value: 795 },
        E_FILE_COURT_HEARING_FINDING_FINDING: {
            name: 'E_FILE_COURT_HEARING_FINDING_FINDING',
            value: 773,
        },
        E_FILE_COURT_HEARING_FINDING_MODE_OF_TRIAL: {
            name: 'E_FILE_COURT_HEARING_FINDING_MODE_OF_TRIAL',
            value: 772,
        },
        E_FILE_COURT_HEARING_FINDING_PLEA: {
            name: 'E_FILE_COURT_HEARING_FINDING_PLEA',
            value: 771,
        },
        E_FILE_COURT_HEARING_FINDING_RESULT_BAIL_STATUS: {
            name: 'E_FILE_COURT_HEARING_FINDING_RESULT_BAIL_STATUS',
            value: 775,
        },
        E_FILE_COURT_HEARING_FINDING_RESULT_DURATION_UNIT: {
            name: 'E_FILE_COURT_HEARING_FINDING_RESULT_DURATION_UNIT',
            value: 777,
        },
        E_FILE_COURT_HEARING_FINDING_RESULT_QUALIFIER: {
            name: 'E_FILE_COURT_HEARING_FINDING_RESULT_QUALIFIER',
            value: 776,
        },
        E_FILE_COURT_HEARING_FINDING_RESULT_RESULT_CODE: {
            name: 'E_FILE_COURT_HEARING_FINDING_RESULT_RESULT_CODE',
            value: 774,
        },
        E_FILE_DECISION_BAIL_REASON: { name: 'E_FILE_DECISION_BAIL_REASON', value: 758 },
        E_FILE_DECISION_BAIL_REASON_GLOBAL: {
            name: 'E_FILE_DECISION_BAIL_REASON_GLOBAL',
            value: 813,
        },
        E_FILE_DECISION_CONDITIONAL_CAUTION_CONDITION_TYPE: {
            name: 'E_FILE_DECISION_CONDITIONAL_CAUTION_CONDITION_TYPE',
            value: 761,
        },
        E_FILE_DECISION_CONDITION_IMPOSED_REASON: {
            name: 'E_FILE_DECISION_CONDITION_IMPOSED_REASON',
            value: 759,
        },
        E_FILE_DECISION_NFA_MADE_BY: { name: 'E_FILE_DECISION_NFA_MADE_BY', value: 757 },
        E_FILE_DECISION_NFA_REASON: { name: 'E_FILE_DECISION_NFA_REASON', value: 756 },
        E_FILE_DECISION_POLICE_BAIL_CONDITION_TYPE: {
            name: 'E_FILE_DECISION_POLICE_BAIL_CONDITION_TYPE',
            value: 762,
        },
        E_FILE_DOCUMENT_CONFIGURATION_TYPE: {
            name: 'E_FILE_DOCUMENT_CONFIGURATION_TYPE',
            value: 755,
        },
        E_FILE_DOCUMENT_CONFIGURATION_TYPE_GLOBAL: {
            name: 'E_FILE_DOCUMENT_CONFIGURATION_TYPE_GLOBAL',
            value: 768,
        },
        E_FILE_DOCUMENT_STATUS: { name: 'E_FILE_DOCUMENT_STATUS', value: 779 },
        E_FILE_DOCUMENT_STATUS_GLOBAL: { name: 'E_FILE_DOCUMENT_STATUS_GLOBAL', value: 780 },
        E_FILE_FILE_TYPE: { name: 'E_FILE_FILE_TYPE', value: 745 },
        E_FILE_MATERIAL_CLASSIFICATION: { name: 'E_FILE_MATERIAL_CLASSIFICATION', value: 787 },
        E_FILE_MATERIAL_EVIDENCE: { name: 'E_FILE_MATERIAL_EVIDENCE', value: 786 },
        E_FILE_MATERIAL_EVIDENCE_GLOBAL: { name: 'E_FILE_MATERIAL_EVIDENCE_GLOBAL', value: 785 },
        E_FILE_MATERIAL_SENSITIVE_BY_CPIA: {
            name: 'E_FILE_MATERIAL_SENSITIVE_BY_CPIA',
            value: 788,
        },
        E_FILE_MOVEMENT_STATUS: { name: 'E_FILE_MOVEMENT_STATUS', value: 746 },
        E_FILE_OFFENSE_BAIL_ANSWER_TYPE: { name: 'E_FILE_OFFENSE_BAIL_ANSWER_TYPE', value: 805 },
        E_FILE_OFFENSE_BAIL_STATUS: { name: 'E_FILE_OFFENSE_BAIL_STATUS', value: 770 },
        E_FILE_OFFENSE_BAIL_STATUS_GLOBAL: {
            name: 'E_FILE_OFFENSE_BAIL_STATUS_GLOBAL',
            value: 769,
        },
        E_FILE_OFFENSE_DECISION_TYPE_GLOBAL: {
            name: 'E_FILE_OFFENSE_DECISION_TYPE_GLOBAL',
            value: 754,
        },
        E_FILE_OFFENSE_LOCATION_FORCE_STATION_CODE: {
            name: 'E_FILE_OFFENSE_LOCATION_FORCE_STATION_CODE',
            value: 782,
        },
        E_FILE_OFFICER_NON_AVAILABILITY_DATES_REASON: {
            name: 'E_FILE_OFFICER_NON_AVAILABILITY_DATES_REASON',
            value: 800,
        },
        E_FILE_PERSON_TYPE: { name: 'E_FILE_PERSON_TYPE', value: 789 },
        E_FILE_PERSON_TYPE_GLOBAL: { name: 'E_FILE_PERSON_TYPE_GLOBAL', value: 790 },
        E_FILE_POLICE_POST_CHARGE_REMAND_STATUS: {
            name: 'E_FILE_POLICE_POST_CHARGE_REMAND_STATUS',
            value: 803,
        },
        E_FILE_POLICE_POST_CHARGE_REMAND_STATUS_GLOBAL: {
            name: 'E_FILE_POLICE_POST_CHARGE_REMAND_STATUS_GLOBAL',
            value: 804,
        },
        E_FILE_REASON_FOR_ASSOCIATION: { name: 'E_FILE_REASON_FOR_ASSOCIATION', value: 744 },
        E_FILE_REMAND_STATUS: { name: 'E_FILE_REMAND_STATUS', value: 751 },
        E_FILE_REMAND_STATUS_GLOBAL: { name: 'E_FILE_REMAND_STATUS_GLOBAL', value: 760 },
        E_FILE_ROLE_INVOLVEMENT_TYPE: { name: 'E_FILE_ROLE_INVOLVEMENT_TYPE', value: 668 },
        E_FILE_SPLIT_MERGE_RELATED: { name: 'E_FILE_SPLIT_MERGE_RELATED', value: 802 },
        E_FILE_SPLIT_MERGE_STATUS: { name: 'E_FILE_SPLIT_MERGE_STATUS', value: 801 },
        E_FILE_STATUS: { name: 'E_FILE_STATUS', value: 667 },
        E_FILE_STATUS_CHANGE_REASON: { name: 'E_FILE_STATUS_CHANGE_REASON', value: 827 },
        E_FILE_STATUS_GLOBAL: { name: 'E_FILE_STATUS_GLOBAL', value: 794 },
        E_FILE_TYPE_OF_WITNESS: { name: 'E_FILE_TYPE_OF_WITNESS', value: 793 },
        E_FILE_TYPE_OF_WITNESS_GLOBAL: { name: 'E_FILE_TYPE_OF_WITNESS_GLOBAL', value: 796 },
        E_FILE_VICTIM_WITNESS_KEY_WITNESS: {
            name: 'E_FILE_VICTIM_WITNESS_KEY_WITNESS',
            value: 828,
        },
        FACIAL_HAIR_TYPE: { name: 'FACIAL_HAIR_TYPE', value: 60 },
        FEDERAL_JUDICIAL_DISTRICT: { name: 'FEDERAL_JUDICIAL_DISTRICT', value: 752 },
        FIELD_CONTACT_DISPOSITION: { name: 'FIELD_CONTACT_DISPOSITION', value: 82 },
        FIELD_CONTACT_REASON_FOR_STOP: { name: 'FIELD_CONTACT_REASON_FOR_STOP', value: 81 },
        FIELD_CONTACT_SUBJECT_TYPE: { name: 'FIELD_CONTACT_SUBJECT_TYPE', value: 241 },
        FIELD_CONTACT_TYPE: { name: 'FIELD_CONTACT_TYPE', value: 96 },
        FIELD_CONTACT_TYPE_GLOBAL: { name: 'FIELD_CONTACT_TYPE_GLOBAL', value: 395 },
        FIREARM_GRIP: { name: 'FIREARM_GRIP', value: 113 },
        FIREARM_MAKE: { name: 'FIREARM_MAKE', value: 87 },
        FIREARM_MODEL_NUMBER_LOCATION: { name: 'FIREARM_MODEL_NUMBER_LOCATION', value: 623 },
        FIREARM_SERIAL_NUMBER_LOCATION: { name: 'FIREARM_SERIAL_NUMBER_LOCATION', value: 622 },
        FIREARM_STOCK: { name: 'FIREARM_STOCK', value: 112 },
        FORCE_IDENTIFIER: { name: 'FORCE_IDENTIFIER', value: 748 },
        GANG_CRITERIA: { name: 'GANG_CRITERIA', value: 402 },
        GANG_INFORMATION: { name: 'GANG_INFORMATION', value: 206 },
        GANG_NAME: { name: 'GANG_NAME', value: 403 },
        GANG_SUBGROUP: { name: 'GANG_SUBGROUP', value: 404 },
        GUN_TYPE_CATEGORY: { name: 'GUN_TYPE_CATEGORY', value: 767 },
        HAIR_COLOR: { name: 'HAIR_COLOR', value: 25 },
        HAIR_LENGTH: { name: 'HAIR_LENGTH', value: 58 },
        HAIR_STYLE: { name: 'HAIR_STYLE', value: 59 },
        HATE_CRIME_OFFENSIVE_ACT: { name: 'HATE_CRIME_OFFENSIVE_ACT', value: 454 },
        HOMICIDE_CIRCUMSTANCE: { name: 'HOMICIDE_CIRCUMSTANCE', value: 38 },
        HONOR_BASED_ABUSE_TYPE: { name: 'HONOR_BASED_ABUSE_TYPE', value: 691 },
        HOSPITAL_CAPABILITY: { name: 'HOSPITAL_CAPABILITY', value: 722 },
        HOSPITAL_STATUS: { name: 'HOSPITAL_STATUS', value: 721 },
        HOSPITAL_STATUS_GLOBAL: { name: 'HOSPITAL_STATUS_GLOBAL', value: 720 },
        HOW_AGGRESSOR_WAS_IDENTIFIED: { name: 'HOW_AGGRESSOR_WAS_IDENTIFIED', value: 437 },
        IDENTIFYING_MARK_TYPE: { name: 'IDENTIFYING_MARK_TYPE', value: 84 },
        IMPLEMENT_WEAPON_CATEGORY: { name: 'IMPLEMENT_WEAPON_CATEGORY', value: 696 },
        IMPLEMENT_WEAPON_INVOLVED: { name: 'IMPLEMENT_WEAPON_INVOLVED', value: 688 },
        INCIDENT_STATISTIC: { name: 'INCIDENT_STATISTIC', value: 193 },
        INDEMNITY_OBTAINED_TYPE: { name: 'INDEMNITY_OBTAINED_TYPE', value: 626 },
        INDUSTRY: { name: 'INDUSTRY', value: 94 },
        INFANT_AGE: { name: 'INFANT_AGE', value: 644 },
        INFORMATION_COLLECTED: { name: 'INFORMATION_COLLECTED', value: 820 },
        INFORMATION_PROVIDED_TO_VICTIM: { name: 'INFORMATION_PROVIDED_TO_VICTIM', value: 55 },
        INJURY_CATEGORY: { name: 'INJURY_CATEGORY', value: 11 },
        INJURY_FATAL_GLOBAL: { name: 'INJURY_FATAL_GLOBAL', value: 211 },
        INTERNAL_WARRANT_STATUS: { name: 'INTERNAL_WARRANT_STATUS', value: 409 },
        INTERNET_INVOLVEMENT_TYPE: { name: 'INTERNET_INVOLVEMENT_TYPE', value: 671 },
        INVESTIGATION_OUTCOME: { name: 'INVESTIGATION_OUTCOME', value: 825 },
        INVESTIGATION_SEVERITY: { name: 'INVESTIGATION_SEVERITY', value: 450 },
        INVESTIGATION_TYPE: { name: 'INVESTIGATION_TYPE', value: 449 },
        ISSUING_AGENCY_NAME: { name: 'ISSUING_AGENCY_NAME', value: 419 },
        IS_PREGNANT: { name: 'IS_PREGNANT', value: 750 },
        ITEM_CATEGORY: { name: 'ITEM_CATEGORY', value: 19 },
        ITEM_COLOR: { name: 'ITEM_COLOR', value: 42 },
        ITEM_IDENTIFIER_TYPE: { name: 'ITEM_IDENTIFIER_TYPE', value: 373 },
        ITEM_IDENTIFIER_TYPE_GLOBAL: { name: 'ITEM_IDENTIFIER_TYPE_GLOBAL', value: 374 },
        ITEM_TYPE: { name: 'ITEM_TYPE', value: 26 },
        JUSTIFIABLE_HOMICIDE_CIRCUMSTANCE: { name: 'JUSTIFIABLE_HOMICIDE_CIRCUMSTANCE', value: 12 },
        JUVENILE_DISPOSITION: { name: 'JUVENILE_DISPOSITION', value: 32 },
        LAB_TEST_STATUS: { name: 'LAB_TEST_STATUS', value: 225 },
        LANGUAGE: { name: 'LANGUAGE', value: 192 },
        LARCENY_TYPE: { name: 'LARCENY_TYPE', value: 673 },
        LEGACY_CHARGE_SOURCE: { name: 'LEGACY_CHARGE_SOURCE', value: 226 },
        LEGACY_CLASSIFICATION_CODE: { name: 'LEGACY_CLASSIFICATION_CODE', value: 678 },
        LEGACY_MIGRATION_STATISTIC: { name: 'LEGACY_MIGRATION_STATISTIC', value: 679 },
        LEGACY_REPORT_SUB_TYPE: { name: 'LEGACY_REPORT_SUB_TYPE', value: 677 },
        LEGACY_REPORT_TYPE: { name: 'LEGACY_REPORT_TYPE', value: 676 },
        LEGACY_SYSTEM: { name: 'LEGACY_SYSTEM', value: 675 },
        LEGISLATIVE_LANGUAGE: { name: 'LEGISLATIVE_LANGUAGE', value: 662 },
        LEOKA_ACTIVITY_CATEGORY: { name: 'LEOKA_ACTIVITY_CATEGORY', value: 13 },
        LEOKA_ASSAULT_STATUS: { name: 'LEOKA_ASSAULT_STATUS', value: 817 },
        LEOKA_ASSIGNMENT_CATEGORY: { name: 'LEOKA_ASSIGNMENT_CATEGORY', value: 14 },
        LEOKA_OTHER_JURISDICTION_ORI: { name: 'LEOKA_OTHER_JURISDICTION_ORI', value: 724 },
        LICENSE_PLATE_TYPE_CODE: { name: 'LICENSE_PLATE_TYPE_CODE', value: 740 },
        LICENSE_STATUS: { name: 'LICENSE_STATUS', value: 92 },
        LOCATION_CATEGORY: { name: 'LOCATION_CATEGORY', value: 15 },
        LOCATION_CAUTION: { name: 'LOCATION_CAUTION', value: 372 },
        LOCATION_CAUTION_CATEGORY: { name: 'LOCATION_CAUTION_CATEGORY', value: 371 },
        LOCATION_CAUTION_PRIORITY: { name: 'LOCATION_CAUTION_PRIORITY', value: 370 },
        LOCATION_INTEREST_TYPE: { name: 'LOCATION_INTEREST_TYPE', value: 597 },
        LOCATION_POSITION: { name: 'LOCATION_POSITION', value: 577 },
        LOCATION_PROPERTY_TYPE: { name: 'LOCATION_PROPERTY_TYPE', value: 189 },
        LOCATION_TYPE_OF_MARIJUANA_SEIZURE_TYPE: {
            name: 'LOCATION_TYPE_OF_MARIJUANA_SEIZURE_TYPE',
            value: 727,
        },
        MARITAL_STATUS: { name: 'MARITAL_STATUS', value: 46 },
        MAX_TIME_SPENT_IN_STATUS: { name: 'MAX_TIME_SPENT_IN_STATUS', value: 313 },
        MEANS_OF_APPROACH: { name: 'MEANS_OF_APPROACH', value: 684 },
        MEANS_OF_APPROACH_CATEGORY: { name: 'MEANS_OF_APPROACH_CATEGORY', value: 702 },
        MEDICAL_FACILITY: { name: 'MEDICAL_FACILITY', value: 416 },
        MEDICAL_STATISTICS: { name: 'MEDICAL_STATISTICS', value: 219 },
        MEDICAL_TRANSPORT_TYPE: { name: 'MEDICAL_TRANSPORT_TYPE', value: 185 },
        MEDICAL_TREATMENT_RECEIVED: { name: 'MEDICAL_TREATMENT_RECEIVED', value: 54 },
        METHOD_OF_ENTRY_EXIT: { name: 'METHOD_OF_ENTRY_EXIT', value: 681 },
        METHOD_OF_ENTRY_EXIT_CATEGORY: { name: 'METHOD_OF_ENTRY_EXIT_CATEGORY', value: 701 },
        MILITARY_BRANCH: { name: 'MILITARY_BRANCH', value: 375 },
        MISSING_PERSON_ADDITIONAL_INFO: { name: 'MISSING_PERSON_ADDITIONAL_INFO', value: 217 },
        MISSING_PERSON_CRITICALITY: { name: 'MISSING_PERSON_CRITICALITY', value: 447 },
        MISSING_PERSON_STATUS: { name: 'MISSING_PERSON_STATUS', value: 133 },
        MISSING_PERSON_TYPE: { name: 'MISSING_PERSON_TYPE', value: 204 },
        MODE_OF_TRIAL: { name: 'MODE_OF_TRIAL', value: 660 },
        MODUS_OPERANDI: { name: 'MODUS_OPERANDI', value: 124 },
        MODUS_OPERANDI_GROUP: { name: 'MODUS_OPERANDI_GROUP', value: 376 },
        MOOD: { name: 'MOOD', value: 53 },
        MOPI_REVIEW_GROUP: { name: 'MOPI_REVIEW_GROUP', value: 661 },
        NAME_IDENTIFIER_TYPE: { name: 'NAME_IDENTIFIER_TYPE', value: 363 },
        NAME_IDENTIFIER_TYPE_GLOBAL: { name: 'NAME_IDENTIFIER_TYPE_GLOBAL', value: 364 },
        NAME_ITEM_ASSOCIATION: { name: 'NAME_ITEM_ASSOCIATION', value: 401 },
        NAME_ITEM_ASSOCIATION_GLOBAL: { name: 'NAME_ITEM_ASSOCIATION_GLOBAL', value: 400 },
        NCIC_FIREARM_CALIBER_TYPE: { name: 'NCIC_FIREARM_CALIBER_TYPE', value: 630 },
        NEGLIGENT_MANSLAUGHTER_CIRCUMSTANCE: {
            name: 'NEGLIGENT_MANSLAUGHTER_CIRCUMSTANCE',
            value: 39,
        },
        NIBRS_WARRANT_TYPE: { name: 'NIBRS_WARRANT_TYPE', value: 725 },
        NJ_BIAS_DESCRIPTION: { name: 'NJ_BIAS_DESCRIPTION', value: 637 },
        OBJECT_OF_SEARCH: { name: 'OBJECT_OF_SEARCH', value: 588 },
        OFFENDER_CONTRIBUTING_FACTORS: { name: 'OFFENDER_CONTRIBUTING_FACTORS', value: 682 },
        OFFENDER_HOUSEHOLD_STATUS: { name: 'OFFENDER_HOUSEHOLD_STATUS', value: 629 },
        OFFENSE_CASE_STATUS: { name: 'OFFENSE_CASE_STATUS', value: 603 },
        OFFENSE_CLASSIFICATION: { name: 'OFFENSE_CLASSIFICATION', value: 240 },
        OFFENSE_CODE_LEVEL: { name: 'OFFENSE_CODE_LEVEL', value: 453 },
        OFFENSE_CODE_STATUTE_CODE_SET: { name: 'OFFENSE_CODE_STATUTE_CODE_SET', value: 213 },
        OFFENSE_CODE_TYPE: { name: 'OFFENSE_CODE_TYPE', value: 452 },
        OFFENSE_SCENE_OF_CRIME_LOCATION: { name: 'OFFENSE_SCENE_OF_CRIME_LOCATION', value: 710 },
        OFFENSE_SCENE_OF_CRIME_LOCATION_CATEGORY: {
            name: 'OFFENSE_SCENE_OF_CRIME_LOCATION_CATEGORY',
            value: 709,
        },
        OFFENSE_SPECIAL_CIRCUMSTANCE: { name: 'OFFENSE_SPECIAL_CIRCUMSTANCE', value: 818 },
        OFFENSE_STATISTIC: { name: 'OFFENSE_STATISTIC', value: 194 },
        OFFENSE_STATUS: { name: 'OFFENSE_STATUS', value: 27 },
        OFFICER_ASSIST_TYPE: { name: 'OFFICER_ASSIST_TYPE', value: 131 },
        OFFICER_DRESS: { name: 'OFFICER_DRESS', value: 351 },
        OFFICER_EMPLOYMENT_TYPE: { name: 'OFFICER_EMPLOYMENT_TYPE', value: 601 },
        ORGANIZATION_TYPE: { name: 'ORGANIZATION_TYPE', value: 95 },
        ORGANIZATION_TYPE_GLOBAL: { name: 'ORGANIZATION_TYPE_GLOBAL', value: 260 },
        ORIGIN_OF_DRUG_TYPE: { name: 'ORIGIN_OF_DRUG_TYPE', value: 729 },
        OTHER_MODUS_OPERANDI: { name: 'OTHER_MODUS_OPERANDI', value: 714 },
        OTHER_MODUS_OPERANDI_CATEGORY: { name: 'OTHER_MODUS_OPERANDI_CATEGORY', value: 715 },
        PERSONNEL_UNIT: { name: 'PERSONNEL_UNIT', value: 65 },
        PERSON_FLAG: { name: 'PERSON_FLAG', value: 797 },
        PERSON_FLAG_GLOBAL: { name: 'PERSON_FLAG_GLOBAL', value: 798 },
        PERSON_LABEL_ATTRIBUTES: { name: 'PERSON_LABEL_ATTRIBUTES', value: 431 },
        PERSON_LABEL_CATEGORY: { name: 'PERSON_LABEL_CATEGORY', value: 430 },
        PERSON_LABEL_PRIORITY: { name: 'PERSON_LABEL_PRIORITY', value: 429 },
        PERSON_SKILL: { name: 'PERSON_SKILL', value: 191 },
        PHONE_MAKE: { name: 'PHONE_MAKE', value: 307 },
        PHONE_MODEL: { name: 'PHONE_MODEL', value: 308 },
        PHONE_SERVICE_STATUS: { name: 'PHONE_SERVICE_STATUS', value: 625 },
        PHYSICAL_CHARACTERISTIC: { name: 'PHYSICAL_CHARACTERISTIC', value: 126 },
        PHYSICAL_CHARACTERISTIC_GROUP: { name: 'PHYSICAL_CHARACTERISTIC_GROUP', value: 125 },
        PNC_CODE: { name: 'PNC_CODE', value: 659 },
        PNC_REQUEST_REASON_CODE: { name: 'PNC_REQUEST_REASON_CODE', value: 816 },
        POINT_OF_ENTRY_EXIT: { name: 'POINT_OF_ENTRY_EXIT', value: 690 },
        POINT_OF_ENTRY_EXIT_CATEGORY: { name: 'POINT_OF_ENTRY_EXIT_CATEGORY', value: 697 },
        POLICE_ACTION: { name: 'POLICE_ACTION', value: 434 },
        POLICE_ACTION_GLOBAL: { name: 'POLICE_ACTION_GLOBAL', value: 448 },
        PREVIOUS_COMPLAINTS: { name: 'PREVIOUS_COMPLAINTS', value: 435 },
        PRIORITY_GLOBAL: { name: 'PRIORITY_GLOBAL', value: 638 },
        PRIOR_COURT_ORDERS: { name: 'PRIOR_COURT_ORDERS', value: 436 },
        PROBATION_TYPE: { name: 'PROBATION_TYPE', value: 575 },
        PROFESSIONAL_PROFILES_PERSON_TYPE: {
            name: 'PROFESSIONAL_PROFILES_PERSON_TYPE',
            value: 791,
        },
        PROFESSIONAL_PROFILES_PERSON_TYPE_GLOBAL: {
            name: 'PROFESSIONAL_PROFILES_PERSON_TYPE_GLOBAL',
            value: 799,
        },
        PROFESSIONAL_PROFILES_RELATIONSHIP_TO_DEFENDANT: {
            name: 'PROFESSIONAL_PROFILES_RELATIONSHIP_TO_DEFENDANT',
            value: 792,
        },
        PROFILE_LEVEL_GLOBAL: { name: 'PROFILE_LEVEL_GLOBAL', value: 723 },
        PROOF_OF_OWNERSHIP: { name: 'PROOF_OF_OWNERSHIP', value: 252 },
        PROOF_OF_OWNERSHIP_GLOBAL: { name: 'PROOF_OF_OWNERSHIP_GLOBAL', value: 250 },
        PROPERTY_LOSS: { name: 'PROPERTY_LOSS', value: 20 },
        PROPERTY_REASON_FOR_SEARCH: { name: 'PROPERTY_REASON_FOR_SEARCH', value: 591 },
        PROPERTY_STATUS_GLOBAL: { name: 'PROPERTY_STATUS_GLOBAL', value: 199 },
        PROPERTY_TYPE_OF_SEARCH: { name: 'PROPERTY_TYPE_OF_SEARCH', value: 590 },
        PROSECUTOR_TYPE: { name: 'PROSECUTOR_TYPE', value: 451 },
        PROTECTION_ORDER_STATUS: { name: 'PROTECTION_ORDER_STATUS', value: 446 },
        PROTECTION_ORDER_TYPE: { name: 'PROTECTION_ORDER_TYPE', value: 445 },
        PRO_QA_CODE: { name: 'PRO_QA_CODE', value: 778 },
        QC_ACCESS_CONTROL: { name: 'QC_ACCESS_CONTROL', value: 545 },
        QC_AIR_BAG_DEPLOYED: { name: 'QC_AIR_BAG_DEPLOYED', value: 516 },
        QC_ALCOHOL_INTERLOCK_PRESENT: { name: 'QC_ALCOHOL_INTERLOCK_PRESENT', value: 525 },
        QC_ALCOHOL_INVOLVEMENT: { name: 'QC_ALCOHOL_INVOLVEMENT', value: 480 },
        QC_ALCOHOL_TEST_RESULT: { name: 'QC_ALCOHOL_TEST_RESULT', value: 642 },
        QC_ALCOHOL_TEST_STATUS: { name: 'QC_ALCOHOL_TEST_STATUS', value: 532 },
        QC_ALCOHOL_TEST_TYPE: { name: 'QC_ALCOHOL_TEST_TYPE', value: 533 },
        QC_ATTEMPTED_AVOIDANCE_MANEUVER: { name: 'QC_ATTEMPTED_AVOIDANCE_MANEUVER', value: 554 },
        QC_BODY_TYPE_CATEGORY: { name: 'QC_BODY_TYPE_CATEGORY', value: 484 },
        QC_CARGO_BODY_TYPE: { name: 'QC_CARGO_BODY_TYPE', value: 564 },
        QC_CMV_LICENSE_COMPLIANCE: { name: 'QC_CMV_LICENSE_COMPLIANCE', value: 558 },
        QC_CMV_LICENSE_STATUS: { name: 'QC_CMV_LICENSE_STATUS', value: 557 },
        QC_CONDITION: { name: 'QC_CONDITION', value: 530 },
        QC_CRASH_CLASSIFICATION_CHARACTERISTICS: {
            name: 'QC_CRASH_CLASSIFICATION_CHARACTERISTICS',
            value: 458,
        },
        QC_CRASH_CLASSIFICATION_OWNERSHIP: {
            name: 'QC_CRASH_CLASSIFICATION_OWNERSHIP',
            value: 457,
        },
        QC_CRASH_CLASSIFICATION_SECONDARY_CRASH: {
            name: 'QC_CRASH_CLASSIFICATION_SECONDARY_CRASH',
            value: 459,
        },
        QC_CRASH_RELATED_TO_HOV_HOT_LANES: {
            name: 'QC_CRASH_RELATED_TO_HOV_HOT_LANES',
            value: 495,
        },
        QC_CRASH_SEVERITY: { name: 'QC_CRASH_SEVERITY', value: 479 },
        QC_CROSS_STREET_NUM_LANES_AT_INTERSECTION: {
            name: 'QC_CROSS_STREET_NUM_LANES_AT_INTERSECTION',
            value: 553,
        },
        QC_DAY_OF_WEEK: { name: 'QC_DAY_OF_WEEK', value: 482 },
        QC_DIRECTION_OF_TRAVEL_BEFORE_CRASH: {
            name: 'QC_DIRECTION_OF_TRAVEL_BEFORE_CRASH',
            value: 490,
        },
        QC_DISTRACTED_BY: { name: 'QC_DISTRACTED_BY', value: 528 },
        QC_DISTRACTED_BY_SOURCE: { name: 'QC_DISTRACTED_BY_SOURCE', value: 529 },
        QC_DRIVER_ACTIONS: { name: 'QC_DRIVER_ACTIONS', value: 523 },
        QC_DRIVER_LICENSE_CDL: { name: 'QC_DRIVER_LICENSE_CDL', value: 520 },
        QC_DRIVER_LICENSE_CLASS: { name: 'QC_DRIVER_LICENSE_CLASS', value: 519 },
        QC_DRIVER_LICENSE_JURISDICTION: { name: 'QC_DRIVER_LICENSE_JURISDICTION', value: 518 },
        QC_DRIVER_LICENSE_RESTRICTIONS: { name: 'QC_DRIVER_LICENSE_RESTRICTIONS', value: 524 },
        QC_DRUG_INVOLVEMENT: { name: 'QC_DRUG_INVOLVEMENT', value: 481 },
        QC_DRUG_TEST_RESULT: { name: 'QC_DRUG_TEST_RESULT', value: 538 },
        QC_DRUG_TEST_STATUS: { name: 'QC_DRUG_TEST_STATUS', value: 536 },
        QC_DRUG_TEST_TYPE: { name: 'QC_DRUG_TEST_TYPE', value: 537 },
        QC_EJECTION: { name: 'QC_EJECTION', value: 517 },
        QC_EMERGENCY_MOTOR_VEHICLE_USE: { name: 'QC_EMERGENCY_MOTOR_VEHICLE_USE', value: 489 },
        QC_FATAL_ALCOHOL_TEST_TYPE: { name: 'QC_FATAL_ALCOHOL_TEST_TYPE', value: 555 },
        QC_FATAL_DRUG_TEST_TYPE: { name: 'QC_FATAL_DRUG_TEST_TYPE', value: 556 },
        QC_FIRST_HARMFUL_EVENT: { name: 'QC_FIRST_HARMFUL_EVENT', value: 460 },
        QC_GRADE_DIRECTION_OF_SLOPE: { name: 'QC_GRADE_DIRECTION_OF_SLOPE', value: 542 },
        QC_HAS_HM_PLACARD: { name: 'QC_HAS_HM_PLACARD', value: 487 },
        QC_HAZARDOUS_MATERIALS_CLASS: { name: 'QC_HAZARDOUS_MATERIALS_CLASS', value: 593 },
        QC_HAZARDOUS_MATERIALS_RELEASED: { name: 'QC_HAZARDOUS_MATERIALS_RELEASED', value: 565 },
        QC_HIT_AND_RUN: { name: 'QC_HIT_AND_RUN', value: 506 },
        QC_INCIDENT_RESPONDER: { name: 'QC_INCIDENT_RESPONDER', value: 511 },
        QC_INITIAL_CONTACT_POINT_ON_NON_MOTORIST: {
            name: 'QC_INITIAL_CONTACT_POINT_ON_NON_MOTORIST',
            value: 571,
        },
        QC_INITIAL_POINT_OF_CONTACT: { name: 'QC_INITIAL_POINT_OF_CONTACT', value: 501 },
        QC_INJURY_AREA: { name: 'QC_INJURY_AREA', value: 540 },
        QC_INJURY_SEVERITY: { name: 'QC_INJURY_SEVERITY', value: 541 },
        QC_INJURY_STATUS: { name: 'QC_INJURY_STATUS', value: 512 },
        QC_INTERSECTION_NUM_APPROACHES: { name: 'QC_INTERSECTION_NUM_APPROACHES', value: 470 },
        QC_INTERSECTION_OVERALL_GEOMETRY: { name: 'QC_INTERSECTION_OVERALL_GEOMETRY', value: 471 },
        QC_INTERSECTION_OVERALL_TRAFFIC_CONTROL_DEVICE: {
            name: 'QC_INTERSECTION_OVERALL_TRAFFIC_CONTROL_DEVICE',
            value: 472,
        },
        QC_JUNCTION_SPECIFIC_LOCATION: { name: 'QC_JUNCTION_SPECIFIC_LOCATION', value: 469 },
        QC_JUNCTION_WITHIN_INTERCHANGE_AREA: {
            name: 'QC_JUNCTION_WITHIN_INTERCHANGE_AREA',
            value: 468,
        },
        QC_LANDMARK_DIRECTION: { name: 'QC_LANDMARK_DIRECTION', value: 605 },
        QC_LANDMARK_DISTANCE_UNITS: { name: 'QC_LANDMARK_DISTANCE_UNITS', value: 604 },
        QC_LAW_ENFORCEMENT_SUSPECTS_ALCOHOL_USE: {
            name: 'QC_LAW_ENFORCEMENT_SUSPECTS_ALCOHOL_USE',
            value: 531,
        },
        QC_LAW_ENFORCEMENT_SUSPECTS_DRUG_USE: {
            name: 'QC_LAW_ENFORCEMENT_SUSPECTS_DRUG_USE',
            value: 535,
        },
        QC_LIGHT_CONDITION: { name: 'QC_LIGHT_CONDITION', value: 465 },
        QC_LOCATION_OF_DAMAGED_AREAS: { name: 'QC_LOCATION_OF_DAMAGED_AREAS', value: 502 },
        QC_LOCATION_OF_FIRST_HARMFUL_EVENT: {
            name: 'QC_LOCATION_OF_FIRST_HARMFUL_EVENT',
            value: 461,
        },
        QC_LONGITUDINAL_CENTERLINE_TYPE: { name: 'QC_LONGITUDINAL_CENTERLINE_TYPE', value: 548 },
        QC_LONGITUDINAL_EDGELINE_TYPE: { name: 'QC_LONGITUDINAL_EDGELINE_TYPE', value: 547 },
        QC_LONGITUDINAL_LANE_LINE_MARKINGS: {
            name: 'QC_LONGITUDINAL_LANE_LINE_MARKINGS',
            value: 549,
        },
        QC_MAINLINE_NUM_LANES_AT_INTERSECTION: {
            name: 'QC_MAINLINE_NUM_LANES_AT_INTERSECTION',
            value: 552,
        },
        QC_MANEUVER: { name: 'QC_MANEUVER', value: 500 },
        QC_MANNER_OF_CRASH: { name: 'QC_MANNER_OF_CRASH', value: 462 },
        QC_MEDICAL_TRANSPORT_SOURCE: { name: 'QC_MEDICAL_TRANSPORT_SOURCE', value: 539 },
        QC_MILEPOST_DIRECTION: { name: 'QC_MILEPOST_DIRECTION', value: 613 },
        QC_MILEPOST_DISTANCE_UNITS: { name: 'QC_MILEPOST_DISTANCE_UNITS', value: 614 },
        QC_MOST_HARMFUL_EVENT: { name: 'QC_MOST_HARMFUL_EVENT', value: 505 },
        QC_MOTOR_CARRIER_IDENTIFICATION_CARRIER_TYPE: {
            name: 'QC_MOTOR_CARRIER_IDENTIFICATION_CARRIER_TYPE',
            value: 560,
        },
        QC_MOTOR_CARRIER_IDENTIFICATION_TYPE: {
            name: 'QC_MOTOR_CARRIER_IDENTIFICATION_TYPE',
            value: 559,
        },
        QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS: {
            name: 'QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS',
            value: 572,
        },
        QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_ENGAGED: {
            name: 'QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_ENGAGED',
            value: 574,
        },
        QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_LEVEL: {
            name: 'QC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_LEVEL',
            value: 573,
        },
        QC_NON_MOTORIST_ACTION_PRIOR_TO_CRASH: {
            name: 'QC_NON_MOTORIST_ACTION_PRIOR_TO_CRASH',
            value: 566,
        },
        QC_NON_MOTORIST_CONTRIBUTING_ACTIONS: {
            name: 'QC_NON_MOTORIST_CONTRIBUTING_ACTIONS',
            value: 568,
        },
        QC_NON_MOTORIST_LOCATION_AT_TIME_OF_CRASH: {
            name: 'QC_NON_MOTORIST_LOCATION_AT_TIME_OF_CRASH',
            value: 569,
        },
        QC_NON_MOTORIST_ORIGIN_OR_DESTINATION: {
            name: 'QC_NON_MOTORIST_ORIGIN_OR_DESTINATION',
            value: 567,
        },
        QC_NON_MOTORIST_SAFETY_EQUIPMENT: { name: 'QC_NON_MOTORIST_SAFETY_EQUIPMENT', value: 570 },
        QC_NUM_TRAILING_UNITS: { name: 'QC_NUM_TRAILING_UNITS', value: 485 },
        QC_PART_OF_NATIONAL_HIGHWAY_SYSTEM: {
            name: 'QC_PART_OF_NATIONAL_HIGHWAY_SYSTEM',
            value: 543,
        },
        QC_PERSON_TYPE: { name: 'QC_PERSON_TYPE', value: 510 },
        QC_RESTRAINTS_AND_HELMETS: { name: 'QC_RESTRAINTS_AND_HELMETS', value: 514 },
        QC_RESTRAINT_SYSTEMS_IMPROPER_USE: {
            name: 'QC_RESTRAINT_SYSTEMS_IMPROPER_USE',
            value: 515,
        },
        QC_RESULTING_EXTENT_OF_DAMAGE: { name: 'QC_RESULTING_EXTENT_OF_DAMAGE', value: 503 },
        QC_ROADWAY_CONTRIBUTING_CIRCUMSTANCES: {
            name: 'QC_ROADWAY_CONTRIBUTING_CIRCUMSTANCES',
            value: 467,
        },
        QC_ROADWAY_DIRECTION: { name: 'QC_ROADWAY_DIRECTION', value: 615 },
        QC_ROADWAY_FUNCTIONAL_CLASS: { name: 'QC_ROADWAY_FUNCTIONAL_CLASS', value: 544 },
        QC_ROADWAY_GRADE: { name: 'QC_ROADWAY_GRADE', value: 497 },
        QC_ROADWAY_HORIZONTAL_ALIGNMENT: { name: 'QC_ROADWAY_HORIZONTAL_ALIGNMENT', value: 496 },
        QC_ROADWAY_LIGHTING: { name: 'QC_ROADWAY_LIGHTING', value: 546 },
        QC_ROADWAY_SURFACE_CONDITION: { name: 'QC_ROADWAY_SURFACE_CONDITION', value: 466 },
        QC_SCHOOL_BUS_RELATED: { name: 'QC_SCHOOL_BUS_RELATED', value: 473 },
        QC_SEATING_POSITION: { name: 'QC_SEATING_POSITION', value: 513 },
        QC_SEQUENCE_OF_EVENTS: { name: 'QC_SEQUENCE_OF_EVENTS', value: 504 },
        QC_SIGNED_BICYCLE_ROUTE: { name: 'QC_SIGNED_BICYCLE_ROUTE', value: 551 },
        QC_SOURCE_OF_INFORMATION: { name: 'QC_SOURCE_OF_INFORMATION', value: 463 },
        QC_SPECIAL_FUNCTION: { name: 'QC_SPECIAL_FUNCTION', value: 488 },
        QC_SPEEDING_RELATED: { name: 'QC_SPEEDING_RELATED', value: 522 },
        QC_TOWED_DUE_TO_DISABLING_DAMAGE: { name: 'QC_TOWED_DUE_TO_DISABLING_DAMAGE', value: 507 },
        QC_TRAFFICWAY_BARRIER_TYPE: { name: 'QC_TRAFFICWAY_BARRIER_TYPE', value: 493 },
        QC_TRAFFICWAY_DIVIDED: { name: 'QC_TRAFFICWAY_DIVIDED', value: 492 },
        QC_TRAFFICWAY_HOV_HOT_LANES: { name: 'QC_TRAFFICWAY_HOV_HOT_LANES', value: 494 },
        QC_TRAFFICWAY_TRAVEL_DIRECTIONS: { name: 'QC_TRAFFICWAY_TRAVEL_DIRECTIONS', value: 491 },
        QC_TRAFFIC_CONTROLS_INOPERATIVE_OR_MISSING: {
            name: 'QC_TRAFFIC_CONTROLS_INOPERATIVE_OR_MISSING',
            value: 499,
        },
        QC_TRAFFIC_CONTROLS_TYPE: { name: 'QC_TRAFFIC_CONTROLS_TYPE', value: 498 },
        QC_TYPE_OF_BICYCLE_FACILITY: { name: 'QC_TYPE_OF_BICYCLE_FACILITY', value: 550 },
        QC_UNIT_TYPE: { name: 'QC_UNIT_TYPE', value: 483 },
        QC_VEHICLE_CONFIGURATION: { name: 'QC_VEHICLE_CONFIGURATION', value: 561 },
        QC_VEHICLE_CONFIGURATION_PERMITTED: {
            name: 'QC_VEHICLE_CONFIGURATION_PERMITTED',
            value: 563,
        },
        QC_VEHICLE_CONFIGURATION_SPECIAL_SIZING: {
            name: 'QC_VEHICLE_CONFIGURATION_SPECIAL_SIZING',
            value: 562,
        },
        QC_VEHICLE_CONTRIBUTING_CIRCUMSTANCES: {
            name: 'QC_VEHICLE_CONTRIBUTING_CIRCUMSTANCES',
            value: 508,
        },
        QC_VEHICLE_SIZE: { name: 'QC_VEHICLE_SIZE', value: 486 },
        QC_WORK_ZONE_LAW_ENFORCEMENT_PRESENT: {
            name: 'QC_WORK_ZONE_LAW_ENFORCEMENT_PRESENT',
            value: 478,
        },
        QC_WORK_ZONE_LOCATION_OF_CRASH: { name: 'QC_WORK_ZONE_LOCATION_OF_CRASH', value: 475 },
        QC_WORK_ZONE_RELATED: { name: 'QC_WORK_ZONE_RELATED', value: 474 },
        QC_WORK_ZONE_TYPE: { name: 'QC_WORK_ZONE_TYPE', value: 476 },
        QC_WORK_ZONE_WORKERS_PRESENT: { name: 'QC_WORK_ZONE_WORKERS_PRESENT', value: 477 },
        RACE: { name: 'RACE', value: 33 },
        RADIO_CHANNEL: { name: 'RADIO_CHANNEL', value: 393 },
        RADIO_ID: { name: 'RADIO_ID', value: 650 },
        RANK: { name: 'RANK', value: 63 },
        REASON_FOR_ASSOCIATION: { name: 'REASON_FOR_ASSOCIATION', value: 391 },
        REASON_FOR_NO_ARREST: { name: 'REASON_FOR_NO_ARREST', value: 433 },
        REASON_FOR_POLICE_CUSTODY_GLOBAL: { name: 'REASON_FOR_POLICE_CUSTODY_GLOBAL', value: 397 },
        REASON_FOR_POLICE_CUSTODY_OF_PROPERTY: {
            name: 'REASON_FOR_POLICE_CUSTODY_OF_PROPERTY',
            value: 41,
        },
        REASON_FOR_RELATION: { name: 'REASON_FOR_RELATION', value: 652 },
        REASON_FOR_REMOVAL: { name: 'REASON_FOR_REMOVAL', value: 653 },
        REASON_FOR_SEARCH: { name: 'REASON_FOR_SEARCH', value: 443 },
        RELIGION: { name: 'RELIGION', value: 620 },
        REPORT_NOTIFICATION_TYPE: { name: 'REPORT_NOTIFICATION_TYPE', value: 224 },
        RESIDENT_OF_JURISDICTION: { name: 'RESIDENT_OF_JURISDICTION', value: 377 },
        RESULT_OF_STOP: { name: 'RESULT_OF_STOP', value: 441 },
        RESULT_OF_STOP_GLOBAL: { name: 'RESULT_OF_STOP_GLOBAL', value: 440 },
        RISK_LEVEL: { name: 'RISK_LEVEL', value: 339 },
        RISK_LEVEL_GLOBAL: { name: 'RISK_LEVEL_GLOBAL', value: 338 },
        ROLODEX_PROFILE_TYPE: { name: 'ROLODEX_PROFILE_TYPE', value: 382 },
        ROUTE_OF_APPROACH: { name: 'ROUTE_OF_APPROACH', value: 687 },
        ROUTE_OF_APPROACH_CATEGORY: { name: 'ROUTE_OF_APPROACH_CATEGORY', value: 703 },
        ROUTING_LABEL: { name: 'ROUTING_LABEL', value: 383 },
        ROUTING_LABEL_CATEGORY: { name: 'ROUTING_LABEL_CATEGORY', value: 809 },
        ROUTING_LABEL_PRIORITY: { name: 'ROUTING_LABEL_PRIORITY', value: 808 },
        SAFEGUARDING_MO: { name: 'SAFEGUARDING_MO', value: 693 },
        SAFEGUARDING_MO_CATEGORY: { name: 'SAFEGUARDING_MO_CATEGORY', value: 704 },
        SCHOOL_CODE: { name: 'SCHOOL_CODE', value: 732 },
        SEALING_STATUTE_CODE: { name: 'SEALING_STATUTE_CODE', value: 657 },
        SECURITY_CLASSIFICATION: { name: 'SECURITY_CLASSIFICATION', value: 737 },
        SECURITY_SYSTEM: { name: 'SECURITY_SYSTEM', value: 83 },
        SERVICE_ROTATION_ACTION_TYPE_GLOBAL: {
            name: 'SERVICE_ROTATION_ACTION_TYPE_GLOBAL',
            value: 398,
        },
        SERVICE_ROTATION_ADMIN_ACTION_TYPE_GLOBAL: {
            name: 'SERVICE_ROTATION_ADMIN_ACTION_TYPE_GLOBAL',
            value: 399,
        },
        SEX: { name: 'SEX', value: 24 },
        SEXUAL_ORIENTATION: { name: 'SEXUAL_ORIENTATION', value: 643 },
        SHOWUP_OUTCOME_OF_IDENTIFICATION: { name: 'SHOWUP_OUTCOME_OF_IDENTIFICATION', value: 823 },
        SKIN_TONE: { name: 'SKIN_TONE', value: 61 },
        SPECIAL_ASSIGNMENT: { name: 'SPECIAL_ASSIGNMENT', value: 358 },
        STATE: { name: 'STATE', value: 48 },
        STOP_ACTION_TAKEN: { name: 'STOP_ACTION_TAKEN', value: 578 },
        STOP_BASIS_FOR_PROPERTY_SEIZURE: { name: 'STOP_BASIS_FOR_PROPERTY_SEIZURE', value: 579 },
        STOP_DATA_OFFICER_GENDER: { name: 'STOP_DATA_OFFICER_GENDER', value: 656 },
        STOP_DATA_OFFICER_RACE: { name: 'STOP_DATA_OFFICER_RACE', value: 655 },
        STOP_EDUCATION_CODE_SECTION: { name: 'STOP_EDUCATION_CODE_SECTION', value: 580 },
        STOP_EDUCATION_CODE_SUBDIVISION: { name: 'STOP_EDUCATION_CODE_SUBDIVISION', value: 581 },
        STOP_FORCIBLE_ACTION_TAKEN: { name: 'STOP_FORCIBLE_ACTION_TAKEN', value: 658 },
        STOP_NON_FORCIBLE_ACTION_TAKEN: { name: 'STOP_NON_FORCIBLE_ACTION_TAKEN', value: 649 },
        STOP_PROPERTY_TYPE_OF_PROPERTY_SEIZED: {
            name: 'STOP_PROPERTY_TYPE_OF_PROPERTY_SEIZED',
            value: 592,
        },
        STOP_REASON_FOR_STOP: { name: 'STOP_REASON_FOR_STOP', value: 594 },
        STOP_SUSPICION_TYPE: { name: 'STOP_SUSPICION_TYPE', value: 582 },
        STOP_TYPE_OF_PROPERTY_SEIZED: { name: 'STOP_TYPE_OF_PROPERTY_SEIZED', value: 583 },
        STOP_TYPE_OF_TRAFFIC_VIOLATION: { name: 'STOP_TYPE_OF_TRAFFIC_VIOLATION', value: 584 },
        STOP_USER_ASSIGNMENT_TYPE: { name: 'STOP_USER_ASSIGNMENT_TYPE', value: 585 },
        SUBDIVISION_DEPTH_1: { name: 'SUBDIVISION_DEPTH_1', value: 50 },
        SUBDIVISION_DEPTH_2: { name: 'SUBDIVISION_DEPTH_2', value: 49 },
        SUBDIVISION_DEPTH_3: { name: 'SUBDIVISION_DEPTH_3', value: 214 },
        SUBDIVISION_DEPTH_4: { name: 'SUBDIVISION_DEPTH_4', value: 215 },
        SUBDIVISION_DEPTH_5: { name: 'SUBDIVISION_DEPTH_5', value: 216 },
        SUBDIVISION_FIRE_DEPTH_1: { name: 'SUBDIVISION_FIRE_DEPTH_1', value: 384 },
        SUBDIVISION_FIRE_DEPTH_2: { name: 'SUBDIVISION_FIRE_DEPTH_2', value: 385 },
        SUBDIVISION_FIRE_DEPTH_3: { name: 'SUBDIVISION_FIRE_DEPTH_3', value: 386 },
        SUBDIVISION_FIRE_DEPTH_4: { name: 'SUBDIVISION_FIRE_DEPTH_4', value: 387 },
        SUBDIVISION_FIRE_DEPTH_5: { name: 'SUBDIVISION_FIRE_DEPTH_5', value: 388 },
        SUBDIVISION_MEDICAL_DEPTH_1: { name: 'SUBDIVISION_MEDICAL_DEPTH_1', value: 421 },
        SUBDIVISION_MEDICAL_DEPTH_2: { name: 'SUBDIVISION_MEDICAL_DEPTH_2', value: 422 },
        SUBDIVISION_MEDICAL_DEPTH_3: { name: 'SUBDIVISION_MEDICAL_DEPTH_3', value: 423 },
        SUBDIVISION_MEDICAL_DEPTH_4: { name: 'SUBDIVISION_MEDICAL_DEPTH_4', value: 424 },
        SUBDIVISION_MEDICAL_DEPTH_5: { name: 'SUBDIVISION_MEDICAL_DEPTH_5', value: 425 },
        SUBJECT_DATA_CONTRABAND_OR_EVIDENCE: {
            name: 'SUBJECT_DATA_CONTRABAND_OR_EVIDENCE',
            value: 610,
        },
        SUBJECT_DATA_DISABILITY: { name: 'SUBJECT_DATA_DISABILITY', value: 408 },
        SUBJECT_DATA_GENDER: { name: 'SUBJECT_DATA_GENDER', value: 407 },
        SUBJECT_DATA_PROBABLE_CAUSE: { name: 'SUBJECT_DATA_PROBABLE_CAUSE', value: 654 },
        SUBJECT_DATA_RACE: { name: 'SUBJECT_DATA_RACE', value: 406 },
        SUBJECT_DATA_REASON_FOR_STOP: { name: 'SUBJECT_DATA_REASON_FOR_STOP', value: 411 },
        SUBJECT_DATA_REASON_GIVEN_TO_STOPPED_PERSON: {
            name: 'SUBJECT_DATA_REASON_GIVEN_TO_STOPPED_PERSON',
            value: 672,
        },
        SUBJECT_DATA_RESULT_OF_STOP: { name: 'SUBJECT_DATA_RESULT_OF_STOP', value: 412 },
        SUBSTANCE_ABUSE: { name: 'SUBSTANCE_ABUSE', value: 438 },
        SUPPLEMENT_TYPE: { name: 'SUPPLEMENT_TYPE', value: 390 },
        SUSPECTED_DRUG_TYPE: { name: 'SUSPECTED_DRUG_TYPE', value: 716 },
        SUSPECTED_METAL_THEFT: { name: 'SUSPECTED_METAL_THEFT', value: 674 },
        SUSPECT_STATUS: { name: 'SUSPECT_STATUS', value: 694 },
        TAG_NUMBER: { name: 'TAG_NUMBER', value: 336 },
        TARGET_PROFILE_CATEGORY: { name: 'TARGET_PROFILE_CATEGORY', value: 707 },
        TARGET_PROFILE_LEVEL: { name: 'TARGET_PROFILE_LEVEL', value: 719 },
        TARGET_PROFILE_PRIORITY: { name: 'TARGET_PROFILE_PRIORITY', value: 711 },
        TASK_PRIORITY: { name: 'TASK_PRIORITY', value: 639 },
        TASK_STATUS: { name: 'TASK_STATUS', value: 331 },
        TASK_STATUS_GLOBAL: { name: 'TASK_STATUS_GLOBAL', value: 330 },
        TASK_TYPE: { name: 'TASK_TYPE', value: 621 },
        TOW_AUTHORIZED_BY: { name: 'TOW_AUTHORIZED_BY', value: 742 },
        TOW_VEHICLE_REASON_FOR_TOW: { name: 'TOW_VEHICLE_REASON_FOR_TOW', value: 354 },
        TOW_VEHICLE_REASON_FOR_TOW_GLOBAL: {
            name: 'TOW_VEHICLE_REASON_FOR_TOW_GLOBAL',
            value: 353,
        },
        TOW_VEHICLE_RELEASE_TYPE: { name: 'TOW_VEHICLE_RELEASE_TYPE', value: 355 },
        TOW_VEHICLE_STATUS: { name: 'TOW_VEHICLE_STATUS', value: 352 },
        TOW_VEHICLE_TOW_COMPANY: { name: 'TOW_VEHICLE_TOW_COMPANY', value: 322 },
        TYPE_OF_GANG_TYPE: { name: 'TYPE_OF_GANG_TYPE', value: 731 },
        TYPE_OF_MARIJUANA: { name: 'TYPE_OF_MARIJUANA', value: 426 },
        TYPE_OF_SEARCH: { name: 'TYPE_OF_SEARCH', value: 587 },
        TYPE_OF_SEARCH_CATEGORY: { name: 'TYPE_OF_SEARCH_CATEGORY', value: 695 },
        TYPE_OF_SEARCH_CONDUCTED_BY_OFFENDER: {
            name: 'TYPE_OF_SEARCH_CONDUCTED_BY_OFFENDER',
            value: 689,
        },
        TYPE_OF_STOP: { name: 'TYPE_OF_STOP', value: 648 },
        UK_OFFENSE_CODE_CATEGORY: { name: 'UK_OFFENSE_CODE_CATEGORY', value: 683 },
        UNIT_IDENTIFIER: { name: 'UNIT_IDENTIFIER', value: 749 },
        UNIT_TYPE: { name: 'UNIT_TYPE', value: 337 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER_SKILL: { name: 'USER_SKILL', value: 300 },
        USER_TRAINING: { name: 'USER_TRAINING', value: 301 },
        USE_OF_FORCE_EXTENDED_BOOLEAN: { name: 'USE_OF_FORCE_EXTENDED_BOOLEAN', value: 598 },
        USE_OF_FORCE_MEDICAL_AID_RECEIVED: {
            name: 'USE_OF_FORCE_MEDICAL_AID_RECEIVED',
            value: 349,
        },
        USE_OF_FORCE_OFFICER_DUTY_TYPE: { name: 'USE_OF_FORCE_OFFICER_DUTY_TYPE', value: 616 },
        USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT: {
            name: 'USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT',
            value: 230,
        },
        USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT_LOCATION: {
            name: 'USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT_LOCATION',
            value: 347,
        },
        USE_OF_FORCE_OFFICER_INJURY_SEVERITY: {
            name: 'USE_OF_FORCE_OFFICER_INJURY_SEVERITY',
            value: 344,
        },
        USE_OF_FORCE_OFFICER_INJURY_TYPE: { name: 'USE_OF_FORCE_OFFICER_INJURY_TYPE', value: 346 },
        USE_OF_FORCE_OFFICER_WEAPON_USED: { name: 'USE_OF_FORCE_OFFICER_WEAPON_USED', value: 812 },
        USE_OF_FORCE_PENDING_UNKNOWN: { name: 'USE_OF_FORCE_PENDING_UNKNOWN', value: 617 },
        USE_OF_FORCE_REASON: { name: 'USE_OF_FORCE_REASON', value: 231 },
        USE_OF_FORCE_STATISTICS: { name: 'USE_OF_FORCE_STATISTICS', value: 227 },
        USE_OF_FORCE_SUBJECT_ACTIONS: { name: 'USE_OF_FORCE_SUBJECT_ACTIONS', value: 229 },
        USE_OF_FORCE_SUBJECT_CONFIRMED_ARMED_WITH: {
            name: 'USE_OF_FORCE_SUBJECT_CONFIRMED_ARMED_WITH',
            value: 342,
        },
        USE_OF_FORCE_SUBJECT_DETAILS: { name: 'USE_OF_FORCE_SUBJECT_DETAILS', value: 228 },
        USE_OF_FORCE_SUBJECT_DE_ESCALATION_TYPE: {
            name: 'USE_OF_FORCE_SUBJECT_DE_ESCALATION_TYPE',
            value: 600,
        },
        USE_OF_FORCE_SUBJECT_DISPOSITION: { name: 'USE_OF_FORCE_SUBJECT_DISPOSITION', value: 611 },
        USE_OF_FORCE_SUBJECT_FORCE_TOWARDS_OFFICER: {
            name: 'USE_OF_FORCE_SUBJECT_FORCE_TOWARDS_OFFICER',
            value: 350,
        },
        USE_OF_FORCE_SUBJECT_FORCE_TOWARDS_OFFICER_LOCATION: {
            name: 'USE_OF_FORCE_SUBJECT_FORCE_TOWARDS_OFFICER_LOCATION',
            value: 348,
        },
        USE_OF_FORCE_SUBJECT_IMPAIRMENTS: { name: 'USE_OF_FORCE_SUBJECT_IMPAIRMENTS', value: 612 },
        USE_OF_FORCE_SUBJECT_INJURY_SEVERITY: {
            name: 'USE_OF_FORCE_SUBJECT_INJURY_SEVERITY',
            value: 343,
        },
        USE_OF_FORCE_SUBJECT_INJURY_TYPE: { name: 'USE_OF_FORCE_SUBJECT_INJURY_TYPE', value: 345 },
        USE_OF_FORCE_SUBJECT_PERCEIVED_ARMED_WITH: {
            name: 'USE_OF_FORCE_SUBJECT_PERCEIVED_ARMED_WITH',
            value: 341,
        },
        USE_OF_FORCE_SUBJECT_THREAT_DIRECTED_AT: {
            name: 'USE_OF_FORCE_SUBJECT_THREAT_DIRECTED_AT',
            value: 599,
        },
        VEHICLE_BODY_STYLE: { name: 'VEHICLE_BODY_STYLE', value: 89 },
        VEHICLE_DAMAGE_AREA: { name: 'VEHICLE_DAMAGE_AREA', value: 170 },
        VEHICLE_ENTRY_POINT: { name: 'VEHICLE_ENTRY_POINT', value: 663 },
        VEHICLE_INVOLVEMENT_TYPE: { name: 'VEHICLE_INVOLVEMENT_TYPE', value: 595 },
        VEHICLE_LABEL_ATTRIBUTES: { name: 'VEHICLE_LABEL_ATTRIBUTES', value: 635 },
        VEHICLE_LABEL_CATEGORY: { name: 'VEHICLE_LABEL_CATEGORY', value: 634 },
        VEHICLE_MAKE: { name: 'VEHICLE_MAKE', value: 44 },
        VEHICLE_MO: { name: 'VEHICLE_MO', value: 692 },
        VEHICLE_MODEL: { name: 'VEHICLE_MODEL', value: 88 },
        VEHICLE_RECOVERY_TYPE: { name: 'VEHICLE_RECOVERY_TYPE', value: 417 },
        VERIFICATION_OF_DEATH: { name: 'VERIFICATION_OF_DEATH', value: 641 },
        VICTIM_BY_ASSOCIATION_RELATION: { name: 'VICTIM_BY_ASSOCIATION_RELATION', value: 456 },
        VICTIM_BY_ASSOCIATION_TYPE: { name: 'VICTIM_BY_ASSOCIATION_TYPE', value: 455 },
        VICTIM_DISABILITY_TYPE: { name: 'VICTIM_DISABILITY_TYPE', value: 628 },
        VIRTUAL_PATROL: { name: 'VIRTUAL_PATROL', value: 317 },
        VISION: { name: 'VISION', value: 90 },
        WARNING_MARKER_ATTRIBUTES: { name: 'WARNING_MARKER_ATTRIBUTES', value: 810 },
        WARNING_MARKER_CATEGORY: { name: 'WARNING_MARKER_CATEGORY', value: 811 },
        WARRANT_ACTIVITY: { name: 'WARRANT_ACTIVITY', value: 405 },
        WARRANT_ACTIVITY_GLOBAL: { name: 'WARRANT_ACTIVITY_GLOBAL', value: 420 },
        WARRANT_CHECK_TYPES: { name: 'WARRANT_CHECK_TYPES', value: 223 },
        WARRANT_ENTRY_LEVEL_CODE: { name: 'WARRANT_ENTRY_LEVEL_CODE', value: 410 },
        WARRANT_FELONY_EXTRADITION: { name: 'WARRANT_FELONY_EXTRADITION', value: 427 },
        WARRANT_MISDEMEANOR_EXTRADITION: { name: 'WARRANT_MISDEMEANOR_EXTRADITION', value: 428 },
        WARRANT_STATISTIC: { name: 'WARRANT_STATISTIC', value: 369 },
        WARRANT_STATUS: { name: 'WARRANT_STATUS', value: 367 },
        WARRANT_STATUS_GLOBAL: { name: 'WARRANT_STATUS_GLOBAL', value: 368 },
        WARRANT_TYPE: { name: 'WARRANT_TYPE', value: 365 },
        WARRANT_TYPE_GLOBAL: { name: 'WARRANT_TYPE_GLOBAL', value: 366 },
        WAS_SUBJECT_SCREENED: { name: 'WAS_SUBJECT_SCREENED', value: 444 },
        WEAPON_INVOLVED: { name: 'WEAPON_INVOLVED', value: 415 },
        WEAPON_OR_FORCE_INVOLVED: { name: 'WEAPON_OR_FORCE_INVOLVED', value: 78 },
        WEAPON_OR_FORCE_INVOLVED_CATEGORY: {
            name: 'WEAPON_OR_FORCE_INVOLVED_CATEGORY',
            value: 708,
        },
        WEATHER: { name: 'WEATHER', value: 18 },
        YES_NO: { name: 'YES_NO', value: 733 },
        YES_NO_UNKNOWN: { name: 'YES_NO_UNKNOWN', value: 619 },
    },
    FT = {
        ALREADY_CONFIGURED: { name: 'ALREADY_CONFIGURED' },
        MESSAGE_CATCH_ALL_ALREADY_CONFIGURED: { name: 'MESSAGE_CATCH_ALL_ALREADY_CONFIGURED' },
    },
    GT = {
        CROSS_LOGIN: { name: 'CROSS_LOGIN', value: 2 },
        STANDARD_LOGIN: { name: 'STANDARD_LOGIN', value: 1 },
        STANDARD_LOGOUT: { name: 'STANDARD_LOGOUT', value: 3 },
    },
    HT = {
        AUDIO: { name: 'AUDIO' },
        DOCUMENT: { name: 'DOCUMENT' },
        FIRING_LOG: { name: 'FIRING_LOG' },
        IMAGE: { name: 'IMAGE' },
        MASTER_COPY: { name: 'MASTER_COPY' },
        OTHER: { name: 'OTHER' },
        VIDEO: { name: 'VIDEO' },
    },
    YT = { COURT: { name: 'COURT', value: 2 }, POLICE: { name: 'POLICE', value: 1 } },
    tT = {
        COMPLETE: { name: 'COMPLETE', value: 4 },
        COMPLETE_WITH_ERROR: { name: 'COMPLETE_WITH_ERROR', value: 3 },
        PROCESSING: { name: 'PROCESSING', value: 2 },
        READY: { name: 'READY', value: 1 },
    },
    VT = {
        BEXAR_ARRESTEE_CITY_POI_REPORT: { name: 'BEXAR_ARRESTEE_CITY_POI_REPORT' },
        BEXAR_ARRESTEE_COUNTY_POI_REPORT: { name: 'BEXAR_ARRESTEE_COUNTY_POI_REPORT' },
        NONE: { name: 'NONE' },
    },
    oT = {
        EXPORT: { name: 'EXPORT', value: 2 },
        FILE: { name: 'FILE', value: 8 },
        IMPORT: { name: 'IMPORT', value: 1 },
        SQL: { name: 'SQL', value: 4 },
        WEB: { name: 'WEB', value: 16 },
    },
    BT = {
        ADSI_CADFORCE_INTEGRATION: { name: 'ADSI_CADFORCE_INTEGRATION', value: 1302 },
        AFIS_ITOUCH_ARREST_EXPORT: { name: 'AFIS_ITOUCH_ARREST_EXPORT', value: 2379 },
        AFIS_ITOUCH_ARREST_IMPORT: { name: 'AFIS_ITOUCH_ARREST_IMPORT', value: 2380 },
        ANPR_BLACKSMITH: { name: 'ANPR_BLACKSMITH', value: 2344 },
        ATIMS_JMS_INTEGRATION: { name: 'ATIMS_JMS_INTEGRATION', value: 906 },
        AWS_MERGE_ID_TRANSLATOR: { name: 'AWS_MERGE_ID_TRANSLATOR', value: 2333 },
        AXON_EVIDENCE_LINK_INTEGRATION: { name: 'AXON_EVIDENCE_LINK_INTEGRATION', value: 1200 },
        AXON_EVIDENCE_TAGGING_INTEGRATION: {
            name: 'AXON_EVIDENCE_TAGGING_INTEGRATION',
            value: 1201,
        },
        BEXAR_PERSON_OF_INTEREST_INTEGRATION: {
            name: 'BEXAR_PERSON_OF_INTEREST_INTEGRATION',
            value: 1105,
        },
        BIOMETRICS_4_ALL_BLACKSMITH: { name: 'BIOMETRICS_4_ALL_BLACKSMITH', value: 2332 },
        BIOMETRICS_4_ALL_LIVESCAN_BLACKSMITH: {
            name: 'BIOMETRICS_4_ALL_LIVESCAN_BLACKSMITH',
            value: 2395,
        },
        BLACK_CREEK_SALLYPORT_JMS_INTEGRATION: {
            name: 'BLACK_CREEK_SALLYPORT_JMS_INTEGRATION',
            value: 1104,
        },
        BOSTON_RICI_INTEGRATION: { name: 'BOSTON_RICI_INTEGRATION', value: 962 },
        CAD_FAKER: { name: 'CAD_FAKER', value: 400 },
        CAD_TICKET_DELETION: { name: 'CAD_TICKET_DELETION', value: 214 },
        CARROLLTON_FORAY_EVIDENCE_INTEGRATION: {
            name: 'CARROLLTON_FORAY_EVIDENCE_INTEGRATION',
            value: 1103,
        },
        CASE_DELETION: { name: 'CASE_DELETION', value: 215 },
        CCLEA_CAD_INTEGRATION: { name: 'CCLEA_CAD_INTEGRATION', value: 800 },
        CCPD_LEAA_CAD_INTEGRATION: { name: 'CCPD_LEAA_CAD_INTEGRATION', value: 300 },
        CCPD_LEAA_SECURITY: { name: 'CCPD_LEAA_SECURITY', value: 301 },
        CCPD_PACKETALK_INTEGRATION: { name: 'CCPD_PACKETALK_INTEGRATION', value: 303 },
        CCPD_PDF_EXPORTER: { name: 'CCPD_PDF_EXPORTER', value: 304 },
        CCPD_POSS_SCHEDULING: { name: 'CCPD_POSS_SCHEDULING', value: 302 },
        CIBRS_BLACKSMITH: { name: 'CIBRS_BLACKSMITH', value: 2347 },
        CLOUDGAVEL_WARRANT_INTEGRATION: { name: 'CLOUDGAVEL_WARRANT_INTEGRATION', value: 1601 },
        CLRKP_REPORT_EXPORT_INTEGRATION: { name: 'CLRKP_REPORT_EXPORT_INTEGRATION', value: 1102 },
        CONFIGURATION_DATA_EXPORT: { name: 'CONFIGURATION_DATA_EXPORT', value: 2401 },
        CONFIGURATION_DATA_IMPORT: { name: 'CONFIGURATION_DATA_IMPORT', value: 2402 },
        CONSORTIUM_PERMISSIONS: { name: 'CONSORTIUM_PERMISSIONS', value: 208 },
        CRIMEREPORTS_INTEGRATION: { name: 'CRIMEREPORTS_INTEGRATION', value: 501 },
        CRIS_CRASH_TRAFFIC_INTEGRATION: { name: 'CRIS_CRASH_TRAFFIC_INTEGRATION', value: 1800 },
        CROSSROADS_INTEGRATION: { name: 'CROSSROADS_INTEGRATION', value: 504 },
        CROSSROADS_PARTNERSHIP_INTEGRATION: {
            name: 'CROSSROADS_PARTNERSHIP_INTEGRATION',
            value: 511,
        },
        CULVERCITY_LIVESCAN_INTEGRATION: { name: 'CULVERCITY_LIVESCAN_INTEGRATION', value: 910 },
        DATAWORKSPLUS_BOOKING_EXPORT: { name: 'DATAWORKSPLUS_BOOKING_EXPORT', value: 2300 },
        DATAWORKSPLUS_BOOKING_MUGSHOT_UPLOAD: {
            name: 'DATAWORKSPLUS_BOOKING_MUGSHOT_UPLOAD',
            value: 2301,
        },
        DATAWORKSPLUS_MORPHO_MUGSHOT_UPLOAD: {
            name: 'DATAWORKSPLUS_MORPHO_MUGSHOT_UPLOAD',
            value: 2303,
        },
        DEPARTMENT_RESET: { name: 'DEPARTMENT_RESET', value: 204 },
        DEPARTMENT_RESYNC: { name: 'DEPARTMENT_RESYNC', value: 210 },
        DISPATCHNOW_CAD_INTEGRATION: { name: 'DISPATCHNOW_CAD_INTEGRATION', value: 509 },
        DOCUSIGN_RELEASE_EXPORTER: { name: 'DOCUSIGN_RELEASE_EXPORTER', value: 2319 },
        DOCUSIGN_RELEASE_IMPORTER: { name: 'DOCUSIGN_RELEASE_IMPORTER', value: 2320 },
        DOI_CVB: { name: 'DOI_CVB', value: 2343 },
        DPD_NWS_CAD_INTEGRATION: { name: 'DPD_NWS_CAD_INTEGRATION', value: 500 },
        ECRASH_INTEGRATION: { name: 'ECRASH_INTEGRATION', value: 2321 },
        EIS_JMS: { name: 'EIS_JMS', value: 2201 },
        EXTERNAL_SERVICE_BUS_BLACKSMITH: { name: 'EXTERNAL_SERVICE_BUS_BLACKSMITH', value: 2342 },
        FIREHOUSE_FIRE_RMS_INTEGRATION: { name: 'FIREHOUSE_FIRE_RMS_INTEGRATION', value: 952 },
        GANGNET_GATEKEEPER_INTEGRATION: { name: 'GANGNET_GATEKEEPER_INTEGRATION', value: 1500 },
        GENERIC_ACTIVE_DIRECTORY_INTEGRATION: {
            name: 'GENERIC_ACTIVE_DIRECTORY_INTEGRATION',
            value: 1700,
        },
        GENERIC_API_TO_API_INTEGRATION: { name: 'GENERIC_API_TO_API_INTEGRATION', value: 2346 },
        GENERIC_CAD_API_INTEGRATION: { name: 'GENERIC_CAD_API_INTEGRATION', value: 2314 },
        GENERIC_CAD_FILE_DROP_INTEGRATION: {
            name: 'GENERIC_CAD_FILE_DROP_INTEGRATION',
            value: 514,
        },
        GENERIC_CAD_INTEGRATION: { name: 'GENERIC_CAD_INTEGRATION', value: 510 },
        GENERIC_FILEDROP_REPORT_CREATION_INTEGRATION: {
            name: 'GENERIC_FILEDROP_REPORT_CREATION_INTEGRATION',
            value: 1403,
        },
        GENERIC_FILE_ATTACHMENT_BLACKSMITH: {
            name: 'GENERIC_FILE_ATTACHMENT_BLACKSMITH',
            value: 2331,
        },
        GENERIC_PERSON_MERGE_BLACKSMITH: { name: 'GENERIC_PERSON_MERGE_BLACKSMITH', value: 2330 },
        GENERIC_RELEASE_EXPORT_INTEGRATION: {
            name: 'GENERIC_RELEASE_EXPORT_INTEGRATION',
            value: 1400,
        },
        GENERIC_REPORT_API_EXPORT_INTEGRATION: {
            name: 'GENERIC_REPORT_API_EXPORT_INTEGRATION',
            value: 2328,
        },
        GEO_ADDRESS_POINT_BACKFILL: { name: 'GEO_ADDRESS_POINT_BACKFILL', value: 2318 },
        GEO_ALIAS_BACKFILL: { name: 'GEO_ALIAS_BACKFILL', value: 2317 },
        GEO_CAUTION_BACKFILL: { name: 'GEO_CAUTION_BACKFILL', value: 2316 },
        HODH_DATALAKE_BLACKSMITH: { name: 'HODH_DATALAKE_BLACKSMITH', value: 2339 },
        HOUSTON_POLICE_PERSONNEL_SYSTEM_INTEGRATION: {
            name: 'HOUSTON_POLICE_PERSONNEL_SYSTEM_INTEGRATION',
            value: 916,
        },
        ICS_CAD_CSV_INTEGRATION: { name: 'ICS_CAD_CSV_INTEGRATION', value: 1301 },
        IMAGEDIRECTOR_REPORT_EXPORT_INTEGRATION: {
            name: 'IMAGEDIRECTOR_REPORT_EXPORT_INTEGRATION',
            value: 1401,
        },
        IMAGETREND_EPCR: { name: 'IMAGETREND_EPCR', value: 2e3 },
        INDEAVOR_INTEGRATION: { name: 'INDEAVOR_INTEGRATION', value: 2335 },
        JADES_WARRANT_INTEGRATION: { name: 'JADES_WARRANT_INTEGRATION', value: 1603 },
        JCPD_RUTGERS_CRIMEDATA_INTEGRATION: {
            name: 'JCPD_RUTGERS_CRIMEDATA_INTEGRATION',
            value: 502,
        },
        JUSTICETRAX_EVIDENCE_EXPORT_INTEGRATION: {
            name: 'JUSTICETRAX_EVIDENCE_EXPORT_INTEGRATION',
            value: 2323,
        },
        JUSTICETRAX_FILE_IMPORT_INTEGRATION: {
            name: 'JUSTICETRAX_FILE_IMPORT_INTEGRATION',
            value: 2322,
        },
        KARPEL_INTEGRATION: { name: 'KARPEL_INTEGRATION', value: 2313 },
        KCSO_PERSONNEL_INTEGRATION: { name: 'KCSO_PERSONNEL_INTEGRATION', value: 602 },
        KCSO_SEATTLE_JMS_INTEGRATION: { name: 'KCSO_SEATTLE_JMS_INTEGRATION', value: 2308 },
        KCSO_TE_CAD_INTEGRATION: { name: 'KCSO_TE_CAD_INTEGRATION', value: 600 },
        KRONOS_TELESTAFF_PERSONNEL_INTEGRATION: {
            name: 'KRONOS_TELESTAFF_PERSONNEL_INTEGRATION',
            value: 914,
        },
        KRONOS_TELESTAFF_UNIT_LOGON_INTEGRATION: {
            name: 'KRONOS_TELESTAFF_UNIT_LOGON_INTEGRATION',
            value: 915,
        },
        KSCO_BARS_INTEGRATION: { name: 'KSCO_BARS_INTEGRATION', value: 505 },
        KYOPS_INTEGRATION: { name: 'KYOPS_INTEGRATION', value: 2329 },
        LENEL_PERSONS_INTEGRATION: { name: 'LENEL_PERSONS_INTEGRATION', value: 1106 },
        LOCATION_LINK_CROSS_STREET_LAT_LONG_BACKFILL: {
            name: 'LOCATION_LINK_CROSS_STREET_LAT_LONG_BACKFILL',
            value: 2334,
        },
        LOCATION_RECLASSIFIER: { name: 'LOCATION_RECLASSIFIER', value: 2101 },
        LOCATION_RECLASSIFIER_LAT_LNG: { name: 'LOCATION_RECLASSIFIER_LAT_LNG', value: 2102 },
        LOCATION_TYPE_BACKFILL: { name: 'LOCATION_TYPE_BACKFILL', value: 2324 },
        M43_PDF_SFTP_EXPORT: { name: 'M43_PDF_SFTP_EXPORT', value: 2381 },
        MANDRILL_WHITELIST: { name: 'MANDRILL_WHITELIST', value: 201 },
        MARYLAND_COMPTROLLER_WARRANT_SUBJECT_EXPORT: {
            name: 'MARYLAND_COMPTROLLER_WARRANT_SUBJECT_EXPORT',
            value: 2307,
        },
        MARYLAND_DELTA_PLUS_INTEGRATION: { name: 'MARYLAND_DELTA_PLUS_INTEGRATION', value: 1801 },
        MARYLAND_MVA_WARRANT_SUBJECT_EXPORT: {
            name: 'MARYLAND_MVA_WARRANT_SUBJECT_EXPORT',
            value: 2306,
        },
        MARYLAND_MVA_WARRANT_SUBJECT_IMPORT: {
            name: 'MARYLAND_MVA_WARRANT_SUBJECT_IMPORT',
            value: 2305,
        },
        MARYLAND_OFFENDER_360_INTEGRATION: {
            name: 'MARYLAND_OFFENDER_360_INTEGRATION',
            value: 1802,
        },
        MENTALIX_ARREST_DEMOGRAPHICS_INTEGRATION: {
            name: 'MENTALIX_ARREST_DEMOGRAPHICS_INTEGRATION',
            value: 905,
        },
        MIAMI_DADE_THINKSTREAM_AFORM_IMPORT: {
            name: 'MIAMI_DADE_THINKSTREAM_AFORM_IMPORT',
            value: 2304,
        },
        MIGRATION_DATALOADER_ATTACHMENT: { name: 'MIGRATION_DATALOADER_ATTACHMENT', value: 760 },
        MIGRATION_DATALOADER_CAD_TICKET: { name: 'MIGRATION_DATALOADER_CAD_TICKET', value: 761 },
        MIGRATION_DATALOADER_CASE: { name: 'MIGRATION_DATALOADER_CASE', value: 721 },
        MIGRATION_DATALOADER_CASE_STATUS: { name: 'MIGRATION_DATALOADER_CASE_STATUS', value: 764 },
        MIGRATION_DATALOADER_CUSTOM_ENTITY: {
            name: 'MIGRATION_DATALOADER_CUSTOM_ENTITY',
            value: 765,
        },
        MIGRATION_DATALOADER_DATA_SLICE: { name: 'MIGRATION_DATALOADER_DATA_SLICE', value: 767 },
        MIGRATION_DATALOADER_ENTITY_PERMISSION: {
            name: 'MIGRATION_DATALOADER_ENTITY_PERMISSION',
            value: 763,
        },
        MIGRATION_DATALOADER_EVIDENCE: { name: 'MIGRATION_DATALOADER_EVIDENCE', value: 690 },
        MIGRATION_DATALOADER_EXTERNAL_OFFICER: {
            name: 'MIGRATION_DATALOADER_EXTERNAL_OFFICER',
            value: 2400,
        },
        MIGRATION_DATALOADER_E_FILE: { name: 'MIGRATION_DATALOADER_E_FILE', value: 2375 },
        MIGRATION_DATALOADER_ITEM: { name: 'MIGRATION_DATALOADER_ITEM', value: 740 },
        MIGRATION_DATALOADER_JMS_ARREST: { name: 'MIGRATION_DATALOADER_JMS_ARREST', value: 2350 },
        MIGRATION_DATALOADER_JMS_ATTACHMENT: {
            name: 'MIGRATION_DATALOADER_JMS_ATTACHMENT',
            value: 2392,
        },
        MIGRATION_DATALOADER_JMS_ATTRIBUTE: {
            name: 'MIGRATION_DATALOADER_JMS_ATTRIBUTE',
            value: 2351,
        },
        MIGRATION_DATALOADER_JMS_ATTRIBUTE_TYPE: {
            name: 'MIGRATION_DATALOADER_JMS_ATTRIBUTE_TYPE',
            value: 2353,
        },
        MIGRATION_DATALOADER_JMS_ATTR_CUST_FORM_CONF: {
            name: 'MIGRATION_DATALOADER_JMS_ATTR_CUST_FORM_CONF',
            value: 2352,
        },
        MIGRATION_DATALOADER_JMS_BAIL_APPOINTMENT: {
            name: 'MIGRATION_DATALOADER_JMS_BAIL_APPOINTMENT',
            value: 2390,
        },
        MIGRATION_DATALOADER_JMS_BAIL_APPT_EVENT: {
            name: 'MIGRATION_DATALOADER_JMS_BAIL_APPT_EVENT',
            value: 2393,
        },
        MIGRATION_DATALOADER_JMS_BOND: { name: 'MIGRATION_DATALOADER_JMS_BOND', value: 2354 },
        MIGRATION_DATALOADER_JMS_BOOKING: { name: 'MIGRATION_DATALOADER_JMS_BOOKING', value: 2355 },
        MIGRATION_DATALOADER_JMS_CHARGE: { name: 'MIGRATION_DATALOADER_JMS_CHARGE', value: 2356 },
        MIGRATION_DATALOADER_JMS_DETAINEE: {
            name: 'MIGRATION_DATALOADER_JMS_DETAINEE',
            value: 2357,
        },
        MIGRATION_DATALOADER_JMS_DETAINEE_TRANSF: {
            name: 'MIGRATION_DATALOADER_JMS_DETAINEE_TRANSF',
            value: 2359,
        },
        MIGRATION_DATALOADER_JMS_DET_IDENT_VALUE: {
            name: 'MIGRATION_DATALOADER_JMS_DET_IDENT_VALUE',
            value: 2358,
        },
        MIGRATION_DATALOADER_JMS_EVENTS_LOG: {
            name: 'MIGRATION_DATALOADER_JMS_EVENTS_LOG',
            value: 2360,
        },
        MIGRATION_DATALOADER_JMS_FILE_METADATA: {
            name: 'MIGRATION_DATALOADER_JMS_FILE_METADATA',
            value: 2391,
        },
        MIGRATION_DATALOADER_JMS_FIN_TRANSACTION: {
            name: 'MIGRATION_DATALOADER_JMS_FIN_TRANSACTION',
            value: 2361,
        },
        MIGRATION_DATALOADER_JMS_FORM_CONF: {
            name: 'MIGRATION_DATALOADER_JMS_FORM_CONF',
            value: 2362,
        },
        MIGRATION_DATALOADER_JMS_FORM_DATA: {
            name: 'MIGRATION_DATALOADER_JMS_FORM_DATA',
            value: 2363,
        },
        MIGRATION_DATALOADER_JMS_FORM_FIELD: {
            name: 'MIGRATION_DATALOADER_JMS_FORM_FIELD',
            value: 2364,
        },
        MIGRATION_DATALOADER_JMS_FORM_FIELD_VALUES: {
            name: 'MIGRATION_DATALOADER_JMS_FORM_FIELD_VALUES',
            value: 2365,
        },
        MIGRATION_DATALOADER_JMS_HOLD: { name: 'MIGRATION_DATALOADER_JMS_HOLD', value: 2366 },
        MIGRATION_DATALOADER_JMS_IDENTIFIER: {
            name: 'MIGRATION_DATALOADER_JMS_IDENTIFIER',
            value: 2367,
        },
        MIGRATION_DATALOADER_JMS_IDENTIFIER_VALUE: {
            name: 'MIGRATION_DATALOADER_JMS_IDENTIFIER_VALUE',
            value: 2368,
        },
        MIGRATION_DATALOADER_JMS_LIVESCAN_RESULT: {
            name: 'MIGRATION_DATALOADER_JMS_LIVESCAN_RESULT',
            value: 2376,
        },
        MIGRATION_DATALOADER_JMS_LOCATION: {
            name: 'MIGRATION_DATALOADER_JMS_LOCATION',
            value: 2369,
        },
        MIGRATION_DATALOADER_JMS_LOCATION_TAG_ATTR: {
            name: 'MIGRATION_DATALOADER_JMS_LOCATION_TAG_ATTR',
            value: 2370,
        },
        MIGRATION_DATALOADER_JMS_MUGSHOT: { name: 'MIGRATION_DATALOADER_JMS_MUGSHOT', value: 2386 },
        MIGRATION_DATALOADER_JMS_OFFENSE_CODE: {
            name: 'MIGRATION_DATALOADER_JMS_OFFENSE_CODE',
            value: 2371,
        },
        MIGRATION_DATALOADER_JMS_OFFICER: { name: 'MIGRATION_DATALOADER_JMS_OFFICER', value: 2399 },
        MIGRATION_DATALOADER_JMS_PROPERTY: {
            name: 'MIGRATION_DATALOADER_JMS_PROPERTY',
            value: 2372,
        },
        MIGRATION_DATALOADER_JMS_SCHEDULE: {
            name: 'MIGRATION_DATALOADER_JMS_SCHEDULE',
            value: 2387,
        },
        MIGRATION_DATALOADER_JMS_SCHEDULED_EVENT: {
            name: 'MIGRATION_DATALOADER_JMS_SCHEDULED_EVENT',
            value: 2388,
        },
        MIGRATION_DATALOADER_JMS_SCHEDULED_INSTANCE: {
            name: 'MIGRATION_DATALOADER_JMS_SCHEDULED_INSTANCE',
            value: 2383,
        },
        MIGRATION_DATALOADER_JMS_SCHED_EVT_INSTANCE: {
            name: 'MIGRATION_DATALOADER_JMS_SCHED_EVT_INSTANCE',
            value: 2389,
        },
        MIGRATION_DATALOADER_JMS_USER: { name: 'MIGRATION_DATALOADER_JMS_USER', value: 2374 },
        MIGRATION_DATALOADER_JMS_VA_APPOINTMENT: {
            name: 'MIGRATION_DATALOADER_JMS_VA_APPOINTMENT',
            value: 2384,
        },
        MIGRATION_DATALOADER_JMS_VA_APPOINTMENT_EVENT: {
            name: 'MIGRATION_DATALOADER_JMS_VA_APPOINTMENT_EVENT',
            value: 2385,
        },
        MIGRATION_DATALOADER_JMS_WARNING_SIGNAL: {
            name: 'MIGRATION_DATALOADER_JMS_WARNING_SIGNAL',
            value: 2377,
        },
        MIGRATION_DATALOADER_JMS_WARRANT: { name: 'MIGRATION_DATALOADER_JMS_WARRANT', value: 2373 },
        MIGRATION_DATALOADER_LEGACY_ENTITY_DETAILS: {
            name: 'MIGRATION_DATALOADER_LEGACY_ENTITY_DETAILS',
            value: 750,
        },
        MIGRATION_DATALOADER_LOCATION: { name: 'MIGRATION_DATALOADER_LOCATION', value: 730 },
        MIGRATION_DATALOADER_PERSON: { name: 'MIGRATION_DATALOADER_PERSON', value: 700 },
        MIGRATION_DATALOADER_REPORT: { name: 'MIGRATION_DATALOADER_REPORT', value: 720 },
        MIGRATION_DATALOADER_TASK: { name: 'MIGRATION_DATALOADER_TASK', value: 768 },
        MIGRATION_DATALOADER_USER: { name: 'MIGRATION_DATALOADER_USER', value: 710 },
        MIGRATION_DATALOADER_WARRANT: { name: 'MIGRATION_DATALOADER_WARRANT', value: 762 },
        MIGRATION_DRAGON_CONFIGURATION_PREP: {
            name: 'MIGRATION_DRAGON_CONFIGURATION_PREP',
            value: 766,
        },
        MIGRATION_VALIDATOR: { name: 'MIGRATION_VALIDATOR', value: 790 },
        MORPHOTRAK_ARREST_EXPORT: { name: 'MORPHOTRAK_ARREST_EXPORT', value: 1900 },
        MORPHOTRAK_ARREST_IMPORT: { name: 'MORPHOTRAK_ARREST_IMPORT', value: 1901 },
        MPD_SAFETYNET_XML_GENERATION: { name: 'MPD_SAFETYNET_XML_GENERATION', value: 2309 },
        NIST_DECODER: { name: 'NIST_DECODER', value: 250 },
        NIST_FILE_LIVESCAN_INTEGRATION: { name: 'NIST_FILE_LIVESCAN_INTEGRATION', value: 904 },
        NJ_CRASH_SUBMIT: { name: 'NJ_CRASH_SUBMIT', value: 2382 },
        NY_CRIS_BLACKSMITH: { name: 'NY_CRIS_BLACKSMITH', value: 2397 },
        ODYSSEY_WARRANT_INTEGRATION: { name: 'ODYSSEY_WARRANT_INTEGRATION', value: 1604 },
        OFFENDER_WATCH_INTEGRATION: { name: 'OFFENDER_WATCH_INTEGRATION', value: 1404 },
        PARTNERSHIP_CAD_EVENT_FILE_EXPORTER: {
            name: 'PARTNERSHIP_CAD_EVENT_FILE_EXPORTER',
            value: 2312,
        },
        PARTNERSHIP_REPORT_FILE_EXPORTER: { name: 'PARTNERSHIP_REPORT_FILE_EXPORTER', value: 2302 },
        PARTNERSHIP_REPORT_FILE_IMPORTER: { name: 'PARTNERSHIP_REPORT_FILE_IMPORTER', value: 2315 },
        PARTNERSHIP_V2_REPORT_FILE_IMPORTER: {
            name: 'PARTNERSHIP_V2_REPORT_FILE_IMPORTER',
            value: 2341,
        },
        PA_LEJIS_RMS_SUBMISSION_INTEGRATION: {
            name: 'PA_LEJIS_RMS_SUBMISSION_INTEGRATION',
            value: 1405,
        },
        PDF_EXPORTER: { name: 'PDF_EXPORTER', value: 203 },
        PDF_TEXT_EXTRACTOR: { name: 'PDF_TEXT_EXTRACTOR', value: 213 },
        PICTURE_LINK_EXPORTER: { name: 'PICTURE_LINK_EXPORTER', value: 305 },
        PNLD_OFFENSE_CODE_BLACKSMITH: { name: 'PNLD_OFFENSE_CODE_BLACKSMITH', value: 2394 },
        QUETEL_INTEGRATION: { name: 'QUETEL_INTEGRATION', value: 1107 },
        RECORDS_ARCHIVE_ATTACHMENT_MIGRATION: {
            name: 'RECORDS_ARCHIVE_ATTACHMENT_MIGRATION',
            value: 2336,
        },
        RECORDS_ARCHIVE_LOAD: { name: 'RECORDS_ARCHIVE_LOAD', value: 2337 },
        REDFLEX_CITATION_XML_INTEGRATION: { name: 'REDFLEX_CITATION_XML_INTEGRATION', value: 911 },
        REPORTBEAM_CITATION_CSV_INTEGRATION: {
            name: 'REPORTBEAM_CITATION_CSV_INTEGRATION',
            value: 903,
        },
        REPORTBEAM_CITATION_INTEGRATION: { name: 'REPORTBEAM_CITATION_INTEGRATION', value: 506 },
        REPORTBEAM_CITATION_PARTNERSHIP_INTEGRATION: {
            name: 'REPORTBEAM_CITATION_PARTNERSHIP_INTEGRATION',
            value: 516,
        },
        REPORT_DELETION: { name: 'REPORT_DELETION', value: 207 },
        RESPONSE_PLAN_EXECUTION_INFO_VERSION_BACKFILL: {
            name: 'RESPONSE_PLAN_EXECUTION_INFO_VERSION_BACKFILL',
            value: 2326,
        },
        RPD_RIPNRUN_INTEGRATION: { name: 'RPD_RIPNRUN_INTEGRATION', value: 1e3 },
        SALLYPORT_WARRANT_INTEGRATION: { name: 'SALLYPORT_WARRANT_INTEGRATION', value: 1600 },
        SCHEDULED_EVENT_BACKFILL: { name: 'SCHEDULED_EVENT_BACKFILL', value: 2325 },
        SEARCH_REINDEX_ALIAS: { name: 'SEARCH_REINDEX_ALIAS', value: 205 },
        SEARCH_RESYNC: { name: 'SEARCH_RESYNC', value: 200 },
        SEATTLE_CAD_INTEGRATION: { name: 'SEATTLE_CAD_INTEGRATION', value: 1100 },
        SMOKE_TEST_BLACKSMITH: { name: 'SMOKE_TEST_BLACKSMITH', value: 2403 },
        SOCRATA_PUBLIC_DATA: { name: 'SOCRATA_PUBLIC_DATA', value: 9999 },
        SOUTHBAY_BOOKING_INTEGRATION: { name: 'SOUTHBAY_BOOKING_INTEGRATION', value: 902 },
        SOUTHBAY_CAD_INTEGRATION: { name: 'SOUTHBAY_CAD_INTEGRATION', value: 900 },
        SOUTHBAY_LIVESCAN_INTEGRATION: { name: 'SOUTHBAY_LIVESCAN_INTEGRATION', value: 901 },
        SPD_MIGRATED_RELEASES_BLACKSMITH: { name: 'SPD_MIGRATED_RELEASES_BLACKSMITH', value: 1101 },
        STATE_PLANE_COORDINATE: { name: 'STATE_PLANE_COORDINATE', value: 209 },
        SUPERION_CAD_INTEGRATION: { name: 'SUPERION_CAD_INTEGRATION', value: 1300 },
        SWITRS_INTEGRATION: { name: 'SWITRS_INTEGRATION', value: 2311 },
        TEST_ADDITION: { name: 'TEST_ADDITION', value: 1 },
        TEST_PRINT_EMAIL: { name: 'TEST_PRINT_EMAIL', value: 2 },
        THUMBNAIL_CREATOR: { name: 'THUMBNAIL_CREATOR', value: 206 },
        TIBURON_TE_CAD_INTEGRATION: { name: 'TIBURON_TE_CAD_INTEGRATION', value: 606 },
        TRACS_TRAFFIC_INTEGRATION: { name: 'TRACS_TRAFFIC_INTEGRATION', value: 961 },
        TRAINING_DATA_IMPORT: { name: 'TRAINING_DATA_IMPORT', value: 2378 },
        TRITECH_CAD_INTEGRATION: { name: 'TRITECH_CAD_INTEGRATION', value: 507 },
        TRITECH_FILE_DROP_CAD_INTEGRATION: {
            name: 'TRITECH_FILE_DROP_CAD_INTEGRATION',
            value: 513,
        },
        UBS_BOOKING_INTEGRATION: { name: 'UBS_BOOKING_INTEGRATION', value: 960 },
        UK_CORONIAL_BLACKSMITH: { name: 'UK_CORONIAL_BLACKSMITH', value: 2348 },
        UK_GMP_CRIMESTOPPERS_BLACKSMITH: { name: 'UK_GMP_CRIMESTOPPERS_BLACKSMITH', value: 2396 },
        UK_PENTIP_BLACKSMITH: { name: 'UK_PENTIP_BLACKSMITH', value: 2398 },
        UK_SAAB_GET_NEW_ISSUES_BLACKSMITH: {
            name: 'UK_SAAB_GET_NEW_ISSUES_BLACKSMITH',
            value: 2406,
        },
        UK_SAAB_RMS_REPORT_UPDATES_BLACKSMITH: {
            name: 'UK_SAAB_RMS_REPORT_UPDATES_BLACKSMITH',
            value: 2404,
        },
        VENDOR_RELEASE_EXPORT_INTEGRATION: {
            name: 'VENDOR_RELEASE_EXPORT_INTEGRATION',
            value: 1402,
        },
        VERSATERM_CAD_INTEGRATION: { name: 'VERSATERM_CAD_INTEGRATION', value: 508 },
        VERSATERM_PERSONNEL_INTEGRATION: { name: 'VERSATERM_PERSONNEL_INTEGRATION', value: 913 },
        VIGILANT_FACESEARCH_INTEGRATION: { name: 'VIGILANT_FACESEARCH_INTEGRATION', value: 2310 },
        VSS_CSV_EXPORTER_BLACKSMITH: { name: 'VSS_CSV_EXPORTER_BLACKSMITH', value: 2345 },
        WARRANT_DELETION: { name: 'WARRANT_DELETION', value: 212 },
        ZOLL_FIRE_RMS_INTEGRATION: { name: 'ZOLL_FIRE_RMS_INTEGRATION', value: 950 },
        ZOLL_FIRE_RMS_PARTNERSHIP_INTEGRATION: {
            name: 'ZOLL_FIRE_RMS_PARTNERSHIP_INTEGRATION',
            value: 951,
        },
    },
    rT = {
        CREATED: { name: 'CREATED', value: 1 },
        DELETED: { name: 'DELETED', value: 3 },
        PINNED: { name: 'PINNED', value: 4 },
        UNPINNED: { name: 'UNPINNED', value: 5 },
        UPDATED: { name: 'UPDATED', value: 2 },
    },
    sT = {
        IN_CUSTODY: { name: 'IN_CUSTODY', value: 'IN_CUSTODY' },
        IN_TRANSFER: { name: 'IN_TRANSFER', value: 'IN_TRANSFER' },
        PENDING_BOOKING: { name: 'PENDING_BOOKING', value: 'PENDING_BOOKING' },
        RELEASED: { name: 'RELEASED', value: 'RELEASED' },
        TEMP_RELEASE: { name: 'TEMP_RELEASE', value: 'TEMP_RELEASE' },
    },
    iT = {
        DIRECT_BOOKING: { name: 'DIRECT_BOOKING', value: 'DIRECT_BOOKING' },
        HISTORICAL_BOOKING: { name: 'HISTORICAL_BOOKING', value: 'HISTORICAL_BOOKING' },
        PREBOOKING: { name: 'PREBOOKING', value: 'PREBOOKING' },
    },
    WT = {
        AGENCY_EVENT: { name: 'AGENCY_EVENT', value: 1 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 3 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 2 },
    },
    cT = {
        ACTIVE: { name: 'ACTIVE', value: 2 },
        ARCHIVED: { name: 'ARCHIVED', value: 3 },
        DRAFT: { name: 'DRAFT', value: 1 },
    },
    KT = {
        NEGATIVE_BUFFER_MINUTES: { name: 'NEGATIVE_BUFFER_MINUTES' },
        NO_BUFFER_MINUTES: { name: 'NO_BUFFER_MINUTES' },
        TIMER_ALREADY_CONFIGURED: { name: 'TIMER_ALREADY_CONFIGURED' },
    },
    dT = {
        DEV: { name: 'DEV', value: 1 },
        PROD_AWS: { name: 'PROD_AWS', value: 4 },
        PROD_AZURE: { name: 'PROD_AZURE', value: 5 },
        QA: { name: 'QA', value: 2 },
        STAGING: { name: 'STAGING', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    pT = {
        ABILITY_ROLE_LINK: { name: 'ABILITY_ROLE_LINK', value: 22 },
        ATTRIBUTE: { name: 'ATTRIBUTE', value: 1 },
        CAD_CONTACT_LISTS: { name: 'CAD_CONTACT_LISTS', value: 11 },
        CAD_UNITS: { name: 'CAD_UNITS', value: 15 },
        CALL_FOR_SERVICE: { name: 'CALL_FOR_SERVICE', value: 16 },
        CALL_TAKER_STATIONS: { name: 'CALL_TAKER_STATIONS', value: 14 },
        DOJ_SCHOOLS: { name: 'DOJ_SCHOOLS', value: 23 },
        EVIDENCE_FACILITY: { name: 'EVIDENCE_FACILITY', value: 19 },
        EVIDENCE_LOCATION: { name: 'EVIDENCE_LOCATION', value: 9 },
        EVIDENCE_LOCATION_WITH_FACILITY: { name: 'EVIDENCE_LOCATION_WITH_FACILITY', value: 20 },
        EVIDENCE_RETENTION: { name: 'EVIDENCE_RETENTION', value: 10 },
        LOCATION_ALIAS: { name: 'LOCATION_ALIAS', value: 4 },
        LOCATION_CAUTION: { name: 'LOCATION_CAUTION', value: 5 },
        LOG_ON_BULK_UNITS: { name: 'LOG_ON_BULK_UNITS', value: 13 },
        NEW_YORK_NIBRS_OFFENSE_CODE_CONFIGURATIONS: {
            name: 'NEW_YORK_NIBRS_OFFENSE_CODE_CONFIGURATIONS',
            value: 25,
        },
        NIBRS_OFFENSE_CODE_CONFIGURATIONS: { name: 'NIBRS_OFFENSE_CODE_CONFIGURATIONS', value: 24 },
        OFFENSE_CODE: { name: 'OFFENSE_CODE', value: 2 },
        RADIO_CHANNELS: { name: 'RADIO_CHANNELS', value: 12 },
        RIPA_OFFENSE_CODES: { name: 'RIPA_OFFENSE_CODES', value: 21 },
        STREET_SEARCH_ALIAS: { name: 'STREET_SEARCH_ALIAS', value: 6 },
        STREET_SEGMENT: { name: 'STREET_SEGMENT', value: 7 },
        UNIT_STATE_DEPARTMENT_TRANSITIONS: { name: 'UNIT_STATE_DEPARTMENT_TRANSITIONS', value: 18 },
        UNIT_STATE_TRANSITIONS: { name: 'UNIT_STATE_TRANSITIONS', value: 17 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 3 },
        VEHICLE_MAKE_MODEL: { name: 'VEHICLE_MAKE_MODEL', value: 8 },
    },
    yT = {
        CAD_CLIENT: { name: 'CAD_CLIENT', value: 1 },
        CAD_NEXT: { name: 'CAD_NEXT', value: 3 },
        FR_CLIENT: { name: 'FR_CLIENT', value: 2 },
    },
    XT = {
        ALPHA: { name: 'ALPHA', value: 4 },
        BETA: { name: 'BETA', value: 5 },
        DEVELOP: { name: 'DEVELOP', value: 3 },
        NEXT: { name: 'NEXT', value: 6 },
        PRODUCTION: { name: 'PRODUCTION', value: 1 },
        STAGING: { name: 'STAGING', value: 2 },
        TEST: { name: 'TEST', value: 7 },
    },
    QT = {
        ADDITIONAL_CALL_FOR_SERVICE: { name: 'ADDITIONAL_CALL_FOR_SERVICE' },
        ADDITIONAL_DISPOSITIONS_ENABLED: { name: 'ADDITIONAL_DISPOSITIONS_ENABLED' },
        ADD_BOLO_ATTACHMENTS: { name: 'ADD_BOLO_ATTACHMENTS' },
        ADD_EVENT_ATTACHMENTS: { name: 'ADD_EVENT_ATTACHMENTS' },
        ADD_TOW_VEHICLES_ASSIGNED_EVENTS: { name: 'ADD_TOW_VEHICLES_ASSIGNED_EVENTS' },
        ADD_TOW_VEHICLES_UNASSIGNED_EVENTS: { name: 'ADD_TOW_VEHICLES_UNASSIGNED_EVENTS' },
        ALERT_DISPATCH_AREAS: { name: 'ALERT_DISPATCH_AREAS' },
        ALLOW_LIGHT_MODE_ENABLED: { name: 'ALLOW_LIGHT_MODE_ENABLED' },
        AML_USER: { name: 'AML_USER' },
        ASSIGN_SELF_TO_EVENTS: { name: 'ASSIGN_SELF_TO_EVENTS' },
        ASSOCIATED_EVENTS_ENABLED: { name: 'ASSOCIATED_EVENTS_ENABLED' },
        ASSOCIATE_EVENTS: { name: 'ASSOCIATE_EVENTS' },
        ASYNC_RESPONSE_PLANS_ENABLED: { name: 'ASYNC_RESPONSE_PLANS_ENABLED' },
        ATTEMPT_MAP_AUTO_RECOVERY_ENABLED: { name: 'ATTEMPT_MAP_AUTO_RECOVERY_ENABLED' },
        AUTOMATICALLY_HOLD_EVENTS_FOR_UNITS: { name: 'AUTOMATICALLY_HOLD_EVENTS_FOR_UNITS' },
        AUTOMATICALLY_IMPORT_CALLER_NAME_AND_LOCATION_ON_E911_CALLS: {
            name: 'AUTOMATICALLY_IMPORT_CALLER_NAME_AND_LOCATION_ON_E911_CALLS',
        },
        BLUR_DIAGNOSTICS_ENABLED: { name: 'BLUR_DIAGNOSTICS_ENABLED' },
        CAD_ALLOW_UNIT_GPS_FOR_LOCATION: { name: 'CAD_ALLOW_UNIT_GPS_FOR_LOCATION' },
        CAD_BOOTSTRAP_EXCLUDE_UNACKED_IN_PROGRESS_UNIT_EMERGENCIES_ENABLED: {
            name: 'CAD_BOOTSTRAP_EXCLUDE_UNACKED_IN_PROGRESS_UNIT_EMERGENCIES_ENABLED',
        },
        CAD_DATADOG_SESSION_REPLAY_ENABLED: { name: 'CAD_DATADOG_SESSION_REPLAY_ENABLED' },
        CAD_DATADOG_UNMASKING_ENABLED: { name: 'CAD_DATADOG_UNMASKING_ENABLED' },
        CAD_EXPUNGEMENTS: { name: 'CAD_EXPUNGEMENTS' },
        CAD_FR_APP_DOWNLOAD: { name: 'CAD_FR_APP_DOWNLOAD' },
        CAD_LIGHT_MODE_ENABLED: { name: 'CAD_LIGHT_MODE_ENABLED' },
        CAD_MAP_TESTS_ENABLED: { name: 'CAD_MAP_TESTS_ENABLED' },
        CAD_MULTIPLE_ORI_ENABLED: { name: 'CAD_MULTIPLE_ORI_ENABLED' },
        CAD_NEXT_DISABLE_LEGACY_CAD_ACCESS: { name: 'CAD_NEXT_DISABLE_LEGACY_CAD_ACCESS' },
        CAD_PROLOG_RESPONSE_PLANS_STAFFING_POOL_ENABLED: {
            name: 'CAD_PROLOG_RESPONSE_PLANS_STAFFING_POOL_ENABLED',
        },
        CAD_REPLACES_AML_ENABLED: { name: 'CAD_REPLACES_AML_ENABLED' },
        CAD_RESPONSE_PLAN_CROSS_STAFFING_ENABLED: {
            name: 'CAD_RESPONSE_PLAN_CROSS_STAFFING_ENABLED',
        },
        CAN_CREATE_EVENT: { name: 'CAN_CREATE_EVENT' },
        CAN_GENERATE_REPOSSESSION_REN: { name: 'CAN_GENERATE_REPOSSESSION_REN' },
        CAN_REACTIVATE_EVENT: { name: 'CAN_REACTIVATE_EVENT' },
        CHANGE_ORI_ALIAS: { name: 'CHANGE_ORI_ALIAS' },
        CLEAR_EVENT: { name: 'CLEAR_EVENT' },
        CLOSEST_UNIT_RECOMMENDATION: { name: 'CLOSEST_UNIT_RECOMMENDATION' },
        COMMAND_LINE_COMPACT_BY_DEFAULT: { name: 'COMMAND_LINE_COMPACT_BY_DEFAULT' },
        COMMENTS_REQUIRED_WHEN_BYPASSING_SERVICE_ROTATION: {
            name: 'COMMENTS_REQUIRED_WHEN_BYPASSING_SERVICE_ROTATION',
        },
        CONFIRM_BEFORE_CLOSING_NEW_EVENT_FORMS: { name: 'CONFIRM_BEFORE_CLOSING_NEW_EVENT_FORMS' },
        CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP: {
            name: 'CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP',
        },
        CONSOLIDATED_EVENT_EXPORT: { name: 'CONSOLIDATED_EVENT_EXPORT' },
        COPY_CALL: { name: 'COPY_CALL' },
        CREATE_ADDITIONAL_INFOS: { name: 'CREATE_ADDITIONAL_INFOS' },
        CREATE_BOLOS: { name: 'CREATE_BOLOS' },
        CREATE_EVENT_AT_LOCATION_PIN: { name: 'CREATE_EVENT_AT_LOCATION_PIN' },
        CROSS_CLASS_ASSISTANCE: { name: 'CROSS_CLASS_ASSISTANCE' },
        CUSTOM_TRACING_ENABLED: { name: 'CUSTOM_TRACING_ENABLED' },
        DATADOG_ENABLED: { name: 'DATADOG_ENABLED' },
        DATA_EXCHANGE: { name: 'DATA_EXCHANGE' },
        DATA_EXCHANGE_EVENT_PANEL_TAB: { name: 'DATA_EXCHANGE_EVENT_PANEL_TAB' },
        DATA_EXCHANGE_INCOMING_MESSAGES_ENABLE_MOCKED_DEMO_MODE: {
            name: 'DATA_EXCHANGE_INCOMING_MESSAGES_ENABLE_MOCKED_DEMO_MODE',
        },
        DATE_PICKER_FORCE_LEADING_ZEROS_ENABLED: {
            name: 'DATE_PICKER_FORCE_LEADING_ZEROS_ENABLED',
        },
        DEFAULT_CA_PURPOSE_CODE_FIELD: { name: 'DEFAULT_CA_PURPOSE_CODE_FIELD' },
        DEFAULT_DEX_FORMS_IMAGE_INDICATOR: { name: 'DEFAULT_DEX_FORMS_IMAGE_INDICATOR' },
        DEFAULT_FUZZY_MATCHING_ENABLED: { name: 'DEFAULT_FUZZY_MATCHING_ENABLED' },
        DEFAULT_INCLUDE_ACTIVE_ENABLED: { name: 'DEFAULT_INCLUDE_ACTIVE_ENABLED' },
        DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP: { name: 'DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP' },
        DEFAULT_UNIT_LOCATION_CHECKBOX_VALUE: { name: 'DEFAULT_UNIT_LOCATION_CHECKBOX_VALUE' },
        DELETE_ADDITIONAL_INFOS: { name: 'DELETE_ADDITIONAL_INFOS' },
        DELETE_BOLO_ATTACHMENTS: { name: 'DELETE_BOLO_ATTACHMENTS' },
        DELETE_EVENT_ATTACHMENTS: { name: 'DELETE_EVENT_ATTACHMENTS' },
        DESKTOP_INTEGRATION_ENABLED: { name: 'DESKTOP_INTEGRATION_ENABLED' },
        DEVICE_MANAGER_ENABLED: { name: 'DEVICE_MANAGER_ENABLED' },
        DEVICE_MANAGER_UPDATE_CONTROL_ENABLED: { name: 'DEVICE_MANAGER_UPDATE_CONTROL_ENABLED' },
        DEX_ACTIVITY_EXPORT_ENABLED: { name: 'DEX_ACTIVITY_EXPORT_ENABLED' },
        DEX_NEXT_ENABLED: { name: 'DEX_NEXT_ENABLED' },
        DEX_PARSING_ENABLED: { name: 'DEX_PARSING_ENABLED' },
        DEX_PURPOSE_CODE: { name: 'DEX_PURPOSE_CODE' },
        DEX_USE_RESPONSE_TYPE_LABEL: { name: 'DEX_USE_RESPONSE_TYPE_LABEL' },
        DIAGNOSTIC_CONTEXT_ENABLED: { name: 'DIAGNOSTIC_CONTEXT_ENABLED' },
        DISABLE_LEGACY_CAD_WEB: { name: 'DISABLE_LEGACY_CAD_WEB' },
        DISABLE_LEGACY_MAP_AND_SEARCHES: { name: 'DISABLE_LEGACY_MAP_AND_SEARCHES' },
        DISABLE_POWER_SAVE_BLOCKER_ENABLED: { name: 'DISABLE_POWER_SAVE_BLOCKER_ENABLED' },
        DISPATCHER_CLI: { name: 'DISPATCHER_CLI' },
        DISPATCHER_INITIATE_EVENT: { name: 'DISPATCHER_INITIATE_EVENT' },
        DISPATCH_CONFIRM_UNASSIGNING_EVENTS: { name: 'DISPATCH_CONFIRM_UNASSIGNING_EVENTS' },
        DISPATCH_FROM_MAP: { name: 'DISPATCH_FROM_MAP' },
        DISPATCH_PLAY_ALERT_ON_AED_EVENT: { name: 'DISPATCH_PLAY_ALERT_ON_AED_EVENT' },
        DISPATCH_PLAY_ALERT_ON_ENTER_UNASSIGNED_QUEUE: {
            name: 'DISPATCH_PLAY_ALERT_ON_ENTER_UNASSIGNED_QUEUE',
        },
        DISPATCH_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE: {
            name: 'DISPATCH_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE',
        },
        DISPATCH_PLAY_ALERT_ON_NEW_URGENT_MESSAGE: {
            name: 'DISPATCH_PLAY_ALERT_ON_NEW_URGENT_MESSAGE',
        },
        DISPATCH_PLAY_ALERT_ON_UNIT_STATUS_TIMER_EXPIRATION: {
            name: 'DISPATCH_PLAY_ALERT_ON_UNIT_STATUS_TIMER_EXPIRATION',
        },
        DOWNLOAD_ALL_EXPORTS_INDIVIDUALLY_ENABLED: {
            name: 'DOWNLOAD_ALL_EXPORTS_INDIVIDUALLY_ENABLED',
        },
        DRAG_AND_DROP_DISPATCH: { name: 'DRAG_AND_DROP_DISPATCH' },
        EDIT_ADDITIONAL_INFOS: { name: 'EDIT_ADDITIONAL_INFOS' },
        EDIT_ASSIGNED_EVENTS: { name: 'EDIT_ASSIGNED_EVENTS' },
        EDIT_CLEARED_EVENTS: { name: 'EDIT_CLEARED_EVENTS' },
        EDIT_CONTACT_LIST: { name: 'EDIT_CONTACT_LIST' },
        EDIT_UNASSIGNED_EVENTS: { name: 'EDIT_UNASSIGNED_EVENTS' },
        ELECTRON_AUTO_UPDATES_ENABLED: { name: 'ELECTRON_AUTO_UPDATES_ENABLED' },
        ELECTRON_HIGH_FIDELITY_NETWORK_CHECKS_ENABLED: {
            name: 'ELECTRON_HIGH_FIDELITY_NETWORK_CHECKS_ENABLED',
        },
        ELECTRON_LOG_RECOVERY_ENABLED: { name: 'ELECTRON_LOG_RECOVERY_ENABLED' },
        ELECTRON_MACHINE_INSTALLATION_AUTO_UPDATES_ENABLED: {
            name: 'ELECTRON_MACHINE_INSTALLATION_AUTO_UPDATES_ENABLED',
        },
        ELECTRON_REMOTE_DEBUG_LOGGING_ENABLED: { name: 'ELECTRON_REMOTE_DEBUG_LOGGING_ENABLED' },
        ELECTRON_REMOTE_LOGGING_ENABLED: { name: 'ELECTRON_REMOTE_LOGGING_ENABLED' },
        ELECTRON_USE_SEPARATE_SESSION_FOR_DOWNLOADS_ENABLED: {
            name: 'ELECTRON_USE_SEPARATE_SESSION_FOR_DOWNLOADS_ENABLED',
        },
        ENABLE_INFINITE_MAP_RECOVERY_ENABLED: { name: 'ENABLE_INFINITE_MAP_RECOVERY_ENABLED' },
        ENABLE_UNIT_CLUSTERING_ON_MAP: { name: 'ENABLE_UNIT_CLUSTERING_ON_MAP' },
        ENHANCED_ENTITIES_ENABLED: { name: 'ENHANCED_ENTITIES_ENABLED' },
        ENHANCED_RELATED_DATA: { name: 'ENHANCED_RELATED_DATA' },
        ENHANCED_SEARCH_EXPORTS_ENABLED: { name: 'ENHANCED_SEARCH_EXPORTS_ENABLED' },
        ENHANCED_SELF_INITIATION_ENABLED: { name: 'ENHANCED_SELF_INITIATION_ENABLED' },
        ENHANCED_SERVICE_ROTATION: { name: 'ENHANCED_SERVICE_ROTATION' },
        ESRI_FEATURE_REDUCTION_CLUSTERING_ENABLED: {
            name: 'ESRI_FEATURE_REDUCTION_CLUSTERING_ENABLED',
        },
        ESRI_OAUTH_TOKEN_ENABLED: { name: 'ESRI_OAUTH_TOKEN_ENABLED' },
        EVENTS_ALLOW_ADDING_TOW_VEHICLE: { name: 'EVENTS_ALLOW_ADDING_TOW_VEHICLE' },
        EVENTS_HAVE_EMS_D_AREA_AND_EMS_AGENCY: { name: 'EVENTS_HAVE_EMS_D_AREA_AND_EMS_AGENCY' },
        EVENTS_HAVE_FIRE_D_AREA_AND_FIRE_AGENCY: {
            name: 'EVENTS_HAVE_FIRE_D_AREA_AND_FIRE_AGENCY',
        },
        EVENTS_HAVE_RISK_LEVEL: { name: 'EVENTS_HAVE_RISK_LEVEL' },
        EVENT_LABELS: { name: 'EVENT_LABELS' },
        EVENT_LOCATION_NOTES: { name: 'EVENT_LOCATION_NOTES' },
        EVENT_LOCATION_PREFILLS_REPORTING_PARTY_LOCATION: {
            name: 'EVENT_LOCATION_PREFILLS_REPORTING_PARTY_LOCATION',
        },
        EVENT_PANEL_COMPACT_BY_DEFAULT: { name: 'EVENT_PANEL_COMPACT_BY_DEFAULT' },
        EXPIRE_BOLOS: { name: 'EXPIRE_BOLOS' },
        EXTERNAL_AGENCIES: { name: 'EXTERNAL_AGENCIES' },
        FARO_DISABLED: { name: 'FARO_DISABLED' },
        FEDERATED_SEARCH_ID_AWARE_STREAMS_ENABLED: {
            name: 'FEDERATED_SEARCH_ID_AWARE_STREAMS_ENABLED',
        },
        FE_CUSTOM_SPANS_ENABLED: { name: 'FE_CUSTOM_SPANS_ENABLED' },
        FE_DEBUG_LOGGING_ENABLED: { name: 'FE_DEBUG_LOGGING_ENABLED' },
        FE_LOGGING_ENABLED: { name: 'FE_LOGGING_ENABLED' },
        FE_USE_AXIOS_FETCH: { name: 'FE_USE_AXIOS_FETCH' },
        FILTER_LOCATION_BY_DISPATCH_AREA_ENABLED: {
            name: 'FILTER_LOCATION_BY_DISPATCH_AREA_ENABLED',
        },
        FILTER_OUT_SYSTEM_MESSAGES_FROM_NARRATIVE_BY_DEFAULT: {
            name: 'FILTER_OUT_SYSTEM_MESSAGES_FROM_NARRATIVE_BY_DEFAULT',
        },
        FIRST_RESPONDER_CAN_EDIT_UNIT_LOCATIONS: {
            name: 'FIRST_RESPONDER_CAN_EDIT_UNIT_LOCATIONS',
        },
        FIRST_RESPONDER_CAN_GENERATE_REN: { name: 'FIRST_RESPONDER_CAN_GENERATE_REN' },
        FIRST_RESPONDER_CONFIRM_UNASSIGNING_EVENTS: {
            name: 'FIRST_RESPONDER_CONFIRM_UNASSIGNING_EVENTS',
        },
        FIRST_RESPONDER_CORE: { name: 'FIRST_RESPONDER_CORE' },
        FIRST_RESPONDER_LIGHT_MODE_ENABLED: { name: 'FIRST_RESPONDER_LIGHT_MODE_ENABLED' },
        FIRST_RESPONDER_MAP_CONTAINER_FIXED_POSITION_ENABLED: {
            name: 'FIRST_RESPONDER_MAP_CONTAINER_FIXED_POSITION_ENABLED',
        },
        FIRST_RESPONDER_MAP_SELF_FOCUS: { name: 'FIRST_RESPONDER_MAP_SELF_FOCUS' },
        FIRST_RESPONDER_OFF_DUTY: { name: 'FIRST_RESPONDER_OFF_DUTY' },
        FIRST_RESPONDER_PLAY_ALERT_ON_HOT_HIT_DEX_RESULT: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_HOT_HIT_DEX_RESULT',
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_AED_ASSIGNMENT: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_AED_ASSIGNMENT',
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_ASSIGNMENT: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_ASSIGNMENT',
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE',
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_NEW_URGENT_MESSAGE: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_NEW_URGENT_MESSAGE',
        },
        FIRST_RESPONDER_VIEW_ASSIGNED_EVENTS_ENABLED: {
            name: 'FIRST_RESPONDER_VIEW_ASSIGNED_EVENTS_ENABLED',
        },
        FIRST_RESPONDER_VIEW_UNASSIGNED_EVENTS_ENABLED: {
            name: 'FIRST_RESPONDER_VIEW_UNASSIGNED_EVENTS_ENABLED',
        },
        FLEET_ENABLED: { name: 'FLEET_ENABLED' },
        FOCUS_EVENT_PANEL_ON_E911_CALL: { name: 'FOCUS_EVENT_PANEL_ON_E911_CALL' },
        FOCUS_MAP_DURING_ACTIVE_EVENT: { name: 'FOCUS_MAP_DURING_ACTIVE_EVENT' },
        FOCUS_MAP_DURING_CALL_CREATION: { name: 'FOCUS_MAP_DURING_CALL_CREATION' },
        FR_NEXT_ENABLED: { name: 'FR_NEXT_ENABLED' },
        FR_SELF_INITIATE_GPS_LOCATION: { name: 'FR_SELF_INITIATE_GPS_LOCATION' },
        FR_SHOW_NEARBY_EVENTS_ENABLED: { name: 'FR_SHOW_NEARBY_EVENTS_ENABLED' },
        GENERATE_REN_ASSIGNED_CLEARED: { name: 'GENERATE_REN_ASSIGNED_CLEARED' },
        GENERATE_REN_UNASSIGNED: { name: 'GENERATE_REN_UNASSIGNED' },
        HELD_EVENTS: { name: 'HELD_EVENTS' },
        HIDE_MANAGE_DISPATCH_AREAS_MODAL_AT_STARTUP: {
            name: 'HIDE_MANAGE_DISPATCH_AREAS_MODAL_AT_STARTUP',
        },
        HIDE_PATROLS_AND_SPECIAL_ASSIGNMENT: { name: 'HIDE_PATROLS_AND_SPECIAL_ASSIGNMENT' },
        HOSPITALS_ENABLED: { name: 'HOSPITALS_ENABLED' },
        IMAGES_IN_DEX_RESULTS: { name: 'IMAGES_IN_DEX_RESULTS' },
        IMPROVED_SCHEDULED_EVENTS: { name: 'IMPROVED_SCHEDULED_EVENTS' },
        INVOLVED_PERSONS_AND_VEHICLES_ENABLED: { name: 'INVOLVED_PERSONS_AND_VEHICLES_ENABLED' },
        INVOLVED_PROPERTY_ENABLED: { name: 'INVOLVED_PROPERTY_ENABLED' },
        LAB_EXTENSION_ENABLED: { name: 'LAB_EXTENSION_ENABLED' },
        LAW_ENFORCEMENT_RESPONSE_PLANS: { name: 'LAW_ENFORCEMENT_RESPONSE_PLANS' },
        LEGACY_APP_DEPRECATION: { name: 'LEGACY_APP_DEPRECATION' },
        LIMIT_WPH2_REBID_ENABLED: { name: 'LIMIT_WPH2_REBID_ENABLED' },
        LOCAL_FIRST_EVENT_AUTOCOMPLETE_ENABLED: { name: 'LOCAL_FIRST_EVENT_AUTOCOMPLETE_ENABLED' },
        LOGROCKET_ENABLED: { name: 'LOGROCKET_ENABLED' },
        LOG_ON_EDIT_UNIT: { name: 'LOG_ON_EDIT_UNIT' },
        MANAGE_DEPARTMENT_SHARED_EVENT_SEARCHES_ENABLED: {
            name: 'MANAGE_DEPARTMENT_SHARED_EVENT_SEARCHES_ENABLED',
        },
        MANAGE_STATION_STAFFING_POOL: { name: 'MANAGE_STATION_STAFFING_POOL' },
        MAP_DEBOUNCE_MAP_RECONNECTS_ENABLED: { name: 'MAP_DEBOUNCE_MAP_RECONNECTS_ENABLED' },
        MAP_RELEASE_WEBGL_CONTEXT_ON_TEARDOWN_ENABLED: {
            name: 'MAP_RELEASE_WEBGL_CONTEXT_ON_TEARDOWN_ENABLED',
        },
        MAP_ROUTE_ENABLED: { name: 'MAP_ROUTE_ENABLED' },
        MAP_STAY_MOUNTED_ON_RECONNECT_ENABLED: { name: 'MAP_STAY_MOUNTED_ON_RECONNECT_ENABLED' },
        MAP_TILE_CACHE_ENABLED: { name: 'MAP_TILE_CACHE_ENABLED' },
        MAP_VIEW_STREAM_ENABLED: { name: 'MAP_VIEW_STREAM_ENABLED' },
        MAP_WINDOW_ENABLED: { name: 'MAP_WINDOW_ENABLED' },
        MARITIME_COORDINATES_ENABLED: { name: 'MARITIME_COORDINATES_ENABLED' },
        MASTER_PROFILES_ENABLED: { name: 'MASTER_PROFILES_ENABLED' },
        MEDIA_ATTACHMENTS_ENABLED: { name: 'MEDIA_ATTACHMENTS_ENABLED' },
        MERGE_EVENTS: { name: 'MERGE_EVENTS' },
        MESSAGING: { name: 'MESSAGING' },
        MOTOROLA_RADIO_TO_MAP_ENABLED: { name: 'MOTOROLA_RADIO_TO_MAP_ENABLED' },
        MULTI_AGENCY_SUBDIVISIONS: { name: 'MULTI_AGENCY_SUBDIVISIONS' },
        MULTI_REN_GENERATION: { name: 'MULTI_REN_GENERATION' },
        NARRATIVE_SELECTIONS_RESET_AFTER_EACH_ENTRY: {
            name: 'NARRATIVE_SELECTIONS_RESET_AFTER_EACH_ENTRY',
        },
        NEARBY_CAUTIONS_ENABLED: { name: 'NEARBY_CAUTIONS_ENABLED' },
        NEARBY_CAUTIONS_ON_MAP_ENABLED: { name: 'NEARBY_CAUTIONS_ON_MAP_ENABLED' },
        NEW_PRO_QA_ENDPOINT_ENABLED: { name: 'NEW_PRO_QA_ENDPOINT_ENABLED' },
        NEW_QUEUES_SENTRY_PROFILER: { name: 'NEW_QUEUES_SENTRY_PROFILER' },
        NEW_SINGLE_AGENCY_SUBDIVISIONS: { name: 'NEW_SINGLE_AGENCY_SUBDIVISIONS' },
        NON_HIERARCHICAL_CLASSIFICATION_ENABLED: {
            name: 'NON_HIERARCHICAL_CLASSIFICATION_ENABLED',
        },
        NO_BACKGROUNDED_MAP_ENABLED: { name: 'NO_BACKGROUNDED_MAP_ENABLED' },
        OPEN_EVENT_PANEL_ON_E911_CALL: { name: 'OPEN_EVENT_PANEL_ON_E911_CALL' },
        OPEN_RELATED_DATA_TAB_BY_DEFAULT: { name: 'OPEN_RELATED_DATA_TAB_BY_DEFAULT' },
        OWN_DISPATCH_AREAS: { name: 'OWN_DISPATCH_AREAS' },
        PENDO_ENABLED: { name: 'PENDO_ENABLED' },
        PENDO_TRACK_EVENTS_ENABLED: { name: 'PENDO_TRACK_EVENTS_ENABLED' },
        PHONE_AREA_CODE_OPTIONAL: { name: 'PHONE_AREA_CODE_OPTIONAL' },
        PIN_UNPIN_ADDITIONAL_INFOS: { name: 'PIN_UNPIN_ADDITIONAL_INFOS' },
        PLAY_ALERT_ON_HOT_HIT_RESULT_FOR_OFFICER_DEX_QUERY: {
            name: 'PLAY_ALERT_ON_HOT_HIT_RESULT_FOR_OFFICER_DEX_QUERY',
        },
        PLAY_ALERT_ON_URGENT_BOLOS: { name: 'PLAY_ALERT_ON_URGENT_BOLOS' },
        PLAY_MESSAGING_SOUNDS_IN_CAD_NEXT: { name: 'PLAY_MESSAGING_SOUNDS_IN_CAD_NEXT' },
        PREFER_CAD_NEXT_MAP_WINDOW: { name: 'PREFER_CAD_NEXT_MAP_WINDOW' },
        PREFER_NEW_EVENTS_WINDOW: { name: 'PREFER_NEW_EVENTS_WINDOW' },
        PREFER_PHYSICAL_ADDRESS_FOR_VOIP_911_CALLS: {
            name: 'PREFER_PHYSICAL_ADDRESS_FOR_VOIP_911_CALLS',
        },
        PREPARED911_ENABLED: { name: 'PREPARED911_ENABLED' },
        PROLOG_RESPONSE_PLANS_DISPATCH_STAFF_COUNT_WRITE_ENABLED: {
            name: 'PROLOG_RESPONSE_PLANS_DISPATCH_STAFF_COUNT_WRITE_ENABLED',
        },
        PROMPT_BEFORE_GENERATING_REN: { name: 'PROMPT_BEFORE_GENERATING_REN' },
        PRO_QA_ENABLED: { name: 'PRO_QA_ENABLED' },
        PRO_QA_ENHANCEMENTS_ENABLED: { name: 'PRO_QA_ENHANCEMENTS_ENABLED' },
        PRO_QA_FIRE_ENABLED: { name: 'PRO_QA_FIRE_ENABLED' },
        PRO_QA_POLICE_ENABLED: { name: 'PRO_QA_POLICE_ENABLED' },
        QUEUES_REARCHITECTURE_ENABLED: { name: 'QUEUES_REARCHITECTURE_ENABLED' },
        RADIO_CHANNELS: { name: 'RADIO_CHANNELS' },
        REASON_REQUIRED_FOR_EVENT_REACTIVATION: { name: 'REASON_REQUIRED_FOR_EVENT_REACTIVATION' },
        REPORTING_PARTY_NAME_REQUIRED: { name: 'REPORTING_PARTY_NAME_REQUIRED' },
        ROLLOUT_DISABLE_INTEGRATED_FORM_AUTO_FOCUS: {
            name: 'ROLLOUT_DISABLE_INTEGRATED_FORM_AUTO_FOCUS',
        },
        ROLLOUT_SYNC_STATION_ON_BOOT: { name: 'ROLLOUT_SYNC_STATION_ON_BOOT' },
        ROLL_OUT_CAD_EVENT_PANEL_DEX_RESULTS_USE_VIRTUOSO_ENABLED: {
            name: 'ROLL_OUT_CAD_EVENT_PANEL_DEX_RESULTS_USE_VIRTUOSO_ENABLED',
        },
        ROLL_OUT_CAD_LOCATION_RESOLUTION_ENDPOINT_ENABLED: {
            name: 'ROLL_OUT_CAD_LOCATION_RESOLUTION_ENDPOINT_ENABLED',
        },
        ROLL_OUT_CAD_NARRATIVE_FILTERING_AND_FOCUS_IMPROVEMENTS_ENABLED: {
            name: 'ROLL_OUT_CAD_NARRATIVE_FILTERING_AND_FOCUS_IMPROVEMENTS_ENABLED',
        },
        ROLL_OUT_EDITABLE_INITIAL_NARRATIVE_ENABLED: {
            name: 'ROLL_OUT_EDITABLE_INITIAL_NARRATIVE_ENABLED',
        },
        ROLL_OUT_FR_FOOTER_AND_TAB_REDESIGN_ENABLED: {
            name: 'ROLL_OUT_FR_FOOTER_AND_TAB_REDESIGN_ENABLED',
        },
        ROLL_OUT_ON_SCENE_CAN_EDIT_PERSONS_AND_VEHICLES_ENABLED: {
            name: 'ROLL_OUT_ON_SCENE_CAN_EDIT_PERSONS_AND_VEHICLES_ENABLED',
        },
        ROLL_OUT_PERSIST_WORKSPACE_MAP_FILTERS_ENABLED: {
            name: 'ROLL_OUT_PERSIST_WORKSPACE_MAP_FILTERS_ENABLED',
        },
        ROLL_OUT_UNIT_MEMBER_ORDERING_ENABLED: { name: 'ROLL_OUT_UNIT_MEMBER_ORDERING_ENABLED' },
        ROLL_OUT_VEHICLE_REQUIRED_UNIT_SETTING_ENABLED: {
            name: 'ROLL_OUT_VEHICLE_REQUIRED_UNIT_SETTING_ENABLED',
        },
        ROLL_OUT_WORKSPACE_MAP_CENTERPOINT_ENABLED: {
            name: 'ROLL_OUT_WORKSPACE_MAP_CENTERPOINT_ENABLED',
        },
        ROTATION_ACCESS: { name: 'ROTATION_ACCESS' },
        SAVED_SEARCH_SHARING_ENABLED: { name: 'SAVED_SEARCH_SHARING_ENABLED' },
        SCHEDULED_EVENTS_ENABLED: { name: 'SCHEDULED_EVENTS_ENABLED' },
        SEARCH_BOLOS: { name: 'SEARCH_BOLOS' },
        SEARCH_FOR_DUPLICATE_EVENTS: { name: 'SEARCH_FOR_DUPLICATE_EVENTS' },
        SEARCH_WINDOWS_ENABLED: { name: 'SEARCH_WINDOWS_ENABLED' },
        SELF_INITIATE_EVENT: { name: 'SELF_INITIATE_EVENT' },
        SELF_INITIATE_UNIT_AGENCY_ENABLED: { name: 'SELF_INITIATE_UNIT_AGENCY_ENABLED' },
        SEND_MESSAGES_AS_INDIVIDUAL: { name: 'SEND_MESSAGES_AS_INDIVIDUAL' },
        SEND_MESSAGES_TO_ALL: { name: 'SEND_MESSAGES_TO_ALL' },
        SENSORS_ENABLED: { name: 'SENSORS_ENABLED' },
        SENTRY_TEST_ENABLED: { name: 'SENTRY_TEST_ENABLED' },
        SHORTCUT_KEYS_ENABLED: { name: 'SHORTCUT_KEYS_ENABLED' },
        SHOW_MOBILE_DEVICES_ON_MAP: { name: 'SHOW_MOBILE_DEVICES_ON_MAP' },
        SHOW_MOBILE_DEVICES_POLYLINES_ON_MAP: { name: 'SHOW_MOBILE_DEVICES_POLYLINES_ON_MAP' },
        SHOW_UNIT_LOCATION_WHEN_GPS_IS_NOT_AVAILABLE: {
            name: 'SHOW_UNIT_LOCATION_WHEN_GPS_IS_NOT_AVAILABLE',
        },
        STAFF_COUNT_ENABLED: { name: 'STAFF_COUNT_ENABLED' },
        SUBJECT_DATA_ENABLED: { name: 'SUBJECT_DATA_ENABLED' },
        SUBPREMISE_SUPPORT: { name: 'SUBPREMISE_SUPPORT' },
        TRACING_RECORD_TIMING_ENABLED: { name: 'TRACING_RECORD_TIMING_ENABLED' },
        UNASSOCIATE_EVENTS: { name: 'UNASSOCIATE_EVENTS' },
        UNITS_ADMIN: { name: 'UNITS_ADMIN' },
        UNIT_BULK_LOGIN_ADMIN: { name: 'UNIT_BULK_LOGIN_ADMIN' },
        UNIT_EMERGENCY_ACTIVATION_COUNTDOWN_ENABLED: {
            name: 'UNIT_EMERGENCY_ACTIVATION_COUNTDOWN_ENABLED',
        },
        UNIT_EMERGENCY_ENABLED: { name: 'UNIT_EMERGENCY_ENABLED' },
        UNIT_EVENT_TILES_STANDARDIZATION: { name: 'UNIT_EVENT_TILES_STANDARDIZATION' },
        UNIT_HISTORY: { name: 'UNIT_HISTORY' },
        UNIT_LEVEL_DISPOSITIONS_ENABLED: { name: 'UNIT_LEVEL_DISPOSITIONS_ENABLED' },
        UNIT_LOCATIONS_MUST_BE_VERIFIED: { name: 'UNIT_LOCATIONS_MUST_BE_VERIFIED' },
        UNIT_LOCATION_COMMENTS_FIELD_IS_REQUIRED: {
            name: 'UNIT_LOCATION_COMMENTS_FIELD_IS_REQUIRED',
        },
        UNIT_LOCATION_FIELD_IS_REQUIRED: { name: 'UNIT_LOCATION_FIELD_IS_REQUIRED' },
        UNIT_LOCATION_REMOVED_ON_EVENT_ASSIGNMENT: {
            name: 'UNIT_LOCATION_REMOVED_ON_EVENT_ASSIGNMENT',
        },
        UNIT_LOCATION_STREAM_ENABLED: { name: 'UNIT_LOCATION_STREAM_ENABLED' },
        UNIT_MANAGEMENT: { name: 'UNIT_MANAGEMENT' },
        UNIT_STATUS_SEARCH_WINDOW_ENABLED: { name: 'UNIT_STATUS_SEARCH_WINDOW_ENABLED' },
        UNIT_TIMERS_ENABLED: { name: 'UNIT_TIMERS_ENABLED' },
        UNMERGE_EVENTS: { name: 'UNMERGE_EVENTS' },
        UPDATE_EVENT_QUEUE_STREAM_ENABLED: { name: 'UPDATE_EVENT_QUEUE_STREAM_ENABLED' },
        UPDATE_UNIT_QUEUE_STREAM_ENABLED: { name: 'UPDATE_UNIT_QUEUE_STREAM_ENABLED' },
        USERS_CAN_CHANGE_UPDATE_PRIORITY: { name: 'USERS_CAN_CHANGE_UPDATE_PRIORITY' },
        USER_DRAG_AND_DROP_DISPATCH: { name: 'USER_DRAG_AND_DROP_DISPATCH' },
        USE_DEX_RESULT_MESSAGE_PROPERTY: { name: 'USE_DEX_RESULT_MESSAGE_PROPERTY' },
        USE_MAPBOX_MAP_FOR_LOCATION_INPUTS: { name: 'USE_MAPBOX_MAP_FOR_LOCATION_INPUTS' },
        USE_UNIT_AGENCY_FOR_REPORTING: { name: 'USE_UNIT_AGENCY_FOR_REPORTING' },
        VIEW_BOLOS: { name: 'VIEW_BOLOS' },
        VIEW_CONTACT_LIST: { name: 'VIEW_CONTACT_LIST' },
        VIEW_DISPATCH: { name: 'VIEW_DISPATCH' },
        WORKSPACE_ADMIN: { name: 'WORKSPACE_ADMIN' },
    },
    bT = { TRIAGE_QUESTION_VERSION: { name: 'TRIAGE_QUESTION_VERSION', value: 1 } },
    fT = {
        BLACK_HOLE: { name: 'BLACK_HOLE', value: 3 },
        BOUNCE: { name: 'BOUNCE', value: 2 },
        ICEMS: { name: 'ICEMS', value: 1 },
    },
    gT = { LIST: { name: 'LIST', value: 1 }, TEXT: { name: 'TEXT', value: 2 } },
    JT = { CREATE: { name: 'CREATE' }, DELETE: { name: 'DELETE' } },
    hT = {
        ADDITIONAL_INFO: { name: 'ADDITIONAL_INFO' },
        AGENCY_EVENT: { name: 'AGENCY_EVENT' },
        BOLO: { name: 'BOLO' },
        DRUGS: { name: 'DRUGS' },
        EVENT: { name: 'EVENT' },
        FIREARM: { name: 'FIREARM' },
        INVOLVED_PERSON: { name: 'INVOLVED_PERSON' },
        OTHER_ITEM: { name: 'OTHER_ITEM' },
        PERSON: { name: 'PERSON' },
        REPORTING_PARTY: { name: 'REPORTING_PARTY' },
        TOW_VEHICLE: { name: 'TOW_VEHICLE' },
        UNIT: { name: 'UNIT' },
        VEHICLE: { name: 'VEHICLE' },
    },
    ZT = { HIGH: { name: 'HIGH' }, STANDARD: { name: 'STANDARD' } },
    jT = {
        ADDITIONAL_CFS: { name: 'ADDITIONAL_CFS' },
        ADDITIONAL_RADIO_CHANNEL: { name: 'ADDITIONAL_RADIO_CHANNEL' },
        AGENCY: { name: 'AGENCY' },
        ALARM_LEVEL: { name: 'ALARM_LEVEL' },
        ASSOCIATED_EVENT: { name: 'ASSOCIATED_EVENT' },
        BEAT: { name: 'BEAT' },
        BOLO_BOLO_TYPE: { name: 'BOLO_BOLO_TYPE' },
        BOLO_DESCRIPTION: { name: 'BOLO_DESCRIPTION' },
        BOLO_DISPATCH_AREA_RECIPIENT: { name: 'BOLO_DISPATCH_AREA_RECIPIENT' },
        BOLO_LABEL: { name: 'BOLO_LABEL' },
        BOLO_LOCATION: { name: 'BOLO_LOCATION' },
        BOLO_LOCATION_NOTES: { name: 'BOLO_LOCATION_NOTES' },
        BOLO_LOCATION_SUB_PREMISE: { name: 'BOLO_LOCATION_SUB_PREMISE' },
        BOLO_PRIORITY: { name: 'BOLO_PRIORITY' },
        BOLO_SCHEDULED_EXPIRATION_DATE: { name: 'BOLO_SCHEDULED_EXPIRATION_DATE' },
        BOLO_SUBDIVISION_RECIPIENT: { name: 'BOLO_SUBDIVISION_RECIPIENT' },
        CFS: { name: 'CFS' },
        CROSS_STREETS: { name: 'CROSS_STREETS' },
        DISPATCH_AREA: { name: 'DISPATCH_AREA' },
        DRUGS_DESCRIPTION: { name: 'DRUGS_DESCRIPTION' },
        DRUGS_DRUG_CATEGORY: { name: 'DRUGS_DRUG_CATEGORY' },
        DRUGS_IDENTIFIER: { name: 'DRUGS_IDENTIFIER' },
        DRUGS_IDENTIFIER_TYPE: { name: 'DRUGS_IDENTIFIER_TYPE' },
        DRUGS_IDENTIFIER_TYPE_OTHER_DESCRIPTION: {
            name: 'DRUGS_IDENTIFIER_TYPE_OTHER_DESCRIPTION',
        },
        DRUGS_IS_PRECURSOR_CHEMICAL: { name: 'DRUGS_IS_PRECURSOR_CHEMICAL' },
        DRUGS_MEASUREMENT_UNITS: { name: 'DRUGS_MEASUREMENT_UNITS' },
        DRUGS_QUANTITY: { name: 'DRUGS_QUANTITY' },
        EVENT_LABELS: { name: 'EVENT_LABELS' },
        EVENT_LOCATION: { name: 'EVENT_LOCATION' },
        EVENT_LOCATION_NOTES: { name: 'EVENT_LOCATION_NOTES' },
        EVENT_LOCATION_SUB_PREMISE: { name: 'EVENT_LOCATION_SUB_PREMISE' },
        EVENT_MERGED: { name: 'EVENT_MERGED' },
        EVENT_PRIORITY: { name: 'EVENT_PRIORITY' },
        EVENT_STAFF_COUNT: { name: 'EVENT_STAFF_COUNT' },
        EVENT_UNMERGED: { name: 'EVENT_UNMERGED' },
        FIREARM_ALTERATION_INDICATED: { name: 'FIREARM_ALTERATION_INDICATED' },
        FIREARM_CALIBER: { name: 'FIREARM_CALIBER' },
        FIREARM_DESCRIPTION: { name: 'FIREARM_DESCRIPTION' },
        FIREARM_FIREARM_TYPE: { name: 'FIREARM_FIREARM_TYPE' },
        FIREARM_IDENTIFIER: { name: 'FIREARM_IDENTIFIER' },
        FIREARM_IDENTIFIER_TYPE: { name: 'FIREARM_IDENTIFIER_TYPE' },
        FIREARM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: {
            name: 'FIREARM_IDENTIFIER_TYPE_OTHER_DESCRIPTION',
        },
        FIREARM_MAKE: { name: 'FIREARM_MAKE' },
        FIREARM_MODEL: { name: 'FIREARM_MODEL' },
        FIREARM_REGISTRATION_NUMBER: { name: 'FIREARM_REGISTRATION_NUMBER' },
        FIREARM_SERIAL_NUMBER: { name: 'FIREARM_SERIAL_NUMBER' },
        INVOLVED_PERSON_ADDRESS: { name: 'INVOLVED_PERSON_ADDRESS' },
        INVOLVED_PERSON_ADDRESS_SUB_PREMISE: { name: 'INVOLVED_PERSON_ADDRESS_SUB_PREMISE' },
        INVOLVED_PERSON_AGE_MAX: { name: 'INVOLVED_PERSON_AGE_MAX' },
        INVOLVED_PERSON_AGE_MIN: { name: 'INVOLVED_PERSON_AGE_MIN' },
        INVOLVED_PERSON_DATE_OF_BIRTH: { name: 'INVOLVED_PERSON_DATE_OF_BIRTH' },
        INVOLVED_PERSON_DATE_OF_BIRTH_UNKNOWN: { name: 'INVOLVED_PERSON_DATE_OF_BIRTH_UNKNOWN' },
        INVOLVED_PERSON_DELETED: { name: 'INVOLVED_PERSON_DELETED' },
        INVOLVED_PERSON_DRIVERS_LICENSE_NUMBER: { name: 'INVOLVED_PERSON_DRIVERS_LICENSE_NUMBER' },
        INVOLVED_PERSON_DRIVERS_LICENSE_STATE: { name: 'INVOLVED_PERSON_DRIVERS_LICENSE_STATE' },
        INVOLVED_PERSON_EYE_COLOR: { name: 'INVOLVED_PERSON_EYE_COLOR' },
        INVOLVED_PERSON_FIRST_NAME: { name: 'INVOLVED_PERSON_FIRST_NAME' },
        INVOLVED_PERSON_HAIR_COLOR: { name: 'INVOLVED_PERSON_HAIR_COLOR' },
        INVOLVED_PERSON_HEIGHT: { name: 'INVOLVED_PERSON_HEIGHT' },
        INVOLVED_PERSON_HEIGHT_MAX: { name: 'INVOLVED_PERSON_HEIGHT_MAX' },
        INVOLVED_PERSON_HEIGHT_MIN: { name: 'INVOLVED_PERSON_HEIGHT_MIN' },
        INVOLVED_PERSON_INVOLVEMENT_TYPE: { name: 'INVOLVED_PERSON_INVOLVEMENT_TYPE' },
        INVOLVED_PERSON_LAST_NAME: { name: 'INVOLVED_PERSON_LAST_NAME' },
        INVOLVED_PERSON_LOCATION: { name: 'INVOLVED_PERSON_LOCATION' },
        INVOLVED_PERSON_LOCATION_SUB_PREMISE: { name: 'INVOLVED_PERSON_LOCATION_SUB_PREMISE' },
        INVOLVED_PERSON_MASTER_SEARCH_RESULTS: { name: 'INVOLVED_PERSON_MASTER_SEARCH_RESULTS' },
        INVOLVED_PERSON_NOTES: { name: 'INVOLVED_PERSON_NOTES' },
        INVOLVED_PERSON_PHONE_EXTENSION: { name: 'INVOLVED_PERSON_PHONE_EXTENSION' },
        INVOLVED_PERSON_PHONE_NUMBER: { name: 'INVOLVED_PERSON_PHONE_NUMBER' },
        INVOLVED_PERSON_RACE: { name: 'INVOLVED_PERSON_RACE' },
        INVOLVED_PERSON_SEX: { name: 'INVOLVED_PERSON_SEX' },
        INVOLVED_PERSON_SOCIAL_SECURITY_NUMBER: { name: 'INVOLVED_PERSON_SOCIAL_SECURITY_NUMBER' },
        INVOLVED_PERSON_WEIGHT: { name: 'INVOLVED_PERSON_WEIGHT' },
        INVOLVED_PERSON_WEIGHT_MAX: { name: 'INVOLVED_PERSON_WEIGHT_MAX' },
        INVOLVED_PERSON_WEIGHT_MIN: { name: 'INVOLVED_PERSON_WEIGHT_MIN' },
        LOCATION_CAUTION: { name: 'LOCATION_CAUTION' },
        NARRATIVE: { name: 'NARRATIVE' },
        NEW_BOLO: { name: 'NEW_BOLO' },
        NEW_DRUGS: { name: 'NEW_DRUGS' },
        NEW_EVENT: { name: 'NEW_EVENT' },
        NEW_FIREARM: { name: 'NEW_FIREARM' },
        NEW_INVOLVED_PERSON: { name: 'NEW_INVOLVED_PERSON' },
        NEW_OTHER_ITEM: { name: 'NEW_OTHER_ITEM' },
        NEW_REPORTING_PARTY: { name: 'NEW_REPORTING_PARTY' },
        NEW_TOW_VEHICLE: { name: 'NEW_TOW_VEHICLE' },
        NEW_VEHICLE: { name: 'NEW_VEHICLE' },
        OTHER_ITEM_COLOR: { name: 'OTHER_ITEM_COLOR' },
        OTHER_ITEM_DESCRIPTION: { name: 'OTHER_ITEM_DESCRIPTION' },
        OTHER_ITEM_IDENTIFIER: { name: 'OTHER_ITEM_IDENTIFIER' },
        OTHER_ITEM_IDENTIFIER_TYPE: { name: 'OTHER_ITEM_IDENTIFIER_TYPE' },
        OTHER_ITEM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: {
            name: 'OTHER_ITEM_IDENTIFIER_TYPE_OTHER_DESCRIPTION',
        },
        OTHER_ITEM_ITEM_CATEGORY: { name: 'OTHER_ITEM_ITEM_CATEGORY' },
        OTHER_ITEM_MAKE: { name: 'OTHER_ITEM_MAKE' },
        OTHER_ITEM_MODEL: { name: 'OTHER_ITEM_MODEL' },
        OTHER_ITEM_QUANTITY: { name: 'OTHER_ITEM_QUANTITY' },
        OTHER_ITEM_SERIAL_NUMBER: { name: 'OTHER_ITEM_SERIAL_NUMBER' },
        OTHER_ITEM_SIZE: { name: 'OTHER_ITEM_SIZE' },
        PHONE_CALL_CALLER_ADDRESS: { name: 'PHONE_CALL_CALLER_ADDRESS' },
        PHONE_CALL_CALLER_NAME: { name: 'PHONE_CALL_CALLER_NAME' },
        PHONE_CALL_GPS: { name: 'PHONE_CALL_GPS' },
        PRO_QA_URGENT: { name: 'PRO_QA_URGENT' },
        RADIO_CHANNEL: { name: 'RADIO_CHANNEL' },
        REPORTING_PARTY_ADDRESS: { name: 'REPORTING_PARTY_ADDRESS' },
        REPORTING_PARTY_ADDRESS_SUB_PREMISE: { name: 'REPORTING_PARTY_ADDRESS_SUB_PREMISE' },
        REPORTING_PARTY_AGE_MAX: { name: 'REPORTING_PARTY_AGE_MAX' },
        REPORTING_PARTY_AGE_MIN: { name: 'REPORTING_PARTY_AGE_MIN' },
        REPORTING_PARTY_DATE_OF_BIRTH: { name: 'REPORTING_PARTY_DATE_OF_BIRTH' },
        REPORTING_PARTY_DATE_OF_BIRTH_UNKNOWN: { name: 'REPORTING_PARTY_DATE_OF_BIRTH_UNKNOWN' },
        REPORTING_PARTY_DRIVERS_LICENSE_NUMBER: { name: 'REPORTING_PARTY_DRIVERS_LICENSE_NUMBER' },
        REPORTING_PARTY_DRIVERS_LICENSE_STATE: { name: 'REPORTING_PARTY_DRIVERS_LICENSE_STATE' },
        REPORTING_PARTY_EYE_COLOR: { name: 'REPORTING_PARTY_EYE_COLOR' },
        REPORTING_PARTY_FIRST_NAME: { name: 'REPORTING_PARTY_FIRST_NAME' },
        REPORTING_PARTY_HAIR_COLOR: { name: 'REPORTING_PARTY_HAIR_COLOR' },
        REPORTING_PARTY_HEIGHT: { name: 'REPORTING_PARTY_HEIGHT' },
        REPORTING_PARTY_HEIGHT_MAX: { name: 'REPORTING_PARTY_HEIGHT_MAX' },
        REPORTING_PARTY_HEIGHT_MIN: { name: 'REPORTING_PARTY_HEIGHT_MIN' },
        REPORTING_PARTY_INVOLVEMENT_TYPE: { name: 'REPORTING_PARTY_INVOLVEMENT_TYPE' },
        REPORTING_PARTY_LAST_NAME: { name: 'REPORTING_PARTY_LAST_NAME' },
        REPORTING_PARTY_LOCATION: { name: 'REPORTING_PARTY_LOCATION' },
        REPORTING_PARTY_LOCATION_SUB_PREMISE: { name: 'REPORTING_PARTY_LOCATION_SUB_PREMISE' },
        REPORTING_PARTY_MASTER_SEARCH_RESULTS: { name: 'REPORTING_PARTY_MASTER_SEARCH_RESULTS' },
        REPORTING_PARTY_NOTES: { name: 'REPORTING_PARTY_NOTES' },
        REPORTING_PARTY_PHONE_EXTENSION: { name: 'REPORTING_PARTY_PHONE_EXTENSION' },
        REPORTING_PARTY_PHONE_NUMBER: { name: 'REPORTING_PARTY_PHONE_NUMBER' },
        REPORTING_PARTY_RACE: { name: 'REPORTING_PARTY_RACE' },
        REPORTING_PARTY_SEX: { name: 'REPORTING_PARTY_SEX' },
        REPORTING_PARTY_SOCIAL_SECURITY_NUMBER: { name: 'REPORTING_PARTY_SOCIAL_SECURITY_NUMBER' },
        REPORTING_PARTY_WEIGHT: { name: 'REPORTING_PARTY_WEIGHT' },
        REPORTING_PARTY_WEIGHT_MAX: { name: 'REPORTING_PARTY_WEIGHT_MAX' },
        REPORTING_PARTY_WEIGHT_MIN: { name: 'REPORTING_PARTY_WEIGHT_MIN' },
        RISK_LEVEL: { name: 'RISK_LEVEL' },
        SUBDIVISION: { name: 'SUBDIVISION' },
        TOW_VEHICLE_AUTO_INSURANCE_CARRIER: { name: 'TOW_VEHICLE_AUTO_INSURANCE_CARRIER' },
        TOW_VEHICLE_COLOR: { name: 'TOW_VEHICLE_COLOR' },
        TOW_VEHICLE_INVOLVEMENT_TYPE: { name: 'TOW_VEHICLE_INVOLVEMENT_TYPE' },
        TOW_VEHICLE_MAKE: { name: 'TOW_VEHICLE_MAKE' },
        TOW_VEHICLE_MASTER_SEARCH_RESULTS: { name: 'TOW_VEHICLE_MASTER_SEARCH_RESULTS' },
        TOW_VEHICLE_MODEL: { name: 'TOW_VEHICLE_MODEL' },
        TOW_VEHICLE_NOTES: { name: 'TOW_VEHICLE_NOTES' },
        TOW_VEHICLE_PLATE_NUMBER: { name: 'TOW_VEHICLE_PLATE_NUMBER' },
        TOW_VEHICLE_STATE: { name: 'TOW_VEHICLE_STATE' },
        TOW_VEHICLE_VIN_NUMBER: { name: 'TOW_VEHICLE_VIN_NUMBER' },
        TOW_VEHICLE_YEAR: { name: 'TOW_VEHICLE_YEAR' },
        UNIT_STAFF_COUNT: { name: 'UNIT_STAFF_COUNT' },
        VEHICLE_AUTO_INSURANCE_CARRIER: { name: 'VEHICLE_AUTO_INSURANCE_CARRIER' },
        VEHICLE_COLOR: { name: 'VEHICLE_COLOR' },
        VEHICLE_DELETED: { name: 'VEHICLE_DELETED' },
        VEHICLE_INVOLVEMENT_TYPE: { name: 'VEHICLE_INVOLVEMENT_TYPE' },
        VEHICLE_MAKE: { name: 'VEHICLE_MAKE' },
        VEHICLE_MASTER_SEARCH_RESULTS: { name: 'VEHICLE_MASTER_SEARCH_RESULTS' },
        VEHICLE_MODEL: { name: 'VEHICLE_MODEL' },
        VEHICLE_NOTES: { name: 'VEHICLE_NOTES' },
        VEHICLE_PLATE_NUMBER: { name: 'VEHICLE_PLATE_NUMBER' },
        VEHICLE_STATE: { name: 'VEHICLE_STATE' },
        VEHICLE_VIN_NUMBER: { name: 'VEHICLE_VIN_NUMBER' },
        VEHICLE_YEAR: { name: 'VEHICLE_YEAR' },
    },
    xT = { OSX: { name: 'OSX' }, WINDOWS: { name: 'WINDOWS' } },
    kT = {
        SCHEMA_VERSION: { name: 'SCHEMA_VERSION', value: '_schema_version' },
        SCHEMA_VERSION_COMMON_REPEATABLE: {
            name: 'SCHEMA_VERSION_COMMON_REPEATABLE',
            value: '_schema_version_common_repeatable',
        },
        SCHEMA_VERSION_CONFIGURATION: {
            name: 'SCHEMA_VERSION_CONFIGURATION',
            value: '_schema_version_configuration',
        },
        SCHEMA_VERSION_ES5: { name: 'SCHEMA_VERSION_ES5', value: '_schema_version_es5' },
        SCHEMA_VERSION_POST_MIGRATION: {
            name: 'SCHEMA_VERSION_POST_MIGRATION',
            value: '_schema_version_post_migration',
        },
        SCHEMA_VERSION_SECURITY: {
            name: 'SCHEMA_VERSION_SECURITY',
            value: '_schema_version_security',
        },
        SCHEMA_VERSION_SETTINGS: {
            name: 'SCHEMA_VERSION_SETTINGS',
            value: '_schema_version_settings',
        },
    },
    wT = {
        ACTIVE: { name: 'ACTIVE', value: 1 },
        COMPLETED: { name: 'COMPLETED', value: 2 },
        NOT_APPLICABLE: { name: 'NOT_APPLICABLE', value: 3 },
    },
    zT = {
        ASSIGNEE: { name: 'ASSIGNEE' },
        ASSISTING_INVESTIGATOR: { name: 'ASSISTING_INVESTIGATOR' },
    },
    qT = {
        DEPARTMENT: { name: 'DEPARTMENT', value: 'DEPARTMENT' },
        GLOBAL: { name: 'GLOBAL', value: 'GLOBAL' },
        JMS: { name: 'JMS', value: 'JMS' },
        MARK43_RMS_IMPORTED: { name: 'MARK43_RMS_IMPORTED', value: 'MARK43_RMS_IMPORTED' },
    },
    $T = {
        DEPARTMENT: { name: 'DEPARTMENT', value: 'DEPARTMENT' },
        GLOBAL: { name: 'GLOBAL', value: 'GLOBAL' },
        MARK43_RMS_IMPORTED: { name: 'MARK43_RMS_IMPORTED', value: 'MARK43_RMS_IMPORTED' },
    },
    Ee = {
        DELETE: { name: 'DELETE', value: 3 },
        INSERT: { name: 'INSERT', value: 1 },
        UPDATE: { name: 'UPDATE', value: 2 },
    },
    _e = { FAILED: { name: 'FAILED', value: 2 }, PROCESSED: { name: 'PROCESSED', value: 1 } },
    Te = {
        DELETE: { name: 'DELETE', value: 3 },
        INSERT: { name: 'INSERT', value: 1 },
        UPDATE: { name: 'UPDATE', value: 2 },
    },
    ee = {
        DELETE: { name: 'DELETE', value: 'DELETE' },
        INSERT: { name: 'INSERT', value: 'INSERT' },
        UPDATE: { name: 'UPDATE', value: 'UPDATE' },
    },
    Ae = {
        DELETE: { name: 'DELETE', value: 'DELETE' },
        INSERT: { name: 'INSERT', value: 'INSERT' },
        UPDATE: { name: 'UPDATE', value: 'UPDATE' },
    },
    Ne = {
        ADDITIONAL_INFO: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ADDITIONAL_INFO',
            value: 24,
        },
        ADD_EMS: { argumentType: 'COMMAND', isDexCommand: !1, name: 'ADD_EMS', value: 74 },
        ADD_FIRE: { argumentType: 'COMMAND', isDexCommand: !1, name: 'ADD_FIRE', value: 73 },
        ADD_POLICE: { argumentType: 'COMMAND', isDexCommand: !1, name: 'ADD_POLICE', value: 72 },
        ADD_UNIT_NOTES: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ADD_UNIT_NOTES',
            value: 101,
        },
        AGENCY: { argumentType: 'FORM_IDENTIFIER', isDexCommand: !1, name: 'AGENCY', value: 36 },
        AGENCY_ASSISTANCE: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'AGENCY_ASSISTANCE',
            value: 71,
        },
        AGENCY_EVENT_RADIO_CHANNELS: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'AGENCY_EVENT_RADIO_CHANNELS',
            value: 103,
        },
        ALARM_LEVEL: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'ALARM_LEVEL',
            value: 77,
        },
        ASSIGN_ADDITIONAL_EVENT_RADIO_CHANNELS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ASSIGN_ADDITIONAL_EVENT_RADIO_CHANNELS',
            value: 105,
        },
        ASSIGN_UNITS_AS_BACKUP: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ASSIGN_UNITS_AS_BACKUP',
            value: 23,
        },
        ASSIGN_UNITS_TO_EVENT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ASSIGN_UNITS_TO_EVENT',
            value: 28,
        },
        ASSOCIATE_EVENTS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'ASSOCIATE_EVENTS',
            value: 107,
        },
        CAD_REQUEST_PROFILE: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'CAD_REQUEST_PROFILE',
            value: 109,
        },
        CALL_FOR_SERVICE: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'CALL_FOR_SERVICE',
            value: 10,
        },
        CALL_TAKER_STATION: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'CALL_TAKER_STATION',
            value: 68,
        },
        CHANGE_EVENT_AGENCY: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CHANGE_EVENT_AGENCY',
            value: 113,
        },
        CHANGE_PRIMARY_EVENT_RADIO_CHANNEL: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CHANGE_PRIMARY_EVENT_RADIO_CHANNEL',
            value: 104,
        },
        CHANGE_UNIT_LOCATION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CHANGE_UNIT_LOCATION',
            value: 18,
        },
        CLEAR_EVENT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'CLEAR_EVENT', value: 20 },
        CLEAR_EVENT_WITH_PRIMARY_DISPOSITION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CLEAR_EVENT_WITH_PRIMARY_DISPOSITION',
            value: 29,
        },
        CLEAR_UNIT_LOCATION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CLEAR_UNIT_LOCATION',
            value: 78,
        },
        CLEAR_UNIT_NOTES: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CLEAR_UNIT_NOTES',
            value: 102,
        },
        CLEAR_UNIT_TIMER: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CLEAR_UNIT_TIMER',
            value: 90,
        },
        COMMENT: { argumentType: 'TOKEN', isDexCommand: !1, name: 'COMMENT', value: 3 },
        CROSS_CLASS_ADDITIONAL_INFO: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CROSS_CLASS_ADDITIONAL_INFO',
            value: 35,
        },
        CROSS_CLASS_FORMATTED_ADDITIONAL_INFO: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CROSS_CLASS_FORMATTED_ADDITIONAL_INFO',
            value: 81,
        },
        CROSS_CLASS_RADIO_TRAFFIC: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'CROSS_CLASS_RADIO_TRAFFIC',
            value: 87,
        },
        DATA_EXCHANGE_INQUIRY_PARAMETERS: {
            argumentType: 'TOKEN',
            isDexCommand: !1,
            name: 'DATA_EXCHANGE_INQUIRY_PARAMETERS',
            value: 48,
        },
        DISPATCH_AREA: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'DISPATCH_AREA',
            value: 7,
        },
        DISPATCH_AREA_GROUP: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'DISPATCH_AREA_GROUP',
            value: 39,
        },
        DISPOSITION: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'DISPOSITION',
            value: 11,
        },
        EDIT_EVENT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'EDIT_EVENT', value: 15 },
        EDIT_UNIT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'EDIT_UNIT', value: 62 },
        EVENT: { argumentType: 'TOKEN', isDexCommand: !1, name: 'EVENT', value: 2 },
        FORMATTED_ADDITIONAL_INFO: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'FORMATTED_ADDITIONAL_INFO',
            value: 80,
        },
        FORM_DELIMITER: {
            argumentType: 'TOKEN',
            isDexCommand: !1,
            name: 'FORM_DELIMITER',
            value: 6,
        },
        FORM_SEPARATOR: {
            argumentType: 'TOKEN',
            isDexCommand: !1,
            name: 'FORM_SEPARATOR',
            value: 5,
        },
        GENERATE_REN: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'GENERATE_REN',
            value: 25,
        },
        HELP: { argumentType: 'COMMAND', isDexCommand: !1, name: 'HELP', value: 21 },
        HOLD_UNITS_FOR_EVENT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'HOLD_UNITS_FOR_EVENT',
            value: 63,
        },
        HOSPITAL: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'HOSPITAL',
            value: 118,
        },
        IS_HIGH_PRIORITY: {
            argumentType: 'TOKEN',
            isDexCommand: !1,
            name: 'IS_HIGH_PRIORITY',
            value: 69,
        },
        LICENSE_PLATE: { argumentType: 'TOKEN', isDexCommand: !1, name: 'LICENSE_PLATE', value: 4 },
        LINK_EVENTS: { argumentType: 'COMMAND', isDexCommand: !1, name: 'LINK_EVENTS', value: 30 },
        LOCATION: { argumentType: 'TOKEN', isDexCommand: !1, name: 'LOCATION', value: 1 },
        LOGOFF_UNITS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'LOGOFF_UNITS',
            value: 22,
        },
        LOGON_TEMPORARY_UNIT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'LOGON_TEMPORARY_UNIT',
            value: 61,
        },
        LOGON_UNIT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'LOGON_UNIT', value: 26 },
        LOGOUT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'LOGOUT', value: 17 },
        MEMBER: { argumentType: 'FORM_IDENTIFIER', isDexCommand: !1, name: 'MEMBER', value: 8 },
        MESSAGE_GROUP: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'MESSAGE_GROUP',
            value: 67,
        },
        MESSAGE_RECIPIENT: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'MESSAGE_RECIPIENT',
            value: 122,
        },
        MONITOR_ALL_DISPATCH_AREAS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'MONITOR_ALL_DISPATCH_AREAS',
            value: 43,
        },
        MONITOR_DISPATCH_AREA: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'MONITOR_DISPATCH_AREA',
            value: 42,
        },
        MOVE_UNIT_TO_HOME_STATION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'MOVE_UNIT_TO_HOME_STATION',
            value: 52,
        },
        MOVE_UNIT_TO_STATE: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'MOVE_UNIT_TO_STATE',
            value: 19,
        },
        MOVE_UNIT_TO_STATION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'MOVE_UNIT_TO_STATION',
            value: 51,
        },
        OPEN_BOLO_FORM: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'OPEN_BOLO_FORM',
            value: 93,
        },
        OPEN_DEX_PERSON_FORM: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'OPEN_DEX_PERSON_FORM',
            value: 60,
        },
        OPEN_DEX_RESULTS: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'OPEN_DEX_RESULTS',
            value: 58,
        },
        OPEN_DEX_VEHICLE_FORM: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'OPEN_DEX_VEHICLE_FORM',
            value: 59,
        },
        OPEN_EDIT_HOSPITAL_FORM: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'OPEN_EDIT_HOSPITAL_FORM',
            value: 117,
        },
        OPEN_ROTATION_FOR_EVENT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'OPEN_ROTATION_FOR_EVENT',
            value: 55,
        },
        ORI_ALIAS: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'ORI_ALIAS',
            value: 119,
        },
        PRIMARY_SUBDIVISION: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'PRIMARY_SUBDIVISION',
            value: 86,
        },
        PRIMARY_UNIT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'PRIMARY_UNIT',
            value: 32,
        },
        QUERY_DRIVER_HISTORY_BY_LICENSE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_DRIVER_HISTORY_BY_LICENSE',
            value: 112,
        },
        QUERY_DRIVER_HISTORY_BY_NAME: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_DRIVER_HISTORY_BY_NAME',
            value: 111,
        },
        QUERY_DRIVER_LICENSE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_DRIVER_LICENSE',
            value: 53,
        },
        QUERY_DRIVER_LICENSE_PURPOSE_CODE_AND_ATTENTION: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_DRIVER_LICENSE_PURPOSE_CODE_AND_ATTENTION',
            value: 121,
        },
        QUERY_DRIVER_LICENSE_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_DRIVER_LICENSE_WITH_PURPOSE_CODE',
            value: 96,
        },
        QUERY_GUN_SERIAL: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_GUN_SERIAL',
            value: 57,
        },
        QUERY_GUN_SERIAL_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_GUN_SERIAL_WITH_PURPOSE_CODE',
            value: 98,
        },
        QUERY_LOJACK: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_LOJACK',
            value: 65,
        },
        QUERY_LOJACK_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_LOJACK_WITH_PURPOSE_CODE',
            value: 100,
        },
        QUERY_PERSON_NAME: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PERSON_NAME',
            value: 56,
        },
        QUERY_PERSON_NAME_PURPOSE_CODE_AND_ATTENTION: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PERSON_NAME_PURPOSE_CODE_AND_ATTENTION',
            value: 120,
        },
        QUERY_PERSON_NAME_WITH_MIDDLE_NAME: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PERSON_NAME_WITH_MIDDLE_NAME',
            value: 114,
        },
        QUERY_PERSON_NAME_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PERSON_NAME_WITH_PURPOSE_CODE',
            value: 97,
        },
        QUERY_PLATE: { argumentType: 'COMMAND', isDexCommand: !0, name: 'QUERY_PLATE', value: 47 },
        QUERY_PLATE_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PLATE_WITH_PURPOSE_CODE',
            value: 94,
        },
        QUERY_PLATE_WITH_VEHICLE_TYPE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_PLATE_WITH_VEHICLE_TYPE',
            value: 123,
        },
        QUERY_VIN: { argumentType: 'COMMAND', isDexCommand: !0, name: 'QUERY_VIN', value: 49 },
        QUERY_VIN_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_VIN_WITH_PURPOSE_CODE',
            value: 95,
        },
        QUERY_VIN_WITH_VEHICLE_TYPE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'QUERY_VIN_WITH_VEHICLE_TYPE',
            value: 124,
        },
        RADIO_TRAFFIC: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'RADIO_TRAFFIC',
            value: 83,
        },
        RADIO_TRAFFIC_ALL_AGENCIES: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'RADIO_TRAFFIC_ALL_AGENCIES',
            value: 110,
        },
        REACTIVATE_EVENT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'REACTIVATE_EVENT',
            value: 31,
        },
        REASSIGN_UNIT_DISPATCH_AREA: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'REASSIGN_UNIT_DISPATCH_AREA',
            value: 38,
        },
        REASSIGN_UNIT_PRIMARY_SUBDIVISION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'REASSIGN_UNIT_PRIMARY_SUBDIVISION',
            value: 85,
        },
        RELEASE_UNITS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'RELEASE_UNITS',
            value: 27,
        },
        RELINQUISH_ALL_DISPATCH_AREAS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'RELINQUISH_ALL_DISPATCH_AREAS',
            value: 46,
        },
        REMOVE_HELD_UNIT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'REMOVE_HELD_UNIT',
            value: 64,
        },
        RESET_UNIT_TIMER: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'RESET_UNIT_TIMER',
            value: 91,
        },
        RESYNC: { argumentType: 'COMMAND', isDexCommand: !1, name: 'RESYNC', value: 13 },
        ROTATION_SERVICE_TYPE: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'ROTATION_SERVICE_TYPE',
            value: 54,
        },
        SELF_INITIATE: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'SELF_INITIATE',
            value: 33,
        },
        SELF_INITIATE_WITH_PURPOSE_CODE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'SELF_INITIATE_WITH_PURPOSE_CODE',
            value: 99,
        },
        SELF_INITIATE_WITH_VEHICLE_TYPE: {
            argumentType: 'COMMAND',
            isDexCommand: !0,
            name: 'SELF_INITIATE_WITH_VEHICLE_TYPE',
            value: 125,
        },
        SEND_DISPATCH_AREAS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'SEND_DISPATCH_AREAS',
            value: 41,
        },
        SEND_MESSAGE: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'SEND_MESSAGE',
            value: 66,
        },
        SHOW_ON_MAP: { argumentType: 'COMMAND', isDexCommand: !1, name: 'SHOW_ON_MAP', value: 88 },
        STAFF_COUNT: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'STAFF_COUNT',
            value: 115,
        },
        STATION: { argumentType: 'FORM_IDENTIFIER', isDexCommand: !1, name: 'STATION', value: 50 },
        SWAP_UNITS: { argumentType: 'COMMAND', isDexCommand: !1, name: 'SWAP_UNITS', value: 82 },
        TAKE_DISPATCH_AREA: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'TAKE_DISPATCH_AREA',
            value: 40,
        },
        TIME: { argumentType: 'FORM_IDENTIFIER', isDexCommand: !1, name: 'TIME', value: 92 },
        TRANSFER_EVENT_DISPATCH_AREA: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'TRANSFER_EVENT_DISPATCH_AREA',
            value: 37,
        },
        TRANSPORT_UNIT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'TRANSPORT_UNIT',
            value: 79,
        },
        UNASSOCIATE_EVENTS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UNASSOCIATE_EVENTS',
            value: 108,
        },
        UNIT: { argumentType: 'TOKEN', isDexCommand: !1, name: 'UNIT', value: 12 },
        UNIT_TAG: {
            argumentType: 'FORM_IDENTIFIER',
            isDexCommand: !1,
            name: 'UNIT_TAG',
            value: 70,
        },
        UNMONITOR_ALL_DISPATCH_AREAS: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UNMONITOR_ALL_DISPATCH_AREAS',
            value: 45,
        },
        UNMONITOR_DISPATCH_AREA: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UNMONITOR_DISPATCH_AREA',
            value: 44,
        },
        UPDATE_ALARM_LEVEL: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UPDATE_ALARM_LEVEL',
            value: 76,
        },
        UPDATE_EVENT_CALL_FOR_SERVICE: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UPDATE_EVENT_CALL_FOR_SERVICE',
            value: 84,
        },
        UPDATE_EVENT_LOCATION: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UPDATE_EVENT_LOCATION',
            value: 75,
        },
        UPDATE_UNIT_STAFF_COUNT: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'UPDATE_UNIT_STAFF_COUNT',
            value: 116,
        },
        VEHICLE: { argumentType: 'FORM_IDENTIFIER', isDexCommand: !1, name: 'VEHICLE', value: 9 },
        VIEW_EVENT: { argumentType: 'COMMAND', isDexCommand: !1, name: 'VIEW_EVENT', value: 14 },
        VIEW_EVENT_HISTORY: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'VIEW_EVENT_HISTORY',
            value: 16,
        },
        VIEW_UNIT_HISTORY: {
            argumentType: 'COMMAND',
            isDexCommand: !1,
            name: 'VIEW_UNIT_HISTORY',
            value: 34,
        },
    },
    Ie = {
        COMMAND: { name: 'COMMAND', value: 2 },
        FORM_IDENTIFIER: { name: 'FORM_IDENTIFIER', value: 3 },
        TOKEN: { name: 'TOKEN', value: 1 },
    },
    Re = {
        ALLOWED: { name: 'ALLOWED', value: 2 },
        REPEATING: { name: 'REPEATING', value: 1 },
        REQUIRED: { name: 'REQUIRED', value: 3 },
    },
    ae = {
        RECEIVED: { name: 'RECEIVED', value: 1 },
        RUNTIME_ERROR: { name: 'RUNTIME_ERROR', value: 3 },
        SUCCESS: { name: 'SUCCESS', value: 4 },
        VALIDATION_ERROR: { name: 'VALIDATION_ERROR', value: 2 },
    },
    Oe = {
        AGENCY_ASSISTANCE: { name: 'AGENCY_ASSISTANCE' },
        EDIT_EVENT: { name: 'EDIT_EVENT' },
        EDIT_UNIT: { name: 'EDIT_UNIT' },
        GENERATE_REN: { name: 'GENERATE_REN' },
        LOGOUT: { name: 'LOGOUT' },
        OPEN_ALERT_BANNER: { name: 'OPEN_ALERT_BANNER' },
        OPEN_BOLO_FORM: { name: 'OPEN_BOLO_FORM' },
        OPEN_DEX_PERSON_FORM: { name: 'OPEN_DEX_PERSON_FORM' },
        OPEN_DEX_RESULTS: { name: 'OPEN_DEX_RESULTS' },
        OPEN_DEX_VEHICLE_FORM: { name: 'OPEN_DEX_VEHICLE_FORM' },
        OPEN_EDIT_HOSPITAL_FORM: { name: 'OPEN_EDIT_HOSPITAL_FORM' },
        OPEN_ROTATION_FOR_EVENT: { name: 'OPEN_ROTATION_FOR_EVENT' },
        RESYNC: { name: 'RESYNC' },
        SELF_INITIATE: { name: 'SELF_INITIATE' },
        SHOW_ON_MAP: { name: 'SHOW_ON_MAP' },
        UPDATE_EVENT_LOCATION: { name: 'UPDATE_EVENT_LOCATION' },
        VIEW_EVENT: { name: 'VIEW_EVENT' },
        VIEW_EVENT_HISTORY: { name: 'VIEW_EVENT_HISTORY' },
        VIEW_UNIT_HISTORY: { name: 'VIEW_UNIT_HISTORY' },
    },
    Se = {
        AGENCY_EVENT: { name: 'AGENCY_EVENT' },
        COMMENT: { name: 'COMMENT' },
        LOCATION: { name: 'LOCATION' },
        MESSAGING: { name: 'MESSAGING' },
        TEXT: { name: 'TEXT' },
        UNIT: { name: 'UNIT' },
        UNIT_STATE: { name: 'UNIT_STATE' },
    },
    Ce = {
        COMPLETED: { name: 'COMPLETED', value: 5 },
        DRAFT: { name: 'DRAFT', value: 1 },
        PENDING_SECONDARY_REVIEW: { name: 'PENDING_SECONDARY_REVIEW', value: 4 },
        PENDING_SUPERVISOR_REVIEW: { name: 'PENDING_SUPERVISOR_REVIEW', value: 3 },
        REJECTED: { name: 'REJECTED', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ne = { NONE: { name: 'NONE' }, TIBURON_CLRKP: { name: 'TIBURON_CLRKP' } },
    De = {
        BY_LABEL: { name: 'BY_LABEL' },
        BY_LABEL_AND_UPDATED_UTC: { name: 'BY_LABEL_AND_UPDATED_UTC' },
        BY_UPDATED_UTC: { name: 'BY_UPDATED_UTC' },
        NONE: { name: 'NONE' },
    },
    Le = {
        BY_REPORT_LABEL: { name: 'BY_REPORT_LABEL' },
        BY_REPORT_STATUS: { name: 'BY_REPORT_STATUS' },
        BY_REPORT_TYPE: { name: 'BY_REPORT_TYPE' },
        NONE: { name: 'NONE' },
    },
    me = {
        ARREST_ARRESTEE_SUSPECTED_USING: { name: 'ARREST_ARRESTEE_SUSPECTED_USING', value: 217 },
        CAMPUS_VICTIM_CLASSIFICATION_DRUG_TYPE: {
            name: 'CAMPUS_VICTIM_CLASSIFICATION_DRUG_TYPE',
            value: 261,
        },
        CA_EARREST_NON_FILING_REASON: { name: 'CA_EARREST_NON_FILING_REASON', value: 259 },
        CA_EARREST_NON_FILING_TYPE: { name: 'CA_EARREST_NON_FILING_TYPE', value: 258 },
        CIBRS_HATE_CRIME_OFFENSIVE_ACT: { name: 'CIBRS_HATE_CRIME_OFFENSIVE_ACT', value: 58 },
        CIBRS_VICTIM_BY_ASSOCIATION_RELATION: {
            name: 'CIBRS_VICTIM_BY_ASSOCIATION_RELATION',
            value: 60,
        },
        CIBRS_VICTIM_BY_ASSOCIATION_TYPE: { name: 'CIBRS_VICTIM_BY_ASSOCIATION_TYPE', value: 59 },
        DEX_WARRANT_TYPE: { name: 'DEX_WARRANT_TYPE', value: 45 },
        DIRECTION_OF_ENTRY_1: { name: 'DIRECTION_OF_ENTRY_1', value: 247 },
        DIRECTION_OF_ENTRY_2: { name: 'DIRECTION_OF_ENTRY_2', value: 248 },
        DRUG_INVOLVEMENT: { name: 'DRUG_INVOLVEMENT', value: 257 },
        DRUG_PRECURSOR_TYPE: { name: 'DRUG_PRECURSOR_TYPE', value: 263 },
        DRUG_TYPE: { name: 'DRUG_TYPE', value: 265 },
        ENTRY_LEVEL_CODE: { name: 'ENTRY_LEVEL_CODE', value: 46 },
        ENTRY_POINT: { name: 'ENTRY_POINT', value: 200 },
        FIRST_RESPONDER_VICTIM_TYPE: { name: 'FIRST_RESPONDER_VICTIM_TYPE', value: 234 },
        FTRIB_NIBRS_FEDERAL_JUDICIAL_DISTRICT: {
            name: 'FTRIB_NIBRS_FEDERAL_JUDICIAL_DISTRICT',
            value: 269,
        },
        GA_NIBRS_RELIGION: { name: 'GA_NIBRS_RELIGION', value: 216 },
        IDENTIFYING_MARKS: { name: 'IDENTIFYING_MARKS', value: 245 },
        INFANT_AGE: { name: 'INFANT_AGE', value: 229 },
        LARCENY_TYPE: { name: 'LARCENY_TYPE', value: 253 },
        LEOKA_ASSAULT_STATUS: { name: 'LEOKA_ASSAULT_STATUS', value: 277 },
        LOCATION_TYPE_OF_MARIJUANA_SEIZURE_TYPE: {
            name: 'LOCATION_TYPE_OF_MARIJUANA_SEIZURE_TYPE',
            value: 262,
        },
        METHOD_OF_ENTRY_EXIT: { name: 'METHOD_OF_ENTRY_EXIT', value: 280 },
        MMUCC_ACCESS_CONTROL: { name: 'MMUCC_ACCESS_CONTROL', value: 154 },
        MMUCC_AIR_BAG_DEPLOYED: { name: 'MMUCC_AIR_BAG_DEPLOYED', value: 125 },
        MMUCC_ALCOHOL_INTERLOCK_PRESENT: { name: 'MMUCC_ALCOHOL_INTERLOCK_PRESENT', value: 134 },
        MMUCC_ALCOHOL_INVOLVEMENT: { name: 'MMUCC_ALCOHOL_INVOLVEMENT', value: 89 },
        MMUCC_ALCOHOL_TEST_RESULT: { name: 'MMUCC_ALCOHOL_TEST_RESULT', value: 228 },
        MMUCC_ALCOHOL_TEST_STATUS: { name: 'MMUCC_ALCOHOL_TEST_STATUS', value: 141 },
        MMUCC_ALCOHOL_TEST_TYPE: { name: 'MMUCC_ALCOHOL_TEST_TYPE', value: 142 },
        MMUCC_ATTEMPTED_AVOIDANCE_MANEUVER: {
            name: 'MMUCC_ATTEMPTED_AVOIDANCE_MANEUVER',
            value: 163,
        },
        MMUCC_BODY_TYPE_CATEGORY: { name: 'MMUCC_BODY_TYPE_CATEGORY', value: 93 },
        MMUCC_CARGO_BODY_TYPE: { name: 'MMUCC_CARGO_BODY_TYPE', value: 173 },
        MMUCC_CMV_LICENSE_COMPLIANCE: { name: 'MMUCC_CMV_LICENSE_COMPLIANCE', value: 167 },
        MMUCC_CMV_LICENSE_STATUS: { name: 'MMUCC_CMV_LICENSE_STATUS', value: 166 },
        MMUCC_CONDITION: { name: 'MMUCC_CONDITION', value: 139 },
        MMUCC_CRASH_CLASSIFICATION_CHARACTERISTICS: {
            name: 'MMUCC_CRASH_CLASSIFICATION_CHARACTERISTICS',
            value: 67,
        },
        MMUCC_CRASH_CLASSIFICATION_OWNERSHIP: {
            name: 'MMUCC_CRASH_CLASSIFICATION_OWNERSHIP',
            value: 66,
        },
        MMUCC_CRASH_CLASSIFICATION_SECONDARY_CRASH: {
            name: 'MMUCC_CRASH_CLASSIFICATION_SECONDARY_CRASH',
            value: 68,
        },
        MMUCC_CRASH_RELATED_TO_HOV_HOT_LANES: {
            name: 'MMUCC_CRASH_RELATED_TO_HOV_HOT_LANES',
            value: 104,
        },
        MMUCC_CRASH_SEVERITY: { name: 'MMUCC_CRASH_SEVERITY', value: 88 },
        MMUCC_CROSS_STREET_NUM_LANES_AT_INTERSECTION: {
            name: 'MMUCC_CROSS_STREET_NUM_LANES_AT_INTERSECTION',
            value: 162,
        },
        MMUCC_DAY_OF_WEEK: { name: 'MMUCC_DAY_OF_WEEK', value: 91 },
        MMUCC_DIRECTION_OF_TRAVEL_BEFORE_CRASH: {
            name: 'MMUCC_DIRECTION_OF_TRAVEL_BEFORE_CRASH',
            value: 99,
        },
        MMUCC_DISTRACTED_BY: { name: 'MMUCC_DISTRACTED_BY', value: 137 },
        MMUCC_DISTRACTED_BY_SOURCE: { name: 'MMUCC_DISTRACTED_BY_SOURCE', value: 138 },
        MMUCC_DRIVER_ACTIONS: { name: 'MMUCC_DRIVER_ACTIONS', value: 132 },
        MMUCC_DRIVER_LICENSE_CDL: { name: 'MMUCC_DRIVER_LICENSE_CDL', value: 129 },
        MMUCC_DRIVER_LICENSE_CLASS: { name: 'MMUCC_DRIVER_LICENSE_CLASS', value: 128 },
        MMUCC_DRIVER_LICENSE_ENDORSEMENTS: {
            name: 'MMUCC_DRIVER_LICENSE_ENDORSEMENTS',
            value: 130,
        },
        MMUCC_DRIVER_LICENSE_JURISDICTION: {
            name: 'MMUCC_DRIVER_LICENSE_JURISDICTION',
            value: 127,
        },
        MMUCC_DRIVER_LICENSE_RESTRICTIONS: {
            name: 'MMUCC_DRIVER_LICENSE_RESTRICTIONS',
            value: 133,
        },
        MMUCC_DRIVER_LICENSE_STATUS: { name: 'MMUCC_DRIVER_LICENSE_STATUS', value: 136 },
        MMUCC_DRIVER_LICENSE_TYPE: { name: 'MMUCC_DRIVER_LICENSE_TYPE', value: 135 },
        MMUCC_DRUG_INVOLVEMENT: { name: 'MMUCC_DRUG_INVOLVEMENT', value: 90 },
        MMUCC_DRUG_TEST_RESULT: { name: 'MMUCC_DRUG_TEST_RESULT', value: 147 },
        MMUCC_DRUG_TEST_STATUS: { name: 'MMUCC_DRUG_TEST_STATUS', value: 145 },
        MMUCC_DRUG_TEST_TYPE: { name: 'MMUCC_DRUG_TEST_TYPE', value: 146 },
        MMUCC_EJECTION: { name: 'MMUCC_EJECTION', value: 126 },
        MMUCC_EMERGENCY_MOTOR_VEHICLE_USE: { name: 'MMUCC_EMERGENCY_MOTOR_VEHICLE_USE', value: 98 },
        MMUCC_FATAL_ALCOHOL_TEST_TYPE: { name: 'MMUCC_FATAL_ALCOHOL_TEST_TYPE', value: 164 },
        MMUCC_FATAL_DRUG_TEST_TYPE: { name: 'MMUCC_FATAL_DRUG_TEST_TYPE', value: 165 },
        MMUCC_FIRST_HARMFUL_EVENT: { name: 'MMUCC_FIRST_HARMFUL_EVENT', value: 69 },
        MMUCC_GRADE_DIRECTION_OF_SLOPE: { name: 'MMUCC_GRADE_DIRECTION_OF_SLOPE', value: 151 },
        MMUCC_HAS_HM_PLACARD: { name: 'MMUCC_HAS_HM_PLACARD', value: 96 },
        MMUCC_HAZARDOUS_MATERIALS_CLASS: { name: 'MMUCC_HAZARDOUS_MATERIALS_CLASS', value: 205 },
        MMUCC_HAZARDOUS_MATERIALS_RELEASED: {
            name: 'MMUCC_HAZARDOUS_MATERIALS_RELEASED',
            value: 174,
        },
        MMUCC_HIT_AND_RUN: { name: 'MMUCC_HIT_AND_RUN', value: 115 },
        MMUCC_INCIDENT_RESPONDER: { name: 'MMUCC_INCIDENT_RESPONDER', value: 120 },
        MMUCC_INITIAL_CONTACT_POINT_ON_NON_MOTORIST: {
            name: 'MMUCC_INITIAL_CONTACT_POINT_ON_NON_MOTORIST',
            value: 180,
        },
        MMUCC_INITIAL_POINT_OF_CONTACT: { name: 'MMUCC_INITIAL_POINT_OF_CONTACT', value: 110 },
        MMUCC_INJURY_AREA: { name: 'MMUCC_INJURY_AREA', value: 149 },
        MMUCC_INJURY_SEVERITY: { name: 'MMUCC_INJURY_SEVERITY', value: 150 },
        MMUCC_INJURY_STATUS: { name: 'MMUCC_INJURY_STATUS', value: 121 },
        MMUCC_INTERSECTION_NUM_APPROACHES: { name: 'MMUCC_INTERSECTION_NUM_APPROACHES', value: 79 },
        MMUCC_INTERSECTION_OVERALL_GEOMETRY: {
            name: 'MMUCC_INTERSECTION_OVERALL_GEOMETRY',
            value: 80,
        },
        MMUCC_INTERSECTION_OVERALL_TRAFFIC_CONTROL_DEVICE: {
            name: 'MMUCC_INTERSECTION_OVERALL_TRAFFIC_CONTROL_DEVICE',
            value: 81,
        },
        MMUCC_JUNCTION_SPECIFIC_LOCATION: { name: 'MMUCC_JUNCTION_SPECIFIC_LOCATION', value: 78 },
        MMUCC_JUNCTION_WITHIN_INTERCHANGE_AREA: {
            name: 'MMUCC_JUNCTION_WITHIN_INTERCHANGE_AREA',
            value: 77,
        },
        MMUCC_LAW_ENFORCEMENT_SUSPECTS_ALCOHOL_USE: {
            name: 'MMUCC_LAW_ENFORCEMENT_SUSPECTS_ALCOHOL_USE',
            value: 140,
        },
        MMUCC_LAW_ENFORCEMENT_SUSPECTS_DRUG_USE: {
            name: 'MMUCC_LAW_ENFORCEMENT_SUSPECTS_DRUG_USE',
            value: 144,
        },
        MMUCC_LIGHT_CONDITION: { name: 'MMUCC_LIGHT_CONDITION', value: 74 },
        MMUCC_LOCATION_OF_DAMAGED_AREAS: { name: 'MMUCC_LOCATION_OF_DAMAGED_AREAS', value: 111 },
        MMUCC_LOCATION_OF_FIRST_HARMFUL_EVENT: {
            name: 'MMUCC_LOCATION_OF_FIRST_HARMFUL_EVENT',
            value: 70,
        },
        MMUCC_LONGITUDINAL_CENTERLINE_TYPE: {
            name: 'MMUCC_LONGITUDINAL_CENTERLINE_TYPE',
            value: 157,
        },
        MMUCC_LONGITUDINAL_EDGELINE_TYPE: { name: 'MMUCC_LONGITUDINAL_EDGELINE_TYPE', value: 156 },
        MMUCC_LONGITUDINAL_LANE_LINE_MARKINGS: {
            name: 'MMUCC_LONGITUDINAL_LANE_LINE_MARKINGS',
            value: 158,
        },
        MMUCC_MAINLINE_NUM_LANES_AT_INTERSECTION: {
            name: 'MMUCC_MAINLINE_NUM_LANES_AT_INTERSECTION',
            value: 161,
        },
        MMUCC_MANEUVER: { name: 'MMUCC_MANEUVER', value: 109 },
        MMUCC_MANNER_OF_CRASH: { name: 'MMUCC_MANNER_OF_CRASH', value: 71 },
        MMUCC_MEDICAL_TRANSPORT_SOURCE: { name: 'MMUCC_MEDICAL_TRANSPORT_SOURCE', value: 148 },
        MMUCC_MOST_HARMFUL_EVENT: { name: 'MMUCC_MOST_HARMFUL_EVENT', value: 114 },
        MMUCC_MOTOR_CARRIER_IDENTIFICATION_CARRIER_TYPE: {
            name: 'MMUCC_MOTOR_CARRIER_IDENTIFICATION_CARRIER_TYPE',
            value: 169,
        },
        MMUCC_MOTOR_CARRIER_IDENTIFICATION_TYPE: {
            name: 'MMUCC_MOTOR_CARRIER_IDENTIFICATION_TYPE',
            value: 168,
        },
        MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS: {
            name: 'MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS',
            value: 181,
        },
        MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_ENGAGED: {
            name: 'MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_ENGAGED',
            value: 183,
        },
        MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_LEVEL: {
            name: 'MMUCC_MOTOR_VEHICLE_AUTOMATED_DRIVING_SYSTEMS_LEVEL',
            value: 182,
        },
        MMUCC_NON_MOTORIST_ACTION_PRIOR_TO_CRASH: {
            name: 'MMUCC_NON_MOTORIST_ACTION_PRIOR_TO_CRASH',
            value: 175,
        },
        MMUCC_NON_MOTORIST_CONTRIBUTING_ACTIONS: {
            name: 'MMUCC_NON_MOTORIST_CONTRIBUTING_ACTIONS',
            value: 177,
        },
        MMUCC_NON_MOTORIST_LOCATION_AT_TIME_OF_CRASH: {
            name: 'MMUCC_NON_MOTORIST_LOCATION_AT_TIME_OF_CRASH',
            value: 178,
        },
        MMUCC_NON_MOTORIST_ORIGIN_OR_DESTINATION: {
            name: 'MMUCC_NON_MOTORIST_ORIGIN_OR_DESTINATION',
            value: 176,
        },
        MMUCC_NON_MOTORIST_SAFETY_EQUIPMENT: {
            name: 'MMUCC_NON_MOTORIST_SAFETY_EQUIPMENT',
            value: 179,
        },
        MMUCC_NUM_TRAILING_UNITS: { name: 'MMUCC_NUM_TRAILING_UNITS', value: 94 },
        MMUCC_PART_OF_NATIONAL_HIGHWAY_SYSTEM: {
            name: 'MMUCC_PART_OF_NATIONAL_HIGHWAY_SYSTEM',
            value: 152,
        },
        MMUCC_PERSON_TYPE: { name: 'MMUCC_PERSON_TYPE', value: 119 },
        MMUCC_RESTRAINTS_AND_HELMETS: { name: 'MMUCC_RESTRAINTS_AND_HELMETS', value: 123 },
        MMUCC_RESTRAINT_SYSTEMS_IMPROPER_USE: {
            name: 'MMUCC_RESTRAINT_SYSTEMS_IMPROPER_USE',
            value: 124,
        },
        MMUCC_RESULTING_EXTENT_OF_DAMAGE: { name: 'MMUCC_RESULTING_EXTENT_OF_DAMAGE', value: 112 },
        MMUCC_ROADWAY_CONTRIBUTING_CIRCUMSTANCES: {
            name: 'MMUCC_ROADWAY_CONTRIBUTING_CIRCUMSTANCES',
            value: 76,
        },
        MMUCC_ROADWAY_FUNCTIONAL_CLASS: { name: 'MMUCC_ROADWAY_FUNCTIONAL_CLASS', value: 153 },
        MMUCC_ROADWAY_GRADE: { name: 'MMUCC_ROADWAY_GRADE', value: 106 },
        MMUCC_ROADWAY_HORIZONTAL_ALIGNMENT: {
            name: 'MMUCC_ROADWAY_HORIZONTAL_ALIGNMENT',
            value: 105,
        },
        MMUCC_ROADWAY_LIGHTING: { name: 'MMUCC_ROADWAY_LIGHTING', value: 155 },
        MMUCC_ROADWAY_SURFACE_CONDITION: { name: 'MMUCC_ROADWAY_SURFACE_CONDITION', value: 75 },
        MMUCC_SCHOOL_BUS_RELATED: { name: 'MMUCC_SCHOOL_BUS_RELATED', value: 82 },
        MMUCC_SEATING_POSITION: { name: 'MMUCC_SEATING_POSITION', value: 122 },
        MMUCC_SEQUENCE_OF_EVENTS: { name: 'MMUCC_SEQUENCE_OF_EVENTS', value: 113 },
        MMUCC_SEX: { name: 'MMUCC_SEX', value: 118 },
        MMUCC_SIGNED_BICYCLE_ROUTE: { name: 'MMUCC_SIGNED_BICYCLE_ROUTE', value: 160 },
        MMUCC_SOURCE_OF_INFORMATION: { name: 'MMUCC_SOURCE_OF_INFORMATION', value: 72 },
        MMUCC_SPECIAL_FUNCTION: { name: 'MMUCC_SPECIAL_FUNCTION', value: 97 },
        MMUCC_SPEEDING_RELATED: { name: 'MMUCC_SPEEDING_RELATED', value: 131 },
        MMUCC_TOWED_DUE_TO_DISABLING_DAMAGE: {
            name: 'MMUCC_TOWED_DUE_TO_DISABLING_DAMAGE',
            value: 116,
        },
        MMUCC_TRAFFICWAY_BARRIER_TYPE: { name: 'MMUCC_TRAFFICWAY_BARRIER_TYPE', value: 102 },
        MMUCC_TRAFFICWAY_DIVIDED: { name: 'MMUCC_TRAFFICWAY_DIVIDED', value: 101 },
        MMUCC_TRAFFICWAY_HOV_HOT_LANES: { name: 'MMUCC_TRAFFICWAY_HOV_HOT_LANES', value: 103 },
        MMUCC_TRAFFICWAY_TRAVEL_DIRECTIONS: {
            name: 'MMUCC_TRAFFICWAY_TRAVEL_DIRECTIONS',
            value: 100,
        },
        MMUCC_TRAFFIC_CONTROLS_INOPERATIVE_OR_MISSING: {
            name: 'MMUCC_TRAFFIC_CONTROLS_INOPERATIVE_OR_MISSING',
            value: 108,
        },
        MMUCC_TRAFFIC_CONTROLS_TYPE: { name: 'MMUCC_TRAFFIC_CONTROLS_TYPE', value: 107 },
        MMUCC_TYPE_OF_BICYCLE_FACILITY: { name: 'MMUCC_TYPE_OF_BICYCLE_FACILITY', value: 159 },
        MMUCC_UNIT_TYPE: { name: 'MMUCC_UNIT_TYPE', value: 92 },
        MMUCC_VEHICLE_CONFIGURATION: { name: 'MMUCC_VEHICLE_CONFIGURATION', value: 170 },
        MMUCC_VEHICLE_CONFIGURATION_PERMITTED: {
            name: 'MMUCC_VEHICLE_CONFIGURATION_PERMITTED',
            value: 172,
        },
        MMUCC_VEHICLE_CONFIGURATION_SPECIAL_SIZING: {
            name: 'MMUCC_VEHICLE_CONFIGURATION_SPECIAL_SIZING',
            value: 171,
        },
        MMUCC_VEHICLE_CONTRIBUTING_CIRCUMSTANCES: {
            name: 'MMUCC_VEHICLE_CONTRIBUTING_CIRCUMSTANCES',
            value: 117,
        },
        MMUCC_VEHICLE_SIZE: { name: 'MMUCC_VEHICLE_SIZE', value: 95 },
        MMUCC_WEATHER_CONDITIONS: { name: 'MMUCC_WEATHER_CONDITIONS', value: 73 },
        MMUCC_WORK_ZONE_LAW_ENFORCEMENT_PRESENT: {
            name: 'MMUCC_WORK_ZONE_LAW_ENFORCEMENT_PRESENT',
            value: 87,
        },
        MMUCC_WORK_ZONE_LOCATION_OF_CRASH: { name: 'MMUCC_WORK_ZONE_LOCATION_OF_CRASH', value: 84 },
        MMUCC_WORK_ZONE_RELATED: { name: 'MMUCC_WORK_ZONE_RELATED', value: 83 },
        MMUCC_WORK_ZONE_TYPE: { name: 'MMUCC_WORK_ZONE_TYPE', value: 85 },
        MMUCC_WORK_ZONE_WORKERS_PRESENT: { name: 'MMUCC_WORK_ZONE_WORKERS_PRESENT', value: 86 },
        MODUS_OPERANDI: { name: 'MODUS_OPERANDI', value: 249 },
        NCIC_ARTICLE_CATEGORY: { name: 'NCIC_ARTICLE_CATEGORY', value: 272 },
        NCIC_ARTICLE_TYPE: { name: 'NCIC_ARTICLE_TYPE', value: 271 },
        NCIC_FIREARM_CALIBER: { name: 'NCIC_FIREARM_CALIBER', value: 225 },
        NCIC_FIREARM_MAKE: { name: 'NCIC_FIREARM_MAKE', value: 232 },
        NCIC_FIREARM_TYPE: { name: 'NCIC_FIREARM_TYPE', value: 274 },
        NCIC_LICENSE_PLATE_TYPE: { name: 'NCIC_LICENSE_PLATE_TYPE', value: 273 },
        NCIC_OFFENSE_CODE: { name: 'NCIC_OFFENSE_CODE', value: 40 },
        NCIC_VEHICLE_COLOR: { name: 'NCIC_VEHICLE_COLOR', value: 221 },
        NIBRS_AGGRAVATED_ASSAULT_HOMICIDE_FACTORS: {
            name: 'NIBRS_AGGRAVATED_ASSAULT_HOMICIDE_FACTORS',
            value: 17,
        },
        NIBRS_ARRESTEE_SUSPECTED_OF_USING: { name: 'NIBRS_ARRESTEE_SUSPECTED_OF_USING', value: 64 },
        NIBRS_ARRESTEE_WEAPON: { name: 'NIBRS_ARRESTEE_WEAPON', value: 19 },
        NIBRS_ARREST_CATEGORY: { name: 'NIBRS_ARREST_CATEGORY', value: 18 },
        NIBRS_ARREST_DISPOSITION: { name: 'NIBRS_ARREST_DISPOSITION', value: 65 },
        NIBRS_COUNTY_CODE: { name: 'NIBRS_COUNTY_CODE', value: 254 },
        NIBRS_CRIMINAL_ACTIVITY_CATEGORY: { name: 'NIBRS_CRIMINAL_ACTIVITY_CATEGORY', value: 20 },
        NIBRS_DRUG_CATEGORY: { name: 'NIBRS_DRUG_CATEGORY', value: 21 },
        NIBRS_DRUG_MEASUREMENT: { name: 'NIBRS_DRUG_MEASUREMENT', value: 22 },
        NIBRS_ETHNICITY: { name: 'NIBRS_ETHNICITY', value: 23 },
        NIBRS_GANG_TYPE: { name: 'NIBRS_GANG_TYPE', value: 61 },
        NIBRS_INCIDENT_BIAS_MOTIVATION: { name: 'NIBRS_INCIDENT_BIAS_MOTIVATION', value: 24 },
        NIBRS_INCIDENT_EXCEPTIONAL_CLEARANCE: {
            name: 'NIBRS_INCIDENT_EXCEPTIONAL_CLEARANCE',
            value: 25,
        },
        NIBRS_INJURY_CATEGORY: { name: 'NIBRS_INJURY_CATEGORY', value: 26 },
        NIBRS_JUSTIFIABLE_HOMICIDE_FACTORS: {
            name: 'NIBRS_JUSTIFIABLE_HOMICIDE_FACTORS',
            value: 27,
        },
        NIBRS_JUVENILE_ARREST_DISPOSITION: { name: 'NIBRS_JUVENILE_ARREST_DISPOSITION', value: 28 },
        NIBRS_LEOKA_ACTIVITY_CATEGORY: { name: 'NIBRS_LEOKA_ACTIVITY_CATEGORY', value: 29 },
        NIBRS_LEOKA_OFFICER_ASSIGNMENT_CATEGORY: {
            name: 'NIBRS_LEOKA_OFFICER_ASSIGNMENT_CATEGORY',
            value: 30,
        },
        NIBRS_LOCATION_CATEGORY: { name: 'NIBRS_LOCATION_CATEGORY', value: 32 },
        NIBRS_MASS_INCIDENT_BIAS_MOTIVATION: {
            name: 'NIBRS_MASS_INCIDENT_BIAS_MOTIVATION',
            value: 31,
        },
        NIBRS_OFFENSE_CODE_LEVEL: { name: 'NIBRS_OFFENSE_CODE_LEVEL', value: 63 },
        NIBRS_OFFENSE_CODE_TYPE: { name: 'NIBRS_OFFENSE_CODE_TYPE', value: 62 },
        NIBRS_PROPERTY_CATEGORY: { name: 'NIBRS_PROPERTY_CATEGORY', value: 33 },
        NIBRS_PROPERTY_LOSS: { name: 'NIBRS_PROPERTY_LOSS', value: 34 },
        NIBRS_RACE: { name: 'NIBRS_RACE', value: 35 },
        NIBRS_RESIDENT: { name: 'NIBRS_RESIDENT', value: 36 },
        NIBRS_SEX: { name: 'NIBRS_SEX', value: 37 },
        NIBRS_TYPE_OF_CLANDENSTINE_LAB: { name: 'NIBRS_TYPE_OF_CLANDENSTINE_LAB', value: 44 },
        NIBRS_TYPE_OF_MARIJUANA: { name: 'NIBRS_TYPE_OF_MARIJUANA', value: 43 },
        NIBRS_TYPE_OF_WEAPON_FORCE_INVOLVED: {
            name: 'NIBRS_TYPE_OF_WEAPON_FORCE_INVOLVED',
            value: 38,
        },
        NIBRS_VICTIM_CATEGORY: { name: 'NIBRS_VICTIM_CATEGORY', value: 39 },
        NIBRS_WARRANT_TYPE: { name: 'NIBRS_WARRANT_TYPE', value: 260 },
        NJ_NIBRS_BIAS_DESCRIPTION: { name: 'NJ_NIBRS_BIAS_DESCRIPTION', value: 227 },
        NJ_NIBRS_OFFICER_RANK: { name: 'NJ_NIBRS_OFFICER_RANK', value: 226 },
        NJ_NIBRS_STATE: { name: 'NJ_NIBRS_STATE', value: 222 },
        NY_DRUGS_DATA_SOURCE: { name: 'NY_DRUGS_DATA_SOURCE', value: 233 },
        NY_INJURY_CATEGORY: { name: 'NY_INJURY_CATEGORY', value: 242 },
        NY_MEDICAL_TREATMENT_RECEIVED: { name: 'NY_MEDICAL_TREATMENT_RECEIVED', value: 243 },
        NY_NIBRS_ARREST_STATUS: { name: 'NY_NIBRS_ARREST_STATUS', value: 231 },
        NY_NIBRS_OFFENDER_CONDITION: { name: 'NY_NIBRS_OFFENDER_CONDITION', value: 240 },
        NY_NIBRS_OFFENSE_CODE_CLASSIFICATION: {
            name: 'NY_NIBRS_OFFENSE_CODE_CLASSIFICATION',
            value: 235,
        },
        NY_NIBRS_PROPERTY_CATEGORY: { name: 'NY_NIBRS_PROPERTY_CATEGORY', value: 241 },
        OFFENDER_HOUSEHOLD_STATUS: { name: 'OFFENDER_HOUSEHOLD_STATUS', value: 223 },
        OFFENSE_SPECIAL_CIRCUMSTANCE: { name: 'OFFENSE_SPECIAL_CIRCUMSTANCE', value: 278 },
        OH_NIBRS_EYE_COLOR: { name: 'OH_NIBRS_EYE_COLOR', value: 252 },
        OH_NIBRS_HAIR_COLOR: { name: 'OH_NIBRS_HAIR_COLOR', value: 251 },
        OH_NIBRS_PROPERTY_CATEGORY: { name: 'OH_NIBRS_PROPERTY_CATEGORY', value: 244 },
        ORIGIN_OF_DRUG_TYPE: { name: 'ORIGIN_OF_DRUG_TYPE', value: 264 },
        PNC_REQUEST_REASON_CODE: { name: 'PNC_REQUEST_REASON_CODE', value: 276 },
        POLICE_ACTION_TAKEN: { name: 'POLICE_ACTION_TAKEN', value: 219 },
        QC_COLOR: { name: 'QC_COLOR', value: 201 },
        QC_DOI_PERSONNEL_UNIT: { name: 'QC_DOI_PERSONNEL_UNIT', value: 270 },
        QC_EYE_COLOR: { name: 'QC_EYE_COLOR', value: 204 },
        QC_HAIR_COLOR: { name: 'QC_HAIR_COLOR', value: 203 },
        QC_LANDMARK_DIRECTION: { name: 'QC_LANDMARK_DIRECTION', value: 207 },
        QC_LANDMARK_DISTANCE_UNITS: { name: 'QC_LANDMARK_DISTANCE_UNITS', value: 206 },
        QC_MILEPOST_DIRECTION: { name: 'QC_MILEPOST_DIRECTION', value: 210 },
        QC_MILEPOST_DISTANCE_UNITS: { name: 'QC_MILEPOST_DISTANCE_UNITS', value: 211 },
        QC_RACE: { name: 'QC_RACE', value: 202 },
        QC_ROADWAY_DIRECTION: { name: 'QC_ROADWAY_DIRECTION', value: 212 },
        SCHOOL_CODE: { name: 'SCHOOL_CODE', value: 267 },
        SECURITY_SYSTEM: { name: 'SECURITY_SYSTEM', value: 281 },
        STOP_ACTION_TAKEN: { name: 'STOP_ACTION_TAKEN', value: 185 },
        STOP_BASIS_FOR_PROPERTY_SEIZURE: { name: 'STOP_BASIS_FOR_PROPERTY_SEIZURE', value: 186 },
        STOP_BASIS_FOR_SEARCH: { name: 'STOP_BASIS_FOR_SEARCH', value: 187 },
        STOP_CONSENT_TYPE: { name: 'STOP_CONSENT_TYPE', value: 239 },
        STOP_CONTRABAND_TYPE: { name: 'STOP_CONTRABAND_TYPE', value: 188 },
        STOP_DISABILITY: { name: 'STOP_DISABILITY', value: 189 },
        STOP_EDUCATION_CODE_SECTION: { name: 'STOP_EDUCATION_CODE_SECTION', value: 190 },
        STOP_EDUCATION_CODE_SUBDIVISION: { name: 'STOP_EDUCATION_CODE_SUBDIVISION', value: 191 },
        STOP_FORCIBLE_ACTION_TAKEN: { name: 'STOP_FORCIBLE_ACTION_TAKEN', value: 238 },
        STOP_NON_FORCIBLE_ACTION_TAKEN: { name: 'STOP_NON_FORCIBLE_ACTION_TAKEN', value: 237 },
        STOP_PERCEIVED_GENDER: { name: 'STOP_PERCEIVED_GENDER', value: 192 },
        STOP_PERCEIVED_RACE: { name: 'STOP_PERCEIVED_RACE', value: 193 },
        STOP_REASON_FOR_STOP: { name: 'STOP_REASON_FOR_STOP', value: 194 },
        STOP_REASON_GIVEN_TO_STOPPED_PERSON: {
            name: 'STOP_REASON_GIVEN_TO_STOPPED_PERSON',
            value: 250,
        },
        STOP_RESULT_OF_STOP: { name: 'STOP_RESULT_OF_STOP', value: 195 },
        STOP_SUSPICION_TYPE: { name: 'STOP_SUSPICION_TYPE', value: 196 },
        STOP_TYPE_OF_PROPERTY_SEIZED: { name: 'STOP_TYPE_OF_PROPERTY_SEIZED', value: 197 },
        STOP_TYPE_OF_STOP: { name: 'STOP_TYPE_OF_STOP', value: 236 },
        STOP_TYPE_OF_TRAFFIC_VIOLATION: { name: 'STOP_TYPE_OF_TRAFFIC_VIOLATION', value: 198 },
        STOP_USER_ASSIGNMENT_TYPE: { name: 'STOP_USER_ASSIGNMENT_TYPE', value: 199 },
        SUBSTANCE_ABUSE: { name: 'SUBSTANCE_ABUSE', value: 268 },
        TYPE_OF_GANG_TYPE: { name: 'TYPE_OF_GANG_TYPE', value: 266 },
        UCR_ARREST_DISPOSITION: { name: 'UCR_ARREST_DISPOSITION', value: 51 },
        UCR_ARREST_LEVEL: { name: 'UCR_ARREST_LEVEL', value: 49 },
        UCR_ARREST_STATUS: { name: 'UCR_ARREST_STATUS', value: 50 },
        UCR_ARREST_STATUTE_CODE_TYPE: { name: 'UCR_ARREST_STATUTE_CODE_TYPE', value: 52 },
        UCR_ARSON_LOCATION_TYPE: { name: 'UCR_ARSON_LOCATION_TYPE', value: 13 },
        UCR_BIAS_MOTIVATION: { name: 'UCR_BIAS_MOTIVATION', value: 53 },
        UCR_BURGLARY_RESIDENCE_TYPE: { name: 'UCR_BURGLARY_RESIDENCE_TYPE', value: 3 },
        UCR_BURGLARY_TIME_OF_DAY: { name: 'UCR_BURGLARY_TIME_OF_DAY', value: 7 },
        UCR_CLEARANCE_STATUS: { name: 'UCR_CLEARANCE_STATUS', value: 9 },
        UCR_ETHNICITY: { name: 'UCR_ETHNICITY', value: 56 },
        UCR_GENDER: { name: 'UCR_GENDER', value: 47 },
        UCR_HOMICIDE_CIRCUMSTANCE: { name: 'UCR_HOMICIDE_CIRCUMSTANCE', value: 14 },
        UCR_HOMICIDE_WEAPON_OR_FORCE: { name: 'UCR_HOMICIDE_WEAPON_OR_FORCE', value: 12 },
        UCR_JUSTIFIABLE_HOMICIDE_CIRCUMSTANCE: {
            name: 'UCR_JUSTIFIABLE_HOMICIDE_CIRCUMSTANCE',
            value: 16,
        },
        UCR_JUVENILE_ARREST_DISPOSITION: { name: 'UCR_JUVENILE_ARREST_DISPOSITION', value: 57 },
        UCR_LARCENY_THEFT_AMOUNT: { name: 'UCR_LARCENY_THEFT_AMOUNT', value: 2 },
        UCR_LEOKA_ACTIVITY_CATEGORY: { name: 'UCR_LEOKA_ACTIVITY_CATEGORY', value: 54 },
        UCR_LEOKA_OFFICER_ASSIGNMENT_CATEGORY: {
            name: 'UCR_LEOKA_OFFICER_ASSIGNMENT_CATEGORY',
            value: 55,
        },
        UCR_NEGLIGENT_MANSLAUGHTER_CIRCUMSTANCE: {
            name: 'UCR_NEGLIGENT_MANSLAUGHTER_CIRCUMSTANCE',
            value: 15,
        },
        UCR_PROPERTY_CATEGORY: { name: 'UCR_PROPERTY_CATEGORY', value: 6 },
        UCR_PROPERTY_STATUS: { name: 'UCR_PROPERTY_STATUS', value: 5 },
        UCR_RACE: { name: 'UCR_RACE', value: 48 },
        UCR_RELATIONSHIP: { name: 'UCR_RELATIONSHIP', value: 11 },
        UCR_ROBBERY_LOCATION_TYPE: { name: 'UCR_ROBBERY_LOCATION_TYPE', value: 4 },
        UCR_SUFFOCATION_OR_STRANGULATION: { name: 'UCR_SUFFOCATION_OR_STRANGULATION', value: 8 },
        UCR_VEHICLE_RECOVERY_TYPE: { name: 'UCR_VEHICLE_RECOVERY_TYPE', value: 10 },
        UCR_WEAPON_OR_FORCE: { name: 'UCR_WEAPON_OR_FORCE', value: 1 },
        UK_OFFENSE_CODE_CATEGORY: { name: 'UK_OFFENSE_CODE_CATEGORY', value: 256 },
        UK_SEX: { name: 'UK_SEX', value: 255 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USE_OF_FORCE_EXTENDED_BOOLEAN: { name: 'USE_OF_FORCE_EXTENDED_BOOLEAN', value: 208 },
        USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT: {
            name: 'USE_OF_FORCE_OFFICER_FORCE_TOWARDS_SUBJECT',
            value: 220,
        },
        USE_OF_FORCE_OFFICER_WEAPON_USED: { name: 'USE_OF_FORCE_OFFICER_WEAPON_USED', value: 275 },
        USE_OF_FORCE_PENDING_UNKNOWN: { name: 'USE_OF_FORCE_PENDING_UNKNOWN', value: 214 },
        USE_OF_FORCE_REASON: { name: 'USE_OF_FORCE_REASON', value: 215 },
        USE_OF_FORCE_SUBJECT_DISPOSITION: { name: 'USE_OF_FORCE_SUBJECT_DISPOSITION', value: 213 },
        USE_OF_FORCE_SUBJECT_IMPAIRMENTS: { name: 'USE_OF_FORCE_SUBJECT_IMPAIRMENTS', value: 209 },
        VEHICLE_BODY_STYLE: { name: 'VEHICLE_BODY_STYLE', value: 42 },
        VEHICLE_ENTRY_POINT: { name: 'VEHICLE_ENTRY_POINT', value: 246 },
        VEHICLE_TYPE: { name: 'VEHICLE_TYPE', value: 41 },
        VICTIM_DISABILITY_STATUS: { name: 'VICTIM_DISABILITY_STATUS', value: 224 },
        YES_NO_UNKNOWN: { name: 'YES_NO_UNKNOWN', value: 218 },
    },
    le = {
        AZ_NIBRS: { name: 'AZ_NIBRS', value: 80 },
        CA_CLETS: { name: 'CA_CLETS', value: 64 },
        CA_EARREST: { name: 'CA_EARREST', value: 86 },
        CA_NIBRS: { name: 'CA_NIBRS', value: 71 },
        CA_RIPA: { name: 'CA_RIPA', value: 74 },
        CA_UCR: { name: 'CA_UCR', value: 62 },
        CA_USE_OF_FORCE: { name: 'CA_USE_OF_FORCE', value: 61 },
        COPLOGIC: { name: 'COPLOGIC', value: 52 },
        CO_CONTACTS_USE_OF_FORCE: { name: 'CO_CONTACTS_USE_OF_FORCE', value: 98 },
        DC_COMMON_LIBRARY: { name: 'DC_COMMON_LIBRARY', value: 25 },
        DC_COURTS: { name: 'DC_COURTS', value: 23 },
        DC_EVIDENCE_ON_Q: { name: 'DC_EVIDENCE_ON_Q', value: 26 },
        DC_ILEADS: { name: 'DC_ILEADS', value: 21 },
        DC_LOCAL: { name: 'DC_LOCAL', value: 20 },
        DC_TRAFFIC_CRASH: { name: 'DC_TRAFFIC_CRASH', value: 24 },
        FL_NIBRS: { name: 'FL_NIBRS', value: 77 },
        FL_UCR: { name: 'FL_UCR', value: 66 },
        FTRIB_NIBRS: { name: 'FTRIB_NIBRS', value: 90 },
        GA_FAM_VIOLENCE: { name: 'GA_FAM_VIOLENCE', value: 69 },
        GA_NIBRS: { name: 'GA_NIBRS', value: 79 },
        HI_NIBRS: { name: 'HI_NIBRS', value: 88 },
        IL_NIBRS: { name: 'IL_NIBRS', value: 84 },
        INTEGRATION: { name: 'INTEGRATION', value: 51 },
        LA_LEMS: { name: 'LA_LEMS', value: 91 },
        LA_NIBRS: { name: 'LA_NIBRS', value: 68 },
        MA_NIBRS: { name: 'MA_NIBRS', value: 65 },
        MD_NIBRS: { name: 'MD_NIBRS', value: 73 },
        MIGRATION: { name: 'MIGRATION', value: 50 },
        MMUCC: { name: 'MMUCC', value: 5 },
        NCIC: { name: 'NCIC', value: 3 },
        NDEX: { name: 'NDEX', value: 4 },
        NIBRS: { name: 'NIBRS', value: 2 },
        NJ_NIBRS: { name: 'NJ_NIBRS', value: 81 },
        NJ_UCR: { name: 'NJ_UCR', value: 63 },
        NM_NIBRS: { name: 'NM_NIBRS', value: 78 },
        NY_NIBRS: { name: 'NY_NIBRS', value: 82 },
        NY_UCR: { name: 'NY_UCR', value: 92 },
        OH_NIBRS: { name: 'OH_NIBRS', value: 83 },
        PA_NIBRS: { name: 'PA_NIBRS', value: 72 },
        PNC_NDI: { name: 'PNC_NDI', value: 96 },
        QUICK_CRASH: { name: 'QUICK_CRASH', value: 75 },
        SC_NIBRS: { name: 'SC_NIBRS', value: 95 },
        TCOLE: { name: 'TCOLE', value: 70 },
        TN_NIBRS: { name: 'TN_NIBRS', value: 87 },
        TN_TIES: { name: 'TN_TIES', value: 89 },
        TX_NIBRS: { name: 'TX_NIBRS', value: 67 },
        UK: { name: 'UK', value: 85 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USE_OF_FORCE: { name: 'USE_OF_FORCE', value: 76 },
        US_CVB: { name: 'US_CVB', value: 93 },
        VA_NIBRS: { name: 'VA_NIBRS', value: 97 },
        VEHICLE: { name: 'VEHICLE', value: 6 },
        WA_NIBRS: { name: 'WA_NIBRS', value: 60 },
    },
    ue = {
        ADDRESS: { name: 'ADDRESS', value: 'Address' },
        EMAIL: { name: 'EMAIL', value: 'Email' },
        NAME_IDENTIFIER: { name: 'NAME_IDENTIFIER', value: 'NameIdentifier' },
        PHONE: { name: 'PHONE', value: 'Phone' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    Pe = {
        ADDITIONAL_CFS: {
            columnAbbreviation: 'Additional CFS',
            defaultWidth: 232,
            displayName: 'Additional CFS',
            groupable: !1,
            name: 'ADDITIONAL_CFS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 92,
        },
        AGENCY: {
            columnAbbreviation: 'E. Agency',
            defaultWidth: 110,
            displayName: 'Event Agency',
            groupable: !0,
            name: 'AGENCY',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 30,
        },
        ALARM_LEVEL: {
            columnAbbreviation: 'Alarm Level',
            defaultWidth: 177,
            displayName: 'Alarm Level',
            groupable: !0,
            name: 'ALARM_LEVEL',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 95,
        },
        ALL_UNIT_TYPES_CODE: {
            columnAbbreviation: 'Types',
            defaultWidth: 110,
            displayName: 'Types - All Unit Types Code',
            groupable: !1,
            name: 'ALL_UNIT_TYPES_CODE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 73,
        },
        ALL_UNIT_TYPES_TEXT: {
            columnAbbreviation: 'Types',
            defaultWidth: 177,
            displayName: 'Types - All Unit Types Text',
            groupable: !1,
            name: 'ALL_UNIT_TYPES_TEXT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 74,
        },
        ASSIGNED_STATUS: {
            columnAbbreviation: 'Assigned Status',
            defaultWidth: 232,
            displayName: 'Assigned Status',
            groupable: !0,
            name: 'ASSIGNED_STATUS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT'],
            value: 112,
        },
        ASSIGNED_UNITS: {
            columnAbbreviation: 'Units',
            defaultWidth: 232,
            displayName: 'Assigned Units',
            groupable: !1,
            name: 'ASSIGNED_UNITS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 16,
        },
        AVAILABILITY: {
            columnAbbreviation: 'Av.',
            defaultWidth: 110,
            displayName: 'Availability',
            groupable: !0,
            name: 'AVAILABILITY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 31,
        },
        BEAT: {
            columnAbbreviation: 'E. Beat',
            defaultWidth: 66,
            displayName: 'Event Beat',
            groupable: !0,
            name: 'BEAT',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 62,
        },
        BOLO_ACTIVE_DATE: {
            columnAbbreviation: 'Active Date/Time',
            defaultWidth: 177,
            displayName: 'Active Date/Time',
            groupable: !1,
            name: 'BOLO_ACTIVE_DATE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 84,
        },
        BOLO_CATEGORY: {
            columnAbbreviation: 'Category',
            defaultWidth: 177,
            displayName: 'Bolo Category',
            groupable: !1,
            name: 'BOLO_CATEGORY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 82,
        },
        BOLO_DESCRIPTION: {
            columnAbbreviation: 'Description',
            defaultWidth: 322,
            displayName: 'Description',
            groupable: !1,
            name: 'BOLO_DESCRIPTION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 80,
        },
        BOLO_DISPATCH_AREAS: {
            columnAbbreviation: 'D-Areas',
            defaultWidth: 110,
            displayName: 'Dispatch Areas',
            groupable: !1,
            name: 'BOLO_DISPATCH_AREAS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 87,
        },
        BOLO_EXPIRY_DATE: {
            columnAbbreviation: 'Expiration Date',
            defaultWidth: 177,
            displayName: 'Expiration Date',
            groupable: !1,
            name: 'BOLO_EXPIRY_DATE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 85,
        },
        BOLO_LABELS: {
            columnAbbreviation: 'Labels',
            defaultWidth: 177,
            displayName: 'Labels',
            groupable: !1,
            name: 'BOLO_LABELS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 110,
        },
        BOLO_LAST_UPDATED: {
            columnAbbreviation: 'Last Updated',
            defaultWidth: 177,
            displayName: 'Last Updated',
            groupable: !1,
            name: 'BOLO_LAST_UPDATED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 109,
        },
        BOLO_LOCATION: {
            columnAbbreviation: 'Location',
            defaultWidth: 177,
            displayName: 'Location',
            groupable: !1,
            name: 'BOLO_LOCATION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 88,
        },
        BOLO_LOCATION_DETAILS: {
            columnAbbreviation: 'Loc. Details',
            defaultWidth: 232,
            displayName: 'Location Details',
            groupable: !1,
            name: 'BOLO_LOCATION_DETAILS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 89,
        },
        BOLO_NUMBER: {
            columnAbbreviation: 'BOLO #',
            defaultWidth: 110,
            displayName: 'Bolo Number',
            groupable: !1,
            name: 'BOLO_NUMBER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 79,
        },
        BOLO_ORIGINATING_AGENCY: {
            columnAbbreviation: 'Agency',
            defaultWidth: 177,
            displayName: 'Originating Agency',
            groupable: !1,
            name: 'BOLO_ORIGINATING_AGENCY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 86,
        },
        BOLO_PRIMARY_SUBJECT: {
            columnAbbreviation: 'Primary Subject',
            defaultWidth: 177,
            displayName: 'Primary Subject',
            groupable: !1,
            name: 'BOLO_PRIMARY_SUBJECT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 107,
        },
        BOLO_PRIORITY: {
            columnAbbreviation: 'Priority',
            defaultWidth: 110,
            displayName: 'Bolo Priority',
            groupable: !0,
            name: 'BOLO_PRIORITY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 81,
        },
        BOLO_RELATED_CAD_EVENT_NUMBER: {
            columnAbbreviation: 'Related Event #',
            defaultWidth: 110,
            displayName: 'Related Event Number',
            groupable: !1,
            name: 'BOLO_RELATED_CAD_EVENT_NUMBER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 90,
        },
        BOLO_STATUS: {
            columnAbbreviation: 'Status',
            defaultWidth: 110,
            displayName: 'Bolo Status',
            groupable: !1,
            name: 'BOLO_STATUS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 83,
        },
        BOLO_SUBDIVISIONS: {
            columnAbbreviation: 'Sub Div',
            defaultWidth: 177,
            displayName: 'Subdivisions',
            groupable: !1,
            name: 'BOLO_SUBDIVISIONS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 108,
        },
        BOLO_TYPE: {
            columnAbbreviation: 'Type',
            defaultWidth: 177,
            displayName: 'Bolo Type',
            groupable: !0,
            name: 'BOLO_TYPE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['BOLO'],
            value: 111,
        },
        CALL_SIGN: {
            columnAbbreviation: 'Unit',
            defaultWidth: 110,
            displayName: 'Call Sign',
            groupable: !1,
            name: 'CALL_SIGN',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 28,
        },
        CALL_SIGN_COLOR_CODED: {
            columnAbbreviation: 'Unit',
            defaultWidth: 110,
            displayName: 'Call Sign (Color Coded)',
            groupable: !1,
            name: 'CALL_SIGN_COLOR_CODED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 29,
        },
        CALL_TAKER: {
            columnAbbreviation: 'Call-Taker',
            defaultWidth: 177,
            displayName: 'Call-Taker',
            groupable: !0,
            name: 'CALL_TAKER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 24,
        },
        CFS_NUMBER: {
            columnAbbreviation: 'CFS',
            defaultWidth: 66,
            displayName: 'CFS - Number',
            groupable: !1,
            name: 'CFS_NUMBER',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 6,
        },
        CFS_NUMBER_AND_TEXT: {
            columnAbbreviation: 'CFS',
            defaultWidth: 232,
            displayName: 'CFS',
            groupable: !0,
            name: 'CFS_NUMBER_AND_TEXT',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 5,
        },
        CFS_TEXT: {
            columnAbbreviation: 'CFS',
            defaultWidth: 232,
            displayName: 'CFS - Text',
            groupable: !1,
            name: 'CFS_TEXT',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 7,
        },
        CLASS: {
            columnAbbreviation: 'E. Class',
            defaultWidth: 66,
            displayName: 'Event Class',
            groupable: !0,
            name: 'CLASS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 27,
        },
        CROSS_STREETS: {
            columnAbbreviation: 'Event / Streets',
            defaultWidth: 177,
            displayName: 'Event Cross Streets',
            groupable: !1,
            name: 'CROSS_STREETS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 14,
        },
        DISPATCHER: {
            columnAbbreviation: 'Dispatcher',
            defaultWidth: 177,
            displayName: 'Dispatcher',
            groupable: !0,
            name: 'DISPATCHER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 23,
        },
        DISPATCH_AREA: {
            columnAbbreviation: 'E. D-Area',
            defaultWidth: 66,
            displayName: 'Event Dispatch Area',
            groupable: !0,
            name: 'DISPATCH_AREA',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 11,
        },
        DISPLAY_IN_QUEUE: {
            columnAbbreviation: 'Display In Queue',
            defaultWidth: 177,
            displayName: 'Display In Queue',
            groupable: !1,
            name: 'DISPLAY_IN_QUEUE',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 94,
        },
        DISTANCE_FROM_EVENT: {
            columnAbbreviation: 'Distance',
            defaultWidth: 232,
            displayName: 'Distance',
            groupable: !1,
            name: 'DISTANCE_FROM_EVENT',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !1,
            validEntityTypes: [],
            value: 113,
        },
        EQUIPMENT: {
            columnAbbreviation: 'Equip',
            defaultWidth: 177,
            displayName: 'Equipment',
            groupable: !1,
            name: 'EQUIPMENT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 70,
        },
        EVENT_LABELS: {
            columnAbbreviation: 'Labels',
            defaultWidth: 110,
            displayName: 'Event Labels',
            groupable: !1,
            name: 'EVENT_LABELS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 91,
        },
        EVENT_LOCATION: {
            columnAbbreviation: 'Event Loc.',
            defaultWidth: 177,
            displayName: 'Event Location',
            groupable: !1,
            name: 'EVENT_LOCATION',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 9,
        },
        EVENT_LOCATION_NOTES: {
            columnAbbreviation: 'Loc. Notes',
            defaultWidth: 232,
            displayName: 'Event Location Notes',
            groupable: !1,
            name: 'EVENT_LOCATION_NOTES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 10,
        },
        EVENT_NUMBER: {
            columnAbbreviation: 'Event #',
            defaultWidth: 110,
            displayName: 'Event Number',
            groupable: !1,
            name: 'EVENT_NUMBER',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 2,
        },
        EVENT_NUMBER_LAST_4_DIGITS: {
            columnAbbreviation: 'Event #',
            defaultWidth: 66,
            displayName: 'Event Number (Last 4 Digits)',
            groupable: !1,
            name: 'EVENT_NUMBER_LAST_4_DIGITS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 3,
        },
        EVENT_RADIO_CHANNEL: {
            columnAbbreviation: 'Event Radio',
            defaultWidth: 110,
            displayName: 'Event Radio Channels',
            groupable: !0,
            name: 'EVENT_RADIO_CHANNEL',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 77,
        },
        EVENT_STAFF_COUNT: {
            columnAbbreviation: 'E. Staff Count',
            defaultWidth: 66,
            displayName: 'Event Staff Count',
            groupable: !1,
            name: 'EVENT_STAFF_COUNT',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 100,
        },
        EVENT_STATUS: {
            columnAbbreviation: 'Event Status',
            defaultWidth: 177,
            displayName: 'Event Status',
            groupable: !0,
            name: 'EVENT_STATUS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT'],
            value: 4,
        },
        HOSPITAL_CAPABILITIES: {
            columnAbbreviation: 'Capabilities',
            defaultWidth: 110,
            displayName: 'Hospital Capabilities',
            groupable: !1,
            name: 'HOSPITAL_CAPABILITIES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['HOSPITAL'],
            value: 104,
        },
        HOSPITAL_LOCATION: {
            columnAbbreviation: 'Location',
            defaultWidth: 110,
            displayName: 'Hospital Location',
            groupable: !1,
            name: 'HOSPITAL_LOCATION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['HOSPITAL'],
            value: 103,
        },
        HOSPITAL_NAME: {
            columnAbbreviation: 'Name',
            defaultWidth: 110,
            displayName: 'Hospital Name',
            groupable: !1,
            name: 'HOSPITAL_NAME',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['HOSPITAL'],
            value: 101,
        },
        HOSPITAL_NOTES: {
            columnAbbreviation: 'Notes',
            defaultWidth: 110,
            displayName: 'Hospital Notes',
            groupable: !1,
            name: 'HOSPITAL_NOTES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['HOSPITAL'],
            value: 105,
        },
        HOSPITAL_STATUS: {
            columnAbbreviation: 'Status',
            defaultWidth: 110,
            displayName: 'Hospital Status',
            groupable: !0,
            name: 'HOSPITAL_STATUS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['HOSPITAL'],
            value: 102,
        },
        HOSPITAL_UNITS: {
            columnAbbreviation: 'Units',
            defaultWidth: 110,
            displayName: 'Transport En-Route/Transport Arrived Units',
            groupable: !1,
            name: 'HOSPITAL_UNITS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['HOSPITAL'],
            value: 106,
        },
        MINUTES_IN_STATUS: {
            columnAbbreviation: 'Sta.',
            defaultWidth: 110,
            displayName: 'Time in Status',
            groupable: !1,
            name: 'MINUTES_IN_STATUS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 36,
        },
        MINUTES_STANDING: {
            columnAbbreviation: 'SM.',
            defaultWidth: 66,
            displayName: 'Minutes - Standing Minutes',
            groupable: !1,
            name: 'MINUTES_STANDING',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 21,
        },
        MINUTES_WORKING: {
            columnAbbreviation: 'WM.',
            defaultWidth: 66,
            displayName: 'Minutes - Working Minutes',
            groupable: !1,
            name: 'MINUTES_WORKING',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 22,
        },
        NARRATIVE: {
            columnAbbreviation: 'Narrative',
            defaultWidth: 322,
            displayName: 'Narrative',
            groupable: !1,
            name: 'NARRATIVE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 15,
        },
        NOTES: {
            columnAbbreviation: 'Notes',
            defaultWidth: 322,
            displayName: 'Notes',
            groupable: !1,
            name: 'NOTES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 76,
        },
        PATROL_ADMIN_NOTES: {
            columnAbbreviation: 'Status Notes',
            defaultWidth: 232,
            displayName: 'Status Notes',
            groupable: !1,
            name: 'PATROL_ADMIN_NOTES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 40,
        },
        PATROL_TYPE: {
            columnAbbreviation: 'Patrol Type',
            defaultWidth: 177,
            displayName: 'Patrol Type',
            groupable: !0,
            name: 'PATROL_TYPE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 39,
        },
        PERSONNEL_ABBREVIATED_NAME: {
            columnAbbreviation: 'Personnel',
            defaultWidth: 177,
            displayName: 'Personnel - Abbrev. Name',
            groupable: !1,
            name: 'PERSONNEL_ABBREVIATED_NAME',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 46,
        },
        PERSONNEL_BADGE_NUMBER: {
            columnAbbreviation: 'Badge #',
            defaultWidth: 110,
            displayName: 'Personnel - Badge #',
            groupable: !1,
            name: 'PERSONNEL_BADGE_NUMBER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 78,
        },
        PERSONNEL_FULL_NAME: {
            columnAbbreviation: 'Personnel',
            defaultWidth: 177,
            displayName: 'Personnel - Full Name',
            groupable: !1,
            name: 'PERSONNEL_FULL_NAME',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 45,
        },
        PRIMARY_UNIT_TYPE_CODE: {
            columnAbbreviation: 'Type',
            defaultWidth: 66,
            displayName: 'Type - Primary Unit Type Code',
            groupable: !1,
            name: 'PRIMARY_UNIT_TYPE_CODE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 72,
        },
        PRIORITY: {
            columnAbbreviation: 'Priority',
            defaultWidth: 66,
            displayName: 'Priority',
            groupable: !0,
            name: 'PRIORITY',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 1,
        },
        REPORTING_PARTY: {
            columnAbbreviation: 'Reporting Party',
            defaultWidth: 177,
            displayName: 'Reporting Party',
            groupable: !1,
            name: 'REPORTING_PARTY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 25,
        },
        REPORTING_PARTY_PHONE_NUMBER: {
            columnAbbreviation: 'R. Party Phone #',
            defaultWidth: 177,
            displayName: 'Reporting Party Phone Number',
            groupable: !1,
            name: 'REPORTING_PARTY_PHONE_NUMBER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 26,
        },
        RISK_LEVEL: {
            columnAbbreviation: 'Risk',
            defaultWidth: 66,
            displayName: 'Risk Level',
            groupable: !0,
            name: 'RISK_LEVEL',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['CAD_AGENCY_EVENT'],
            value: 8,
        },
        SCHEDULED_EVENT_NUMBER: {
            columnAbbreviation: 'Sched.',
            defaultWidth: 110,
            displayName: 'Scheduled Event Number',
            groupable: !1,
            name: 'SCHEDULED_EVENT_NUMBER',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 65,
        },
        SCHEDULED_EVENT_NUMBER_LAST_4_DIGITS: {
            columnAbbreviation: 'Sched.',
            defaultWidth: 66,
            displayName: 'Scheduled Event Number (Last 4 Digits)',
            groupable: !1,
            name: 'SCHEDULED_EVENT_NUMBER_LAST_4_DIGITS',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 66,
        },
        SCHEDULED_RECURRING: {
            columnAbbreviation: 'Recurring?',
            defaultWidth: 110,
            displayName: 'Scheduled Recurring',
            groupable: !0,
            name: 'SCHEDULED_RECURRING',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 64,
        },
        SCHEDULED_TIME: {
            columnAbbreviation: 'Scheduled Date/Time',
            defaultWidth: 66,
            displayName: 'Scheduled Time',
            groupable: !1,
            name: 'SCHEDULED_TIME',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 63,
        },
        SHIFT: {
            columnAbbreviation: 'Shift',
            defaultWidth: 110,
            displayName: 'Shift Times',
            groupable: !1,
            name: 'SHIFT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 75,
        },
        SKILLS: {
            columnAbbreviation: 'Skills',
            defaultWidth: 177,
            displayName: 'Skills',
            groupable: !1,
            name: 'SKILLS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 71,
        },
        STATION: {
            columnAbbreviation: 'Station',
            defaultWidth: 110,
            displayName: 'Station',
            groupable: !0,
            name: 'STATION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 61,
        },
        STATUS: {
            columnAbbreviation: 'Status',
            defaultWidth: 110,
            displayName: 'Status',
            groupable: !0,
            name: 'STATUS',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 32,
        },
        STATUS_CODE: {
            columnAbbreviation: 'Sta.',
            defaultWidth: 66,
            displayName: 'Status Code',
            groupable: !1,
            name: 'STATUS_CODE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 34,
        },
        STATUS_CODE_COLOR_CODED: {
            columnAbbreviation: 'Sta.',
            defaultWidth: 66,
            displayName: 'Status Code (Color Coded)',
            groupable: !1,
            name: 'STATUS_CODE_COLOR_CODED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 35,
        },
        STATUS_COLOR_CODED: {
            columnAbbreviation: 'Status',
            defaultWidth: 110,
            displayName: 'Status (Color Coded)',
            groupable: !1,
            name: 'STATUS_COLOR_CODED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 33,
        },
        STATUS_LOCATION: {
            columnAbbreviation: 'Status Loc.',
            defaultWidth: 177,
            displayName: 'Status Location',
            groupable: !1,
            name: 'STATUS_LOCATION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 41,
        },
        TAG_NUMBER: {
            columnAbbreviation: 'Tag #',
            defaultWidth: 110,
            displayName: 'Tag Number',
            groupable: !1,
            name: 'TAG_NUMBER',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 47,
        },
        TARGET_ON_SCENE_TIME: {
            columnAbbreviation: 'Target On Scene Time',
            defaultWidth: 177,
            displayName: 'Target On Scene Time',
            groupable: !1,
            name: 'TARGET_ON_SCENE_TIME',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !0,
            validEntityTypes: ['SCHEDULED_AGENCY_EVENT'],
            value: 93,
        },
        TIME_ARRIVED: {
            columnAbbreviation: 'Arrv.',
            defaultWidth: 66,
            displayName: 'Time Arrived',
            groupable: !1,
            name: 'TIME_ARRIVED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 20,
        },
        TIME_DISPATCHED: {
            columnAbbreviation: 'Disp.',
            defaultWidth: 66,
            displayName: 'Time Dispatched',
            groupable: !1,
            name: 'TIME_DISPATCHED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 19,
        },
        TIME_RECEIVED: {
            columnAbbreviation: 'Recv.',
            defaultWidth: 66,
            displayName: 'Time Received',
            groupable: !1,
            name: 'TIME_RECEIVED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'SCHEDULED_AGENCY_EVENT', 'UNIT'],
            value: 17,
        },
        TIME_SINCE_UNIT_LOCATION_UPDATED: {
            columnAbbreviation: 'Unit',
            defaultWidth: 66,
            displayName: 'Time Since Unit Location Updated',
            groupable: !1,
            name: 'TIME_SINCE_UNIT_LOCATION_UPDATED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 44,
        },
        TIME_TRANSMITTED: {
            columnAbbreviation: 'Trans.',
            defaultWidth: 66,
            displayName: 'Time Transmitted',
            groupable: !1,
            name: 'TIME_TRANSMITTED',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['CAD_AGENCY_EVENT', 'UNIT'],
            value: 18,
        },
        UNIT_AGENCY: {
            columnAbbreviation: 'U. Agency',
            defaultWidth: 110,
            displayName: 'Unit Agency',
            groupable: !0,
            name: 'UNIT_AGENCY',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 97,
        },
        UNIT_BEAT: {
            columnAbbreviation: 'U. Beat',
            defaultWidth: 66,
            displayName: 'Unit Beat',
            groupable: !0,
            name: 'UNIT_BEAT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 98,
        },
        UNIT_CLASS_ICON: {
            columnAbbreviation: 'U. Class',
            defaultWidth: 66,
            displayName: 'Unit Class Icon',
            groupable: !1,
            name: 'UNIT_CLASS_ICON',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 68,
        },
        UNIT_CLASS_TEXT: {
            columnAbbreviation: 'U. Class',
            defaultWidth: 110,
            displayName: 'Unit Class',
            groupable: !0,
            name: 'UNIT_CLASS_TEXT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 69,
        },
        UNIT_DISPATCH_AREA: {
            columnAbbreviation: 'U. D-Area',
            defaultWidth: 66,
            displayName: 'Unit Dispatch Area',
            groupable: !0,
            name: 'UNIT_DISPATCH_AREA',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 67,
        },
        UNIT_IS_ASSISTING: {
            columnAbbreviation: 'Asst.',
            defaultWidth: 66,
            displayName: 'Assisting',
            groupable: !0,
            name: 'UNIT_IS_ASSISTING',
            omitWhenBackupPinnedToPrimary: !0,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 38,
        },
        UNIT_LOCATION: {
            columnAbbreviation: 'Unit Location',
            defaultWidth: 177,
            displayName: 'Unit Location',
            groupable: !1,
            name: 'UNIT_LOCATION',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 42,
        },
        UNIT_LOCATION_NOTES: {
            columnAbbreviation: 'Unit Location Notes',
            defaultWidth: 232,
            displayName: 'Unit Location Notes',
            groupable: !1,
            name: 'UNIT_LOCATION_NOTES',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 43,
        },
        UNIT_STAFF_COUNT: {
            columnAbbreviation: 'U. Staff Count',
            defaultWidth: 66,
            displayName: 'Unit Staff Count',
            groupable: !1,
            name: 'UNIT_STAFF_COUNT',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !1,
            validEntityTypes: ['UNIT'],
            value: 99,
        },
        UNIT_TYPE: {
            columnAbbreviation: 'Type',
            defaultWidth: 110,
            displayName: 'Unit Type',
            groupable: !0,
            name: 'UNIT_TYPE',
            omitWhenBackupPinnedToPrimary: !1,
            searchable: !0,
            validEntityTypes: ['UNIT'],
            value: 37,
        },
    },
    Ue = {
        AGENCY_EVENT_SEARCH_RESYNC: { name: 'AGENCY_EVENT_SEARCH_RESYNC', value: 32 },
        BLACKSMITH: { name: 'BLACKSMITH', value: 6 },
        CAD_TICKET_INTEGRATION_RESYNC: { name: 'CAD_TICKET_INTEGRATION_RESYNC', value: 33 },
        CAD_TICKET_SEARCH_RESYNC: { name: 'CAD_TICKET_SEARCH_RESYNC', value: 45 },
        CASE_SEARCH_RESYNC: { name: 'CASE_SEARCH_RESYNC', value: 29 },
        CASE_TARGET_PROFILE_REVIEW_DUE_TODAY_NOTIFICATION: {
            name: 'CASE_TARGET_PROFILE_REVIEW_DUE_TODAY_NOTIFICATION',
            value: 66,
        },
        CITATION_NUMBERS_CLEANUP: { name: 'CITATION_NUMBERS_CLEANUP', value: 72 },
        DATA_EXCHANGE: { name: 'DATA_EXCHANGE', value: 37 },
        DEACTIVATE_BLOCKED_DISPATCH_AREAS: { name: 'DEACTIVATE_BLOCKED_DISPATCH_AREAS', value: 52 },
        DEPLOYED_BLACKSMITH: { name: 'DEPLOYED_BLACKSMITH', value: 16 },
        DEPLOYED_DATA_EXCHANGE: { name: 'DEPLOYED_DATA_EXCHANGE', value: 38 },
        DISPOSITION_UPDATE: { name: 'DISPOSITION_UPDATE', value: 35 },
        ELASTIC_SEARCH_HEALTH_METRIC: { name: 'ELASTIC_SEARCH_HEALTH_METRIC', value: 74 },
        EVIDENCE_ITEM_SEARCH_RESYNC: { name: 'EVIDENCE_ITEM_SEARCH_RESYNC', value: 39 },
        EVIDENCE_OVERDUE_ITEM_NOTIFICATIONS: {
            name: 'EVIDENCE_OVERDUE_ITEM_NOTIFICATIONS',
            value: 36,
        },
        FACILITY_SEARCH_RESYNC: { name: 'FACILITY_SEARCH_RESYNC', value: 41 },
        FILE_CLEANUP: { name: 'FILE_CLEANUP', value: 12 },
        FILE_SEARCH_RESYNC: { name: 'FILE_SEARCH_RESYNC', value: 51 },
        FLEXIBLE_CASES_BACKFILL: { name: 'FLEXIBLE_CASES_BACKFILL', value: 84 },
        GPS_DATA_DELETION: { name: 'GPS_DATA_DELETION', value: 62 },
        ITEM_PROFILE_SEARCH_RESYNC: { name: 'ITEM_PROFILE_SEARCH_RESYNC', value: 48 },
        MATERIALIZED_USER_ACTION_SEARCH_RESYNC: {
            name: 'MATERIALIZED_USER_ACTION_SEARCH_RESYNC',
            value: 58,
        },
        ORGANIZATION_PROFILE_SEARCH_RESYNC: {
            name: 'ORGANIZATION_PROFILE_SEARCH_RESYNC',
            value: 47,
        },
        PAPERMILL: { name: 'PAPERMILL', value: 11 },
        PERCOLATE_SEARCH: { name: 'PERCOLATE_SEARCH', value: 57 },
        PERSON_PROFILE_SEARCH_RESYNC: { name: 'PERSON_PROFILE_SEARCH_RESYNC', value: 44 },
        POPULATE_CAD_METRICS: { name: 'POPULATE_CAD_METRICS', value: 64 },
        POPULATE_SEARCH_USAGE_STATS: { name: 'POPULATE_SEARCH_USAGE_STATS', value: 56 },
        REDIS_STREAM_MEMORY_JANITOR: { name: 'REDIS_STREAM_MEMORY_JANITOR', value: 70 },
        REPORT_AI_COMPLETED_REPORTS_FOR_EVALUATION: {
            name: 'REPORT_AI_COMPLETED_REPORTS_FOR_EVALUATION',
            value: 71,
        },
        RMS_CDC_EVENTS_FETCH: { name: 'RMS_CDC_EVENTS_FETCH', value: 73 },
        RMS_DATA_INTEGRITY_CHECK: { name: 'RMS_DATA_INTEGRITY_CHECK', value: 13 },
        RMS_E_FILE_MERGE: { name: 'RMS_E_FILE_MERGE', value: 75 },
        RMS_E_FILE_SPLIT: { name: 'RMS_E_FILE_SPLIT', value: 77 },
        RMS_JUVENILE_FLAG_RECONCILE: { name: 'RMS_JUVENILE_FLAG_RECONCILE', value: 85 },
        RMS_MASTER_ENTITY_DELETE_EXPUNGE: { name: 'RMS_MASTER_ENTITY_DELETE_EXPUNGE', value: 79 },
        RMS_NUKE_INVESTIGATED_WITH_LINKS: { name: 'RMS_NUKE_INVESTIGATED_WITH_LINKS', value: 76 },
        RMS_PERCOLATE_SEARCH: { name: 'RMS_PERCOLATE_SEARCH', value: 67 },
        RMS_REINSERT_MASTER_NNLS_FOR_CUMBRIA: {
            name: 'RMS_REINSERT_MASTER_NNLS_FOR_CUMBRIA',
            value: 68,
        },
        SEARCH_CLEANUP: { name: 'SEARCH_CLEANUP', value: 10 },
        SEARCH_DUPLICATE_CANDIDATES: { name: 'SEARCH_DUPLICATE_CANDIDATES', value: 55 },
        SEARCH_RESYNC: { name: 'SEARCH_RESYNC', value: 22 },
        SEARCH_SYNC_CONFIDENCE_METRIC: { name: 'SEARCH_SYNC_CONFIDENCE_METRIC', value: 59 },
        SEARCH_SYNC_THROTTLE_STATE: { name: 'SEARCH_SYNC_THROTTLE_STATE', value: 78 },
        SECRET_EXPIRATION_CHECK: { name: 'SECRET_EXPIRATION_CHECK', value: 69 },
        SECURITY_ALERT_MONITOR: { name: 'SECURITY_ALERT_MONITOR', value: 65 },
        SECURITY_DATA_INTEGRITY_CHECK: { name: 'SECURITY_DATA_INTEGRITY_CHECK', value: 14 },
        SEND_EMAIL_REQUEST: { name: 'SEND_EMAIL_REQUEST', value: 63 },
        STORAGE_LOCATION_SEARCH_RESYNC: { name: 'STORAGE_LOCATION_SEARCH_RESYNC', value: 40 },
        SUBSCRIPTION_DIGEST_NOTIFICATION: { name: 'SUBSCRIPTION_DIGEST_NOTIFICATION', value: 54 },
        SYNC_API_TOKENS_TO_AWS: { name: 'SYNC_API_TOKENS_TO_AWS', value: 61 },
        TASK_DUE_TODAY_NOTIFICATION: { name: 'TASK_DUE_TODAY_NOTIFICATION', value: 53 },
        TASK_SEARCH_RESYNC: { name: 'TASK_SEARCH_RESYNC', value: 43 },
        TEST_COMMAND: { name: 'TEST_COMMAND', value: 1 },
        TEST_COMMAND_HTTPS: { name: 'TEST_COMMAND_HTTPS', value: 2 },
        TEST_DEPARTMENT_COMMAND: { name: 'TEST_DEPARTMENT_COMMAND', value: 15 },
        UNIT_STATUS_SEARCH_RESYNC: { name: 'UNIT_STATUS_SEARCH_RESYNC', value: 31 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER_ACTION_SEARCH_RESYNC: { name: 'USER_ACTION_SEARCH_RESYNC', value: 50 },
        USER_SEARCH_RESYNC: { name: 'USER_SEARCH_RESYNC', value: 46 },
        WARRANT_SEARCH_RESYNC: { name: 'WARRANT_SEARCH_RESYNC', value: 49 },
        WORKFLOW_END_TO_END: { name: 'WORKFLOW_END_TO_END', value: 60 },
    },
    Me = {
        CLEARED: { name: 'CLEARED', value: 21 },
        FAILED: { name: 'FAILED', value: 20 },
        QUEUED: { name: 'QUEUED', value: 1 },
        RUNNING: { name: 'RUNNING', value: 3 },
        STARTING: { name: 'STARTING', value: 2 },
        STOPPING: { name: 'STOPPING', value: 4 },
        SUCCEEDED: { name: 'SUCCEEDED', value: 10 },
        TIMEDOUT: { name: 'TIMEDOUT', value: 5 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ve = {
        FAILED: { name: 'FAILED' },
        GENERATING_FILE: { name: 'GENERATING_FILE' },
        QUEUED: { name: 'QUEUED' },
        SENDING: { name: 'SENDING' },
        SENT: { name: 'SENT' },
    },
    Fe = {
        EQUALS: { name: 'EQUALS', value: 'equals' },
        IN: { name: 'IN', value: 'in' },
        NOT_IN: { name: 'NOT_IN', value: 'not_in' },
        REGEX: { name: 'REGEX', value: 'regex' },
    },
    Ge = {
        ACQUAINTANCE_OF: { name: 'ACQUAINTANCE_OF', value: 37 },
        ADDITIONAL_INFORMATION_IN_AGENCY_EVENT: {
            name: 'ADDITIONAL_INFORMATION_IN_AGENCY_EVENT',
            value: 171,
        },
        ADOPTED_BROTHER_OF: { name: 'ADOPTED_BROTHER_OF', value: 331 },
        ADOPTED_GRANDPARENT_OF: { name: 'ADOPTED_GRANDPARENT_OF', value: 337 },
        ADOPTED_PARENT_OF: { name: 'ADOPTED_PARENT_OF', value: 335 },
        ADOPTED_SISTER_OF: { name: 'ADOPTED_SISTER_OF', value: 332 },
        AGENCY_EVENT_UNLINK: { name: 'AGENCY_EVENT_UNLINK', value: 198 },
        AGENCY_PROFILE_LOGO: { name: 'AGENCY_PROFILE_LOGO', value: 271 },
        ALLEGED_MEMBER_OF_GANG: { name: 'ALLEGED_MEMBER_OF_GANG', value: 135 },
        ARREST_LOCATION: { name: 'ARREST_LOCATION', value: 124 },
        ASSISTING_AGENCY: { name: 'ASSISTING_AGENCY', value: 221 },
        ASSOCIATE_OF: { name: 'ASSOCIATE_OF', value: 17 },
        ASSURED_WITH: { name: 'ASSURED_WITH', value: 338 },
        ATTACHMENT_IN_BRIEFING: { name: 'ATTACHMENT_IN_BRIEFING', value: 291 },
        ATTACHMENT_IN_EFILE: { name: 'ATTACHMENT_IN_EFILE', value: 281 },
        ATTACHMENT_TO_BULLETIN: { name: 'ATTACHMENT_TO_BULLETIN', value: 160 },
        ATTENDED: { name: 'ATTENDED', value: 339 },
        ATTENDS_SCHOOL_AT: { name: 'ATTENDS_SCHOOL_AT', value: 10 },
        AXON_TRANSCRIPT_ATTACHMENT: { name: 'AXON_TRANSCRIPT_ATTACHMENT', value: 379 },
        BABYSITTER_OF: { name: 'BABYSITTER_OF', value: 104 },
        BAILIFF_OF: { name: 'BAILIFF_OF', value: 326 },
        BOLO_ATTACHMENT: { name: 'BOLO_ATTACHMENT', value: 370 },
        BOLO_LOCATION: { name: 'BOLO_LOCATION', value: 253 },
        BOLO_SUBJECT_LOCATION: { name: 'BOLO_SUBJECT_LOCATION', value: 361 },
        BOYFRIEND_GIRLFRIEND: { name: 'BOYFRIEND_GIRLFRIEND', value: 362 },
        BUSINESS_ADDRESS: { name: 'BUSINESS_ADDRESS', value: 110 },
        BUSINESS_BUSINESS: { name: 'BUSINESS_BUSINESS', value: 111 },
        BUSINESS_INTEREST_OF: { name: 'BUSINESS_INTEREST_OF', value: 340 },
        BUSINESS_LOCATION: { name: 'BUSINESS_LOCATION', value: 109 },
        CAD_AGENCY_EVENT_ATTACHMENT: { name: 'CAD_AGENCY_EVENT_ATTACHMENT', value: 369 },
        CALL_FOR_SERVICE_AGENCY_MAPPING: { name: 'CALL_FOR_SERVICE_AGENCY_MAPPING', value: 197 },
        CARETAKER_OF: { name: 'CARETAKER_OF', value: 26 },
        CASCADED_FROM: { name: 'CASCADED_FROM', value: 368 },
        CASE_ATTACHMENT: { name: 'CASE_ATTACHMENT', value: 268 },
        CASE_NOTE_ATTACHMENT: { name: 'CASE_NOTE_ATTACHMENT', value: 49 },
        CASE_NOTE_LOCATION: { name: 'CASE_NOTE_LOCATION', value: 129 },
        CHAIN_EVENT_ATTACHMENT: { name: 'CHAIN_EVENT_ATTACHMENT', value: 220 },
        CHAIN_EVENT_ID_SCAN: { name: 'CHAIN_EVENT_ID_SCAN', value: 181 },
        CHAIN_EVENT_SIGNATURE: { name: 'CHAIN_EVENT_SIGNATURE', value: 180 },
        CHILD_OF: { name: 'CHILD_OF', value: 20 },
        CHILD_OF_BOYFRIEND_OF: { name: 'CHILD_OF_BOYFRIEND_OF', value: 250 },
        CHILD_OF_EX_BOYFRIEND_GIRLFRIEND: { name: 'CHILD_OF_EX_BOYFRIEND_GIRLFRIEND', value: 356 },
        CHILD_OF_GIRLFRIEND_OF: { name: 'CHILD_OF_GIRLFRIEND_OF', value: 251 },
        CHILD_OF_INTIMATE_PARTNER: { name: 'CHILD_OF_INTIMATE_PARTNER', value: 376 },
        CHILD_OF_SIGNIFICANT_OTHER: { name: 'CHILD_OF_SIGNIFICANT_OTHER', value: 98 },
        CLAIMED_BY: { name: 'CLAIMED_BY', value: 113 },
        CLIENT_OF: { name: 'CLIENT_OF', value: 245 },
        COHABITANT_NON_INTIMATE_RELATIONSHIP: {
            name: 'COHABITANT_NON_INTIMATE_RELATIONSHIP',
            value: 293,
        },
        COMMON_LAW_SPOUSE: { name: 'COMMON_LAW_SPOUSE', value: 100 },
        COMPLAINANT_IN_REPORT: { name: 'COMPLAINANT_IN_REPORT', value: 205 },
        CONFIGURED_ENTITY_LOCATION: { name: 'CONFIGURED_ENTITY_LOCATION', value: 285 },
        CONFIGURED_ENTITY_NAME_IN_REPORT: { name: 'CONFIGURED_ENTITY_NAME_IN_REPORT', value: 272 },
        CONFIRMED_MEMBER_OF_GANG: { name: 'CONFIRMED_MEMBER_OF_GANG', value: 136 },
        CONTACT_OF: { name: 'CONTACT_OF', value: 341 },
        CONTRACTED_TO: { name: 'CONTRACTED_TO', value: 342 },
        COPIED_CALL: { name: 'COPIED_CALL', value: 222 },
        COURT_ORDER_ATTACHMENT: { name: 'COURT_ORDER_ATTACHMENT', value: 217 },
        COWORKER_OF: { name: 'COWORKER_OF', value: 21 },
        CO_DEFENDANT: { name: 'CO_DEFENDANT', value: 53 },
        CRIMINAL_ASSOCIATE_OF: { name: 'CRIMINAL_ASSOCIATE_OF', value: 324 },
        DATING_WITH: { name: 'DATING_WITH', value: 287 },
        DEFENDANT: { name: 'DEFENDANT', value: 252 },
        DEFENDANT_IN_ARREST: { name: 'DEFENDANT_IN_ARREST', value: 28 },
        DEFENDANT_IN_EFILE: { name: 'DEFENDANT_IN_EFILE', value: 278 },
        DEPARTMENT_PROFILE_ADDRESS: { name: 'DEPARTMENT_PROFILE_ADDRESS', value: 212 },
        DEPARTMENT_PROFILE_LOGO: { name: 'DEPARTMENT_PROFILE_LOGO', value: 211 },
        DEX_MESSAGE_DISPATCH_AREA_OWNER: { name: 'DEX_MESSAGE_DISPATCH_AREA_OWNER', value: 228 },
        DEX_MESSAGE_SENT_FOR: { name: 'DEX_MESSAGE_SENT_FOR', value: 227 },
        DISPATCH_AREA_MONITOR: { name: 'DISPATCH_AREA_MONITOR', value: 225 },
        DISPATCH_AREA_OWNER_PRIMARY: { name: 'DISPATCH_AREA_OWNER_PRIMARY', value: 224 },
        DRIVERS_LICENSE_PHOTO: { name: 'DRIVERS_LICENSE_PHOTO', value: 275 },
        DRIVER_LICENSE_BACK_PHOTO: { name: 'DRIVER_LICENSE_BACK_PHOTO', value: 256 },
        DRIVER_LICENSE_FRONT_PHOTO: { name: 'DRIVER_LICENSE_FRONT_PHOTO', value: 255 },
        DRUGS_IN_AGENCY_EVENT: { name: 'DRUGS_IN_AGENCY_EVENT', value: 359 },
        EMAIL_EXPORTED_ATTACHMENT: { name: 'EMAIL_EXPORTED_ATTACHMENT', value: 355 },
        EMAIL_EXPORT_RELEASE_ATTACHMENT: { name: 'EMAIL_EXPORT_RELEASE_ATTACHMENT', value: 316 },
        EMPLOYEE: { name: 'EMPLOYEE', value: 2 },
        EMPLOYEE_OF: { name: 'EMPLOYEE_OF', value: 22 },
        ENEMY_OF: { name: 'ENEMY_OF', value: 23 },
        ENGAGED_TO: { name: 'ENGAGED_TO', value: 24 },
        EQUIPPED_ON_UNIT: { name: 'EQUIPPED_ON_UNIT', value: 168 },
        ESTRANGED_SPOUSE_OF: { name: 'ESTRANGED_SPOUSE_OF', value: 241 },
        EVENT_LOCATION: { name: 'EVENT_LOCATION', value: 161 },
        EVIDENCE_FACILITY_LOCATION: { name: 'EVIDENCE_FACILITY_LOCATION', value: 178 },
        EXPORTED_ATTACHMENT: { name: 'EXPORTED_ATTACHMENT', value: 354 },
        EXPORT_RELEASE_ATTACHMENT: { name: 'EXPORT_RELEASE_ATTACHMENT', value: 210 },
        EX_BOYFRIEND_GIRLFRIEND: { name: 'EX_BOYFRIEND_GIRLFRIEND', value: 357 },
        EX_DATING_WITH: { name: 'EX_DATING_WITH', value: 289 },
        EX_EMPLOYEE_OF: { name: 'EX_EMPLOYEE_OF', value: 249 },
        EX_LIVE_IN_WITH: { name: 'EX_LIVE_IN_WITH', value: 288 },
        EX_PARTNER_PARTNERSHIP_NOT_KNOWN: { name: 'EX_PARTNER_PARTNERSHIP_NOT_KNOWN', value: 322 },
        EX_SIGNIFICANT_OTHER_OF: { name: 'EX_SIGNIFICANT_OTHER_OF', value: 32 },
        EX_SPOUSE_OF: { name: 'EX_SPOUSE_OF', value: 105 },
        E_FILE_ARREST_LOCATION: { name: 'E_FILE_ARREST_LOCATION', value: 381 },
        E_FILE_OFFENSE_LOCATION: { name: 'E_FILE_OFFENSE_LOCATION', value: 375 },
        FACTION_SUBSET_OF_GANG: { name: 'FACTION_SUBSET_OF_GANG', value: 137 },
        FEMALE_COHABITANT: { name: 'FEMALE_COHABITANT', value: 266 },
        FEMALE_SEXUAL: { name: 'FEMALE_SEXUAL', value: 267 },
        FIELD_NOTE_ATTACHMENT: { name: 'FIELD_NOTE_ATTACHMENT', value: 213 },
        FIELD_NOTE_ITEM_PROFILE: { name: 'FIELD_NOTE_ITEM_PROFILE', value: 367 },
        FIELD_NOTE_LINKED_LOCATION: { name: 'FIELD_NOTE_LINKED_LOCATION', value: 230 },
        FIELD_NOTE_LINKED_PERSON: { name: 'FIELD_NOTE_LINKED_PERSON', value: 229 },
        FINGERPRINT: { name: 'FINGERPRINT', value: 43 },
        FIREARM_IN_AGENCY_EVENT: { name: 'FIREARM_IN_AGENCY_EVENT', value: 358 },
        FORMER_EMPLOYEE_OF: { name: 'FORMER_EMPLOYEE_OF', value: 343 },
        FORMER_INTIMATE_PARTNER: { name: 'FORMER_INTIMATE_PARTNER', value: 377 },
        FORMER_MEMBER_OF: { name: 'FORMER_MEMBER_OF', value: 344 },
        FOSTER_CHILD: { name: 'FOSTER_CHILD', value: 292 },
        FOSTER_CHILD_OF: { name: 'FOSTER_CHILD_OF', value: 239 },
        FOSTER_SIBLING_OF: { name: 'FOSTER_SIBLING_OF', value: 243 },
        FRIEND_OF: { name: 'FRIEND_OF', value: 25 },
        GANG_MEMBER_WITH: { name: 'GANG_MEMBER_WITH', value: 248 },
        GRANDCHILD_OF: { name: 'GRANDCHILD_OF', value: 101 },
        GUARDIAN_OF: { name: 'GUARDIAN_OF', value: 31 },
        HALF_BROTHER_OF: { name: 'HALF_BROTHER_OF', value: 334 },
        HALF_SISTER_OF: { name: 'HALF_SISTER_OF', value: 333 },
        HANGS_OUT_AT: { name: 'HANGS_OUT_AT', value: 131 },
        HAS_CHILD_WITH: { name: 'HAS_CHILD_WITH', value: 40 },
        HETEROSEXUAL_EX_PARTNER_OF: { name: 'HETEROSEXUAL_EX_PARTNER_OF', value: 320 },
        HETEROSEXUAL_PARTNER_OF: { name: 'HETEROSEXUAL_PARTNER_OF', value: 317 },
        HOMOSEXUAL_COHABITANT: { name: 'HOMOSEXUAL_COHABITANT', value: 263 },
        HOMOSEXUAL_RELATIONSHIP: { name: 'HOMOSEXUAL_RELATIONSHIP', value: 264 },
        HOSPITAL_LOCATION: { name: 'HOSPITAL_LOCATION', value: 353 },
        HTML_EDITOR_IMAGE_BRIEFING_ATTACHMENT: {
            name: 'HTML_EDITOR_IMAGE_BRIEFING_ATTACHMENT',
            value: 283,
        },
        HTML_EDITOR_IMAGE_REPORT_ATTACHMENT: {
            name: 'HTML_EDITOR_IMAGE_REPORT_ATTACHMENT',
            value: 284,
        },
        IDENTIFYING_MARK: { name: 'IDENTIFYING_MARK', value: 127 },
        INSURED_WITH: { name: 'INSURED_WITH', value: 345 },
        INTERSECTING_ROADWAY_OF_TRAFFIC_CRASH: {
            name: 'INTERSECTING_ROADWAY_OF_TRAFFIC_CRASH',
            value: 260,
        },
        INVOLVED_ORG_IN_REPORT: { name: 'INVOLVED_ORG_IN_REPORT', value: 216 },
        INVOLVED_PERSON_IN_AGENCY_EVENT: { name: 'INVOLVED_PERSON_IN_AGENCY_EVENT', value: 269 },
        INVOLVED_PERSON_IN_REPORT: { name: 'INVOLVED_PERSON_IN_REPORT', value: 215 },
        INVOLVED_PERSON_LOCATION: { name: 'INVOLVED_PERSON_LOCATION', value: 270 },
        INVOLVED_PROFILE_IN_EFILE: { name: 'INVOLVED_PROFILE_IN_EFILE', value: 279 },
        INVOLVED_PROPERTY: { name: 'INVOLVED_PROPERTY', value: 11 },
        IN_DISPUTE_WITH: { name: 'IN_DISPUTE_WITH', value: 325 },
        IN_LAW_OF: { name: 'IN_LAW_OF', value: 106 },
        ITEM_IN_EFILE: { name: 'ITEM_IN_EFILE', value: 280 },
        ITEM_PROFILE_ATTACHMENT: { name: 'ITEM_PROFILE_ATTACHMENT', value: 219 },
        ITEM_PROFILE_PHOTO: { name: 'ITEM_PROFILE_PHOTO', value: 218 },
        KEYHOLDER_OF: { name: 'KEYHOLDER_OF', value: 346 },
        LAST_KNOWN_CONTACT_IN_REPORT: { name: 'LAST_KNOWN_CONTACT_IN_REPORT', value: 169 },
        LAST_KNOWN_LOCATION: { name: 'LAST_KNOWN_LOCATION', value: 63 },
        LIVES_AT: { name: 'LIVES_AT', value: 6 },
        LIVES_WITH: { name: 'LIVES_WITH', value: 38 },
        LOCATION_ATTACHMENT: { name: 'LOCATION_ATTACHMENT', value: 371 },
        LOCATION_OF_BEHAVIORAL_CRISIS: { name: 'LOCATION_OF_BEHAVIORAL_CRISIS', value: 234 },
        LOCATION_OF_CAD_TICKET: { name: 'LOCATION_OF_CAD_TICKET', value: 138 },
        LOCATION_OF_CITATION: { name: 'LOCATION_OF_CITATION', value: 208 },
        LOCATION_OF_EVENT: { name: 'LOCATION_OF_EVENT', value: 7 },
        LOCATION_OF_FIELD_CONTACT: { name: 'LOCATION_OF_FIELD_CONTACT', value: 116 },
        LOCATION_OF_PERSON_STOP: { name: 'LOCATION_OF_PERSON_STOP', value: 240 },
        LOCATION_OF_STOP: { name: 'LOCATION_OF_STOP', value: 236 },
        LOCATION_OF_TRAFFIC_CRASH: { name: 'LOCATION_OF_TRAFFIC_CRASH', value: 206 },
        LOCATION_OF_USE_OF_FORCE: { name: 'LOCATION_OF_USE_OF_FORCE', value: 183 },
        LOCATION_OF_WARRANT: { name: 'LOCATION_OF_WARRANT', value: 203 },
        LOCATION_WHERE_LOCATED: { name: 'LOCATION_WHERE_LOCATED', value: 130 },
        LOVER_OF: { name: 'LOVER_OF', value: 27 },
        MEDICAL_PROFESSIONAL_OF: { name: 'MEDICAL_PROFESSIONAL_OF', value: 327 },
        MEMBER_OF: { name: 'MEMBER_OF', value: 347 },
        MEMBER_OF_UNIT: { name: 'MEMBER_OF_UNIT', value: 167 },
        MISSING_PERSON_IN_REPORT: { name: 'MISSING_PERSON_IN_REPORT', value: 13 },
        MUGSHOT: { name: 'MUGSHOT', value: 41 },
        MUGSHOT_LEFT: { name: 'MUGSHOT_LEFT', value: 372 },
        MUGSHOT_RIGHT: { name: 'MUGSHOT_RIGHT', value: 373 },
        NEIGHBOR_OF: { name: 'NEIGHBOR_OF', value: 103 },
        NON_HETEROSEXUAL_EX_PARTNER_OF: { name: 'NON_HETEROSEXUAL_EX_PARTNER_OF', value: 321 },
        NON_HETEROSEXUAL_PARTNER_OF: { name: 'NON_HETEROSEXUAL_PARTNER_OF', value: 318 },
        NON_MARRIED_LIVE_IN: { name: 'NON_MARRIED_LIVE_IN', value: 242 },
        NON_MOTORIST: { name: 'NON_MOTORIST', value: 107 },
        OFFENDER_IN_OFFENSE: { name: 'OFFENDER_IN_OFFENSE', value: 301 },
        OFFENSE_IN_ARREST: { name: 'OFFENSE_IN_ARREST', value: 52 },
        OFFENSE_LOCATION: { name: 'OFFENSE_LOCATION', value: 123 },
        ORGANIZATION_IN_FIELD_CONTACT: { name: 'ORGANIZATION_IN_FIELD_CONTACT', value: 133 },
        ORGANIZATION_PROFILE_ATTACHMENT: { name: 'ORGANIZATION_PROFILE_ATTACHMENT', value: 200 },
        ORGANIZATION_PROFILE_PHOTO: { name: 'ORGANIZATION_PROFILE_PHOTO', value: 235 },
        ORG_INVESTIGATED_WITH: { name: 'ORG_INVESTIGATED_WITH', value: 364 },
        OTHERWISE_KNOWN: { name: 'OTHERWISE_KNOWN', value: 16 },
        OTHER_FAMILY_MEMBER: { name: 'OTHER_FAMILY_MEMBER', value: 378 },
        OTHER_ITEM_IN_AGENCY_EVENT: { name: 'OTHER_ITEM_IN_AGENCY_EVENT', value: 360 },
        OTHER_LOCATION_IN_REPORT: { name: 'OTHER_LOCATION_IN_REPORT', value: 42 },
        OTHER_NAME_IN_BEHAVIORAL_CRISIS: { name: 'OTHER_NAME_IN_BEHAVIORAL_CRISIS', value: 232 },
        OTHER_NAME_IN_FIELD_CONTACT: { name: 'OTHER_NAME_IN_FIELD_CONTACT', value: 233 },
        OTHER_NAME_IN_OFFENSE: { name: 'OTHER_NAME_IN_OFFENSE', value: 71 },
        OTHER_NAME_IN_REPORT: { name: 'OTHER_NAME_IN_REPORT', value: 50 },
        OTHER_NAME_IN_STOP: { name: 'OTHER_NAME_IN_STOP', value: 238 },
        OTHER_SEXUAL_RELATIONSHIP: { name: 'OTHER_SEXUAL_RELATIONSHIP', value: 323 },
        OWNED_BY: { name: 'OWNED_BY', value: 112 },
        OWNER_OF: { name: 'OWNER_OF', value: 348 },
        PARENT_DEX_MESSAGE: { name: 'PARENT_DEX_MESSAGE', value: 294 },
        PARENT_IN_LAW_OF: { name: 'PARENT_IN_LAW_OF', value: 246 },
        PARTNERSHIP_NOT_KNOWN: { name: 'PARTNERSHIP_NOT_KNOWN', value: 319 },
        PATROL_LOCATION: { name: 'PATROL_LOCATION', value: 179 },
        PERSONAL_RELATIONSHIP_WITH: { name: 'PERSONAL_RELATIONSHIP_WITH', value: 328 },
        PERSON_BAIL_LOCATION: { name: 'PERSON_BAIL_LOCATION', value: 302 },
        PERSON_DETAINED_AT_LOCATION: { name: 'PERSON_DETAINED_AT_LOCATION', value: 303 },
        PERSON_DISCHARGE_LOCATION: { name: 'PERSON_DISCHARGE_LOCATION', value: 304 },
        PERSON_FOUND_AT_LOCATION: { name: 'PERSON_FOUND_AT_LOCATION', value: 305 },
        PERSON_FREQUENTS_LOCATION: { name: 'PERSON_FREQUENTS_LOCATION', value: 306 },
        PERSON_HAS_AN_INTEREST_IN_LOCATION: {
            name: 'PERSON_HAS_AN_INTEREST_IN_LOCATION',
            value: 307,
        },
        PERSON_INVESTIGATED_WITH: { name: 'PERSON_INVESTIGATED_WITH', value: 363 },
        PERSON_IN_BOOKING: { name: 'PERSON_IN_BOOKING', value: 380 },
        PERSON_IN_VEHICLE: { name: 'PERSON_IN_VEHICLE', value: 12 },
        PERSON_PLACE_OF_SAFETY_LOCATION: { name: 'PERSON_PLACE_OF_SAFETY_LOCATION', value: 310 },
        PERSON_PROFILE_ATTACHMENT: { name: 'PERSON_PROFILE_ATTACHMENT', value: 199 },
        PERSON_RELATIVES_LOCATION: { name: 'PERSON_RELATIVES_LOCATION', value: 309 },
        PERSON_SAFE_LOCATION: { name: 'PERSON_SAFE_LOCATION', value: 311 },
        PERSON_SEARCHED_AT_LOCATION: { name: 'PERSON_SEARCHED_AT_LOCATION', value: 312 },
        PERSON_SIGHTED_LOCATION: { name: 'PERSON_SIGHTED_LOCATION', value: 308 },
        PERSON_STAYING_AT_LOCATION: { name: 'PERSON_STAYING_AT_LOCATION', value: 313 },
        PERSON_STOPPED_AND_SEARCHED_LOCATION: {
            name: 'PERSON_STOPPED_AND_SEARCHED_LOCATION',
            value: 314,
        },
        PERSON_STOPPED_LOCATION: { name: 'PERSON_STOPPED_LOCATION', value: 315 },
        PHONE_CALL_IN_EVENT: { name: 'PHONE_CALL_IN_EVENT', value: 177 },
        PLAYS_WITH: { name: 'PLAYS_WITH', value: 35 },
        PROPERTY_RECOVERED_LOCATION: { name: 'PROPERTY_RECOVERED_LOCATION', value: 117 },
        RELATED_TO: { name: 'RELATED_TO', value: 29 },
        RELATIONSHIP_TO_ORGANIZATION_UNKNOWN: {
            name: 'RELATIONSHIP_TO_ORGANIZATION_UNKNOWN',
            value: 194,
        },
        RELATIONSHIP_UNKNOWN: { name: 'RELATIONSHIP_UNKNOWN', value: 193 },
        RELATIVE_OF: { name: 'RELATIVE_OF', value: 329 },
        REPORTING_PARTY_IN_AGENCY_EVENT: { name: 'REPORTING_PARTY_IN_AGENCY_EVENT', value: 164 },
        REPORTING_PARTY_IN_REPORT: { name: 'REPORTING_PARTY_IN_REPORT', value: 56 },
        REPORTING_PARTY_LOCATION: { name: 'REPORTING_PARTY_LOCATION', value: 162 },
        REPORT_ATTACHMENT: { name: 'REPORT_ATTACHMENT', value: 126 },
        REPRESENTATIVE_OF: { name: 'REPRESENTATIVE_OF', value: 349 },
        RMS_PERSON_CREATED_FROM_CAD_PERSON: {
            name: 'RMS_PERSON_CREATED_FROM_CAD_PERSON',
            value: 277,
        },
        RMS_VEHICLE_CREATED_FROM_CAD_VEHICLE: {
            name: 'RMS_VEHICLE_CREATED_FROM_CAD_VEHICLE',
            value: 374,
        },
        ROADWAY_OF_TRAFFIC_CRASH: { name: 'ROADWAY_OF_TRAFFIC_CRASH', value: 259 },
        ROADWAY_OF_VEHICLE: { name: 'ROADWAY_OF_VEHICLE', value: 261 },
        ROOMMATE_OF: { name: 'ROOMMATE_OF', value: 286 },
        ROTATION_SERVICE_PROVIDER_LOCATION: {
            name: 'ROTATION_SERVICE_PROVIDER_LOCATION',
            value: 295,
        },
        SCHOOL_ADMINISTRATOR_OF: { name: 'SCHOOL_ADMINISTRATOR_OF', value: 290 },
        SELLS_TO: { name: 'SELLS_TO', value: 36 },
        SIBLING_IN_LAW_OF: { name: 'SIBLING_IN_LAW_OF', value: 247 },
        SIBLING_OF: { name: 'SIBLING_OF', value: 18 },
        SIGNIFICANT_OTHER_OF: { name: 'SIGNIFICANT_OTHER_OF', value: 39 },
        SPECIAL_ASSIGNMENT_LOCATION: { name: 'SPECIAL_ASSIGNMENT_LOCATION', value: 195 },
        SPOUSE_OF: { name: 'SPOUSE_OF', value: 33 },
        STATION_LOCATION: { name: 'STATION_LOCATION', value: 226 },
        STEP_GRANDPARENT_OF: { name: 'STEP_GRANDPARENT_OF', value: 336 },
        STEP_PARENT_OF: { name: 'STEP_PARENT_OF', value: 3 },
        STEP_SIBLING_OF: { name: 'STEP_SIBLING_OF', value: 102 },
        STOLE_IDENTITY_OF: { name: 'STOLE_IDENTITY_OF', value: 19 },
        STRANGER_OF: { name: 'STRANGER_OF', value: 99 },
        STRANGER_TO: { name: 'STRANGER_TO', value: 350 },
        STUDENT_OF: { name: 'STUDENT_OF', value: 244 },
        STUDIED_AT: { name: 'STUDIED_AT', value: 351 },
        STUDIES_AT: { name: 'STUDIES_AT', value: 352 },
        SUBJECT_IN_BEHAVIORAL_CRISIS: { name: 'SUBJECT_IN_BEHAVIORAL_CRISIS', value: 223 },
        SUBJECT_IN_CITATION: { name: 'SUBJECT_IN_CITATION', value: 209 },
        SUBJECT_IN_COMMUNITY_INFORMATION: { name: 'SUBJECT_IN_COMMUNITY_INFORMATION', value: 134 },
        SUBJECT_IN_FIELD_CONTACT: { name: 'SUBJECT_IN_FIELD_CONTACT', value: 114 },
        SUBJECT_IN_OFFENSE: { name: 'SUBJECT_IN_OFFENSE', value: 14 },
        SUBJECT_IN_STOP: { name: 'SUBJECT_IN_STOP', value: 237 },
        SUBJECT_IN_TRAFFIC_CRASH: { name: 'SUBJECT_IN_TRAFFIC_CRASH', value: 207 },
        SUBJECT_IN_USE_OF_FORCE: { name: 'SUBJECT_IN_USE_OF_FORCE', value: 132 },
        SUBJECT_OF_WARRANT: { name: 'SUBJECT_OF_WARRANT', value: 30 },
        SUSPECT_IN_OFFENSE: { name: 'SUSPECT_IN_OFFENSE', value: 5 },
        SUSPECT_IN_REPORT: { name: 'SUSPECT_IN_REPORT', value: 8 },
        TASK_ATTACHMENT: { name: 'TASK_ATTACHMENT', value: 182 },
        THREATENED: { name: 'THREATENED', value: 231 },
        TIED_TO: { name: 'TIED_TO', value: 1 },
        TOW_VEHICLE_FROM_LOCATION: { name: 'TOW_VEHICLE_FROM_LOCATION', value: 175 },
        TOW_VEHICLE_RECOVERY_LOCATION: { name: 'TOW_VEHICLE_RECOVERY_LOCATION', value: 189 },
        TOW_VEHICLE_RELEASE_AUTHORIZED_BY: {
            name: 'TOW_VEHICLE_RELEASE_AUTHORIZED_BY',
            value: 192,
        },
        TOW_VEHICLE_RELEASE_TO: { name: 'TOW_VEHICLE_RELEASE_TO', value: 191 },
        TOW_VEHICLE_REPORTED_STOLEN_LOCATION: {
            name: 'TOW_VEHICLE_REPORTED_STOLEN_LOCATION',
            value: 188,
        },
        TOW_VEHICLE_STORAGE_LOCATION: { name: 'TOW_VEHICLE_STORAGE_LOCATION', value: 190 },
        TOW_VEHICLE_TOWED_FROM_LOCATION: { name: 'TOW_VEHICLE_TOWED_FROM_LOCATION', value: 187 },
        TOW_VEHICLE_TO_LOCATION: { name: 'TOW_VEHICLE_TO_LOCATION', value: 176 },
        TOW_VEHICLE_VEHICLE: { name: 'TOW_VEHICLE_VEHICLE', value: 186 },
        TRAFFIC_CRASH_ATTACHMENT: { name: 'TRAFFIC_CRASH_ATTACHMENT', value: 257 },
        TRAFFIC_CRASH_EXPORT_ATTACHMENT: { name: 'TRAFFIC_CRASH_EXPORT_ATTACHMENT', value: 258 },
        TRANSPORT_LOCATION: { name: 'TRANSPORT_LOCATION', value: 173 },
        TRU_RESPONDER: { name: 'TRU_RESPONDER', value: 170 },
        UNIT_LOCATION_INFO_LOCATION: { name: 'UNIT_LOCATION_INFO_LOCATION', value: 201 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER_ERROR_REPORT_ATTACHMENT: { name: 'USER_ERROR_REPORT_ATTACHMENT', value: 214 },
        USER_HOME_ADDRESS: { name: 'USER_HOME_ADDRESS', value: 184 },
        USER_PHOTO: { name: 'USER_PHOTO', value: 185 },
        USER_PROFILE_ATTACHMENT: { name: 'USER_PROFILE_ATTACHMENT', value: 196 },
        USER_SIGNATURE: { name: 'USER_SIGNATURE', value: 262 },
        USES_PARTICULARS_OF: { name: 'USES_PARTICULARS_OF', value: 330 },
        VEHICLE_ABANDONED_LOCATION: { name: 'VEHICLE_ABANDONED_LOCATION', value: 296 },
        VEHICLE_BURNED_LOCATION: { name: 'VEHICLE_BURNED_LOCATION', value: 297 },
        VEHICLE_IN_AGENCY_EVENT: { name: 'VEHICLE_IN_AGENCY_EVENT', value: 166 },
        VEHICLE_LICENSE_PLATE_PHOTO: { name: 'VEHICLE_LICENSE_PLATE_PHOTO', value: 254 },
        VEHICLE_REGISTERED_LOCATION: { name: 'VEHICLE_REGISTERED_LOCATION', value: 298 },
        VEHICLE_SEEN_LOCATION: { name: 'VEHICLE_SEEN_LOCATION', value: 299 },
        VEHICLE_STOLEN_FROM_LOCATION: { name: 'VEHICLE_STOLEN_FROM_LOCATION', value: 300 },
        VICTIM_IN_OFFENSE: { name: 'VICTIM_IN_OFFENSE', value: 4 },
        VICTIM_IN_REPORT: { name: 'VICTIM_IN_REPORT', value: 125 },
        VULNERABLE_PERSON_IN_REPORT: { name: 'VULNERABLE_PERSON_IN_REPORT', value: 274 },
        WARRANT_ATTACHMENT: { name: 'WARRANT_ATTACHMENT', value: 202 },
        WIFE: { name: 'WIFE', value: 265 },
        WITNESS_IN_OFFENSE: { name: 'WITNESS_IN_OFFENSE', value: 15 },
        WITNESS_IN_REPORT: { name: 'WITNESS_IN_REPORT', value: 108 },
        WORKS_AT: { name: 'WORKS_AT', value: 9 },
    },
    He = {
        ATTRIBUTE_MAPPED_TO_MULTIPLE_CODES: { name: 'ATTRIBUTE_MAPPED_TO_MULTIPLE_CODES' },
        ATTRIBUTE_MISSING_CODE_TYPE_MAPPING: { name: 'ATTRIBUTE_MISSING_CODE_TYPE_MAPPING' },
    },
    Ye = {
        ASSEMBLING: { name: 'ASSEMBLING', value: 'ASSEMBLING' },
        LOADING_SEGMENTS: { name: 'LOADING_SEGMENTS', value: 'LOADING_SEGMENTS' },
        REGENERATING: { name: 'REGENERATING', value: 'REGENERATING' },
        UPLOADING: { name: 'UPLOADING', value: 'UPLOADING' },
    },
    te = {
        CALIFORNIA_DOMESTIC_VIOLENCE: { name: 'CALIFORNIA_DOMESTIC_VIOLENCE', value: 1 },
        CALIFORNIA_RIPA: { name: 'CALIFORNIA_RIPA', value: 2 },
        GEORGIA_DOMESTIC_VIOLENCE: { name: 'GEORGIA_DOMESTIC_VIOLENCE', value: 4 },
        M43_FORMS_TEXT_EXPORT: { name: 'M43_FORMS_TEXT_EXPORT', value: 7 },
        PENNSYLVANIA_USE_OF_FORCE: { name: 'PENNSYLVANIA_USE_OF_FORCE', value: 5 },
        US_DOI_CVB: { name: 'US_DOI_CVB', value: 6 },
        US_USE_OF_FORCE: { name: 'US_USE_OF_FORCE', value: 3 },
    },
    Ve = {
        ILLEGAL_NOT_CONSECUTIVE: {
            name: 'ILLEGAL_NOT_CONSECUTIVE',
            value: 'Request for final export skipped month(s).',
        },
        ILLEGAL_NOT_RECENT: {
            name: 'ILLEGAL_NOT_RECENT',
            value: 'There is a final export for the subsequent month.',
        },
        LEGAL_FIRST_EXPORT: {
            name: 'LEGAL_FIRST_EXPORT',
            value: 'Final export for this month does not exist.',
        },
        LEGAL_OVERWRITE: {
            name: 'LEGAL_OVERWRITE',
            value: 'Final export for the month exists and it is the most recent month.',
        },
    },
    oe = {
        CALIFORNIA: { name: 'CALIFORNIA', value: 1 },
        GEORGIA: { name: 'GEORGIA', value: 4 },
        PENNSYLVANIA: { name: 'PENNSYLVANIA', value: 5 },
        UNITED_KINGDOM: { name: 'UNITED_KINGDOM', value: 6 },
        UNITED_STATES: { name: 'UNITED_STATES', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        US_DOI: { name: 'US_DOI', value: 7 },
        WASHINGTON_DC: { name: 'WASHINGTON_DC', value: 2 },
    },
    Be = {
        CARD: { name: 'CARD', value: 2 },
        ROOT: { name: 'ROOT', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    re = { ERROR: { name: 'ERROR' }, SUCCESS: { name: 'SUCCESS' }, WARNING: { name: 'WARNING' } },
    se = {
        INVESTIGATION: { name: 'INVESTIGATION', value: 'Investigation' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    ie = {
        GLOBAL: { name: 'GLOBAL', value: 1 },
        READ_SCOPE: { name: 'READ_SCOPE', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    We = {
        ELEMENT_ERROR_MESSAGE: { name: 'ELEMENT_ERROR_MESSAGE', value: 1 },
        HIDE_ELEMENT: { name: 'HIDE_ELEMENT', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ce = {
        LABEL_OF: { name: 'LABEL_OF', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VALUE_OF: { name: 'VALUE_OF', value: 2 },
    },
    Ke = {
        AND: { name: 'AND', value: 5 },
        EACH_AND: { name: 'EACH_AND', value: 15 },
        EACH_AND_READ_SCOPE: { name: 'EACH_AND_READ_SCOPE', value: 18 },
        EACH_OR: { name: 'EACH_OR', value: 14 },
        EACH_OR_READ_SCOPE: { name: 'EACH_OR_READ_SCOPE', value: 17 },
        FIRST: { name: 'FIRST', value: 13 },
        FORM_VALUE_OF: { name: 'FORM_VALUE_OF', value: 1 },
        IN: { name: 'IN', value: 4 },
        IN_LIST: { name: 'IN_LIST', value: 19 },
        IS_EMPTY: { name: 'IS_EMPTY', value: 9 },
        IS_EQUAL: { name: 'IS_EQUAL', value: 8 },
        IS_INTEGER: { name: 'IS_INTEGER', value: 12 },
        IS_LESS_THAN: { name: 'IS_LESS_THAN', value: 20 },
        IS_NUMBER: { name: 'IS_NUMBER', value: 11 },
        LENGTH: { name: 'LENGTH', value: 10 },
        NOT: { name: 'NOT', value: 3 },
        OR: { name: 'OR', value: 6 },
        RUN_EFFECT: { name: 'RUN_EFFECT', value: 16 },
        STATIC_VALUE_OF: { name: 'STATIC_VALUE_OF', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        XOR: { name: 'XOR', value: 7 },
    },
    de = {
        ANY_LIST: { name: 'ANY_LIST', value: 2 },
        BOOLEAN: { name: 'BOOLEAN', value: 3 },
        BOOLEAN_LIST: { name: 'BOOLEAN_LIST', value: 4 },
        DATE: { name: 'DATE', value: 9 },
        DATE_LIST: { name: 'DATE_LIST', value: 10 },
        INFERRED: { name: 'INFERRED', value: 1 },
        INSTANCE: { name: 'INSTANCE', value: 13 },
        NUMBER: { name: 'NUMBER', value: 7 },
        NUMBER_LIST: { name: 'NUMBER_LIST', value: 8 },
        OBJECT: { name: 'OBJECT', value: 11 },
        OBJECT_LIST: { name: 'OBJECT_LIST', value: 12 },
        STRING: { name: 'STRING', value: 5 },
        STRING_LIST: { name: 'STRING_LIST', value: 6 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    pe = {
        COULD_NOT_EVALUATE: { name: 'COULD_NOT_EVALUATE', value: 3 },
        FAILURE: { name: 'FAILURE', value: 2 },
        SUCCESS: { name: 'SUCCESS', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ye = {
        DEGRADED: { name: 'DEGRADED' },
        OFFLINE: { name: 'OFFLINE' },
        ONLINE: { name: 'ONLINE' },
    },
    Xe = {
        DNS_RESOLUTION: { name: 'DNS_RESOLUTION' },
        FARO: { name: 'FARO' },
        INTERNET: { name: 'INTERNET' },
        MARK43_PING: { name: 'MARK43_PING' },
        SOCKET: { name: 'SOCKET' },
    },
    Qe = { BAREBONES: { name: 'BAREBONES' }, STANDARD: { name: 'STANDARD' } },
    be = {
        ELECTRONIC: { name: 'ELECTRONIC', value: 'Electronic' },
        FACE_TO_FACE: { name: 'FACE_TO_FACE', value: 'Face to Face' },
        TELEPHONE_CPS_DIRECT_: { name: 'TELEPHONE_CPS_DIRECT_', value: 'Telephone (CPS Direct)' },
        TELEPHONE_DAYTIME_DIRECT_: {
            name: 'TELEPHONE_DAYTIME_DIRECT_',
            value: 'Telephone (Daytime Direct)',
        },
        WRITTEN: { name: 'WRITTEN', value: 'Written' },
    },
    fe = {
        FORM: { name: 'FORM', value: 1 },
        REPORT: { name: 'REPORT', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ge = {
        ALL_DISPATCH: { name: 'ALL_DISPATCH', value: 2 },
        ALL_RESPONDERS: { name: 'ALL_RESPONDERS', value: 3 },
        CALL_TAKER_STATION: { name: 'CALL_TAKER_STATION', value: 151 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 115 },
        DISPATCH_AREA_RESPONDERS: { name: 'DISPATCH_AREA_RESPONDERS', value: 1 },
        MESSAGE_GROUP: { name: 'MESSAGE_GROUP', value: 126 },
        UNIT: { name: 'UNIT', value: 44 },
        USER: { name: 'USER', value: 19 },
    },
    Je = {
        CALL_TAKER_STATION: { name: 'CALL_TAKER_STATION', value: 151 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 115 },
        DISPATCH_AREA_RESPONDERS: { name: 'DISPATCH_AREA_RESPONDERS', value: 1 },
        UNIT: { name: 'UNIT', value: 44 },
        USER: { name: 'USER', value: 19 },
    },
    he = { ACTIVE: { name: 'ACTIVE', value: 1 }, ARCHIVED: { name: 'ARCHIVED', value: 2 } },
    Ze = {
        AGENCY_PROFILE: { name: 'AGENCY_PROFILE', value: 30 },
        APPROVAL_LEVEL: { name: 'APPROVAL_LEVEL', value: 14 },
        APPROVAL_STATUS: { name: 'APPROVAL_STATUS', value: 15 },
        ARREST: { name: 'ARREST', value: 54 },
        ATF_MANUFACTURER: { name: 'ATF_MANUFACTURER', value: 61 },
        ATTRIBUTE: { name: 'ATTRIBUTE', value: 8 },
        ATTRIBUTE_TYPE: { name: 'ATTRIBUTE_TYPE', value: 7 },
        CHARGE: { name: 'CHARGE', value: 56 },
        CODE_TYPE_SOURCE: { name: 'CODE_TYPE_SOURCE', value: 3 },
        COMPLIANCE_GROUP: { name: 'COMPLIANCE_GROUP', value: 32 },
        COURT: { name: 'COURT', value: 57 },
        CRASH_DETAIL: { name: 'CRASH_DETAIL', value: 66 },
        CRASH_LOCATION: { name: 'CRASH_LOCATION', value: 67 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 21 },
        DEPARTMENT_AGENCY: { name: 'DEPARTMENT_AGENCY', value: 19 },
        DEPARTMENT_LOCAL_TYPE: { name: 'DEPARTMENT_LOCAL_TYPE', value: 1 },
        DEPARTMENT_PROFILE: { name: 'DEPARTMENT_PROFILE', value: 9 },
        DEPARTMENT_STATUS: { name: 'DEPARTMENT_STATUS', value: 11 },
        DEX_REGION: { name: 'DEX_REGION', value: 5 },
        ENTITY_TYPE: { name: 'ENTITY_TYPE', value: 26 },
        EXPORT_INTERVAL_TYPE: { name: 'EXPORT_INTERVAL_TYPE', value: 65 },
        FILE: { name: 'FILE', value: 64 },
        FILE_STATUS: { name: 'FILE_STATUS', value: 62 },
        FILE_TYPE: { name: 'FILE_TYPE', value: 63 },
        FIREARM: { name: 'FIREARM', value: 53 },
        ID_FORMAT_CONFIGURATION: { name: 'ID_FORMAT_CONFIGURATION', value: 31 },
        ITEM_INVOLVEMENT_TYPE: { name: 'ITEM_INVOLVEMENT_TYPE', value: 38 },
        ITEM_PROFILE: { name: 'ITEM_PROFILE', value: 51 },
        LINK_TYPES: { name: 'LINK_TYPES', value: 47 },
        LOCATION: { name: 'LOCATION', value: 59 },
        LOCATION_ENTITY_LINK: { name: 'LOCATION_ENTITY_LINK', value: 60 },
        LOCATION_SOURCE: { name: 'LOCATION_SOURCE', value: 58 },
        MEASUREMENT_SYSTEM: { name: 'MEASUREMENT_SYSTEM', value: 43 },
        NAME_REPORT_LINK: { name: 'NAME_REPORT_LINK', value: 48 },
        NIBRS_CRIME_AGAINST_CATEGORY: { name: 'NIBRS_CRIME_AGAINST_CATEGORY', value: 36 },
        NIBRS_FLAG: { name: 'NIBRS_FLAG', value: 34 },
        NIBRS_OFFENSE_CODE: { name: 'NIBRS_OFFENSE_CODE', value: 37 },
        NIBRS_OFFENSE_GROUP: { name: 'NIBRS_OFFENSE_GROUP', value: 35 },
        OFFENSE: { name: 'OFFENSE', value: 44 },
        OFFENSE_CODE: { name: 'OFFENSE_CODE', value: 42 },
        ORGANIZATION_PROFILE: { name: 'ORGANIZATION_PROFILE', value: 45 },
        PERSON_PROFILE: { name: 'PERSON_PROFILE', value: 46 },
        PERSON_SEARCH_RESULTS_DEFAULT: { name: 'PERSON_SEARCH_RESULTS_DEFAULT', value: 4 },
        REGIONAL_GROUP: { name: 'REGIONAL_GROUP', value: 2 },
        REN_CONFIGURATION: { name: 'REN_CONFIGURATION', value: 23 },
        REPORT: { name: 'REPORT', value: 27 },
        REPORTING_EVENT: { name: 'REPORTING_EVENT', value: 28 },
        REPORT_DEFINITION: { name: 'REPORT_DEFINITION', value: 29 },
        REPORT_HISTORY_VISIBILITY_LEVEL: { name: 'REPORT_HISTORY_VISIBILITY_LEVEL', value: 22 },
        REPORT_TITLE_FORMAT: { name: 'REPORT_TITLE_FORMAT', value: 25 },
        ROLE: { name: 'ROLE', value: 18 },
        ROLE_TYPE: { name: 'ROLE_TYPE', value: 13 },
        STATE_PLANE_ZONE: { name: 'STATE_PLANE_ZONE', value: 6 },
        SUFFIX_TYPE: { name: 'SUFFIX_TYPE', value: 24 },
        TWO_FACTOR_METHOD: { name: 'TWO_FACTOR_METHOD', value: 12 },
        UCR_CATEGORY: { name: 'UCR_CATEGORY', value: 39 },
        UCR_SUMMARY_CODE: { name: 'UCR_SUMMARY_CODE', value: 41 },
        UCR_SUMMARY_OFFENSE_PART: { name: 'UCR_SUMMARY_OFFENSE_PART', value: 40 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 20 },
        USER_ACCOUNT: { name: 'USER_ACCOUNT', value: 17 },
        USER_GROUP: { name: 'USER_GROUP', value: 10 },
        USER_PROFILE: { name: 'USER_PROFILE', value: 16 },
        USE_OF_FORCE: { name: 'USE_OF_FORCE', value: 33 },
        VEHICLE: { name: 'VEHICLE', value: 52 },
        VEHICLE_MAKE: { name: 'VEHICLE_MAKE', value: 49 },
        VEHICLE_MODEL: { name: 'VEHICLE_MODEL', value: 50 },
        WARRANT: { name: 'WARRANT', value: 55 },
    },
    je = { CIVICA: { name: 'CIVICA' }, WPC: { name: 'WPC' } },
    xe = {
        AC: { name: 'AC' },
        AD: { name: 'AD' },
        AE: { name: 'AE' },
        AF: { name: 'AF' },
        AG: { name: 'AG' },
        AI: { name: 'AI' },
        AL: { name: 'AL' },
        AM: { name: 'AM' },
        AN: { name: 'AN' },
        AO: { name: 'AO' },
        AQ: { name: 'AQ' },
        AR: { name: 'AR' },
        AS: { name: 'AS' },
        AT: { name: 'AT' },
        AU: { name: 'AU' },
        AW: { name: 'AW' },
        AX: { name: 'AX' },
        AZ: { name: 'AZ' },
        BA: { name: 'BA' },
        BB: { name: 'BB' },
        BD: { name: 'BD' },
        BE: { name: 'BE' },
        BF: { name: 'BF' },
        BG: { name: 'BG' },
        BH: { name: 'BH' },
        BI: { name: 'BI' },
        BJ: { name: 'BJ' },
        BL: { name: 'BL' },
        BM: { name: 'BM' },
        BN: { name: 'BN' },
        BO: { name: 'BO' },
        BQ: { name: 'BQ' },
        BR: { name: 'BR' },
        BS: { name: 'BS' },
        BT: { name: 'BT' },
        BU: { name: 'BU' },
        BV: { name: 'BV' },
        BW: { name: 'BW' },
        BY: { name: 'BY' },
        BZ: { name: 'BZ' },
        CA: { name: 'CA' },
        CC: { name: 'CC' },
        CD: { name: 'CD' },
        CF: { name: 'CF' },
        CG: { name: 'CG' },
        CH: { name: 'CH' },
        CI: { name: 'CI' },
        CK: { name: 'CK' },
        CL: { name: 'CL' },
        CM: { name: 'CM' },
        CN: { name: 'CN' },
        CO: { name: 'CO' },
        CP: { name: 'CP' },
        CR: { name: 'CR' },
        CS: { name: 'CS' },
        CU: { name: 'CU' },
        CV: { name: 'CV' },
        CW: { name: 'CW' },
        CX: { name: 'CX' },
        CY: { name: 'CY' },
        CZ: { name: 'CZ' },
        DE: { name: 'DE' },
        DG: { name: 'DG' },
        DJ: { name: 'DJ' },
        DK: { name: 'DK' },
        DM: { name: 'DM' },
        DO: { name: 'DO' },
        DZ: { name: 'DZ' },
        EA: { name: 'EA' },
        EC: { name: 'EC' },
        EE: { name: 'EE' },
        EG: { name: 'EG' },
        EH: { name: 'EH' },
        ER: { name: 'ER' },
        ES: { name: 'ES' },
        ET: { name: 'ET' },
        EU: { name: 'EU' },
        EZ: { name: 'EZ' },
        FI: { name: 'FI' },
        FJ: { name: 'FJ' },
        FK: { name: 'FK' },
        FM: { name: 'FM' },
        FO: { name: 'FO' },
        FR: { name: 'FR' },
        FX: { name: 'FX' },
        GA: { name: 'GA' },
        GB: { name: 'GB' },
        GD: { name: 'GD' },
        GE: { name: 'GE' },
        GF: { name: 'GF' },
        GG: { name: 'GG' },
        GH: { name: 'GH' },
        GI: { name: 'GI' },
        GL: { name: 'GL' },
        GM: { name: 'GM' },
        GN: { name: 'GN' },
        GP: { name: 'GP' },
        GQ: { name: 'GQ' },
        GR: { name: 'GR' },
        GS: { name: 'GS' },
        GT: { name: 'GT' },
        GU: { name: 'GU' },
        GW: { name: 'GW' },
        GY: { name: 'GY' },
        HK: { name: 'HK' },
        HM: { name: 'HM' },
        HN: { name: 'HN' },
        HR: { name: 'HR' },
        HT: { name: 'HT' },
        HU: { name: 'HU' },
        IC: { name: 'IC' },
        ID: { name: 'ID' },
        IE: { name: 'IE' },
        IL: { name: 'IL' },
        IM: { name: 'IM' },
        IN: { name: 'IN' },
        IO: { name: 'IO' },
        IQ: { name: 'IQ' },
        IR: { name: 'IR' },
        IS: { name: 'IS' },
        IT: { name: 'IT' },
        JE: { name: 'JE' },
        JM: { name: 'JM' },
        JO: { name: 'JO' },
        JP: { name: 'JP' },
        KE: { name: 'KE' },
        KG: { name: 'KG' },
        KH: { name: 'KH' },
        KI: { name: 'KI' },
        KM: { name: 'KM' },
        KN: { name: 'KN' },
        KP: { name: 'KP' },
        KR: { name: 'KR' },
        KW: { name: 'KW' },
        KY: { name: 'KY' },
        KZ: { name: 'KZ' },
        LA: { name: 'LA' },
        LB: { name: 'LB' },
        LC: { name: 'LC' },
        LI: { name: 'LI' },
        LK: { name: 'LK' },
        LR: { name: 'LR' },
        LS: { name: 'LS' },
        LT: { name: 'LT' },
        LU: { name: 'LU' },
        LV: { name: 'LV' },
        LY: { name: 'LY' },
        MA: { name: 'MA' },
        MC: { name: 'MC' },
        MD: { name: 'MD' },
        ME: { name: 'ME' },
        MF: { name: 'MF' },
        MG: { name: 'MG' },
        MH: { name: 'MH' },
        MK: { name: 'MK' },
        ML: { name: 'ML' },
        MM: { name: 'MM' },
        MN: { name: 'MN' },
        MO: { name: 'MO' },
        MP: { name: 'MP' },
        MQ: { name: 'MQ' },
        MR: { name: 'MR' },
        MS: { name: 'MS' },
        MT: { name: 'MT' },
        MU: { name: 'MU' },
        MV: { name: 'MV' },
        MW: { name: 'MW' },
        MX: { name: 'MX' },
        MY: { name: 'MY' },
        MZ: { name: 'MZ' },
        NA: { name: 'NA' },
        NC: { name: 'NC' },
        NE: { name: 'NE' },
        NF: { name: 'NF' },
        NG: { name: 'NG' },
        NI: { name: 'NI' },
        NL: { name: 'NL' },
        NO: { name: 'NO' },
        NP: { name: 'NP' },
        NR: { name: 'NR' },
        NT: { name: 'NT' },
        NU: { name: 'NU' },
        NZ: { name: 'NZ' },
        OM: { name: 'OM' },
        PA: { name: 'PA' },
        PE: { name: 'PE' },
        PF: { name: 'PF' },
        PG: { name: 'PG' },
        PH: { name: 'PH' },
        PK: { name: 'PK' },
        PL: { name: 'PL' },
        PM: { name: 'PM' },
        PN: { name: 'PN' },
        PR: { name: 'PR' },
        PS: { name: 'PS' },
        PT: { name: 'PT' },
        PW: { name: 'PW' },
        PY: { name: 'PY' },
        QA: { name: 'QA' },
        RE: { name: 'RE' },
        RO: { name: 'RO' },
        RS: { name: 'RS' },
        RU: { name: 'RU' },
        RW: { name: 'RW' },
        SA: { name: 'SA' },
        SB: { name: 'SB' },
        SC: { name: 'SC' },
        SD: { name: 'SD' },
        SE: { name: 'SE' },
        SF: { name: 'SF' },
        SG: { name: 'SG' },
        SH: { name: 'SH' },
        SI: { name: 'SI' },
        SJ: { name: 'SJ' },
        SK: { name: 'SK' },
        SL: { name: 'SL' },
        SM: { name: 'SM' },
        SN: { name: 'SN' },
        SO: { name: 'SO' },
        SR: { name: 'SR' },
        SS: { name: 'SS' },
        ST: { name: 'ST' },
        SU: { name: 'SU' },
        SV: { name: 'SV' },
        SX: { name: 'SX' },
        SY: { name: 'SY' },
        SZ: { name: 'SZ' },
        TA: { name: 'TA' },
        TC: { name: 'TC' },
        TD: { name: 'TD' },
        TF: { name: 'TF' },
        TG: { name: 'TG' },
        TH: { name: 'TH' },
        TJ: { name: 'TJ' },
        TK: { name: 'TK' },
        TL: { name: 'TL' },
        TM: { name: 'TM' },
        TN: { name: 'TN' },
        TO: { name: 'TO' },
        TP: { name: 'TP' },
        TR: { name: 'TR' },
        TT: { name: 'TT' },
        TV: { name: 'TV' },
        TW: { name: 'TW' },
        TZ: { name: 'TZ' },
        UA: { name: 'UA' },
        UG: { name: 'UG' },
        UK: { name: 'UK' },
        UM: { name: 'UM' },
        UNDEFINED: { name: 'UNDEFINED' },
        US: { name: 'US' },
        UY: { name: 'UY' },
        UZ: { name: 'UZ' },
        VA: { name: 'VA' },
        VC: { name: 'VC' },
        VE: { name: 'VE' },
        VG: { name: 'VG' },
        VI: { name: 'VI' },
        VN: { name: 'VN' },
        VU: { name: 'VU' },
        WF: { name: 'WF' },
        WS: { name: 'WS' },
        XI: { name: 'XI' },
        XK: { name: 'XK' },
        XU: { name: 'XU' },
        YE: { name: 'YE' },
        YT: { name: 'YT' },
        YU: { name: 'YU' },
        ZA: { name: 'ZA' },
        ZM: { name: 'ZM' },
        ZR: { name: 'ZR' },
        ZW: { name: 'ZW' },
    },
    ke = { CHARGE: { name: 'CHARGE', value: 1 }, SUMMONS: { name: 'SUMMONS', value: 2 } },
    we = {
        APP: { name: 'APP', value: 3 },
        FIN: { name: 'FIN', value: 1 },
        LIV: { name: 'LIV', value: 2 },
        MON: { name: 'MON', value: 4 },
    },
    ze = { BLOCK: { name: 'BLOCK' }, FULL: { name: 'FULL' } },
    qe = {
        LEFT_SIDEBAR: { name: 'LEFT_SIDEBAR', value: 1 },
        RIGHT_CARDS: { name: 'RIGHT_CARDS', value: 2 },
    },
    $e = {
        ACTION_REQUIRED_REPORTS: { name: 'ACTION_REQUIRED_REPORTS', value: 1 },
        EXTERNAL_LINKS: { name: 'EXTERNAL_LINKS', value: 4 },
        INSIGHTS: { name: 'INSIGHTS', value: 15 },
        ITEMS_PENDING_REVIEW: { name: 'ITEMS_PENDING_REVIEW', value: 8 },
        MY_BRIEFINGS: { name: 'MY_BRIEFINGS', value: 13 },
        MY_CAD_EVENTS: { name: 'MY_CAD_EVENTS', value: 7 },
        MY_CASES: { name: 'MY_CASES', value: 10 },
        MY_TASKS: { name: 'MY_TASKS', value: 9 },
        MY_WARRANTS: { name: 'MY_WARRANTS', value: 12 },
        RECENTLY_VIEWED: { name: 'RECENTLY_VIEWED', value: 3 },
        RECENT_ALERTS: { name: 'RECENT_ALERTS', value: 6 },
        RECENT_ARRESTS: { name: 'RECENT_ARRESTS', value: 2 },
        RECENT_SAVED_SEARCHES: { name: 'RECENT_SAVED_SEARCHES', value: 5 },
        RECENT_WARRANTS: { name: 'RECENT_WARRANTS', value: 11 },
        TARGET_PROFILES: { name: 'TARGET_PROFILES', value: 14 },
    },
    EA = {
        QUERY_DRIVER_HISTORY_BY_LICENSE_COMMAND: {
            name: 'QUERY_DRIVER_HISTORY_BY_LICENSE_COMMAND',
            value: 16,
        },
        QUERY_DRIVER_HISTORY_BY_NAME_COMMAND: {
            name: 'QUERY_DRIVER_HISTORY_BY_NAME_COMMAND',
            value: 15,
        },
        QUERY_DRIVER_LICENSE_COMMAND: { name: 'QUERY_DRIVER_LICENSE_COMMAND', value: 3 },
        QUERY_DRIVER_LICENSE_PURPOSE_CODE_AND_ATTENTION_COMMAND: {
            name: 'QUERY_DRIVER_LICENSE_PURPOSE_CODE_AND_ATTENTION_COMMAND',
            value: 19,
        },
        QUERY_DRIVER_LICENSE_PURPOSE_CODE_COMMAND: {
            name: 'QUERY_DRIVER_LICENSE_PURPOSE_CODE_COMMAND',
            value: 10,
        },
        QUERY_GUN_SERIAL_COMMAND: { name: 'QUERY_GUN_SERIAL_COMMAND', value: 5 },
        QUERY_GUN_SERIAL_PURPOSE_CODE_COMMAND: {
            name: 'QUERY_GUN_SERIAL_PURPOSE_CODE_COMMAND',
            value: 12,
        },
        QUERY_LOJACK_COMMAND: { name: 'QUERY_LOJACK_COMMAND', value: 7 },
        QUERY_LOJACK_PURPOSE_CODE_COMMAND: { name: 'QUERY_LOJACK_PURPOSE_CODE_COMMAND', value: 14 },
        QUERY_PERSON_NAME_COMMAND: { name: 'QUERY_PERSON_NAME_COMMAND', value: 4 },
        QUERY_PERSON_NAME_PURPOSE_CODE_AND_ATTENTION_COMMAND: {
            name: 'QUERY_PERSON_NAME_PURPOSE_CODE_AND_ATTENTION_COMMAND',
            value: 18,
        },
        QUERY_PERSON_NAME_PURPOSE_CODE_COMMAND: {
            name: 'QUERY_PERSON_NAME_PURPOSE_CODE_COMMAND',
            value: 11,
        },
        QUERY_PERSON_NAME_WITH_MIDDLE_NAME_COMMAND: {
            name: 'QUERY_PERSON_NAME_WITH_MIDDLE_NAME_COMMAND',
            value: 17,
        },
        QUERY_PLATE_COMMAND: { name: 'QUERY_PLATE_COMMAND', value: 1 },
        QUERY_PLATE_PURPOSE_CODE_COMMAND: { name: 'QUERY_PLATE_PURPOSE_CODE_COMMAND', value: 8 },
        QUERY_PLATE_WHILE_SELF_INITIATING_EVENT_COMMAND: {
            name: 'QUERY_PLATE_WHILE_SELF_INITIATING_EVENT_COMMAND',
            value: 6,
        },
        QUERY_PLATE_WHILE_SELF_INITIATING_EVENT_PURPOSE_CODE_COMMAND: {
            name: 'QUERY_PLATE_WHILE_SELF_INITIATING_EVENT_PURPOSE_CODE_COMMAND',
            value: 13,
        },
        QUERY_PLATE_WHILE_SELF_INIT_EVENT_WITH_VEHICLE_TYPE_COMMAND: {
            name: 'QUERY_PLATE_WHILE_SELF_INIT_EVENT_WITH_VEHICLE_TYPE_COMMAND',
            value: 22,
        },
        QUERY_PLATE_WITH_VEHICLE_TYPE_COMMAND: {
            name: 'QUERY_PLATE_WITH_VEHICLE_TYPE_COMMAND',
            value: 20,
        },
        QUERY_VIN_COMMAND: { name: 'QUERY_VIN_COMMAND', value: 2 },
        QUERY_VIN_PURPOSE_CODE_COMMAND: { name: 'QUERY_VIN_PURPOSE_CODE_COMMAND', value: 9 },
        QUERY_VIN_WITH_VEHICLE_TYPE_COMMAND: {
            name: 'QUERY_VIN_WITH_VEHICLE_TYPE_COMMAND',
            value: 21,
        },
    },
    _A = {
        AUTO_DRILLDOWN: { name: 'AUTO_DRILLDOWN', value: 11 },
        CAD_DISPATCH_COMMAND_LINE: { name: 'CAD_DISPATCH_COMMAND_LINE', value: 1 },
        CAD_DISPATCH_EVENT_CREATION_FORM: { name: 'CAD_DISPATCH_EVENT_CREATION_FORM', value: 4 },
        CAD_DISPATCH_FORM: { name: 'CAD_DISPATCH_FORM', value: 2 },
        CAD_FIRST_RESPONDER_EVENT_CREATION_FORM: {
            name: 'CAD_FIRST_RESPONDER_EVENT_CREATION_FORM',
            value: 5,
        },
        CAD_FIRST_RESPONDER_FORM: { name: 'CAD_FIRST_RESPONDER_FORM', value: 3 },
        CASCADED_QUERY: { name: 'CASCADED_QUERY', value: 10 },
        CLIPS: { name: 'CLIPS', value: 7 },
        ONSCENE_ANDROID: { name: 'ONSCENE_ANDROID', value: 8 },
        ONSCENE_IOS: { name: 'ONSCENE_IOS', value: 9 },
        RMS_WARRANT: { name: 'RMS_WARRANT', value: 6 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    TA = {
        FILE: { name: 'FILE', value: 3 },
        FREE_TEXT: { name: 'FREE_TEXT', value: 1 },
        URL: { name: 'URL', value: 2 },
    },
    eA = {
        ALL_CASES_DASHBOARD: { name: 'ALL_CASES_DASHBOARD', value: 13 },
        CASE_TASKS: { name: 'CASE_TASKS', value: 5 },
        EFILE_DASHBOARD: { name: 'EFILE_DASHBOARD', value: 10 },
        EFILE_DEFENDANTS: { name: 'EFILE_DEFENDANTS', value: 9 },
        EFILE_DOCUMENTS: { name: 'EFILE_DOCUMENTS', value: 7 },
        EFILE_MATERIALS: { name: 'EFILE_MATERIALS', value: 8 },
        EFILE_OFFICERS: { name: 'EFILE_OFFICERS', value: 12 },
        EFILE_TASKS: { name: 'EFILE_TASKS', value: 6 },
        EFILE_VICTIM_WITNESSES: { name: 'EFILE_VICTIM_WITNESSES', value: 11 },
        ENTITY_PROFILE_TASKS: { name: 'ENTITY_PROFILE_TASKS', value: 4 },
        INVENTORIES_EVIDENCE: { name: 'INVENTORIES_EVIDENCE', value: 2 },
        MANAGE_EVIDENCE: { name: 'MANAGE_EVIDENCE', value: 1 },
        MY_CASES_DASHBOARD: { name: 'MY_CASES_DASHBOARD', value: 14 },
        MY_TASKS: { name: 'MY_TASKS', value: 16 },
        TASKS_DASHBOARD: { name: 'TASKS_DASHBOARD', value: 3 },
        UNASSIGNED_REPORTS_DASHBOARD: { name: 'UNASSIGNED_REPORTS_DASHBOARD', value: 15 },
    },
    AA = {
        ATTACHMENT: { name: 'ATTACHMENT' },
        CAD_TICKET: { name: 'CAD_TICKET' },
        CASE: { name: 'CASE' },
        EVIDENCE_ITEM: { name: 'EVIDENCE_ITEM' },
        EXTERNAL_OFFICER: { name: 'EXTERNAL_OFFICER' },
        E_FILE: { name: 'E_FILE' },
        ITEM: { name: 'ITEM' },
        JMS_ARREST: { name: 'JMS_ARREST' },
        JMS_ATTACHMENT: { name: 'JMS_ATTACHMENT' },
        JMS_ATTRIBUTE: { name: 'JMS_ATTRIBUTE' },
        JMS_ATTRIBUTE_TYPE: { name: 'JMS_ATTRIBUTE_TYPE' },
        JMS_BAIL_APPOINTMENT: { name: 'JMS_BAIL_APPOINTMENT' },
        JMS_BAIL_APPOINTMENT_EVENT: { name: 'JMS_BAIL_APPOINTMENT_EVENT' },
        JMS_BOND: { name: 'JMS_BOND' },
        JMS_BOOKING: { name: 'JMS_BOOKING' },
        JMS_CHARGE: { name: 'JMS_CHARGE' },
        JMS_DETAINEE: { name: 'JMS_DETAINEE' },
        JMS_DETAINEE_IDENTIFIER_VALUE: { name: 'JMS_DETAINEE_IDENTIFIER_VALUE' },
        JMS_DETAINEE_TRANSF: { name: 'JMS_DETAINEE_TRANSF' },
        JMS_EVENTS_LOG: { name: 'JMS_EVENTS_LOG' },
        JMS_FILE_METADATA: { name: 'JMS_FILE_METADATA' },
        JMS_FIN_TRANSACTION: { name: 'JMS_FIN_TRANSACTION' },
        JMS_FORM_DATA: { name: 'JMS_FORM_DATA' },
        JMS_HOLD: { name: 'JMS_HOLD' },
        JMS_IDENTIFIER: { name: 'JMS_IDENTIFIER' },
        JMS_IDENTIFIER_VALUE: { name: 'JMS_IDENTIFIER_VALUE' },
        JMS_LIVESCAN_RESULT: { name: 'JMS_LIVESCAN_RESULT' },
        JMS_LOCATION: { name: 'JMS_LOCATION' },
        JMS_LOCATION_TAG_ATTR: { name: 'JMS_LOCATION_TAG_ATTR' },
        JMS_MUGSHOT: { name: 'JMS_MUGSHOT' },
        JMS_OFFENSE_CODE: { name: 'JMS_OFFENSE_CODE' },
        JMS_OFFICER: { name: 'JMS_OFFICER' },
        JMS_PROPERTY: { name: 'JMS_PROPERTY' },
        JMS_SCHEDULE: { name: 'JMS_SCHEDULE' },
        JMS_SCHEDULED_EVENT: { name: 'JMS_SCHEDULED_EVENT' },
        JMS_SCHEDULED_EVENT_INSTANCE: { name: 'JMS_SCHEDULED_EVENT_INSTANCE' },
        JMS_SCHEDULED_INSTANCE: { name: 'JMS_SCHEDULED_INSTANCE' },
        JMS_USER: { name: 'JMS_USER' },
        JMS_VA_APPOINTMENT: { name: 'JMS_VA_APPOINTMENT' },
        JMS_VA_APPOINTMENT_EVENT: { name: 'JMS_VA_APPOINTMENT_EVENT' },
        JMS_WARNING_SIGNAL: { name: 'JMS_WARNING_SIGNAL' },
        JMS_WARRANT: { name: 'JMS_WARRANT' },
        LEGACY_ENTITY_DETAIL: { name: 'LEGACY_ENTITY_DETAIL' },
        LOCATION: { name: 'LOCATION' },
        NAME: { name: 'NAME' },
        REPORT: { name: 'REPORT' },
        TASK: { name: 'TASK' },
        USER: { name: 'USER' },
        WARRANT: { name: 'WARRANT' },
    },
    NA = {
        ARCHIVED: { name: 'ARCHIVED', value: 5 },
        COMPLETE: { name: 'COMPLETE', value: 4 },
        ERRORED: { name: 'ERRORED', value: 2 },
        PARTIAL: { name: 'PARTIAL', value: 3 },
        STARTED: { name: 'STARTED', value: 1 },
    },
    IA = {
        NO: { name: 'NO', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        UNSURE: { name: 'UNSURE', value: 3 },
        YES: { name: 'YES', value: 1 },
    },
    RA = {
        ALERT: { name: 'ALERT', value: 3 },
        EMAIL: { name: 'EMAIL', value: 2 },
        PUSH: { name: 'PUSH', value: 4 },
        SMS: { name: 'SMS', value: 5 },
        WEB_APP: { name: 'WEB_APP', value: 1 },
    },
    aA = { INLINE: { name: 'INLINE' }, PUSH: { name: 'PUSH' } },
    OA = {
        DC: { name: 'DC', value: 1 },
        NONE: { name: 'NONE', value: 0 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    SA = {
        DEFAULT: {
            name: 'DEFAULT',
            value: `WARNING: You are accessing a U.S. Government Information System operated by Mark43. This system is provided for authorized use only.

By using this system, you acknowledge that:
1. You are accessing a U.S. Government information system.
2. System usage may be monitored, recorded, and subject to audit.
3. Unauthorized use of the system is prohibited and subject to criminal and civil penalties.
4. Use of the system indicates consent to monitoring and recording.

Disconnect immediately if you do not agree to these conditions.`,
        },
    },
    CA = {
        DEACTIVATED: { name: 'DEACTIVATED', value: 7 },
        DEPARTMENT_CURRENTLY_BEING_SETUP: { name: 'DEPARTMENT_CURRENTLY_BEING_SETUP', value: 10 },
        DEPARTMENT_SETUP_FAILURE: { name: 'DEPARTMENT_SETUP_FAILURE', value: 5 },
        LIVE: { name: 'LIVE', value: 6 },
        MIGRATED: { name: 'MIGRATED', value: 9 },
        PARALLEL_PROCESSING: { name: 'PARALLEL_PROCESSING', value: 3 },
        PRE_PROD_CUTOVER: { name: 'PRE_PROD_CUTOVER', value: 8 },
        RESETTING: { name: 'RESETTING', value: 4 },
        TEST: { name: 'TEST', value: 1 },
        TRAINING: { name: 'TRAINING', value: 2 },
    },
    nA = {
        ATTACHMENTS: { name: 'ATTACHMENTS' },
        ATTRIBUTES: { name: 'ATTRIBUTES' },
        CLOSEST_UNIT: { name: 'CLOSEST_UNIT' },
        DB1: { name: 'DB1' },
        DEX_API: { name: 'DEX_API' },
        ELASTICSEARCH: { name: 'ELASTICSEARCH' },
        GPS_API: { name: 'GPS_API' },
        MASTER_ENTITIES: { name: 'MASTER_ENTITIES' },
        PERSONNEL: { name: 'PERSONNEL' },
        REDIS: { name: 'REDIS' },
        RMS_API: { name: 'RMS_API' },
        SECURITY: { name: 'SECURITY' },
        SETTINGS: { name: 'SETTINGS' },
    },
    DA = {
        ARTICLE_MASTER_QUERY: { name: 'ARTICLE_MASTER_QUERY', value: 4 },
        BOAT_MASTER_QUERY: { name: 'BOAT_MASTER_QUERY', value: 5 },
        CANADIAN_DRIVER_LICENSE_QUERY: { name: 'CANADIAN_DRIVER_LICENSE_QUERY', value: 29 },
        CANADIAN_VEHICLE_REGISTRATION_QUERY: {
            name: 'CANADIAN_VEHICLE_REGISTRATION_QUERY',
            value: 30,
        },
        CANADIAN_WANTED_PERSON_QUERY: { name: 'CANADIAN_WANTED_PERSON_QUERY', value: 28 },
        CRIMINAL_HISTORY_COMBINED_QUERY: { name: 'CRIMINAL_HISTORY_COMBINED_QUERY', value: 26 },
        CRIMINAL_HISTORY_FULL_RECORD_QUERY: {
            name: 'CRIMINAL_HISTORY_FULL_RECORD_QUERY',
            value: 25,
        },
        CRIMINAL_HISTORY_IDENTITY_QUERY: { name: 'CRIMINAL_HISTORY_IDENTITY_QUERY', value: 24 },
        CRIMINAL_HISTORY_INDEX_QUERY: { name: 'CRIMINAL_HISTORY_INDEX_QUERY', value: 22 },
        CRIMINAL_HISTORY_RECORD_REQUEST_QUERY: {
            name: 'CRIMINAL_HISTORY_RECORD_REQUEST_QUERY',
            value: 23,
        },
        CRIMINAL_MASTER_QUERY: { name: 'CRIMINAL_MASTER_QUERY', value: 8 },
        CRIMS_MASTER_QUERY: { name: 'CRIMS_MASTER_QUERY', value: 9 },
        FIREARM_CONCEALED_WEAPONS_QUERY: { name: 'FIREARM_CONCEALED_WEAPONS_QUERY', value: 11 },
        FIREARM_MASTER_QUERY: { name: 'FIREARM_MASTER_QUERY', value: 3 },
        FIREARM_OWNERS_ID_QUERY: { name: 'FIREARM_OWNERS_ID_QUERY', value: 12 },
        IMAGE_QUERY: { name: 'IMAGE_QUERY', value: 21 },
        LOJACK_MASTER_QUERY: { name: 'LOJACK_MASTER_QUERY', value: 7 },
        PERSON_MASTER_QUERY: { name: 'PERSON_MASTER_QUERY', value: 2 },
        PERSON_PROBATION_QUERY: { name: 'PERSON_PROBATION_QUERY', value: 18 },
        PERSON_SEX_OFFENDER_QUERY: { name: 'PERSON_SEX_OFFENDER_QUERY', value: 19 },
        PERSON_WARRANT_DETAIL_QUERY: { name: 'PERSON_WARRANT_DETAIL_QUERY', value: 20 },
        VEHICLE_BY_NAME_QUERY: { name: 'VEHICLE_BY_NAME_QUERY', value: 10 },
        VEHICLE_MASTER_QUERY: { name: 'VEHICLE_MASTER_QUERY', value: 1 },
        VEHICLE_RECENT_QUERY_FILES: { name: 'VEHICLE_RECENT_QUERY_FILES', value: 17 },
        VEHICLE_REGISTRATION_BY_NAME_QUERY: {
            name: 'VEHICLE_REGISTRATION_BY_NAME_QUERY',
            value: 15,
        },
        VEHICLE_REGISTRATION_BY_OTHER: { name: 'VEHICLE_REGISTRATION_BY_OTHER', value: 16 },
        VEHICLE_REGISTRATION_BY_PLATE_QUERY: {
            name: 'VEHICLE_REGISTRATION_BY_PLATE_QUERY',
            value: 13,
        },
        VEHICLE_REGISTRATION_BY_VIN_QUERY: { name: 'VEHICLE_REGISTRATION_BY_VIN_QUERY', value: 14 },
        VEHICLE_STOLEN_QUERY: { name: 'VEHICLE_STOLEN_QUERY', value: 27 },
    },
    LA = {
        ARTICLE: { name: 'ARTICLE', value: 'article' },
        BOAT: { name: 'BOAT', value: 'boat' },
        CLIPS: { name: 'CLIPS', value: 'clips' },
        FIREARM: { name: 'FIREARM', value: 'firearm' },
        IMAGE: { name: 'IMAGE', value: 'image' },
        PERSON: { name: 'PERSON', value: 'person' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unknown' },
        VEHICLE: { name: 'VEHICLE', value: 'vehicle' },
    },
    mA = { FULL: { name: 'FULL' }, MEDIUM: { name: 'MEDIUM' }, SMALL: { name: 'SMALL' } },
    lA = {
        BOAT_INQUIRY: { dexEntityType: 'BOAT', name: 'BOAT_INQUIRY', value: 5 },
        CANADIAN_DRIVER_LICENSE_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CANADIAN_DRIVER_LICENSE_QUERY',
            value: 32,
        },
        CANADIAN_VEHICLE_REGISTRATION_QUERY: {
            dexEntityType: 'VEHICLE',
            name: 'CANADIAN_VEHICLE_REGISTRATION_QUERY',
            value: 33,
        },
        CANADIAN_WANTED_PERSON_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CANADIAN_WANTED_PERSON_QUERY',
            value: 31,
        },
        CLIPS_QUERY: { dexEntityType: 'CLIPS', name: 'CLIPS_QUERY', value: 11 },
        CRIMINAL_HISTORY_COMBINED_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CRIMINAL_HISTORY_COMBINED_QUERY',
            value: 28,
        },
        CRIMINAL_HISTORY_FULL_RECORD_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CRIMINAL_HISTORY_FULL_RECORD_QUERY',
            value: 27,
        },
        CRIMINAL_HISTORY_IDENTITY_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CRIMINAL_HISTORY_IDENTITY_QUERY',
            value: 26,
        },
        CRIMINAL_HISTORY_INDEX_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CRIMINAL_HISTORY_INDEX_QUERY',
            value: 24,
        },
        CRIMINAL_HISTORY_RECORD_REQUEST_QUERY: {
            dexEntityType: 'PERSON',
            name: 'CRIMINAL_HISTORY_RECORD_REQUEST_QUERY',
            value: 25,
        },
        CRIMS_QUERY: { dexEntityType: 'PERSON', name: 'CRIMS_QUERY', value: 12 },
        DRILLDOWN_SELECTION_QUERY: {
            dexEntityType: 'UNKNOWN',
            name: 'DRILLDOWN_SELECTION_QUERY',
            value: 30,
        },
        FIREARM_CONCEALED_WEAPON_QUERY: {
            dexEntityType: 'FIREARM',
            name: 'FIREARM_CONCEALED_WEAPON_QUERY',
            value: 13,
        },
        FIREARM_INQUIRY: { dexEntityType: 'FIREARM', name: 'FIREARM_INQUIRY', value: 2 },
        FIREARM_OWNERS_ID_QUERY: {
            dexEntityType: 'FIREARM',
            name: 'FIREARM_OWNERS_ID_QUERY',
            value: 14,
        },
        IMAGE_QUERY: { dexEntityType: 'IMAGE', name: 'IMAGE_QUERY', value: 23 },
        LOJACK_INQUIRY: { dexEntityType: 'VEHICLE', name: 'LOJACK_INQUIRY', value: 10 },
        PERSON_BY_PROBATION_ID_QUERY: {
            dexEntityType: 'PERSON',
            name: 'PERSON_BY_PROBATION_ID_QUERY',
            value: 20,
        },
        PERSON_BY_SEX_OFFENDER_NUMBER_QUERY: {
            dexEntityType: 'PERSON',
            name: 'PERSON_BY_SEX_OFFENDER_NUMBER_QUERY',
            value: 21,
        },
        PERSON_BY_WARRANT_DETAIL_QUERY: {
            dexEntityType: 'PERSON',
            name: 'PERSON_BY_WARRANT_DETAIL_QUERY',
            value: 22,
        },
        PERSON_INQUIRY: { dexEntityType: 'PERSON', name: 'PERSON_INQUIRY', value: 9 },
        SINGLE_ARTICLE_INQUIRY: {
            dexEntityType: 'ARTICLE',
            name: 'SINGLE_ARTICLE_INQUIRY',
            value: 4,
        },
        VEHICLE_BY_NAME_QUERY: {
            dexEntityType: 'VEHICLE',
            name: 'VEHICLE_BY_NAME_QUERY',
            value: 17,
        },
        VEHICLE_BY_PLATE_AND_STATUS_QUERY: {
            dexEntityType: 'VEHICLE',
            name: 'VEHICLE_BY_PLATE_AND_STATUS_QUERY',
            value: 18,
        },
        VEHICLE_BY_PLATE_QUERY: {
            dexEntityType: 'VEHICLE',
            name: 'VEHICLE_BY_PLATE_QUERY',
            value: 15,
        },
        VEHICLE_BY_VIN_QUERY: { dexEntityType: 'VEHICLE', name: 'VEHICLE_BY_VIN_QUERY', value: 16 },
        VEHICLE_RECENT_QUERY: { dexEntityType: 'VEHICLE', name: 'VEHICLE_RECENT_QUERY', value: 19 },
        VEHICLE_REGISTRATION_INQUIRY: {
            dexEntityType: 'VEHICLE',
            name: 'VEHICLE_REGISTRATION_INQUIRY',
            value: 1,
        },
        VEHICLE_STOLEN_QUERY: { dexEntityType: 'VEHICLE', name: 'VEHICLE_STOLEN_QUERY', value: 29 },
        WARRANT_CANCEL: { dexEntityType: 'PERSON', name: 'WARRANT_CANCEL', value: 8 },
        WARRANT_ENTRY: { dexEntityType: 'PERSON', name: 'WARRANT_ENTRY', value: 7 },
    },
    uA = {
        AZ_ACJIS: { name: 'AZ_ACJIS', value: 11 },
        CA_ALEMS: { name: 'CA_ALEMS', value: 12 },
        CA_CLETS: { name: 'CA_CLETS', value: 2 },
        CA_CONTRA_COSTA_COUNTY: { name: 'CA_CONTRA_COSTA_COUNTY', value: 1 },
        CA_JDIC: { name: 'CA_JDIC', value: 5 },
        CA_JDIC_EXPANDED: { name: 'CA_JDIC_EXPANDED', value: 14 },
        CA_OCATS: { name: 'CA_OCATS', value: 6 },
        CA_SDSD_ESUN: { name: 'CA_SDSD_ESUN', value: 9 },
        FL_FCIC: { name: 'FL_FCIC', value: 3 },
        HI_HCJDC_OFML: { name: 'HI_HCJDC_OFML', value: 21 },
        IL_LEADS_OFML: { name: 'IL_LEADS_OFML', value: 18 },
        LA_LLETS: { name: 'LA_LLETS', value: 4 },
        MA_LEAPS: { name: 'MA_LEAPS', value: 7 },
        NJ_CJIS: { name: 'NJ_CJIS', value: 15 },
        NM_NMLETS: { name: 'NM_NMLETS', value: 13 },
        NY_SPIN: { name: 'NY_SPIN', value: 17 },
        OR_LEDS: { name: 'OR_LEDS', value: 16 },
        PORT_AUTHORITY: { name: 'PORT_AUTHORITY', value: 20 },
        SAN_LUIS_OBISPO: { name: 'SAN_LUIS_OBISPO', value: 19 },
        TN_TIES: { name: 'TN_TIES', value: 10 },
        TX_TLETS: { name: 'TX_TLETS', value: 8 },
    },
    PA = {
        COMMSYS: { name: 'COMMSYS', value: 2 },
        DATAMAXX: { name: 'DATAMAXX', value: 1 },
        WCSG: { name: 'WCSG', value: 3 },
    },
    UA = {
        ACTING_USER_ID: { name: 'ACTING_USER_ID' },
        APPLICATION_NAME: { name: 'APPLICATION_NAME' },
        CLIENT_REQUEST_ID: { name: 'CLIENT_REQUEST_ID' },
        CLIENT_SESSION_ID: { name: 'CLIENT_SESSION_ID' },
        COMMAND_NAME: { name: 'COMMAND_NAME' },
        COMMAND_RECORD_ID: { name: 'COMMAND_RECORD_ID' },
        DEPARTMENT_ID: { name: 'DEPARTMENT_ID' },
        DEPARTMENT_STATUS: { name: 'DEPARTMENT_STATUS' },
        DEPARTMENT_SUBDOMAIN: { name: 'DEPARTMENT_SUBDOMAIN' },
        INTERFACE_ID: { name: 'INTERFACE_ID' },
        JOB_MODE: { name: 'JOB_MODE' },
        JOB_TYPE: { name: 'JOB_TYPE' },
        REQUEST_ID: { name: 'REQUEST_ID' },
        SFX_SPAN_ID: { name: 'SFX_SPAN_ID' },
        SFX_TRACE_ID: { name: 'SFX_TRACE_ID' },
        SUBPREMISE_SUPPORT_ENABLED: { name: 'SUBPREMISE_SUPPORT_ENABLED' },
        USER_EMAIL: { name: 'USER_EMAIL' },
        USER_ID: { name: 'USER_ID' },
    },
    MA = {
        ARROWS: { name: 'ARROWS', value: 2 },
        CRASH_BACKGROUND: { name: 'CRASH_BACKGROUND', value: 5 },
        OTHER: { name: 'OTHER', value: 4 },
        TRAFFIC_SIGNS: { name: 'TRAFFIC_SIGNS', value: 1 },
        VEHICLES: { name: 'VEHICLES', value: 3 },
    },
    vA = { CRASH: { name: 'CRASH', value: 1 } },
    FA = { CATCHUP: { name: 'CATCHUP', value: 2 }, HISTORIC: { name: 'HISTORIC', value: 1 } },
    GA = { DEAD: { name: 'DEAD' }, SHUTDOWN: { name: 'SHUTDOWN' }, STALE: { name: 'STALE' } },
    HA = { OWNED: { name: 'OWNED', value: 1 }, VIEWED: { name: 'VIEWED', value: 2 } },
    YA = {
        ACTIVE: { name: 'ACTIVE', value: 1 },
        BLOCKED: { name: 'BLOCKED', value: 2 },
        DEACTIVATED: { name: 'DEACTIVATED', value: 3 },
    },
    tA = { MONITOR: { name: 'MONITOR' }, OWNER: { name: 'OWNER' } },
    VA = {
        CALL_TAKER: { name: 'CALL_TAKER', value: 1 },
        DISPATCHER: { name: 'DISPATCHER', value: 2 },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER', value: 3 },
    },
    oA = {
        APPROVED_FOR_DISPOSITION: { name: 'APPROVED_FOR_DISPOSITION', value: 6 },
        APPROVED_FOR_RELEASE: { name: 'APPROVED_FOR_RELEASE', value: 5 },
        DISPOSITION_COMPLETED: { name: 'DISPOSITION_COMPLETED', value: 7 },
        INELIGIBLE_FOR_DISPOSITION: { name: 'INELIGIBLE_FOR_DISPOSITION', value: 8 },
        PENDING_PRIMARY_REVIEW: { name: 'PENDING_PRIMARY_REVIEW', value: 2 },
        PENDING_SECONDARY_REVIEW_FOR_DISPOSITION: {
            name: 'PENDING_SECONDARY_REVIEW_FOR_DISPOSITION',
            value: 4,
        },
        PENDING_SECONDARY_REVIEW_FOR_RELEASE: {
            name: 'PENDING_SECONDARY_REVIEW_FOR_RELEASE',
            value: 3,
        },
        WAITING_RETENTION_PERIOD: { name: 'WAITING_RETENTION_PERIOD', value: 1 },
    },
    BA = { HAS_DLQ: { name: 'HAS_DLQ' }, NO_DLQ: { name: 'NO_DLQ' } },
    rA = { INSTANCE: { name: 'INSTANCE' } },
    sA = {
        ADMIN_LEAVE: { name: 'ADMIN_LEAVE', value: 5 },
        DECEASED: { name: 'DECEASED', value: 11 },
        FULL: { name: 'FULL', value: 1 },
        INACTIVE_OTHER: { name: 'INACTIVE_OTHER', value: 12 },
        LIMITED: { name: 'LIMITED', value: 2 },
        MILITARY_LEAVE: { name: 'MILITARY_LEAVE', value: 3 },
        NON_CONTACT: { name: 'NON_CONTACT', value: 6 },
        RETIRED: { name: 'RETIRED', value: 10 },
        REVOKED: { name: 'REVOKED', value: 9 },
        SICK_LEAVE: { name: 'SICK_LEAVE', value: 4 },
        SUSPENDED_WITHOUT_PAY: { name: 'SUSPENDED_WITHOUT_PAY', value: 8 },
        SUSPENDED_WITH_PAY: { name: 'SUSPENDED_WITH_PAY', value: 7 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    iA = { DOWNLOADABLES: { name: 'DOWNLOADABLES', value: 1 } },
    WA = {
        ATTRIBUTE_TYPE: { name: 'ATTRIBUTE_TYPE' },
        ATTRIBUTE_TYPE_VIEW: { name: 'ATTRIBUTE_TYPE_VIEW' },
        CODE_TYPE_CATEGORY: { name: 'CODE_TYPE_CATEGORY' },
        CODE_TYPE_SOURCE: { name: 'CODE_TYPE_SOURCE' },
        COMPLIANCE_GROUP: { name: 'COMPLIANCE_GROUP' },
        REGIONAL_GROUP: { name: 'REGIONAL_GROUP' },
    },
    cA = { ONGOING: { name: 'ONGOING', value: 1 }, PAUSED: { name: 'PAUSED', value: 2 } },
    KA = {
        E_FILE: { name: 'E_FILE', value: 3 },
        E_FILE_DEFENDANTS: { name: 'E_FILE_DEFENDANTS', value: 2 },
        E_FILE_DEFENDANT_DETAILS: { name: 'E_FILE_DEFENDANT_DETAILS', value: 9 },
        E_FILE_DOCUMENT: { name: 'E_FILE_DOCUMENT', value: 7 },
        E_FILE_INVOLVED_PROFILES: { name: 'E_FILE_INVOLVED_PROFILES', value: 1 },
        E_FILE_MATERIALS: { name: 'E_FILE_MATERIALS', value: 4 },
        E_FILE_OFFENSES: { name: 'E_FILE_OFFENSES', value: 6 },
        E_FILE_OFFICERS: { name: 'E_FILE_OFFICERS', value: 5 },
        E_FILE_OFFICER_DETAILS: { name: 'E_FILE_OFFICER_DETAILS', value: 10 },
        E_FILE_VICTIM_WITNESSES_DETAILS: { name: 'E_FILE_VICTIM_WITNESSES_DETAILS', value: 8 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    dA = {
        IMPORTED: { name: 'IMPORTED', value: 'Imported' },
        NEW_FORM: { name: 'NEW_FORM', value: 'New Form' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    pA = { CUSTODY: { name: 'CUSTODY', value: 2 }, E_FILE: { name: 'E_FILE', value: 1 } },
    yA = {
        CANNABIS_WARNING: { name: 'CANNABIS_WARNING', value: 64 },
        CAUTION: { name: 'CAUTION', value: 2 },
        CHARGE: { name: 'CHARGE', value: 1 },
        CONDITIONAL_CAUTION: { name: 'CONDITIONAL_CAUTION', value: 4 },
        FIXED_PENALTY: { name: 'FIXED_PENALTY', value: 128 },
        JOINT_CHARGE: { name: 'JOINT_CHARGE', value: 32 },
        NFA: { name: 'NFA', value: 8 },
        POLICE_BAIL: { name: 'POLICE_BAIL', value: 2048 },
        POSTAL_CHARGE: { name: 'POSTAL_CHARGE', value: 256 },
        POSTAL_REQUISITION: { name: 'POSTAL_REQUISITION', value: 512 },
        PROCESS: { name: 'PROCESS', value: 1024 },
        RELEASED_WITHOUT_BAIL: { name: 'RELEASED_WITHOUT_BAIL', value: 4096 },
        TAKEN_INTO_CONSIDERATION: { name: 'TAKEN_INTO_CONSIDERATION', value: 16 },
    },
    XA = {
        DEACTIVATED: { name: 'DEACTIVATED', value: 2 },
        REACTIVATED: { name: 'REACTIVATED', value: 4 },
        REMOVED: { name: 'REMOVED', value: 1 },
        UNLINKED: { name: 'UNLINKED', value: 3 },
        UPDATED: { name: 'UPDATED', value: 5 },
    },
    QA = {
        ATTACHMENT_CREATED_DATE_UTC: {
            name: 'ATTACHMENT_CREATED_DATE_UTC',
            value: 'createdDateUtc',
        },
        BOLO_ACTIVE_DATE: { name: 'BOLO_ACTIVE_DATE', value: 'createdDateUtc' },
        BOLO_EFFECTIVE_EXPIRATION_DATE: {
            name: 'BOLO_EFFECTIVE_EXPIRATION_DATE',
            value: 'effectiveExpirationDateUtc',
        },
        BOLO_PRIORITY: { name: 'BOLO_PRIORITY', value: 'priority.parentAttributeId' },
        CAD_TICKET_START_DATE_UTC: { name: 'CAD_TICKET_START_DATE_UTC', value: 'startDateUtc' },
        CASE_ASSIGNED_DATE_UTC: { name: 'CASE_ASSIGNED_DATE_UTC', value: 'assignedDateUtc' },
        CASE_CREATED_DATE_UTC: { name: 'CASE_CREATED_DATE_UTC', value: 'createdDateUtc' },
        CASE_DUE_DATE_UTC: { name: 'CASE_DUE_DATE_UTC', value: 'dueDateUtc' },
        CASE_INVESTIGATOR: {
            name: 'CASE_INVESTIGATOR',
            value: 'assigneeSort.caseInSensitiveKeywordField',
        },
        CASE_NUMBER: { name: 'CASE_NUMBER', value: 'caseNumber.raw' },
        CASE_PRIORITY: {
            name: 'CASE_PRIORITY',
            value: 'targetProfilePriorityAttrDetail.displayValue',
        },
        CASE_STATUS: { name: 'CASE_STATUS', value: 'currentStatusAttrDetail.displayValue' },
        CASE_TITLE: { name: 'CASE_TITLE', value: 'title.caseInSensitiveKeywordField' },
        CASE_UPDATED_DATE_UTC: { name: 'CASE_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        COBALT_CAD_TICKET_PRIORITY: {
            name: 'COBALT_CAD_TICKET_PRIORITY',
            value: 'priorityGlobalAttrId',
        },
        COBALT_CAD_TICKET_RECEIVED_DATE_UTC: {
            name: 'COBALT_CAD_TICKET_RECEIVED_DATE_UTC',
            value: 'receivedDateUtc',
        },
        COBALT_CAD_TICKET_START_DATE_UTC: {
            name: 'COBALT_CAD_TICKET_START_DATE_UTC',
            value: 'startDateUtc',
        },
        COBALT_CAD_TICKET_UPDATED_DATE_UTC: {
            name: 'COBALT_CAD_TICKET_UPDATED_DATE_UTC',
            value: 'updatedDateUtc',
        },
        COURT_ORDER_COURT_CASE_DATE_UTC: {
            name: 'COURT_ORDER_COURT_CASE_DATE_UTC',
            value: 'courtCaseDateUtc',
        },
        COURT_ORDER_MODIFIED_DATE_UTC: {
            name: 'COURT_ORDER_MODIFIED_DATE_UTC',
            value: 'modifiedDateUtc',
        },
        EFILE_CREATED_DATE_UTC: { name: 'EFILE_CREATED_DATE_UTC', value: 'createdDateUtc' },
        EFILE_DATE_TO_CPS_UTC: { name: 'EFILE_DATE_TO_CPS_UTC', value: 'dateToCpsUtc' },
        EFILE_OFFICER: {
            name: 'EFILE_OFFICER',
            value: 'eFileOfficerUser.lastName.caseInSensitiveKeywordField',
        },
        EFILE_OWNER: {
            name: 'EFILE_OWNER',
            value: 'eFileOwnerUser.lastName.caseInSensitiveKeywordField',
        },
        EFILE_OWNER_ROLE: {
            name: 'EFILE_OWNER_ROLE',
            value: 'eFileOwnerRole.name.caseInSensitiveKeywordField',
        },
        EFILE_PTI_URN: { name: 'EFILE_PTI_URN', value: 'ptiUrnLowered.raw' },
        EFILE_STATUS: { name: 'EFILE_STATUS', value: 'statusAttrDetail.displayValue' },
        ELASTICSEARCH_SCORE: { name: 'ELASTICSEARCH_SCORE', value: '_score' },
        EVIDENCE_ITEM_CHAIN_EVENT_DATE: {
            name: 'EVIDENCE_ITEM_CHAIN_EVENT_DATE',
            value: 'currentChainEvent.updatedDateUtc',
        },
        EVIDENCE_ITEM_DATE_ACQUIRED: {
            name: 'EVIDENCE_ITEM_DATE_ACQUIRED',
            value: 'acquiredDateUtc',
        },
        EVIDENCE_ITEM_DISPLAY_VALUE: {
            name: 'EVIDENCE_ITEM_DISPLAY_VALUE',
            value: 'itemCategoryAttrDetail.displayValue',
        },
        EVIDENCE_ITEM_DISPOSITION_STATUS: {
            name: 'EVIDENCE_ITEM_DISPOSITION_STATUS',
            value: 'dispositionStatus',
        },
        EVIDENCE_ITEM_EVENT_TYPE: {
            name: 'EVIDENCE_ITEM_EVENT_TYPE',
            value: 'currentChainEvent.eventTypeId',
        },
        EVIDENCE_ITEM_REPORTING_EVENT_NUMBER: {
            name: 'EVIDENCE_ITEM_REPORTING_EVENT_NUMBER',
            value: 'reportingEventNumber.raw',
        },
        EVIDENCE_ITEM_SEQUENCE_NUMBER: {
            name: 'EVIDENCE_ITEM_SEQUENCE_NUMBER',
            value: 'sequenceNumber',
        },
        EVIDENCE_ITEM_STAFF_REMARKS: { name: 'EVIDENCE_ITEM_STAFF_REMARKS', value: 'staffRemarks' },
        FORENSIC_RESULT_EXHIBIT_DESCRIPTION: {
            name: 'FORENSIC_RESULT_EXHIBIT_DESCRIPTION',
            value: 'exhibitDescription',
        },
        FORENSIC_RESULT_FORENSIC_LINK: {
            name: 'FORENSIC_RESULT_FORENSIC_LINK',
            value: 'forensicLink',
        },
        FORENSIC_RESULT_JOB_TYPE: { name: 'FORENSIC_RESULT_JOB_TYPE', value: 'jobType' },
        FORENSIC_RESULT_RESULT_DESCRIPTION: {
            name: 'FORENSIC_RESULT_RESULT_DESCRIPTION',
            value: 'resultDescription',
        },
        GEO_ADDRESS_POINT_CENTER_POINT: {
            name: 'GEO_ADDRESS_POINT_CENTER_POINT',
            value: 'centerPoint',
        },
        GEO_ALIAS_CENTER_POINT: { name: 'GEO_ALIAS_CENTER_POINT', value: 'centerPoint' },
        ID: { name: 'ID', value: 'id' },
        ORGANIZATION_NAME: { name: 'ORGANIZATION_NAME', value: 'name.raw' },
        ORGANIZATION_UPDATED_DATE_UTC: {
            name: 'ORGANIZATION_UPDATED_DATE_UTC',
            value: 'updatedDateUtc',
        },
        PERSON_DATE_OF_BIRTH: { name: 'PERSON_DATE_OF_BIRTH', value: 'dateOfBirth' },
        PERSON_FIRST_NAME: {
            name: 'PERSON_FIRST_NAME',
            value: 'firstName.caseInSensitiveKeywordField',
        },
        PERSON_LAST_NAME: {
            name: 'PERSON_LAST_NAME',
            value: 'lastName.caseInSensitiveKeywordField',
        },
        PERSON_NUMBER_OF_CAUTIONS: { name: 'PERSON_NUMBER_OF_CAUTIONS', value: 'numberOfCautions' },
        PERSON_UPDATED_DATE_UTC: { name: 'PERSON_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        PROPERTY_UPDATED_DATE_UTC: { name: 'PROPERTY_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        REPORT_ARREST_DATE_UTC: {
            name: 'REPORT_ARREST_DATE_UTC',
            value: 'reportDefinition.arrest.arrestDateUtc',
        },
        REPORT_EVENT_START_UTC: { name: 'REPORT_EVENT_START_UTC', value: 'eventStartUtc' },
        REPORT_REPORTING_EVENT_NUMBER: { name: 'REPORT_REPORTING_EVENT_NUMBER', value: 'ren.raw' },
        REPORT_REPORT_CREATION_DATE_UTC: {
            name: 'REPORT_REPORT_CREATION_DATE_UTC',
            value: 'reportCreationDateUtc',
        },
        REPORT_UPDATED_DATE_UTC: { name: 'REPORT_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        RMS_EVENT_ID: { name: 'RMS_EVENT_ID', value: 'rmsEventId' },
        STREET_SEGMENT_CENTER_POINT: { name: 'STREET_SEGMENT_CENTER_POINT', value: 'centerPoint' },
        SUBJECT_PERSON_FIRST_NAME: {
            name: 'SUBJECT_PERSON_FIRST_NAME',
            value: 'subject.firstName.caseInSensitiveKeywordField',
        },
        SUBJECT_PERSON_LAST_NAME: {
            name: 'SUBJECT_PERSON_LAST_NAME',
            value: 'subject.lastName.caseInSensitiveKeywordField',
        },
        TASK_ASSIGNEE: { name: 'TASK_ASSIGNEE', value: 'assigneeSort.caseInSensitiveKeywordField' },
        TASK_CREATED_DATE: { name: 'TASK_CREATED_DATE', value: 'createdDateUtc' },
        TASK_DUE_DATE: { name: 'TASK_DUE_DATE', value: 'dueDateUtc' },
        TASK_MODIFIED_DATE: { name: 'TASK_MODIFIED_DATE', value: 'updatedDateUtc' },
        TASK_PRIORITY: { name: 'TASK_PRIORITY', value: 'priorityAttrDetail.displayValue' },
        TASK_RECORD_NUMBER: {
            name: 'TASK_RECORD_NUMBER',
            value: 'recordNumber.caseInSensitiveKeywordField',
        },
        TASK_STATUS: { name: 'TASK_STATUS', value: 'statusAttrDetail.displayValue' },
        TASK_STATUS_DEFAULT: { name: 'TASK_STATUS_DEFAULT', value: 'statusSort' },
        TASK_TARGET_AGENCY: {
            name: 'TASK_TARGET_AGENCY',
            value: 'targetAgency.agencyName.caseInSensitiveKeywordField',
        },
        TASK_TITLE: { name: 'TASK_TITLE', value: 'title.caseInSensitiveKeywordField' },
        TASK_TYPE: { name: 'TASK_TYPE', value: 'typeAttrDetail.displayValue' },
        UNIT_LOCATION_DISTANCE: { name: 'UNIT_LOCATION_DISTANCE', value: 'location' },
        UNIT_STATUS_AGENCY_EVENT_GLOBAL_PRIORITY: {
            name: 'UNIT_STATUS_AGENCY_EVENT_GLOBAL_PRIORITY',
            value: 'agencyEvent.priorityGlobalAttrId',
        },
        UNIT_STATUS_AGENCY_EVENT_NUMBER: {
            name: 'UNIT_STATUS_AGENCY_EVENT_NUMBER',
            value: 'agencyEvent.agencyEventNumber.raw',
        },
        UNIT_STATUS_AGENCY_TYPE: { name: 'UNIT_STATUS_AGENCY_TYPE', value: 'agencyTypeAttrId' },
        UNIT_STATUS_START_DATE_UTC: { name: 'UNIT_STATUS_START_DATE_UTC', value: 'startDateUtc' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
        USER_ACTION_CREATED_DATE_UTC: {
            name: 'USER_ACTION_CREATED_DATE_UTC',
            value: 'createdDateUtc',
        },
        USER_ACTIVE: { name: 'USER_ACTIVE', value: 'isDisabled' },
        USER_FULL_NAME: { name: 'USER_FULL_NAME', value: 'fullName' },
        USER_UPDATED_DATE_UTC: { name: 'USER_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        VEHICLE_UPDATED_DATE_UTC: { name: 'VEHICLE_UPDATED_DATE_UTC', value: 'updatedDateUtc' },
        WARRANT_DATE_ISSUED_UTC: { name: 'WARRANT_DATE_ISSUED_UTC', value: 'warrantIssuedDateUtc' },
        WARRANT_STATUS: { name: 'WARRANT_STATUS', value: 'warrantStatusAttrDetail.displayValue' },
    },
    bA = {
        ACTIVE_TO_INACTIVE: { name: 'ACTIVE_TO_INACTIVE', value: 15 },
        AGE_OLDEST_TO_YOUNGEST: { name: 'AGE_OLDEST_TO_YOUNGEST', value: 6 },
        AGE_YOUNGEST_TO_OLDEST: { name: 'AGE_YOUNGEST_TO_OLDEST', value: 5 },
        ALPHABETICAL_A_TO_Z: { name: 'ALPHABETICAL_A_TO_Z', value: 3 },
        ALPHABETICAL_Z_TO_A: { name: 'ALPHABETICAL_Z_TO_A', value: 4 },
        DATE_LEAST_RECENT_TO_MOST_RECENT: { name: 'DATE_LEAST_RECENT_TO_MOST_RECENT', value: 2 },
        DATE_MOST_RECENT_TO_LEAST_RECENT: { name: 'DATE_MOST_RECENT_TO_LEAST_RECENT', value: 1 },
        DISTANCE_FARTHEST_TO_NEAREST: { name: 'DISTANCE_FARTHEST_TO_NEAREST', value: 12 },
        DISTANCE_NEAREST_TO_FARTHEST: { name: 'DISTANCE_NEAREST_TO_FARTHEST', value: 11 },
        NUMBER_HIGHEST_TO_LOWEST: { name: 'NUMBER_HIGHEST_TO_LOWEST', value: 10 },
        NUMBER_LOWEST_TO_HIGHEST: { name: 'NUMBER_LOWEST_TO_HIGHEST', value: 9 },
        PRIORITY_HIGHEST_TO_LOWEST: { name: 'PRIORITY_HIGHEST_TO_LOWEST', value: 7 },
        PRIORITY_LOWEST_TO_HIGHEST: { name: 'PRIORITY_LOWEST_TO_HIGHEST', value: 8 },
        RELEVANCE_LEAST_TO_MOST: { name: 'RELEVANCE_LEAST_TO_MOST', value: 14 },
        RELEVANCE_MOST_TO_LEAST: { name: 'RELEVANCE_MOST_TO_LEAST', value: 13 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    fA = {
        ALPHANUMERIC_TOKEN_SEARCH: {
            name: 'ALPHANUMERIC_TOKEN_SEARCH',
            value: 'alphanumericTokenField',
        },
        CASE_INSENSITIVE_KEYWORD_SORT: {
            name: 'CASE_INSENSITIVE_KEYWORD_SORT',
            value: 'caseInSensitiveKeywordField',
        },
        CASE_INSENSITIVE_SEARCH: {
            name: 'CASE_INSENSITIVE_SEARCH',
            value: 'caseInSensitiveFieldField',
        },
        CASE_INSENSITIVE_SUBSTRING_SEARCH: {
            name: 'CASE_INSENSITIVE_SUBSTRING_SEARCH',
            value: 'caseInsensitiveSubstring',
        },
        ENGLISH_FREE_TEXT_SEARCH: {
            name: 'ENGLISH_FREE_TEXT_SEARCH',
            value: 'englishFreeTextField',
        },
        FILE_NAME_SEARCH: { name: 'FILE_NAME_SEARCH', value: 'fileNameSearchField' },
        LOCATION_EGDGE_NGRAM_SEARCH: {
            name: 'LOCATION_EGDGE_NGRAM_SEARCH',
            value: 'locationNgramEdgeField',
        },
        LOCATION_SOUNDEX_SYNONYM_SEARCH: {
            name: 'LOCATION_SOUNDEX_SYNONYM_SEARCH',
            value: 'locationSoundexField',
        },
        LOCATION_SYNONYM_SEARCH: { name: 'LOCATION_SYNONYM_SEARCH', value: 'locationSynonymField' },
        LOWER_CASE_KEYWORD_SEARCH: {
            name: 'LOWER_CASE_KEYWORD_SEARCH',
            value: 'lowerCaseKeywordField',
        },
        NAME_SYNONYM_SEARCH: { name: 'NAME_SYNONYM_SEARCH', value: 'nameSynonymField' },
        PATTERN: { name: 'PATTERN', value: 'pattern' },
        PREFIX_SEARCH: { name: 'PREFIX_SEARCH', value: 'prefix' },
        RAW: { name: 'RAW', value: 'raw' },
        REVERSE: { name: 'REVERSE', value: 'reverse' },
        SOUNDEX_SEARCH: { name: 'SOUNDEX_SEARCH', value: 'soundex' },
        SUBSTRING_SEARCH: { name: 'SUBSTRING_SEARCH', value: 'substring' },
        SUFFIX_SEARCH: { name: 'SUFFIX_SEARCH', value: 'suffix' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    gA = {
        ATTACHMENTS: { name: 'ATTACHMENTS', value: 19 },
        BOLO: { name: 'BOLO', value: 22 },
        BRIEFING: { name: 'BRIEFING', value: 21 },
        CAD_CAD_TICKET: { name: 'CAD_CAD_TICKET', value: 10 },
        CAD_TICKET: { name: 'CAD_TICKET', value: 3 },
        CALENDAR_EVENT: { name: 'CALENDAR_EVENT', value: 33 },
        CASE: { name: 'CASE', value: 7 },
        CASE_ASSIGNED_TO_ME: { name: 'CASE_ASSIGNED_TO_ME', value: 15 },
        CASE_TASK: { name: 'CASE_TASK', value: 24 },
        COURT_ORDERS: { name: 'COURT_ORDERS', value: 20 },
        EFILE_DASHBOARD: { name: 'EFILE_DASHBOARD', value: 30 },
        EFILE_DEFENDANT: { name: 'EFILE_DEFENDANT', value: 28 },
        EFILE_DOCUMENT: { name: 'EFILE_DOCUMENT', value: 26 },
        EFILE_MATERIAL: { name: 'EFILE_MATERIAL', value: 27 },
        EFILE_OFFICER: { name: 'EFILE_OFFICER', value: 31 },
        EFILE_TASK: { name: 'EFILE_TASK', value: 25 },
        EFILE_VICTIM_WITNESS: { name: 'EFILE_VICTIM_WITNESS', value: 29 },
        ENTITY_PROFILE_TASK: { name: 'ENTITY_PROFILE_TASK', value: 23 },
        EVIDENCE_ITEM: { name: 'EVIDENCE_ITEM', value: 14 },
        LOCATION: { name: 'LOCATION', value: 32 },
        ORGANIZATION: { name: 'ORGANIZATION', value: 5 },
        PERSON: { name: 'PERSON', value: 2 },
        PROPERTY: { name: 'PROPERTY', value: 6 },
        REPORT: { name: 'REPORT', value: 1 },
        REPORTS_DASHBOARD: { name: 'REPORTS_DASHBOARD', value: 18 },
        REPORT_NOT_ASSIGNED_TO_CASE: { name: 'REPORT_NOT_ASSIGNED_TO_CASE', value: 8 },
        ROLODEX_PROFILE: { name: 'ROLODEX_PROFILE', value: 16 },
        TASK: { name: 'TASK', value: 13 },
        UNIT_STATUS: { name: 'UNIT_STATUS', value: 11 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 9 },
        USER_ACTION: { name: 'USER_ACTION', value: 17 },
        VEHICLE: { name: 'VEHICLE', value: 4 },
        WARRANT: { name: 'WARRANT', value: 12 },
    },
    JA = {
        CAD_ELECTRON: { name: 'CAD_ELECTRON', value: 'cad-electron' },
        CAD_LEGACY: { name: 'CAD_LEGACY', value: 'cad-legacy' },
        FR_ELECTRON: { name: 'FR_ELECTRON', value: 'fr-electron' },
        FR_LEGACY: { name: 'FR_LEGACY', value: 'fr-legacy' },
        LEGACY: { name: 'LEGACY', value: 'legacy' },
    },
    hA = {
        ALLOWED: { name: 'ALLOWED' },
        DISABLED: { name: 'DISABLED' },
        RATE_LIMITED: { name: 'RATE_LIMITED' },
        REDIS_UNAVAILABLE: { name: 'REDIS_UNAVAILABLE' },
    },
    ZA = { ERROR: { name: 'ERROR' }, PENDING: { name: 'PENDING' }, SUCCESS: { name: 'SUCCESS' } },
    jA = {
        APPROVED_REPORT: { name: 'APPROVED_REPORT', value: 'Approved_IncidentReport_aws_v6' },
        ASSOCIATED_RECORD_ADDED_TO_REPORT: {
            name: 'ASSOCIATED_RECORD_ADDED_TO_REPORT',
            value: 'associatedRecordAddedToReport_aws_v6',
        },
        ASSOCIATED_RECORD_ADDED_TO_REPORT_IN_CASE: {
            name: 'ASSOCIATED_RECORD_ADDED_TO_REPORT_IN_CASE',
            value: 'associatedRecordAddedToReportInCase_aws_v7',
        },
        CAD_DEBUG_TEMPLATE: { name: 'CAD_DEBUG_TEMPLATE', value: 'cad_debug_report_templateV2' },
        CASE_APPROVED: { name: 'CASE_APPROVED', value: 'case_approved_aws_v7' },
        CASE_ASSIGNED: { name: 'CASE_ASSIGNED', value: 'caseAssigned_aws_v7' },
        CASE_ASSIGNED_UNIT: { name: 'CASE_ASSIGNED_UNIT', value: 'caseAssigned_Unit_aws_v7' },
        CASE_ASSIGNMENT_REMOVED_SUPERVISOR: {
            name: 'CASE_ASSIGNMENT_REMOVED_SUPERVISOR',
            value: 'caseAssignmentRemovedSupervisor_aws_v7',
        },
        CASE_ASSIGNMENT_UPDATED_SUPERVISOR: {
            name: 'CASE_ASSIGNMENT_UPDATED_SUPERVISOR',
            value: 'caseAssignmentUpdatedSupervisor_aws_v7',
        },
        CASE_NOTE_ADDED: { name: 'CASE_NOTE_ADDED', value: 'caseNoteAdded_aws_v7' },
        CASE_NOTE_REMOVED: { name: 'CASE_NOTE_REMOVED', value: 'caseNoteRemoved_aws_v7' },
        CASE_REJECTED: { name: 'CASE_REJECTED', value: 'case_rejected_aws_v7' },
        CASE_REPORT_STATUS_APPROVED: {
            name: 'CASE_REPORT_STATUS_APPROVED',
            value: 'caseUpdated_reportApproved_aws_v7',
        },
        CASE_REPORT_STATUS_DRAFT: {
            name: 'CASE_REPORT_STATUS_DRAFT',
            value: 'caseUpdated_reportReturnedToDraft_aws_v7',
        },
        CASE_REPORT_STATUS_REJECTED: {
            name: 'CASE_REPORT_STATUS_REJECTED',
            value: 'caseUpdated_reportRejected_aws_v7',
        },
        CASE_REVIEWED: { name: 'CASE_REVIEWED', value: 'caseReviewed_aws_v7' },
        CASE_REVIEW_REQUESTED: {
            name: 'CASE_REVIEW_REQUESTED',
            value: 'caseReview_requested_aws_v7',
        },
        CASE_STATUS_CHANGED: { name: 'CASE_STATUS_CHANGED', value: 'caseStatus_changed_aws_v7' },
        CASE_TARGET_PROFILE_REVIEW_DUE_TODAY: {
            name: 'CASE_TARGET_PROFILE_REVIEW_DUE_TODAY',
            value: 'caseTargetProfileReviewDueToday',
        },
        CASE_UNASSIGNED: { name: 'CASE_UNASSIGNED', value: 'caseUnassigned_aws_v7' },
        CATHEDRAL_CITY_ACTIVE911: {
            name: 'CATHEDRAL_CITY_ACTIVE911',
            value: 'cathedral_city_active911_v2',
        },
        CONFIRM_EMAIL_ADDRESS: {
            name: 'CONFIRM_EMAIL_ADDRESS',
            value: 'confirm_email_address_aws_v3',
        },
        DIRECT_EMAIL_COMMON: { name: 'DIRECT_EMAIL_COMMON', value: 'direct_email_common_v2' },
        DUPLICATE_PROFILES_IDENTIFIED: {
            name: 'DUPLICATE_PROFILES_IDENTIFIED',
            value: 'duplicateProfilesIdentified_aws_v5',
        },
        EVIDENCE_ITEM_APPROVED_FOR_DISPOSITION: {
            name: 'EVIDENCE_ITEM_APPROVED_FOR_DISPOSITION',
            value: 'Evidence_DispositionApproved_aws_v5',
        },
        EVIDENCE_ITEM_APPROVED_FOR_RELEASE: {
            name: 'EVIDENCE_ITEM_APPROVED_FOR_RELEASE',
            value: 'Evidence_ReleaseApproved_aws_v5',
        },
        EVIDENCE_ITEM_OVERDUE_CLERK: {
            name: 'EVIDENCE_ITEM_OVERDUE_CLERK',
            value: 'Evidence_ItemOverdueClerk_aws_v5',
        },
        EVIDENCE_ITEM_OVERDUE_USER: {
            name: 'EVIDENCE_ITEM_OVERDUE_USER',
            value: 'Evidence_ItemOverdueUser_aws_v5',
        },
        EVIDENCE_REVIEW_ITEM_FOR_DISPOSITION: {
            name: 'EVIDENCE_REVIEW_ITEM_FOR_DISPOSITION',
            value: 'Evidence_ReviewDisposition_aws_v5',
        },
        EXISTING_USER_NEW_ACCOUNT: {
            name: 'EXISTING_USER_NEW_ACCOUNT',
            value: 'existing_user_new_account_aws_v2',
        },
        HTML_BASE_TEMPLATE: {
            name: 'HTML_BASE_TEMPLATE',
            value: 'basic_html_message_body_template',
        },
        PARTNERSHIPS_BLANK_TEMPLATE: {
            name: 'PARTNERSHIPS_BLANK_TEMPLATE',
            value: 'ptnr_blank_template_v2',
        },
        PARTNERSHIPS_BLANK_TEMPLATE_NO_SUBJECT: {
            name: 'PARTNERSHIPS_BLANK_TEMPLATE_NO_SUBJECT',
            value: 'ptnr_blank_template_no_sub_v2',
        },
        PASSWORD_CHANGED: { name: 'PASSWORD_CHANGED', value: 'password_changed_aws_v3' },
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 'password_reset_aws_v3' },
        REPORTING_EVENT_NUMBER_CHANGED: {
            name: 'REPORTING_EVENT_NUMBER_CHANGED',
            value: 'Report_EventNumberChanged_aws_v6',
        },
        REPORT_ADDED_TO_CASE: {
            name: 'REPORT_ADDED_TO_CASE',
            value: 'caseLinkChanged_reportAdded_aws_v7',
        },
        REPORT_AUTHOR_ADDED: { name: 'REPORT_AUTHOR_ADDED', value: 'report_author_added_v2' },
        REPORT_CASE_STATUS_CHANGED: {
            name: 'REPORT_CASE_STATUS_CHANGED',
            value: 'reportCaseStatusChanged_aws_v7',
        },
        REPORT_COMMENT_CREATED: {
            name: 'REPORT_COMMENT_CREATED',
            value: 'reportComment_created_v2',
        },
        REPORT_DELETED: { name: 'REPORT_DELETED', value: 'report_deleted_v2' },
        REPORT_OWNER_MODIFIED: { name: 'REPORT_OWNER_MODIFIED', value: 'report_owner_modified_v2' },
        REPORT_PERMISSION_MODIFIED: {
            name: 'REPORT_PERMISSION_MODIFIED',
            value: 'report_permission_modified_v2',
        },
        REPORT_REMOVED_FROM_CASE: {
            name: 'REPORT_REMOVED_FROM_CASE',
            value: 'caseLinkChanged_reportRemoved_aws_v7',
        },
        REVIEW_NOTIFICATION: {
            name: 'REVIEW_NOTIFICATION',
            value: 'ReportNeedsApproval_IncidentReport_aws_v6',
        },
        SECRET_CHANGE_NOTIFICATION: {
            name: 'SECRET_CHANGE_NOTIFICATION',
            value: 'secret_change_notification_aws_v3',
        },
        SECRET_CHANGE_NOTIFICATION_ADMIN: {
            name: 'SECRET_CHANGE_NOTIFICATION_ADMIN',
            value: 'secret_change_notification_admin_aws_v2',
        },
        SECRET_EXPIRATION_WARNING: {
            name: 'SECRET_EXPIRATION_WARNING',
            value: 'secret_expiration_warning_aws_v2',
        },
        SHARED_SAVED_SEARCH: { name: 'SHARED_SAVED_SEARCH', value: 'savedSearchShared_aws_v5' },
        SHARED_SAVED_SEARCH_DELETED: {
            name: 'SHARED_SAVED_SEARCH_DELETED',
            value: 'sharedSavedSearchDeleted_aws_v5',
        },
        SHARED_SAVED_SEARCH_UPDATED: {
            name: 'SHARED_SAVED_SEARCH_UPDATED',
            value: 'sharedSavedSearchUpdated_aws_v5',
        },
        STAFF_REVIEW_APPROVED_RETURNED_TO_DRAFT: {
            name: 'STAFF_REVIEW_APPROVED_RETURNED_TO_DRAFT',
            value: 'staffReviewApproved_reportReturnedToDraft_aws_v5',
        },
        STAFF_REVIEW_REJECTION_REPORT: {
            name: 'STAFF_REVIEW_REJECTION_REPORT',
            value: 'StaffReviewRejection_IncidentReport_aws_v6',
        },
        SUBSCRIPTION_HIT: { name: 'SUBSCRIPTION_HIT', value: 'subscriptionHit_aws_v5' },
        SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT: {
            name: 'SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT',
            value: 'suggestedAssociatedRecordAddedToReport_aws_v6',
        },
        SUPERVISOR_REJECTION_REPORT: {
            name: 'SUPERVISOR_REJECTION_REPORT',
            value: 'SupervisorRejection_IncidentReport_aws_v6',
        },
        SYSTEM_ALERT: { name: 'SYSTEM_ALERT', value: 'system_alert_v2' },
        TASK_ASSIGNED: { name: 'TASK_ASSIGNED', value: 'taskAssigned_aws_v5' },
        TASK_DUE_TODAY: { name: 'TASK_DUE_TODAY', value: 'taskDueToday_aws_v5' },
        TASK_STATUS_CHANGED: { name: 'TASK_STATUS_CHANGED', value: 'taskStatusChanged_aws_v5' },
        TEST_TEMPLATE: { name: 'TEST_TEMPLATE', value: 'test_template_aws_v1' },
        TEST_TEMPLATE_WITH_CONDITIONALS: {
            name: 'TEST_TEMPLATE_WITH_CONDITIONALS',
            value: 'test_template_with_conditionals_aws_v1',
        },
        TWO_FACTOR_CODE: { name: 'TWO_FACTOR_CODE', value: 'two_factor_code_aws_v3' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    xA = {
        HOME_EMAIL: { name: 'HOME_EMAIL', value: 'Home Email' },
        OTHER_EMAIL: { name: 'OTHER_EMAIL', value: 'Other Email' },
        PERSONAL_EMAIL: { name: 'PERSONAL_EMAIL', value: 'Personal Email' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
        WORK_EMAIL: { name: 'WORK_EMAIL', value: 'Work Email' },
    },
    kA = {
        NULL_CHECK_ONLY: { name: 'NULL_CHECK_ONLY' },
        TRIM_AND_CHECK: { name: 'TRIM_AND_CHECK' },
    },
    wA = {
        ARRAY: { name: 'ARRAY' },
        BOOLEAN: { name: 'BOOLEAN' },
        BYTE: { name: 'BYTE' },
        COLLECTION: { name: 'COLLECTION' },
        DEFAULT: { name: 'DEFAULT' },
        DOUBLE: { name: 'DOUBLE' },
        FLOAT: { name: 'FLOAT' },
        INTEGER: { name: 'INTEGER' },
        LONG: { name: 'LONG' },
        MAP: { name: 'MAP' },
        SHORT: { name: 'SHORT' },
        STRING: { name: 'STRING' },
    },
    zA = { REPORT: { name: 'REPORT', value: 1 }, UNKNOWN: { name: 'UNKNOWN', value: -1 } },
    qA = {
        ALLOWED: { name: 'ALLOWED', value: 'allowed' },
        BLOCKED: { name: 'BLOCKED', value: 'blocked' },
    },
    $A = {
        NON_PAGINATED: { name: 'NON_PAGINATED', value: 'non_paginated' },
        PAGINATED: { name: 'PAGINATED', value: 'paginated' },
    },
    EN = {
        COMPLETE: { name: 'COMPLETE', value: 'complete' },
        TRUNCATED: { name: 'TRUNCATED', value: 'truncated' },
    },
    _N = {
        ADDITIONAL_INFO: { name: 'ADDITIONAL_INFO', value: 46 },
        AGENCY: { name: 'AGENCY', value: 25 },
        AGENCY_EVENT_CAUTIONS_TYPE: { name: 'AGENCY_EVENT_CAUTIONS_TYPE', value: 258 },
        AGENCY_EVENT_EXPUNGEMENT_LOG: { name: 'AGENCY_EVENT_EXPUNGEMENT_LOG', value: 281 },
        AGENCY_EVENT_LINKED_ENTITY_CHANGED: {
            name: 'AGENCY_EVENT_LINKED_ENTITY_CHANGED',
            value: 157,
        },
        AGENCY_EVENT_RFA_DETAILS: { name: 'AGENCY_EVENT_RFA_DETAILS', value: 259 },
        ALERT_SCHEDULE: { name: 'ALERT_SCHEDULE', value: 125 },
        AML_PHONE_CALL: { name: 'AML_PHONE_CALL', value: 229 },
        AML_RAPIDSOS_CONFIG: { name: 'AML_RAPIDSOS_CONFIG', value: 231 },
        ARREST: { name: 'ARREST', value: 13 },
        ASN: { name: 'ASN', value: 334 },
        ATF_IMPORTER: { name: 'ATF_IMPORTER', value: 328 },
        ATF_MANUFACTURER: { name: 'ATF_MANUFACTURER', value: 294 },
        ATTACHMENT: { name: 'ATTACHMENT', value: 28 },
        BARCODE: { name: 'BARCODE', value: 61 },
        BEHAVIORAL_CRISIS: { name: 'BEHAVIORAL_CRISIS', value: 127 },
        BOLO: { name: 'BOLO', value: 211 },
        BOLO_ATTRIBUTE: { name: 'BOLO_ATTRIBUTE', value: 318 },
        BOLO_RECIPIENT: { name: 'BOLO_RECIPIENT', value: 212 },
        BOLO_SUBJECT: { name: 'BOLO_SUBJECT', value: 319 },
        BOLO_TYPE: { name: 'BOLO_TYPE', value: 317 },
        BOND: { name: 'BOND', value: 355 },
        BOOKING: { name: 'BOOKING', value: 276 },
        BRIEFING: { name: 'BRIEFING', value: 291 },
        BUSINESS_TYPE: { name: 'BUSINESS_TYPE', value: 335 },
        CAD_AGENCY_EVENT: { name: 'CAD_AGENCY_EVENT', value: 42 },
        CAD_COMMON_EVENT: { name: 'CAD_COMMON_EVENT', value: 41 },
        CAD_INTEGRATION_PROFILE: { name: 'CAD_INTEGRATION_PROFILE', value: 251 },
        CAD_INTEGRATION_PROFILE_META_CONFIG: {
            name: 'CAD_INTEGRATION_PROFILE_META_CONFIG',
            value: 252,
        },
        CAD_INTEGRATION_TRIAGE_QUESTION: { name: 'CAD_INTEGRATION_TRIAGE_QUESTION', value: 250 },
        CAD_INTEGRATION_TYPE: { name: 'CAD_INTEGRATION_TYPE', value: 253 },
        CAD_PHONE_NUMBER: { name: 'CAD_PHONE_NUMBER', value: 71 },
        CAD_TICKET: { name: 'CAD_TICKET', value: 31 },
        CAD_UNIT_LOCATIONS: { name: 'CAD_UNIT_LOCATIONS', value: 73 },
        CAD_USER_LOCATIONS: { name: 'CAD_USER_LOCATIONS', value: 86 },
        CALENDAR_EVENT: { name: 'CALENDAR_EVENT', value: 389 },
        CALL_FOR_SERVICE: { name: 'CALL_FOR_SERVICE', value: 40 },
        CALL_TAKER_STATION: { name: 'CALL_TAKER_STATION', value: 151 },
        CASE: { name: 'CASE', value: 4 },
        CASE_APPROVAL_STATUS: { name: 'CASE_APPROVAL_STATUS', value: 65 },
        CASE_DEFINITION: { name: 'CASE_DEFINITION', value: 97 },
        CASE_NOTE: { name: 'CASE_NOTE', value: 29 },
        CASE_REPORT_LINK: { name: 'CASE_REPORT_LINK', value: 287 },
        CASE_REVIEW: { name: 'CASE_REVIEW', value: 64 },
        CASE_STATUS: { name: 'CASE_STATUS', value: 66 },
        CHAIN_EVENT: { name: 'CHAIN_EVENT', value: 59 },
        CHAIN_EVENT_TYPE: { name: 'CHAIN_EVENT_TYPE', value: 58 },
        CHAIN_OF_CUSTODY: { name: 'CHAIN_OF_CUSTODY', value: 60 },
        CHARGE: { name: 'CHARGE', value: 81 },
        CITATION: { name: 'CITATION', value: 91 },
        CITATION_CHARGE: { name: 'CITATION_CHARGE', value: 92 },
        CITATION_NUMBER: { name: 'CITATION_NUMBER', value: 344 },
        CLI_ARGUMENT_CONFIGURATION: { name: 'CLI_ARGUMENT_CONFIGURATION', value: 108 },
        COMMAND_RECORD: { name: 'COMMAND_RECORD', value: 105 },
        COMPLIANCE_EXPORT: { name: 'COMPLIANCE_EXPORT', value: 198 },
        COMPLIANCE_EXPORTED_REPORT: { name: 'COMPLIANCE_EXPORTED_REPORT', value: 202 },
        CONFIGURED_ENTITY_INSTANCE: { name: 'CONFIGURED_ENTITY_INSTANCE', value: 162 },
        CONFIGURED_ENTITY_INSTANCE_CORE_MODEL_LINK: {
            name: 'CONFIGURED_ENTITY_INSTANCE_CORE_MODEL_LINK',
            value: 172,
        },
        CONFIGURED_ENTITY_PROPERTY: { name: 'CONFIGURED_ENTITY_PROPERTY', value: 169 },
        CONFIGURED_ENTITY_PROPERTY_CORE_MODEL_LINK: {
            name: 'CONFIGURED_ENTITY_PROPERTY_CORE_MODEL_LINK',
            value: 173,
        },
        CONFIGURED_ENTITY_TYPE: { name: 'CONFIGURED_ENTITY_TYPE', value: 168 },
        CONFIGURED_FORM: { name: 'CONFIGURED_FORM', value: 174 },
        CONFIGURED_FORM_BASE_ENTITY_LINK: { name: 'CONFIGURED_FORM_BASE_ENTITY_LINK', value: 176 },
        CONFIGURED_FORM_CONFIGURED_RULE_LINK: {
            name: 'CONFIGURED_FORM_CONFIGURED_RULE_LINK',
            value: 188,
        },
        CONFIGURED_FORM_ENTITY_CONTAINER_LINK: {
            name: 'CONFIGURED_FORM_ENTITY_CONTAINER_LINK',
            value: 286,
        },
        CONFIGURED_FORM_PROPERTY_ALIAS: { name: 'CONFIGURED_FORM_PROPERTY_ALIAS', value: 255 },
        CONFIGURED_FORM_QUERY_CONFIGURATION: {
            name: 'CONFIGURED_FORM_QUERY_CONFIGURATION',
            value: 256,
        },
        CONFIGURED_RULE: { name: 'CONFIGURED_RULE', value: 187 },
        CONFIGURED_RULE_CONDITION: { name: 'CONFIGURED_RULE_CONDITION', value: 189 },
        CONFIGURED_RULE_EFFECT: { name: 'CONFIGURED_RULE_EFFECT', value: 190 },
        CONFIGURED_RULE_EFFECT_MESSAGE_TEMPLATE: {
            name: 'CONFIGURED_RULE_EFFECT_MESSAGE_TEMPLATE',
            value: 191,
        },
        CONTEXT: { name: 'CONTEXT', value: 149 },
        CONVERSATION: { name: 'CONVERSATION', value: 140 },
        CONVERSATION_MESSAGE: { name: 'CONVERSATION_MESSAGE', value: 142 },
        CORE_MODEL_DEFAULT_CFG_ENTITY_TYPE_LINK: {
            name: 'CORE_MODEL_DEFAULT_CFG_ENTITY_TYPE_LINK',
            value: 225,
        },
        COURT: { name: 'COURT', value: 290 },
        COURT_CASE: { name: 'COURT_CASE', value: 39 },
        COURT_HEARING: { name: 'COURT_HEARING', value: 339 },
        COURT_HEARING_CUSTODY_INFO: { name: 'COURT_HEARING_CUSTODY_INFO', value: 343 },
        COURT_ORDER: { name: 'COURT_ORDER', value: 9 },
        COURT_ROOM: { name: 'COURT_ROOM', value: 333 },
        COURT_ROOM_TIMETABLE: { name: 'COURT_ROOM_TIMETABLE', value: 338 },
        COURT_ROOM_TIME_SLOT: { name: 'COURT_ROOM_TIME_SLOT', value: 337 },
        CRASH_DETAIL: { name: 'CRASH_DETAIL', value: 315 },
        CRASH_TRAFFIC_LOCATION: { name: 'CRASH_TRAFFIC_LOCATION', value: 316 },
        CUSTODIAL_RESPONSIBLE_OFFICER: { name: 'CUSTODIAL_RESPONSIBLE_OFFICER', value: 77 },
        DEBUG_FILE_INFO: { name: 'DEBUG_FILE_INFO', value: 201 },
        DEBUG_SNAPSHOT: { name: 'DEBUG_SNAPSHOT', value: 200 },
        DEDUPLICATE_BUCKET_FUNCTION: { name: 'DEDUPLICATE_BUCKET_FUNCTION', value: 181 },
        DEFAULT_FOLDER: { name: 'DEFAULT_FOLDER', value: 269 },
        DEFAULT_UNIT_VEHICLE: { name: 'DEFAULT_UNIT_VEHICLE', value: 223 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 78 },
        DETAINEE: { name: 'DETAINEE', value: 350 },
        DETAINEE_IDENTIFIER_VALUE: { name: 'DETAINEE_IDENTIFIER_VALUE', value: 357 },
        DETAINEE_TRANSFER: { name: 'DETAINEE_TRANSFER', value: 358 },
        DETENTION: { name: 'DETENTION', value: 308 },
        DEVICE: { name: 'DEVICE', value: 69 },
        DEVICE_IN_GEOFENCE: { name: 'DEVICE_IN_GEOFENCE', value: 249 },
        DEX_INCOMING_MESSAGE: { name: 'DEX_INCOMING_MESSAGE', value: 277 },
        DEX_OUTGOING_MESSAGE: { name: 'DEX_OUTGOING_MESSAGE', value: 134 },
        DISCLAIMER_MESSAGE: { name: 'DISCLAIMER_MESSAGE', value: 323 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 115 },
        DISPOSITION: { name: 'DISPOSITION', value: 327 },
        DISPOSITION_EVENT: { name: 'DISPOSITION_EVENT', value: 80 },
        DOJ_SCHOOL: { name: 'DOJ_SCHOOL', value: 239 },
        ELASTIC_MATERIALIZED_LOCATION: { name: 'ELASTIC_MATERIALIZED_LOCATION', value: 275 },
        EMAIL_EXPORT_RELEASE: { name: 'EMAIL_EXPORT_RELEASE', value: 297 },
        EMAIL_EXPORT_RELEASE_ENTITY: { name: 'EMAIL_EXPORT_RELEASE_ENTITY', value: 299 },
        EMAIL_EXPORT_RELEASE_FILE_LINK: { name: 'EMAIL_EXPORT_RELEASE_FILE_LINK', value: 298 },
        ENTITY_ORDERED_ATTRIBUTE: { name: 'ENTITY_ORDERED_ATTRIBUTE', value: 209 },
        EQUIPMENT: { name: 'EQUIPMENT', value: 45 },
        EVENTS_LOG: { name: 'EVENTS_LOG', value: 351 },
        EVENT_ASSOCIATION_REASON: { name: 'EVENT_ASSOCIATION_REASON', value: 230 },
        EVENT_CLEARING: { name: 'EVENT_CLEARING', value: 70 },
        EVENT_LABEL: { name: 'EVENT_LABEL', value: 228 },
        EVENT_REACTIVATION_REASON: { name: 'EVENT_REACTIVATION_REASON', value: 89 },
        EVENT_UNLINK_REASON: { name: 'EVENT_UNLINK_REASON', value: 79 },
        EVIDENCE_ENTITY_SETTING: { name: 'EVIDENCE_ENTITY_SETTING', value: 235 },
        EVIDENCE_FACILITY: { name: 'EVIDENCE_FACILITY', value: 53 },
        EVIDENCE_INVENTORY: { name: 'EVIDENCE_INVENTORY', value: 93 },
        EVIDENCE_INVENTORY_ITEM: { name: 'EVIDENCE_INVENTORY_ITEM', value: 153 },
        EVIDENCE_PRINTING_TEMPLATE: { name: 'EVIDENCE_PRINTING_TEMPLATE', value: 129 },
        EVIDENCE_STAFF_REMARK: { name: 'EVIDENCE_STAFF_REMARK', value: 116 },
        EVIDENCE_STORAGE_LOCATION: { name: 'EVIDENCE_STORAGE_LOCATION', value: 55 },
        EVIDENCE_STORAGE_PATH: { name: 'EVIDENCE_STORAGE_PATH', value: 56 },
        EXPORT_PRESET: { name: 'EXPORT_PRESET', value: 161 },
        EXPORT_PRESET_REPORT_TYPE: { name: 'EXPORT_PRESET_REPORT_TYPE', value: 182 },
        EXPORT_RELEASE: { name: 'EXPORT_RELEASE', value: 90 },
        EXPORT_RELEASE_ENTITY: { name: 'EXPORT_RELEASE_ENTITY', value: 158 },
        EXTERNAL_AGENCY_EVENT: { name: 'EXTERNAL_AGENCY_EVENT', value: 260 },
        EXTERNAL_AGENCY_EVENT_ACTION: { name: 'EXTERNAL_AGENCY_EVENT_ACTION', value: 261 },
        EXTERNAL_OFFICER: { name: 'EXTERNAL_OFFICER', value: 388 },
        EXTERNAL_REPORT_STATUS: { name: 'EXTERNAL_REPORT_STATUS', value: 199 },
        E_FILE: { name: 'E_FILE', value: 283 },
        E_FILE_DOCUMENT: { name: 'E_FILE_DOCUMENT', value: 342 },
        E_FILE_DOCUMENT_CONFIGURATION: { name: 'E_FILE_DOCUMENT_CONFIGURATION', value: 331 },
        E_FILE_OFFENSE: { name: 'E_FILE_OFFENSE', value: 329 },
        E_FILE_OFFENSE_BAIL: { name: 'E_FILE_OFFENSE_BAIL', value: 340 },
        E_FILE_OFFENSE_DECISION: { name: 'E_FILE_OFFENSE_DECISION', value: 330 },
        E_FILE_VICTIM_WITNESS: { name: 'E_FILE_VICTIM_WITNESS', value: 345 },
        FIELD_BIGINT_VALUE: { name: 'FIELD_BIGINT_VALUE', value: 164 },
        FIELD_BOOLEAN_VALUE: { name: 'FIELD_BOOLEAN_VALUE', value: 184 },
        FIELD_CONFIGURATION: { name: 'FIELD_CONFIGURATION', value: 98 },
        FIELD_CONTACT: { name: 'FIELD_CONTACT', value: 27 },
        FIELD_DATETIME_VALUE: { name: 'FIELD_DATETIME_VALUE', value: 166 },
        FIELD_DECIMAL_VALUE: { name: 'FIELD_DECIMAL_VALUE', value: 165 },
        FIELD_ENTITY_ID_VALUE: { name: 'FIELD_ENTITY_ID_VALUE', value: 167 },
        FIELD_NOTE: { name: 'FIELD_NOTE', value: 110 },
        FIELD_STRING_VALUE: { name: 'FIELD_STRING_VALUE', value: 163 },
        FILE: { name: 'FILE', value: 11 },
        FINANCIAL_TRANSACTION: { name: 'FINANCIAL_TRANSACTION', value: 359 },
        FOLDER: { name: 'FOLDER', value: 270 },
        FOLDER_CONTENT: { name: 'FOLDER_CONTENT', value: 271 },
        FORM_CONFIG: { name: 'FORM_CONFIG', value: 360 },
        FORM_DATA: { name: 'FORM_DATA', value: 361 },
        GEOFENCE: { name: 'GEOFENCE', value: 234 },
        GEOFENCE_EVENT_LINK: { name: 'GEOFENCE_EVENT_LINK', value: 237 },
        GEOFENCE_RULE: { name: 'GEOFENCE_RULE', value: 244 },
        GEOFENCE_STYLE: { name: 'GEOFENCE_STYLE', value: 236 },
        GEORULE_EVENT_TYPE_LINK: { name: 'GEORULE_EVENT_TYPE_LINK', value: 245 },
        GEORULE_NOTIFY_CALLTKR_LINK: { name: 'GEORULE_NOTIFY_CALLTKR_LINK', value: 247 },
        GEORULE_NOTIFY_DISPATCH_LINK: { name: 'GEORULE_NOTIFY_DISPATCH_LINK', value: 246 },
        GEORULE_NOTIFY_USER_LINK: { name: 'GEORULE_NOTIFY_USER_LINK', value: 248 },
        GEO_ADDRESS_POINT_MAPPING: { name: 'GEO_ADDRESS_POINT_MAPPING', value: 267 },
        GEO_ADDRESS_POINT_TYPE: { name: 'GEO_ADDRESS_POINT_TYPE', value: 263 },
        GEO_ALIAS: { name: 'GEO_ALIAS', value: 262 },
        GEO_CAUTION: { name: 'GEO_CAUTION', value: 257 },
        GEO_VERSION_TYPE: { name: 'GEO_VERSION_TYPE', value: 264 },
        HELD_EVENT: { name: 'HELD_EVENT', value: 147 },
        HELD_UNIT: { name: 'HELD_UNIT', value: 148 },
        HOLD: { name: 'HOLD', value: 362 },
        HOSPITAL: { name: 'HOSPITAL', value: 309 },
        ID_FORMAT_CONFIGURATION: { name: 'ID_FORMAT_CONFIGURATION', value: 150 },
        IMAGE: { name: 'IMAGE', value: 17 },
        IMPOUND: { name: 'IMPOUND', value: 33 },
        INTEGRATION: { name: 'INTEGRATION', value: 107 },
        INTEGRATION_ENTITY_ID_MAPPING: { name: 'INTEGRATION_ENTITY_ID_MAPPING', value: 203 },
        INVOLVED_PERSON: { name: 'INVOLVED_PERSON', value: 243 },
        ITEM_CATEGORY: { name: 'ITEM_CATEGORY', value: 232 },
        ITEM_PROFILE: { name: 'ITEM_PROFILE', value: 5 },
        ITEM_TYPE: { name: 'ITEM_TYPE', value: 233 },
        JMS_ARREST: { name: 'JMS_ARREST', value: 352 },
        JMS_ATTACHMENT: { name: 'JMS_ATTACHMENT', value: 386 },
        JMS_ATTRIBUTE: { name: 'JMS_ATTRIBUTE', value: 349 },
        JMS_ATTRIBUTE_CUSTOM_FORM_CONFIG: { name: 'JMS_ATTRIBUTE_CUSTOM_FORM_CONFIG', value: 353 },
        JMS_ATTRIBUTE_TYPE: { name: 'JMS_ATTRIBUTE_TYPE', value: 354 },
        JMS_BAIL_APPOINTMENT: { name: 'JMS_BAIL_APPOINTMENT', value: 377 },
        JMS_BAIL_APPOINTMENT_EVENT: { name: 'JMS_BAIL_APPOINTMENT_EVENT', value: 387 },
        JMS_CHARGE: { name: 'JMS_CHARGE', value: 356 },
        JMS_DETAINEE_IDENTIFIER_VALUE: { name: 'JMS_DETAINEE_IDENTIFIER_VALUE', value: 375 },
        JMS_FILE_METADATA: { name: 'JMS_FILE_METADATA', value: 385 },
        JMS_IDENTIFIER: { name: 'JMS_IDENTIFIER', value: 366 },
        JMS_IDENTIFIER_VALUE: { name: 'JMS_IDENTIFIER_VALUE', value: 374 },
        JMS_LIVE_SCAN_RESULT: { name: 'JMS_LIVE_SCAN_RESULT', value: 373 },
        JMS_LOCATION: { name: 'JMS_LOCATION', value: 348 },
        JMS_LOCATION_TAG_ATTRIBUTE: { name: 'JMS_LOCATION_TAG_ATTRIBUTE', value: 363 },
        JMS_MUGSHOT: { name: 'JMS_MUGSHOT', value: 381 },
        JMS_OFFENSE_CODE: { name: 'JMS_OFFENSE_CODE', value: 364 },
        JMS_OFFICER_REFERENCE: { name: 'JMS_OFFICER_REFERENCE', value: 390 },
        JMS_PROPERTY: { name: 'JMS_PROPERTY', value: 367 },
        JMS_SCHEDULE: { name: 'JMS_SCHEDULE', value: 382 },
        JMS_SCHEDULED_EVENT: { name: 'JMS_SCHEDULED_EVENT', value: 383 },
        JMS_SCHEDULED_EVENT_INSTANCE: { name: 'JMS_SCHEDULED_EVENT_INSTANCE', value: 384 },
        JMS_SCHEDULED_INSTANCE: { name: 'JMS_SCHEDULED_INSTANCE', value: 378 },
        JMS_USER: { name: 'JMS_USER', value: 347 },
        JMS_VA_APPOINTMENT: { name: 'JMS_VA_APPOINTMENT', value: 379 },
        JMS_VA_APPOINTMENT_EVENT: { name: 'JMS_VA_APPOINTMENT_EVENT', value: 380 },
        JMS_WARNING_SIGNAL: { name: 'JMS_WARNING_SIGNAL', value: 372 },
        JMS_WARRANT: { name: 'JMS_WARRANT', value: 365 },
        LATEST_SEEN_DEX_INCOMING_MESSAGE: { name: 'LATEST_SEEN_DEX_INCOMING_MESSAGE', value: 282 },
        LOCATION: { name: 'LOCATION', value: 2 },
        LOCATION_CAUTION: { name: 'LOCATION_CAUTION', value: 85 },
        MARKER: { name: 'MARKER', value: 240 },
        MARKER_STYLE: { name: 'MARKER_STYLE', value: 241 },
        MATERIALIZED_USER_ACTION: { name: 'MATERIALIZED_USER_ACTION', value: 196 },
        MESSAGE: { name: 'MESSAGE', value: 141 },
        MESSAGE_GROUP: { name: 'MESSAGE_GROUP', value: 126 },
        MISSING_PERSON: { name: 'MISSING_PERSON', value: 38 },
        MNEMONIC: { name: 'MNEMONIC', value: 72 },
        MULTI_AGENCY_SUBDIVISION: { name: 'MULTI_AGENCY_SUBDIVISION', value: 266 },
        NIBRS_EXPORT_LINK: { name: 'NIBRS_EXPORT_LINK', value: 112 },
        NIBRS_EXTERNAL_REPORT_SEGMENTS_ERRORS: {
            name: 'NIBRS_EXTERNAL_REPORT_SEGMENTS_ERRORS',
            value: 218,
        },
        NIBRS_FINAL_EXPORT: { name: 'NIBRS_FINAL_EXPORT', value: 272 },
        NIBRS_PROCESSOR_ERROR_CODE: { name: 'NIBRS_PROCESSOR_ERROR_CODE', value: 292 },
        NIBRS_PROCESSOR_TRANSLATOR_ERROR_CODE: {
            name: 'NIBRS_PROCESSOR_TRANSLATOR_ERROR_CODE',
            value: 293,
        },
        NIBRS_REPORT_SEGMENT_DETAIL: { name: 'NIBRS_REPORT_SEGMENT_DETAIL', value: 113 },
        NOTIFICATION: { name: 'NOTIFICATION', value: 67 },
        NOTIFICATION_CENTER_PANEL: { name: 'NOTIFICATION_CENTER_PANEL', value: 265 },
        NOTIFICATION_USER_LINK: { name: 'NOTIFICATION_USER_LINK', value: 109 },
        NY_INCIDENT_LOCATION_CODE: { name: 'NY_INCIDENT_LOCATION_CODE', value: 341 },
        OFFENSE: { name: 'OFFENSE', value: 12 },
        OFFENSE_CASE_STATUS: { name: 'OFFENSE_CASE_STATUS', value: 206 },
        OFFENSE_CODE: { name: 'OFFENSE_CODE', value: 21 },
        ORGANIZATION_PROFILE: { name: 'ORGANIZATION_PROFILE', value: 18 },
        ORI_ALIAS: { name: 'ORI_ALIAS', value: 312 },
        PARTNERSHIPS_REALTIME_ACTION: { name: 'PARTNERSHIPS_REALTIME_ACTION', value: 185 },
        PATROL: { name: 'PATROL', value: 48 },
        PERSONNEL_UNIT: { name: 'PERSONNEL_UNIT', value: 336 },
        PERSON_PROFILE: { name: 'PERSON_PROFILE', value: 10 },
        PHONE_CALL: { name: 'PHONE_CALL', value: 43 },
        PHOTO_LINEUP: { name: 'PHOTO_LINEUP', value: 274 },
        POINT_LOCATION: { name: 'POINT_LOCATION', value: 156 },
        PRINTING_TEMPLATE: { name: 'PRINTING_TEMPLATE', value: 284 },
        PROPERTY_STATUS: { name: 'PROPERTY_STATUS', value: 280 },
        QUEUE: { name: 'QUEUE', value: 118 },
        QUEUE_COLUMN: { name: 'QUEUE_COLUMN', value: 119 },
        QUEUE_COLUMN_FILTER: { name: 'QUEUE_COLUMN_FILTER', value: 311 },
        RADIO_CHANNEL: { name: 'RADIO_CHANNEL', value: 224 },
        REPORT: { name: 'REPORT', value: 16 },
        REPORTING_EVENT: { name: 'REPORTING_EVENT', value: 30 },
        REPORTING_EVENT_NUMBER: { name: 'REPORTING_EVENT_NUMBER', value: 122 },
        REPORTING_PARTY: { name: 'REPORTING_PARTY', value: 54 },
        REPORT_CARD: { name: 'REPORT_CARD', value: 100 },
        REPORT_DEFINITION: { name: 'REPORT_DEFINITION', value: 96 },
        REPORT_GENERATED_SEGMENT: { name: 'REPORT_GENERATED_SEGMENT', value: 273 },
        REPORT_HARD_DELETE_STATUS: { name: 'REPORT_HARD_DELETE_STATUS', value: 332 },
        REPORT_MODULE: { name: 'REPORT_MODULE', value: 295 },
        REPORT_NOTIFICATION: { name: 'REPORT_NOTIFICATION', value: 35 },
        REPORT_PRINTING_TEMPLATE: { name: 'REPORT_PRINTING_TEMPLATE', value: 183 },
        RESPONSE_PLAN_DEPRIORITIZED_UNIT_STATE: {
            name: 'RESPONSE_PLAN_DEPRIORITIZED_UNIT_STATE',
            value: 322,
        },
        RESPONSE_PLAN_TIE_BREAK_PREFERENCE: {
            name: 'RESPONSE_PLAN_TIE_BREAK_PREFERENCE',
            value: 321,
        },
        RETENTION_POLICY: { name: 'RETENTION_POLICY', value: 101 },
        RIPA_OFFENSE_CODE: { name: 'RIPA_OFFENSE_CODE', value: 242 },
        RMS_AUTOGENERATED_REPORTING_EVENT_NUMBER: {
            name: 'RMS_AUTOGENERATED_REPORTING_EVENT_NUMBER',
            value: 227,
        },
        RMS_TOW_VEHICLE: { name: 'RMS_TOW_VEHICLE', value: 68 },
        ROLE: { name: 'ROLE', value: 20 },
        ROLODEX_CONTACT: { name: 'ROLODEX_CONTACT', value: 103 },
        ROLODEX_PROFILE: { name: 'ROLODEX_PROFILE', value: 102 },
        ROTATION_LIST: { name: 'ROTATION_LIST', value: 145 },
        ROTATION_LIST_AREA: { name: 'ROTATION_LIST_AREA', value: 296 },
        ROTATION_SERVICE_LIST_ENTITY: { name: 'ROTATION_SERVICE_LIST_ENTITY', value: 144 },
        RULE: { name: 'RULE', value: 99 },
        RULE_CONDITION: { name: 'RULE_CONDITION', value: 139 },
        SAVED_SEARCH: { name: 'SAVED_SEARCH', value: 160 },
        SCHEDULE: { name: 'SCHEDULE', value: 104 },
        SCHEDULED_AGENCY_EVENT: { name: 'SCHEDULED_AGENCY_EVENT', value: 154 },
        SCHEDULED_EVENT_TIMES: { name: 'SCHEDULED_EVENT_TIMES', value: 155 },
        SECURITY_CLASSIFICATION: { name: 'SECURITY_CLASSIFICATION', value: 313 },
        SERVICE_ROTATION_CAPABILITY: { name: 'SERVICE_ROTATION_CAPABILITY', value: 143 },
        SERVICE_ROTATION_PROVIDER: { name: 'SERVICE_ROTATION_PROVIDER', value: 135 },
        SERVICE_ROTATION_TYPE: { name: 'SERVICE_ROTATION_TYPE', value: 132 },
        SHAPEFILE: { name: 'SHAPEFILE', value: 130 },
        SHORTCUT_KEY: { name: 'SHORTCUT_KEY', value: 114 },
        SPECIAL_ASSIGNMENT: { name: 'SPECIAL_ASSIGNMENT', value: 49 },
        STATION: { name: 'STATION', value: 131 },
        STATION_ADDRESS: { name: 'STATION_ADDRESS', value: 376 },
        STOP: { name: 'STOP', value: 170 },
        STOP_ANONYMOUS_SUBJECT: { name: 'STOP_ANONYMOUS_SUBJECT', value: 238 },
        STREET: { name: 'STREET', value: 82 },
        STREET_CENTERLINE_MAPPING: { name: 'STREET_CENTERLINE_MAPPING', value: 124 },
        STREET_SEGMENT: { name: 'STREET_SEGMENT', value: 83 },
        STREET_SEGMENT_VERSION: { name: 'STREET_SEGMENT_VERSION', value: 146 },
        SUBDIVISION: { name: 'SUBDIVISION', value: 186 },
        SUBJECT_DATA: { name: 'SUBJECT_DATA', value: 136 },
        SUBJECT_STOP: { name: 'SUBJECT_STOP', value: 137 },
        SUBMISSION: { name: 'SUBMISSION', value: 23 },
        SUBMISSION_MESSAGE: { name: 'SUBMISSION_MESSAGE', value: 289 },
        SUBMISSION_MESSAGE_TYPE: { name: 'SUBMISSION_MESSAGE_TYPE', value: 288 },
        TASK: { name: 'TASK', value: 63 },
        TASK_LIST: { name: 'TASK_LIST', value: 95 },
        TOW_VEHICLE: { name: 'TOW_VEHICLE', value: 52 },
        TRAFFIC_CRASH: { name: 'TRAFFIC_CRASH', value: 192 },
        TRAFFIC_CRASH_CUSTOM_ATTRIBUTE: { name: 'TRAFFIC_CRASH_CUSTOM_ATTRIBUTE', value: 217 },
        TRAFFIC_CRASH_CUSTOM_FIELD: { name: 'TRAFFIC_CRASH_CUSTOM_FIELD', value: 216 },
        TRAFFIC_CRASH_DIAGRAM_CONTENT: { name: 'TRAFFIC_CRASH_DIAGRAM_CONTENT', value: 220 },
        TRAFFIC_CRASH_ENTITY_DETAIL: { name: 'TRAFFIC_CRASH_ENTITY_DETAIL', value: 197 },
        TRAFFIC_CRASH_PERSON: { name: 'TRAFFIC_CRASH_PERSON', value: 194 },
        TRAFFIC_CRASH_PERSON_OFFENSE: { name: 'TRAFFIC_CRASH_PERSON_OFFENSE', value: 207 },
        TRAFFIC_CRASH_ROADWAY: { name: 'TRAFFIC_CRASH_ROADWAY', value: 193 },
        TRAFFIC_CRASH_VEHICLE: { name: 'TRAFFIC_CRASH_VEHICLE', value: 195 },
        TRANSPORT: { name: 'TRANSPORT', value: 50 },
        UCR_EVENTS: { name: 'UCR_EVENTS', value: 76 },
        UCR_OFFENSE: { name: 'UCR_OFFENSE', value: 74 },
        UCR_PROPERTY: { name: 'UCR_PROPERTY', value: 75 },
        UI_CONFIGURATION: { name: 'UI_CONFIGURATION', value: 178 },
        UI_INPUT_CONFIGURATION: { name: 'UI_INPUT_CONFIGURATION', value: 179 },
        UNIT: { name: 'UNIT', value: 44 },
        UNIT_ATTRIBUTE: { name: 'UNIT_ATTRIBUTE', value: 133 },
        UNIT_EMERGENCY: { name: 'UNIT_EMERGENCY', value: 324 },
        UNIT_LOCATION_INFO: { name: 'UNIT_LOCATION_INFO', value: 84 },
        UNIT_SHIFT: { name: 'UNIT_SHIFT', value: 221 },
        UNIT_SHIFT_ATTRIBUTE: { name: 'UNIT_SHIFT_ATTRIBUTE', value: 222 },
        UNIT_STATE: { name: 'UNIT_STATE', value: 62 },
        UNIT_STATUS: { name: 'UNIT_STATUS', value: 47 },
        UNIT_TIMER: { name: 'UNIT_TIMER', value: 204 },
        UNIT_TIMER_POLICY: { name: 'UNIT_TIMER_POLICY', value: 205 },
        UNIT_TYPE_DIMENSION: { name: 'UNIT_TYPE_DIMENSION', value: 310 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 19 },
        USER_ACTION: { name: 'USER_ACTION', value: 123 },
        USER_ERROR_REPORT: { name: 'USER_ERROR_REPORT', value: 111 },
        USE_OF_FORCE: { name: 'USE_OF_FORCE', value: 36 },
        USE_OF_FORCE_SUBJECT: { name: 'USE_OF_FORCE_SUBJECT', value: 37 },
        VEHICLE: { name: 'VEHICLE', value: 159 },
        VEHICLE_MAKE: { name: 'VEHICLE_MAKE', value: 87 },
        VEHICLE_MODEL: { name: 'VEHICLE_MODEL', value: 88 },
        VENDOR_ENTITY_FILTER: { name: 'VENDOR_ENTITY_FILTER', value: 210 },
        VIDEO: { name: 'VIDEO', value: 15 },
        VOIDED_CITATION: { name: 'VOIDED_CITATION', value: 346 },
        WARRANT: { name: 'WARRANT', value: 8 },
        WARRANT_CHARGE: { name: 'WARRANT_CHARGE', value: 138 },
        WARRANT_STATUS: { name: 'WARRANT_STATUS', value: 219 },
        WARSHIP_COMMUNICATION: { name: 'WARSHIP_COMMUNICATION', value: 106 },
        WORKSPACE: { name: 'WORKSPACE', value: 117 },
        WORKSPACE_PANEL: { name: 'WORKSPACE_PANEL', value: 121 },
        WORKSPACE_WINDOW: { name: 'WORKSPACE_WINDOW', value: 120 },
    },
    TN = {
        ADMINISTRATIVE_AREA_LEVEL_1: { name: 'ADMINISTRATIVE_AREA_LEVEL_1' },
        ADMINISTRATIVE_AREA_LEVEL_2: { name: 'ADMINISTRATIVE_AREA_LEVEL_2' },
        ADMINISTRATIVE_AREA_LEVEL_3: { name: 'ADMINISTRATIVE_AREA_LEVEL_3' },
        ADMINISTRATIVE_AREA_LEVEL_4: { name: 'ADMINISTRATIVE_AREA_LEVEL_4' },
        ADMINISTRATIVE_AREA_LEVEL_5: { name: 'ADMINISTRATIVE_AREA_LEVEL_5' },
        AIRPORT: { name: 'AIRPORT' },
        BUS_STATION: { name: 'BUS_STATION' },
        COLLOQUIAL_AREA: { name: 'COLLOQUIAL_AREA' },
        COUNTRY: { name: 'COUNTRY' },
        ESTABLISHMENT: { name: 'ESTABLISHMENT' },
        FLOOR: { name: 'FLOOR' },
        INTERSECTION: { name: 'INTERSECTION' },
        LIGHT_RAIL_STATION: { name: 'LIGHT_RAIL_STATION' },
        LOCALITY: { name: 'LOCALITY' },
        NATURAL_FEATURE: { name: 'NATURAL_FEATURE' },
        NEIGHBORHOOD: { name: 'NEIGHBORHOOD' },
        PARK: { name: 'PARK' },
        PARKING: { name: 'PARKING' },
        POINT_OF_INTEREST: { name: 'POINT_OF_INTEREST' },
        POLITICAL: { name: 'POLITICAL' },
        POSTAL_CODE: { name: 'POSTAL_CODE' },
        POSTAL_CODE_PREFIX: { name: 'POSTAL_CODE_PREFIX' },
        POSTAL_CODE_SUFFIX: { name: 'POSTAL_CODE_SUFFIX' },
        POSTAL_TOWN: { name: 'POSTAL_TOWN' },
        POST_BOX: { name: 'POST_BOX' },
        PREMISE: { name: 'PREMISE' },
        ROOM: { name: 'ROOM' },
        ROUTE: { name: 'ROUTE' },
        STREET_ADDRESS: { name: 'STREET_ADDRESS' },
        STREET_NUMBER: { name: 'STREET_NUMBER' },
        SUBLOCALITY: { name: 'SUBLOCALITY' },
        SUBLOCALITY_LEVEL_1: { name: 'SUBLOCALITY_LEVEL_1' },
        SUBLOCALITY_LEVEL_2: { name: 'SUBLOCALITY_LEVEL_2' },
        SUBLOCALITY_LEVEL_3: { name: 'SUBLOCALITY_LEVEL_3' },
        SUBLOCALITY_LEVEL_4: { name: 'SUBLOCALITY_LEVEL_4' },
        SUBLOCALITY_LEVEL_5: { name: 'SUBLOCALITY_LEVEL_5' },
        SUBPREMISE: { name: 'SUBPREMISE' },
        SUBWAY_STATION: { name: 'SUBWAY_STATION' },
        TRAIN_STATION: { name: 'TRAIN_STATION' },
        TRANSIT_STATION: { name: 'TRANSIT_STATION' },
        UNKNOWN: { name: 'UNKNOWN' },
        WARD: { name: 'WARD' },
    },
    eN = {
        DEPARTMENT: { name: 'DEPARTMENT', value: 1 },
        GLOBAL: { name: 'GLOBAL', value: 2 },
        GLOBAL_AFTER_DEPARTMENT_FAILURE: { name: 'GLOBAL_AFTER_DEPARTMENT_FAILURE', value: 3 },
    },
    AN = {
        DISTANCE_MARKER: { name: 'DISTANCE_MARKER' },
        LAT_LONG: { name: 'LAT_LONG' },
        LOCALITY: { name: 'LOCALITY' },
        MGRS: { name: 'MGRS' },
        POI: { name: 'POI' },
        POINT_ADDRESS: { name: 'POINT_ADDRESS' },
        POSTAL: { name: 'POSTAL' },
        POSTAL_EXT: { name: 'POSTAL_EXT' },
        POSTAL_LOC: { name: 'POSTAL_LOC' },
        STREET_ADDRESS: { name: 'STREET_ADDRESS' },
        STREET_ADDRESS_EXT: { name: 'STREET_ADDRESS_EXT' },
        STREET_INT: { name: 'STREET_INT' },
        STREET_MID_BLOCK: { name: 'STREET_MID_BLOCK' },
        STREET_NAME: { name: 'STREET_NAME' },
        SUB_ADDRESS: { name: 'SUB_ADDRESS' },
        XY: { name: 'XY' },
        YX: { name: 'YX' },
    },
    NN = {
        CREATE: { name: 'CREATE', value: 'CREATE' },
        DELETE: { name: 'DELETE', value: 'DELETE' },
        UPDATE: { name: 'UPDATE', value: 'UPDATE' },
    },
    IN = {
        ASSOCIATED: { name: 'ASSOCIATED', value: 1 },
        UNASSOCIATED: { name: 'UNASSOCIATED', value: 2 },
    },
    RN = {
        ELASTIC_SEARCH_INDEXING_FAILED: { name: 'ELASTIC_SEARCH_INDEXING_FAILED', value: 10 },
        EVENT_NOT_FOUND: { name: 'EVENT_NOT_FOUND', value: 4 },
        EVENT_NOT_FROM_SCHEDULED_EVENT: { name: 'EVENT_NOT_FROM_SCHEDULED_EVENT', value: 7 },
        EVENT_NOT_IN_ALLOWLIST: { name: 'EVENT_NOT_IN_ALLOWLIST', value: 5 },
        NO_RESTORABLE_DATA_MISSING: { name: 'NO_RESTORABLE_DATA_MISSING', value: 2 },
        RESTORABLE: { name: 'RESTORABLE', value: 12 },
        RESTORED: { name: 'RESTORED', value: 1 },
        RESTORE_FAILED: { name: 'RESTORE_FAILED', value: 9 },
        RESTORE_VERIFICATION_FAILED: { name: 'RESTORE_VERIFICATION_FAILED', value: 8 },
        SNAPSHOT_HAS_NO_RESTORABLE_DATA: { name: 'SNAPSHOT_HAS_NO_RESTORABLE_DATA', value: 3 },
        SNAPSHOT_PARSE_FAILED: { name: 'SNAPSHOT_PARSE_FAILED', value: 11 },
        WRONG_DEPARTMENT_FOR_EVENT: { name: 'WRONG_DEPARTMENT_FOR_EVENT', value: 6 },
    },
    aN = {
        DRUGS: { name: 'DRUGS', value: 4 },
        FIREARM: { name: 'FIREARM', value: 3 },
        OTHER_ITEM: { name: 'OTHER_ITEM', value: 5 },
        PERSON: { name: 'PERSON', value: 1 },
        VEHICLE: { name: 'VEHICLE', value: 2 },
    },
    ON = {
        CALL_FOR_SERVICE: { name: 'CALL_FOR_SERVICE' },
        EVENT_LOCATION: { name: 'EVENT_LOCATION' },
    },
    SN = {
        DISPATCH: { name: 'DISPATCH', value: 1 },
        TELEPHONE_RESPONSE_UNIT: { name: 'TELEPHONE_RESPONSE_UNIT', value: 2 },
    },
    CN = { SUBMISSION: { name: 'SUBMISSION', value: 'SUBMISSION' } },
    nN = {
        NEW_CELL_STYLE: { name: 'NEW_CELL_STYLE', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        UPDATE_CELL_STYLE: { name: 'UPDATE_CELL_STYLE', value: 2 },
    },
    DN = { REQUEST: { name: 'REQUEST' }, RESPONSE: { name: 'RESPONSE' } },
    LN = {
        COMPLETED: { name: 'COMPLETED', value: 2 },
        FAILED: { name: 'FAILED', value: 3 },
        RUNNING: { name: 'RUNNING', value: 1 },
    },
    mN = {
        CUSTOM: { name: 'CUSTOM', value: 5 },
        MONTHLY: { name: 'MONTHLY', value: 1 },
        NONE: { name: 'NONE', value: 0 },
        TN_WEEKLY: { name: 'TN_WEEKLY', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        WEEKLY: { name: 'WEEKLY', value: 4 },
        YEARLY: { name: 'YEARLY', value: 2 },
    },
    lN = {
        APPLY_PACKET_PAGE_NUMBERS: { name: 'APPLY_PACKET_PAGE_NUMBERS', value: 8 },
        DISPLAY_NARRATIVE_AS_LAST_SECTION: { name: 'DISPLAY_NARRATIVE_AS_LAST_SECTION', value: 11 },
        DISPLAY_SIGNATURE_ON_LAST_PAGE_ONLY: {
            name: 'DISPLAY_SIGNATURE_ON_LAST_PAGE_ONLY',
            value: 12,
        },
        INCLUDE_AI_ATTRIBUTION_LANGUAGE: { name: 'INCLUDE_AI_ATTRIBUTION_LANGUAGE', value: 14 },
        INCLUDE_ASSOCIATED_RECORDS: { name: 'INCLUDE_ASSOCIATED_RECORDS', value: 10 },
        INCLUDE_ATTACHMENT_FILES: { name: 'INCLUDE_ATTACHMENT_FILES', value: 6 },
        INCLUDE_CONFIDENTIAL_INFORMATION: { name: 'INCLUDE_CONFIDENTIAL_INFORMATION', value: 4 },
        INCLUDE_HISTORY_EVENTS: { name: 'INCLUDE_HISTORY_EVENTS', value: 2 },
        INCLUDE_NAME_ADDENDUM: { name: 'INCLUDE_NAME_ADDENDUM', value: 1 },
        INCLUDE_OFFENSE_WORDING: { name: 'INCLUDE_OFFENSE_WORDING', value: 13 },
        INCLUDE_WARRANT_ACTIVITY: { name: 'INCLUDE_WARRANT_ACTIVITY', value: 3 },
        MERGE_ATTACHMENTS: { name: 'MERGE_ATTACHMENTS', value: 7 },
        ONLY_INCLUDE_FIELDS_WITH_DATA: { name: 'ONLY_INCLUDE_FIELDS_WITH_DATA', value: 5 },
        ONLY_INCLUDE_NOT_EXPORTED: { name: 'ONLY_INCLUDE_NOT_EXPORTED', value: 9 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    uN = {
        EMAIL: { name: 'EMAIL', value: 2 },
        REGULAR: { name: 'REGULAR', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    PN = {
        CURRENT: { name: 'CURRENT', value: 1 },
        OFFICER: { name: 'OFFICER', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    UN = {
        CANCELLED: { name: 'CANCELLED' },
        COMPLETED: { name: 'COMPLETED' },
        CREATED: { name: 'CREATED' },
    },
    MN = {
        ADDITIONAL_INFO: { name: 'ADDITIONAL_INFO', value: 2 },
        DEX_LINKED_MATERIALIZED_USER_ACTION: {
            name: 'DEX_LINKED_MATERIALIZED_USER_ACTION',
            value: 11,
        },
        INVOLVED_PERSON_LOCATION: { name: 'INVOLVED_PERSON_LOCATION', value: 6 },
        INVOLVED_PERSON_NAME_LINK: { name: 'INVOLVED_PERSON_NAME_LINK', value: 8 },
        INVOLVED_PERSON_PHONE_NUMBER: { name: 'INVOLVED_PERSON_PHONE_NUMBER', value: 7 },
        NARRATIVE: { name: 'NARRATIVE', value: 1 },
        REMOVE_ALL_ADDITIONAL_INFOS: { name: 'REMOVE_ALL_ADDITIONAL_INFOS', value: 9 },
        REMOVE_ALL_EVENT_LOG: { name: 'REMOVE_ALL_EVENT_LOG', value: 10 },
        REMOVE_VEHICLE_FROM_EVENT: { name: 'REMOVE_VEHICLE_FROM_EVENT', value: 14 },
        REPORTING_PARTY_LOCATION: { name: 'REPORTING_PARTY_LOCATION', value: 4 },
        REPORTING_PARTY_NAME_LINK: { name: 'REPORTING_PARTY_NAME_LINK', value: 5 },
        REPORTING_PARTY_PHONE_NUMBER: { name: 'REPORTING_PARTY_PHONE_NUMBER', value: 3 },
        VEHICLE_PLATE: { name: 'VEHICLE_PLATE', value: 12 },
        VEHICLE_VIN: { name: 'VEHICLE_VIN', value: 13 },
    },
    vN = { DEFAULT: { name: 'DEFAULT' }, ERROR: { name: 'ERROR' } },
    FN = { EXTERNAL_EVENT_CREATION: { name: 'EXTERNAL_EVENT_CREATION', value: 1 } },
    GN = {
        EXTERNAL_CAD_EVENT_ID: { name: 'EXTERNAL_CAD_EVENT_ID', value: 3 },
        NUM_RETRIES: { name: 'NUM_RETRIES', value: 1 },
        ORIGINATING_EVENT_ID: { name: 'ORIGINATING_EVENT_ID', value: 4 },
        SOURCE_CAD: { name: 'SOURCE_CAD', value: 2 },
        USER_TO_NOTIFY_ID: { name: 'USER_TO_NOTIFY_ID', value: 5 },
    },
    HN = {
        CREATE_EVENT_FAILURE: { name: 'CREATE_EVENT_FAILURE', value: 4 },
        CREATE_EVENT_REQUEST: { name: 'CREATE_EVENT_REQUEST', value: 1 },
        CREATE_EVENT_RETRY: { name: 'CREATE_EVENT_RETRY', value: 2 },
        CREATE_EVENT_SUCCESS: { name: 'CREATE_EVENT_SUCCESS', value: 3 },
        CREATE_EVENT_TIMEOUT: { name: 'CREATE_EVENT_TIMEOUT', value: 6 },
        RFA_ADDITIONAL_AGENCY_INVOLVED: { name: 'RFA_ADDITIONAL_AGENCY_INVOLVED', value: 107 },
        RFA_ASSISTANCE_REQUEST: { name: 'RFA_ASSISTANCE_REQUEST', value: 100 },
        RFA_ASSISTANCE_REQUEST_RESPONSE: { name: 'RFA_ASSISTANCE_REQUEST_RESPONSE', value: 101 },
        RFA_ERROR: { name: 'RFA_ERROR', value: 110 },
        RFA_EVENT_MESSAGE: { name: 'RFA_EVENT_MESSAGE', value: 102 },
        RFA_EVENT_MESSAGE_ACKNOWLEDGEMENT: {
            name: 'RFA_EVENT_MESSAGE_ACKNOWLEDGEMENT',
            value: 103,
        },
        RFA_EVENT_STATUS_UPDATE: { name: 'RFA_EVENT_STATUS_UPDATE', value: 106 },
        RFA_HEALTH_CHECK: { name: 'RFA_HEALTH_CHECK', value: 108 },
        RFA_SYSTEM_ACKNOWLEDGEMENT: { name: 'RFA_SYSTEM_ACKNOWLEDGEMENT', value: 109 },
        RFA_UNIT_STATUS_QUERY: { name: 'RFA_UNIT_STATUS_QUERY', value: 105 },
        RFA_UNIT_STATUS_UPDATE: { name: 'RFA_UNIT_STATUS_UPDATE', value: 104 },
        UPDATE_UNIT_STATUS: { name: 'UPDATE_UNIT_STATUS', value: 5 },
    },
    YN = {
        EVENT_CLEARED: { name: 'EVENT_CLEARED' },
        EVENT_CREATED: { name: 'EVENT_CREATED' },
        EVENT_UPDATED: { name: 'EVENT_UPDATED' },
        NARRATIVE_COMMENT_ADDED: { name: 'NARRATIVE_COMMENT_ADDED' },
        UNIT_STATUS_UPDATED: { name: 'UNIT_STATUS_UPDATED' },
    },
    tN = {
        OFFLINE: { name: 'OFFLINE', value: 3 },
        ONLINE: { name: 'ONLINE', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: 1 },
    },
    VN = {
        APPROVED: { name: 'APPROVED' },
        DRAFT: { name: 'DRAFT' },
        REJECTED: { name: 'REJECTED' },
        SUBMITTED: { name: 'SUBMITTED' },
    },
    oN = {
        INCOMING_ASSISTANCE_REQUEST: { name: 'INCOMING_ASSISTANCE_REQUEST', value: 2 },
        INCOMING_NOTIFICATION: { name: 'INCOMING_NOTIFICATION', value: 3 },
        OUTGOING_ASSISTANCE_REQUEST: { name: 'OUTGOING_ASSISTANCE_REQUEST', value: 1 },
    },
    BN = {
        ACCEPTED: { name: 'ACCEPTED', value: 3 },
        CLOSED: { name: 'CLOSED', value: 4 },
        FAILED: { name: 'FAILED', value: 5 },
        RECEIVED: { name: 'RECEIVED', value: 2 },
        SENT: { name: 'SENT', value: 1 },
        TIMED_OUT: { name: 'TIMED_OUT', value: 6 },
    },
    rN = {
        EN_ROUTE: { name: 'EN_ROUTE', value: 2 },
        LEFT_SCENE: { name: 'LEFT_SCENE', value: 4 },
        ON_SCENE: { name: 'ON_SCENE', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: 6 },
        WILL_ATTEND: { name: 'WILL_ATTEND', value: 1 },
        WILL_NOT_ATTEND: { name: 'WILL_NOT_ATTEND', value: 5 },
    },
    sN = { EXECUTING: { name: 'EXECUTING', value: 2 }, PENDING: { name: 'PENDING', value: 1 } },
    iN = {
        APPROVED: { name: 'APPROVED' },
        COMPLETED: { name: 'COMPLETED' },
        DRAFT: { name: 'DRAFT' },
        REJECTED: { name: 'REJECTED' },
        STAFF_REJECTED: { name: 'STAFF_REJECTED' },
        SUBMITTED: { name: 'SUBMITTED' },
    },
    WN = {
        APPROVED: { name: 'APPROVED' },
        COMPLETED: { name: 'COMPLETED' },
        DRAFT: { name: 'DRAFT' },
        REJECTED: { name: 'REJECTED' },
        STAFF_REJECTED: { name: 'STAFF_REJECTED' },
        SUBMITTED: { name: 'SUBMITTED' },
    },
    cN = {
        APPROVED: { name: 'APPROVED' },
        COMPLETED: { name: 'COMPLETED' },
        DRAFT: { name: 'DRAFT' },
        REJECTED: { name: 'REJECTED' },
        RETURNED_TO_APPROVED: { name: 'RETURNED_TO_APPROVED' },
        STAFF_APPROVED: { name: 'STAFF_APPROVED' },
        STAFF_REJECTED: { name: 'STAFF_REJECTED' },
        SUBMITTED: { name: 'SUBMITTED' },
        SUBMITTED_NO_REVIEW_REQUIRED: { name: 'SUBMITTED_NO_REVIEW_REQUIRED' },
    },
    KN = {
        ARREST: { name: 'ARREST' },
        CITATION: { name: 'CITATION' },
        CUSTODIAL_PROPERTY: { name: 'CUSTODIAL_PROPERTY' },
        CUSTOM: { name: 'CUSTOM' },
        FIELD_CONTACT: { name: 'FIELD_CONTACT' },
        IMPOUND: { name: 'IMPOUND' },
        MISSING_PERSONS: { name: 'MISSING_PERSONS' },
        OFFENSE: { name: 'OFFENSE' },
        SUPPLEMENT: { name: 'SUPPLEMENT' },
        TOW_VEHICLE: { name: 'TOW_VEHICLE' },
        TRAFFIC_CRASH: { name: 'TRAFFIC_CRASH' },
        USE_OF_FORCE: { name: 'USE_OF_FORCE' },
    },
    dN = { EXTERNAL_AGENCY: { name: 'EXTERNAL_AGENCY', value: 1 } },
    pN = {
        CAD_EVENT: { name: 'CAD_EVENT', value: 'External CAD Event' },
        CAD_EVENT_ADDITIONAL_INFO: {
            name: 'CAD_EVENT_ADDITIONAL_INFO',
            value: 'External CAD Event Additional Info',
        },
        CAD_EVENT_DISPOSITION: {
            name: 'CAD_EVENT_DISPOSITION',
            value: 'External CAD Event Disposition',
        },
        CAD_EVENT_INVOLVED_UNIT: { name: 'CAD_EVENT_INVOLVED_UNIT', value: 'External Unit' },
        CAD_EVENT_INVOLVED_UNIT_STATUS: {
            name: 'CAD_EVENT_INVOLVED_UNIT_STATUS',
            value: 'External Unit Status',
        },
        CASE: { name: 'CASE', value: 'External Case' },
        LINKED_EXTERNAL_RECORD: { name: 'LINKED_EXTERNAL_RECORD', value: 'Linked External Record' },
        REPORT: { name: 'REPORT', value: 'Report' },
        TASK: { name: 'TASK', value: 'External Task' },
        WARRANT: { name: 'WARRANT', value: 'External Warrant' },
        WARRANT_SUBJECT: { name: 'WARRANT_SUBJECT', value: 'External Warrant Subject' },
    },
    yN = { AppSettings: { name: 'AppSettings' }, LaunchDarkly: { name: 'LaunchDarkly' } },
    XN = {
        AK: { name: 'AK' },
        ALM: { name: 'ALM' },
        ALN: { name: 'ALN' },
        ALS: { name: 'ALS' },
        ARE: { name: 'ARE' },
        ARW: { name: 'ARW' },
        AZ: { name: 'AZ' },
        CAC: { name: 'CAC' },
        CAE: { name: 'CAE' },
        CAN: { name: 'CAN' },
        CAS: { name: 'CAS' },
        CO: { name: 'CO' },
        CT: { name: 'CT' },
        DE: { name: 'DE' },
        FLM: { name: 'FLM' },
        FLN: { name: 'FLN' },
        FLS: { name: 'FLS' },
        GAM: { name: 'GAM' },
        GAN: { name: 'GAN' },
        GAS: { name: 'GAS' },
        GU: { name: 'GU' },
        HI: { name: 'HI' },
        IAN: { name: 'IAN' },
        IAS: { name: 'IAS' },
        ID: { name: 'ID' },
        ILC: { name: 'ILC' },
        ILN: { name: 'ILN' },
        ILS: { name: 'ILS' },
        INN: { name: 'INN' },
        INS: { name: 'INS' },
        KS: { name: 'KS' },
        KYE: { name: 'KYE' },
        KYW: { name: 'KYW' },
        LAE: { name: 'LAE' },
        LAM: { name: 'LAM' },
        LAW: { name: 'LAW' },
        MA: { name: 'MA' },
        MD: { name: 'MD' },
        ME: { name: 'ME' },
        MIE: { name: 'MIE' },
        MIW: { name: 'MIW' },
        MN: { name: 'MN' },
        MOE: { name: 'MOE' },
        MOW: { name: 'MOW' },
        MP: { name: 'MP' },
        MSN: { name: 'MSN' },
        MSS: { name: 'MSS' },
        MT: { name: 'MT' },
        NCE: { name: 'NCE' },
        NCM: { name: 'NCM' },
        NCW: { name: 'NCW' },
        ND: { name: 'ND' },
        NE: { name: 'NE' },
        NH: { name: 'NH' },
        NJ: { name: 'NJ' },
        NM: { name: 'NM' },
        NV: { name: 'NV' },
        NYE: { name: 'NYE' },
        NYN: { name: 'NYN' },
        NYS: { name: 'NYS' },
        NYW: { name: 'NYW' },
        OHN: { name: 'OHN' },
        OHS: { name: 'OHS' },
        OKE: { name: 'OKE' },
        OKN: { name: 'OKN' },
        OKW: { name: 'OKW' },
        OR: { name: 'OR' },
        PAE: { name: 'PAE' },
        PAM: { name: 'PAM' },
        PAW: { name: 'PAW' },
        PR: { name: 'PR' },
        RI: { name: 'RI' },
        SC: { name: 'SC' },
        SD: { name: 'SD' },
        TNE: { name: 'TNE' },
        TNM: { name: 'TNM' },
        TNW: { name: 'TNW' },
        TXE: { name: 'TXE' },
        TXN: { name: 'TXN' },
        TXS: { name: 'TXS' },
        TXW: { name: 'TXW' },
        UT: { name: 'UT' },
        VAE: { name: 'VAE' },
        VAW: { name: 'VAW' },
        VI: { name: 'VI' },
        VT: { name: 'VT' },
        WA: { name: 'WA' },
        WAE: { name: 'WAE' },
        WAW: { name: 'WAW' },
        WIE: { name: 'WIE' },
        WIW: { name: 'WIW' },
        WVN: { name: 'WVN' },
        WVS: { name: 'WVS' },
        WY: { name: 'WY' },
    },
    QN = {
        COMMAND_LINE: { name: 'COMMAND_LINE', value: 1 },
        DISPATCH: { name: 'DISPATCH', value: 2 },
        DISPATCH_EVENT_CREATION: { name: 'DISPATCH_EVENT_CREATION', value: 4 },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER', value: 3 },
        FIRST_RESPONDER_EVENT_CREATION: { name: 'FIRST_RESPONDER_EVENT_CREATION', value: 5 },
    },
    bN = {
        RAN_BY_USER: { name: 'RAN_BY_USER', value: 1 },
        RAN_FOR_EVENT: { name: 'RAN_FOR_EVENT', value: 4 },
        RAN_FOR_UNIT: { name: 'RAN_FOR_UNIT', value: 3 },
        USER_IN_UNIT: { name: 'USER_IN_UNIT', value: 2 },
    },
    fN = {
        CREATED: { name: 'CREATED', value: 1 },
        ERROR: { name: 'ERROR', value: 4 },
        IN_PROGRESS: { name: 'IN_PROGRESS', value: 2 },
        READ: { name: 'READ', value: 5 },
        SUCCESS: { name: 'SUCCESS', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    gN = {
        ARTICLE: { name: 'ARTICLE', value: 4 },
        BOAT: { name: 'BOAT', value: 5 },
        FIREARM: { name: 'FIREARM', value: 3 },
        OTHER: { name: 'OTHER', value: 6 },
        PERSON: { name: 'PERSON', value: 2 },
        VEHICLE: { name: 'VEHICLE', value: 1 },
    },
    JN = {
        DIRECT_FIELD_ACCESS: { name: 'DIRECT_FIELD_ACCESS' },
        GETTER_METHOD: { name: 'GETTER_METHOD' },
        GETTER_WITH_FALLBACK: { name: 'GETTER_WITH_FALLBACK' },
    },
    hN = { PERSON: { name: 'PERSON' }, VEHICLE: { name: 'VEHICLE' } },
    ZN = {
        ATTRIBUTE_ID: { name: 'ATTRIBUTE_ID' },
        HEIGHT: { name: 'HEIGHT' },
        LOCAL_DATE: { name: 'LOCAL_DATE' },
        LOCATION: { name: 'LOCATION' },
        NUMBER: { name: 'NUMBER' },
        PERSON_NAME: { name: 'PERSON_NAME' },
        STRING: { name: 'STRING' },
        VEHICLE_MAKE_ID: { name: 'VEHICLE_MAKE_ID' },
        VEHICLE_MODEL_ID: { name: 'VEHICLE_MODEL_ID' },
    },
    jN = { MASK: { name: 'MASK' }, MISSING: { name: 'MISSING' }, UNSAFE: { name: 'UNSAFE' } },
    xN = {
        AGENCY_EVENT_PRIMARY_UNIT_ID: {
            name: 'AGENCY_EVENT_PRIMARY_UNIT_ID',
            value: 'AGENCY_EVENT_PRIMARY_UNIT_ID',
        },
        AGENCY_EVENT_REPORTING_EVENT_NUMBER: {
            name: 'AGENCY_EVENT_REPORTING_EVENT_NUMBER',
            value: 'AGENCY_EVENT_REPORTING_EVENT_NUMBER',
        },
        BARCODE_VALUE: { name: 'BARCODE_VALUE', value: 'BARCODE_VALUE' },
        BASE_EVENT_CALL_FOR_SERVICE_ID: {
            name: 'BASE_EVENT_CALL_FOR_SERVICE_ID',
            value: 'BASE_EVENT_CALL_FOR_SERVICE_ID',
        },
        BASE_EVENT_EVENT_ORIGIN_ATTR_ID: {
            name: 'BASE_EVENT_EVENT_ORIGIN_ATTR_ID',
            value: 'BASE_EVENT_EVENT_ORIGIN_ATTR_ID',
        },
        BASE_EVENT_PRIORITY_ATTR_ID: {
            name: 'BASE_EVENT_PRIORITY_ATTR_ID',
            value: 'BASE_EVENT_PRIORITY_ATTR_ID',
        },
        BASE_EVENT_RISK_LEVEL_ATTR_ID: {
            name: 'BASE_EVENT_RISK_LEVEL_ATTR_ID',
            value: 'BASE_EVENT_RISK_LEVEL_ATTR_ID',
        },
        BASE_EVENT_TRANSMITTED_DATE_UTC: {
            name: 'BASE_EVENT_TRANSMITTED_DATE_UTC',
            value: 'BASE_EVENT_TRANSMITTED_DATE_UTC',
        },
        CALL_FOR_SERVICE_DETAIL_AGENCY_TYPE_GLOBAL_ATTR_ID: {
            name: 'CALL_FOR_SERVICE_DETAIL_AGENCY_TYPE_GLOBAL_ATTR_ID',
            value: 'CALL_FOR_SERVICE_DETAIL_AGENCY_TYPE_GLOBAL_ATTR_ID',
        },
        CASE_CASE_DEFINITION_ID: {
            name: 'CASE_CASE_DEFINITION_ID',
            value: 'CASE_CASE_DEFINITION_ID',
        },
        CASE_LOCAL_ID: { name: 'CASE_LOCAL_ID', value: 'CASE_LOCAL_ID' },
        CASE_NOTE_CASE_ID: { name: 'CASE_NOTE_CASE_ID', value: 'CASE_NOTE_CASE_ID' },
        CHAIN_EVENT_CREATED_DATE_UTC: {
            name: 'CHAIN_EVENT_CREATED_DATE_UTC',
            value: 'CHAIN_EVENT_CREATED_DATE_UTC',
        },
        CUSTODIAL_RESPONSIBLE_OFFICER_OFFICER_ID: {
            name: 'CUSTODIAL_RESPONSIBLE_OFFICER_OFFICER_ID',
            value: 'CUSTODIAL_RESPONSIBLE_OFFICER_OFFICER_ID',
        },
        DISPLAY_ATTRIBUTE_CAUTION: {
            name: 'DISPLAY_ATTRIBUTE_CAUTION',
            value: 'DISPLAY_ATTRIBUTE_CAUTION',
        },
        DISPLAY_ATTRIBUTE_PHYSICAL_CHARACTERISTIC: {
            name: 'DISPLAY_ATTRIBUTE_PHYSICAL_CHARACTERISTIC',
            value: 'DISPLAY_ATTRIBUTE_PHYSICAL_CHARACTERISTIC',
        },
        DISPLAY_BOLO: { name: 'DISPLAY_BOLO', value: 'DISPLAY_BOLO' },
        DISPLAY_CAD_EVENT_FIRE_AGENCY_NAME: {
            name: 'DISPLAY_CAD_EVENT_FIRE_AGENCY_NAME',
            value: 'DISPLAY_CAD_EVENT_FIRE_AGENCY_NAME',
        },
        DISPLAY_CAD_EVENT_FIRE_DISPATCH_AREA: {
            name: 'DISPLAY_CAD_EVENT_FIRE_DISPATCH_AREA',
            value: 'DISPLAY_CAD_EVENT_FIRE_DISPATCH_AREA',
        },
        DISPLAY_CAD_EVENT_MEDICAL_AGENCY_NAME: {
            name: 'DISPLAY_CAD_EVENT_MEDICAL_AGENCY_NAME',
            value: 'DISPLAY_CAD_EVENT_MEDICAL_AGENCY_NAME',
        },
        DISPLAY_CAD_EVENT_MEDICAL_DISPATCH_AREA: {
            name: 'DISPLAY_CAD_EVENT_MEDICAL_DISPATCH_AREA',
            value: 'DISPLAY_CAD_EVENT_MEDICAL_DISPATCH_AREA',
        },
        DISPLAY_CAD_EVENT_POLICE_AGENCY_NAME: {
            name: 'DISPLAY_CAD_EVENT_POLICE_AGENCY_NAME',
            value: 'DISPLAY_CAD_EVENT_POLICE_AGENCY_NAME',
        },
        DISPLAY_CAD_EVENT_POLICE_DISPATCH_AREA: {
            name: 'DISPLAY_CAD_EVENT_POLICE_DISPATCH_AREA',
            value: 'DISPLAY_CAD_EVENT_POLICE_DISPATCH_AREA',
        },
        DISPLAY_CAD_UNIT_OFF_DUTY: {
            name: 'DISPLAY_CAD_UNIT_OFF_DUTY',
            value: 'DISPLAY_CAD_UNIT_OFF_DUTY',
        },
        DISPLAY_CASE_ASSIGNEE: { name: 'DISPLAY_CASE_ASSIGNEE', value: 'DISPLAY_CASE_ASSIGNEE' },
        DISPLAY_CHAIN_OF_CUSTODY_ACQUIRED_DATE_UTC: {
            name: 'DISPLAY_CHAIN_OF_CUSTODY_ACQUIRED_DATE_UTC',
            value: 'DISPLAY_CHAIN_OF_CUSTODY_ACQUIRED_DATE_UTC',
        },
        DISPLAY_EVENT_LOG_DETAILED_VIEW_LOCATION: {
            name: 'DISPLAY_EVENT_LOG_DETAILED_VIEW_LOCATION',
            value: 'DISPLAY_EVENT_LOG_DETAILED_VIEW_LOCATION',
        },
        DISPLAY_EVIDENCE_LABEL_ITEM_ID: {
            name: 'DISPLAY_EVIDENCE_LABEL_ITEM_ID',
            value: 'DISPLAY_EVIDENCE_LABEL_ITEM_ID',
        },
        DISPLAY_NON_DISPATCH_QUEUE: {
            name: 'DISPLAY_NON_DISPATCH_QUEUE',
            value: 'DISPLAY_NON_DISPATCH_QUEUE',
        },
        DISPLAY_ONLY_CASE: { name: 'DISPLAY_ONLY_CASE', value: 'DISPLAY_ONLY_CASE' },
        DISPLAY_ONLY_E_FILE: { name: 'DISPLAY_ONLY_E_FILE', value: 'DISPLAY_ONLY_E_FILE' },
        DISPLAY_ONLY_NARRATIVE_TITLE: {
            name: 'DISPLAY_ONLY_NARRATIVE_TITLE',
            value: 'DISPLAY_ONLY_NARRATIVE_TITLE',
        },
        DISPLAY_ONLY_NARRATIVE_TITLE_ARREST_REPORT: {
            name: 'DISPLAY_ONLY_NARRATIVE_TITLE_ARREST_REPORT',
            value: 'DISPLAY_ONLY_NARRATIVE_TITLE_ARREST_REPORT',
        },
        DISPLAY_ONLY_OFFENSE: { name: 'DISPLAY_ONLY_OFFENSE', value: 'DISPLAY_ONLY_OFFENSE' },
        DISPLAY_ONLY_PERSONNEL_REPORT_OWNER_LABEL: {
            name: 'DISPLAY_ONLY_PERSONNEL_REPORT_OWNER_LABEL',
            value: 'DISPLAY_ONLY_PERSONNEL_REPORT_OWNER_LABEL',
        },
        DISPLAY_ONLY_PHOTO_LINEUP: {
            name: 'DISPLAY_ONLY_PHOTO_LINEUP',
            value: 'DISPLAY_ONLY_PHOTO_LINEUP',
        },
        DISPLAY_ONLY_SUB_PREMISE_NAME_LABEL: {
            name: 'DISPLAY_ONLY_SUB_PREMISE_NAME_LABEL',
            value: 'DISPLAY_ONLY_SUB_PREMISE_NAME_LABEL',
        },
        DISPLAY_ONLY_SUB_PREMISE_VALUE_LABEL: {
            name: 'DISPLAY_ONLY_SUB_PREMISE_VALUE_LABEL',
            value: 'DISPLAY_ONLY_SUB_PREMISE_VALUE_LABEL',
        },
        DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE: {
            name: 'DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE',
            value: 'DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE',
        },
        DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE_ARREST_REPORT: {
            name: 'DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE_ARREST_REPORT',
            value: 'DISPLAY_ONLY_SUMMARY_NARRATIVE_TITLE_ARREST_REPORT',
        },
        DISPLAY_PERSON_PROFILE_IDENTIFYING_MARKS: {
            name: 'DISPLAY_PERSON_PROFILE_IDENTIFYING_MARKS',
            value: 'DISPLAY_PERSON_PROFILE_IDENTIFYING_MARKS',
        },
        DISPLAY_PRIMARY_SUBDIVISION: {
            name: 'DISPLAY_PRIMARY_SUBDIVISION',
            value: 'DISPLAY_PRIMARY_SUBDIVISION',
        },
        DISPLAY_REPORTING_EVENT_NUMBER_SEQUENCE_NUMBER: {
            name: 'DISPLAY_REPORTING_EVENT_NUMBER_SEQUENCE_NUMBER',
            value: 'DISPLAY_REPORTING_EVENT_NUMBER_SEQUENCE_NUMBER',
        },
        DISPLAY_TOW_VEHICLE_FROM_LOCATION: {
            name: 'DISPLAY_TOW_VEHICLE_FROM_LOCATION',
            value: 'DISPLAY_TOW_VEHICLE_FROM_LOCATION',
        },
        DISPLAY_TOW_VEHICLE_TO_LOCATION: {
            name: 'DISPLAY_TOW_VEHICLE_TO_LOCATION',
            value: 'DISPLAY_TOW_VEHICLE_TO_LOCATION',
        },
        EVENT_CLEARING_COMMENTS: {
            name: 'EVENT_CLEARING_COMMENTS',
            value: 'EVENT_CLEARING_COMMENTS',
        },
        EVENT_CLEARING_DISPOSITION_DISPOSITION_ATTR_ID: {
            name: 'EVENT_CLEARING_DISPOSITION_DISPOSITION_ATTR_ID',
            value: 'EVENT_CLEARING_DISPOSITION_DISPOSITION_ATTR_ID',
        },
        EVENT_CLEARING_DISPOSITION_IS_PRIMARY: {
            name: 'EVENT_CLEARING_DISPOSITION_IS_PRIMARY',
            value: 'EVENT_CLEARING_DISPOSITION_IS_PRIMARY',
        },
        EVENT_DETAIL_RESPONDING_OFFICER_ID: {
            name: 'EVENT_DETAIL_RESPONDING_OFFICER_ID',
            value: 'EVENT_DETAIL_RESPONDING_OFFICER_ID',
        },
        EVENT_REACTIVATION_REASON_REASON: {
            name: 'EVENT_REACTIVATION_REASON_REASON',
            value: 'EVENT_REACTIVATION_REASON_REASON',
        },
        ITEM_EVENT_LINK_INVOLVEMENT_TYPE_ATTR_ID: {
            name: 'ITEM_EVENT_LINK_INVOLVEMENT_TYPE_ATTR_ID',
            value: 'ITEM_EVENT_LINK_INVOLVEMENT_TYPE_ATTR_ID',
        },
        ITEM_PROFILE_DESCRIPTION: {
            name: 'ITEM_PROFILE_DESCRIPTION',
            value: 'ITEM_PROFILE_DESCRIPTION',
        },
        ITEM_PROFILE_IS_BIOHAZARD: {
            name: 'ITEM_PROFILE_IS_BIOHAZARD',
            value: 'ITEM_PROFILE_IS_BIOHAZARD',
        },
        ITEM_PROFILE_ITEM_CATEGORY_ATTR_ID: {
            name: 'ITEM_PROFILE_ITEM_CATEGORY_ATTR_ID',
            value: 'ITEM_PROFILE_ITEM_CATEGORY_ATTR_ID',
        },
        ITEM_PROFILE_ITEM_TYPE_ATTR_ID: {
            name: 'ITEM_PROFILE_ITEM_TYPE_ATTR_ID',
            value: 'ITEM_PROFILE_ITEM_TYPE_ATTR_ID',
        },
        ITEM_PROFILE_ITEM_TYPE_VEHICLE_PRIMARY_COLOR_ATTR_ID: {
            name: 'ITEM_PROFILE_ITEM_TYPE_VEHICLE_PRIMARY_COLOR_ATTR_ID',
            value: 'ITEM_PROFILE_ITEM_TYPE_VEHICLE_PRIMARY_COLOR_ATTR_ID',
        },
        ITEM_PROFILE_ITEM_TYPE_VEHICLE_SECONDARY_COLOR_ATTR_ID: {
            name: 'ITEM_PROFILE_ITEM_TYPE_VEHICLE_SECONDARY_COLOR_ATTR_ID',
            value: 'ITEM_PROFILE_ITEM_TYPE_VEHICLE_SECONDARY_COLOR_ATTR_ID',
        },
        ITEM_PROFILE_SERIAL_NUMBER: {
            name: 'ITEM_PROFILE_SERIAL_NUMBER',
            value: 'ITEM_PROFILE_SERIAL_NUMBER',
        },
        LOCATION_ENTITY_LINK_SUBDIVISION_1_ATTR_ID: {
            name: 'LOCATION_ENTITY_LINK_SUBDIVISION_1_ATTR_ID',
            value: 'LOCATION_ENTITY_LINK_SUBDIVISION_1_ATTR_ID',
        },
        LOCATION_ENTITY_LINK_SUBDIVISION_2_ATTR_ID: {
            name: 'LOCATION_ENTITY_LINK_SUBDIVISION_2_ATTR_ID',
            value: 'LOCATION_ENTITY_LINK_SUBDIVISION_2_ATTR_ID',
        },
        LOCATION_ENTITY_LINK_SUBDIVISION_3_ATTR_ID: {
            name: 'LOCATION_ENTITY_LINK_SUBDIVISION_3_ATTR_ID',
            value: 'LOCATION_ENTITY_LINK_SUBDIVISION_3_ATTR_ID',
        },
        LOCATION_ENTITY_LINK_SUBDIVISION_4_ATTR_ID: {
            name: 'LOCATION_ENTITY_LINK_SUBDIVISION_4_ATTR_ID',
            value: 'LOCATION_ENTITY_LINK_SUBDIVISION_4_ATTR_ID',
        },
        LOCATION_ENTITY_LINK_SUBDIVISION_5_ATTR_ID: {
            name: 'LOCATION_ENTITY_LINK_SUBDIVISION_5_ATTR_ID',
            value: 'LOCATION_ENTITY_LINK_SUBDIVISION_5_ATTR_ID',
        },
        LOCATION_ENTITY_LINK_SUB_PREMISE: {
            name: 'LOCATION_ENTITY_LINK_SUB_PREMISE',
            value: 'LOCATION_ENTITY_LINK_SUB_PREMISE',
        },
        NAME_ITEM_LINK_PROOF_OF_OWNERSHIP_ATTR_ID: {
            name: 'NAME_ITEM_LINK_PROOF_OF_OWNERSHIP_ATTR_ID',
            value: 'NAME_ITEM_LINK_PROOF_OF_OWNERSHIP_ATTR_ID',
        },
        NAME_PHONE_NUMBER_PHONE_NUMBER: {
            name: 'NAME_PHONE_NUMBER_PHONE_NUMBER',
            value: 'NAME_PHONE_NUMBER_PHONE_NUMBER',
        },
        PERSON_PROFILE_AGE_MAX: { name: 'PERSON_PROFILE_AGE_MAX', value: 'PERSON_PROFILE_AGE_MAX' },
        PERSON_PROFILE_AGE_MIN: { name: 'PERSON_PROFILE_AGE_MIN', value: 'PERSON_PROFILE_AGE_MIN' },
        PERSON_PROFILE_BUILD_ATTR_ID: {
            name: 'PERSON_PROFILE_BUILD_ATTR_ID',
            value: 'PERSON_PROFILE_BUILD_ATTR_ID',
        },
        PERSON_PROFILE_DATE_OF_BIRTH: {
            name: 'PERSON_PROFILE_DATE_OF_BIRTH',
            value: 'PERSON_PROFILE_DATE_OF_BIRTH',
        },
        PERSON_PROFILE_DATE_OF_DEATH_UTC: {
            name: 'PERSON_PROFILE_DATE_OF_DEATH_UTC',
            value: 'PERSON_PROFILE_DATE_OF_DEATH_UTC',
        },
        PERSON_PROFILE_DL_NUMBER: {
            name: 'PERSON_PROFILE_DL_NUMBER',
            value: 'PERSON_PROFILE_DL_NUMBER',
        },
        PERSON_PROFILE_DL_STATE_ATTR_ID: {
            name: 'PERSON_PROFILE_DL_STATE_ATTR_ID',
            value: 'PERSON_PROFILE_DL_STATE_ATTR_ID',
        },
        PERSON_PROFILE_ETHNICITY_ATTR_ID: {
            name: 'PERSON_PROFILE_ETHNICITY_ATTR_ID',
            value: 'PERSON_PROFILE_ETHNICITY_ATTR_ID',
        },
        PERSON_PROFILE_EYE_COLOR_ATTR_ID: {
            name: 'PERSON_PROFILE_EYE_COLOR_ATTR_ID',
            value: 'PERSON_PROFILE_EYE_COLOR_ATTR_ID',
        },
        PERSON_PROFILE_FACIAL_HAIR_TYPE_ATTR_ID: {
            name: 'PERSON_PROFILE_FACIAL_HAIR_TYPE_ATTR_ID',
            value: 'PERSON_PROFILE_FACIAL_HAIR_TYPE_ATTR_ID',
        },
        PERSON_PROFILE_FBI_UCN: { name: 'PERSON_PROFILE_FBI_UCN', value: 'PERSON_PROFILE_FBI_UCN' },
        PERSON_PROFILE_FIRST_NAME: {
            name: 'PERSON_PROFILE_FIRST_NAME',
            value: 'PERSON_PROFILE_FIRST_NAME',
        },
        PERSON_PROFILE_HAIR_COLOR_ATTR_ID: {
            name: 'PERSON_PROFILE_HAIR_COLOR_ATTR_ID',
            value: 'PERSON_PROFILE_HAIR_COLOR_ATTR_ID',
        },
        PERSON_PROFILE_HAIR_LENGTH_ATTR_ID: {
            name: 'PERSON_PROFILE_HAIR_LENGTH_ATTR_ID',
            value: 'PERSON_PROFILE_HAIR_LENGTH_ATTR_ID',
        },
        PERSON_PROFILE_HAIR_STYLE_ATTR_ID: {
            name: 'PERSON_PROFILE_HAIR_STYLE_ATTR_ID',
            value: 'PERSON_PROFILE_HAIR_STYLE_ATTR_ID',
        },
        PERSON_PROFILE_HEIGHT: { name: 'PERSON_PROFILE_HEIGHT', value: 'PERSON_PROFILE_HEIGHT' },
        PERSON_PROFILE_HEIGHT_RANGE_MAX: {
            name: 'PERSON_PROFILE_HEIGHT_RANGE_MAX',
            value: 'PERSON_PROFILE_HEIGHT_RANGE_MAX',
        },
        PERSON_PROFILE_HEIGHT_RANGE_MIN: {
            name: 'PERSON_PROFILE_HEIGHT_RANGE_MIN',
            value: 'PERSON_PROFILE_HEIGHT_RANGE_MIN',
        },
        PERSON_PROFILE_LAST_NAME: {
            name: 'PERSON_PROFILE_LAST_NAME',
            value: 'PERSON_PROFILE_LAST_NAME',
        },
        PERSON_PROFILE_RACE_ATTR_ID: {
            name: 'PERSON_PROFILE_RACE_ATTR_ID',
            value: 'PERSON_PROFILE_RACE_ATTR_ID',
        },
        PERSON_PROFILE_SEX_ATTR_ID: {
            name: 'PERSON_PROFILE_SEX_ATTR_ID',
            value: 'PERSON_PROFILE_SEX_ATTR_ID',
        },
        PERSON_PROFILE_SKIN_TONE_ATTR_ID: {
            name: 'PERSON_PROFILE_SKIN_TONE_ATTR_ID',
            value: 'PERSON_PROFILE_SKIN_TONE_ATTR_ID',
        },
        PERSON_PROFILE_SSN: { name: 'PERSON_PROFILE_SSN', value: 'PERSON_PROFILE_SSN' },
        PERSON_PROFILE_STATE_ID_NUMBER: {
            name: 'PERSON_PROFILE_STATE_ID_NUMBER',
            value: 'PERSON_PROFILE_STATE_ID_NUMBER',
        },
        PERSON_PROFILE_VISION_ATTR_ID: {
            name: 'PERSON_PROFILE_VISION_ATTR_ID',
            value: 'PERSON_PROFILE_VISION_ATTR_ID',
        },
        PERSON_PROFILE_WEIGHT: { name: 'PERSON_PROFILE_WEIGHT', value: 'PERSON_PROFILE_WEIGHT' },
        PERSON_PROFILE_WEIGHT_RANGE_MAX: {
            name: 'PERSON_PROFILE_WEIGHT_RANGE_MAX',
            value: 'PERSON_PROFILE_WEIGHT_RANGE_MAX',
        },
        PERSON_PROFILE_WEIGHT_RANGE_MIN: {
            name: 'PERSON_PROFILE_WEIGHT_RANGE_MIN',
            value: 'PERSON_PROFILE_WEIGHT_RANGE_MIN',
        },
        PROPERTY_STATUS_PROPERTY_STATUS_ATTR_ID: {
            name: 'PROPERTY_STATUS_PROPERTY_STATUS_ATTR_ID',
            value: 'PROPERTY_STATUS_PROPERTY_STATUS_ATTR_ID',
        },
        REPORTING_EVENT_REPORTING_EVENT_NUMBER: {
            name: 'REPORTING_EVENT_REPORTING_EVENT_NUMBER',
            value: 'REPORTING_EVENT_REPORTING_EVENT_NUMBER',
        },
        REPORT_RECORD_NUMBER: { name: 'REPORT_RECORD_NUMBER', value: 'REPORT_RECORD_NUMBER' },
        REPORT_REPORTING_EVENT_NUMBER: {
            name: 'REPORT_REPORTING_EVENT_NUMBER',
            value: 'REPORT_REPORTING_EVENT_NUMBER',
        },
        REPORT_SUBMISSION_AUTHOR_OFFICER_ID: {
            name: 'REPORT_SUBMISSION_AUTHOR_OFFICER_ID',
            value: 'REPORT_SUBMISSION_AUTHOR_OFFICER_ID',
        },
        REPORT_SUBMISSION_OWNER_ID: {
            name: 'REPORT_SUBMISSION_OWNER_ID',
            value: 'REPORT_SUBMISSION_OWNER_ID',
        },
        STORAGE_LOCATION_VIEW_DISPLAY_VALUE: {
            name: 'STORAGE_LOCATION_VIEW_DISPLAY_VALUE',
            value: 'STORAGE_LOCATION_VIEW_DISPLAY_VALUE',
        },
        TOW_VEHICLE_IS_PRIVATE_TOW: {
            name: 'TOW_VEHICLE_IS_PRIVATE_TOW',
            value: 'TOW_VEHICLE_IS_PRIVATE_TOW',
        },
        TOW_VEHICLE_TOW_COMPANY_NAME: {
            name: 'TOW_VEHICLE_TOW_COMPANY_NAME',
            value: 'TOW_VEHICLE_TOW_COMPANY_NAME',
        },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
        VEHICLE_BODY_STYLE_ATTR_ID: {
            name: 'VEHICLE_BODY_STYLE_ATTR_ID',
            value: 'VEHICLE_BODY_STYLE_ATTR_ID',
        },
        VEHICLE_REGISTRATION_STATE_ATTR_ID: {
            name: 'VEHICLE_REGISTRATION_STATE_ATTR_ID',
            value: 'VEHICLE_REGISTRATION_STATE_ATTR_ID',
        },
        VEHICLE_TAG: { name: 'VEHICLE_TAG', value: 'VEHICLE_TAG' },
        VEHICLE_VEHICLE_MAKE_ATTR_ID: {
            name: 'VEHICLE_VEHICLE_MAKE_ATTR_ID',
            value: 'VEHICLE_VEHICLE_MAKE_ATTR_ID',
        },
        VEHICLE_VEHICLE_MAKE_ID: {
            name: 'VEHICLE_VEHICLE_MAKE_ID',
            value: 'VEHICLE_VEHICLE_MAKE_ID',
        },
        VEHICLE_VEHICLE_MODEL_ATTR_ID: {
            name: 'VEHICLE_VEHICLE_MODEL_ATTR_ID',
            value: 'VEHICLE_VEHICLE_MODEL_ATTR_ID',
        },
        VEHICLE_VEHICLE_MODEL_ID: {
            name: 'VEHICLE_VEHICLE_MODEL_ID',
            value: 'VEHICLE_VEHICLE_MODEL_ID',
        },
        VEHICLE_VIN_NUMBER: { name: 'VEHICLE_VIN_NUMBER', value: 'VEHICLE_VIN_NUMBER' },
        VEHICLE_YEAR_OF_MANUFACTURE: {
            name: 'VEHICLE_YEAR_OF_MANUFACTURE',
            value: 'VEHICLE_YEAR_OF_MANUFACTURE',
        },
        WARRANT_BAIL_AMOUNT: { name: 'WARRANT_BAIL_AMOUNT', value: 'WARRANT_BAIL_AMOUNT' },
        WARRANT_COURT_CASE_NUMBER: {
            name: 'WARRANT_COURT_CASE_NUMBER',
            value: 'WARRANT_COURT_CASE_NUMBER',
        },
        WARRANT_COURT_NAME: { name: 'WARRANT_COURT_NAME', value: 'WARRANT_COURT_NAME' },
        WARRANT_COURT_PHONE_NUMBER: {
            name: 'WARRANT_COURT_PHONE_NUMBER',
            value: 'WARRANT_COURT_PHONE_NUMBER',
        },
        WARRANT_DAYS_TO_SERVE: { name: 'WARRANT_DAYS_TO_SERVE', value: 'WARRANT_DAYS_TO_SERVE' },
        WARRANT_HAS_NIGHT_SERVICE: {
            name: 'WARRANT_HAS_NIGHT_SERVICE',
            value: 'WARRANT_HAS_NIGHT_SERVICE',
        },
        WARRANT_ISSUING_AGENCY_NAME_ATTR_ID: {
            name: 'WARRANT_ISSUING_AGENCY_NAME_ATTR_ID',
            value: 'WARRANT_ISSUING_AGENCY_NAME_ATTR_ID',
        },
        WARRANT_ISSUING_JUDGE: { name: 'WARRANT_ISSUING_JUDGE', value: 'WARRANT_ISSUING_JUDGE' },
        WARRANT_STATUS_WARRANT_STATUS_ATTR_ID: {
            name: 'WARRANT_STATUS_WARRANT_STATUS_ATTR_ID',
            value: 'WARRANT_STATUS_WARRANT_STATUS_ATTR_ID',
        },
        WARRANT_WARRANT_ISSUED_DATE_UTC: {
            name: 'WARRANT_WARRANT_ISSUED_DATE_UTC',
            value: 'WARRANT_WARRANT_ISSUED_DATE_UTC',
        },
        WARRANT_WARRANT_NUMBER: { name: 'WARRANT_WARRANT_NUMBER', value: 'WARRANT_WARRANT_NUMBER' },
        WARRANT_WARRANT_TYPE_ATTR_ID: {
            name: 'WARRANT_WARRANT_TYPE_ATTR_ID',
            value: 'WARRANT_WARRANT_TYPE_ATTR_ID',
        },
    },
    kN = {
        ATTRIBUTE: { name: 'ATTRIBUTE', value: 11 },
        BOOLEAN: { name: 'BOOLEAN', value: 5 },
        DATE: { name: 'DATE', value: 3 },
        DATETIME: { name: 'DATETIME', value: 6 },
        DISPLAY_ONLY: { name: 'DISPLAY_ONLY', value: 10 },
        ENUM: { name: 'ENUM', value: 12 },
        ID: { name: 'ID', value: 8 },
        INTEGER: { name: 'INTEGER', value: 4 },
        INTERNAL_DATA: { name: 'INTERNAL_DATA', value: 9 },
        NUMBER: { name: 'NUMBER', value: 2 },
        N_ITEMS: { name: 'N_ITEMS', value: 13 },
        STRING: { name: 'STRING', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 7 },
    },
    wN = {
        ARRAY: { name: 'ARRAY', value: 'ARRAY' },
        BOOLEAN: { name: 'BOOLEAN', value: 'BOOLEAN' },
        DATETIME: { name: 'DATETIME', value: 'DATETIME' },
        NUMBER: { name: 'NUMBER', value: 'NUMBER' },
        OBJECT: { name: 'OBJECT', value: 'OBJECT' },
        STRING: { name: 'STRING', value: 'STRING' },
    },
    zN = {
        AUDIO: { name: 'AUDIO', value: 3 },
        FILE: { name: 'FILE', value: 5 },
        IMAGE: { name: 'IMAGE', value: 2 },
        PDF: { name: 'PDF', value: 4 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VIDEO: { name: 'VIDEO', value: 1 },
    },
    qN = { PDF_API: { name: 'PDF_API', value: 'PDF_API' } },
    $N = {
        CLEAN: { name: 'CLEAN', value: 1 },
        DIRTY: { name: 'DIRTY', value: 4 },
        FAIL: { name: 'FAIL', value: 3 },
        PENDING: { name: 'PENDING', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    EI = {
        AAC: { name: 'AAC', value: 163 },
        ADE: { name: 'ADE', value: 131 },
        ADP: { name: 'ADP', value: 132 },
        AI: { name: 'AI', value: 186 },
        AIFF: { name: 'AIFF', value: 98 },
        AMR: { name: 'AMR', value: 92 },
        ARW: { name: 'ARW', value: 174 },
        ASF: { name: 'ASF', value: 95 },
        AVI: { name: 'AVI', value: 81 },
        BAT: { name: 'BAT', value: 133 },
        BIN: { name: 'BIN', value: 126 },
        BMP: { name: 'BMP', value: 9 },
        CAB: { name: 'CAB', value: 162 },
        CDRX: { name: 'CDRX', value: 189 },
        CHM: { name: 'CHM', value: 134 },
        CMD: { name: 'CMD', value: 135 },
        COM: { name: 'COM', value: 136 },
        CPL: { name: 'CPL', value: 137 },
        CR2: { name: 'CR2', value: 117 },
        CRW: { name: 'CRW', value: 175 },
        CSV: { name: 'CSV', value: 1 },
        DAT: { name: 'DAT', value: 115 },
        DBF: { name: 'DBF', value: 116 },
        DLL: { name: 'DLL', value: 107 },
        DMG: { name: 'DMG', value: 130 },
        DNG: { name: 'DNG', value: 185 },
        DOC: { name: 'DOC', value: 26 },
        DOCM: { name: 'DOCM', value: 29 },
        DOCX: { name: 'DOCX', value: 27 },
        DOT: { name: 'DOT', value: 112 },
        DOTM: { name: 'DOTM', value: 30 },
        DOTX: { name: 'DOTX', value: 28 },
        DVR: { name: 'DVR', value: 97 },
        EDD: { name: 'EDD', value: 188 },
        EPS: { name: 'EPS', value: 173 },
        EXE: { name: 'EXE', value: 108 },
        F4V: { name: 'F4V', value: 167 },
        FLV: { name: 'FLV', value: 166 },
        FR: { name: 'FR', value: 110 },
        GEOJSON: { name: 'GEOJSON', value: 195 },
        GIF: { name: 'GIF', value: 6 },
        GZ: { name: 'GZ', value: 72 },
        HEIF: { name: 'HEIF', value: 172 },
        HTA: { name: 'HTA', value: 138 },
        HTML: { name: 'HTML', value: 90 },
        ICO: { name: 'ICO', value: 169 },
        INS: { name: 'INS', value: 139 },
        ISO: { name: 'ISO', value: 129 },
        ISP: { name: 'ISP', value: 140 },
        JAR: { name: 'JAR', value: 141 },
        JFIF: { name: 'JFIF', value: 118 },
        JP2: { name: 'JP2', value: 182 },
        JPF: { name: 'JPF', value: 183 },
        JPG: { name: 'JPG', value: 10 },
        JS: { name: 'JS', value: 101 },
        JSE: { name: 'JSE', value: 142 },
        JSON: { name: 'JSON', value: 102 },
        LIB: { name: 'LIB', value: 143 },
        LNK: { name: 'LNK', value: 144 },
        LOG: { name: 'LOG', value: 113 },
        M2V: { name: 'M2V', value: 184 },
        M4A: { name: 'M4A', value: 51 },
        M4V: { name: 'M4V', value: 91 },
        MDE: { name: 'MDE', value: 145 },
        MHT: { name: 'MHT', value: 93 },
        MKV: { name: 'MKV', value: 192 },
        MM: { name: 'MM', value: 124 },
        MOV: { name: 'MOV', value: 86 },
        MP3: { name: 'MP3', value: 50 },
        MP4: { name: 'MP4', value: 85 },
        MPEG: { name: 'MPEG', value: 88 },
        MPGA: { name: 'MPGA', value: 52 },
        MSC: { name: 'MSC', value: 146 },
        MSG: { name: 'MSG', value: 87 },
        MSI: { name: 'MSI', value: 147 },
        MSP: { name: 'MSP', value: 148 },
        MST: { name: 'MST', value: 149 },
        MUG: { name: 'MUG', value: 120 },
        MXF: { name: 'MXF', value: 165 },
        NEF: { name: 'NEF', value: 176 },
        NIST: { name: 'NIST', value: 187 },
        NSH: { name: 'NSH', value: 150 },
        NWT: { name: 'NWT', value: 111 },
        OFM: { name: 'OFM', value: 109 },
        ONE: { name: 'ONE', value: 105 },
        ORF: { name: 'ORF', value: 177 },
        PCX: { name: 'PCX', value: 170 },
        PDF: { name: 'PDF', value: 4 },
        PIF: { name: 'PIF', value: 151 },
        PNG: { name: 'PNG', value: 7 },
        POTM: { name: 'POTM', value: 38 },
        POTX: { name: 'POTX', value: 34 },
        PPAM: { name: 'PPAM', value: 36 },
        PPSM: { name: 'PPSM', value: 39 },
        PPSX: { name: 'PPSX', value: 35 },
        PPT: { name: 'PPT', value: 32 },
        PPTM: { name: 'PPTM', value: 37 },
        PPTX: { name: 'PPTX', value: 33 },
        PSD: { name: 'PSD', value: 168 },
        RA: { name: 'RA', value: 164 },
        RAF: { name: 'RAF', value: 178 },
        RAR: { name: 'RAR', value: 71 },
        RDP: { name: 'RDP', value: 128 },
        RTF: { name: 'RTF', value: 3 },
        RW2: { name: 'RW2', value: 179 },
        RWL: { name: 'RWL', value: 181 },
        SCR: { name: 'SCR', value: 152 },
        SCT: { name: 'SCT', value: 153 },
        SHB: { name: 'SHB', value: 154 },
        SHP: { name: 'SHP', value: 119 },
        SIG: { name: 'SIG', value: 122 },
        SMI: { name: 'SMI', value: 125 },
        SRW: { name: 'SRW', value: 180 },
        SVG: { name: 'SVG', value: 193 },
        SYS: { name: 'SYS', value: 155 },
        THJ: { name: 'THJ', value: 114 },
        THMX: { name: 'THMX', value: 121 },
        TIFF: { name: 'TIFF', value: 8 },
        TMP: { name: 'TMP', value: 123 },
        TXT: { name: 'TXT', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        URL: { name: 'URL', value: 104 },
        UVH: { name: 'UVH', value: 82 },
        UVM: { name: 'UVM', value: 83 },
        UVU: { name: 'UVU', value: 84 },
        VB: { name: 'VB', value: 156 },
        VBE: { name: 'VBE', value: 157 },
        VBO: { name: 'VBO', value: 194 },
        VBS: { name: 'VBS', value: 127 },
        VCF: { name: 'VCF', value: 103 },
        VOB: { name: 'VOB', value: 99 },
        VSD: { name: 'VSD', value: 191 },
        VSDX: { name: 'VSDX', value: 190 },
        VXD: { name: 'VXD', value: 158 },
        WAV: { name: 'WAV', value: 53 },
        WEBP: { name: 'WEBP', value: 171 },
        WMA: { name: 'WMA', value: 54 },
        WMV: { name: 'WMV', value: 80 },
        WSC: { name: 'WSC', value: 159 },
        WSF: { name: 'WSF', value: 160 },
        WSH: { name: 'WSH', value: 161 },
        XLAM: { name: 'XLAM', value: 24 },
        XLS: { name: 'XLS', value: 31 },
        XLSB: { name: 'XLSB', value: 25 },
        XLSM: { name: 'XLSM', value: 22 },
        XLSX: { name: 'XLSX', value: 20 },
        XLTM: { name: 'XLTM', value: 23 },
        XLTX: { name: 'XLTX', value: 21 },
        XML: { name: 'XML', value: 89 },
        ZIP: { name: 'ZIP', value: 70 },
        _3G2: { name: '_3G2', value: 94 },
        _3GP: { name: '_3GP', value: 96 },
        _7Z: { name: '_7Z', value: 100 },
    },
    _I = {
        ALL_KQS: { name: 'ALL_KQS' },
        CRITICAL_AND_HIGH: { name: 'CRITICAL_AND_HIGH' },
        CRITICAL_ANSWERS: { name: 'CRITICAL_ANSWERS' },
        CRITICAL_HIGH_AND_MODERATE: { name: 'CRITICAL_HIGH_AND_MODERATE' },
    },
    TI = {
        COMPLETED: { name: 'COMPLETED', value: 1 },
        IN_PROGRESS: { name: 'IN_PROGRESS', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    eI = { FORM: { name: 'FORM', value: 'form' }, PDF: { name: 'PDF', value: 'pdf' } },
    AI = {
        ADMIN_AGENCY_PROFILE: { name: 'ADMIN_AGENCY_PROFILE', value: 10 },
        ADMIN_REPORT_DEFINITION: { name: 'ADMIN_REPORT_DEFINITION', value: 44 },
        ADMIN_ROLE_APPROVAL: { name: 'ADMIN_ROLE_APPROVAL', value: 39 },
        ADMIN_USER_PROFILE: { name: 'ADMIN_USER_PROFILE', value: 66 },
        CASE_DETAILS: { name: 'CASE_DETAILS', value: 35 },
        CASE_REVIEW: { name: 'CASE_REVIEW', value: 22 },
        CASE_STATUS_CHANGE: { name: 'CASE_STATUS_CHANGE', value: 21 },
        CHANGE_WARRANT_NUMBER: { name: 'CHANGE_WARRANT_NUMBER', value: 55 },
        CREATE_EXPORT_RELEASE: { name: 'CREATE_EXPORT_RELEASE', value: 59 },
        CREATE_REPORT: { name: 'CREATE_REPORT', value: 1 },
        CREATE_WARRANT: { name: 'CREATE_WARRANT', value: 56 },
        DEPARTMENT_PROFILE: { name: 'DEPARTMENT_PROFILE', value: 24 },
        EVIDENCE_CONFIG_ADMIN: { name: 'EVIDENCE_CONFIG_ADMIN', value: 46 },
        EVIDENCE_CREATE_CHAIN_EVENTS: { name: 'EVIDENCE_CREATE_CHAIN_EVENTS', value: 50 },
        EVIDENCE_ITEM_SPLIT: { name: 'EVIDENCE_ITEM_SPLIT', value: 65 },
        EVIDENCE_PRINTING_TEMPLATE_ADMIN: { name: 'EVIDENCE_PRINTING_TEMPLATE_ADMIN', value: 62 },
        EVIDENCE_RETENTION_POLICY_ADMIN: { name: 'EVIDENCE_RETENTION_POLICY_ADMIN', value: 51 },
        FIELD_CONFIGURATION_ADMIN: { name: 'FIELD_CONFIGURATION_ADMIN', value: 54 },
        INCIDENT: { name: 'INCIDENT', value: 3 },
        INJURIES: { name: 'INJURIES', value: 8 },
        ITEM: { name: 'ITEM', value: 14 },
        LOCATION: { name: 'LOCATION', value: 15 },
        LOCATION_ALIAS_ADMIN: { name: 'LOCATION_ALIAS_ADMIN', value: 33 },
        NARRATIVE: { name: 'NARRATIVE', value: 11 },
        OFFENSE: { name: 'OFFENSE', value: 6 },
        ORGANIZATION: { name: 'ORGANIZATION', value: 13 },
        PERSON: { name: 'PERSON', value: 12 },
        PROPERTY_STATUS: { name: 'PROPERTY_STATUS', value: 32 },
        REPORT_SUBMISSION: { name: 'REPORT_SUBMISSION', value: 23 },
        SECONDARY_APPROVAL: { name: 'SECONDARY_APPROVAL', value: 37 },
        UCR: { name: 'UCR', value: 45 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        WARRANT_CHARGES: { name: 'WARRANT_CHARGES', value: 58 },
    },
    NI = {
        ARCHIVED: { name: 'ARCHIVED', value: 'ARCHIVED' },
        DRAFT: { name: 'DRAFT', value: 'DRAFT' },
        PUBLISHED: { name: 'PUBLISHED', value: 'PUBLISHED' },
    },
    II = {
        BOOKING: { name: 'BOOKING', value: 'BOOKING' },
        EVENT_LOG: { name: 'EVENT_LOG', value: 'EVENT_LOG' },
        INCIDENT_REPORT: { name: 'INCIDENT_REPORT', value: 'INCIDENT_REPORT' },
        PERSONAL_INFO: { name: 'PERSONAL_INFO', value: 'PERSONAL_INFO' },
        PREBOOKING: { name: 'PREBOOKING', value: 'PREBOOKING' },
        RELEASE: { name: 'RELEASE', value: 'RELEASE' },
        REPORT: { name: 'REPORT', value: 'REPORT' },
    },
    RI = {
        FORM: { name: 'FORM', value: 'form' },
        RESOURCE: { name: 'RESOURCE', value: 'resource' },
    },
    aI = {
        ARRAY: { name: 'ARRAY' },
        DATE: { name: 'DATE' },
        INSTANCE: { name: 'INSTANCE' },
        INSTANCE_ARRAY: { name: 'INSTANCE_ARRAY' },
        NUMBER: { name: 'NUMBER' },
        OBJECT: { name: 'OBJECT' },
        STRING: { name: 'STRING' },
    },
    OI = {
        DAILY: { name: 'DAILY', value: 3 },
        HOURLY: { name: 'HOURLY', value: 2 },
        MONTHLY: { name: 'MONTHLY', value: 5 },
        ONCE: { name: 'ONCE', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        WEEKLY: { name: 'WEEKLY', value: 4 },
    },
    SI = {
        BY_DEPARTMENT: { name: 'BY_DEPARTMENT' },
        BY_TOPIC: { name: 'BY_TOPIC' },
        BY_TOPIC_AND_DEPARTMENT: { name: 'BY_TOPIC_AND_DEPARTMENT' },
        GLOBAL: { name: 'GLOBAL' },
    },
    CI = {
        ATTRIBUTE_TYPE: { name: 'ATTRIBUTE_TYPE', value: 1 },
        CODE: { name: 'CODE', value: 4 },
        ITEM_TYPE: { name: 'ITEM_TYPE', value: 3 },
        LINK_TYPE: { name: 'LINK_TYPE', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    nI = {
        ACTIVE: { name: 'ACTIVE', value: 3 },
        INACTIVE: { name: 'INACTIVE', value: 4 },
        PROCESSING: { name: 'PROCESSING', value: 2 },
        SUBMITTED: { name: 'SUBMITTED', value: 1 },
    },
    DI = {
        ADDRESS_POINT: { name: 'ADDRESS_POINT', value: 3 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 4 },
        STREET_CENTERLINE: { name: 'STREET_CENTERLINE', value: 2 },
        SUBDIVISION: { name: 'SUBDIVISION', value: 1 },
    },
    LI = {
        EVENT_ENTERS: { name: 'EVENT_ENTERS', value: 2 },
        UNIT_ENTERS: { name: 'UNIT_ENTERS', value: 3 },
        UNIT_EXITS: { name: 'UNIT_EXITS', value: 4 },
        UNKNOWN: { name: 'UNKNOWN', value: 1 },
        UNKNOWN_VAL: { name: 'UNKNOWN_VAL', value: -1 },
    },
    mI = {
        COMPLETED: { name: 'COMPLETED', value: 2 },
        FAILED: { name: 'FAILED', value: 3 },
        PENDING: { name: 'PENDING', value: 1 },
    },
    lI = {
        ALL: { name: 'ALL' },
        alerting: { name: 'alerting' },
        no_data: { name: 'no_data' },
        ok: { name: 'ok' },
        paused: { name: 'paused' },
        pending: { name: 'pending' },
    },
    uI = {
        ASSAULT_OR_MENACING: { name: 'ASSAULT_OR_MENACING' },
        CRIMINAL_MISCHIEF_OR_ARSON: { name: 'CRIMINAL_MISCHIEF_OR_ARSON' },
        CRIMINAL_TRESPASS_OR_BURGLARY: { name: 'CRIMINAL_TRESPASS_OR_BURGLARY' },
        HARASSMENT: { name: 'HARASSMENT' },
        KIDNAPPING_OR_COERCION: { name: 'KIDNAPPING_OR_COERCION' },
        LARCENY_OR_ROBBERY: { name: 'LARCENY_OR_ROBBERY' },
        MANSLAUGHTER_OR_MURDER: { name: 'MANSLAUGHTER_OR_MURDER' },
        RECKLESS_ENDANGERMENT_OR_STRANGULATION: { name: 'RECKLESS_ENDANGERMENT_OR_STRANGULATION' },
        SEXUAL_ABUSE_OR_UNLAWFUL_IMPRISONMENT: { name: 'SEXUAL_ABUSE_OR_UNLAWFUL_IMPRISONMENT' },
        STALKING_OR_RAPE: { name: 'STALKING_OR_RAPE' },
    },
    PI = {
        CONTENT: { name: 'CONTENT' },
        FOLDERS: { name: 'FOLDERS' },
        WORKFLOW: { name: 'WORKFLOW' },
    },
    UI = {
        ASSOCIATED_RECORD_CHANGED: { name: 'ASSOCIATED_RECORD_CHANGED' },
        ASSOCIATED_RECORD_CREATED: { name: 'ASSOCIATED_RECORD_CREATED' },
        ASSOCIATED_RECORD_DELETED: { name: 'ASSOCIATED_RECORD_DELETED' },
        ATTRIBUTE_LINK_CREATION: { name: 'ATTRIBUTE_LINK_CREATION' },
        ATTRIBUTE_LINK_DELETION: { name: 'ATTRIBUTE_LINK_DELETION' },
        CHILD_PROFILE_CREATION: { name: 'CHILD_PROFILE_CREATION' },
        CHILD_PROFILE_DELETE: { name: 'CHILD_PROFILE_DELETE' },
        ENTITY_CREATION: { name: 'ENTITY_CREATION' },
        ENTITY_DELETE: { name: 'ENTITY_DELETE' },
        ENTITY_MERGE: { name: 'ENTITY_MERGE' },
        ENTITY_PERMISSION_CHANGED: { name: 'ENTITY_PERMISSION_CHANGED' },
        ENTITY_PERMISSION_CREATED: { name: 'ENTITY_PERMISSION_CREATED' },
        ENTITY_PERMISSION_DELETED: { name: 'ENTITY_PERMISSION_DELETED' },
        FIELDS_CHANGED: { name: 'FIELDS_CHANGED' },
        FIELDS_CHANGED_BY_AI: { name: 'FIELDS_CHANGED_BY_AI' },
        LABEL_CREATION: { name: 'LABEL_CREATION' },
        LABEL_DELETION: { name: 'LABEL_DELETION' },
        LINK_CREATION: { name: 'LINK_CREATION' },
        LINK_DELETE: { name: 'LINK_DELETE' },
        OWNER_CHANGED: { name: 'OWNER_CHANGED' },
        REPORT_STATUS: { name: 'REPORT_STATUS' },
        SEALING_ACTION: { name: 'SEALING_ACTION' },
        VACATING_ACTION: { name: 'VACATING_ACTION' },
    },
    MI = {
        ATTRIBUTE: { name: 'ATTRIBUTE' },
        BOOLEAN: { name: 'BOOLEAN' },
        DATE: { name: 'DATE' },
        DATETIME: { name: 'DATETIME' },
        IMAGE: { name: 'IMAGE' },
        LINK_TYPE: { name: 'LINK_TYPE' },
        NARRATIVE: { name: 'NARRATIVE' },
        NUMERIC: { name: 'NUMERIC' },
        STRING: { name: 'STRING' },
        USER: { name: 'USER' },
    },
    vI = { HIT: { name: 'HIT' }, HOT_HIT: { name: 'HOT_HIT' }, NON_HIT: { name: 'NON_HIT' } },
    FI = {
        ALREADY_HELD: { displayName: 'Already Held', index: 0, name: 'ALREADY_HELD' },
        OTHER_UNITS: { displayName: 'Units', index: 1, name: 'OTHER_UNITS' },
        TO_HOLD: { displayName: 'To Hold', index: 0.5, name: 'TO_HOLD' },
    },
    GI = {
        CAD_AGENCY_EVENT_PDF_USE_FIRST_PRIMARY_UNIT: {
            name: 'CAD_AGENCY_EVENT_PDF_USE_FIRST_PRIMARY_UNIT',
            value: 'CAD_AGENCY_EVENT_PDF_USE_FIRST_PRIMARY_UNIT',
        },
        EXCLUDE_ADDITIONAL_INFOS: {
            name: 'EXCLUDE_ADDITIONAL_INFOS',
            value: 'EXCLUDE_ADDITIONAL_INFOS',
        },
        EXCLUDE_ATTACHMENTS: { name: 'EXCLUDE_ATTACHMENTS', value: 'EXCLUDE_ATTACHMENTS' },
        EXCLUDE_MASTER_ITEM_REPORTING_EVENT_LINKS: {
            name: 'EXCLUDE_MASTER_ITEM_REPORTING_EVENT_LINKS',
            value: 'EXCLUDE_MASTER_ITEM_REPORTING_EVENT_LINKS',
        },
        EXCLUDE_OUTSIDE_OFFENSES: {
            name: 'EXCLUDE_OUTSIDE_OFFENSES',
            value: 'EXCLUDE_OUTSIDE_OFFENSES',
        },
        EXCLUDE_PHONES: { name: 'EXCLUDE_PHONES', value: 'EXCLUDE_PHONES' },
        EXCLUDE_PRIMARY_BACKUP_UNITS: {
            name: 'EXCLUDE_PRIMARY_BACKUP_UNITS',
            value: 'EXCLUDE_PRIMARY_BACKUP_UNITS',
        },
        HISTORY_HYDRATION: { name: 'HISTORY_HYDRATION', value: 'HISTORY_HYDRATION' },
        HYDRATE_AGENCY_EVENT_DISPLAY_VIEW: {
            name: 'HYDRATE_AGENCY_EVENT_DISPLAY_VIEW',
            value: 'HYDRATE_AGENCY_EVENT_DISPLAY_VIEW',
        },
        HYDRATE_MASTER_WITH_ALL_CHILDREN: {
            name: 'HYDRATE_MASTER_WITH_ALL_CHILDREN',
            value: 'HYDRATE_MASTER_WITH_ALL_CHILDREN',
        },
        HYDRATE_UNITS: { name: 'HYDRATE_UNITS', value: 'HYDRATE_UNITS' },
        INCLUDE_ACTIVE_WARRANTS: {
            name: 'INCLUDE_ACTIVE_WARRANTS',
            value: 'INCLUDE_ACTIVE_WARRANTS',
        },
        INCLUDE_ACTIVE_WARRANTS_DETAILS: {
            name: 'INCLUDE_ACTIVE_WARRANTS_DETAILS',
            value: 'INCLUDE_ACTIVE_WARRANTS_DETAILS',
        },
        INCLUDE_AGENCIES: { name: 'INCLUDE_AGENCIES', value: 'INCLUDE_AGENCIES' },
        INCLUDE_ASSOCIATED_RECORD_REPORT_SHORT_TITLES: {
            name: 'INCLUDE_ASSOCIATED_RECORD_REPORT_SHORT_TITLES',
            value: 'INCLUDE_ASSOCIATED_RECORD_REPORT_SHORT_TITLES',
        },
        INCLUDE_ATTRIBUTES: { name: 'INCLUDE_ATTRIBUTES', value: 'INCLUDE_ATTRIBUTES' },
        INCLUDE_CAD_EVENT_PDF_DETAILS: {
            name: 'INCLUDE_CAD_EVENT_PDF_DETAILS',
            value: 'INCLUDE_CAD_EVENT_PDF_DETAILS',
        },
        INCLUDE_CHAIN_EVENT_TYPES: {
            name: 'INCLUDE_CHAIN_EVENT_TYPES',
            value: 'INCLUDE_CHAIN_EVENT_TYPES',
        },
        INCLUDE_COPIED_CALLS: { name: 'INCLUDE_COPIED_CALLS', value: 'INCLUDE_COPIED_CALLS' },
        INCLUDE_CORRUPT_NAME_REPORT_LINKS: {
            name: 'INCLUDE_CORRUPT_NAME_REPORT_LINKS',
            value: 'INCLUDE_CORRUPT_NAME_REPORT_LINKS',
        },
        INCLUDE_DRAFT_OMS: { name: 'INCLUDE_DRAFT_OMS', value: 'INCLUDE_DRAFT_OMS' },
        INCLUDE_EVIDENCE_INVENTORIES: {
            name: 'INCLUDE_EVIDENCE_INVENTORIES',
            value: 'INCLUDE_EVIDENCE_INVENTORIES',
        },
        INCLUDE_EVIDENCE_LOCATIONS: {
            name: 'INCLUDE_EVIDENCE_LOCATIONS',
            value: 'INCLUDE_EVIDENCE_LOCATIONS',
        },
        INCLUDE_EVIDENCE_RETENTION_POLICIES: {
            name: 'INCLUDE_EVIDENCE_RETENTION_POLICIES',
            value: 'INCLUDE_EVIDENCE_RETENTION_POLICIES',
        },
        INCLUDE_FINDABLE_ENTITIES: {
            name: 'INCLUDE_FINDABLE_ENTITIES',
            value: 'INCLUDE_FINDABLE_ENTITIES',
        },
        INCLUDE_LOCATION_CAUTIONS: {
            name: 'INCLUDE_LOCATION_CAUTIONS',
            value: 'INCLUDE_LOCATION_CAUTIONS',
        },
        INCLUDE_LOCATION_EXTERNAL_LINKS: {
            name: 'INCLUDE_LOCATION_EXTERNAL_LINKS',
            value: 'INCLUDE_LOCATION_EXTERNAL_LINKS',
        },
        INCLUDE_MASTER_ENTITIES: {
            name: 'INCLUDE_MASTER_ENTITIES',
            value: 'INCLUDE_MASTER_ENTITIES',
        },
        INCLUDE_MASTER_PERSON_ON_CONTEXTED_PERSONS: {
            name: 'INCLUDE_MASTER_PERSON_ON_CONTEXTED_PERSONS',
            value: 'INCLUDE_MASTER_PERSON_ON_CONTEXTED_PERSONS',
        },
        INCLUDE_NON_PERMISSIONED_REPORT_REPORT_LINKS: {
            name: 'INCLUDE_NON_PERMISSIONED_REPORT_REPORT_LINKS',
            value: 'INCLUDE_NON_PERMISSIONED_REPORT_REPORT_LINKS',
        },
        INCLUDE_PARENT_ATTRIBUTES: {
            name: 'INCLUDE_PARENT_ATTRIBUTES',
            value: 'INCLUDE_PARENT_ATTRIBUTES',
        },
        INCLUDE_RADIUS_BASED_CAUTIONS: {
            name: 'INCLUDE_RADIUS_BASED_CAUTIONS',
            value: 'INCLUDE_RADIUS_BASED_CAUTIONS',
        },
        INCLUDE_RELEASED_UNITS: { name: 'INCLUDE_RELEASED_UNITS', value: 'INCLUDE_RELEASED_UNITS' },
        INCLUDE_REPORT_SHORT_TITLES: {
            name: 'INCLUDE_REPORT_SHORT_TITLES',
            value: 'INCLUDE_REPORT_SHORT_TITLES',
        },
        INCLUDE_TRAFFIC_CRASH_DIAGRAM_CONTENTS: {
            name: 'INCLUDE_TRAFFIC_CRASH_DIAGRAM_CONTENTS',
            value: 'INCLUDE_TRAFFIC_CRASH_DIAGRAM_CONTENTS',
        },
        INCLUDE_UK_OFFENSE_CODE_EXTENSIONS: {
            name: 'INCLUDE_UK_OFFENSE_CODE_EXTENSIONS',
            value: 'INCLUDE_UK_OFFENSE_CODE_EXTENSIONS',
        },
        INCLUDE_USERS: { name: 'INCLUDE_USERS', value: 'INCLUDE_USERS' },
        INCLUDE_USER_ATTACHMENTS: {
            name: 'INCLUDE_USER_ATTACHMENTS',
            value: 'INCLUDE_USER_ATTACHMENTS',
        },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    HI = {
        CYYXXXXXX: { name: 'CYYXXXXXX', value: 23 },
        FCYYXXXXXX: { name: 'FCYYXXXXXX', value: 4 },
        HXXXXXXX: { name: 'HXXXXXXX', value: 20 },
        TSKXXXXXXXX: { name: 'TSKXXXXXXXX', value: 27 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        XXXX: { name: 'XXXX', value: 13 },
        XXXXX: { name: 'XXXXX', value: 12 },
        XXXXXX: { name: 'XXXXXX', value: 11 },
        XXXXXXX: { name: 'XXXXXXX', value: 10 },
        XXXXXX_SLASH_YY: { name: 'XXXXXX_SLASH_YY', value: 26 },
        XXXXX_SLASH_YY: { name: 'XXXXX_SLASH_YY', value: 28 },
        YYMM40XXXX: { name: 'YYMM40XXXX', value: 1 },
        YYMMDDX: { name: 'YYMMDDX', value: 19 },
        YYMMDDXX: { name: 'YYMMDDXX', value: 18 },
        YYMMDDXXX: { name: 'YYMMDDXXX', value: 9 },
        YYMMDDXXXX: { name: 'YYMMDDXXXX', value: 5 },
        YYMMXX: { name: 'YYMMXX', value: 17 },
        YYMMXXX: { name: 'YYMMXXX', value: 16 },
        YYMMXXXX: { name: 'YYMMXXXX', value: 15 },
        YYMMXXXXX: { name: 'YYMMXXXXX', value: 14 },
        YYXXXXX: { name: 'YYXXXXX', value: 25 },
        YYYY_XXXXXXXX: { name: 'YYYY_XXXXXXXX', value: 21 },
        YY_MM_XXXXX: { name: 'YY_MM_XXXXX', value: 24 },
        YY_XXX: { name: 'YY_XXX', value: 8 },
        YY_XXXX: { name: 'YY_XXXX', value: 6 },
        YY_XXXXX: { name: 'YY_XXXXX', value: 7 },
        YY_XXXXXX: { name: 'YY_XXXXXX', value: 3 },
        YY_XXXXXXX: { name: 'YY_XXXXXXX', value: 22 },
    },
    YI = { COMPOSITE_KEY: { name: 'COMPOSITE_KEY' }, ID: { name: 'ID' } },
    tI = {
        FAILED: { name: 'FAILED' },
        IN_PROGRESS: { name: 'IN_PROGRESS' },
        SUCCESSFUL: { name: 'SUCCESSFUL' },
    },
    VI = {
        ORIGINAL: { name: 'ORIGINAL', value: 1 },
        THUMBNAIL_LARGE: { name: 'THUMBNAIL_LARGE', value: 8 },
        THUMBNAIL_MEDIUM: { name: 'THUMBNAIL_MEDIUM', value: 4 },
        THUMBNAIL_SMALL: { name: 'THUMBNAIL_SMALL', value: 2 },
        WEB: { name: 'WEB', value: 16 },
    },
    oI = { CRITICAL: { name: 'CRITICAL' }, WARNING: { name: 'WARNING' } },
    BI = { ALL: { name: 'ALL' }, GRAFANA: { name: 'GRAFANA' }, SIGNALFX: { name: 'SIGNALFX' } },
    rI = {
        COMPLETED: { name: 'COMPLETED' },
        IN_PROGRESS: { name: 'IN_PROGRESS' },
        STARTING: { name: 'STARTING' },
    },
    sI = {
        BOLOS: { name: 'BOLOS' },
        CAD_BOLOS: { name: 'CAD_BOLOS' },
        CAD_GEOFENCE: { name: 'CAD_GEOFENCE' },
        CAD_TICKETS: { name: 'CAD_TICKETS' },
        CAD_TICKET_PERCOLATORS: { name: 'CAD_TICKET_PERCOLATORS' },
        CALENDAR_EVENTS: { name: 'CALENDAR_EVENTS' },
        CASES: { name: 'CASES' },
        CASE_PERCOLATORS: { name: 'CASE_PERCOLATORS' },
        COBALT_CAD_TICKETS: { name: 'COBALT_CAD_TICKETS' },
        COURT_ORDERS: { name: 'COURT_ORDERS' },
        DELETED_ENTITIES: { name: 'DELETED_ENTITIES' },
        ELASTIC_GEO_ADDRESS_POINT: { name: 'ELASTIC_GEO_ADDRESS_POINT' },
        ELASTIC_MATERIALIZED_LOCATION: { name: 'ELASTIC_MATERIALIZED_LOCATION' },
        EVIDENCE_ITEMS: { name: 'EVIDENCE_ITEMS' },
        EVIDENCE_ITEM_PERCOLATORS: { name: 'EVIDENCE_ITEM_PERCOLATORS' },
        E_FILES: { name: 'E_FILES' },
        E_FILE_PERCOLATORS: { name: 'E_FILE_PERCOLATORS' },
        FILES: { name: 'FILES' },
        GEO_ALIASES: { name: 'GEO_ALIASES' },
        GEO_CAUTIONS: { name: 'GEO_CAUTIONS' },
        LOCATION_ALIASES: { name: 'LOCATION_ALIASES' },
        LOCATION_ENTITIES: { name: 'LOCATION_ENTITIES' },
        LOCATION_ENTITY_VIEWS: { name: 'LOCATION_ENTITY_VIEWS' },
        LOCATION_ENTITY_VIEW_PERCOLATORS: { name: 'LOCATION_ENTITY_VIEW_PERCOLATORS' },
        OFFENSE_CODES: { name: 'OFFENSE_CODES' },
        ORGANIZATIONS: { name: 'ORGANIZATIONS' },
        ORGANIZATION_PERCOLATORS: { name: 'ORGANIZATION_PERCOLATORS' },
        PERSONS: { name: 'PERSONS' },
        PERSON_PERCOLATORS: { name: 'PERSON_PERCOLATORS' },
        POINT_LOCATION: { name: 'POINT_LOCATION' },
        PROPERTY: { name: 'PROPERTY' },
        PROPERTY_PERCOLATORS: { name: 'PROPERTY_PERCOLATORS' },
        REPORTS: { name: 'REPORTS' },
        REPORT_PERCOLATORS: { name: 'REPORT_PERCOLATORS' },
        ROLODEX_PROFILE: { name: 'ROLODEX_PROFILE' },
        SHAPEFILES: { name: 'SHAPEFILES' },
        SHAPEFILES_V2: { name: 'SHAPEFILES_V2' },
        STORAGE_LOCATIONS: { name: 'STORAGE_LOCATIONS' },
        STREET_SEGMENT: { name: 'STREET_SEGMENT' },
        TASKS: { name: 'TASKS' },
        TASKS_V2: { name: 'TASKS_V2' },
        UNIT_LOCATIONS: { name: 'UNIT_LOCATIONS' },
        UNIT_STATUS: { name: 'UNIT_STATUS' },
        USERS: { name: 'USERS' },
        USER_ACTIONS: { name: 'USER_ACTIONS' },
        USER_LOCATIONS: { name: 'USER_LOCATIONS' },
        USER_PERCOLATORS: { name: 'USER_PERCOLATORS' },
        VEHICLES: { name: 'VEHICLES' },
        VEHICLE_PERCOLATORS: { name: 'VEHICLE_PERCOLATORS' },
        WARRANTS: { name: 'WARRANTS' },
        WARRANT_PERCOLATORS: { name: 'WARRANT_PERCOLATORS' },
    },
    iI = { OPEN: { name: 'OPEN', value: 1 }, RESOLVED: { name: 'RESOLVED', value: 2 } },
    WI = {
        BOOLEAN_SELECT: { name: 'BOOLEAN_SELECT', value: 7 },
        CARD: { name: 'CARD', value: 11 },
        CHECKBOXES: { name: 'CHECKBOXES', value: 10 },
        COURT_SELECT: { name: 'COURT_SELECT', value: 17 },
        CRASH_DIAGRAM: { name: 'CRASH_DIAGRAM', value: 20 },
        DATE: { name: 'DATE', value: 3 },
        DATETIME: { name: 'DATETIME', value: 4 },
        FIREARM_SELECT: { name: 'FIREARM_SELECT', value: 15 },
        INTERNAL_DATA: { name: 'INTERNAL_DATA', value: 8 },
        ITEM_PROFILE_SELECT: { name: 'ITEM_PROFILE_SELECT', value: 16 },
        LOCATION_ENTITY_LINK: { name: 'LOCATION_ENTITY_LINK', value: 18 },
        MULTISELECT: { name: 'MULTISELECT', value: 6 },
        NAME_REPORT_LINK: { name: 'NAME_REPORT_LINK', value: 13 },
        N_CARD: { name: 'N_CARD', value: 22 },
        N_ITEMS: { name: 'N_ITEMS', value: 12 },
        PERSON_SELECT: { name: 'PERSON_SELECT', value: 21 },
        SELECT: { name: 'SELECT', value: 5 },
        SIGNATURE: { name: 'SIGNATURE', value: 19 },
        TEXT: { name: 'TEXT', value: 1 },
        TEXTAREA: { name: 'TEXTAREA', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER_SELECT: { name: 'USER_SELECT', value: 9 },
        VEHICLE_SELECT: { name: 'VEHICLE_SELECT', value: 14 },
    },
    cI = {
        ACKNOWLEDGED: { name: 'ACKNOWLEDGED', value: 2 },
        ERROR: { name: 'ERROR', value: 5 },
        FAILURE: { name: 'FAILURE', value: 6 },
        IN_PROGRESS: { name: 'IN_PROGRESS', value: 3 },
        SENT: { name: 'SENT', value: 1 },
        SUCCESS: { name: 'SUCCESS', value: 4 },
    },
    KI = {
        ASSIGNED_INVESTIGATOR: { name: 'ASSIGNED_INVESTIGATOR', value: 3 },
        ASSIGNED_SUPERVISOR: { name: 'ASSIGNED_SUPERVISOR', value: 4 },
        LATEST_CHAIN_OF_CUSTODY_PERSONNEL: { name: 'LATEST_CHAIN_OF_CUSTODY_PERSONNEL', value: 7 },
        PERSON_CHECKED_OUT_TO: { name: 'PERSON_CHECKED_OUT_TO', value: 6 },
        PRIMARY_REPORTING_OFFICER: { name: 'PRIMARY_REPORTING_OFFICER', value: 1 },
        PROPERTY_PERSONNEL: { name: 'PROPERTY_PERSONNEL', value: 5 },
        RECOVERING_OFFICER: { name: 'RECOVERING_OFFICER', value: 2 },
    },
    dI = {
        NONE: { name: 'NONE', value: 1 },
        PROPERTY_INVOLVED: { name: 'PROPERTY_INVOLVED', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: 2 },
    },
    pI = {
        IN_CUSTODY: { name: 'IN_CUSTODY' },
        IN_TRANSFER: { name: 'IN_TRANSFER' },
        PENDING_BOOKING: { name: 'PENDING_BOOKING' },
        RELEASED: { name: 'RELEASED' },
        TEMP_RELEASE: { name: 'TEMP_RELEASE' },
    },
    yI = {
        ACTIVE: { name: 'ACTIVE' },
        ARCHIVED: { name: 'ARCHIVED' },
        SITE_DISABLED: { name: 'SITE_DISABLED' },
    },
    XI = {
        AREA: { name: 'AREA' },
        BED: { name: 'BED' },
        CELL: { name: 'CELL' },
        OTHER: { name: 'OTHER' },
        PROPERTY_STORAGE: { name: 'PROPERTY_STORAGE' },
        SITE: { name: 'SITE' },
    },
    QI = { ACTIVE: { name: 'ACTIVE' }, PAUSED: { name: 'PAUSED' }, STOPPED: { name: 'STOPPED' } },
    bI = {
        MANAGE: { name: 'MANAGE', value: 'MANAGE' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
        USE: { name: 'USE', value: 'USE' },
    },
    fI = {
        NATIVE: { name: 'NATIVE', value: 'NATIVE' },
        PARENT: { name: 'PARENT', value: 'PARENT' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    gI = {
        ANALYTICAL_DASHBOARD: { name: 'ANALYTICAL_DASHBOARD', value: 'analyticalDashboard' },
        DASHBOARD_PLUGIN: { name: 'DASHBOARD_PLUGIN', value: 'dashboardPlugin' },
        JWK: { name: 'JWK', value: 'jwk' },
        JWT: { name: 'JWT', value: 'jwt' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
        USER: { name: 'USER', value: 'user' },
        USERGROUP: { name: 'USERGROUP', value: 'userGroup' },
        USERSETTING: { name: 'USERSETTING', value: 'userSetting' },
        VISUALIZATION_OBJECT: { name: 'VISUALIZATION_OBJECT', value: 'visualizationObject' },
        WORKSPACE: { name: 'WORKSPACE', value: 'workspace' },
        WORKSPACEDATAFILTER: { name: 'WORKSPACEDATAFILTER', value: 'workspaceDataFilter' },
        WORKSPACEDATAFILTERSETTING: {
            name: 'WORKSPACEDATAFILTERSETTING',
            value: 'workspaceDataFilterSetting',
        },
        WORKSPACESETTING: { name: 'WORKSPACESETTING', value: 'workspaceSetting' },
    },
    JI = {
        LOCALE: { name: 'LOCALE', value: 'LOCALE' },
        TIMEZONE: { name: 'TIMEZONE', value: 'TIMEZONE' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    hI = {
        TIMEZONE: { name: 'TIMEZONE', value: 'TIMEZONE' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    ZI = {
        ANALYZE: { name: 'ANALYZE', value: 'ANALYZE' },
        CREATE_AUTOMATION: { name: 'CREATE_AUTOMATION', value: 'CREATE_AUTOMATION' },
        CREATE_FILTER_VIEW: { name: 'CREATE_FILTER_VIEW', value: 'CREATE_FILTER_VIEW' },
        EXPORT: { name: 'EXPORT', value: 'EXPORT' },
        EXPORT_PDF: { name: 'EXPORT_PDF', value: 'EXPORT_PDF' },
        EXPORT_TABULAR: { name: 'EXPORT_TABULAR', value: 'EXPORT_TABULAR' },
        MANAGE: { name: 'MANAGE', value: 'MANAGE' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
        USE_AI_ASSISTANT: { name: 'USE_AI_ASSISTANT', value: 'USE_AI_ASSISTANT' },
        VIEW: { name: 'VIEW', value: 'VIEW' },
    },
    jI = { SEARCH_SYNC: { name: 'SEARCH_SYNC' } },
    xI = {
        DLQ_REPLAY: { name: 'DLQ_REPLAY' },
        PUBLISHER: { name: 'PUBLISHER' },
        RETRY: { name: 'RETRY' },
    },
    kI = {
        AGENCY_EVENT: { name: 'AGENCY_EVENT' },
        BOLO: { name: 'BOLO' },
        CAD_TICKET: { name: 'CAD_TICKET' },
        CALENDAR_EVENT: { name: 'CALENDAR_EVENT' },
        CASE: { name: 'CASE' },
        COURT_ORDER: { name: 'COURT_ORDER' },
        ENTITY_CHANGED: { name: 'ENTITY_CHANGED' },
        ENTITY_UPDATES: { name: 'ENTITY_UPDATES' },
        E_FILE: { name: 'E_FILE' },
        FACILITY: { name: 'FACILITY' },
        GEOFENCE: { name: 'GEOFENCE' },
        GEO_ADDRESS_POINT: { name: 'GEO_ADDRESS_POINT' },
        GEO_ALIAS: { name: 'GEO_ALIAS' },
        GEO_CAUTION: { name: 'GEO_CAUTION' },
        ITEM_PROFILE: { name: 'ITEM_PROFILE' },
        ITEM_STORAGE_LOCATION: { name: 'ITEM_STORAGE_LOCATION' },
        LOCATION: { name: 'LOCATION' },
        MARK43_FILE: { name: 'MARK43_FILE' },
        MATERIALIZED_USER_ACTION: { name: 'MATERIALIZED_USER_ACTION' },
        OFFENSE_CODE: { name: 'OFFENSE_CODE' },
        ORGANIZATION_PROFILE: { name: 'ORGANIZATION_PROFILE' },
        PERSON_PROFILE: { name: 'PERSON_PROFILE' },
        POINT_LOCATION: { name: 'POINT_LOCATION' },
        REPORT: { name: 'REPORT' },
        RETRY: { name: 'RETRY' },
        ROLODEX_PROFILE: { name: 'ROLODEX_PROFILE' },
        SAVED_SEARCH: { name: 'SAVED_SEARCH' },
        SHAPEFILE: { name: 'SHAPEFILE' },
        STREET_SEGMENT: { name: 'STREET_SEGMENT' },
        TASK: { name: 'TASK' },
        UNIT_STATUS: { name: 'UNIT_STATUS' },
        USER_PROFILE: { name: 'USER_PROFILE' },
        WARRANT: { name: 'WARRANT' },
    },
    wI = { INTERNAL: { name: 'INTERNAL' }, MIRRORED: { name: 'MIRRORED' } },
    zI = {
        CAD_EVENT: { name: 'CAD_EVENT' },
        ITEM: { name: 'ITEM' },
        ORGANIZATION: { name: 'ORGANIZATION' },
        PERSON: { name: 'PERSON' },
        REPORT: { name: 'REPORT' },
        VEHICLE: { name: 'VEHICLE' },
    },
    qI = {
        ACQUAINTANCE_OF: 37,
        ADDITIONAL_INFORMATION_IN_AGENCY_EVENT: 171,
        ADOPTED_BROTHER_OF: 331,
        ADOPTED_GRANDPARENT_OF: 337,
        ADOPTED_PARENT_OF: 335,
        ADOPTED_SISTER_OF: 332,
        AGENCY_EVENT_UNLINK: 198,
        AGENCY_PROFILE_LOGO: 271,
        ALLEGED_MEMBER_OF_GANG: 135,
        ARREST_LOCATION: 124,
        ASSISTING_AGENCY: 221,
        ASSOCIATE_OF: 17,
        ASSURED_WITH: 338,
        ATTACHMENT_IN_BRIEFING: 291,
        ATTACHMENT_IN_EFILE: 281,
        ATTACHMENT_TO_BULLETIN: 160,
        ATTENDED: 339,
        ATTENDS_SCHOOL_AT: 10,
        AXON_TRANSCRIPT_ATTACHMENT: 379,
        BABYSITTER_OF: 104,
        BAILIFF_OF: 326,
        BOLO_ATTACHMENT: 370,
        BOLO_LOCATION: 253,
        BOLO_SUBJECT_LOCATION: 361,
        BOYFRIEND_GIRLFRIEND: 362,
        BUSINESS_ADDRESS: 110,
        BUSINESS_BUSINESS: 111,
        BUSINESS_INTEREST_OF: 340,
        BUSINESS_LOCATION: 109,
        CAD_AGENCY_EVENT_ATTACHMENT: 369,
        CALL_FOR_SERVICE_AGENCY_MAPPING: 197,
        CARETAKER_OF: 26,
        CASCADED_FROM: 368,
        CASE_ATTACHMENT: 268,
        CASE_NOTE_ATTACHMENT: 49,
        CASE_NOTE_LOCATION: 129,
        CHAIN_EVENT_ATTACHMENT: 220,
        CHAIN_EVENT_ID_SCAN: 181,
        CHAIN_EVENT_SIGNATURE: 180,
        CHILD_OF: 20,
        CHILD_OF_BOYFRIEND_OF: 250,
        CHILD_OF_EX_BOYFRIEND_GIRLFRIEND: 356,
        CHILD_OF_GIRLFRIEND_OF: 251,
        CHILD_OF_INTIMATE_PARTNER: 376,
        CHILD_OF_SIGNIFICANT_OTHER: 98,
        CLAIMED_BY: 113,
        CLIENT_OF: 245,
        COHABITANT_NON_INTIMATE_RELATIONSHIP: 293,
        COMMON_LAW_SPOUSE: 100,
        COMPLAINANT_IN_REPORT: 205,
        CONFIGURED_ENTITY_LOCATION: 285,
        CONFIGURED_ENTITY_NAME_IN_REPORT: 272,
        CONFIRMED_MEMBER_OF_GANG: 136,
        CONTACT_OF: 341,
        CONTRACTED_TO: 342,
        COPIED_CALL: 222,
        COURT_ORDER_ATTACHMENT: 217,
        COWORKER_OF: 21,
        CO_DEFENDANT: 53,
        CRIMINAL_ASSOCIATE_OF: 324,
        DATING_WITH: 287,
        DEFENDANT: 252,
        DEFENDANT_IN_ARREST: 28,
        DEFENDANT_IN_EFILE: 278,
        DEPARTMENT_PROFILE_ADDRESS: 212,
        DEPARTMENT_PROFILE_LOGO: 211,
        DEX_MESSAGE_DISPATCH_AREA_OWNER: 228,
        DEX_MESSAGE_SENT_FOR: 227,
        DISPATCH_AREA_MONITOR: 225,
        DISPATCH_AREA_OWNER_PRIMARY: 224,
        DRIVERS_LICENSE_PHOTO: 275,
        DRIVER_LICENSE_BACK_PHOTO: 256,
        DRIVER_LICENSE_FRONT_PHOTO: 255,
        DRUGS_IN_AGENCY_EVENT: 359,
        EMAIL_EXPORTED_ATTACHMENT: 355,
        EMAIL_EXPORT_RELEASE_ATTACHMENT: 316,
        EMPLOYEE: 2,
        EMPLOYEE_OF: 22,
        ENEMY_OF: 23,
        ENGAGED_TO: 24,
        EQUIPPED_ON_UNIT: 168,
        ESTRANGED_SPOUSE_OF: 241,
        EVENT_LOCATION: 161,
        EVIDENCE_FACILITY_LOCATION: 178,
        EXPORTED_ATTACHMENT: 354,
        EXPORT_RELEASE_ATTACHMENT: 210,
        EX_BOYFRIEND_GIRLFRIEND: 357,
        EX_DATING_WITH: 289,
        EX_EMPLOYEE_OF: 249,
        EX_LIVE_IN_WITH: 288,
        EX_PARTNER_PARTNERSHIP_NOT_KNOWN: 322,
        EX_SIGNIFICANT_OTHER_OF: 32,
        EX_SPOUSE_OF: 105,
        E_FILE_ARREST_LOCATION: 381,
        E_FILE_OFFENSE_LOCATION: 375,
        FACTION_SUBSET_OF_GANG: 137,
        FEMALE_COHABITANT: 266,
        FEMALE_SEXUAL: 267,
        FIELD_NOTE_ATTACHMENT: 213,
        FIELD_NOTE_ITEM_PROFILE: 367,
        FIELD_NOTE_LINKED_LOCATION: 230,
        FIELD_NOTE_LINKED_PERSON: 229,
        FINGERPRINT: 43,
        FIREARM_IN_AGENCY_EVENT: 358,
        FORMER_EMPLOYEE_OF: 343,
        FORMER_INTIMATE_PARTNER: 377,
        FORMER_MEMBER_OF: 344,
        FOSTER_CHILD: 292,
        FOSTER_CHILD_OF: 239,
        FOSTER_SIBLING_OF: 243,
        FRIEND_OF: 25,
        GANG_MEMBER_WITH: 248,
        GRANDCHILD_OF: 101,
        GUARDIAN_OF: 31,
        HALF_BROTHER_OF: 334,
        HALF_SISTER_OF: 333,
        HANGS_OUT_AT: 131,
        HAS_CHILD_WITH: 40,
        HETEROSEXUAL_EX_PARTNER_OF: 320,
        HETEROSEXUAL_PARTNER_OF: 317,
        HOMOSEXUAL_COHABITANT: 263,
        HOMOSEXUAL_RELATIONSHIP: 264,
        HOSPITAL_LOCATION: 353,
        HTML_EDITOR_IMAGE_BRIEFING_ATTACHMENT: 283,
        HTML_EDITOR_IMAGE_REPORT_ATTACHMENT: 284,
        IDENTIFYING_MARK: 127,
        INSURED_WITH: 345,
        INTERSECTING_ROADWAY_OF_TRAFFIC_CRASH: 260,
        INVOLVED_ORG_IN_REPORT: 216,
        INVOLVED_PERSON_IN_AGENCY_EVENT: 269,
        INVOLVED_PERSON_IN_REPORT: 215,
        INVOLVED_PERSON_LOCATION: 270,
        INVOLVED_PROFILE_IN_EFILE: 279,
        INVOLVED_PROPERTY: 11,
        IN_DISPUTE_WITH: 325,
        IN_LAW_OF: 106,
        ITEM_IN_EFILE: 280,
        ITEM_PROFILE_ATTACHMENT: 219,
        ITEM_PROFILE_PHOTO: 218,
        KEYHOLDER_OF: 346,
        LAST_KNOWN_CONTACT_IN_REPORT: 169,
        LAST_KNOWN_LOCATION: 63,
        LIVES_AT: 6,
        LIVES_WITH: 38,
        LOCATION_ATTACHMENT: 371,
        LOCATION_OF_BEHAVIORAL_CRISIS: 234,
        LOCATION_OF_CAD_TICKET: 138,
        LOCATION_OF_CITATION: 208,
        LOCATION_OF_EVENT: 7,
        LOCATION_OF_FIELD_CONTACT: 116,
        LOCATION_OF_PERSON_STOP: 240,
        LOCATION_OF_STOP: 236,
        LOCATION_OF_TRAFFIC_CRASH: 206,
        LOCATION_OF_USE_OF_FORCE: 183,
        LOCATION_OF_WARRANT: 203,
        LOCATION_WHERE_LOCATED: 130,
        LOVER_OF: 27,
        MEDICAL_PROFESSIONAL_OF: 327,
        MEMBER_OF: 347,
        MEMBER_OF_UNIT: 167,
        MISSING_PERSON_IN_REPORT: 13,
        MUGSHOT: 41,
        MUGSHOT_LEFT: 372,
        MUGSHOT_RIGHT: 373,
        NEIGHBOR_OF: 103,
        NON_HETEROSEXUAL_EX_PARTNER_OF: 321,
        NON_HETEROSEXUAL_PARTNER_OF: 318,
        NON_MARRIED_LIVE_IN: 242,
        NON_MOTORIST: 107,
        OFFENDER_IN_OFFENSE: 301,
        OFFENSE_IN_ARREST: 52,
        OFFENSE_LOCATION: 123,
        ORGANIZATION_IN_FIELD_CONTACT: 133,
        ORGANIZATION_PROFILE_ATTACHMENT: 200,
        ORGANIZATION_PROFILE_PHOTO: 235,
        ORG_INVESTIGATED_WITH: 364,
        OTHERWISE_KNOWN: 16,
        OTHER_FAMILY_MEMBER: 378,
        OTHER_ITEM_IN_AGENCY_EVENT: 360,
        OTHER_LOCATION_IN_REPORT: 42,
        OTHER_NAME_IN_BEHAVIORAL_CRISIS: 232,
        OTHER_NAME_IN_FIELD_CONTACT: 233,
        OTHER_NAME_IN_OFFENSE: 71,
        OTHER_NAME_IN_REPORT: 50,
        OTHER_NAME_IN_STOP: 238,
        OTHER_SEXUAL_RELATIONSHIP: 323,
        OWNED_BY: 112,
        OWNER_OF: 348,
        PARENT_DEX_MESSAGE: 294,
        PARENT_IN_LAW_OF: 246,
        PARTNERSHIP_NOT_KNOWN: 319,
        PATROL_LOCATION: 179,
        PERSONAL_RELATIONSHIP_WITH: 328,
        PERSON_BAIL_LOCATION: 302,
        PERSON_DETAINED_AT_LOCATION: 303,
        PERSON_DISCHARGE_LOCATION: 304,
        PERSON_FOUND_AT_LOCATION: 305,
        PERSON_FREQUENTS_LOCATION: 306,
        PERSON_HAS_AN_INTEREST_IN_LOCATION: 307,
        PERSON_INVESTIGATED_WITH: 363,
        PERSON_IN_BOOKING: 380,
        PERSON_IN_VEHICLE: 12,
        PERSON_PLACE_OF_SAFETY_LOCATION: 310,
        PERSON_PROFILE_ATTACHMENT: 199,
        PERSON_RELATIVES_LOCATION: 309,
        PERSON_SAFE_LOCATION: 311,
        PERSON_SEARCHED_AT_LOCATION: 312,
        PERSON_SIGHTED_LOCATION: 308,
        PERSON_STAYING_AT_LOCATION: 313,
        PERSON_STOPPED_AND_SEARCHED_LOCATION: 314,
        PERSON_STOPPED_LOCATION: 315,
        PHONE_CALL_IN_EVENT: 177,
        PLAYS_WITH: 35,
        PROPERTY_RECOVERED_LOCATION: 117,
        RELATED_TO: 29,
        RELATIONSHIP_TO_ORGANIZATION_UNKNOWN: 194,
        RELATIONSHIP_UNKNOWN: 193,
        RELATIVE_OF: 329,
        REPORTING_PARTY_IN_AGENCY_EVENT: 164,
        REPORTING_PARTY_IN_REPORT: 56,
        REPORTING_PARTY_LOCATION: 162,
        REPORT_ATTACHMENT: 126,
        REPRESENTATIVE_OF: 349,
        RMS_PERSON_CREATED_FROM_CAD_PERSON: 277,
        RMS_VEHICLE_CREATED_FROM_CAD_VEHICLE: 374,
        ROADWAY_OF_TRAFFIC_CRASH: 259,
        ROADWAY_OF_VEHICLE: 261,
        ROOMMATE_OF: 286,
        ROTATION_SERVICE_PROVIDER_LOCATION: 295,
        SCHOOL_ADMINISTRATOR_OF: 290,
        SELLS_TO: 36,
        SIBLING_IN_LAW_OF: 247,
        SIBLING_OF: 18,
        SIGNIFICANT_OTHER_OF: 39,
        SPECIAL_ASSIGNMENT_LOCATION: 195,
        SPOUSE_OF: 33,
        STATION_LOCATION: 226,
        STEP_GRANDPARENT_OF: 336,
        STEP_PARENT_OF: 3,
        STEP_SIBLING_OF: 102,
        STOLE_IDENTITY_OF: 19,
        STRANGER_OF: 99,
        STRANGER_TO: 350,
        STUDENT_OF: 244,
        STUDIED_AT: 351,
        STUDIES_AT: 352,
        SUBJECT_IN_BEHAVIORAL_CRISIS: 223,
        SUBJECT_IN_CITATION: 209,
        SUBJECT_IN_COMMUNITY_INFORMATION: 134,
        SUBJECT_IN_FIELD_CONTACT: 114,
        SUBJECT_IN_OFFENSE: 14,
        SUBJECT_IN_STOP: 237,
        SUBJECT_IN_TRAFFIC_CRASH: 207,
        SUBJECT_IN_USE_OF_FORCE: 132,
        SUBJECT_OF_WARRANT: 30,
        SUSPECT_IN_OFFENSE: 5,
        SUSPECT_IN_REPORT: 8,
        TASK_ATTACHMENT: 182,
        THREATENED: 231,
        TIED_TO: 1,
        TOW_VEHICLE_FROM_LOCATION: 175,
        TOW_VEHICLE_RECOVERY_LOCATION: 189,
        TOW_VEHICLE_RELEASE_AUTHORIZED_BY: 192,
        TOW_VEHICLE_RELEASE_TO: 191,
        TOW_VEHICLE_REPORTED_STOLEN_LOCATION: 188,
        TOW_VEHICLE_STORAGE_LOCATION: 190,
        TOW_VEHICLE_TOWED_FROM_LOCATION: 187,
        TOW_VEHICLE_TO_LOCATION: 176,
        TOW_VEHICLE_VEHICLE: 186,
        TRAFFIC_CRASH_ATTACHMENT: 257,
        TRAFFIC_CRASH_EXPORT_ATTACHMENT: 258,
        TRANSPORT_LOCATION: 173,
        TRU_RESPONDER: 170,
        UNIT_LOCATION_INFO_LOCATION: 201,
        UNKNOWN: -1,
        USER_ERROR_REPORT_ATTACHMENT: 214,
        USER_HOME_ADDRESS: 184,
        USER_PHOTO: 185,
        USER_PROFILE_ATTACHMENT: 196,
        USER_SIGNATURE: 262,
        USES_PARTICULARS_OF: 330,
        VEHICLE_ABANDONED_LOCATION: 296,
        VEHICLE_BURNED_LOCATION: 297,
        VEHICLE_IN_AGENCY_EVENT: 166,
        VEHICLE_LICENSE_PLATE_PHOTO: 254,
        VEHICLE_REGISTERED_LOCATION: 298,
        VEHICLE_SEEN_LOCATION: 299,
        VEHICLE_STOLEN_FROM_LOCATION: 300,
        VICTIM_IN_OFFENSE: 4,
        VICTIM_IN_REPORT: 125,
        VULNERABLE_PERSON_IN_REPORT: 274,
        WARRANT_ATTACHMENT: 202,
        WIFE: 265,
        WITNESS_IN_OFFENSE: 15,
        WITNESS_IN_REPORT: 108,
        WORKS_AT: 9,
    },
    $I = {
        CCM: { name: 'CCM', value: 'CCM' },
        CDM: { name: 'CDM', value: 'CDM' },
        CRM: { name: 'CRM', value: 'CRM' },
    },
    ER = {
        DC_MAR: { name: 'DC_MAR' },
        ESRI_ARCGIS_ENTERPRISE: { name: 'ESRI_ARCGIS_ENTERPRISE' },
        SHAPEFILE_ELASTIC: { name: 'SHAPEFILE_ELASTIC' },
        UNKNOWN: { name: 'UNKNOWN' },
    },
    _R = {
        DC_CAD: { name: 'DC_CAD', value: 16 },
        DC_MAR: { name: 'DC_MAR', value: 2 },
        ESRI: { name: 'ESRI', value: 17 },
        ESRI_CUSTOM: { name: 'ESRI_CUSTOM', value: 18 },
        FORCED_LOCATION: { name: 'FORCED_LOCATION', value: 20 },
        FORCED_SUB_PREMISES: { name: 'FORCED_SUB_PREMISES', value: 26 },
        GEO_ADDRESS_POINTS: { name: 'GEO_ADDRESS_POINTS', value: 24 },
        GEO_ALIAS: { name: 'GEO_ALIAS', value: 25 },
        GOOGLE: { name: 'GOOGLE', value: 8 },
        INTEGRATION_LOCATION: { name: 'INTEGRATION_LOCATION', value: 23 },
        LAT_LONG: { name: 'LAT_LONG', value: 27 },
        LEGACY_LOCATION: { name: 'LEGACY_LOCATION', value: 21 },
        MARK43: { name: 'MARK43', value: 1 },
        MIGRATION_LOCATION: { name: 'MIGRATION_LOCATION', value: 22 },
        POSTCODER: { name: 'POSTCODER', value: 28 },
        SMARTY_STREETS: { name: 'SMARTY_STREETS', value: 4 },
        STREET_CENTERLINE: { name: 'STREET_CENTERLINE', value: 19 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    TR = {
        ADDRESS: { name: 'ADDRESS', value: 'ADDRESS' },
        INTERSECTION: { name: 'INTERSECTION', value: 'INTERSECTION' },
        POINT: { name: 'POINT', value: 'POINT' },
        RANGE: { name: 'RANGE', value: 'RANGE' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    eR = {
        AREA: { name: 'AREA', value: 'AREA' },
        BED: { name: 'BED', value: 'BED' },
        CELL: { name: 'CELL', value: 'CELL' },
        OTHER: { name: 'OTHER', value: 'OTHER' },
        PROPERTY_STORAGE: { name: 'PROPERTY_STORAGE', value: 'PROPERTY_STORAGE' },
        SITE: { name: 'SITE', value: 'SITE' },
    },
    AR = {
        EMAIL: { name: 'EMAIL', value: 'email' },
        LOGIN_COMPLETE: { name: 'LOGIN_COMPLETE', value: 'login_complete' },
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 'password_reset' },
        SECURITY_QUESTION: { name: 'SECURITY_QUESTION', value: 'security_question' },
        TEXT_MESSAGE: { name: 'TEXT_MESSAGE', value: 'text_message' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unknown' },
    },
    NR = {
        FOLDER: { name: 'FOLDER', value: 4 },
        GROUP: { name: 'GROUP', value: 2 },
        PERSONAL: { name: 'PERSONAL', value: 1 },
        SHARED: { name: 'SHARED', value: 3 },
    },
    IR = {
        DASHBOARD: { name: 'DASHBOARD', value: 2 },
        EXPLORE: { name: 'EXPLORE', value: 3 },
        FOLDER: { name: 'FOLDER', value: 5 },
        LOOK: { name: 'LOOK', value: 1 },
        SPACE: { name: 'SPACE', value: 4 },
    },
    RR = {
        ARREST: { name: 'ARREST', value: 'ARREST' },
        ARRESTATTRIBUTE: { name: 'ARRESTATTRIBUTE', value: 'ARRESTATTRIBUTE' },
        ASSISTINGOFFICER: { name: 'ASSISTINGOFFICER', value: 'ASSISTINGOFFICER' },
        BEHAVIORALCRISIS: { name: 'BEHAVIORALCRISIS', value: 'BEHAVIORALCRISIS' },
        CHARGE: { name: 'CHARGE', value: 'CHARGE' },
        CITATION: { name: 'CITATION', value: 'CITATION' },
        CITATIONCHARGE: { name: 'CITATIONCHARGE', value: 'CITATIONCHARGE' },
        COURTCASE: { name: 'COURTCASE', value: 'COURTCASE' },
        CRASHDETAIL: { name: 'CRASHDETAIL', value: 'CRASHDETAIL' },
        EVENTDETAIL: { name: 'EVENTDETAIL', value: 'EVENTDETAIL' },
        E_FILE: { name: 'E_FILE', value: 'E_FILE' },
        FIELDCONTACT: { name: 'FIELDCONTACT', value: 'FIELDCONTACT' },
        IMPOUND: { name: 'IMPOUND', value: 'IMPOUND' },
        LEGACYENTITYDETAIL: { name: 'LEGACYENTITYDETAIL', value: 'LEGACYENTITYDETAIL' },
        LOCATIONENTITYLINK: { name: 'LOCATIONENTITYLINK', value: 'LOCATIONENTITYLINK' },
        MISSINGPERSON: { name: 'MISSINGPERSON', value: 'MISSINGPERSON' },
        NAMEATTRIBUTE: { name: 'NAMEATTRIBUTE', value: 'NAMEATTRIBUTE' },
        NAMENAMELINK: { name: 'NAMENAMELINK', value: 'NAMENAMELINK' },
        NAMEREPORTLINK: { name: 'NAMEREPORTLINK', value: 'NAMEREPORTLINK' },
        OFFENSE: { name: 'OFFENSE', value: 'OFFENSE' },
        OFFENSEATTRIBUTE: { name: 'OFFENSEATTRIBUTE', value: 'OFFENSEATTRIBUTE' },
        OFFENSEINVOLVEDCHILD: { name: 'OFFENSEINVOLVEDCHILD', value: 'OFFENSEINVOLVEDCHILD' },
        OFFENSESUBCRIMELINK: { name: 'OFFENSESUBCRIMELINK', value: 'OFFENSESUBCRIMELINK' },
        OTHERINVOLVEDAGENCY: { name: 'OTHERINVOLVEDAGENCY', value: 'OTHERINVOLVEDAGENCY' },
        PROPERTYSTATUS: { name: 'PROPERTYSTATUS', value: 'PROPERTYSTATUS' },
        REPORT: { name: 'REPORT', value: 'REPORT' },
        REPORTATTRIBUTE: { name: 'REPORTATTRIBUTE', value: 'REPORTATTRIBUTE' },
        REPORTNOTIFICATION: { name: 'REPORTNOTIFICATION', value: 'REPORTNOTIFICATION' },
        RIPASUBJECTOFFENSECODE: { name: 'RIPASUBJECTOFFENSECODE', value: 'RIPASUBJECTOFFENSECODE' },
        RMSTOWVEHICLE: { name: 'RMSTOWVEHICLE', value: 'RMSTOWVEHICLE' },
        STOP: { name: 'STOP', value: 'STOP' },
        STOPANONYMOUSSUBJECT: { name: 'STOPANONYMOUSSUBJECT', value: 'STOPANONYMOUSSUBJECT' },
        STOPENTITYATTRIBUTE: { name: 'STOPENTITYATTRIBUTE', value: 'STOPENTITYATTRIBUTE' },
        SUMMARYNARRATIVE: { name: 'SUMMARYNARRATIVE', value: 'SUMMARYNARRATIVE' },
        TOWVEHICLECHECKIN: { name: 'TOWVEHICLECHECKIN', value: 'TOWVEHICLECHECKIN' },
        TOWVEHICLERELEASE: { name: 'TOWVEHICLERELEASE', value: 'TOWVEHICLERELEASE' },
        TRAFFICCRASH: { name: 'TRAFFICCRASH', value: 'TRAFFICCRASH' },
        TRAFFICCRASHPERSON: { name: 'TRAFFICCRASHPERSON', value: 'TRAFFICCRASHPERSON' },
        TRAFFICCRASHUNIT: { name: 'TRAFFICCRASHUNIT', value: 'TRAFFICCRASHUNIT' },
        TRAFFICCRASHVEHICLE: { name: 'TRAFFICCRASHVEHICLE', value: 'TRAFFICCRASHVEHICLE' },
        USEOFFORCE: { name: 'USEOFFORCE', value: 'USEOFFORCE' },
        USEOFFORCESUBJECT: { name: 'USEOFFORCESUBJECT', value: 'USEOFFORCESUBJECT' },
        USEOFFORCESUBJECTDEESCALATION: {
            name: 'USEOFFORCESUBJECTDEESCALATION',
            value: 'USEOFFORCESUBJECTDEESCALATION',
        },
    },
    aR = {
        CREATE: { name: 'CREATE', value: 'CREATE' },
        DELETE: { name: 'DELETE', value: 'DELETE' },
        UPDATE: { name: 'UPDATE', value: 'UPDATE' },
    },
    OR = {
        ALREADY_DISPATCHED: {
            displayName: 'Already Dispatched',
            index: 0,
            name: 'ALREADY_DISPATCHED',
        },
        AVAILABLE: { displayName: 'Available', index: 3, name: 'AVAILABLE' },
        HELD: { displayName: 'Held', index: 2, name: 'HELD' },
        RECOMMENDED: { displayName: 'Recommended', index: 1, name: 'RECOMMENDED' },
        TO_DISPATCH: { displayName: 'To Dispatch', index: 2.5, name: 'TO_DISPATCH' },
        UNAVAILABLE: { displayName: 'Unavailable', index: 4, name: 'UNAVAILABLE' },
    },
    SR = {
        AGENCY_PROFILE: { name: 'AGENCY_PROFILE', value: 7 },
        AGENCY_TYPE: { name: 'AGENCY_TYPE', value: 5 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 4 },
        LAYER: { name: 'LAYER', value: 6 },
        MAP_UNIT_STATUS: { name: 'MAP_UNIT_STATUS', value: 2 },
        PRIMARY_SUBDIVISION: { name: 'PRIMARY_SUBDIVISION', value: 3 },
        PRIORITY: { name: 'PRIORITY', value: 1 },
    },
    CR = { UNIT: { name: 'UNIT' }, USER: { name: 'USER' } },
    nR = {
        _13019: { name: '_13019' },
        _13078: { name: '_13078' },
        _14050: { name: '_14050' },
        _16069: { name: '_16069' },
        _22100: { name: '_22100' },
        _22110: { name: '_22110' },
        _23220: { name: '_23220' },
    },
    DR = {
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        _001: { name: '_001', value: 245 },
        _015: { name: '_015', value: 1 },
        _016: { name: '_016', value: 2 },
        _017: { name: '_017', value: 3 },
        _050: { name: '_050', value: 4 },
        _051: { name: '_051', value: 5 },
        _052: { name: '_052', value: 6 },
        _055: { name: '_055', value: 7 },
        _056: { name: '_056', value: 8 },
        _058: { name: '_058', value: 9 },
        _059: { name: '_059', value: 10 },
        _060: { name: '_060', value: 11 },
        _065: { name: '_065', value: 12 },
        _070: { name: '_070', value: 13 },
        _071: { name: '_071', value: 14 },
        _072: { name: '_072', value: 15 },
        _073: { name: '_073', value: 16 },
        _074: { name: '_074', value: 17 },
        _075: { name: '_075', value: 18 },
        _076: { name: '_076', value: 19 },
        _077: { name: '_077', value: 20 },
        _078: { name: '_078', value: 21 },
        _080: { name: '_080', value: 22 },
        _081: { name: '_081', value: 23 },
        _084: { name: '_084', value: 24 },
        _085: { name: '_085', value: 25 },
        _088: { name: '_088', value: 26 },
        _090_StructureCheck: { name: '_090_StructureCheck', value: 246 },
        _090_ZeroReport: { name: '_090_ZeroReport', value: 250 },
        _091: { name: '_091', value: 27 },
        _092_StructureCheck: { name: '_092_StructureCheck', value: 247 },
        _092_ZeroReport: { name: '_092_ZeroReport', value: 251 },
        _093_StructureCheck: { name: '_093_StructureCheck', value: 248 },
        _093_ZeroReport: { name: '_093_ZeroReport', value: 252 },
        _094_StructureCheck: { name: '_094_StructureCheck', value: 249 },
        _094_ZeroReport: { name: '_094_ZeroReport', value: 253 },
        _101: { name: '_101', value: 28 },
        _101AZ: { name: '_101AZ', value: 345 },
        _102AZ: { name: '_102AZ', value: 346 },
        _103AZ: { name: '_103AZ', value: 347 },
        _104: { name: '_104', value: 29 },
        _104AZ: { name: '_104AZ', value: 348 },
        _105: { name: '_105', value: 30 },
        _105AZ: { name: '_105AZ', value: 349 },
        _115: { name: '_115', value: 31 },
        _116: { name: '_116', value: 32 },
        _117: { name: '_117', value: 33 },
        _118: { name: '_118', value: 34 },
        _119: { name: '_119', value: 35 },
        _122: { name: '_122', value: 36 },
        _151: { name: '_151', value: 37 },
        _152: { name: '_152', value: 38 },
        _153: { name: '_153', value: 39 },
        _155: { name: '_155', value: 40 },
        _156: { name: '_156', value: 41 },
        _170: { name: '_170', value: 42 },
        _171: { name: '_171', value: 43 },
        _172: { name: '_172', value: 44 },
        _173: { name: '_173', value: 45 },
        _175: { name: '_175', value: 46 },
        _178: { name: '_178', value: 47 },
        _201: { name: '_201', value: 48 },
        _202: { name: '_202', value: 49 },
        _202AZ: { name: '_202AZ', value: 351 },
        _203AZ: { name: '_203AZ', value: 352 },
        _204: { name: '_204', value: 50 },
        _205: { name: '_205', value: 51 },
        _206: { name: '_206', value: 52 },
        _207: { name: '_207', value: 53 },
        _215: { name: '_215', value: 54 },
        _216: { name: '_216', value: 55 },
        _217: { name: '_217', value: 56 },
        _219: { name: '_219', value: 57 },
        _220: { name: '_220', value: 58 },
        _221: { name: '_221', value: 59 },
        _251: { name: '_251', value: 60 },
        _252: { name: '_252', value: 61 },
        _253: { name: '_253', value: 62 },
        _254: { name: '_254', value: 63 },
        _255: { name: '_255', value: 64 },
        _256: { name: '_256', value: 65 },
        _257: { name: '_257', value: 66 },
        _258: { name: '_258', value: 67 },
        _262: { name: '_262', value: 68 },
        _263: { name: '_263', value: 69 },
        _264: { name: '_264', value: 70 },
        _265: { name: '_265', value: 71 },
        _266: { name: '_266', value: 72 },
        _267: { name: '_267', value: 73 },
        _268: { name: '_268', value: 74 },
        _269: { name: '_269', value: 75 },
        _270: { name: '_270', value: 76 },
        _2736_AZ: { name: '_2736_AZ', value: 478 },
        _284: { name: '_284', value: 77 },
        _301: { name: '_301', value: 78 },
        _302: { name: '_302', value: 79 },
        _304: { name: '_304', value: 80 },
        _305: { name: '_305', value: 81 },
        _306: { name: '_306', value: 82 },
        _315: { name: '_315', value: 83 },
        _316: { name: '_316', value: 84 },
        _317: { name: '_317', value: 85 },
        _320: { name: '_320', value: 86 },
        _342: { name: '_342', value: 87 },
        _343: { name: '_343', value: 88 },
        _351: { name: '_351', value: 89 },
        _352: { name: '_352', value: 90 },
        _353: { name: '_353', value: 91 },
        _354: { name: '_354', value: 92 },
        _355: { name: '_355', value: 93 },
        _356: { name: '_356', value: 94 },
        _357: { name: '_357', value: 95 },
        _358: { name: '_358', value: 96 },
        _359: { name: '_359', value: 97 },
        _360: { name: '_360', value: 98 },
        _361: { name: '_361', value: 99 },
        _362: { name: '_362', value: 100 },
        _363: { name: '_363', value: 101 },
        _364: { name: '_364', value: 102 },
        _365: { name: '_365', value: 103 },
        _366: { name: '_366', value: 104 },
        _367: { name: '_367', value: 105 },
        _368: { name: '_368', value: 106 },
        _372: { name: '_372', value: 107 },
        _375: { name: '_375', value: 108 },
        _376: { name: '_376', value: 109 },
        _382: { name: '_382', value: 110 },
        _383: { name: '_383', value: 111 },
        _384: { name: '_384', value: 112 },
        _387: { name: '_387', value: 113 },
        _388: { name: '_388', value: 114 },
        _389: { name: '_389', value: 115 },
        _390: { name: '_390', value: 116 },
        _391: { name: '_391', value: 117 },
        _392: { name: '_392', value: 118 },
        _401: { name: '_401', value: 119 },
        _402: { name: '_402', value: 120 },
        _404: { name: '_404', value: 121 },
        _406: { name: '_406', value: 122 },
        _407: { name: '_407', value: 123 },
        _408: { name: '_408', value: 124 },
        _409: { name: '_409', value: 125 },
        _410: { name: '_410', value: 126 },
        _415: { name: '_415', value: 127 },
        _416: { name: '_416', value: 128 },
        _417: { name: '_417', value: 129 },
        _419: { name: '_419', value: 130 },
        _422: { name: '_422', value: 131 },
        _449: { name: '_449', value: 132 },
        _450: { name: '_450', value: 133 },
        _451: { name: '_451', value: 134 },
        _452: { name: '_452', value: 312 },
        _453: { name: '_453', value: 135 },
        _454: { name: '_454', value: 136 },
        _455: { name: '_455', value: 137 },
        _456: { name: '_456', value: 138 },
        _457: { name: '_457', value: 139 },
        _458: { name: '_458', value: 140 },
        _459: { name: '_459', value: 141 },
        _460: { name: '_460', value: 142 },
        _461: { name: '_461', value: 143 },
        _462: { name: '_462', value: 144 },
        _463: { name: '_463', value: 145 },
        _464: { name: '_464', value: 146 },
        _465: { name: '_465', value: 147 },
        _466: { name: '_466', value: 148 },
        _467: { name: '_467', value: 149 },
        _468: { name: '_468', value: 150 },
        _469: { name: '_469', value: 151 },
        _470: { name: '_470', value: 152 },
        _471: { name: '_471', value: 153 },
        _472: { name: '_472', value: 154 },
        _474: { name: '_474', value: 155 },
        _475: { name: '_475', value: 156 },
        _476: { name: '_476', value: 157 },
        _477: { name: '_477', value: 158 },
        _478: { name: '_478', value: 159 },
        _479: { name: '_479', value: 160 },
        _480: { name: '_480', value: 161 },
        _481: { name: '_481', value: 162 },
        _482: { name: '_482', value: 163 },
        _483: { name: '_483', value: 164 },
        _484: { name: '_484', value: 165 },
        _501: { name: '_501', value: 166 },
        _502: { name: '_502', value: 167 },
        _504: { name: '_504', value: 168 },
        _508: { name: '_508', value: 169 },
        _509: { name: '_509', value: 170 },
        _510: { name: '_510', value: 171 },
        _515: { name: '_515', value: 172 },
        _516: { name: '_516', value: 173 },
        _517: { name: '_517', value: 174 },
        _522: { name: '_522', value: 175 },
        _549: { name: '_549', value: 176 },
        _550: { name: '_550', value: 177 },
        _551: { name: '_551', value: 178 },
        _552: { name: '_552', value: 179 },
        _554: { name: '_554', value: 181 },
        _555: { name: '_555', value: 182 },
        _556: { name: '_556', value: 183 },
        _557: { name: '_557', value: 184 },
        _558: { name: '_558', value: 185 },
        _559: { name: '_559', value: 186 },
        _560: { name: '_560', value: 187 },
        _572: { name: '_572', value: 188 },
        _584: { name: '_584', value: 189 },
        _601: { name: '_601', value: 190 },
        _602: { name: '_602', value: 191 },
        _602AZ: { name: '_602AZ', value: 354 },
        _603AZ: { name: '_603AZ', value: 355 },
        _604: { name: '_604', value: 192 },
        _605: { name: '_605', value: 193 },
        _606: { name: '_606', value: 194 },
        _607: { name: '_607', value: 195 },
        _608: { name: '_608', value: 196 },
        _609: { name: '_609', value: 197 },
        _610: { name: '_610', value: 198 },
        _615: { name: '_615', value: 199 },
        _616: { name: '_616', value: 200 },
        _617: { name: '_617', value: 201 },
        _618: { name: '_618', value: 202 },
        _622: { name: '_622', value: 203 },
        _623: { name: '_623', value: 204 },
        _640: { name: '_640', value: 205 },
        _641: { name: '_641', value: 206 },
        _652: { name: '_652', value: 207 },
        _653: { name: '_653', value: 208 },
        _654: { name: '_654', value: 209 },
        _655: { name: '_655', value: 210 },
        _656: { name: '_656', value: 211 },
        _661: { name: '_661', value: 212 },
        _664: { name: '_664', value: 213 },
        _665: { name: '_665', value: 214 },
        _667: { name: '_667', value: 215 },
        _669: { name: '_669', value: 216 },
        _670: { name: '_670', value: 217 },
        _701: { name: '_701', value: 218 },
        _701AZ: { name: '_701AZ', value: 356 },
        _702: { name: '_702', value: 219 },
        _702AZ: { name: '_702AZ', value: 357 },
        _704: { name: '_704', value: 220 },
        _705: { name: '_705', value: 221 },
        _706: { name: '_706', value: 222 },
        _707: { name: '_707', value: 223 },
        _708: { name: '_708', value: 224 },
        _709: { name: '_709', value: 225 },
        _710: { name: '_710', value: 226 },
        _715: { name: '_715', value: 227 },
        _716: { name: '_716', value: 228 },
        _717: { name: '_717', value: 229 },
        _718: { name: '_718', value: 230 },
        _720: { name: '_720', value: 231 },
        _722: { name: '_722', value: 232 },
        _740: { name: '_740', value: 233 },
        _741: { name: '_741', value: 234 },
        _751: { name: '_751', value: 235 },
        _752: { name: '_752', value: 236 },
        _753: { name: '_753', value: 237 },
        _754: { name: '_754', value: 238 },
        _755: { name: '_755', value: 239 },
        _757: { name: '_757', value: 240 },
        _758: { name: '_758', value: 241 },
        _759: { name: '_759', value: 242 },
        _760: { name: '_760', value: 243 },
        _761: { name: '_761', value: 244 },
        _801: { name: '_801', value: 257 },
        _819: { name: '_819', value: 258 },
        _824: { name: '_824', value: 259 },
        _833: { name: '_833', value: 260 },
        _835: { name: '_835', value: 315 },
        _842: { name: '_842', value: 261 },
        _843: { name: '_843', value: 262 },
        _848: { name: '_848', value: 316 },
        _914: { name: '_914', value: 263 },
        _915: { name: '_915', value: 264 },
        _916: { name: '_916', value: 265 },
        _928: { name: '_928', value: 266 },
        _929: { name: '_929', value: 267 },
        _936: { name: '_936', value: 268 },
        _940: { name: '_940', value: 317 },
        _942: { name: '_942', value: 269 },
        _952_VictimSegment: { name: '_952_VictimSegment', value: 313 },
        _CA204: { name: '_CA204', value: 372 },
        _CA265C: { name: '_CA265C', value: 358 },
        _CA404: { name: '_CA404', value: 359 },
        _CA820: { name: '_CA820', value: 270 },
        _CA821: { name: '_CA821', value: 303 },
        _CA829: { name: '_CA829', value: 271 },
        _CA839: { name: '_CA839', value: 272 },
        _CA842: { name: '_CA842', value: 273 },
        _CA843: { name: '_CA843', value: 274 },
        _CA844: { name: '_CA844', value: 304 },
        _CA845: { name: '_CA845', value: 275 },
        _CA846: { name: '_CA846', value: 276 },
        _CA847: { name: '_CA847', value: 277 },
        _CA925: { name: '_CA925', value: 278 },
        _CA932: { name: '_CA932', value: 279 },
        _CA934: { name: '_CA934', value: 280 },
        _CA935: { name: '_CA935', value: 281 },
        _CA937: { name: '_CA937', value: 282 },
        _CA938: { name: '_CA938', value: 283 },
        _CA939: { name: '_CA939', value: 284 },
        _CA942: { name: '_CA942', value: 285 },
        _CA943: { name: '_CA943', value: 286 },
        _CAA22: { name: '_CAA22', value: 295 },
        _CAA23: { name: '_CAA23', value: 296 },
        _CAA24: { name: '_CAA24', value: 297 },
        _CAA25: { name: '_CAA25', value: 298 },
        _CAA26: { name: '_CAA26', value: 299 },
        _CAA34: { name: '_CAA34', value: 300 },
        _CAA35: { name: '_CAA35', value: 301 },
        _CAA36: { name: '_CAA36', value: 458 },
        _CAA40: { name: '_CAA40', value: 302 },
        _CAB22: { name: '_CAB22', value: 287 },
        _CAB23: { name: '_CAB23', value: 288 },
        _CAB24: { name: '_CAB24', value: 289 },
        _CAB25: { name: '_CAB25', value: 290 },
        _CAB26: { name: '_CAB26', value: 291 },
        _CAB34: { name: '_CAB34', value: 292 },
        _CAB35: { name: '_CAB35', value: 293 },
        _CAB36: { name: '_CAB36', value: 457 },
        _CAB40: { name: '_CAB40', value: 294 },
        _DV1: { name: '_DV1', value: 254 },
        _DV2: { name: '_DV2', value: 255 },
        _DV3: { name: '_DV3', value: 256 },
        _EXPORT: { name: '_EXPORT', value: 319 },
        _FT205: { name: '_FT205', value: 490 },
        _FT219: { name: '_FT219', value: 495 },
        _FT220: { name: '_FT220', value: 496 },
        _FT221: { name: '_FT221', value: 493 },
        _FT256: { name: '_FT256', value: 494 },
        _FT559: { name: '_FT559', value: 491 },
        _G801: { name: '_G801', value: 320 },
        _G802: { name: '_G802', value: 321 },
        _G803: { name: '_G803', value: 322 },
        _G804: { name: '_G804', value: 323 },
        _G805: { name: '_G805', value: 324 },
        _G806: { name: '_G806', value: 325 },
        _G807: { name: '_G807', value: 326 },
        _G808: { name: '_G808', value: 327 },
        _G809: { name: '_G809', value: 328 },
        _G810: { name: '_G810', value: 329 },
        _G811: { name: '_G811', value: 330 },
        _G812: { name: '_G812', value: 331 },
        _G813: { name: '_G813', value: 332 },
        _G814: { name: '_G814', value: 333 },
        _G815: { name: '_G815', value: 334 },
        _G816: { name: '_G816', value: 335 },
        _G817: { name: '_G817', value: 336 },
        _G818: { name: '_G818', value: 337 },
        _G819: { name: '_G819', value: 338 },
        _G820: { name: '_G820', value: 339 },
        _G821: { name: '_G821', value: 340 },
        _G822: { name: '_G822', value: 341 },
        _G823: { name: '_G823', value: 342 },
        _G824: { name: '_G824', value: 343 },
        _G825: { name: '_G825', value: 344 },
        _IL805: { name: '_IL805', value: 482 },
        _NJ801: { name: '_NJ801', value: 360 },
        _NJ802: { name: '_NJ802', value: 365 },
        _NJ804: { name: '_NJ804', value: 361 },
        _NJ824: { name: '_NJ824', value: 362 },
        _NJ826: { name: '_NJ826', value: 366 },
        _NJ827: { name: '_NJ827', value: 367 },
        _NJ828: { name: '_NJ828', value: 368 },
        _NJ829: { name: '_NJ829', value: 369 },
        _NJ830: { name: '_NJ830', value: 370 },
        _NJ831: { name: '_NJ831', value: 371 },
        _NJ832: { name: '_NJ832', value: 374 },
        _NJ836: { name: '_NJ836', value: 363 },
        _NJ842: { name: '_NJ842', value: 492 },
        _NY1000: { name: '_NY1000', value: 574 },
        _NY1002: { name: '_NY1002', value: 575 },
        _NY1004: { name: '_NY1004', value: 576 },
        _NY1006: { name: '_NY1006', value: 577 },
        _NY1008: { name: '_NY1008', value: 578 },
        _NY1010: { name: '_NY1010', value: 579 },
        _NY1012: { name: '_NY1012', value: 580 },
        _NY1014: { name: '_NY1014', value: 581 },
        _NY1016: { name: '_NY1016', value: 582 },
        _NY1018: { name: '_NY1018', value: 583 },
        _NY1020: { name: '_NY1020', value: 584 },
        _NY1022: { name: '_NY1022', value: 585 },
        _NY1024: { name: '_NY1024', value: 586 },
        _NY1028: { name: '_NY1028', value: 527 },
        _NY154: { name: '_NY154', value: 376 },
        _NY156: { name: '_NY156', value: 377 },
        _NY158: { name: '_NY158', value: 378 },
        _NY160: { name: '_NY160', value: 379 },
        _NY164: { name: '_NY164', value: 380 },
        _NY166: { name: '_NY166', value: 381 },
        _NY168: { name: '_NY168', value: 382 },
        _NY170: { name: '_NY170', value: 393 },
        _NY172: { name: '_NY172', value: 394 },
        _NY174: { name: '_NY174', value: 395 },
        _NY176: { name: '_NY176', value: 375 },
        _NY186: { name: '_NY186', value: 588 },
        _NY195: { name: '_NY195', value: 396 },
        _NY196: { name: '_NY196', value: 397 },
        _NY207: { name: '_NY207', value: 401 },
        _NY214: { name: '_NY214', value: 400 },
        _NY237: { name: '_NY237', value: 429 },
        _NY239: { name: '_NY239', value: 430 },
        _NY241: { name: '_NY241', value: 431 },
        _NY243: { name: '_NY243', value: 432 },
        _NY256: { name: '_NY256', value: 520 },
        _NY265: { name: '_NY265', value: 465 },
        _NY428: { name: '_NY428', value: 433 },
        _NY436: { name: '_NY436', value: 441 },
        _NY459: { name: '_NY459', value: 455 },
        _NY462: { name: '_NY462', value: 638 },
        _NY465: { name: '_NY465', value: 544 },
        _NY471: { name: '_NY471', value: 440 },
        _NY478: { name: '_NY478', value: 443 },
        _NY490: { name: '_NY490', value: 444 },
        _NY496: { name: '_NY496', value: 445 },
        _NY498: { name: '_NY498', value: 446 },
        _NY501: { name: '_NY501', value: 447 },
        _NY503: { name: '_NY503', value: 448 },
        _NY510: { name: '_NY510', value: 453 },
        _NY530: { name: '_NY530', value: 450 },
        _NY550: { name: '_NY550', value: 404 },
        _NY552: { name: '_NY552', value: 405 },
        _NY562: { name: '_NY562', value: 589 },
        _NY566: { name: '_NY566', value: 442 },
        _NY650: { name: '_NY650', value: 383 },
        _NY652: { name: '_NY652', value: 384 },
        _NY653: { name: '_NY653', value: 385 },
        _NY676: { name: '_NY676', value: 406 },
        _NY678: { name: '_NY678', value: 407 },
        _NY680: { name: '_NY680', value: 434 },
        _NY682: { name: '_NY682', value: 523 },
        _NY683: { name: '_NY683', value: 392 },
        _NY684: { name: '_NY684', value: 435 },
        _NY685: { name: '_NY685', value: 524 },
        _NY693: { name: '_NY693', value: 538 },
        _NY701: { name: '_NY701', value: 408 },
        _NY703: { name: '_NY703', value: 409 },
        _NY705: { name: '_NY705', value: 410 },
        _NY707: { name: '_NY707', value: 411 },
        _NY709: { name: '_NY709', value: 412 },
        _NY710: { name: '_NY710', value: 413 },
        _NY711: { name: '_NY711', value: 414 },
        _NY713: { name: '_NY713', value: 415 },
        _NY714: { name: '_NY714', value: 416 },
        _NY715: { name: '_NY715', value: 417 },
        _NY716: { name: '_NY716', value: 418 },
        _NY717: { name: '_NY717', value: 419 },
        _NY718: { name: '_NY718', value: 420 },
        _NY719: { name: '_NY719', value: 421 },
        _NY720: { name: '_NY720', value: 422 },
        _NY721: { name: '_NY721', value: 423 },
        _NY722: { name: '_NY722', value: 424 },
        _NY723: { name: '_NY723', value: 425 },
        _NY727: { name: '_NY727', value: 426 },
        _NY728: { name: '_NY728', value: 539 },
        _NY729: { name: '_NY729', value: 427 },
        _NY730: { name: '_NY730', value: 428 },
        _NY732: { name: '_NY732', value: 451 },
        _NY733: { name: '_NY733', value: 528 },
        _NY734: { name: '_NY734', value: 529 },
        _NY735: { name: '_NY735', value: 530 },
        _NY736: { name: '_NY736', value: 531 },
        _NY737: { name: '_NY737', value: 532 },
        _NY744: { name: '_NY744', value: 386 },
        _NY745: { name: '_NY745', value: 387 },
        _NY746: { name: '_NY746', value: 388 },
        _NY747: { name: '_NY747', value: 389 },
        _NY750: { name: '_NY750', value: 402 },
        _NY752: { name: '_NY752', value: 403 },
        _NY756: { name: '_NY756', value: 436 },
        _NY758: { name: '_NY758', value: 437 },
        _NY762: { name: '_NY762', value: 438 },
        _NY766: { name: '_NY766', value: 439 },
        _NY768: { name: '_NY768', value: 540 },
        _NY776: { name: '_NY776', value: 533 },
        _NY778: { name: '_NY778', value: 534 },
        _NY780: { name: '_NY780', value: 535 },
        _NY781: { name: '_NY781', value: 536 },
        _NY782: { name: '_NY782', value: 537 },
        _NY784: { name: '_NY784', value: 452 },
        _NY785: { name: '_NY785', value: 456 },
        _NY788: { name: '_NY788', value: 449 },
        _NY789: { name: '_NY789', value: 541 },
        _NY790: { name: '_NY790', value: 390 },
        _NY792: { name: '_NY792', value: 391 },
        _NY855: { name: '_NY855', value: 526 },
        _NY857: { name: '_NY857', value: 542 },
        _NY859: { name: '_NY859', value: 543 },
        _NY884: { name: '_NY884', value: 497 },
        _NY886: { name: '_NY886', value: 498 },
        _NY890: { name: '_NY890', value: 499 },
        _NY892: { name: '_NY892', value: 500 },
        _NY894: { name: '_NY894', value: 501 },
        _NY896: { name: '_NY896', value: 502 },
        _NY898: { name: '_NY898', value: 503 },
        _NY900: { name: '_NY900', value: 504 },
        _NY902: { name: '_NY902', value: 505 },
        _NY906: { name: '_NY906', value: 506 },
        _NY908: { name: '_NY908', value: 507 },
        _NY909: { name: '_NY909', value: 508 },
        _NY912: { name: '_NY912', value: 509 },
        _NY913: { name: '_NY913', value: 521 },
        _NY915: { name: '_NY915', value: 510 },
        _NY916: { name: '_NY916', value: 522 },
        _NY924: { name: '_NY924', value: 511 },
        _NY926: { name: '_NY926', value: 512 },
        _NY928: { name: '_NY928', value: 513 },
        _NY930: { name: '_NY930', value: 514 },
        _NY932: { name: '_NY932', value: 515 },
        _NY934: { name: '_NY934', value: 516 },
        _NY936: { name: '_NY936', value: 517 },
        _NY938: { name: '_NY938', value: 518 },
        _NY939: { name: '_NY939', value: 519 },
        _NY942: { name: '_NY942', value: 545 },
        _NY944: { name: '_NY944', value: 546 },
        _NY946: { name: '_NY946', value: 547 },
        _NY948: { name: '_NY948', value: 548 },
        _NY950: { name: '_NY950', value: 549 },
        _NY952: { name: '_NY952', value: 550 },
        _NY954: { name: '_NY954', value: 551 },
        _NY956: { name: '_NY956', value: 552 },
        _NY958: { name: '_NY958', value: 553 },
        _NY960: { name: '_NY960', value: 554 },
        _NY962: { name: '_NY962', value: 555 },
        _NY964: { name: '_NY964', value: 556 },
        _NY966: { name: '_NY966', value: 557 },
        _NY968: { name: '_NY968', value: 558 },
        _NY970: { name: '_NY970', value: 559 },
        _NY972: { name: '_NY972', value: 560 },
        _NY974: { name: '_NY974', value: 561 },
        _NY976: { name: '_NY976', value: 562 },
        _NY978: { name: '_NY978', value: 563 },
        _NY980: { name: '_NY980', value: 564 },
        _NY982: { name: '_NY982', value: 565 },
        _NY984: { name: '_NY984', value: 566 },
        _NY986: { name: '_NY986', value: 567 },
        _NY988: { name: '_NY988', value: 568 },
        _NY990: { name: '_NY990', value: 569 },
        _NY992: { name: '_NY992', value: 570 },
        _NY994: { name: '_NY994', value: 571 },
        _NY996: { name: '_NY996', value: 572 },
        _NY998: { name: '_NY998', value: 573 },
        _NY_WARNING_1: { name: '_NY_WARNING_1', value: 464 },
        _OH2151_022: { name: '_OH2151_022', value: 460 },
        _OH265: { name: '_OH265', value: 467 },
        _OH2903_00J: { name: '_OH2903_00J', value: 459 },
        _OH2903_01: { name: '_OH2903_01', value: 461 },
        _OH2905_05: { name: '_OH2905_05', value: 466 },
        _OH2907_02: { name: '_OH2907_02', value: 590 },
        _OH2907_02_A: { name: '_OH2907_02_A', value: 591 },
        _OH2907_02_B: { name: '_OH2907_02_B', value: 592 },
        _OH2907_03: { name: '_OH2907_03', value: 471 },
        _OH2907_03_A: { name: '_OH2907_03_A', value: 472 },
        _OH2907_03_B: { name: '_OH2907_03_B', value: 473 },
        _OH2907_03_C: { name: '_OH2907_03_C', value: 474 },
        _OH2907_03_D: { name: '_OH2907_03_D', value: 609 },
        _OH2907_03_E: { name: '_OH2907_03_E', value: 610 },
        _OH2907_03_F: { name: '_OH2907_03_F', value: 611 },
        _OH2907_04: { name: '_OH2907_04', value: 469 },
        _OH2913_02_A: { name: '_OH2913_02_A', value: 479 },
        _OH2913_02_B: { name: '_OH2913_02_B', value: 480 },
        _OH2913_30: { name: '_OH2913_30', value: 639 },
        _OH2913_30_A: { name: '_OH2913_30_A', value: 640 },
        _OH2913_30_B: { name: '_OH2913_30_B', value: 641 },
        _OH2913_31: { name: '_OH2913_31', value: 642 },
        _OH2913_31_A: { name: '_OH2913_31_A', value: 643 },
        _OH2913_31_B: { name: '_OH2913_31_B', value: 644 },
        _OH2913_32: { name: '_OH2913_32', value: 645 },
        _OH2913_32_A: { name: '_OH2913_32_A', value: 646 },
        _OH2913_32_B: { name: '_OH2913_32_B', value: 647 },
        _OH2913_33: { name: '_OH2913_33', value: 648 },
        _OH2913_33_A: { name: '_OH2913_33_A', value: 649 },
        _OH2913_33_B: { name: '_OH2913_33_B', value: 650 },
        _OH2915_02: { name: '_OH2915_02', value: 651 },
        _OH2915_02_A: { name: '_OH2915_02_A', value: 652 },
        _OH2915_02_B: { name: '_OH2915_02_B', value: 653 },
        _OH2915_09: { name: '_OH2915_09', value: 654 },
        _OH2915_09_A: { name: '_OH2915_09_A', value: 655 },
        _OH2915_09_B: { name: '_OH2915_09_B', value: 656 },
        _OH2919_13: { name: '_OH2919_13', value: 468 },
        _OH2919_22: { name: '_OH2919_22', value: 617 },
        _OH2919_22_A: { name: '_OH2919_22_A', value: 618 },
        _OH2919_22_B: { name: '_OH2919_22_B', value: 619 },
        _OH2919_22_C: { name: '_OH2919_22_C', value: 620 },
        _OH2919_25: { name: '_OH2919_25', value: 621 },
        _OH2919_25_A: { name: '_OH2919_25_A', value: 622 },
        _OH2919_25_B: { name: '_OH2919_25_B', value: 623 },
        _OH2919_25_C: { name: '_OH2919_25_C', value: 624 },
        _OH2921_05: { name: '_OH2921_05', value: 612 },
        _OH2921_05_A: { name: '_OH2921_05_A', value: 613 },
        _OH2921_05_B: { name: '_OH2921_05_B', value: 614 },
        _OH2921_05_C: { name: '_OH2921_05_C', value: 615 },
        _OH2921_05_D: { name: '_OH2921_05_D', value: 616 },
        _OH2921_33: { name: '_OH2921_33', value: 625 },
        _OH2921_33B: { name: '_OH2921_33B', value: 593 },
        _OH2921_33B_A: { name: '_OH2921_33B_A', value: 594 },
        _OH2921_33B_B: { name: '_OH2921_33B_B', value: 595 },
        _OH2921_33B_C: { name: '_OH2921_33B_C', value: 596 },
        _OH2921_33B_D: { name: '_OH2921_33B_D', value: 597 },
        _OH2921_33B_E: { name: '_OH2921_33B_E', value: 598 },
        _OH2921_33_A: { name: '_OH2921_33_A', value: 626 },
        _OH2921_33_C: { name: '_OH2921_33_C', value: 627 },
        _OH2921_33_D: { name: '_OH2921_33_D', value: 628 },
        _OH2921_33_E: { name: '_OH2921_33_E', value: 629 },
        _OH2921_36A2: { name: '_OH2921_36A2', value: 657 },
        _OH2921_36A2_A: { name: '_OH2921_36A2_A', value: 658 },
        _OH2921_36A2_B: { name: '_OH2921_36A2_B', value: 659 },
        _OH2921_36A2_C: { name: '_OH2921_36A2_C', value: 660 },
        _OH2921_36A2_D: { name: '_OH2921_36A2_D', value: 661 },
        _OH2921_36A2_E: { name: '_OH2921_36A2_E', value: 662 },
        _OH2921_38: { name: '_OH2921_38', value: 634 },
        _OH2921_38C: { name: '_OH2921_38C', value: 630 },
        _OH2921_38C_A: { name: '_OH2921_38C_A', value: 631 },
        _OH2921_38C_B: { name: '_OH2921_38C_B', value: 632 },
        _OH2921_38C_C: { name: '_OH2921_38C_C', value: 633 },
        _OH2921_38_A: { name: '_OH2921_38_A', value: 635 },
        _OH2921_38_B: { name: '_OH2921_38_B', value: 636 },
        _OH2921_38_C: { name: '_OH2921_38_C', value: 637 },
        _OH2923_211: { name: '_OH2923_211', value: 462 },
        _OH4303_15: { name: '_OH4303_15', value: 470 },
        _PA913: { name: '_PA913', value: 305 },
        _T208: { name: '_T208', value: 306 },
        _T221: { name: '_T221', value: 307 },
        _T285: { name: '_T285', value: 309 },
        _T451: { name: '_T451', value: 483 },
        _T473: { name: '_T473', value: 310 },
        _T484: { name: '_T484', value: 308 },
        _T486: { name: '_T486', value: 311 },
        _T551: { name: '_T551', value: 484 },
        _T585: { name: '_T585', value: 314 },
        _T945: { name: '_T945', value: 485 },
        _T951: { name: '_T951', value: 486 },
        _T981: { name: '_T981', value: 487 },
        _T982: { name: '_T982', value: 488 },
        _T983: { name: '_T983', value: 489 },
        _VALIDATOR: { name: '_VALIDATOR', value: 318 },
    },
    LR = { DELETE: { name: 'DELETE' }, EXPUNGE: { name: 'EXPUNGE' } },
    mR = { CREATION: { name: 'CREATION', value: 2 }, MATCH: { name: 'MATCH', value: 1 } },
    lR = {
        CREATE_PERSON_ON_ONE_MATCH: { name: 'CREATE_PERSON_ON_ONE_MATCH', value: 2 },
        CREATE_PERSON_ON_ZERO_MATCHES: { name: 'CREATE_PERSON_ON_ZERO_MATCHES', value: 1 },
        CREATE_VEHICLE_ON_ONE_MATCH: { name: 'CREATE_VEHICLE_ON_ONE_MATCH', value: 4 },
        CREATE_VEHICLE_ON_ZERO_MATCHES: { name: 'CREATE_VEHICLE_ON_ZERO_MATCHES', value: 3 },
    },
    uR = {
        PERSON_ADDRESS: { entityType: 'PERSON_PROFILE', name: 'PERSON_ADDRESS', value: 5 },
        PERSON_DATE_OF_BIRTH: {
            entityType: 'PERSON_PROFILE',
            name: 'PERSON_DATE_OF_BIRTH',
            value: 6,
        },
        PERSON_DRIVERS_LICENSE_NUMBER: {
            entityType: 'PERSON_PROFILE',
            name: 'PERSON_DRIVERS_LICENSE_NUMBER',
            value: 7,
        },
        PERSON_EYE_COLOR: { entityType: 'PERSON_PROFILE', name: 'PERSON_EYE_COLOR', value: 11 },
        PERSON_FIRST_NAME: { entityType: 'PERSON_PROFILE', name: 'PERSON_FIRST_NAME', value: 1 },
        PERSON_HAIR_COLOR: { entityType: 'PERSON_PROFILE', name: 'PERSON_HAIR_COLOR', value: 12 },
        PERSON_HEIGHT: { entityType: 'PERSON_PROFILE', name: 'PERSON_HEIGHT', value: 10 },
        PERSON_LAST_NAME: { entityType: 'PERSON_PROFILE', name: 'PERSON_LAST_NAME', value: 2 },
        PERSON_MIDDLE_NAME: { entityType: 'PERSON_PROFILE', name: 'PERSON_MIDDLE_NAME', value: 4 },
        PERSON_RACE: { entityType: 'PERSON_PROFILE', name: 'PERSON_RACE', value: 8 },
        PERSON_SEX: { entityType: 'PERSON_PROFILE', name: 'PERSON_SEX', value: 9 },
        PERSON_SOCIAL_SECURITY_NUMBER: {
            entityType: 'PERSON_PROFILE',
            name: 'PERSON_SOCIAL_SECURITY_NUMBER',
            value: 3,
        },
        VEHICLE_COLOR: { entityType: 'VEHICLE', name: 'VEHICLE_COLOR', value: 16 },
        VEHICLE_MAKE: { entityType: 'VEHICLE', name: 'VEHICLE_MAKE', value: 17 },
        VEHICLE_MODEL: { entityType: 'VEHICLE', name: 'VEHICLE_MODEL', value: 18 },
        VEHICLE_PLATE_NUMBER: { entityType: 'VEHICLE', name: 'VEHICLE_PLATE_NUMBER', value: 13 },
        VEHICLE_STATE: { entityType: 'VEHICLE', name: 'VEHICLE_STATE', value: 14 },
        VEHICLE_VIN: { entityType: 'VEHICLE', name: 'VEHICLE_VIN', value: 15 },
        VEHICLE_YEAR: { entityType: 'VEHICLE', name: 'VEHICLE_YEAR', value: 19 },
    },
    PR = {
        FULL: { name: 'FULL' },
        REMOVE_DIRECTIONALS: { name: 'REMOVE_DIRECTIONALS' },
        STREET_ONLY: { name: 'STREET_ONLY' },
    },
    UR = {
        CROSS1_DIRECT: { name: 'CROSS1_DIRECT' },
        CROSS1_REVERSE: { name: 'CROSS1_REVERSE' },
        CROSS2_DIRECT: { name: 'CROSS2_DIRECT' },
        CROSS2_REVERSE: { name: 'CROSS2_REVERSE' },
        NUMERIC: { name: 'NUMERIC' },
        RANGE: { name: 'RANGE' },
    },
    MR = {
        IMPERIAL: { name: 'IMPERIAL', value: 1 },
        METRIC: { name: 'METRIC', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    vR = {
        FEET: { name: 'FEET', value: 9002 },
        KILOMETERS: { name: 'KILOMETERS', value: 9036 },
        METERS: { name: 'METERS', value: 9001 },
        MILES: { name: 'MILES', value: 9093 },
        YARDS: { name: 'YARDS', value: 9096 },
    },
    FR = {
        CATEGORY: { name: 'CATEGORY', value: 9 },
        DATE: { name: 'DATE', value: 2 },
        GUIDE: { name: 'GUIDE', value: 8 },
        LOCATION: { name: 'LOCATION', value: 5 },
        OFFICER: { name: 'OFFICER', value: 1 },
        ORGANIZATION: { name: 'ORGANIZATION', value: 4 },
        PERSON: { name: 'PERSON', value: 3 },
        PROPERTY: { name: 'PROPERTY', value: 7 },
        VEHICLE: { name: 'VEHICLE', value: 6 },
    },
    GR = { INCOMING: { name: 'INCOMING' }, OUTGOING: { name: 'OUTGOING' } },
    HR = { HIGH: { name: 'HIGH' }, LOW: { name: 'LOW' } },
    YR = {
        CLEARED: { name: 'CLEARED', value: 4 },
        PENDING_ASSIGNMENT: { name: 'PENDING_ASSIGNMENT', value: 6 },
        READ: { name: 'READ', value: 3 },
        SENT: { name: 'SENT', value: 1 },
        SYSTEM_ARCHIVED: { name: 'SYSTEM_ARCHIVED', value: 5 },
        UNREAD: { name: 'UNREAD', value: 2 },
    },
    tR = {
        ABILITY_ROLE_LINK: { name: 'ABILITY_ROLE_LINK', value: 'security.ability_role_link' },
        AGENCY_EVENT_SEARCH_SYNC: {
            name: 'AGENCY_EVENT_SEARCH_SYNC',
            value: 'agency_event.search.sync',
        },
        AGENCY_EVENT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'AGENCY_EVENT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'agency_event.search.sync.low_priority',
        },
        ARMADA: { name: 'ARMADA', value: 'armada.event.channel' },
        ARMADA_TIMERED_EVENT_PROCESSING: {
            name: 'ARMADA_TIMERED_EVENT_PROCESSING',
            value: 'armada.timered.event.processing',
        },
        BOLO_INSTANCE_SEARCH_SYNC: {
            name: 'BOLO_INSTANCE_SEARCH_SYNC',
            value: 'bolo_instance.search.sync',
        },
        BOLO_INSTANCE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'BOLO_INSTANCE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'bolo_instance.search.sync.low_priority',
        },
        BOLO_SEARCH_SYNC: { name: 'BOLO_SEARCH_SYNC', value: 'bolo.search.sync' },
        BOLO_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'BOLO_SEARCH_SYNC_LOW_PRIORITY',
            value: 'bolo.search.sync.low_priority',
        },
        CAD_ADDITIONAL_INFO_EVENT_LINK_CREATED: {
            name: 'CAD_ADDITIONAL_INFO_EVENT_LINK_CREATED',
            value: 'cad.additional.info.event.link.created',
        },
        CAD_ADDITIONAL_INFO_EVENT_LINK_DELETED: {
            name: 'CAD_ADDITIONAL_INFO_EVENT_LINK_DELETED',
            value: 'cad.additional.info.event.link.deleted',
        },
        CAD_AGENCY_EVENT_ACCESSED: {
            name: 'CAD_AGENCY_EVENT_ACCESSED',
            value: 'cad.agency_event.accessed',
        },
        CAD_AGENCY_EVENT_CLEARED: {
            name: 'CAD_AGENCY_EVENT_CLEARED',
            value: 'cad.agency_event.cleared',
        },
        CAD_AGENCY_EVENT_LINKED_ENTITY_CHANGED_REALTIME: {
            name: 'CAD_AGENCY_EVENT_LINKED_ENTITY_CHANGED_REALTIME',
            value: 'cad.agency_event_linked_entity_changed.realtime',
        },
        CAD_AGENCY_EVENT_LINK_UPDATE: {
            name: 'CAD_AGENCY_EVENT_LINK_UPDATE',
            value: 'cad.agency_event.link_update',
        },
        CAD_AGENCY_EVENT_REALTIME: {
            name: 'CAD_AGENCY_EVENT_REALTIME',
            value: 'cad.agency_event.realtime',
        },
        CAD_AGENCY_EVENT_UPDATE: {
            name: 'CAD_AGENCY_EVENT_UPDATE',
            value: 'cad.agency_event_update',
        },
        CAD_ALERT_SCHEDULE_REALTIME: {
            name: 'CAD_ALERT_SCHEDULE_REALTIME',
            value: 'cad.alert.schedule.realtime',
        },
        CAD_AML_PHONE_CALL: { name: 'CAD_AML_PHONE_CALL', value: 'cad.aml_phone_call' },
        CAD_AUTOMATIC_DISPATCH_ASSIGNMENT: {
            name: 'CAD_AUTOMATIC_DISPATCH_ASSIGNMENT',
            value: 'cad.automatic_dispatch_assignment',
        },
        CAD_AUTOMATIC_DISPATCH_EXPIRED: {
            name: 'CAD_AUTOMATIC_DISPATCH_EXPIRED',
            value: 'cad.automatic_dispatch_expired',
        },
        CAD_BUFFER_MINUTES_EXPIRED: {
            name: 'CAD_BUFFER_MINUTES_EXPIRED',
            value: 'cad.buffer_minutes_expired',
        },
        CAD_CONFIGURATION_REALTIME: {
            name: 'CAD_CONFIGURATION_REALTIME',
            value: 'cad.configuration.realtime',
        },
        CAD_DISPATCH_AREA_REALTIME: {
            name: 'CAD_DISPATCH_AREA_REALTIME',
            value: 'cad.dispatch_area.realtime',
        },
        CAD_NEXT_NOTIFIABLES_UPDATED: {
            name: 'CAD_NEXT_NOTIFIABLES_UPDATED',
            value: 'cad.next.notifiables_updated',
        },
        CAD_PHONE_CALL: { name: 'CAD_PHONE_CALL', value: 'cad.phone_call' },
        CAD_PROCESSED_GPS_DATA: { name: 'CAD_PROCESSED_GPS_DATA', value: 'cad.processed_gps_data' },
        CAD_REALTIME_CLIENT_ENTITY_CHANGED: {
            name: 'CAD_REALTIME_CLIENT_ENTITY_CHANGED',
            value: 'cad.realtime.client.entity.changed',
        },
        CAD_REALTIME_UPDATE_WRAPPER_REALTIME: {
            name: 'CAD_REALTIME_UPDATE_WRAPPER_REALTIME',
            value: 'cad.realtime.update.wrapper.realtime',
        },
        CAD_REQUEST_FOR_ASSISTANCE: {
            name: 'CAD_REQUEST_FOR_ASSISTANCE',
            value: 'cad.request_for_assistance',
        },
        CAD_ROUND_TRIP_REALTIME: {
            name: 'CAD_ROUND_TRIP_REALTIME',
            value: 'cad.round_trip.realtime',
        },
        CAD_ROUND_TRIP_WARSHIP: { name: 'CAD_ROUND_TRIP_WARSHIP', value: 'cad.round_trip.warship' },
        CAD_SCHEDULED_AGENCY_EVENT: {
            name: 'CAD_SCHEDULED_AGENCY_EVENT',
            value: 'cad.scheduled_agency_event',
        },
        CAD_SCHEDULED_EVENTS_REALTIME: {
            name: 'CAD_SCHEDULED_EVENTS_REALTIME',
            value: 'cad.schedule_events.realtime',
        },
        CAD_TICKET_CREATED: { name: 'CAD_TICKET_CREATED', value: 'cad.ticket.created' },
        CAD_TICKET_SEARCH_SYNC: { name: 'CAD_TICKET_SEARCH_SYNC', value: 'cad_ticket.search.sync' },
        CAD_TICKET_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'CAD_TICKET_SEARCH_SYNC_LOW_PRIORITY',
            value: 'cad_ticket.search.sync.low_priority',
        },
        CAD_UNIT_GPS_DATA: { name: 'CAD_UNIT_GPS_DATA', value: 'cad.unit_gps_data' },
        CAD_UNIT_LINK_UPDATE: { name: 'CAD_UNIT_LINK_UPDATE', value: 'cad.unit.link_update' },
        CAD_UNIT_PINGER_GPS_DATA: {
            name: 'CAD_UNIT_PINGER_GPS_DATA',
            value: 'cad.unit_pinger_gps_data',
        },
        CAD_UNIT_REALTIME: { name: 'CAD_UNIT_REALTIME', value: 'cad.unit.realtime' },
        CALENDAR_EVENT_SEARCH_SYNC: {
            name: 'CALENDAR_EVENT_SEARCH_SYNC',
            value: 'calendar_event.search.sync',
        },
        CALENDAR_EVENT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'CALENDAR_EVENT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'calendar_event.search.sync.low_priority',
        },
        CASE_SEARCH_SYNC: { name: 'CASE_SEARCH_SYNC', value: 'case.search.sync' },
        CASE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'CASE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'case.search.sync.low_priority',
        },
        CHAIN_OF_CUSTODY_SEARCH_SYNC: {
            name: 'CHAIN_OF_CUSTODY_SEARCH_SYNC',
            value: 'chain_of_custody.search.sync',
        },
        CHAIN_OF_CUSTODY_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'CHAIN_OF_CUSTODY_SEARCH_SYNC_LOW_PRIORITY',
            value: 'chain_of_custody,search.sync.low_priority',
        },
        COURT_ORDER_SEARCH_SYNC: {
            name: 'COURT_ORDER_SEARCH_SYNC',
            value: 'court_order.search.sync',
        },
        COURT_ORDER_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'COURT_ORDER_SEARCH_SYNC_LOW_PRIORITY',
            value: 'court_order.search.sync.low_priority',
        },
        DATA_EXCHANGE_INCOMING_MESSAGE: {
            name: 'DATA_EXCHANGE_INCOMING_MESSAGE',
            value: 'data_exchange.incoming_message',
        },
        DATA_EXCHANGE_INCOMING_MESSAGES: {
            name: 'DATA_EXCHANGE_INCOMING_MESSAGES',
            value: 'data_exchange.incoming_messages',
        },
        DATA_EXCHANGE_OUTGOING_MESSAGES: {
            name: 'DATA_EXCHANGE_OUTGOING_MESSAGES',
            value: 'data_exchange.outgoing_messages',
        },
        DEAD_LETTER: { name: 'DEAD_LETTER', value: 'dead.letter' },
        DEPARTMENT_RESET: { name: 'DEPARTMENT_RESET', value: 'department.reset' },
        EMAIL_STATUS: { name: 'EMAIL_STATUS', value: 'email.status' },
        ENTITY_CHANGED: { name: 'ENTITY_CHANGED', value: 'entity.changed' },
        ENTITY_PERMISSION_MODIFIED: {
            name: 'ENTITY_PERMISSION_MODIFIED',
            value: 'entity.permission_modified',
        },
        ENTITY_UPDATES: { name: 'ENTITY_UPDATES', value: 'entity.updates' },
        EVIDENCE_CHAIN_OF_CUSTODY_UPDATE: {
            name: 'EVIDENCE_CHAIN_OF_CUSTODY_UPDATE',
            value: 'evidence.chain_of_custody.updated',
        },
        EVIDENCE_DISPOSITION_UPDATE: {
            name: 'EVIDENCE_DISPOSITION_UPDATE',
            value: 'evidence.disposition.updated',
        },
        EVIDENCE_IMPORT_REQUEST: {
            name: 'EVIDENCE_IMPORT_REQUEST',
            value: 'evidence.import.request',
        },
        E_FILE_SEARCH_SYNC: { name: 'E_FILE_SEARCH_SYNC', value: 'efile.search.sync' },
        E_FILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'E_FILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'efile.search.sync.low_priority',
        },
        FACILITY_SEARCH_SYNC: { name: 'FACILITY_SEARCH_SYNC', value: 'facility.search.sync' },
        FACILITY_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'FACILITY_SEARCH_SYNC_LOW_PRIORITY',
            value: 'facility.search.sync.low_priority',
        },
        FILE_CREATED: { name: 'FILE_CREATED', value: 'file.created' },
        FOUNDATION_MODELS_LLM_PROMPT: {
            name: 'FOUNDATION_MODELS_LLM_PROMPT',
            value: 'foundation_models.llm_prompt',
        },
        GEOFENCE_SEARCH_SYNC: { name: 'GEOFENCE_SEARCH_SYNC', value: 'geofence.search.sync' },
        GEOFENCE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'GEOFENCE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'geofence.search.sync.low_priority',
        },
        GEO_ADDRESS_POINT_SEARCH_SYNC: {
            name: 'GEO_ADDRESS_POINT_SEARCH_SYNC',
            value: 'geo_address_point.search.sync',
        },
        GEO_ADDRESS_POINT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'GEO_ADDRESS_POINT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'geo_address_point.search.sync.low_priority',
        },
        GEO_ALIAS_BACKFILL: { name: 'GEO_ALIAS_BACKFILL', value: 'geo_alias_backfill' },
        GEO_ALIAS_SEARCH_SYNC: { name: 'GEO_ALIAS_SEARCH_SYNC', value: 'geo_alias.search.sync' },
        GEO_ALIAS_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'GEO_ALIAS_SEARCH_SYNC_LOW_PRIORITY',
            value: 'geo_alias.search.sync.low_priority',
        },
        GEO_CAUTION_BACKFILL: { name: 'GEO_CAUTION_BACKFILL', value: 'geo_caution_backfill' },
        GEO_CAUTION_SEARCH_SYNC: {
            name: 'GEO_CAUTION_SEARCH_SYNC',
            value: 'geo_caution.search.sync',
        },
        GEO_CAUTION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'GEO_CAUTION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'geo_caution.search.sync.low_priority',
        },
        GPS_DATA_DELETION: { name: 'GPS_DATA_DELETION', value: 'gps.data_deletion' },
        IMAGE_RESIZE: { name: 'IMAGE_RESIZE', value: 'image.resize' },
        ITEM_PROFILE_SEARCH_SYNC: {
            name: 'ITEM_PROFILE_SEARCH_SYNC',
            value: 'item_profile.search.sync',
        },
        ITEM_PROFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'ITEM_PROFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'item_profile.search.sync.low_priority',
        },
        ITEM_STORAGE_LOCATION_SEARCH_SYNC: {
            name: 'ITEM_STORAGE_LOCATION_SEARCH_SYNC',
            value: 'item_storage_location.search.sync',
        },
        ITEM_STORAGE_LOCATION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'ITEM_STORAGE_LOCATION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'item_storage_location.search.sync.low_priority',
        },
        JMS_BOOKING_VIEWED: { name: 'JMS_BOOKING_VIEWED', value: 'jms.booking.viewed' },
        JMS_PNC_DATA_CHANGED: { name: 'JMS_PNC_DATA_CHANGED', value: 'jms.pnc.data.changed' },
        LOCATION_ALIAS_SEARCH_SYNC: {
            name: 'LOCATION_ALIAS_SEARCH_SYNC',
            value: 'location_alias.search.sync',
        },
        LOCATION_ALIAS_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'LOCATION_ALIAS_SEARCH_SYNC_LOW_PRIORITY',
            value: 'location_alias.search.sync.low_priority',
        },
        LOCATION_CAUTION_SEARCH_SYNC: {
            name: 'LOCATION_CAUTION_SEARCH_SYNC',
            value: 'location_caution.search.sync',
        },
        LOCATION_CAUTION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'LOCATION_CAUTION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'location_caution.search.sync.low_priority',
        },
        LOCATION_ENTITY_LINK_CROSS_STREETS_BACKFILL: {
            name: 'LOCATION_ENTITY_LINK_CROSS_STREETS_BACKFILL',
            value: 'location_entity_link.cross_streets.backfill',
        },
        LOCATION_SEARCH_SYNC: { name: 'LOCATION_SEARCH_SYNC', value: 'location.search.sync' },
        LOCATION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'LOCATION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'location.search.sync.low_priority',
        },
        MARK43_FILE_SEARCH_SYNC: {
            name: 'MARK43_FILE_SEARCH_SYNC',
            value: 'mark43_file.search.sync',
        },
        MARK43_FILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'MARK43_FILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'mark43_file.search.sync.low_priority',
        },
        MATERIALIZED_USER_ACTION_SEARCH_SYNC: {
            name: 'MATERIALIZED_USER_ACTION_SEARCH_SYNC',
            value: 'materialized_user_action.search.sync',
        },
        MATERIALIZED_USER_ACTION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'MATERIALIZED_USER_ACTION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'materialized_user_action.search.sync.low_priority',
        },
        NAME_PHONE_NUMBER_CLEANUP: {
            name: 'NAME_PHONE_NUMBER_CLEANUP',
            value: 'name_phone_number_cleanup',
        },
        NOTIFICATIONS: { name: 'NOTIFICATIONS', value: 'notifications' },
        NOTIFICATIONS_BULK_SETTINGS_UPDATE: {
            name: 'NOTIFICATIONS_BULK_SETTINGS_UPDATE',
            value: 'notifications.bulk.update',
        },
        NOTIFICATIONS_SEND_NOTIFICATION: {
            name: 'NOTIFICATIONS_SEND_NOTIFICATION',
            value: 'notifications.send.notification',
        },
        NOTIFICATIONS_SEND_SECURITY_ALERT: {
            name: 'NOTIFICATIONS_SEND_SECURITY_ALERT',
            value: 'notifications.send.security_alert',
        },
        OFFENSE_CODE_SEARCH_SYNC: {
            name: 'OFFENSE_CODE_SEARCH_SYNC',
            value: 'offense_code.search.sync',
        },
        OFFENSE_CODE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'OFFENSE_CODE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'offense_code.search.sync.low_priority',
        },
        ORGANIZATION_PROFILE_SEARCH_SYNC: {
            name: 'ORGANIZATION_PROFILE_SEARCH_SYNC',
            value: 'organization_profile.search.sync',
        },
        ORGANIZATION_PROFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'ORGANIZATION_PROFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'organization_profile.search.sync.low_priority',
        },
        PARTNERSHIPS_CREATE_API_PHONE_CALL: {
            name: 'PARTNERSHIPS_CREATE_API_PHONE_CALL',
            value: 'partnerships.create_api_phone_call',
        },
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 'security.password_reset' },
        PDF_RESIZE: { name: 'PDF_RESIZE', value: 'pdf.resize' },
        PERSON_PROFILE_SEARCH_SYNC: {
            name: 'PERSON_PROFILE_SEARCH_SYNC',
            value: 'person_profile.search.sync',
        },
        PERSON_PROFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'PERSON_PROFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'person_profile.search.sync.low_priority',
        },
        POINT_LOCATION_SEARCH_SYNC: {
            name: 'POINT_LOCATION_SEARCH_SYNC',
            value: 'point_location.search.sync',
        },
        POINT_LOCATION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'POINT_LOCATION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'point_location.search.sync.low_priority',
        },
        REPORT_SEARCH_SYNC: { name: 'REPORT_SEARCH_SYNC', value: 'report.search.sync' },
        REPORT_SEARCH_SYNC_DEDUPLICATION: {
            name: 'REPORT_SEARCH_SYNC_DEDUPLICATION',
            value: 'report.search.sync.deduplication',
        },
        REPORT_SEARCH_SYNC_DEDUPLICATION_SYNC: {
            name: 'REPORT_SEARCH_SYNC_DEDUPLICATION_SYNC',
            value: 'report.search.sync.deduplication.sync',
        },
        REPORT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'REPORT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'report.search.sync.low_priority',
        },
        RMS_AI_EVENT_INFO_EVALUATION: {
            name: 'RMS_AI_EVENT_INFO_EVALUATION',
            value: 'rms.ai.event_info_evaluation',
        },
        RMS_AI_FIELD_SUGGESTION_EXECUTION: {
            name: 'RMS_AI_FIELD_SUGGESTION_EXECUTION',
            value: 'rms.ai.field_suggestion_execution',
        },
        RMS_AI_FIELD_SUGGESTION_FILTER: {
            name: 'RMS_AI_FIELD_SUGGESTION_FILTER',
            value: 'rms.ai.field_suggestion_filter',
        },
        RMS_AI_NARRATIVE_EVALUATION: {
            name: 'RMS_AI_NARRATIVE_EVALUATION',
            value: 'rms.ai.narrative_evaluation',
        },
        RMS_AI_OFFENSE_INCIDENT_EVALUATION: {
            name: 'RMS_AI_OFFENSE_INCIDENT_EVALUATION',
            value: 'rms.ai.offense_incident.evaluation',
        },
        RMS_AI_VALIDATION_CONTEXT_EXTRACTION: {
            name: 'RMS_AI_VALIDATION_CONTEXT_EXTRACTION',
            value: 'rms.ai.validation_context_extraction',
        },
        RMS_AI_VALIDATION_RULE_EVALUATION: {
            name: 'RMS_AI_VALIDATION_RULE_EVALUATION',
            value: 'rms.ai.validation_rule_evaluation',
        },
        RMS_BATCH_OPERATION_CREATED: {
            name: 'RMS_BATCH_OPERATION_CREATED',
            value: 'rms.batch_operations.batch_operation_created',
        },
        RMS_BATCH_OPERATION_ITEM_CREATED: {
            name: 'RMS_BATCH_OPERATION_ITEM_CREATED',
            value: 'rms.batch_operation_items.batch_operation_item_created',
        },
        RMS_CASE_APPROVAL_STATUS_OR_REVIEWS_CHANGED: {
            name: 'RMS_CASE_APPROVAL_STATUS_OR_REVIEWS_CHANGED',
            value: 'rms.case_approval_status_or_reviews_changed',
        },
        RMS_CASE_CREATED: { name: 'RMS_CASE_CREATED', value: 'rms.case.created' },
        RMS_CASE_NOTES_CHANGED: { name: 'RMS_CASE_NOTES_CHANGED', value: 'rms.case_notes_changed' },
        RMS_CASE_REPORT_LINK_CREATED: {
            name: 'RMS_CASE_REPORT_LINK_CREATED',
            value: 'rms.case_report_link_created',
        },
        RMS_CASE_REPORT_LINK_REMOVED: {
            name: 'RMS_CASE_REPORT_LINK_REMOVED',
            value: 'rms.case_report_link_removed',
        },
        RMS_CASE_STATUS_CHANGED: {
            name: 'RMS_CASE_STATUS_CHANGED',
            value: 'rms.case_status_changed',
        },
        RMS_CASE_TARGET_PROFILE_REVIEW_DUE_TODAY: {
            name: 'RMS_CASE_TARGET_PROFILE_REVIEW_DUE_TODAY',
            value: 'rms.case_target_profile_review_due_today',
        },
        RMS_COMPLIANCE_EXPORT_REQUESTED: {
            name: 'RMS_COMPLIANCE_EXPORT_REQUESTED',
            value: 'rms.compliance_export_requested',
        },
        RMS_COMPLIANCE_SEGMENT_REGENERATION: {
            name: 'RMS_COMPLIANCE_SEGMENT_REGENERATION',
            value: 'rms.compliance_segment_regeneration',
        },
        RMS_DEPARTMENT_SETUP_ASYNC_STARTED: {
            name: 'RMS_DEPARTMENT_SETUP_ASYNC_STARTED',
            value: 'rms.department_setup_async.started',
        },
        RMS_DEPARTMENT_SETUP_SUCCESS: {
            name: 'RMS_DEPARTMENT_SETUP_SUCCESS',
            value: 'rms.department_setup.success',
        },
        RMS_EXTERNAL_REPORT_STATUS_CREATED: {
            name: 'RMS_EXTERNAL_REPORT_STATUS_CREATED',
            value: 'rms.external_report_status.created',
        },
        RMS_EXTERNAL_REPORT_STATUS_DELETED: {
            name: 'RMS_EXTERNAL_REPORT_STATUS_DELETED',
            value: 'rms.external_report_status.deleted',
        },
        RMS_E_FILE_EVENT: { name: 'RMS_E_FILE_EVENT', value: 'rms.e_file.event' },
        RMS_FIX_REN_MISMATCH: { name: 'RMS_FIX_REN_MISMATCH', value: 'rms.fix_ren_mismatch' },
        RMS_MASTER_PROFILES_MERGED: {
            name: 'RMS_MASTER_PROFILES_MERGED',
            value: 'rms.master.profiles.merged',
        },
        RMS_NIBRS_ERROR_GENERATION_REQUEST: {
            name: 'RMS_NIBRS_ERROR_GENERATION_REQUEST',
            value: 'rms.nibrs_error_generation_request',
        },
        RMS_NIBRS_EXPORT_REQUESTED: {
            name: 'RMS_NIBRS_EXPORT_REQUESTED',
            value: 'rms.nibrs_export_requested',
        },
        RMS_NIBRS_EXPORT_RESULTS_REQUEST: {
            name: 'RMS_NIBRS_EXPORT_RESULTS_REQUEST',
            value: 'rms.nibrs_export_results_request',
        },
        RMS_NIBRS_PRINT_REQUEST: {
            name: 'RMS_NIBRS_PRINT_REQUEST',
            value: 'rms.nibrs_print_request',
        },
        RMS_PERCOLATE_SEARCH: { name: 'RMS_PERCOLATE_SEARCH', value: 'rms.percolate_search' },
        RMS_PERCOLATE_SEARCH_LOW_PRIORITY: {
            name: 'RMS_PERCOLATE_SEARCH_LOW_PRIORITY',
            value: 'rms.percolate_search.low_priority',
        },
        RMS_PNC_DATA_CHANGED: { name: 'RMS_PNC_DATA_CHANGED', value: 'rms.pnc.data.changed' },
        RMS_REPORT_ASSOCIATED_RECORD_ADDED_TO_REPORT: {
            name: 'RMS_REPORT_ASSOCIATED_RECORD_ADDED_TO_REPORT',
            value: 'rms.report.associated_record_added_to_report',
        },
        RMS_REPORT_AUTHOR_ADDED: {
            name: 'RMS_REPORT_AUTHOR_ADDED',
            value: 'rms.report.author_added',
        },
        RMS_REPORT_CASE_STATUS_CHANGED: {
            name: 'RMS_REPORT_CASE_STATUS_CHANGED',
            value: 'rms.report_case_status.changed',
        },
        RMS_REPORT_COMMENT_CREATED: {
            name: 'RMS_REPORT_COMMENT_CREATED',
            value: 'rms.report_comment.created',
        },
        RMS_REPORT_CREATED: { name: 'RMS_REPORT_CREATED', value: 'rms.report.created' },
        RMS_REPORT_DELETED: { name: 'RMS_REPORT_DELETED', value: 'rms.report.deleted' },
        RMS_REPORT_OWNER_MODIFIED: {
            name: 'RMS_REPORT_OWNER_MODIFIED',
            value: 'rms.report.owner_modified',
        },
        RMS_REPORT_PERMISSION_MODIFIED: {
            name: 'RMS_REPORT_PERMISSION_MODIFIED',
            value: 'rms.report.permission_modified',
        },
        RMS_REPORT_REN_UPDATED: { name: 'RMS_REPORT_REN_UPDATED', value: 'rms.report.ren.updated' },
        RMS_REPORT_RETURNED_TO_DRAFT: {
            name: 'RMS_REPORT_RETURNED_TO_DRAFT',
            value: 'rms.report.returned.to.draft',
        },
        RMS_REPORT_REVIEWED: { name: 'RMS_REPORT_REVIEWED', value: 'rms.report.reviewed' },
        RMS_REPORT_SUBMITTED: { name: 'RMS_REPORT_SUBMITTED', value: 'rms.report.submitted' },
        RMS_REPORT_SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT: {
            name: 'RMS_REPORT_SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT',
            value: 'rms.report.suggested_associated_record_added_to_report',
        },
        RMS_SEARCH_DUPLICATE_CANDIDATES: {
            name: 'RMS_SEARCH_DUPLICATE_CANDIDATES',
            value: 'rms.search_duplicate_candidates',
        },
        RMS_SHARED_SAVED_SEARCH: {
            name: 'RMS_SHARED_SAVED_SEARCH',
            value: 'rms.shared_saved_search',
        },
        RMS_SHARED_SAVED_SEARCH_DELETED: {
            name: 'RMS_SHARED_SAVED_SEARCH_DELETED',
            value: 'rms.shared_saved_search_deleted',
        },
        RMS_SHARED_SAVED_SEARCH_UPDATED: {
            name: 'RMS_SHARED_SAVED_SEARCH_UPDATED',
            value: 'rms.shared_saved_search_updated',
        },
        RMS_SUBSCRIPTION_BACKFILL: {
            name: 'RMS_SUBSCRIPTION_BACKFILL',
            value: 'rms.subscription_backfill',
        },
        RMS_SUBSCRIPTION_HIT: { name: 'RMS_SUBSCRIPTION_HIT', value: 'rms.subscription_hit' },
        RMS_SUBSCRIPTION_PERCOLATION: {
            name: 'RMS_SUBSCRIPTION_PERCOLATION',
            value: 'rms.subscription_percolation',
        },
        RMS_TASK_CREATED: { name: 'RMS_TASK_CREATED', value: 'rms.task_created' },
        RMS_TASK_DUE_TODAY: { name: 'RMS_TASK_DUE_TODAY', value: 'rms.task_due_today' },
        RMS_TASK_STATUS_CHANGED: {
            name: 'RMS_TASK_STATUS_CHANGED',
            value: 'rms.task_status_changed',
        },
        RMS_UNIT_CASE_ASSIGNMENT: {
            name: 'RMS_UNIT_CASE_ASSIGNMENT',
            value: 'rms.case_unit_assignment',
        },
        RMS_USER_CASE_ASSIGNMENT: {
            name: 'RMS_USER_CASE_ASSIGNMENT',
            value: 'rms.case_user_assignment',
        },
        RMS_USER_CASE_ASSIGNMENT_UPDATED_SUPERVISOR: {
            name: 'RMS_USER_CASE_ASSIGNMENT_UPDATED_SUPERVISOR',
            value: 'rms.case_user_assignment_updated_supervisor',
        },
        RMS_USER_CASE_UNASSIGNMENT: {
            name: 'RMS_USER_CASE_UNASSIGNMENT',
            value: 'rms.case_user_unassignment',
        },
        RMS_USER_TASK_ASSIGNMENT: {
            name: 'RMS_USER_TASK_ASSIGNMENT',
            value: 'rms.user_task_assignment',
        },
        ROLODEX_PROFILE_SEARCH_SYNC: {
            name: 'ROLODEX_PROFILE_SEARCH_SYNC',
            value: 'rolodex_profile.search.sync',
        },
        ROLODEX_PROFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'ROLODEX_PROFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'rolodex_profile.search.sync.low_priority',
        },
        SAVED_SEARCH_SEARCH_SYNC: {
            name: 'SAVED_SEARCH_SEARCH_SYNC',
            value: 'saved_search.search.sync',
        },
        SAVED_SEARCH_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'SAVED_SEARCH_SEARCH_SYNC_LOW_PRIORITY',
            value: 'saved_search.search.sync.low_priority',
        },
        SECURITY_EXISTING_USER_EMAIL: {
            name: 'SECURITY_EXISTING_USER_EMAIL',
            value: 'security.user.existing_user_email',
        },
        SECURITY_SYNC_API_TOKENS: {
            name: 'SECURITY_SYNC_API_TOKENS',
            value: 'security.sync_api_tokens',
        },
        SECURITY_USER_AUTHENTICATION: {
            name: 'SECURITY_USER_AUTHENTICATION',
            value: 'security.user.authentication',
        },
        SECURITY_USER_CONFIRM_EMAIL: {
            name: 'SECURITY_USER_CONFIRM_EMAIL',
            value: 'security.user.confirm_email',
        },
        SHAPEFILE_MODIFIED: { name: 'SHAPEFILE_MODIFIED', value: 'shapefile.modified' },
        SHAPEFILE_SEARCH_SYNC: { name: 'SHAPEFILE_SEARCH_SYNC', value: 'shapefile.search.sync' },
        SHAPEFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'SHAPEFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'shapefile.search.sync.low_priority',
        },
        STREET_SEGMENT_SEARCH_SYNC: {
            name: 'STREET_SEGMENT_SEARCH_SYNC',
            value: 'street_segment.search.sync',
        },
        STREET_SEGMENT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'STREET_SEGMENT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'street_segment.search.sync.low_priority',
        },
        TASK_SEARCH_SYNC: { name: 'TASK_SEARCH_SYNC', value: 'task.search.sync' },
        TASK_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'TASK_SEARCH_SYNC_LOW_PRIORITY',
            value: 'task.search.sync.low_priority',
        },
        TEST_BROADCAST: { name: 'TEST_BROADCAST', value: 'test.broadcast' },
        TEST_COMPLEX_TYPE: { name: 'TEST_COMPLEX_TYPE', value: 'test.complex_map' },
        TEST_NOTIFICATIONS: { name: 'TEST_NOTIFICATIONS', value: 'test.notifications' },
        TEST_ROUND_ROBIN: { name: 'TEST_ROUND_ROBIN', value: 'test.round_robin' },
        TEST_TIMERED_EVENT: { name: 'TEST_TIMERED_EVENT', value: 'test.timered.event' },
        UNIT_STATUS_SEARCH_SYNC: {
            name: 'UNIT_STATUS_SEARCH_SYNC',
            value: 'unit_status.search.sync',
        },
        UNIT_STATUS_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'UNIT_STATUS_SEARCH_SYNC_LOW_PRIORITY',
            value: 'unit_status.search.sync.low_priority',
        },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
        USAGE_LOGS_VIEWED_LOGS: { name: 'USAGE_LOGS_VIEWED_LOGS', value: 'usage_logs.viewed_logs' },
        USER_ACTION_SEARCH_SYNC: {
            name: 'USER_ACTION_SEARCH_SYNC',
            value: 'user_action.search.sync',
        },
        USER_ACTION_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'USER_ACTION_SEARCH_SYNC_LOW_PRIORITY',
            value: 'user_action.search.sync.low_priority',
        },
        USER_DISABLED: { name: 'USER_DISABLED', value: 'security.user.disabled' },
        USER_PROFILE: { name: 'USER_PROFILE', value: 'security.user_profile' },
        USER_PROFILE_SEARCH_SYNC: {
            name: 'USER_PROFILE_SEARCH_SYNC',
            value: 'user_profile.search.sync',
        },
        USER_PROFILE_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'USER_PROFILE_SEARCH_SYNC_LOW_PRIORITY',
            value: 'user_profile.search.sync.low_priority',
        },
        USER_ROLES_CHANGED: { name: 'USER_ROLES_CHANGED', value: 'security.user.roles.changed' },
        USER_ROLE_MODIFICATION: {
            name: 'USER_ROLE_MODIFICATION',
            value: 'security.user.roles.modification',
        },
        USER_STATUS_CHANGED: { name: 'USER_STATUS_CHANGED', value: 'security.user.status.changed' },
        VIDEO_RESIZE: { name: 'VIDEO_RESIZE', value: 'video.resize' },
        WARRANT_SEARCH_SYNC: { name: 'WARRANT_SEARCH_SYNC', value: 'warrant.search.sync' },
        WARRANT_SEARCH_SYNC_LOW_PRIORITY: {
            name: 'WARRANT_SEARCH_SYNC_LOW_PRIORITY',
            value: 'warrant.search.sync.low_priority',
        },
        WORKFLOW_END_TO_END: { name: 'WORKFLOW_END_TO_END', value: 'workflow.end_to_end' },
        ZIP_FILES: { name: 'ZIP_FILES', value: 'zip.files' },
    },
    VR = {
        COUNTER: { name: 'COUNTER' },
        GAUGE: { name: 'GAUGE' },
        HISTOGRAM: { name: 'HISTOGRAM' },
        METER: { name: 'METER' },
        TIMER: { name: 'TIMER' },
    },
    oR = {
        CONSTRAINT_VIOLATION: { name: 'CONSTRAINT_VIOLATION', value: 'CONSTRAINT_VIOLATION' },
        MISSING_REFERENCED_ENTITY: {
            name: 'MISSING_REFERENCED_ENTITY',
            value: 'MISSING_REFERENCED_ENTITY',
        },
        RUNTIME_ERROR: { name: 'RUNTIME_ERROR', value: 'RUNTIME_ERROR' },
    },
    BR = { ONSCENE: { name: 'ONSCENE', value: 1 } },
    rR = { ANDROID: { name: 'ANDROID', value: 2 }, IOS: { name: 'IOS', value: 1 } },
    sR = { COMPUTE_ONLY: { name: 'COMPUTE_ONLY' }, DELIVER: { name: 'DELIVER' } },
    iR = {
        BOOLEAN: { name: 'BOOLEAN', value: 2 },
        STANDARD: { name: 'STANDARD', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    WR = {
        ADMIN: { name: 'ADMIN' },
        AML: { name: 'AML' },
        CAD: { name: 'CAD' },
        CITIZEN_PORTAL: { name: 'CITIZEN_PORTAL' },
        COMMAND_RUNNERS: { name: 'COMMAND_RUNNERS' },
        CORE: { name: 'CORE' },
        DEX: { name: 'DEX' },
        DRAGON: { name: 'DRAGON' },
        ENTITY_PERMISSIONS: { name: 'ENTITY_PERMISSIONS' },
        EVIDENCE: { name: 'EVIDENCE' },
        FOUNDATION_MODELS: { name: 'FOUNDATION_MODELS' },
        GPS: { name: 'GPS' },
        INTEGRATIONS: { name: 'INTEGRATIONS' },
        JMS: { name: 'JMS' },
        M43FORMS: { name: 'M43FORMS' },
        NOTIFICATIONS: { name: 'NOTIFICATIONS' },
        PARTNERSHIPS: { name: 'PARTNERSHIPS' },
        RMS: { name: 'RMS' },
        RMS_AI: { name: 'RMS_AI' },
        RMS_DEX: { name: 'RMS_DEX' },
        SHARED: { name: 'SHARED' },
        USAGE_LOGS: { name: 'USAGE_LOGS' },
        WORKFLOW: { name: 'WORKFLOW' },
    },
    cR = {
        MONITORING: { name: 'MONITORING', value: 1 },
        NO_ACTION: { name: 'NO_ACTION', value: 2 },
        RESTARTED: { name: 'RESTARTED', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    KR = {
        CLASS_MISMATCH: { name: 'CLASS_MISMATCH', value: 3 },
        MISSING_DISPATCH_AREA: { name: 'MISSING_DISPATCH_AREA', value: 5 },
        NO_HOME_STATION: { name: 'NO_HOME_STATION', value: 4 },
        STATION_NOT_FOUND: { name: 'STATION_NOT_FOUND', value: 2 },
        UNIT_NOT_FOUND: { name: 'UNIT_NOT_FOUND', value: 1 },
    },
    dR = {
        APPLIED: { name: 'APPLIED', value: 1 },
        NO_CHANGE: { name: 'NO_CHANGE', value: 2 },
        REJECTED: { name: 'REJECTED', value: 3 },
    },
    pR = {
        FRONT: { name: 'FRONT', value: 'FRONT' },
        LEFT_SIDE: { name: 'LEFT_SIDE', value: 'LEFT_SIDE' },
        OTHER: { name: 'OTHER', value: 'OTHER' },
        RIGHT_SIDE: { name: 'RIGHT_SIDE', value: 'RIGHT_SIDE' },
    },
    yR = { JDBC_URL: { name: 'JDBC_URL' }, MYSQL_DATA_SOURCE: { name: 'MYSQL_DATA_SOURCE' } },
    XR = { BULK: { name: 'BULK' }, SINGLE_ENTRY: { name: 'SINGLE_ENTRY' } },
    QR = {
        HIGH_PRIORITY_UPDATE: { name: 'HIGH_PRIORITY_UPDATE', value: 2 },
        STANDARD_UPDATE: { name: 'STANDARD_UPDATE', value: 1 },
    },
    bR = {
        ANY: { name: 'ANY', value: 5 },
        NOT_A_CRIME: { name: 'NOT_A_CRIME', value: 4 },
        PERSON: { name: 'PERSON', value: 1 },
        PROPERTY: { name: 'PROPERTY', value: 2 },
        SOCIETY: { name: 'SOCIETY', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    fR = {
        ADMIN_SEGMENT: { name: 'ADMIN_SEGMENT', value: 'Admin Segment' },
        ARIZONA_INCIDENT_SEGMENT: {
            name: 'ARIZONA_INCIDENT_SEGMENT',
            value: 'Arizona Incident Segment',
        },
        ARIZONA_SUBJECT_VICTIM_ASSOCIATION_SEGMENT: {
            name: 'ARIZONA_SUBJECT_VICTIM_ASSOCIATION_SEGMENT',
            value: 'Arizona Subject Victim Association Segment',
        },
        ARRESTEE_SEGMENT: { name: 'ARRESTEE_SEGMENT', value: 'Arrestee Segment' },
        CALIFORNIA_SEGMENT_8: { name: 'CALIFORNIA_SEGMENT_8', value: 'California Segment 8' },
        CALIFORNIA_SEGMENT_9: { name: 'CALIFORNIA_SEGMENT_9', value: 'California Segment 9' },
        CALIFORNIA_SEGMENT_A: { name: 'CALIFORNIA_SEGMENT_A', value: 'California Segment A' },
        CALIFORNIA_SEGMENT_B: { name: 'CALIFORNIA_SEGMENT_B', value: 'California Segment B' },
        GROUP_B_ARREST_SEGMENT: { name: 'GROUP_B_ARREST_SEGMENT', value: 'Group B Arrest Segment' },
        NEW_JERSEY_SUPPLEMENT: { name: 'NEW_JERSEY_SUPPLEMENT', value: 'New Jersey Supplement' },
        NEW_YORK_ARREST_CHARGE_SEGMENT: {
            name: 'NEW_YORK_ARREST_CHARGE_SEGMENT',
            value: 'New York Arrest Charge Segment',
        },
        OFFENDER_SEGMENT: { name: 'OFFENDER_SEGMENT', value: 'Offender Segment' },
        OFFENSE_SEGMENT: { name: 'OFFENSE_SEGMENT', value: 'Offense Segment' },
        PENNSYLVANIA_SEGMENT_10: {
            name: 'PENNSYLVANIA_SEGMENT_10',
            value: 'Pennsylvania Segment 10',
        },
        PENNSYLVANIA_SEGMENT_8: { name: 'PENNSYLVANIA_SEGMENT_8', value: 'Pennsylvania Segment 8' },
        PENNSYLVANIA_SEGMENT_9: { name: 'PENNSYLVANIA_SEGMENT_9', value: 'Pennsylvania Segment 9' },
        PROPERTY_SEGMENT: { name: 'PROPERTY_SEGMENT', value: 'Property Segment' },
        STRUCTURE_CHECK: { name: 'STRUCTURE_CHECK', value: 'Structure Check' },
        TEXAS_SEGMENT: { name: 'TEXAS_SEGMENT', value: 'Texas Segment' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
        VICTIM_SEGMENT: { name: 'VICTIM_SEGMENT', value: 'Victim Segment' },
        ZERO_REPORT_SEGMENT: { name: 'ZERO_REPORT_SEGMENT', value: 'Zero Report Segment' },
    },
    gR = {
        ILLEGAL_NOT_CONSECUTIVE: {
            name: 'ILLEGAL_NOT_CONSECUTIVE',
            value: 'Request for final export skipped month(s).',
        },
        ILLEGAL_NOT_RECENT: {
            name: 'ILLEGAL_NOT_RECENT',
            value: 'There is a final export for the subsequent month.',
        },
        LEGAL_FIRST_EXPORT: {
            name: 'LEGAL_FIRST_EXPORT',
            value: 'Final export for this month does not exist.',
        },
        LEGAL_OVERWRITE: {
            name: 'LEGAL_OVERWRITE',
            value: 'Final export for the month exists and it is the most recent month.',
        },
    },
    JR = {
        CAN_INCLUDE_CARGO_THEFT: { name: 'CAN_INCLUDE_CARGO_THEFT', value: 1 },
        CAN_INCLUDE_DOMESTIC_VIOLENCE: { name: 'CAN_INCLUDE_DOMESTIC_VIOLENCE', value: 4096 },
        CAN_INCLUDE_GANG_INFO: { name: 'CAN_INCLUDE_GANG_INFO', value: 1024 },
        CAN_INCLUDE_LEOKA: { name: 'CAN_INCLUDE_LEOKA', value: 2 },
        IS_ABDUCTION_BNE_BRIBERY: { name: 'IS_ABDUCTION_BNE_BRIBERY', value: 8192 },
        IS_ASSAULT_HOMICIDE: { name: 'IS_ASSAULT_HOMICIDE', value: 16384 },
        IS_DRUG_VIOLATION: { name: 'IS_DRUG_VIOLATION', value: 32768 },
        IS_GAMBLING: { name: 'IS_GAMBLING', value: 65536 },
        IS_JUSTIFIABLE_HOMICIDE: { name: 'IS_JUSTIFIABLE_HOMICIDE', value: 64 },
        IS_LARCENY: { name: 'IS_LARCENY', value: 131072 },
        IS_RAPE: { name: 'IS_RAPE', value: 262144 },
        IS_SEXUAL_ASSAULT: { name: 'IS_SEXUAL_ASSAULT', value: 524288 },
        IS_THEFT_FRAUD: { name: 'IS_THEFT_FRAUD', value: 1048576 },
        REQUIRES_AGG_ASSAULT_CIRC: { name: 'REQUIRES_AGG_ASSAULT_CIRC', value: 8 },
        REQUIRES_ANIMAL_CRUELTY_CATEGORY: { name: 'REQUIRES_ANIMAL_CRUELTY_CATEGORY', value: 2048 },
        REQUIRES_CRIMINAL_ACTIVITY: { name: 'REQUIRES_CRIMINAL_ACTIVITY', value: 4 },
        REQUIRES_HOMICIDE_CIRC: { name: 'REQUIRES_HOMICIDE_CIRC', value: 16 },
        REQUIRES_INJURY: { name: 'REQUIRES_INJURY', value: 128 },
        REQUIRES_NEG_MANSLAUGHTER_CIRC: { name: 'REQUIRES_NEG_MANSLAUGHTER_CIRC', value: 32 },
        REQUIRES_PROPERTY: { name: 'REQUIRES_PROPERTY', value: 512 },
        REQUIRES_WEAPON_OR_FORCE: { name: 'REQUIRES_WEAPON_OR_FORCE', value: 256 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    hR = {
        AA: { name: 'AA', value: 1 },
        AC: { name: 'AC', value: 2 },
        AOL: { name: 'AOL', value: 3 },
        AOO: { name: 'AOO', value: 4 },
        AOOP: { name: 'AOOP', value: 66 },
        AOOPR: { name: 'AOOPR', value: 68 },
        AOOS: { name: 'AOOS', value: 67 },
        APP: { name: 'APP', value: 5 },
        AR: { name: 'AR', value: 6 },
        B: { name: 'B', value: 7 },
        BBE: { name: 'BBE', value: 8 },
        BC: { name: 'BC', value: 9 },
        BW: { name: 'BW', value: 10 },
        CATO: { name: 'CATO', value: 69 },
        CC: { name: 'CC', value: 11 },
        CDM: { name: 'CDM', value: 111 },
        CF: { name: 'CF', value: 12 },
        CLV: { name: 'CLV', value: 13 },
        DC: { name: 'DC', value: 14 },
        DDV: { name: 'DDV', value: 15 },
        DEV: { name: 'DEV', value: 16 },
        DN: { name: 'DN', value: 17 },
        DR: { name: 'DR', value: 18 },
        DUI: { name: 'DUI', value: 19 },
        DUIA: { name: 'DUIA', value: 70 },
        DUIAD: { name: 'DUIAD', value: 72 },
        DUID: { name: 'DUID', value: 71 },
        DUIU: { name: 'DUIU', value: 73 },
        EM: { name: 'EM', value: 20 },
        ESP: { name: 'ESP', value: 84 },
        EVI: { name: 'EVI', value: 80 },
        EX: { name: 'EX', value: 21 },
        EXP: { name: 'EXP', value: 97 },
        F: { name: 'F', value: 22 },
        FAD: { name: 'FAD', value: 88 },
        FAP: { name: 'FAP', value: 87 },
        FAR: { name: 'FAR', value: 98 },
        FC: { name: 'FC', value: 90 },
        FLO: { name: 'FLO', value: 81 },
        FON: { name: 'FON', value: 23 },
        FP: { name: 'FP', value: 24 },
        FRSO: { name: 'FRSO', value: 93 },
        FRV: { name: 'FRV', value: 99 },
        FTO: { name: 'FTO', value: 82 },
        GEV: { name: 'GEV', value: 25 },
        HC: { name: 'HC', value: 26 },
        HEC: { name: 'HEC', value: 86 },
        HTCSA: { name: 'HTCSA', value: 27 },
        HTIS: { name: 'HTIS', value: 28 },
        IC: { name: 'IC', value: 108 },
        IEUS: { name: 'IEUS', value: 89 },
        IM: { name: 'IM', value: 29 },
        IN: { name: 'IN', value: 30 },
        INT: { name: 'INT', value: 31 },
        INTIM: { name: 'INTIM', value: 75 },
        IT: { name: 'IT', value: 32 },
        IVI: { name: 'IVI', value: 79 },
        JH: { name: 'JH', value: 33 },
        KA: { name: 'KA', value: 34 },
        LL: { name: 'LL', value: 35 },
        ML: { name: 'ML', value: 85 },
        MNM: { name: 'MNM', value: 36 },
        MP: { name: 'MP', value: 105 },
        MVT: { name: 'MVT', value: 37 },
        NM: { name: 'NM', value: 38 },
        NRN: { name: 'NRN', value: 65 },
        NVM: { name: 'NVM', value: 78 },
        OPAG: { name: 'OPAG', value: 39 },
        PJY: { name: 'PJY', value: 100 },
        POM: { name: 'POM', value: 40 },
        PP: { name: 'PP', value: 41 },
        PPR: { name: 'PPR', value: 42 },
        PR: { name: 'PR', value: 43 },
        PRWL: { name: 'PRWL', value: 107 },
        PS: { name: 'PS', value: 44 },
        PT: { name: 'PT', value: 45 },
        R: { name: 'R', value: 46 },
        RA: { name: 'RA', value: 110 },
        READ: { name: 'READ', value: 92 },
        RO: { name: 'RO', value: 47 },
        RU: { name: 'RU', value: 48 },
        SA: { name: 'SA', value: 49 },
        SAL: { name: 'SAL', value: 91 },
        SAO: { name: 'SAO', value: 50 },
        SE: { name: 'SE', value: 101 },
        SF: { name: 'SF', value: 104 },
        SH: { name: 'SH', value: 51 },
        SO: { name: 'SO', value: 52 },
        SPO: { name: 'SPO', value: 53 },
        SR: { name: 'SR', value: 54 },
        ST: { name: 'ST', value: 55 },
        STK: { name: 'STK', value: 77 },
        STLK: { name: 'STLK', value: 74 },
        SUI: { name: 'SUI', value: 106 },
        TCO: { name: 'TCO', value: 57 },
        TCOH: { name: 'TCOH', value: 102 },
        TFB: { name: 'TFB', value: 56 },
        TMB: { name: 'TMB', value: 76 },
        TMV: { name: 'TMV', value: 58 },
        TMVP: { name: 'TMVP', value: 59 },
        TR: { name: 'TR', value: 60 },
        TRS: { name: 'TRS', value: 94 },
        TRU: { name: 'TRU', value: 109 },
        UMVWC: { name: 'UMVWC', value: 103 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VA_DUI_MARIJUANA: { name: 'VA_DUI_MARIJUANA', value: 113 },
        VNC: { name: 'VNC', value: 61 },
        VNFA: { name: 'VNFA', value: 95 },
        WF: { name: 'WF', value: 63 },
        WIF: { name: 'WIF', value: 64 },
        WL: { name: 'WL', value: 62 },
        WMD: { name: 'WMD', value: 96 },
        WT: { name: 'WT', value: 83 },
    },
    ZR = {
        A: { name: 'A', value: 1 },
        B: { name: 'B', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    jR = {
        AGENCY_ORI_SHOULD_NEVER_BE_NULL: { name: 'AGENCY_ORI_SHOULD_NEVER_BE_NULL', value: 35 },
        ARREST_HAS_NO_CHARGES: { name: 'ARREST_HAS_NO_CHARGES', value: 31 },
        ARREST_MISSING_FOR_WARRANT_ARREST: { name: 'ARREST_MISSING_FOR_WARRANT_ARREST', value: 44 },
        ARREST_ONLY_HAS_WARRANT_CHARGES: { name: 'ARREST_ONLY_HAS_WARRANT_CHARGES', value: 28 },
        ARREST_REPORT_MISSING: { name: 'ARREST_REPORT_MISSING', value: 41 },
        ATTRIBUTE_MAPPED_TO_MULTIPLE_NIBRS_CODES: {
            name: 'ATTRIBUTE_MAPPED_TO_MULTIPLE_NIBRS_CODES',
            value: 27,
        },
        ATTRIBUTE_MISSING_NIBRS_CODE: { name: 'ATTRIBUTE_MISSING_NIBRS_CODE', value: 5 },
        CHARGE_NOT_MAPPED_TO_OFFENSE_CODE: { name: 'CHARGE_NOT_MAPPED_TO_OFFENSE_CODE', value: 20 },
        CODE_MISSING_FOR_ATTRIBUTE_CODE: { name: 'CODE_MISSING_FOR_ATTRIBUTE_CODE', value: 37 },
        CODE_MISSING_FOR_OFFENSE_CODE: { name: 'CODE_MISSING_FOR_OFFENSE_CODE', value: 39 },
        CROSS_AGENCY_REPORTS: { name: 'CROSS_AGENCY_REPORTS', value: 33 },
        DEFENDANT_PERSON_PROFILE_MISSING: { name: 'DEFENDANT_PERSON_PROFILE_MISSING', value: 43 },
        EVENT_SHOULD_NEVER_BE_NULL: { name: 'EVENT_SHOULD_NEVER_BE_NULL', value: 1 },
        EXTERNAL_EXPORT_REPOSITORY_FAILURE: {
            name: 'EXTERNAL_EXPORT_REPOSITORY_FAILURE',
            value: 50,
        },
        GENERIC_SKIP_ERROR: { name: 'GENERIC_SKIP_ERROR', value: 34 },
        NO_DEFENDANT_FOR_ARREST: { name: 'NO_DEFENDANT_FOR_ARREST', value: 42 },
        NUMBER_OF_VICTIMS_EXCEEDED_REPORT_LIMIT: {
            name: 'NUMBER_OF_VICTIMS_EXCEEDED_REPORT_LIMIT',
            value: 47,
        },
        OFFENDER_PERSON_PROFILE_MISSING: { name: 'OFFENDER_PERSON_PROFILE_MISSING', value: 40 },
        OFFENSE_CODE_MISSING_NIBRS_CODE_MAPPING: {
            name: 'OFFENSE_CODE_MISSING_NIBRS_CODE_MAPPING',
            value: 45,
        },
        OFFENSE_COMPLETION_STATUS_MUST_MATCH_WHEN_NIBRS_CODE_MATCH: {
            name: 'OFFENSE_COMPLETION_STATUS_MUST_MATCH_WHEN_NIBRS_CODE_MATCH',
            value: 49,
        },
        OFFENSE_DATE_AND_LOCATION_MUST_MATCH_WHEN_NIBRS_CODE_MATCH: {
            name: 'OFFENSE_DATE_AND_LOCATION_MUST_MATCH_WHEN_NIBRS_CODE_MATCH',
            value: 48,
        },
        OFFENSE_REPORT_HAS_NO_OFFENSES: { name: 'OFFENSE_REPORT_HAS_NO_OFFENSES', value: 2 },
        OFFENSE_REPORT_HAS_NO_REN: { name: 'OFFENSE_REPORT_HAS_NO_REN', value: 36 },
        OFFENSE_REPORT_MISSING_OFFENSE_CODE: {
            name: 'OFFENSE_REPORT_MISSING_OFFENSE_CODE',
            value: 38,
        },
        ORGANIZATION_TYPE_MISSING_FOR_ORGANIZATION_VICTIM: {
            name: 'ORGANIZATION_TYPE_MISSING_FOR_ORGANIZATION_VICTIM',
            value: 51,
        },
        PERSON_ESTIMATED_AGE_BELOW_ZERO: { name: 'PERSON_ESTIMATED_AGE_BELOW_ZERO', value: 46 },
        REPORTABLE_ARREST_LINKED_TO_NOT_REPORTABLE_OFFENSES_ONLY: {
            name: 'REPORTABLE_ARREST_LINKED_TO_NOT_REPORTABLE_OFFENSES_ONLY',
            value: 30,
        },
        WARRANT_IS_MISSING_IS_OTHER_JURISDICTION: {
            name: 'WARRANT_IS_MISSING_IS_OTHER_JURISDICTION',
            value: 29,
        },
    },
    xR = {
        CAD: { name: 'CAD', value: 7 },
        CASES: { name: 'CASES', value: 3 },
        DEX: { name: 'DEX', value: 9 },
        EVIDENCE: { name: 'EVIDENCE', value: 1 },
        REPORTS: { name: 'REPORTS', value: 2 },
        SAVED_SEARCHES: { name: 'SAVED_SEARCHES', value: 8 },
        SECURITY: { name: 'SECURITY', value: 4 },
        SUBSCRIPTIONS: { name: 'SUBSCRIPTIONS', value: 6 },
        TASKS: { name: 'TASKS', value: 5 },
        UNIVERSAL_SEARCH: { name: 'UNIVERSAL_SEARCH', value: 10 },
    },
    kR = { NOTIFICATION_STATUS: { name: 'NOTIFICATION_STATUS', value: 1 } },
    wR = {
        CATEGORY: { name: 'CATEGORY', value: 3 },
        DEFAULT: { name: 'DEFAULT', value: 4 },
        PRIORITY: { name: 'PRIORITY', value: 2 },
        TIME: { name: 'TIME', value: 1 },
    },
    zR = {
        HIGH: { name: 'HIGH', value: 1 },
        LOW: { name: 'LOW', value: 3 },
        MEDIUM: { name: 'MEDIUM', value: 2 },
    },
    qR = {
        ACKNOWLEDGED: { name: 'ACKNOWLEDGED', value: 4 },
        ARCHIVED: { name: 'ARCHIVED', value: 3 },
        READ: { name: 'READ', value: 2 },
        UNREAD: { name: 'UNREAD', value: 1 },
    },
    $R = {
        ASSOCIATED_RECORD_ADDED_TO_REPORT: { name: 'ASSOCIATED_RECORD_ADDED_TO_REPORT', value: 34 },
        BOLO: { name: 'BOLO', value: 49 },
        CAD_MESSAGE: { name: 'CAD_MESSAGE', value: 65 },
        CAD_MESSAGE_URGENT: { name: 'CAD_MESSAGE_URGENT', value: 66 },
        CASE_APPROVED: { name: 'CASE_APPROVED', value: 25 },
        CASE_NOTE_ADDED: { name: 'CASE_NOTE_ADDED', value: 20 },
        CASE_NOTE_DELETED: { name: 'CASE_NOTE_DELETED', value: 21 },
        CASE_REJECTED: { name: 'CASE_REJECTED', value: 26 },
        CASE_REVIEWED: { name: 'CASE_REVIEWED', value: 24 },
        CASE_REVIEW_REQUESTED: { name: 'CASE_REVIEW_REQUESTED', value: 23 },
        CASE_STATUS_CHANGED: { name: 'CASE_STATUS_CHANGED', value: 22 },
        CASE_TARGET_PROFILE_REVIEW_DUE_TODAY: {
            name: 'CASE_TARGET_PROFILE_REVIEW_DUE_TODAY',
            value: 63,
        },
        CASE_TASK_DUE_TODAY: { name: 'CASE_TASK_DUE_TODAY', value: 37 },
        DEX_HIT_RETURN: { name: 'DEX_HIT_RETURN', value: 54 },
        DEX_HOT_HIT_RETURN: { name: 'DEX_HOT_HIT_RETURN', value: 58 },
        DEX_STANDARD_RETURN: { name: 'DEX_STANDARD_RETURN', value: 53 },
        DUPLICATE_PROFILES_IDENTIFIED: { name: 'DUPLICATE_PROFILES_IDENTIFIED', value: 31 },
        EVIDENCE_ITEM_APPROVED_FOR_DISPOSITION: {
            name: 'EVIDENCE_ITEM_APPROVED_FOR_DISPOSITION',
            value: 6,
        },
        EVIDENCE_ITEM_APPROVED_FOR_RELEASE: {
            name: 'EVIDENCE_ITEM_APPROVED_FOR_RELEASE',
            value: 28,
        },
        EVIDENCE_ITEM_OVERDUE_CLERK: { name: 'EVIDENCE_ITEM_OVERDUE_CLERK', value: 4 },
        EVIDENCE_ITEM_OVERDUE_USER: { name: 'EVIDENCE_ITEM_OVERDUE_USER', value: 3 },
        EVIDENCE_LAB_RESULTS_AVAILABLE: { name: 'EVIDENCE_LAB_RESULTS_AVAILABLE', value: 2 },
        EVIDENCE_REVIEW_ITEM_FOR_DISPOSITION: {
            name: 'EVIDENCE_REVIEW_ITEM_FOR_DISPOSITION',
            value: 5,
        },
        HIGH_PRIORITY_NARRATIVE: { name: 'HIGH_PRIORITY_NARRATIVE', value: 52 },
        INCOMING_ASSIGNMENT: { name: 'INCOMING_ASSIGNMENT', value: 51 },
        OFFICER_EMERGENCY: { name: 'OFFICER_EMERGENCY', value: 50 },
        REPORT_ADDED_TO_CASE: { name: 'REPORT_ADDED_TO_CASE', value: 16 },
        REPORT_APPROVAL_REQUESTED: { name: 'REPORT_APPROVAL_REQUESTED', value: 12 },
        REPORT_APPROVED: { name: 'REPORT_APPROVED', value: 9 },
        REPORT_AUTHOR_ADDED: { name: 'REPORT_AUTHOR_ADDED', value: 61 },
        REPORT_CASE_STATUS_CHANGED: { name: 'REPORT_CASE_STATUS_CHANGED', value: 27 },
        REPORT_COMMENT_CREATED: { name: 'REPORT_COMMENT_CREATED', value: 43 },
        REPORT_DELETED: { name: 'REPORT_DELETED', value: 59 },
        REPORT_IN_CASE_APPROVED: { name: 'REPORT_IN_CASE_APPROVED', value: 14 },
        REPORT_IN_CASE_REJECTED: { name: 'REPORT_IN_CASE_REJECTED', value: 15 },
        REPORT_IN_CASE_RETURNED_TO_DRAFT: { name: 'REPORT_IN_CASE_RETURNED_TO_DRAFT', value: 13 },
        REPORT_OWNER_MODIFIED: { name: 'REPORT_OWNER_MODIFIED', value: 62 },
        REPORT_PERMISSION_MODIFIED: { name: 'REPORT_PERMISSION_MODIFIED', value: 60 },
        REPORT_REJECTED: { name: 'REPORT_REJECTED', value: 10 },
        REPORT_REJECTED_BY_SECONDARY: { name: 'REPORT_REJECTED_BY_SECONDARY', value: 11 },
        REPORT_REMOVED_FROM_CASE: { name: 'REPORT_REMOVED_FROM_CASE', value: 17 },
        REPORT_REN_UPDATED: { name: 'REPORT_REN_UPDATED', value: 7 },
        REPORT_RETURNED_TO_DRAFT_AFTER_SECONDARY_APPROVAL: {
            name: 'REPORT_RETURNED_TO_DRAFT_AFTER_SECONDARY_APPROVAL',
            value: 8,
        },
        RFA_FAILURE: { name: 'RFA_FAILURE', value: 57 },
        RFA_TIMED_OUT: { name: 'RFA_TIMED_OUT', value: 56 },
        RFA_URGENT_MESSAGE: { name: 'RFA_URGENT_MESSAGE', value: 55 },
        SECURITY_ALERT: { name: 'SECURITY_ALERT', value: 32 },
        SECURITY_EXISTING_USER_EMAIL: { name: 'SECURITY_EXISTING_USER_EMAIL', value: 30 },
        SECURITY_USER_CONFIRM_EMAIL: { name: 'SECURITY_USER_CONFIRM_EMAIL', value: 29 },
        SHARED_SAVED_SEARCH: { name: 'SHARED_SAVED_SEARCH', value: 44 },
        SHARED_SAVED_SEARCH_DELETED: { name: 'SHARED_SAVED_SEARCH_DELETED', value: 48 },
        SHARED_SAVED_SEARCH_UPDATED: { name: 'SHARED_SAVED_SEARCH_UPDATED', value: 47 },
        SUBSCRIPTION_HIT: { name: 'SUBSCRIPTION_HIT', value: 41 },
        SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT: {
            name: 'SUGGESTED_ASSOCIATED_RECORD_ADDED_TO_REPORT',
            value: 35,
        },
        TASK_DUE_TODAY: { name: 'TASK_DUE_TODAY', value: 42 },
        TASK_STATUS_CHANGED: { name: 'TASK_STATUS_CHANGED', value: 40 },
        TEST: { name: 'TEST', value: 1 },
        TEST_CAD_HIGH: { name: 'TEST_CAD_HIGH', value: 45 },
        TEST_CAD_MEDIUM: { name: 'TEST_CAD_MEDIUM', value: 46 },
        UNIT_CASE_ASSIGNMENT: { name: 'UNIT_CASE_ASSIGNMENT', value: 19 },
        UNIT_EMERGENCY_ALERT: { name: 'UNIT_EMERGENCY_ALERT', value: 64 },
        USER_CASE_ASSIGNMENT: { name: 'USER_CASE_ASSIGNMENT', value: 18 },
        USER_CASE_ASSIGNMENT_UPDATED_SUPERVISOR: {
            name: 'USER_CASE_ASSIGNMENT_UPDATED_SUPERVISOR',
            value: 36,
        },
        USER_CASE_TASK_ASSIGNMENT: { name: 'USER_CASE_TASK_ASSIGNMENT', value: 38 },
        USER_CASE_UNASSIGNMENT: { name: 'USER_CASE_UNASSIGNMENT', value: 33 },
        USER_TASK_ASSIGNMENT: { name: 'USER_TASK_ASSIGNMENT', value: 39 },
        USX_HIT_RETURN: { name: 'USX_HIT_RETURN', value: 68 },
        USX_HOT_HIT_RETURN: { name: 'USX_HOT_HIT_RETURN', value: 69 },
        USX_STANDARD_RETURN: { name: 'USX_STANDARD_RETURN', value: 67 },
    },
    Ea = {
        ALERTS: { name: 'ALERTS', value: 'alerts' },
        ARCHIVE: { name: 'ARCHIVE', value: 'archive' },
        INBOX: { name: 'INBOX', value: 'inbox' },
    },
    _a = {
        ADDITIONAL_CALL_FOR_SERVICE_EVENT_LINK: { name: 'ADDITIONAL_CALL_FOR_SERVICE_EVENT_LINK' },
        ADDITIONAL_INFO_EVENT_LINK_KEY: { name: 'ADDITIONAL_INFO_EVENT_LINK_KEY' },
        ADDITIONAL_INFO_KEY: { name: 'ADDITIONAL_INFO_KEY' },
        AGENCY_EVENT_MATERIALIZED_CAUTIONS: { name: 'AGENCY_EVENT_MATERIALIZED_CAUTIONS' },
        AGENCY_EVENT_RADIO_CHANNEL: { name: 'AGENCY_EVENT_RADIO_CHANNEL' },
        ATTACHMENT: { name: 'ATTACHMENT' },
        CALL_FOR_SERVICE: { name: 'CALL_FOR_SERVICE' },
        CALL_TAKER_STATION_USER_LINK: { name: 'CALL_TAKER_STATION_USER_LINK' },
        CONVERSATION: { name: 'CONVERSATION' },
        DISPATCH_AREA: { name: 'DISPATCH_AREA' },
        DISPATCH_AREA_OWNER_LINKS: { name: 'DISPATCH_AREA_OWNER_LINKS' },
        DISPOSITION: { name: 'DISPOSITION' },
        EVENT_ASSOCIATION_REASON: { name: 'EVENT_ASSOCIATION_REASON' },
        EVENT_CLEARING: { name: 'EVENT_CLEARING' },
        EVENT_CLEARING_DISPOSITION: { name: 'EVENT_CLEARING_DISPOSITION' },
        EVENT_EVENT_ASSOCIATION: { name: 'EVENT_EVENT_ASSOCIATION' },
        EVENT_EVENT_LINK: { name: 'EVENT_EVENT_LINK' },
        EVENT_KEY: { name: 'EVENT_KEY' },
        EVENT_LABEL: { name: 'EVENT_LABEL' },
        EVENT_LABEL_LINK: { name: 'EVENT_LABEL_LINK' },
        GEOFENCE: { name: 'GEOFENCE' },
        GEOFENCE_STYLE: { name: 'GEOFENCE_STYLE' },
        HELD_UNIT_KEY: { name: 'HELD_UNIT_KEY' },
        HOSPITAL: { name: 'HOSPITAL' },
        INVOLVED_PERSON: { name: 'INVOLVED_PERSON' },
        ITEM_EVENT_LINK: { name: 'ITEM_EVENT_LINK' },
        MARKER: { name: 'MARKER' },
        MARKER_STYLE: { name: 'MARKER_STYLE' },
        MESSAGE: { name: 'MESSAGE' },
        PATROL: { name: 'PATROL' },
        PHONE_CALL_EVENT_LINK: { name: 'PHONE_CALL_EVENT_LINK' },
        REPORTING_PARTY: { name: 'REPORTING_PARTY' },
        REPORT_EVENT_NUMBER: { name: 'REPORT_EVENT_NUMBER' },
        SCHEDULED_AGENCY_EVENT: { name: 'SCHEDULED_AGENCY_EVENT' },
        SCHEDULED_EVENT_SOURCE_EVENT_LINK: { name: 'SCHEDULED_EVENT_SOURCE_EVENT_LINK' },
        SCHEDULED_EVENT_TIME: { name: 'SCHEDULED_EVENT_TIME' },
        SENSOR_ALERT_EVENT_LINK: { name: 'SENSOR_ALERT_EVENT_LINK' },
        TRANSPORT_KEY: { name: 'TRANSPORT_KEY' },
        UNIT_KEY: { name: 'UNIT_KEY' },
        UNIT_LOCATION_INFO: { name: 'UNIT_LOCATION_INFO' },
        UNIT_SHIFT: { name: 'UNIT_SHIFT' },
        UNIT_SHIFT_ATTRIBUTE: { name: 'UNIT_SHIFT_ATTRIBUTE' },
        UNIT_STATE_KEY: { name: 'UNIT_STATE_KEY' },
        UNIT_STATE_TRANSITION: { name: 'UNIT_STATE_TRANSITION' },
        UNIT_STATUS_KEY: { name: 'UNIT_STATUS_KEY' },
        UNIT_STATUS_LINK_KEY: { name: 'UNIT_STATUS_LINK_KEY' },
        UNIT_TIMER: { name: 'UNIT_TIMER' },
        USER_UNIT_LINK_KEY: { name: 'USER_UNIT_LINK_KEY' },
    },
    Ta = {
        _09A: { name: '_09A' },
        _09B: { name: '_09B' },
        _09C: { name: '_09C' },
        _100: { name: '_100' },
        _11A: { name: '_11A' },
        _11B: { name: '_11B' },
        _11C: { name: '_11C' },
        _11D: { name: '_11D' },
        _120: { name: '_120' },
        _13A: { name: '_13A' },
        _13B: { name: '_13B' },
        _13C: { name: '_13C' },
        _200: { name: '_200' },
        _210: { name: '_210' },
        _220: { name: '_220' },
        _23A: { name: '_23A' },
        _23B: { name: '_23B' },
        _23C: { name: '_23C' },
        _23D: { name: '_23D' },
        _23E: { name: '_23E' },
        _23F: { name: '_23F' },
        _23G: { name: '_23G' },
        _23H: { name: '_23H' },
        _240: { name: '_240' },
        _250: { name: '_250' },
        _26A: { name: '_26A' },
        _26B: { name: '_26B' },
        _26C: { name: '_26C' },
        _26D: { name: '_26D' },
        _26E: { name: '_26E' },
        _26F: { name: '_26F' },
        _26G: { name: '_26G' },
        _270: { name: '_270' },
        _280: { name: '_280' },
        _290: { name: '_290' },
        _35A: { name: '_35A' },
        _35B: { name: '_35B' },
        _36A: { name: '_36A' },
        _36B: { name: '_36B' },
        _370: { name: '_370' },
        _39A: { name: '_39A' },
        _39B: { name: '_39B' },
        _39C: { name: '_39C' },
        _39D: { name: '_39D' },
        _40A: { name: '_40A' },
        _40B: { name: '_40B' },
        _40C: { name: '_40C' },
        _500: { name: '_500' },
        _510: { name: '_510' },
        _520: { name: '_520' },
        _64A: { name: '_64A' },
        _64B: { name: '_64B' },
        _720: { name: '_720' },
        _90A: { name: '_90A' },
        _90B: { name: '_90B' },
        _90C: { name: '_90C' },
        _90D: { name: '_90D' },
        _90E: { name: '_90E' },
        _90F: { name: '_90F' },
        _90G: { name: '_90G' },
        _90H: { name: '_90H' },
        _90I: { name: '_90I' },
        _90J: { name: '_90J' },
        _90Z: { name: '_90Z' },
        _999: { name: '_999' },
    },
    ea = {
        STATEMENT_OF_FACTS: { name: 'STATEMENT_OF_FACTS', value: 2 },
        WORDING: { name: 'WORDING', value: 1 },
    },
    Aa = {
        BETWEEN: { name: 'BETWEEN', value: 4 },
        ON: { name: 'ON', value: 1 },
        ON_OR_ABOUT: { name: 'ON_OR_ABOUT', value: 2 },
        ON_OR_BEFORE: { name: 'ON_OR_BEFORE', value: 3 },
    },
    Na = {
        ADVISED_RIGHTS: { name: 'ADVISED_RIGHTS', value: 4 },
        ARRESTING: { name: 'ARRESTING', value: 3 },
        RECOVERED_BY: { name: 'RECOVERED_BY', value: 2 },
        RESPONDING: { name: 'RESPONDING', value: 1 },
        TOW_VEHICLE_RELEASED_BY: { name: 'TOW_VEHICLE_RELEASED_BY', value: 6 },
        USE_OF_FORCE: { name: 'USE_OF_FORCE', value: 5 },
    },
    Ia = {
        EXTERNAL_OFFICER: { name: 'EXTERNAL_OFFICER', value: 'EXTERNAL_OFFICER' },
        JMS_USER: { name: 'JMS_USER', value: 'JMS_USER' },
    },
    Ra = {
        ADD: { name: 'ADD', value: 'Add' },
        REMOVE: { name: 'REMOVE', value: 'Remove' },
        REPLACE: { name: 'REPLACE', value: 'Replace' },
    },
    aa = {
        AGENCY_PROFILE_LOOKUP_INVALID: { name: 'AGENCY_PROFILE_LOOKUP_INVALID' },
        AGENCY_REQUIRED: { name: 'AGENCY_REQUIRED' },
        APPROVAL_STATUS_INVALID: { name: 'APPROVAL_STATUS_INVALID' },
        ARRESTING_AGENCY_REQUIRED: { name: 'ARRESTING_AGENCY_REQUIRED' },
        ARRESTING_OFFICER_REQUIRED: { name: 'ARRESTING_OFFICER_REQUIRED' },
        ARREST_DATE_REQUIRED: { name: 'ARREST_DATE_REQUIRED' },
        ARREST_LOCATION_REQUIRED: { name: 'ARREST_LOCATION_REQUIRED' },
        ARREST_NUMBER_REQUIRED: { name: 'ARREST_NUMBER_REQUIRED' },
        ATTRIBUTE_LOOKUP_INVALID: { name: 'ATTRIBUTE_LOOKUP_INVALID' },
        ATTRIBUTE_TYPE_IN_EXPECTED_ATTRIBUTE_TYPES: {
            name: 'ATTRIBUTE_TYPE_IN_EXPECTED_ATTRIBUTE_TYPES',
        },
        ATTRIBUTE_TYPE_LOOKUP_INVALID: { name: 'ATTRIBUTE_TYPE_LOOKUP_INVALID' },
        AT_LEAST_ONE_CHARGE_REQUIRED: { name: 'AT_LEAST_ONE_CHARGE_REQUIRED' },
        BARRIER_ID_REQUIRED: { name: 'BARRIER_ID_REQUIRED' },
        BARRIER_LATITUDE_REQUIRED: { name: 'BARRIER_LATITUDE_REQUIRED' },
        BARRIER_LONGITUDE_REQUIRED: { name: 'BARRIER_LONGITUDE_REQUIRED' },
        CAD_AGENCY_EVENT_NUMBER_IS_REQUIRED: { name: 'CAD_AGENCY_EVENT_NUMBER_IS_REQUIRED' },
        CAD_COMMON_EVENT_NUMBER_IS_REQUIRED: { name: 'CAD_COMMON_EVENT_NUMBER_IS_REQUIRED' },
        CAD_TICKET_CALL_DATE_REQUIRED: { name: 'CAD_TICKET_CALL_DATE_REQUIRED' },
        CAD_TICKET_EVENT_START_DATE_UTC_REQUIRED: {
            name: 'CAD_TICKET_EVENT_START_DATE_UTC_REQUIRED',
        },
        CHARGE_OFFENSE_CODE_REQUIRED: { name: 'CHARGE_OFFENSE_CODE_REQUIRED' },
        CITATION_CHARGE_REQUIRED: { name: 'CITATION_CHARGE_REQUIRED' },
        CITATION_NUMBER_REQUIRED: { name: 'CITATION_NUMBER_REQUIRED' },
        CITATION_TYPE_REQUIRED: { name: 'CITATION_TYPE_REQUIRED' },
        COMMENT_AUTHORED_DATE_IS_REQUIRED: { name: 'COMMENT_AUTHORED_DATE_IS_REQUIRED' },
        COMMENT_IS_REQUIRED: { name: 'COMMENT_IS_REQUIRED' },
        CONFIGURED_ENTITY_PROPERTY_ID_REQUIRED: { name: 'CONFIGURED_ENTITY_PROPERTY_ID_REQUIRED' },
        CONFIGURED_ENTITY_TYPE_ID_REQUIRED: { name: 'CONFIGURED_ENTITY_TYPE_ID_REQUIRED' },
        DEFENDANT_REQUIRED: { name: 'DEFENDANT_REQUIRED' },
        END_BEFORE_START: { name: 'END_BEFORE_START' },
        EVENT_LATITUDE_REQUIRED: { name: 'EVENT_LATITUDE_REQUIRED' },
        EVENT_LONGITUDE_REQUIRED: { name: 'EVENT_LONGITUDE_REQUIRED' },
        EVENT_START_DATE_UTC_REQUIRED: { name: 'EVENT_START_DATE_UTC_REQUIRED' },
        EXTERNAL_KEY_REQUIRED: { name: 'EXTERNAL_KEY_REQUIRED' },
        EXTERNAL_KEY_UNIQUENESS_REQUIRED: { name: 'EXTERNAL_KEY_UNIQUENESS_REQUIRED' },
        EXTERNAL_LINK_REASON_FOR_ASSOCIATION_IS_REQUIRED: {
            name: 'EXTERNAL_LINK_REASON_FOR_ASSOCIATION_IS_REQUIRED',
        },
        EXTERNAL_LINK_SOURCE_ID_IS_REQUIRED: { name: 'EXTERNAL_LINK_SOURCE_ID_IS_REQUIRED' },
        EXTERNAL_LINK_SOURCE_SYSTEM_IS_REQUIRED: {
            name: 'EXTERNAL_LINK_SOURCE_SYSTEM_IS_REQUIRED',
        },
        INVALID_COUNTRY: { name: 'INVALID_COUNTRY' },
        INVALID_CUSTOM_ENTITY_FOR_REPORT_CREATION: {
            name: 'INVALID_CUSTOM_ENTITY_FOR_REPORT_CREATION',
        },
        INVALID_CUSTOM_ENTITY_NO_CONFIGURED_FORM: {
            name: 'INVALID_CUSTOM_ENTITY_NO_CONFIGURED_FORM',
        },
        INVALID_ENTITY_TYPE_FROM: { name: 'INVALID_ENTITY_TYPE_FROM' },
        INVALID_ENTITY_TYPE_TO: { name: 'INVALID_ENTITY_TYPE_TO' },
        INVALID_LINK_TYPE: { name: 'INVALID_LINK_TYPE' },
        INVALID_LOCATION: { name: 'INVALID_LOCATION' },
        INVALID_PHONE_NUMBER_PARSING: { name: 'INVALID_PHONE_NUMBER_PARSING' },
        INVALID_YEAR: { name: 'INVALID_YEAR' },
        INVOLVED_PROFILES_EXTERNAL_IDS_REQUIRED: {
            name: 'INVOLVED_PROFILES_EXTERNAL_IDS_REQUIRED',
        },
        IS_PRIMARY_REQUIRED: { name: 'IS_PRIMARY_REQUIRED' },
        ITEM_EXTERNAL_ID_IS_REQUIRED: { name: 'ITEM_EXTERNAL_ID_IS_REQUIRED' },
        ITEM_EXTERNAL_ID_IS_UNIQUE: { name: 'ITEM_EXTERNAL_ID_IS_UNIQUE' },
        ITEM_INVOLVEMENT_TYPE_INVALID: { name: 'ITEM_INVOLVEMENT_TYPE_INVALID' },
        LINE_BARRIER_PATH_REQUIRED: { name: 'LINE_BARRIER_PATH_REQUIRED' },
        LINE_BARRIER_PATH_SEGMENT_REQUIRED: { name: 'LINE_BARRIER_PATH_SEGMENT_REQUIRED' },
        NAME_ATTRIBUTE_REQUIRED: { name: 'NAME_ATTRIBUTE_REQUIRED' },
        NAME_EMAIL_REQUIRED: { name: 'NAME_EMAIL_REQUIRED' },
        NAME_IDENTIFIER_REQUIRED: { name: 'NAME_IDENTIFIER_REQUIRED' },
        NAME_IDENTIFIER_TYPE_REQUIRED: { name: 'NAME_IDENTIFIER_TYPE_REQUIRED' },
        NAME_MONIKER_DATE_OF_BIRTH_OTHER_REQUIRED: {
            name: 'NAME_MONIKER_DATE_OF_BIRTH_OTHER_REQUIRED',
        },
        NAME_MONIKER_MONIKER_REQUIRED: { name: 'NAME_MONIKER_MONIKER_REQUIRED' },
        NAME_NAME_LINK_FROM_EXTERNAL_ID_IS_REQUIRED: {
            name: 'NAME_NAME_LINK_FROM_EXTERNAL_ID_IS_REQUIRED',
        },
        NAME_NAME_LINK_TO_EXTERNAL_ID_IS_REQUIRED: {
            name: 'NAME_NAME_LINK_TO_EXTERNAL_ID_IS_REQUIRED',
        },
        NAME_PHONE_NUMBER_ENTITY_TYPE_REQUIRED: { name: 'NAME_PHONE_NUMBER_ENTITY_TYPE_REQUIRED' },
        NAME_PHONE_NUMBER_REQUIRED: { name: 'NAME_PHONE_NUMBER_REQUIRED' },
        NAME_REPORT_LINK_EXTERNAL_LINK_ID_IS_UNIQUE: {
            name: 'NAME_REPORT_LINK_EXTERNAL_LINK_ID_IS_UNIQUE',
        },
        NAME_REPORT_LINK_EXTERNAL_LINK_ID_REQUIRED: {
            name: 'NAME_REPORT_LINK_EXTERNAL_LINK_ID_REQUIRED',
        },
        NUMBER_OF_RESOURCES_NEEDED_REQUIRED: { name: 'NUMBER_OF_RESOURCES_NEEDED_REQUIRED' },
        OFFENSE_CODE_IS_REQUIRED: { name: 'OFFENSE_CODE_IS_REQUIRED' },
        OFFENSE_CODE_NOT_FOUND: { name: 'OFFENSE_CODE_NOT_FOUND' },
        OFFENSE_DATE_REQUIRED: { name: 'OFFENSE_DATE_REQUIRED' },
        OFFENSE_ORDER_MUST_BE_UNIQUE: { name: 'OFFENSE_ORDER_MUST_BE_UNIQUE' },
        OFFENSE_ORDER_REQUIRED: { name: 'OFFENSE_ORDER_REQUIRED' },
        ORGANIZATION_EXTERNAL_ID_IS_REQUIRED: { name: 'ORGANIZATION_EXTERNAL_ID_IS_REQUIRED' },
        ORGANIZATION_EXTERNAL_ID_UNIQUE: { name: 'ORGANIZATION_EXTERNAL_ID_UNIQUE' },
        PERSON_EXTERNAL_ID_IS_REQUIRED: { name: 'PERSON_EXTERNAL_ID_IS_REQUIRED' },
        PERSON_EXTERNAL_ID_UNIQUE: { name: 'PERSON_EXTERNAL_ID_UNIQUE' },
        POLYGON_BARRIER_RING_REQUIRED: { name: 'POLYGON_BARRIER_RING_REQUIRED' },
        POLYGON_BARRIER_RING_SEGMENT_REQUIRED: { name: 'POLYGON_BARRIER_RING_SEGMENT_REQUIRED' },
        PROPERTY_VALUE_INVALID: { name: 'PROPERTY_VALUE_INVALID' },
        RECORD_NUMBER_REQUIRED: { name: 'RECORD_NUMBER_REQUIRED' },
        REPORTING_EVENT_NUMBER_INVALID: { name: 'REPORTING_EVENT_NUMBER_INVALID' },
        REPORTING_EVENT_NUMBER_MUST_BE_NULL: { name: 'REPORTING_EVENT_NUMBER_MUST_BE_NULL' },
        REPORT_SEARCH_REQUIRES_RENS_GSNS_OR_UPDATED_DATE_RANGE: {
            name: 'REPORT_SEARCH_REQUIRES_RENS_GSNS_OR_UPDATED_DATE_RANGE',
        },
        STATE_PLANE_ZONE_INVALID: { name: 'STATE_PLANE_ZONE_INVALID' },
        SUBMITTED_BY_AND_APPROVED_BY_CANNOT_BE_EQUAL: {
            name: 'SUBMITTED_BY_AND_APPROVED_BY_CANNOT_BE_EQUAL',
        },
        SUBMITTED_BY_REQUIRED_IF_SUBMITTED: { name: 'SUBMITTED_BY_REQUIRED_IF_SUBMITTED' },
        SUPPLEMENT_DESCRIPTION_REQUIRED: { name: 'SUPPLEMENT_DESCRIPTION_REQUIRED' },
        SUPPLEMENT_TYPE_REQUIRED: { name: 'SUPPLEMENT_TYPE_REQUIRED' },
        UNABLE_TO_PARSE_X: { name: 'UNABLE_TO_PARSE_X' },
        UNITS_REQUIRED: { name: 'UNITS_REQUIRED' },
        UNIT_ID_REQUIRED: { name: 'UNIT_ID_REQUIRED' },
        UNIT_LATITUDE_REQUIRED: { name: 'UNIT_LATITUDE_REQUIRED' },
        UNIT_LONGITUDE_REQUIRED: { name: 'UNIT_LONGITUDE_REQUIRED' },
        USERS_NOT_FOUND_BY_ID: { name: 'USERS_NOT_FOUND_BY_ID' },
        USER_LOOKUP_INCONSISTENT: { name: 'USER_LOOKUP_INCONSISTENT' },
        USER_LOOKUP_INVALID: { name: 'USER_LOOKUP_INVALID' },
        VEHICLE_MAKE_INVALID: { name: 'VEHICLE_MAKE_INVALID' },
        VEHICLE_MODEL_INVALID: { name: 'VEHICLE_MODEL_INVALID' },
    },
    Oa = {
        ANDROID: { name: 'ANDROID', value: 1 },
        IOS: { name: 'IOS', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    Sa = { BORROW: { name: 'BORROW' }, VALIDATION: { name: 'VALIDATION' } },
    Ca = {
        DELETE: { name: 'DELETE', value: 8 },
        MANAGE: { name: 'MANAGE', value: 4 },
        READ: { name: 'READ', value: 1 },
        SEARCH: { name: 'SEARCH', value: 16 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        WRITE: { name: 'WRITE', value: 2 },
    },
    na = {
        IGNORE_MISSING_DEPENDENCIES: { name: 'IGNORE_MISSING_DEPENDENCIES' },
        IGNORE_SELF_DEPENDENCY: { name: 'IGNORE_SELF_DEPENDENCY' },
    },
    Da = {
        BLUE_200: { name: 'BLUE_200', value: 8 },
        BLUE_500: { name: 'BLUE_500', value: 9 },
        BLUE_550: { name: 'BLUE_550', value: 23 },
        BLUE_800: { name: 'BLUE_800', value: 10 },
        CYAN_300: { name: 'CYAN_300', value: 21 },
        GRAY_300: { name: 'GRAY_300', value: 13 },
        GRAY_600: { name: 'GRAY_600', value: 14 },
        GREEN_200: { name: 'GREEN_200', value: 20 },
        GREEN_500: { name: 'GREEN_500', value: 5 },
        ORANGE_300: { name: 'ORANGE_300', value: 16 },
        ORANGE_400: { name: 'ORANGE_400', value: 17 },
        ORANGE_500: { name: 'ORANGE_500', value: 18 },
        PINK_400: { name: 'PINK_400', value: 15 },
        PINK_500: { name: 'PINK_500', value: 25 },
        PURPLE_200: { name: 'PURPLE_200', value: 22 },
        PURPLE_500: { name: 'PURPLE_500', value: 11 },
        PURPLE_700: { name: 'PURPLE_700', value: 12 },
        RED_300: { name: 'RED_300', value: 1 },
        RED_600: { name: 'RED_600', value: 2 },
        TEAL_300: { name: 'TEAL_300', value: 6 },
        TEAL_500: { name: 'TEAL_500', value: 24 },
        TEAL_700: { name: 'TEAL_700', value: 7 },
        YELLOW_200: { name: 'YELLOW_200', value: 19 },
        YELLOW_400: { name: 'YELLOW_400', value: 3 },
        YELLOW_700: { name: 'YELLOW_700', value: 4 },
    },
    La = {
        CSV: { name: 'CSV' },
        HTML: { name: 'HTML' },
        JSON: { name: 'JSON' },
        JSON_ZIP: { name: 'JSON_ZIP' },
        MULTI_PDF: { name: 'MULTI_PDF' },
        NIBRS: { name: 'NIBRS' },
        NIBRS_XML: { name: 'NIBRS_XML' },
        PDF: { name: 'PDF' },
        TXT: { name: 'TXT' },
        XML: { name: 'XML' },
        XML_COMBINED: { name: 'XML_COMBINED' },
        ZIP: { name: 'ZIP' },
    },
    ma = {
        DEX_INCOMING_MESSAGE: { name: 'DEX_INCOMING_MESSAGE', value: 1 },
        FEDERATED_SEARCH_RESULT: { name: 'FEDERATED_SEARCH_RESULT', value: 2 },
    },
    la = {
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 2 },
        REQUESTED_PASSWORD_RESET: { name: 'REQUESTED_PASSWORD_RESET', value: 1 },
    },
    ua = {
        DEFAULT_ADULT_ONLY: { name: 'DEFAULT_ADULT_ONLY', value: 3 },
        DEFAULT_JUVENILE_AND_ADULT: { name: 'DEFAULT_JUVENILE_AND_ADULT', value: 4 },
        DEFAULT_JUVENILE_ONLY: { name: 'DEFAULT_JUVENILE_ONLY', value: 2 },
        SEARCH_OPTION_NOT_DISPLAYED: { name: 'SEARCH_OPTION_NOT_DISPLAYED', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    Pa = {
        CREATE_EMPTY_EVENT: { name: 'CREATE_EMPTY_EVENT', value: 6 },
        DUPE_NOOP: { name: 'DUPE_NOOP', value: 1 },
        FOCUS_MAP: { name: 'FOCUS_MAP', value: 5 },
        NO_ACTION_SUPPLIED: { name: 'NO_ACTION_SUPPLIED', value: 0 },
        OPEN_EVENT_WINDOW: { name: 'OPEN_EVENT_WINDOW', value: 4 },
        UPDATE_ACTIVE_EVENT: { name: 'UPDATE_ACTIVE_EVENT', value: 2 },
        UPDATE_UNSAVED_EVENT: { name: 'UPDATE_UNSAVED_EVENT', value: 3 },
    },
    Ua = { AU: { name: 'AU', value: 61 }, US: { name: 'US', value: 1 } },
    Ma = {
        FIXED_LINE: { name: 'FIXED_LINE', value: 1 },
        FIXED_LINE_OR_MOBILE: { name: 'FIXED_LINE_OR_MOBILE', value: 3 },
        MOBILE: { name: 'MOBILE', value: 2 },
        PAGER: { name: 'PAGER', value: 9 },
        PERSONAL_NUMBER: { name: 'PERSONAL_NUMBER', value: 8 },
        PREMIUM_RATE: { name: 'PREMIUM_RATE', value: 5 },
        SHARED_COST: { name: 'SHARED_COST', value: 6 },
        TOLL_FREE: { name: 'TOLL_FREE', value: 4 },
        UAN: { name: 'UAN', value: 10 },
        UNKNOWN: { name: 'UNKNOWN', value: 12 },
        UNKNOWN_VALUE: { name: 'UNKNOWN_VALUE', value: -1 },
        VOICEMAIL: { name: 'VOICEMAIL', value: 11 },
        VOIP: { name: 'VOIP', value: 7 },
    },
    va = {
        ATTORNEY_PHONE: { name: 'ATTORNEY_PHONE', value: 'Attorney Phone' },
        FAX_PHONE: { name: 'FAX_PHONE', value: 'Fax Phone' },
        HOME_PHONE: { name: 'HOME_PHONE', value: 'Home Phone' },
        MOBILE_PHONE: { name: 'MOBILE_PHONE', value: 'Mobile Phone' },
        OTHER_PHONE: { name: 'OTHER_PHONE', value: 'Other Phone' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
        WORK_PHONE: { name: 'WORK_PHONE', value: 'Work Phone' },
    },
    Fa = {
        SEQUENTIAL: { name: 'SEQUENTIAL', value: 1 },
        SIMULTANEOUS: { name: 'SIMULTANEOUS', value: 2 },
    },
    Ga = { PIN: { name: 'PIN' }, UNPIN: { name: 'UNPIN' } },
    Ha = {
        ADDRESS: { name: 'ADDRESS' },
        AUTOCOMPLETE: { name: 'AUTOCOMPLETE' },
        NGD: { name: 'NGD' },
    },
    Ya = { PRECONDITION_REQUIRED: { name: 'PRECONDITION_REQUIRED' } },
    ta = {
        ADDITIONAL_CALL_FOR_SERVICE: { name: 'ADDITIONAL_CALL_FOR_SERVICE', value: 78 },
        ADD_AND_DISPATCH_TEMPORARY_UNITS_ON_AN_EVENT: {
            name: 'ADD_AND_DISPATCH_TEMPORARY_UNITS_ON_AN_EVENT',
            value: 52,
        },
        ALERT_USERS_OF_AUTOMATIC_TIMEZONE_CHANGES: {
            name: 'ALERT_USERS_OF_AUTOMATIC_TIMEZONE_CHANGES',
            value: 87,
        },
        ALLOW_ADDITIONAL_DISPOSITIONS: { name: 'ALLOW_ADDITIONAL_DISPOSITIONS', value: 105 },
        ALLOW_USE_OF_MARITIME_COORDINATES: {
            name: 'ALLOW_USE_OF_MARITIME_COORDINATES',
            value: 104,
        },
        AUTOMATICALLY_CLEAR_EVENT_WHEN_LAST_UNIT_RELEASED_ENABLED: {
            name: 'AUTOMATICALLY_CLEAR_EVENT_WHEN_LAST_UNIT_RELEASED_ENABLED',
            value: 108,
        },
        AUTOMATICALLY_HOLD_EVENTS_FOR_UNITS: {
            name: 'AUTOMATICALLY_HOLD_EVENTS_FOR_UNITS',
            value: 54,
        },
        AUTOMATICALLY_IMPORT_CALLER_NAME_AND_LOCATION_ON_E911_CALLS: {
            name: 'AUTOMATICALLY_IMPORT_CALLER_NAME_AND_LOCATION_ON_E911_CALLS',
            value: 118,
        },
        AUTOMATIC_REN_GENERATION_CALL_FOR_SERVICE_BASED: {
            name: 'AUTOMATIC_REN_GENERATION_CALL_FOR_SERVICE_BASED',
            value: 35,
        },
        AUTOMATIC_REN_GENERATION_DISPOSITION_BASED: {
            name: 'AUTOMATIC_REN_GENERATION_DISPOSITION_BASED',
            value: 106,
        },
        AUTOMATIC_REN_GENERATION_UNIT_STATUS_BASED: {
            name: 'AUTOMATIC_REN_GENERATION_UNIT_STATUS_BASED',
            value: 36,
        },
        AUTO_POPULATE_REPORTING_PARTY_FROM_PHONE_CALL: {
            name: 'AUTO_POPULATE_REPORTING_PARTY_FROM_PHONE_CALL',
            value: 89,
        },
        CAD_LIGHT_MODE_ENABLED: { name: 'CAD_LIGHT_MODE_ENABLED', value: 113 },
        CALL_STATUS: { name: 'CALL_STATUS', value: 88 },
        CAN_GENERATE_REPOSSESSION_REN: { name: 'CAN_GENERATE_REPOSSESSION_REN', value: 7 },
        COMMAND_LINE_COMPACT_BY_DEFAULT: { name: 'COMMAND_LINE_COMPACT_BY_DEFAULT', value: 49 },
        COMMAND_LINE_ENABLED_FOR_DISPATCHERS: {
            name: 'COMMAND_LINE_ENABLED_FOR_DISPATCHERS',
            value: 26,
        },
        COMMAND_LINE_ENABLED_FOR_FIRST_RESPONDERS: {
            name: 'COMMAND_LINE_ENABLED_FOR_FIRST_RESPONDERS',
            value: 27,
        },
        COMMENTS_REQUIRED_WHEN_BYPASSING_SERVICE_ROTATION: {
            name: 'COMMENTS_REQUIRED_WHEN_BYPASSING_SERVICE_ROTATION',
            value: 97,
        },
        CONFIRM_BEFORE_CLOSING_NEW_EVENT_FORMS: {
            name: 'CONFIRM_BEFORE_CLOSING_NEW_EVENT_FORMS',
            value: 28,
        },
        CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP: {
            name: 'CONFIRM_UNIT_ASSIGNMENT_VIA_DRAG_AND_DROP',
            value: 103,
        },
        CONNECT_MOBILITY_GPS_INDICATORS_TO_UNITS_ON_MAP: {
            name: 'CONNECT_MOBILITY_GPS_INDICATORS_TO_UNITS_ON_MAP',
            value: 82,
        },
        COPY_ALL_INFORMATION: { name: 'COPY_ALL_INFORMATION', value: 40 },
        COPY_CALL: { name: 'COPY_CALL', value: 39 },
        CREATE_UNIT_LOCATION_INFO_ONLY_ON_TRANSPORT: {
            name: 'CREATE_UNIT_LOCATION_INFO_ONLY_ON_TRANSPORT',
            value: 69,
        },
        CROSS_CLASS_ASSISTANCE: { name: 'CROSS_CLASS_ASSISTANCE', value: 37 },
        DEFAULT_CA_PURPOSE_CODE_FIELD: { name: 'DEFAULT_CA_PURPOSE_CODE_FIELD', value: 76 },
        DEFAULT_DEX_TITLE_FIELDS: { name: 'DEFAULT_DEX_TITLE_FIELDS', value: 99 },
        DEFAULT_FUZZY_MATCHING_ENABLED: { name: 'DEFAULT_FUZZY_MATCHING_ENABLED', value: 115 },
        DEFAULT_INCLUDE_ACTIVE_ENABLED: { name: 'DEFAULT_INCLUDE_ACTIVE_ENABLED', value: 116 },
        DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP: {
            name: 'DEFAULT_NARRATIVE_DIRECTION_NEW_ON_TOP',
            value: 117,
        },
        DEFAULT_UNIT_LOCATION_CHECKBOX_VALUE: {
            name: 'DEFAULT_UNIT_LOCATION_CHECKBOX_VALUE',
            value: 23,
        },
        DISPATCH_CONFIRM_UNASSIGNING_EVENTS: {
            name: 'DISPATCH_CONFIRM_UNASSIGNING_EVENTS',
            value: 10,
        },
        DISPATCH_FIRST_UNIT_ON_EVENT: { name: 'DISPATCH_FIRST_UNIT_ON_EVENT', value: 42 },
        DISPATCH_PLAY_ALERT_ON_AED_EVENT: { name: 'DISPATCH_PLAY_ALERT_ON_AED_EVENT', value: 2 },
        DISPATCH_PLAY_ALERT_ON_ENTER_UNASSIGNED_QUEUE: {
            name: 'DISPATCH_PLAY_ALERT_ON_ENTER_UNASSIGNED_QUEUE',
            value: 1,
        },
        DISPATCH_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE: {
            name: 'DISPATCH_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE',
            value: 66,
        },
        DISPATCH_PLAY_ALERT_ON_NEW_URGENT_MESSAGE: {
            name: 'DISPATCH_PLAY_ALERT_ON_NEW_URGENT_MESSAGE',
            value: 67,
        },
        DISPATCH_PLAY_ALERT_ON_RECEIVING_DEX_HIT_RESULT_BY_OFFICER: {
            name: 'DISPATCH_PLAY_ALERT_ON_RECEIVING_DEX_HIT_RESULT_BY_OFFICER',
            value: 47,
        },
        DISPATCH_PLAY_ALERT_ON_UNIT_STATUS_TIMER_EXPIRATION: {
            name: 'DISPATCH_PLAY_ALERT_ON_UNIT_STATUS_TIMER_EXPIRATION',
            value: 70,
        },
        DRIVERS_LICENSE_PHOTOS: { name: 'DRIVERS_LICENSE_PHOTOS', value: 90 },
        ENABLE_HELD_EVENTS_FEATURE: { name: 'ENABLE_HELD_EVENTS_FEATURE', value: 53 },
        ENABLE_MESSAGING_FEATURE: { name: 'ENABLE_MESSAGING_FEATURE', value: 34 },
        ENABLE_UNIT_CLUSTERING_ON_MAP: { name: 'ENABLE_UNIT_CLUSTERING_ON_MAP', value: 101 },
        EVENTS_ALLOW_ADDING_TOW_VEHICLE: { name: 'EVENTS_ALLOW_ADDING_TOW_VEHICLE', value: 9 },
        EVENTS_HAVE_EMS_D_AREA_AND_EMS_AGENCY: {
            name: 'EVENTS_HAVE_EMS_D_AREA_AND_EMS_AGENCY',
            value: 91,
        },
        EVENTS_HAVE_FIRE_D_AREA_AND_FIRE_AGENCY: {
            name: 'EVENTS_HAVE_FIRE_D_AREA_AND_FIRE_AGENCY',
            value: 73,
        },
        EVENTS_HAVE_RISK_LEVEL: { name: 'EVENTS_HAVE_RISK_LEVEL', value: 8 },
        EVENT_LABELS: { name: 'EVENT_LABELS', value: 79 },
        EVENT_LOCATION_NOTES: { name: 'EVENT_LOCATION_NOTES', value: 60 },
        EVENT_LOCATION_PREFILLS_REPORTING_PARTY_LOCATION: {
            name: 'EVENT_LOCATION_PREFILLS_REPORTING_PARTY_LOCATION',
            value: 41,
        },
        EVENT_PANEL_COMPACT_BY_DEFAULT: { name: 'EVENT_PANEL_COMPACT_BY_DEFAULT', value: 72 },
        FILTER_OUT_SYSTEM_MESSAGES_FROM_NARRATIVE_BY_DEFAULT: {
            name: 'FILTER_OUT_SYSTEM_MESSAGES_FROM_NARRATIVE_BY_DEFAULT',
            value: 50,
        },
        FIRST_RESPONDERS_CAN_EDIT_UNIT_LOCATIONS: {
            name: 'FIRST_RESPONDERS_CAN_EDIT_UNIT_LOCATIONS',
            value: 12,
        },
        FIRST_RESPONDER_CAN_GENERATE_REN: { name: 'FIRST_RESPONDER_CAN_GENERATE_REN', value: 5 },
        FIRST_RESPONDER_CONFIRM_UNASSIGNING_EVENTS: {
            name: 'FIRST_RESPONDER_CONFIRM_UNASSIGNING_EVENTS',
            value: 11,
        },
        FIRST_RESPONDER_LIGHT_MODE_ENABLED: {
            name: 'FIRST_RESPONDER_LIGHT_MODE_ENABLED',
            value: 114,
        },
        FIRST_RESPONDER_MAP_SELF_FOCUS: { name: 'FIRST_RESPONDER_MAP_SELF_FOCUS', value: 110 },
        FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_AED_ASSIGNMENT: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_AED_ASSIGNMENT',
            value: 4,
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_ASSIGNMENT: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_INCOMING_ASSIGNMENT',
            value: 3,
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_NEW_STANDARD_MESSAGE',
            value: 64,
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_NEW_URGENT_MESSAGE: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_NEW_URGENT_MESSAGE',
            value: 65,
        },
        FIRST_RESPONDER_PLAY_ALERT_ON_RECEIVING_DEX_HOT_HIT_RESULTS: {
            name: 'FIRST_RESPONDER_PLAY_ALERT_ON_RECEIVING_DEX_HOT_HIT_RESULTS',
            value: 48,
        },
        FIRST_RESPONDER_VIEW_ASSIGNED_EVENTS_ENABLED: {
            name: 'FIRST_RESPONDER_VIEW_ASSIGNED_EVENTS_ENABLED',
            value: 33,
        },
        FIRST_RESPONDER_VIEW_SCHEDULED_EVENTS_ENABLED: {
            name: 'FIRST_RESPONDER_VIEW_SCHEDULED_EVENTS_ENABLED',
            value: 84,
        },
        FIRST_RESPONDER_VIEW_UNASSIGNED_EVENTS_ENABLED: {
            name: 'FIRST_RESPONDER_VIEW_UNASSIGNED_EVENTS_ENABLED',
            value: 32,
        },
        FOCUS_EVENT_PANEL_ON_E911_CALL: { name: 'FOCUS_EVENT_PANEL_ON_E911_CALL', value: 100 },
        FOCUS_MAP_DURING_ACTIVE_EVENT: { name: 'FOCUS_MAP_DURING_ACTIVE_EVENT', value: 77 },
        FOCUS_MAP_DURING_CALL_CREATION: { name: 'FOCUS_MAP_DURING_CALL_CREATION', value: 74 },
        HIDE_MODAL_AT_LOGIN: { name: 'HIDE_MODAL_AT_LOGIN', value: 46 },
        HIDE_PATROLS_AND_SPECIAL_ASSIGNMENT: {
            name: 'HIDE_PATROLS_AND_SPECIAL_ASSIGNMENT',
            value: 61,
        },
        IF_GPS_IS_NOT_AVAILABLE_SHOW_UNIT_LOCATION: {
            name: 'IF_GPS_IS_NOT_AVAILABLE_SHOW_UNIT_LOCATION',
            value: 16,
        },
        IS_DISPOSITION_REQUIRED_TO_CLOSE: { name: 'IS_DISPOSITION_REQUIRED_TO_CLOSE', value: 29 },
        IS_SHORTCUT_KEYS_ENABLED: { name: 'IS_SHORTCUT_KEYS_ENABLED', value: 30 },
        NARRATIVE_SELECTIONS_RESET_AFTER_EACH_ENTRY: {
            name: 'NARRATIVE_SELECTIONS_RESET_AFTER_EACH_ENTRY',
            value: 86,
        },
        NO_PRIORITY_SUGGESTIONS_FOR_ACTIVE_EVENTS: {
            name: 'NO_PRIORITY_SUGGESTIONS_FOR_ACTIVE_EVENTS',
            value: 80,
        },
        ONLY_DISPATCH_AREA_OWNERS_CAN_CLEAR_EVENT: {
            name: 'ONLY_DISPATCH_AREA_OWNERS_CAN_CLEAR_EVENT',
            value: 45,
        },
        OPEN_EVENT_PANEL_ON_E911_CALL: { name: 'OPEN_EVENT_PANEL_ON_E911_CALL', value: 98 },
        OPEN_RELATED_DATA_TAB_BY_DEFAULT: { name: 'OPEN_RELATED_DATA_TAB_BY_DEFAULT', value: 96 },
        PLAY_ALERT_ON_URGENT_BOLOS: { name: 'PLAY_ALERT_ON_URGENT_BOLOS', value: 75 },
        PLAY_MESSAGING_SOUNDS_IN_CAD_NEXT: { name: 'PLAY_MESSAGING_SOUNDS_IN_CAD_NEXT', value: 93 },
        PREFER_CAD_NEXT_MAP_WINDOW: { name: 'PREFER_CAD_NEXT_MAP_WINDOW', value: 94 },
        PREFER_NEW_EVENTS_WINDOW: { name: 'PREFER_NEW_EVENTS_WINDOW', value: 92 },
        PREFER_PHYSICAL_ADDRESS_FOR_VOIP_911_CALLS: {
            name: 'PREFER_PHYSICAL_ADDRESS_FOR_VOIP_911_CALLS',
            value: 111,
        },
        PRIORITIZE_LOCATION_ALIAS_SEARCH_RESULTS: {
            name: 'PRIORITIZE_LOCATION_ALIAS_SEARCH_RESULTS',
            value: 59,
        },
        PROMPT_BEFORE_GENERATING_REN: { name: 'PROMPT_BEFORE_GENERATING_REN', value: 24 },
        RADIO_CHANNELS: { name: 'RADIO_CHANNELS', value: 71 },
        REASON_REQUIRED_FOR_EVENT_REACTIVATION: {
            name: 'REASON_REQUIRED_FOR_EVENT_REACTIVATION',
            value: 21,
        },
        RELATED_DATA_LOCATION_RESULTS_MUST_INCLUDE_MATCH_ON_APT_OR_UNIT: {
            name: 'RELATED_DATA_LOCATION_RESULTS_MUST_INCLUDE_MATCH_ON_APT_OR_UNIT',
            value: 85,
        },
        REPORTING_PARTY_NAME_REQUIRED: { name: 'REPORTING_PARTY_NAME_REQUIRED', value: 19 },
        SAME_CLASS_ASSISTANCE: { name: 'SAME_CLASS_ASSISTANCE', value: 38 },
        SCHEDULE_EVENTS: { name: 'SCHEDULE_EVENTS', value: 56 },
        SEARCH_FOR_DUPLICATE_EVENTS: { name: 'SEARCH_FOR_DUPLICATE_EVENTS', value: 31 },
        SELF_INITIATE_ALLOW_TEMPORARY_UNITS: {
            name: 'SELF_INITIATE_ALLOW_TEMPORARY_UNITS',
            value: 55,
        },
        SELF_INITIATE_UNIT_WITHOUT_MEMBERS: {
            name: 'SELF_INITIATE_UNIT_WITHOUT_MEMBERS',
            value: 51,
        },
        SHOW_MOBILE_DEVICES_ON_AVL_MAP: { name: 'SHOW_MOBILE_DEVICES_ON_AVL_MAP', value: 83 },
        SHOW_NCIC_TOW_VEHICLE_BUTTON: { name: 'SHOW_NCIC_TOW_VEHICLE_BUTTON', value: 22 },
        SHOW_UNITS_ON_AVL_MAP: { name: 'SHOW_UNITS_ON_AVL_MAP', value: 6 },
        TRANSFER_EVENT_FROM_DISPATCH_AREA: { name: 'TRANSFER_EVENT_FROM_DISPATCH_AREA', value: 43 },
        TRANSFER_UNIT_FROM_DISPATCH_AREA: { name: 'TRANSFER_UNIT_FROM_DISPATCH_AREA', value: 44 },
        UNIT_LOCATIONS_MUST_BE_VERIFIED: { name: 'UNIT_LOCATIONS_MUST_BE_VERIFIED', value: 14 },
        UNIT_LOCATION_COMMENTS_FIELD_IS_REQUIRED: {
            name: 'UNIT_LOCATION_COMMENTS_FIELD_IS_REQUIRED',
            value: 15,
        },
        UNIT_LOCATION_CREATES_ADDITIONAL_INFO: {
            name: 'UNIT_LOCATION_CREATES_ADDITIONAL_INFO',
            value: 20,
        },
        UNIT_LOCATION_FIELD_IS_REQUIRED: { name: 'UNIT_LOCATION_FIELD_IS_REQUIRED', value: 13 },
        UNIT_LOCATION_REMOVED_LEAVING_ADMIN_STATUS: {
            name: 'UNIT_LOCATION_REMOVED_LEAVING_ADMIN_STATUS',
            value: 57,
        },
        UNIT_LOCATION_REMOVED_LEAVING_OUT_OF_SERVICE_STATUS: {
            name: 'UNIT_LOCATION_REMOVED_LEAVING_OUT_OF_SERVICE_STATUS',
            value: 58,
        },
        UNIT_LOCATION_REMOVED_ON_ADMIN_STATUS_CHANGE: {
            name: 'UNIT_LOCATION_REMOVED_ON_ADMIN_STATUS_CHANGE',
            value: 25,
        },
        UNIT_LOCATION_REMOVED_ON_EVENT_ASSIGNMENT: {
            name: 'UNIT_LOCATION_REMOVED_ON_EVENT_ASSIGNMENT',
            value: 112,
        },
        UNIT_LOCATION_REMOVED_ON_RELEASE_FROM_EVENT: {
            name: 'UNIT_LOCATION_REMOVED_ON_RELEASE_FROM_EVENT',
            value: 17,
        },
        UNIT_LOCATION_SET_TO_EVENT_LOCATION_ON_ASSIGNMENT: {
            name: 'UNIT_LOCATION_SET_TO_EVENT_LOCATION_ON_ASSIGNMENT',
            value: 68,
        },
        UNIT_LOCATION_SET_WHEN_ASSIGNED_AS_BACKUP: {
            name: 'UNIT_LOCATION_SET_WHEN_ASSIGNED_AS_BACKUP',
            value: 109,
        },
        UNIT_STAFF_COUNTS_ENABLED: { name: 'UNIT_STAFF_COUNTS_ENABLED', value: 95 },
        USERS_CAN_CHANGE_UPDATE_PRIORITY: { name: 'USERS_CAN_CHANGE_UPDATE_PRIORITY', value: 18 },
        USER_DRAG_AND_DROP_DISPATCH: { name: 'USER_DRAG_AND_DROP_DISPATCH', value: 102 },
        USE_UNIT_AGENCY_FOR_REPORTING: { name: 'USE_UNIT_AGENCY_FOR_REPORTING', value: 107 },
    },
    Va = {
        AUDIO_ALERTS: { name: 'AUDIO_ALERTS', value: 2 },
        AVL_MAP: { name: 'AVL_MAP', value: 4 },
        BETA_TESTING: { name: 'BETA_TESTING', value: 10 },
        CLI: { name: 'CLI', value: 8 },
        DEX: { name: 'DEX', value: 11 },
        DISPATCH_AREA_OWNERSHIP: { name: 'DISPATCH_AREA_OWNERSHIP', value: 6 },
        GENERAL: { name: 'GENERAL', value: 1 },
        HELD_EVENTS: { name: 'HELD_EVENTS', value: 7 },
        INTERNATIONALIZATION: { name: 'INTERNATIONALIZATION', value: 9 },
        MESSAGING: { name: 'MESSAGING', value: 5 },
        UNIT_LOCATIONS: { name: 'UNIT_LOCATIONS', value: 3 },
    },
    oa = {
        AGENCY: { name: 'AGENCY', value: 2 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 1 },
        USER: { name: 'USER', value: 8 },
    },
    Ba = {
        AGENCY_EVENT: { name: 'AGENCY_EVENT', value: 5 },
        AGENCY_EVENT_SEARCH: { name: 'AGENCY_EVENT_SEARCH', value: 6 },
        BOLO: { name: 'BOLO', value: 29 },
        CASE: { name: 'CASE', value: 2 },
        CASE_NOTE: { name: 'CASE_NOTE', value: 3 },
        CHAIN_OF_CUSTODY: { name: 'CHAIN_OF_CUSTODY', value: 8 },
        COMPLIANCE_EXPORT: { name: 'COMPLIANCE_EXPORT', value: 20 },
        COURT_ORDER_SEARCH: { name: 'COURT_ORDER_SEARCH', value: 21 },
        EVIDENCE_BARCODE_LABEL: { name: 'EVIDENCE_BARCODE_LABEL', value: 32 },
        EVIDENCE_DOCUMENT: { name: 'EVIDENCE_DOCUMENT', value: 14 },
        EVIDENCE_ITEM_SEARCH: { name: 'EVIDENCE_ITEM_SEARCH', value: 7 },
        E_FILE: { name: 'E_FILE', value: 30 },
        FOLDER: { name: 'FOLDER', value: 22 },
        INVENTORY: { name: 'INVENTORY', value: 27 },
        MULTI_REN_ITEM_LIST: { name: 'MULTI_REN_ITEM_LIST', value: 16 },
        NIBRS: { name: 'NIBRS', value: 12 },
        PARENT_FOLDER: { name: 'PARENT_FOLDER', value: 23 },
        PERSON_PROFILE: { name: 'PERSON_PROFILE', value: 13 },
        PHOTO_LINEUP: { name: 'PHOTO_LINEUP', value: 24 },
        PROPERTY_SEARCH: { name: 'PROPERTY_SEARCH', value: 18 },
        REPORT: { name: 'REPORT', value: 1 },
        REPORT_IDENTIFIER: { name: 'REPORT_IDENTIFIER', value: 28 },
        REPORT_SEARCH: { name: 'REPORT_SEARCH', value: 4 },
        SINGLE_REN_ITEM_LIST: { name: 'SINGLE_REN_ITEM_LIST', value: 15 },
        TASK: { name: 'TASK', value: 25 },
        TASK_TYPE: { name: 'TASK_TYPE', value: 26 },
        TRAFFIC_CRASH_REPORT_SEARCH: { name: 'TRAFFIC_CRASH_REPORT_SEARCH', value: 31 },
        UNIT_STATUS_SEARCH: { name: 'UNIT_STATUS_SEARCH', value: 9 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USAGE_LOGS: { name: 'USAGE_LOGS', value: 19 },
        USER_ACTION_SEARCH: { name: 'USER_ACTION_SEARCH', value: 17 },
        WARRANT: { name: 'WARRANT', value: 10 },
        WARRANT_SEARCH: { name: 'WARRANT_SEARCH', value: 11 },
    },
    ra = {
        EVIDENCE_BARCODE_LABEL: { name: 'EVIDENCE_BARCODE_LABEL', value: 10 },
        FILLABLE_PDF: { name: 'FILLABLE_PDF', value: 2 },
        JAVASCRIPT: { name: 'JAVASCRIPT', value: 1 },
        M43_FORM_PDF: { name: 'M43_FORM_PDF', value: 12 },
        PDF_NEXT: { name: 'PDF_NEXT', value: 6 },
        PDF_NEXT_DYNAMIC_PDF: { name: 'PDF_NEXT_DYNAMIC_PDF', value: 4 },
        PDF_NEXT_EVIDENCE: { name: 'PDF_NEXT_EVIDENCE', value: 11 },
        PDF_NEXT_FILLABLE_PDF: { name: 'PDF_NEXT_FILLABLE_PDF', value: 3 },
        PDF_NEXT_LEGACY_DATA: { name: 'PDF_NEXT_LEGACY_DATA', value: 7 },
        PDF_NEXT_LEGACY_FILLABLE_PDF: { name: 'PDF_NEXT_LEGACY_FILLABLE_PDF', value: 5 },
        PDF_NEXT_M43_FORM: { name: 'PDF_NEXT_M43_FORM', value: 9 },
        PDF_NEXT_REPORT_REN: { name: 'PDF_NEXT_REPORT_REN', value: 8 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    sa = {
        HIGH_PRIORITY_UPDATE: { name: 'HIGH_PRIORITY_UPDATE', value: 'HIGH_PRIORITY_UPDATE' },
        STANDARD_UPDATE: { name: 'STANDARD_UPDATE', value: 'STANDARD_UPDATE' },
    },
    ia = {
        AIRCRAFT: { name: 'AIRCRAFT', value: 1 },
        BICYCLE: { name: 'BICYCLE', value: 3 },
        BOMB: { name: 'BOMB', value: 7 },
        BUSINESS: { name: 'BUSINESS', value: 8 },
        CBRN: { name: 'CBRN', value: 22 },
        CLOTHING: { name: 'CLOTHING', value: 9 },
        EQUIPMENT: { name: 'EQUIPMENT', value: 10 },
        FIRE_BOAT: { name: 'FIRE_BOAT', value: 5 },
        HATE_CRIME: { name: 'HATE_CRIME', value: 11 },
        HAZMAT: { name: 'HAZMAT', value: 12 },
        HOSTAGE_TAKER: { name: 'HOSTAGE_TAKER', value: 13 },
        LOST_PERSON: { name: 'LOST_PERSON', value: 15 },
        OUTDOOR_EXPERIENCE: { name: 'OUTDOOR_EXPERIENCE', value: 14 },
        PERSON: { name: 'PERSON', value: 16 },
        POLICE_AIRCRAFT: { name: 'POLICE_AIRCRAFT', value: 2 },
        POLICE_BOAT: { name: 'POLICE_BOAT', value: 4 },
        RAILROAD_TRAIN: { name: 'RAILROAD_TRAIN', value: 17 },
        SUSPECT: { name: 'SUSPECT', value: 19 },
        SUSPECT_CALLER: { name: 'SUSPECT_CALLER', value: 18 },
        SUSPICIOUS_PACKAGE: { name: 'SUSPICIOUS_PACKAGE', value: 20 },
        VEHICLE: { name: 'VEHICLE', value: 21 },
        WATERCRAFT: { name: 'WATERCRAFT', value: 6 },
    },
    Wa = {
        OPEN_SECONDARY_EVENT_PANELS: { name: 'OPEN_SECONDARY_EVENT_PANELS', value: 1 },
        SHOW_NOTIFICATION: { name: 'SHOW_NOTIFICATION', value: 2 },
    },
    ca = {
        ALERT_ENABLED: { name: 'ALERT_ENABLED', value: 3 },
        ALL_OTHER_DE_BULLETED_MODE: { name: 'ALL_OTHER_DE_BULLETED_MODE', value: 9 },
        ANSWER_TYPE: { name: 'ANSWER_TYPE', value: 1 },
        BOAT_DE_BULLETED_MODE: { name: 'BOAT_DE_BULLETED_MODE', value: 11 },
        COPY_NOTES_TO_SECONDARY_EVENT: { name: 'COPY_NOTES_TO_SECONDARY_EVENT', value: 12 },
        DISPLAY_KQ_AS_SET: { name: 'DISPLAY_KQ_AS_SET', value: 2 },
        FIRE_INFO_TO_MEDICAL: { name: 'FIRE_INFO_TO_MEDICAL', value: 15 },
        FIRE_INFO_TO_POLICE: { name: 'FIRE_INFO_TO_POLICE', value: 16 },
        KQ_IN_BULLETED_MODE: { name: 'KQ_IN_BULLETED_MODE', value: 5 },
        KQ_IN_SHORT_ANSWER_TEXT: { name: 'KQ_IN_SHORT_ANSWER_TEXT', value: 6 },
        KQ_WITH_KQ_NUMBER: { name: 'KQ_WITH_KQ_NUMBER', value: 7 },
        MEDICAL_INFO_TO_FIRE: { name: 'MEDICAL_INFO_TO_FIRE', value: 13 },
        MEDICAL_INFO_TO_POLICE: { name: 'MEDICAL_INFO_TO_POLICE', value: 14 },
        PERSON_DE_BULLETED_MODE: { name: 'PERSON_DE_BULLETED_MODE', value: 8 },
        POLICE_INFO_TO_FIRE: { name: 'POLICE_INFO_TO_FIRE', value: 18 },
        POLICE_INFO_TO_MEDICAL: { name: 'POLICE_INFO_TO_MEDICAL', value: 17 },
        VEHICLE_DE_BULLETED_MODE: { name: 'VEHICLE_DE_BULLETED_MODE', value: 10 },
        WINDOW_FOCUS_HORIZONTAL: { name: 'WINDOW_FOCUS_HORIZONTAL', value: 4 },
    },
    Ka = {
        ABORT: { name: 'ABORT', value: 10 },
        COMPLETE: { name: 'COMPLETE', value: 9 },
        CRITICALUPDATE: { name: 'CRITICALUPDATE', value: 16 },
        DESCINFO: { name: 'DESCINFO', value: 15 },
        DISPATCH: { name: 'DISPATCH', value: 8 },
        ENDCE: { name: 'ENDCE', value: 5 },
        ENDKQ: { name: 'ENDKQ', value: 6 },
        ERROR: { name: 'ERROR', value: 12 },
        INIT: { name: 'INIT', value: 1 },
        OPEN: { name: 'OPEN', value: 2 },
        PEND: { name: 'PEND', value: 4 },
        RECONFIGURE: { name: 'RECONFIGURE', value: 7 },
        SUMMARY: { name: 'SUMMARY', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: 14 },
        UPDATE: { name: 'UPDATE', value: 17 },
        URGENTMSG: { name: 'URGENTMSG', value: 11 },
        WAITING: { name: 'WAITING', value: 13 },
    },
    da = {
        ANALYSIS: { name: 'ANALYSIS', value: 32 },
        BRIEF_AI: { name: 'BRIEF_AI', value: 4194304 },
        CAD: { name: 'CAD', value: 8 },
        CASES: { name: 'CASES', value: 4 },
        CITIZEN_PORTAL: { name: 'CITIZEN_PORTAL', value: 16777216 },
        DATA_EXCHANGE: { name: 'DATA_EXCHANGE', value: 64 },
        EVIDENCE: { name: 'EVIDENCE', value: 16 },
        INSIGHTS: { name: 'INSIGHTS', value: 131072 },
        JMS: { name: 'JMS', value: 2048 },
        JMS_UNIVERSAL_SEARCH: { name: 'JMS_UNIVERSAL_SEARCH', value: 8388608 },
        NOTIFICATIONS: { name: 'NOTIFICATIONS', value: 256 },
        ONSCENE_CAD_CORE: { name: 'ONSCENE_CAD_CORE', value: 4096 },
        ONSCENE_CARPLAY: { name: 'ONSCENE_CARPLAY', value: 262144 },
        ONSCENE_DEX_MAKE_QUERY: { name: 'ONSCENE_DEX_MAKE_QUERY', value: 16384 },
        ONSCENE_DEX_VIEW: { name: 'ONSCENE_DEX_VIEW', value: 8192 },
        ONSCENE_ECITATION: { name: 'ONSCENE_ECITATION', value: 1048576 },
        ONSCENE_RMS_COLLECTIONS: { name: 'ONSCENE_RMS_COLLECTIONS', value: 32768 },
        RECORDS_ARCHIVE: { name: 'RECORDS_ARCHIVE', value: 524288 },
        REPORTS: { name: 'REPORTS', value: 1 },
        REPORT_AI: { name: 'REPORT_AI', value: 2097152 },
        RMS_DEX: { name: 'RMS_DEX', value: 65536 },
        TRAFFIC_CRASH: { name: 'TRAFFIC_CRASH', value: 512 },
        USAGE_LOGS: { name: 'USAGE_LOGS', value: 128 },
        WARRANTS: { name: 'WARRANTS', value: 2 },
        WORKFLOW: { name: 'WORKFLOW', value: 1024 },
    },
    pa = {
        DETAINEE: { name: 'DETAINEE', value: 'Detainee' },
        E_FILE_DEFENDANT: { name: 'E_FILE_DEFENDANT', value: 'E-File Defendant' },
        E_FILE_VICTIM_WITNESS: { name: 'E_FILE_VICTIM_WITNESS', value: 'E-File Victim / Witness' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    ya = { CONFIG: { name: 'CONFIG' }, ENGINE: { name: 'ENGINE' } },
    Xa = {
        ARCHIVED: { name: 'ARCHIVED', value: 4 },
        DIVERGED: { name: 'DIVERGED', value: 5 },
        DRAFT: { name: 'DRAFT', value: 2 },
        NOT_IN_CATALOG: { name: 'NOT_IN_CATALOG', value: 1 },
        PUBLISHED: { name: 'PUBLISHED', value: 3 },
    },
    Qa = {
        ARCHIVED: { name: 'ARCHIVED', value: 3 },
        DRAFT: { name: 'DRAFT', value: 1 },
        PUBLISHED: { name: 'PUBLISHED', value: 2 },
    },
    ba = {
        COMPLETED: { name: 'COMPLETED' },
        ERRORED: { name: 'ERRORED' },
        RUNNING: { name: 'RUNNING' },
    },
    fa = {
        COMPLETED: { name: 'COMPLETED', value: 2 },
        ERRORED: { name: 'ERRORED', value: 3 },
        RUNNING: { name: 'RUNNING', value: 1 },
    },
    ga = {
        CLEAN: { name: 'CLEAN' },
        DIVERGED: { name: 'DIVERGED' },
        INSUFFICIENT: { name: 'INSUFFICIENT' },
    },
    Ja = {
        ARCHIVED: { name: 'ARCHIVED', value: 3 },
        DRAFT: { name: 'DRAFT', value: 1 },
        PUBLISHED: { name: 'PUBLISHED', value: 2 },
    },
    ha = { NO_PLAN: { name: 'NO_PLAN', value: 2 }, PLAN: { name: 'PLAN', value: 1 } },
    Za = {
        ALWAYS: { name: 'ALWAYS', value: 1 },
        ERROR: { name: 'ERROR', value: 3 },
        FORCED: { name: 'FORCED', value: 4 },
        SAMPLED: { name: 'SAMPLED', value: 2 },
    },
    ja = {
        CRASH: { name: 'CRASH', value: 1 },
        PROTOCOL_ERROR: { name: 'PROTOCOL_ERROR', value: 3 },
        TIMEOUT: { name: 'TIMEOUT', value: 2 },
        UPLOAD_FAILED: { name: 'UPLOAD_FAILED', value: 4 },
    },
    xa = {
        CRITERIA_CHECK: { name: 'CRITERIA_CHECK', value: 3 },
        DELIVER: { name: 'DELIVER', value: 2 },
        SHADOW: { name: 'SHADOW', value: 1 },
    },
    ka = {
        ADAPTER_FAILED: { name: 'ADAPTER_FAILED', value: 6 },
        CIRCUIT_OPEN: { name: 'CIRCUIT_OPEN', value: 4 },
        EMPTY_RESULT: { name: 'EMPTY_RESULT', value: 5 },
        ERROR: { name: 'ERROR', value: 2 },
        SUCCESS: { name: 'SUCCESS', value: 1 },
        TIMEOUT: { name: 'TIMEOUT', value: 3 },
    },
    wa = {
        FAILED_VALIDATION: { name: 'FAILED_VALIDATION' },
        NO_VALIDATION_RUN: { name: 'NO_VALIDATION_RUN' },
        OK: { name: 'OK' },
        STALE_VALIDATION: { name: 'STALE_VALIDATION' },
    },
    za = {
        EMPTY_POOLS_ENGINE_DEFAULT: { name: 'EMPTY_POOLS_ENGINE_DEFAULT' },
        MARSHALLER_ERROR: { name: 'MARSHALLER_ERROR' },
        SYNTHETIC_CONTEXT: { name: 'SYNTHETIC_CONTEXT' },
        UNIT_DROPPED_NULL_TYPE: { name: 'UNIT_DROPPED_NULL_TYPE' },
        UNIT_UNMARSHALLABLE_STATION: { name: 'UNIT_UNMARSHALLABLE_STATION' },
    },
    qa = { CANDIDATE_ERROR: { name: 'CANDIDATE_ERROR' }, UNITS_CHANGED: { name: 'UNITS_CHANGED' } },
    $a = {
        DIVERGED: { name: 'DIVERGED' },
        MATCHED: { name: 'MATCHED' },
        QUEUED: { name: 'QUEUED' },
        SKIPPED: { name: 'SKIPPED' },
    },
    EO = {
        NO_INPUT: { name: 'NO_INPUT' },
        STORED_NOT_COMPARABLE: { name: 'STORED_NOT_COMPARABLE' },
        UNPARSEABLE_BASELINE: { name: 'UNPARSEABLE_BASELINE' },
        UNPARSEABLE_INPUT: { name: 'UNPARSEABLE_INPUT' },
    },
    _O = {
        DIVERGED: { name: 'DIVERGED' },
        MATCHED: { name: 'MATCHED' },
        NOT_COMPARABLE: { name: 'NOT_COMPARABLE' },
        NO_LEGACY_TWIN: { name: 'NO_LEGACY_TWIN' },
    },
    TO = {
        ERRORED: { name: 'ERRORED', value: 4 },
        FAILED: { name: 'FAILED', value: 3 },
        PASSED: { name: 'PASSED', value: 2 },
        RUNNING: { name: 'RUNNING', value: 1 },
    },
    eO = {
        ERRORED: { name: 'ERRORED' },
        FAILED: { name: 'FAILED' },
        PASSED: { name: 'PASSED' },
        RUNNING: { name: 'RUNNING' },
    },
    AO = {
        _01: { name: '_01' },
        _02: { name: '_02' },
        _03: { name: '_03' },
        _04: { name: '_04' },
        _05: { name: '_05' },
        _06: { name: '_06' },
        _07: { name: '_07' },
        _08: { name: '_08' },
        _09: { name: '_09' },
        _10: { name: '_10' },
        _11: { name: '_11' },
        _12: { name: '_12' },
        _13: { name: '_13' },
        _14: { name: '_14' },
        _15: { name: '_15' },
        _16: { name: '_16' },
        _17: { name: '_17' },
        _18: { name: '_18' },
        _19: { name: '_19' },
        _20: { name: '_20' },
        _21: { name: '_21' },
        _22: { name: '_22' },
        _23: { name: '_23' },
        _24: { name: '_24' },
        _25: { name: '_25' },
        _26: { name: '_26' },
        _27: { name: '_27' },
        _28: { name: '_28' },
        _29: { name: '_29' },
        _30: { name: '_30' },
        _31: { name: '_31' },
        _32: { name: '_32' },
        _33: { name: '_33' },
        _34: { name: '_34' },
        _35: { name: '_35' },
        _36: { name: '_36' },
        _37: { name: '_37' },
        _38: { name: '_38' },
        _39: { name: '_39' },
        _41: { name: '_41' },
        _42: { name: '_42' },
        _43: { name: '_43' },
        _44: { name: '_44' },
        _45: { name: '_45' },
        _46: { name: '_46' },
        _47: { name: '_47' },
        _48: { name: '_48' },
        _49: { name: '_49' },
        _59: { name: '_59' },
        _64: { name: '_64' },
        _65: { name: '_65' },
        _66: { name: '_66' },
        _67: { name: '_67' },
        _68: { name: '_68' },
        _69: { name: '_69' },
        _70: { name: '_70' },
        _71: { name: '_71' },
        _72: { name: '_72' },
        _73: { name: '_73' },
        _74: { name: '_74' },
        _75: { name: '_75' },
        _76: { name: '_76' },
        _77: { name: '_77' },
        _78: { name: '_78' },
        _79: { name: '_79' },
        _80: { name: '_80' },
        _88: { name: '_88' },
        _99: { name: '_99' },
    },
    NO = {
        LOOKUP: { name: 'LOOKUP', value: 2 },
        STATIC: { name: 'STATIC', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    IO = {
        FIRE: { name: 'FIRE', value: 2 },
        MEDICAL: { name: 'MEDICAL', value: 4 },
        POLICE: { name: 'POLICE', value: 1 },
    },
    RO = {
        CLASSIC: { name: 'CLASSIC', value: 3 },
        COMFORTABLE: { name: 'COMFORTABLE', value: 2 },
        COMPACT: { name: 'COMPACT', value: 1 },
    },
    aO = {
        REGULAR_ASCENDING: { name: 'REGULAR_ASCENDING', value: 1 },
        REGULAR_DESCENDING: { name: 'REGULAR_DESCENDING', value: 2 },
        UNIT_PILL_DEFAULT_ASCENDING: { name: 'UNIT_PILL_DEFAULT_ASCENDING', value: 3 },
        UNIT_PILL_DEFAULT_DESCENDING: { name: 'UNIT_PILL_DEFAULT_DESCENDING', value: 4 },
        UNIT_PILL_DISTRICT_ASCENDING: { name: 'UNIT_PILL_DISTRICT_ASCENDING', value: 5 },
        UNIT_PILL_DISTRICT_DESCENDING: { name: 'UNIT_PILL_DISTRICT_DESCENDING', value: 6 },
        UNIT_PILL_STATUS_ASCENDING: { name: 'UNIT_PILL_STATUS_ASCENDING', value: 7 },
        UNIT_PILL_STATUS_DESCENDING: { name: 'UNIT_PILL_STATUS_DESCENDING', value: 8 },
        UNIT_PILL_TIME_ASCENDING: { name: 'UNIT_PILL_TIME_ASCENDING', value: 9 },
        UNIT_PILL_TIME_DESCENDING: { name: 'UNIT_PILL_TIME_DESCENDING', value: 10 },
    },
    OO = { INTERNAL: { name: 'INTERNAL', value: 2 }, SUMMARY: { name: 'SUMMARY', value: 1 } },
    SO = { ACTIVE: { name: 'ACTIVE', value: 1 }, DEACTIVATED: { name: 'DEACTIVATED', value: 2 } },
    CO = { AGNOSTIC: { name: 'AGNOSTIC', value: 2 }, AWARE: { name: 'AWARE', value: 1 } },
    nO = {
        ADDITIONAL_INFO_CREATED: { name: 'ADDITIONAL_INFO_CREATED', value: 1 },
        ADDITIONAL_INFO_DELETED: { name: 'ADDITIONAL_INFO_DELETED', value: 2 },
        BOLO_NOTIFICATION: { name: 'BOLO_NOTIFICATION', value: 6 },
        EXTERNAL_AGENCY_ACTION_INSERTED: { name: 'EXTERNAL_AGENCY_ACTION_INSERTED', value: 4 },
        EXTERNAL_AGENCY_ACTION_TIMEOUT: { name: 'EXTERNAL_AGENCY_ACTION_TIMEOUT', value: 5 },
        EXTERNAL_CAD_ONLINE_STATUS_UPDATED: {
            name: 'EXTERNAL_CAD_ONLINE_STATUS_UPDATED',
            value: 13,
        },
        GEOFENCE: { name: 'GEOFENCE', value: 7 },
        GEOFENCE_RULE_NUDGE: { name: 'GEOFENCE_RULE_NUDGE', value: 12 },
        GEOFENCE_STYLE: { name: 'GEOFENCE_STYLE', value: 9 },
        GEOMARKER: { name: 'GEOMARKER', value: 8 },
        GEOMARKER_STYLE: { name: 'GEOMARKER_STYLE', value: 10 },
        LINKED_ADDITIONAL_INFO_CREATED: { name: 'LINKED_ADDITIONAL_INFO_CREATED', value: 14 },
        NOTIFICATION_NUDGE: { name: 'NOTIFICATION_NUDGE', value: 15 },
        PROQA_EVENT_LINK_UPSERTED: { name: 'PROQA_EVENT_LINK_UPSERTED', value: 3 },
        UNIT_SHIFT_UPDATED: { name: 'UNIT_SHIFT_UPDATED', value: 11 },
    },
    DO = { AT_DECLARED: { name: 'AT_DECLARED' }, LEFT_TO_RECONCILE: { name: 'LEFT_TO_RECONCILE' } },
    LO = { HASH: { name: 'HASH' }, LABELED: { name: 'LABELED' } },
    mO = {
        ACK_ALL: { name: 'ACK_ALL', value: 1 },
        ACK_ONLY_SUCCESS: { name: 'ACK_ONLY_SUCCESS', value: 2 },
        TEST_NO_ACK: { name: 'TEST_NO_ACK', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    lO = { PUBSUB: { name: 'PUBSUB' } },
    uO = {
        HIGH_LIMIT: { name: 'HIGH_LIMIT', value: 64 },
        LOW_LIMIT: { name: 'LOW_LIMIT', value: 100 },
        MEDIUM_LIMIT: { name: 'MEDIUM_LIMIT', value: 16 },
        TEST_LIMIT_5: { name: 'TEST_LIMIT_5', value: 5 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    PO = {
        FORM_ADMIN_ALERT_SCHEDULE: { name: 'FORM_ADMIN_ALERT_SCHEDULE', value: 29 },
        FORM_ADMIN_BUSINESS_TYPE: { name: 'FORM_ADMIN_BUSINESS_TYPE', value: 155 },
        FORM_ADMIN_DISCLAIMER_MESSAGES: { name: 'FORM_ADMIN_DISCLAIMER_MESSAGES', value: 122 },
        FORM_ADMIN_EXPORT_PRESET: { name: 'FORM_ADMIN_EXPORT_PRESET', value: 97 },
        FORM_ADMIN_E_FILE_CONDITIONAL_WORDING_CONFIGURATION: {
            name: 'FORM_ADMIN_E_FILE_CONDITIONAL_WORDING_CONFIGURATION',
            value: 154,
        },
        FORM_ADMIN_E_FILE_DOCUMENT_CONFIGURATION: {
            name: 'FORM_ADMIN_E_FILE_DOCUMENT_CONFIGURATION',
            value: 132,
        },
        FORM_ADMIN_NARRATIVE_GUIDE: { name: 'FORM_ADMIN_NARRATIVE_GUIDE', value: 84 },
        FORM_ADMIN_REPORT_DEFINITION: { name: 'FORM_ADMIN_REPORT_DEFINITION', value: 59 },
        FORM_ADMIN_STATION_ADDRESS: { name: 'FORM_ADMIN_STATION_ADDRESS', value: 172 },
        FORM_ARREST: { name: 'FORM_ARREST', value: 12 },
        FORM_ARREST_CHARGES_FIND_WARRANT_SEARCH_SIDE_PANEL: {
            name: 'FORM_ARREST_CHARGES_FIND_WARRANT_SEARCH_SIDE_PANEL',
            value: 93,
        },
        FORM_ARREST_CHARGES_LEGACY_OFFENSE_SIDE_PANEL: {
            name: 'FORM_ARREST_CHARGES_LEGACY_OFFENSE_SIDE_PANEL',
            value: 92,
        },
        FORM_ARREST_CHARGES_N_CHARGES_SIDE_PANEL: {
            name: 'FORM_ARREST_CHARGES_N_CHARGES_SIDE_PANEL',
            value: 89,
        },
        FORM_ARREST_CHARGES_PRIOR_OFFENSE_SEARCH_SIDE_PANEL: {
            name: 'FORM_ARREST_CHARGES_PRIOR_OFFENSE_SEARCH_SIDE_PANEL',
            value: 90,
        },
        FORM_ARREST_CHARGES_STUB_OFFENSE_SIDE_PANEL: {
            name: 'FORM_ARREST_CHARGES_STUB_OFFENSE_SIDE_PANEL',
            value: 91,
        },
        FORM_ASN_ID_FORMAT_CONFIGURATION: { name: 'FORM_ASN_ID_FORMAT_CONFIGURATION', value: 157 },
        FORM_ASSOCIATED_E_FILE_SIDE_PANEL: {
            name: 'FORM_ASSOCIATED_E_FILE_SIDE_PANEL',
            value: 125,
        },
        FORM_ATTACHMENTS: { name: 'FORM_ATTACHMENTS', value: 162 },
        FORM_BEHAVIORAL_CRISIS: { name: 'FORM_BEHAVIORAL_CRISIS', value: 28 },
        FORM_BOOKING: { name: 'FORM_BOOKING', value: 14 },
        FORM_BOOKING_JMS: { name: 'FORM_BOOKING_JMS', value: 171 },
        FORM_BOOKING_SIDE_PANEL: { name: 'FORM_BOOKING_SIDE_PANEL', value: 35 },
        FORM_BRIEFING_ROUTING_MODAL: { name: 'FORM_BRIEFING_ROUTING_MODAL', value: 112 },
        FORM_BULK_MANAGE_CASES_SIDE_PANEL: { name: 'FORM_BULK_MANAGE_CASES_SIDE_PANEL', value: 77 },
        FORM_CASE_CHANGE_REN: { name: 'FORM_CASE_CHANGE_REN', value: 23 },
        FORM_CASE_CREATE_CASE: { name: 'FORM_CASE_CREATE_CASE', value: 21 },
        FORM_CASE_PROFILE_LINK_SIDE_PANEL: {
            name: 'FORM_CASE_PROFILE_LINK_SIDE_PANEL',
            value: 115,
        },
        FORM_CHARGES: { name: 'FORM_CHARGES', value: 27 },
        FORM_CHARGE_VACATING: { name: 'FORM_CHARGE_VACATING', value: 32 },
        FORM_CITATION: { name: 'FORM_CITATION', value: 9 },
        FORM_COMMUNITY_INFO: { name: 'FORM_COMMUNITY_INFO', value: 33 },
        FORM_CONSORTIUM_PROFILE: { name: 'FORM_CONSORTIUM_PROFILE', value: 38 },
        FORM_COURT_CASE: { name: 'FORM_COURT_CASE', value: 10 },
        FORM_COURT_HEARING_FINDINGS_RESULTS_MODAL_JMS: {
            name: 'FORM_COURT_HEARING_FINDINGS_RESULTS_MODAL_JMS',
            value: 161,
        },
        FORM_COURT_HEARING_FINDINGS_RESULTS_MODAL_RMS: {
            name: 'FORM_COURT_HEARING_FINDINGS_RESULTS_MODAL_RMS',
            value: 160,
        },
        FORM_COURT_ORDER_EDIT: { name: 'FORM_COURT_ORDER_EDIT', value: 31 },
        FORM_CRASH_EVENT_INFO: { name: 'FORM_CRASH_EVENT_INFO', value: 119 },
        FORM_CRASH_LOCATION_INFO: { name: 'FORM_CRASH_LOCATION_INFO', value: 120 },
        FORM_CREATE_CHAIN_EVENT_TYPE: { name: 'FORM_CREATE_CHAIN_EVENT_TYPE', value: 78 },
        FORM_CREATE_EXPORT_RELEASE: { name: 'FORM_CREATE_EXPORT_RELEASE', value: 8 },
        FORM_CREATE_MANAGE_CASE: { name: 'FORM_CREATE_MANAGE_CASE', value: 76 },
        FORM_CREATE_WARRANT_STUB_SIDE_PANEL: {
            name: 'FORM_CREATE_WARRANT_STUB_SIDE_PANEL',
            value: 43,
        },
        FORM_DELETE_CHAIN_EVENT: { name: 'FORM_DELETE_CHAIN_EVENT', value: 66 },
        FORM_DELETE_EVIDENCE_ITEM: { name: 'FORM_DELETE_EVIDENCE_ITEM', value: 62 },
        FORM_DETENTION_DISPOSITION: { name: 'FORM_DETENTION_DISPOSITION', value: 116 },
        FORM_ENTITY_PERMISSION: { name: 'FORM_ENTITY_PERMISSION', value: 61 },
        FORM_EVENT_INFO: { name: 'FORM_EVENT_INFO', value: 3 },
        FORM_EVIDENCE_DISPOSITION_HOLD: { name: 'FORM_EVIDENCE_DISPOSITION_HOLD', value: 70 },
        FORM_EVIDENCE_DISPOSITION_PRIMARY_APPROVAL_FOR_DISPOSITION: {
            name: 'FORM_EVIDENCE_DISPOSITION_PRIMARY_APPROVAL_FOR_DISPOSITION',
            value: 69,
        },
        FORM_EVIDENCE_DISPOSITION_PRIMARY_APPROVAL_FOR_RELEASE: {
            name: 'FORM_EVIDENCE_DISPOSITION_PRIMARY_APPROVAL_FOR_RELEASE',
            value: 68,
        },
        FORM_EVIDENCE_DISPOSITION_REQUEST: { name: 'FORM_EVIDENCE_DISPOSITION_REQUEST', value: 73 },
        FORM_EVIDENCE_DISPOSITION_SECONDARY_APPROVAL: {
            name: 'FORM_EVIDENCE_DISPOSITION_SECONDARY_APPROVAL',
            value: 71,
        },
        FORM_EVIDENCE_DISPOSITION_SECONDARY_REJECTION: {
            name: 'FORM_EVIDENCE_DISPOSITION_SECONDARY_REJECTION',
            value: 72,
        },
        FORM_EVIDENCE_LOCATION_ENTITY_PERMISSION: {
            name: 'FORM_EVIDENCE_LOCATION_ENTITY_PERMISSION',
            value: 104,
        },
        FORM_EVIDENCE_RESET_RETENTION_POLICY: {
            name: 'FORM_EVIDENCE_RESET_RETENTION_POLICY',
            value: 74,
        },
        FORM_EXTERNAL_LINK: { name: 'FORM_EXTERNAL_LINK', value: 82 },
        FORM_EXTERNAL_OFFICER: { name: 'FORM_EXTERNAL_OFFICER', value: 174 },
        FORM_E_FILE_ADD_DEFENDANT_SIDE_PANEL: {
            name: 'FORM_E_FILE_ADD_DEFENDANT_SIDE_PANEL',
            value: 130,
        },
        FORM_E_FILE_ADD_EDIT_OFFICER_SIDE_PANEL: {
            name: 'FORM_E_FILE_ADD_EDIT_OFFICER_SIDE_PANEL',
            value: 126,
        },
        FORM_E_FILE_BAIL_EXTENSION: { name: 'FORM_E_FILE_BAIL_EXTENSION', value: 176 },
        FORM_E_FILE_DETAILS_MODAL: { name: 'FORM_E_FILE_DETAILS_MODAL', value: 110 },
        FORM_E_FILE_DETAILS_MODAL_FROM_REPORT: {
            name: 'FORM_E_FILE_DETAILS_MODAL_FROM_REPORT',
            value: 175,
        },
        FORM_E_FILE_DETAILS_MODAL_JMS: { name: 'FORM_E_FILE_DETAILS_MODAL_JMS', value: 131 },
        FORM_E_FILE_DOCUMENT_MODAL: { name: 'FORM_E_FILE_DOCUMENT_MODAL', value: 163 },
        FORM_E_FILE_MATERIAL_DETAILS: { name: 'FORM_E_FILE_MATERIAL_DETAILS', value: 166 },
        FORM_E_FILE_OFFENSE_JMS_CANNABIS_WARNING: {
            name: 'FORM_E_FILE_OFFENSE_JMS_CANNABIS_WARNING',
            value: 143,
        },
        FORM_E_FILE_OFFENSE_JMS_CAUTION: { name: 'FORM_E_FILE_OFFENSE_JMS_CAUTION', value: 137 },
        FORM_E_FILE_OFFENSE_JMS_CHARGE: { name: 'FORM_E_FILE_OFFENSE_JMS_CHARGE', value: 135 },
        FORM_E_FILE_OFFENSE_JMS_CONDITIONAL_CAUTION: {
            name: 'FORM_E_FILE_OFFENSE_JMS_CONDITIONAL_CAUTION',
            value: 139,
        },
        FORM_E_FILE_OFFENSE_JMS_FIXED_PENALTY: {
            name: 'FORM_E_FILE_OFFENSE_JMS_FIXED_PENALTY',
            value: 145,
        },
        FORM_E_FILE_OFFENSE_JMS_JOINT_CHARGE: {
            name: 'FORM_E_FILE_OFFENSE_JMS_JOINT_CHARGE',
            value: 153,
        },
        FORM_E_FILE_OFFENSE_JMS_NFA: { name: 'FORM_E_FILE_OFFENSE_JMS_NFA', value: 141 },
        FORM_E_FILE_OFFENSE_JMS_POLICE_BAIL: {
            name: 'FORM_E_FILE_OFFENSE_JMS_POLICE_BAIL',
            value: 149,
        },
        FORM_E_FILE_OFFENSE_JMS_RELEASE_WITHOUT_BAIL: {
            name: 'FORM_E_FILE_OFFENSE_JMS_RELEASE_WITHOUT_BAIL',
            value: 133,
        },
        FORM_E_FILE_OFFENSE_JMS_SIDE_PANEL: {
            name: 'FORM_E_FILE_OFFENSE_JMS_SIDE_PANEL',
            value: 129,
        },
        FORM_E_FILE_OFFENSE_JMS_TIC: { name: 'FORM_E_FILE_OFFENSE_JMS_TIC', value: 151 },
        FORM_E_FILE_OFFENSE_RMS_CANNABIS_WARNING: {
            name: 'FORM_E_FILE_OFFENSE_RMS_CANNABIS_WARNING',
            value: 142,
        },
        FORM_E_FILE_OFFENSE_RMS_CAUTION: { name: 'FORM_E_FILE_OFFENSE_RMS_CAUTION', value: 136 },
        FORM_E_FILE_OFFENSE_RMS_CHARGE: { name: 'FORM_E_FILE_OFFENSE_RMS_CHARGE', value: 134 },
        FORM_E_FILE_OFFENSE_RMS_CONDITIONAL_CAUTION: {
            name: 'FORM_E_FILE_OFFENSE_RMS_CONDITIONAL_CAUTION',
            value: 138,
        },
        FORM_E_FILE_OFFENSE_RMS_FIXED_PENALTY: {
            name: 'FORM_E_FILE_OFFENSE_RMS_FIXED_PENALTY',
            value: 144,
        },
        FORM_E_FILE_OFFENSE_RMS_JOINT_CHARGE: {
            name: 'FORM_E_FILE_OFFENSE_RMS_JOINT_CHARGE',
            value: 152,
        },
        FORM_E_FILE_OFFENSE_RMS_NFA: { name: 'FORM_E_FILE_OFFENSE_RMS_NFA', value: 140 },
        FORM_E_FILE_OFFENSE_RMS_POSTAL_CHARGE: {
            name: 'FORM_E_FILE_OFFENSE_RMS_POSTAL_CHARGE',
            value: 146,
        },
        FORM_E_FILE_OFFENSE_RMS_POSTAL_REQUISITION: {
            name: 'FORM_E_FILE_OFFENSE_RMS_POSTAL_REQUISITION',
            value: 147,
        },
        FORM_E_FILE_OFFENSE_RMS_PROCESS: { name: 'FORM_E_FILE_OFFENSE_RMS_PROCESS', value: 148 },
        FORM_E_FILE_OFFENSE_RMS_SIDE_PANEL: {
            name: 'FORM_E_FILE_OFFENSE_RMS_SIDE_PANEL',
            value: 128,
        },
        FORM_E_FILE_OFFENSE_RMS_TIC: { name: 'FORM_E_FILE_OFFENSE_RMS_TIC', value: 150 },
        FORM_E_FILE_OFFICER_DETAILS: { name: 'FORM_E_FILE_OFFICER_DETAILS', value: 170 },
        FORM_E_FILE_ORGANIZATION_DEFENDANT_DETAILS: {
            name: 'FORM_E_FILE_ORGANIZATION_DEFENDANT_DETAILS',
            value: 169,
        },
        FORM_E_FILE_PERSON_DEFENDANT_DETAILS: {
            name: 'FORM_E_FILE_PERSON_DEFENDANT_DETAILS',
            value: 168,
        },
        FORM_E_FILE_REMOVE_DEACTIVATE_ENTITY: {
            name: 'FORM_E_FILE_REMOVE_DEACTIVATE_ENTITY',
            value: 123,
        },
        FORM_E_FILE_SUMMARY_CARD: { name: 'FORM_E_FILE_SUMMARY_CARD', value: 127 },
        FORM_E_FILE_UPDATE_DETAILS_MODAL: { name: 'FORM_E_FILE_UPDATE_DETAILS_MODAL', value: 156 },
        FORM_E_FILE_VARY_JMS_COURT_BAIL: { name: 'FORM_E_FILE_VARY_JMS_COURT_BAIL', value: 165 },
        FORM_E_FILE_VARY_JMS_POLICE_BAIL: { name: 'FORM_E_FILE_VARY_JMS_POLICE_BAIL', value: 164 },
        FORM_E_FILE_VICTIM_WITNESS_DETAILS: {
            name: 'FORM_E_FILE_VICTIM_WITNESS_DETAILS',
            value: 167,
        },
        FORM_FIELD_CONTACT: { name: 'FORM_FIELD_CONTACT', value: 18 },
        FORM_GANG_UNIT_SIDE_PANEL: { name: 'FORM_GANG_UNIT_SIDE_PANEL', value: 37 },
        FORM_HYDRATED_ITEM: { name: 'FORM_HYDRATED_ITEM', value: 30 },
        FORM_ID_FORMAT_CONFIGURATION: { name: 'FORM_ID_FORMAT_CONFIGURATION', value: 41 },
        FORM_INCIDENT: { name: 'FORM_INCIDENT', value: 20 },
        FORM_INVOLVED_PROFILES: { name: 'FORM_INVOLVED_PROFILES', value: 15 },
        FORM_LOCATION_COORDINATES_SIDE_PANEL: {
            name: 'FORM_LOCATION_COORDINATES_SIDE_PANEL',
            value: 63,
        },
        FORM_LOCATION_ENTITY_LINK_SIDE_PANEL: {
            name: 'FORM_LOCATION_ENTITY_LINK_SIDE_PANEL',
            value: 60,
        },
        FORM_LOCATION_SIDE_PANEL: { name: 'FORM_LOCATION_SIDE_PANEL', value: 42 },
        FORM_MISSING_PERSONS: { name: 'FORM_MISSING_PERSONS', value: 87 },
        FORM_NARRATIVE: { name: 'FORM_NARRATIVE', value: 26 },
        FORM_OFFENSE: { name: 'FORM_OFFENSE', value: 19 },
        FORM_ORGANIZATION_SIDE_PANEL: { name: 'FORM_ORGANIZATION_SIDE_PANEL', value: 65 },
        FORM_PERSON_CITATION_RECIPIENT: { name: 'FORM_PERSON_CITATION_RECIPIENT', value: 56 },
        FORM_PERSON_COMPLAINANT: { name: 'FORM_PERSON_COMPLAINANT', value: 55 },
        FORM_PERSON_CO_DEFENDANT: { name: 'FORM_PERSON_CO_DEFENDANT', value: 53 },
        FORM_PERSON_DEFENDANT: { name: 'FORM_PERSON_DEFENDANT', value: 54 },
        FORM_PERSON_GANG_TRACKING: { name: 'FORM_PERSON_GANG_TRACKING', value: 34 },
        FORM_PERSON_LAST_KNOWN_CONTACT: { name: 'FORM_PERSON_LAST_KNOWN_CONTACT', value: 47 },
        FORM_PERSON_MISSING_PERSON: { name: 'FORM_PERSON_MISSING_PERSON', value: 46 },
        FORM_PERSON_NAME: { name: 'FORM_PERSON_NAME', value: 45 },
        FORM_PERSON_OFFENDER: { name: 'FORM_PERSON_OFFENDER', value: 113 },
        FORM_PERSON_OTHER: { name: 'FORM_PERSON_OTHER', value: 57 },
        FORM_PERSON_REPORTING_PARTY: { name: 'FORM_PERSON_REPORTING_PARTY', value: 49 },
        FORM_PERSON_STOP_SUBJECT: { name: 'FORM_PERSON_STOP_SUBJECT', value: 101 },
        FORM_PERSON_SUBJECT: { name: 'FORM_PERSON_SUBJECT', value: 48 },
        FORM_PERSON_SUSPECT: { name: 'FORM_PERSON_SUSPECT', value: 52 },
        FORM_PERSON_VICTIM: { name: 'FORM_PERSON_VICTIM', value: 51 },
        FORM_PERSON_WITNESS: { name: 'FORM_PERSON_WITNESS', value: 50 },
        FORM_PHOTO_LINEUPS_PHOTO_UPLOAD: { name: 'FORM_PHOTO_LINEUPS_PHOTO_UPLOAD', value: 105 },
        FORM_REASON_FOR_RELATION_MODAL: { name: 'FORM_REASON_FOR_RELATION_MODAL', value: 107 },
        FORM_REASON_FOR_RELATION_SIDE_PANEL: {
            name: 'FORM_REASON_FOR_RELATION_SIDE_PANEL',
            value: 108,
        },
        FORM_REASON_FOR_REMOVAL_MODAL: { name: 'FORM_REASON_FOR_REMOVAL_MODAL', value: 109 },
        FORM_REASON_FOR_UPDATE_MODAL: { name: 'FORM_REASON_FOR_UPDATE_MODAL', value: 173 },
        FORM_RELATIONSHIPS: { name: 'FORM_RELATIONSHIPS', value: 94 },
        FORM_REPORT_ASSOCIATED_RECORD: { name: 'FORM_REPORT_ASSOCIATED_RECORD', value: 25 },
        FORM_REPORT_CASE_STATUSES_SIDE_PANEL: {
            name: 'FORM_REPORT_CASE_STATUSES_SIDE_PANEL',
            value: 100,
        },
        FORM_REPORT_COMMENT: { name: 'FORM_REPORT_COMMENT', value: 81 },
        FORM_REPORT_CREATE_REPORT: { name: 'FORM_REPORT_CREATE_REPORT', value: 44 },
        FORM_REPORT_LEGACY_METADATA: { name: 'FORM_REPORT_LEGACY_METADATA', value: 111 },
        FORM_REPORT_SEALING: { name: 'FORM_REPORT_SEALING', value: 24 },
        FORM_REPORT_SUBMISSION: { name: 'FORM_REPORT_SUBMISSION', value: 85 },
        FORM_SCHEDULE_COURT_HEARING_MODAL_JMS: {
            name: 'FORM_SCHEDULE_COURT_HEARING_MODAL_JMS',
            value: 159,
        },
        FORM_SCHEDULE_COURT_HEARING_MODAL_RMS: {
            name: 'FORM_SCHEDULE_COURT_HEARING_MODAL_RMS',
            value: 158,
        },
        FORM_SECURITY_CLASSIFICATION_MODAL: {
            name: 'FORM_SECURITY_CLASSIFICATION_MODAL',
            value: 121,
        },
        FORM_SHARED_SAVED_SEARCH_PERMISSION: {
            name: 'FORM_SHARED_SAVED_SEARCH_PERMISSION',
            value: 103,
        },
        FORM_STOP: { name: 'FORM_STOP', value: 96 },
        FORM_STUB_OFFENSE_INCIDENT: { name: 'FORM_STUB_OFFENSE_INCIDENT', value: 88 },
        FORM_SUMMARY_NARRATIVE: { name: 'FORM_SUMMARY_NARRATIVE', value: 95 },
        FORM_SUPPLEMENT_INFO: { name: 'FORM_SUPPLEMENT_INFO', value: 13 },
        FORM_SUPPORT_PARTNERSHIP_REAL_TIME_ACTION: {
            name: 'FORM_SUPPORT_PARTNERSHIP_REAL_TIME_ACTION',
            value: 102,
        },
        FORM_TASK: { name: 'FORM_TASK', value: 83 },
        FORM_TOW_VEHICLE: { name: 'FORM_TOW_VEHICLE', value: 1 },
        FORM_TOW_VEHICLE_CHECK_IN: { name: 'FORM_TOW_VEHICLE_CHECK_IN', value: 4 },
        FORM_TOW_VEHICLE_IMPOUND: { name: 'FORM_TOW_VEHICLE_IMPOUND', value: 5 },
        FORM_TOW_VEHICLE_RELEASE: { name: 'FORM_TOW_VEHICLE_RELEASE', value: 2 },
        FORM_TRAFFIC_CRASH: { name: 'FORM_TRAFFIC_CRASH', value: 16 },
        FORM_UPDATE_CHAIN_EVENT: { name: 'FORM_UPDATE_CHAIN_EVENT', value: 67 },
        FORM_USE_OF_FORCE: { name: 'FORM_USE_OF_FORCE', value: 58 },
        FORM_USE_OF_FORCE_SUBJECT: { name: 'FORM_USE_OF_FORCE_SUBJECT', value: 75 },
        FORM_VULNERABLE_PERSON: { name: 'FORM_VULNERABLE_PERSON', value: 106 },
        FORM_WARRANT_ACTIVITY: { name: 'FORM_WARRANT_ACTIVITY', value: 36 },
        FORM_WARRANT_CHANGE_WARRANT_NUMBER: {
            name: 'FORM_WARRANT_CHANGE_WARRANT_NUMBER',
            value: 7,
        },
        FORM_WARRANT_CHARGES: { name: 'FORM_WARRANT_CHARGES', value: 39 },
        FORM_WARRANT_CREATE_WARRANT: { name: 'FORM_WARRANT_CREATE_WARRANT', value: 6 },
        FORM_WARRANT_DETAILS: { name: 'FORM_WARRANT_DETAILS', value: 17 },
        FORM_WARRANT_DEX_SUBMISSION: { name: 'FORM_WARRANT_DEX_SUBMISSION', value: 40 },
        FORM_WARRANT_ID_FORMAT_CONFIGURATION: {
            name: 'FORM_WARRANT_ID_FORMAT_CONFIGURATION',
            value: 98,
        },
        FORM_WILL_NOT_INVESTIGATE: { name: 'FORM_WILL_NOT_INVESTIGATE', value: 80 },
        IMPOUND: { name: 'IMPOUND', value: 11 },
        OFFENSE_CODE: { name: 'OFFENSE_CODE', value: 99 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    UO = {
        ALABAMA: { name: 'ALABAMA' },
        ALASKA: { name: 'ALASKA' },
        ALBERTA: { name: 'ALBERTA' },
        ARIZONA: { name: 'ARIZONA' },
        ARKANSAS: { name: 'ARKANSAS' },
        BRITISH_COLUMBIA: { name: 'BRITISH_COLUMBIA' },
        CALIFORNIA: { name: 'CALIFORNIA' },
        COLORADO: { name: 'COLORADO' },
        CONNECTICUT: { name: 'CONNECTICUT' },
        DELAWARE: { name: 'DELAWARE' },
        FLORIDA: { name: 'FLORIDA' },
        GEORGIA: { name: 'GEORGIA' },
        HAWAII: { name: 'HAWAII' },
        IDAHO: { name: 'IDAHO' },
        ILLINOIS: { name: 'ILLINOIS' },
        INDIANA: { name: 'INDIANA' },
        IOWA: { name: 'IOWA' },
        KANSAS: { name: 'KANSAS' },
        KENTUCKY: { name: 'KENTUCKY' },
        LOUISIANA: { name: 'LOUISIANA' },
        MAINE: { name: 'MAINE' },
        MANITOBA: { name: 'MANITOBA' },
        MARYLAND: { name: 'MARYLAND' },
        MASSACHUSETTS: { name: 'MASSACHUSETTS' },
        MICHIGAN: { name: 'MICHIGAN' },
        MINNESOTA: { name: 'MINNESOTA' },
        MISSISSIPPI: { name: 'MISSISSIPPI' },
        MISSOURI: { name: 'MISSOURI' },
        MONTANA: { name: 'MONTANA' },
        NEBRASKA: { name: 'NEBRASKA' },
        NEVADA: { name: 'NEVADA' },
        NEWFOUNDLAND_LABRADOR: { name: 'NEWFOUNDLAND_LABRADOR' },
        NEW_BRUNSWICK: { name: 'NEW_BRUNSWICK' },
        NEW_HAMPSHIRE: { name: 'NEW_HAMPSHIRE' },
        NEW_JERSEY: { name: 'NEW_JERSEY' },
        NEW_MEXICO: { name: 'NEW_MEXICO' },
        NEW_YORK: { name: 'NEW_YORK' },
        NORTHWEST_TERRITORIES: { name: 'NORTHWEST_TERRITORIES' },
        NORTH_CAROLINA: { name: 'NORTH_CAROLINA' },
        NORTH_DAKOTA: { name: 'NORTH_DAKOTA' },
        NOVA_SCOTIA: { name: 'NOVA_SCOTIA' },
        NUNAVUT: { name: 'NUNAVUT' },
        OHIO: { name: 'OHIO' },
        OKLAHOMA: { name: 'OKLAHOMA' },
        ONTARIO: { name: 'ONTARIO' },
        OREGON: { name: 'OREGON' },
        PENNSYLVANIA: { name: 'PENNSYLVANIA' },
        PRINCE_EDWARD: { name: 'PRINCE_EDWARD' },
        QUEBEC: { name: 'QUEBEC' },
        RHODE_ISLAND: { name: 'RHODE_ISLAND' },
        SASKATCHEWAN: { name: 'SASKATCHEWAN' },
        SOUTH_CAROLINA: { name: 'SOUTH_CAROLINA' },
        SOUTH_DAKOTA: { name: 'SOUTH_DAKOTA' },
        TENNESSEE: { name: 'TENNESSEE' },
        TEXAS: { name: 'TEXAS' },
        UTAH: { name: 'UTAH' },
        VERMONT: { name: 'VERMONT' },
        VIRGINIA: { name: 'VIRGINIA' },
        WASHINGTON: { name: 'WASHINGTON' },
        WEST_VIRGINIA: { name: 'WEST_VIRGINIA' },
        WISCONSIN: { name: 'WISCONSIN' },
        WYOMING: { name: 'WYOMING' },
        YUKON: { name: 'YUKON' },
    },
    MO = {
        ARIZONA_NIBRS: { name: 'ARIZONA_NIBRS', value: 16384 },
        CALIFORNIA_JSON_NIBRS: { name: 'CALIFORNIA_JSON_NIBRS', value: 262144 },
        CALIFORNIA_NIBRS: { name: 'CALIFORNIA_NIBRS', value: 256 },
        CA_UCR: { name: 'CA_UCR', value: 4 },
        FEDERAL_NIBRS: { name: 'FEDERAL_NIBRS', value: 1 },
        FEDERAL_TRIBAL_NIBRS: { name: 'FEDERAL_TRIBAL_NIBRS', value: 4194304 },
        FLORIDA_NIBRS: { name: 'FLORIDA_NIBRS', value: 4096 },
        FL_UCR: { name: 'FL_UCR', value: 32 },
        GEORGIA_NIBRS: { name: 'GEORGIA_NIBRS', value: 8192 },
        HAWAII_NIBRS: { name: 'HAWAII_NIBRS', value: 2097152 },
        ILLINOIS_NIBRS: { name: 'ILLINOIS_NIBRS', value: 524288 },
        LOUISIANA_NIBRS: { name: 'LOUISIANA_NIBRS', value: 128 },
        MARYLAND_NIBRS: { name: 'MARYLAND_NIBRS', value: 1024 },
        MASSACHUSETTS_NIBRS: { name: 'MASSACHUSETTS_NIBRS', value: 16 },
        NEW_JERSEY_NIBRS: { name: 'NEW_JERSEY_NIBRS', value: 32768 },
        NEW_MEXICO_NIBRS: { name: 'NEW_MEXICO_NIBRS', value: 2048 },
        NEW_YORK_NIBRS: { name: 'NEW_YORK_NIBRS', value: 65536 },
        NJ_UCR: { name: 'NJ_UCR', value: 8 },
        NOT_APPLICABLE: { name: 'NOT_APPLICABLE', value: 0 },
        OHIO_NIBRS: { name: 'OHIO_NIBRS', value: 131072 },
        PENNSYLVANIA_NIBRS: { name: 'PENNSYLVANIA_NIBRS', value: 512 },
        SOUTH_CAROLINA_NIBRS: { name: 'SOUTH_CAROLINA_NIBRS', value: 8388608 },
        TENNESSEE_NIBRS: { name: 'TENNESSEE_NIBRS', value: 1048576 },
        TEXAS_NIBRS: { name: 'TEXAS_NIBRS', value: 64 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VIRGINIA_NIBRS: { name: 'VIRGINIA_NIBRS', value: 16777216 },
        WASHINGTON_NIBRS: { name: 'WASHINGTON_NIBRS', value: 2 },
    },
    vO = {
        ORGANIZATION: { name: 'ORGANIZATION', value: 'ORGANIZATION' },
        PERSON_PROFILE: { name: 'PERSON_PROFILE', value: 'PERSON_PROFILE' },
    },
    FO = {
        AQ: { name: 'AQ' },
        BE: { name: 'BE' },
        BG: { name: 'BG' },
        CF: { name: 'CF' },
        CH: { name: 'CH' },
        CO: { name: 'CO' },
        CS: { name: 'CS' },
        CT: { name: 'CT' },
        DR: { name: 'DR' },
        EE: { name: 'EE' },
        ER: { name: 'ER' },
        EX: { name: 'EX' },
        FC: { name: 'FC' },
        FP: { name: 'FP' },
        FR: { name: 'FR' },
        GC: { name: 'GC' },
        GP: { name: 'GP' },
        IL: { name: 'IL' },
        LI: { name: 'LI' },
        NE: { name: 'NE' },
        OF: { name: 'OF' },
        OK: { name: 'OK' },
        PA: { name: 'PA' },
        RM: { name: 'RM' },
        RU: { name: 'RU' },
        SA: { name: 'SA' },
        SB: { name: 'SB' },
        SC: { name: 'SC' },
        SE: { name: 'SE' },
        SP: { name: 'SP' },
        SS: { name: 'SS' },
        ST: { name: 'ST' },
        VO: { name: 'VO' },
        XC: { name: 'XC' },
        XD: { name: 'XD' },
        XL: { name: 'XL' },
        XR: { name: 'XR' },
        XS: { name: 'XS' },
    },
    GO = {
        NONE: { name: 'NONE', value: 1 },
        OPTIONAL: { name: 'OPTIONAL', value: 2 },
        REQUIRED: { name: 'REQUIRED', value: 3 },
    },
    HO = {
        SIDEBAR: { name: 'SIDEBAR', value: 2 },
        TITLE_BAR: { name: 'TITLE_BAR', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    YO = { BADGE_NUMBER: { name: 'BADGE_NUMBER' }, HR_ID: { name: 'HR_ID' } },
    tO = { INLINE: { name: 'INLINE', value: 2 }, REGULAR: { name: 'REGULAR', value: 1 } },
    VO = {
        AFTER_FIRST_APPROVAL: { name: 'AFTER_FIRST_APPROVAL', value: 2 },
        AFTER_FIRST_SUBMISSION: { name: 'AFTER_FIRST_SUBMISSION', value: 1 },
        ALWAYS: { name: 'ALWAYS', value: 3 },
        NEVER: { name: 'NEVER', value: 4 },
    },
    oO = {
        ARREST_NUMBER_NAME_OF_ARRESTEE: { name: 'ARREST_NUMBER_NAME_OF_ARRESTEE', value: 12 },
        CITATION_NUMBER: { name: 'CITATION_NUMBER', value: 6 },
        CITATION_NUMBER_NAME_OF_SUBJECT: { name: 'CITATION_NUMBER_NAME_OF_SUBJECT', value: 14 },
        DEFAULT_REPORT_TYPE_NAME: { name: 'DEFAULT_REPORT_TYPE_NAME', value: 1 },
        FIELD_CONTACT_NUMBER: { name: 'FIELD_CONTACT_NUMBER', value: 13 },
        MAKE_MODEL_YEAR_TAG: { name: 'MAKE_MODEL_YEAR_TAG', value: 9 },
        NAME_OF_ARRESTEE_STATUTE_TOP_OFFENSE: {
            name: 'NAME_OF_ARRESTEE_STATUTE_TOP_OFFENSE',
            value: 4,
        },
        NAME_OF_FIRST_SUBJECT: { name: 'NAME_OF_FIRST_SUBJECT', value: 8 },
        NAME_OF_SUBJECT: { name: 'NAME_OF_SUBJECT', value: 5 },
        OFFENSE_DISPLAY_NAME: { name: 'OFFENSE_DISPLAY_NAME', value: 2 },
        OFFICER_NAME_BADGE: { name: 'OFFICER_NAME_BADGE', value: 11 },
        RECORD_ID: { name: 'RECORD_ID', value: 7 },
        SUPPLEMENT_DESCRIPTION: { name: 'SUPPLEMENT_DESCRIPTION', value: 10 },
        SUPPLEMENT_TYPE: { name: 'SUPPLEMENT_TYPE', value: 3 },
    },
    BO = {
        CLIP: { name: 'CLIP', value: 'CLIP' },
        FILL: { name: 'FILL', value: 'FILL' },
        FIT: { name: 'FIT', value: 'FIT' },
        PAD: { name: 'PAD', value: 'PAD' },
    },
    rO = {
        EITHER: { name: 'EITHER' },
        GROUP: { name: 'GROUP' },
        PRIORITY_SET: { name: 'PRIORITY_SET' },
        RESOURCE_TYPE: { name: 'RESOURCE_TYPE' },
    },
    sO = {
        LINE: { name: 'LINE', value: 2 },
        POINT: { name: 'POINT', value: 1 },
        POLYGON: { name: 'POLYGON', value: 3 },
    },
    iO = {
        RESP_PLAN_VALIDATION_ERROR_BAD_BEAT: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_BEAT',
            value: 18,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_COLUMNS: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_COLUMNS',
            value: 4,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_FORMAT: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_FORMAT',
            value: 1,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_STATION: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_STATION',
            value: 13,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_SUBDIVISION_MAPPING: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_SUBDIVISION_MAPPING',
            value: 6,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_MU: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_MU',
            value: 17,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_RC: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_RC',
            value: 3,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_RP: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_TEMPLATE_RP',
            value: 2,
        },
        RESP_PLAN_VALIDATION_ERROR_BAD_UNIT: {
            name: 'RESP_PLAN_VALIDATION_ERROR_BAD_UNIT',
            value: 12,
        },
        RESP_PLAN_VALIDATION_ERROR_DATETIME_ORDER: {
            name: 'RESP_PLAN_VALIDATION_ERROR_DATETIME_ORDER',
            value: 10,
        },
        RESP_PLAN_VALIDATION_ERROR_DUPE_STRING_IN_ORDER: {
            name: 'RESP_PLAN_VALIDATION_ERROR_DUPE_STRING_IN_ORDER',
            value: 11,
        },
        RESP_PLAN_VALIDATION_ERROR_DUPE_TERM: {
            name: 'RESP_PLAN_VALIDATION_ERROR_DUPE_TERM',
            value: 16,
        },
        RESP_PLAN_VALIDATION_ERROR_DUPLICATE_CRITERIA: {
            name: 'RESP_PLAN_VALIDATION_ERROR_DUPLICATE_CRITERIA',
            value: 7,
        },
        RESP_PLAN_VALIDATION_ERROR_FULL_LIST_FILE_ID: {
            name: 'RESP_PLAN_VALIDATION_ERROR_FULL_LIST_FILE_ID',
            value: 2147483647,
        },
        RESP_PLAN_VALIDATION_ERROR_INVALID_INPUT: {
            name: 'RESP_PLAN_VALIDATION_ERROR_INVALID_INPUT',
            value: 8,
        },
        RESP_PLAN_VALIDATION_ERROR_INVALID_SYMBOL: {
            name: 'RESP_PLAN_VALIDATION_ERROR_INVALID_SYMBOL',
            value: 15,
        },
        RESP_PLAN_VALIDATION_ERROR_MISSING_REQUIRED_FIELD: {
            name: 'RESP_PLAN_VALIDATION_ERROR_MISSING_REQUIRED_FIELD',
            value: 5,
        },
        RESP_PLAN_VALIDATION_ERROR_TOO_MANY: {
            name: 'RESP_PLAN_VALIDATION_ERROR_TOO_MANY',
            value: 9,
        },
    },
    WO = {
        MOVE_UPS_CSV: { name: 'MOVE_UPS_CSV', value: 5 },
        MOVE_UPS_XML: { name: 'MOVE_UPS_XML', value: 6 },
        RESOURCE_PATTERN_CSV: { name: 'RESOURCE_PATTERN_CSV', value: 3 },
        RESOURCE_PATTERN_XML: { name: 'RESOURCE_PATTERN_XML', value: 1 },
        RUN_CARD_CSV: { name: 'RUN_CARD_CSV', value: 4 },
        RUN_CARD_XML: { name: 'RUN_CARD_XML', value: 2 },
    },
    cO = {
        AGENCY_NODE: { name: 'AGENCY_NODE', value: 3 },
        ALARM_LEVEL_NODE: { name: 'ALARM_LEVEL_NODE', value: 4 },
        CALL_FOR_SERVICE_NODE: { name: 'CALL_FOR_SERVICE_NODE', value: 5 },
        DAY_OF_THE_WEEK_NODE: { name: 'DAY_OF_THE_WEEK_NODE', value: 6 },
        DEPARTMENT_NODE: { name: 'DEPARTMENT_NODE', value: 7 },
        DISPATCH_AREA_NODE: { name: 'DISPATCH_AREA_NODE', value: 8 },
        MOVE_UPS_MULTIPATH_NODE: { name: 'MOVE_UPS_MULTIPATH_NODE', value: 21 },
        MOVE_UPS_NODE: { name: 'MOVE_UPS_NODE', value: 20 },
        MULTIPATH_NODE: { name: 'MULTIPATH_NODE', value: 17 },
        PRIORITY_LEVEL_NODE: { name: 'PRIORITY_LEVEL_NODE', value: 22 },
        RESOURCE_PATTERN_MULTIPATH_NODE: { name: 'RESOURCE_PATTERN_MULTIPATH_NODE', value: 18 },
        RESOURCE_PATTERN_NODE: { name: 'RESOURCE_PATTERN_NODE', value: 1 },
        RUN_CARD_MULTIPATH_NODE: { name: 'RUN_CARD_MULTIPATH_NODE', value: 19 },
        RUN_CARD_NODE: { name: 'RUN_CARD_NODE', value: 2 },
        SUBDIVISION_DEPTH_1_NODE: { name: 'SUBDIVISION_DEPTH_1_NODE', value: 11 },
        SUBDIVISION_DEPTH_2_NODE: { name: 'SUBDIVISION_DEPTH_2_NODE', value: 12 },
        SUBDIVISION_DEPTH_3_NODE: { name: 'SUBDIVISION_DEPTH_3_NODE', value: 13 },
        SUBDIVISION_DEPTH_4_NODE: { name: 'SUBDIVISION_DEPTH_4_NODE', value: 14 },
        SUBDIVISION_DEPTH_5_NODE: { name: 'SUBDIVISION_DEPTH_5_NODE', value: 15 },
        SUBDIVISION_NODE: { name: 'SUBDIVISION_NODE', value: 9 },
        TIME_OF_DAY_NODE: { name: 'TIME_OF_DAY_NODE', value: 16 },
        TIME_RANGE_NODE: { name: 'TIME_RANGE_NODE', value: 10 },
    },
    KO = {
        RESP_PLAN_REQUEST_ACTION_CRITERIA_CHANGE: {
            name: 'RESP_PLAN_REQUEST_ACTION_CRITERIA_CHANGE',
            value: 3,
        },
        RESP_PLAN_REQUEST_ACTION_PRIORITY_LEVEL: {
            name: 'RESP_PLAN_REQUEST_ACTION_PRIORITY_LEVEL',
            value: 4,
        },
        RESP_PLAN_REQUEST_ACTION_RAISE_ALARM_LEVEL: {
            name: 'RESP_PLAN_REQUEST_ACTION_RAISE_ALARM_LEVEL',
            value: 2,
        },
        RESP_PLAN_REQUEST_ACTION_REASON_DISPATCH: {
            name: 'RESP_PLAN_REQUEST_ACTION_REASON_DISPATCH',
            value: 1,
        },
    },
    dO = { JAVA: { name: 'JAVA' }, PROLOG: { name: 'PROLOG' } },
    pO = { LAST_RELEASED: { name: 'LAST_RELEASED', value: 1 } },
    yO = {
        MOVE_UPS: { name: 'MOVE_UPS' },
        RESOURCE_PATTERN: { name: 'RESOURCE_PATTERN' },
        RUN_CARD: { name: 'RUN_CARD' },
    },
    XO = { NO_ABILITY_FILTER: { name: 'NO_ABILITY_FILTER' }, SKIP: { name: 'SKIP' } },
    QO = {
        EXPORTED: { name: 'EXPORTED', value: 2 },
        QUEUED: { name: 'QUEUED', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    bO = {
        DETAIL: { name: 'DETAIL' },
        RECOVERED: { name: 'RECOVERED' },
        SUMMARY: { name: 'SUMMARY' },
    },
    fO = {
        JEDIS_CONNECTION: { name: 'JEDIS_CONNECTION' },
        JEDIS_POOL_EXHAUSTED: { name: 'JEDIS_POOL_EXHAUSTED' },
    },
    gO = { NORMAL: { name: 'NORMAL', value: 1 }, URGENT: { name: 'URGENT', value: 2 } },
    JO = {
        ADDITIONAL_PARTICIPANT: { name: 'ADDITIONAL_PARTICIPANT', value: 8 },
        ASSISTANCE_REQUEST: { name: 'ASSISTANCE_REQUEST', value: 1 },
        ERROR: { name: 'ERROR', value: 11 },
        EVENT_MERGE: { name: 'EVENT_MERGE', value: 12 },
        EVENT_STATUS_UPDATE: { name: 'EVENT_STATUS_UPDATE', value: 7 },
        HEALTH_CHECK: { name: 'HEALTH_CHECK', value: 9 },
        NARRATIVE_UPDATE: { name: 'NARRATIVE_UPDATE', value: 3 },
        OPERATIONAL_ACCEPTANCE: { name: 'OPERATIONAL_ACCEPTANCE', value: 2 },
        READ_RECEIPT: { name: 'READ_RECEIPT', value: 4 },
        SYSTEM_ACKNOWLEDGEMENT: { name: 'SYSTEM_ACKNOWLEDGEMENT', value: 10 },
        UNIT_STATUS_QUERY: { name: 'UNIT_STATUS_QUERY', value: 6 },
        UNIT_STATUS_UPDATE: { name: 'UNIT_STATUS_UPDATE', value: 5 },
    },
    hO = {
        COMMUNICATION_ISSUE: { name: 'COMMUNICATION_ISSUE' },
        EVENT_IS_CLOSED: { name: 'EVENT_IS_CLOSED' },
        INVALID_MESSAGE: { name: 'INVALID_MESSAGE' },
        OPERATIONAL_ACCEPTANCE_TIMED_OUT: { name: 'OPERATIONAL_ACCEPTANCE_TIMED_OUT' },
        UNKNOWN: { name: 'UNKNOWN' },
        UNKNOWN_EVENT: { name: 'UNKNOWN_EVENT' },
        UNKNOWN_MESSAGE_TYPE: { name: 'UNKNOWN_MESSAGE_TYPE' },
        UNRECOGNISED_AGENCY: { name: 'UNRECOGNISED_AGENCY' },
    },
    ZO = {
        CANCELLED: { name: 'CANCELLED', value: 2 },
        CREATED: { name: 'CREATED', value: 1 },
        TRIGGERED: { name: 'TRIGGERED', value: 3 },
    },
    jO = {
        CREATOR: { name: 'CREATOR', value: 5 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 4 },
        INTEGRATION: { name: 'INTEGRATION', value: 8 },
        INTEGRATION_TEST: { name: 'INTEGRATION_TEST', value: 10 },
        JOB: { name: 'JOB', value: 7 },
        NORMAL: { name: 'NORMAL', value: 1 },
        SUPER_USER: { name: 'SUPER_USER', value: 3 },
        SUPPORT: { name: 'SUPPORT', value: 9 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USER: { name: 'USER', value: 2 },
    },
    xO = {
        DIVERGE: { name: 'DIVERGE' },
        MATCH: { name: 'MATCH' },
        NO_BUFFER_MINUTES: { name: 'NO_BUFFER_MINUTES' },
        NO_EVENT_TIMERS: { name: 'NO_EVENT_TIMERS' },
    },
    kO = {
        BORROW_TIMEOUT: { name: 'BORROW_TIMEOUT' },
        CONNECTION_REFUSED: { name: 'CONNECTION_REFUSED' },
        CONNECTION_RESET: { name: 'CONNECTION_RESET' },
        OTHER: { name: 'OTHER' },
        POOL_EXHAUSTED: { name: 'POOL_EXHAUSTED' },
        SOCKET_TIMEOUT: { name: 'SOCKET_TIMEOUT' },
        UNEXPECTED_END_OF_STREAM: { name: 'UNEXPECTED_END_OF_STREAM' },
    },
    wO = {
        ACCEPT: { name: 'ACCEPT', value: 'accept' },
        DECLINE: { name: 'DECLINE', value: 'decline' },
        PROVIDER_CANCEL: { name: 'PROVIDER_CANCEL', value: 'provider_cancel' },
        SKIP: { name: 'SKIP', value: 'skip' },
        UNAVAILABLE: { name: 'UNAVAILABLE', value: 'unavailable' },
        USER_CANCEL: { name: 'USER_CANCEL', value: 'user_cancel' },
    },
    zO = {
        BOTH_DRIVING: { name: 'BOTH_DRIVING', value: 'both_driving' },
        KAFKA_DRIVING: { name: 'KAFKA_DRIVING', value: 'kafka_driving' },
        REDIS_DRIVING: { name: 'REDIS_DRIVING', value: 'redis_driving' },
    },
    qO = { KAFKA: { name: 'KAFKA' }, REDIS: { name: 'REDIS' } },
    $O = {
        AND: { name: 'AND', value: 1 },
        CAND: { name: 'CAND', value: 5 },
        IMPLIES: { name: 'IMPLIES', value: 4 },
        OR: { name: 'OR', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        XOR: { name: 'XOR', value: 3 },
    },
    ES = {
        DOES_NOT_INTERSECT: { name: 'DOES_NOT_INTERSECT', value: 10 },
        DOES_NOT_MATCH_REGEXP: { name: 'DOES_NOT_MATCH_REGEXP', value: 12 },
        INTERSECTS: { name: 'INTERSECTS', value: 9 },
        IS_CONTAINED_IN: { name: 'IS_CONTAINED_IN', value: 13 },
        IS_EMPTY: { name: 'IS_EMPTY', value: 1 },
        IS_EQUAL_TO: { name: 'IS_EQUAL_TO', value: 3 },
        IS_GREATER_THAN: { name: 'IS_GREATER_THAN', value: 5 },
        IS_GREATER_THAN_OR_EQUAL_TO: { name: 'IS_GREATER_THAN_OR_EQUAL_TO', value: 6 },
        IS_LESS_THAN: { name: 'IS_LESS_THAN', value: 7 },
        IS_LESS_THAN_OR_EQUAL_TO: { name: 'IS_LESS_THAN_OR_EQUAL_TO', value: 8 },
        IS_NOT_CONTAINED_IN: { name: 'IS_NOT_CONTAINED_IN', value: 14 },
        IS_NOT_EMPTY: { name: 'IS_NOT_EMPTY', value: 2 },
        IS_NOT_EQUAL_TO: { name: 'IS_NOT_EQUAL_TO', value: 4 },
        MATCHES_REGEXP: { name: 'MATCHES_REGEXP', value: 11 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    _S = {
        ATTRIBUTE_TYPE: { name: 'ATTRIBUTE_TYPE', value: 5 },
        BOOLEAN: { name: 'BOOLEAN', value: 6 },
        DATA: { name: 'DATA', value: 1 },
        ENTITY_TYPE_ID: { name: 'ENTITY_TYPE_ID', value: 2 },
        JSON: { name: 'JSON', value: 7 },
        PROPERTY_NAME: { name: 'PROPERTY_NAME', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VALUE_TYPE: { name: 'VALUE_TYPE', value: 4 },
    },
    TS = {
        GET_ATTRIBUTES_ARE_NONE: { name: 'GET_ATTRIBUTES_ARE_NONE', value: 9 },
        GET_ATTRIBUTES_ARE_OTHER: { name: 'GET_ATTRIBUTES_ARE_OTHER', value: 11 },
        GET_ATTRIBUTE_IS_NONE: { name: 'GET_ATTRIBUTE_IS_NONE', value: 7 },
        GET_ATTRIBUTE_IS_OTHER: { name: 'GET_ATTRIBUTE_IS_OTHER', value: 2 },
        GET_CHARGE_OFFENSE_CODE_ID_MATCHES_LINKED_OFFENSE_OFFENSE_CODE_ID: {
            name: 'GET_CHARGE_OFFENSE_CODE_ID_MATCHES_LINKED_OFFENSE_OFFENSE_CODE_ID',
            value: 35,
        },
        GET_CHILD_ATTRIBUTE_COUNT: { name: 'GET_CHILD_ATTRIBUTE_COUNT', value: 6 },
        GET_CODE_CODE: { name: 'GET_CODE_CODE', value: 20 },
        GET_CODE_FOR_ATTRIBUTE_IDS_AND_SOURCE: {
            name: 'GET_CODE_FOR_ATTRIBUTE_IDS_AND_SOURCE',
            value: 25,
        },
        GET_CODE_FOR_ATTRIBUTE_ID_AND_SOURCE: {
            name: 'GET_CODE_FOR_ATTRIBUTE_ID_AND_SOURCE',
            value: 19,
        },
        GET_COUNT: { name: 'GET_COUNT', value: 3 },
        GET_COUNT_DISTINCT: { name: 'GET_COUNT_DISTINCT', value: 4 },
        GET_COUNT_NAME_REPORT_LINKS_IN_OFFENSE_WHERE: {
            name: 'GET_COUNT_NAME_REPORT_LINKS_IN_OFFENSE_WHERE',
            value: 37,
        },
        GET_COUNT_OFFENSE_CODES_REQUIRES_ADDITIONAL_CRIME_CHARGE: {
            name: 'GET_COUNT_OFFENSE_CODES_REQUIRES_ADDITIONAL_CRIME_CHARGE',
            value: 27,
        },
        GET_COUNT_WITH_VALUE: { name: 'GET_COUNT_WITH_VALUE', value: 23 },
        GET_CURRENT_USER_HAS_ABILITY: { name: 'GET_CURRENT_USER_HAS_ABILITY', value: 50 },
        GET_DATA_FROM_LINKED_ENTITIES_MATCHES_VALUE: {
            name: 'GET_DATA_FROM_LINKED_ENTITIES_MATCHES_VALUE',
            value: 47,
        },
        GET_DATA_FROM_PERSON_PROFILE_MATCHES_VALUE: {
            name: 'GET_DATA_FROM_PERSON_PROFILE_MATCHES_VALUE',
            value: 49,
        },
        GET_DECIMAL_COUNT: { name: 'GET_DECIMAL_COUNT', value: 5 },
        GET_ENTITY_PROPERTY_VALUE: { name: 'GET_ENTITY_PROPERTY_VALUE', value: 52 },
        GET_EVIDENCE_DEPARTMENT_CONFIG: { name: 'GET_EVIDENCE_DEPARTMENT_CONFIG', value: 24 },
        GET_IS_AGE_INVALID_FOR_OFFENSE_CODE: {
            name: 'GET_IS_AGE_INVALID_FOR_OFFENSE_CODE',
            value: 45,
        },
        GET_IS_BEFORE_RIPA_CUTOVER_DATE: { name: 'GET_IS_BEFORE_RIPA_CUTOVER_DATE', value: 43 },
        GET_IS_DATE_WITHIN_FUTURE_RANGE: { name: 'GET_IS_DATE_WITHIN_FUTURE_RANGE', value: 42 },
        GET_MATHEMATICAL_OPERATION_RESULT: { name: 'GET_MATHEMATICAL_OPERATION_RESULT', value: 53 },
        GET_NIBRS_CODE_CRIME_AGAINST: { name: 'GET_NIBRS_CODE_CRIME_AGAINST', value: 16 },
        GET_NIBRS_CODE_FLAGS: { name: 'GET_NIBRS_CODE_FLAGS', value: 14 },
        GET_NIBRS_CODE_GROUP: { name: 'GET_NIBRS_CODE_GROUP', value: 17 },
        GET_OFFENDER_IS_UNKNOWN_WITH_NOT_UNKNOWN_RELATIONSHIP: {
            name: 'GET_OFFENDER_IS_UNKNOWN_WITH_NOT_UNKNOWN_RELATIONSHIP',
            value: 32,
        },
        GET_OFFENSE_CODE_FLAG: { name: 'GET_OFFENSE_CODE_FLAG', value: 26 },
        GET_OFFENSE_CODE_PROPERTY_VALUE: { name: 'GET_OFFENSE_CODE_PROPERTY_VALUE', value: 48 },
        GET_OFFENSE_HAS_LESS_THAN_OR_EQUAL_RECOVERED_PROPERTY_VALUE_THAN_STOLEN: {
            name: 'GET_OFFENSE_HAS_LESS_THAN_OR_EQUAL_RECOVERED_PROPERTY_VALUE_THAN_STOLEN',
            value: 31,
        },
        GET_OFFENSE_HAS_LESS_THAN_OR_EQUAL_RECOVERED_VEHICLES_THAN_STOLEN: {
            name: 'GET_OFFENSE_HAS_LESS_THAN_OR_EQUAL_RECOVERED_VEHICLES_THAN_STOLEN',
            value: 30,
        },
        GET_OFFENSE_HAS_VICTIM: { name: 'GET_OFFENSE_HAS_VICTIM', value: 13 },
        GET_OFFENSE_VICTIM_HAS_UNKNOWN_SEX: {
            name: 'GET_OFFENSE_VICTIM_HAS_UNKNOWN_SEX',
            value: 12,
        },
        GET_PARENT_ATTRIBUTE_ID: { name: 'GET_PARENT_ATTRIBUTE_ID', value: 1 },
        GET_PARENT_ATTRIBUTE_IDS: { name: 'GET_PARENT_ATTRIBUTE_IDS', value: 8 },
        GET_PERSON_PROFILE_IN_OFFENSE_WHERE: {
            name: 'GET_PERSON_PROFILE_IN_OFFENSE_WHERE',
            value: 36,
        },
        GET_PERSON_PROFILE_IS_DEAD: { name: 'GET_PERSON_PROFILE_IS_DEAD', value: 29 },
        GET_PERSON_PROFILE_NUMBER_OF_PHYSICAL_CHARACTERISTICS_ENTERED: {
            name: 'GET_PERSON_PROFILE_NUMBER_OF_PHYSICAL_CHARACTERISTICS_ENTERED',
            value: 39,
        },
        GET_PRODUCT_MODULE_IS_ACTIVE: { name: 'GET_PRODUCT_MODULE_IS_ACTIVE', value: 22 },
        GET_RELEVANT_RELATIONSHIP_EXISTS_IN_EACH_DOMESTIC_VIOLENCE_OFFENSE: {
            name: 'GET_RELEVANT_RELATIONSHIP_EXISTS_IN_EACH_DOMESTIC_VIOLENCE_OFFENSE',
            value: 38,
        },
        GET_REPORT_HAS_ARREST_CARD: { name: 'GET_REPORT_HAS_ARREST_CARD', value: 28 },
        GET_REPORT_HAS_MULTIPLE_OFFENSES: { name: 'GET_REPORT_HAS_MULTIPLE_OFFENSES', value: 33 },
        GET_SUSPECT_IS_OFFENDER: { name: 'GET_SUSPECT_IS_OFFENDER', value: 44 },
        GET_SUSPECT_IS_UNKNOWN: { name: 'GET_SUSPECT_IS_UNKNOWN', value: 51 },
        GET_UNBORN_PERSON_PROFILE_REQUIRES_PARENT_RELATIONSHIP: {
            name: 'GET_UNBORN_PERSON_PROFILE_REQUIRES_PARENT_RELATIONSHIP',
            value: 40,
        },
        GET_VICTIM_HAS_VALID_DOMESTIC_VIOLENCE_RELATIONSHIP: {
            name: 'GET_VICTIM_HAS_VALID_DOMESTIC_VIOLENCE_RELATIONSHIP',
            value: 46,
        },
        GET_VICTIM_IS_SUSPECT: { name: 'GET_VICTIM_IS_SUSPECT', value: 34 },
        GET_VULNERABLE_PERSON_PROFILE_REQUIRES_PARENT_OR_GUARDIAN_RELATIONSHIP: {
            name: 'GET_VULNERABLE_PERSON_PROFILE_REQUIRES_PARENT_OR_GUARDIAN_RELATIONSHIP',
            value: 41,
        },
        RETURN_ARGS: { name: 'RETURN_ARGS', value: 18 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    eS = {
        CONDITIONAL: { name: 'CONDITIONAL', value: 3 },
        HIDE: { name: 'HIDE', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        VALIDATION: { name: 'VALIDATION', value: 2 },
    },
    AS = {
        BEAT: { name: 'BEAT' },
        NONE: { name: 'NONE' },
        STATION: { name: 'STATION' },
        UNIT: { name: 'UNIT' },
    },
    NS = {
        BEAT: { name: 'BEAT' },
        CLOSEST_UNIT: { name: 'CLOSEST_UNIT' },
        EITHER: { name: 'EITHER' },
        GROUP: { name: 'GROUP' },
        NONE: { name: 'NONE' },
        PRIORITY_SET: { name: 'PRIORITY_SET' },
        STATION: { name: 'STATION' },
        UNIT: { name: 'UNIT' },
    },
    IS = {
        DAILY: { name: 'DAILY', value: 'DAILY' },
        HOURLY: { name: 'HOURLY', value: 'HOURLY' },
        NONE: { name: 'NONE', value: 'NONE' },
    },
    RS = {
        CANCELED: { name: 'CANCELED', value: 'CANCELED' },
        COMPLETED: { name: 'COMPLETED', value: 'COMPLETED' },
    },
    aS = {
        BAIL_APPOINTMENT: { name: 'BAIL_APPOINTMENT' },
        VOLUNTARY_ATTENDANCE_APPOINTMENT: { name: 'VOLUNTARY_ATTENDANCE_APPOINTMENT' },
    },
    OS = { DISPLAY_NAME: { name: 'DISPLAY_NAME' }, MEMBERS: { name: 'MEMBERS' } },
    SS = {
        GROUP: { name: 'GROUP' },
        LIST_RESPONSE: { name: 'LIST_RESPONSE' },
        MARK43_USER_EXTENSION: { name: 'MARK43_USER_EXTENSION' },
        RESOURCE_TYPE: { name: 'RESOURCE_TYPE' },
        SCHEMA: { name: 'SCHEMA' },
        SERVICE_PROVIDER_CONFIG: { name: 'SERVICE_PROVIDER_CONFIG' },
        USER: { name: 'USER' },
    },
    CS = {
        ACTING_RANK_DISPLAY_NAME: { name: 'ACTING_RANK_DISPLAY_NAME' },
        ACTIVE: { name: 'ACTIVE' },
        AGENCY_CODE: { name: 'AGENCY_CODE' },
        AGENCY_NAME: { name: 'AGENCY_NAME' },
        AGENCY_ORI: { name: 'AGENCY_ORI' },
        BADGE_NUMBER: { name: 'BADGE_NUMBER' },
        BRANCH_DISPLAY_NAME: { name: 'BRANCH_DISPLAY_NAME' },
        BUILD_DISPLAY_NAME: { name: 'BUILD_DISPLAY_NAME' },
        BUREAU_DISPLAY_NAME: { name: 'BUREAU_DISPLAY_NAME' },
        CITY_ID_NUMBER: { name: 'CITY_ID_NUMBER' },
        DATE_DEX_CERTIFICATION_EXPIRES: { name: 'DATE_DEX_CERTIFICATION_EXPIRES' },
        DATE_OF_BIRTH: { name: 'DATE_OF_BIRTH' },
        DATE_OF_HIRED: { name: 'DATE_OF_HIRED' },
        DEFAULT_ARRESTING_AGENCY_DISPLAY_NAME: { name: 'DEFAULT_ARRESTING_AGENCY_DISPLAY_NAME' },
        DEX_STATE_USER_ID: { name: 'DEX_STATE_USER_ID' },
        DIVISION_DISPLAY_NAME: { name: 'DIVISION_DISPLAY_NAME' },
        DRIVERS_LICENSE: { name: 'DRIVERS_LICENSE' },
        DRIVERS_LICENSE_TYPE_DISPLAY_NAME: { name: 'DRIVERS_LICENSE_TYPE_DISPLAY_NAME' },
        EDUCATION_LEVEL_DISPLAY_NAME: { name: 'EDUCATION_LEVEL_DISPLAY_NAME' },
        EMERGENCY_CONTACT_ADDRESS: { name: 'EMERGENCY_CONTACT_ADDRESS' },
        EMERGENCY_CONTACT_EMAIL: { name: 'EMERGENCY_CONTACT_EMAIL' },
        EMERGENCY_CONTACT_NAME: { name: 'EMERGENCY_CONTACT_NAME' },
        EMERGENCY_CONTACT_PHONE: { name: 'EMERGENCY_CONTACT_PHONE' },
        EMPLOYEE_TYPE_DISPLAY_NAME: { name: 'EMPLOYEE_TYPE_DISPLAY_NAME' },
        EMPLOYMENT_TYPE_DISPLAY_NAME: { name: 'EMPLOYMENT_TYPE_DISPLAY_NAME' },
        END_DATE_UTC: { name: 'END_DATE_UTC' },
        EXTERNAL_CAD_ID: { name: 'EXTERNAL_CAD_ID' },
        EXTERNAL_HR_ID: { name: 'EXTERNAL_HR_ID' },
        EXTERNAL_ID: { name: 'EXTERNAL_ID' },
        EYE_COLOR_DISPLAY_NAME: { name: 'EYE_COLOR_DISPLAY_NAME' },
        FIRST_NAME: { name: 'FIRST_NAME' },
        HAIR_COLOR_DISPLAY_NAME: { name: 'HAIR_COLOR_DISPLAY_NAME' },
        HEIGHT: { name: 'HEIGHT' },
        IS_DETAIL: { name: 'IS_DETAIL' },
        IS_SSO_USER: { name: 'IS_SSO_USER' },
        LAST_NAME: { name: 'LAST_NAME' },
        MIDDLE_NAME: { name: 'MIDDLE_NAME' },
        MOBILE_ID: { name: 'MOBILE_ID' },
        PERSONNEL_UNIT_DISPLAY_NAME: { name: 'PERSONNEL_UNIT_DISPLAY_NAME' },
        PRIMARY_EMAIL: { name: 'PRIMARY_EMAIL' },
        PRIMARY_USER_GROUP: { name: 'PRIMARY_USER_GROUP' },
        RACE_DISPLAY_NAME: { name: 'RACE_DISPLAY_NAME' },
        RANK_DISPLAY_NAME: { name: 'RANK_DISPLAY_NAME' },
        SEX_DISPLAY_NAME: { name: 'SEX_DISPLAY_NAME' },
        SSN: { name: 'SSN' },
        START_DATE_UTC: { name: 'START_DATE_UTC' },
        STATE_ID_NUMBER: { name: 'STATE_ID_NUMBER' },
        STOP_USER_ASSIGNMENT_TYPE_DISPLAY_NAME: { name: 'STOP_USER_ASSIGNMENT_TYPE_DISPLAY_NAME' },
        STOP_USER_ASSIGNMENT_TYPE_OTHER: { name: 'STOP_USER_ASSIGNMENT_TYPE_OTHER' },
        SUBDIVISION1_DISPLAY_NAME: { name: 'SUBDIVISION1_DISPLAY_NAME' },
        SUBDIVISION2_DISPLAY_NAME: { name: 'SUBDIVISION2_DISPLAY_NAME' },
        SUBDIVISION3_DISPLAY_NAME: { name: 'SUBDIVISION3_DISPLAY_NAME' },
        SUBDIVISION4_DISPLAY_NAME: { name: 'SUBDIVISION4_DISPLAY_NAME' },
        SUBDIVISION5_DISPLAY_NAME: { name: 'SUBDIVISION5_DISPLAY_NAME' },
        SUFFIX: { name: 'SUFFIX' },
        TITLE: { name: 'TITLE' },
        TRAINING_ID_NUMBER: { name: 'TRAINING_ID_NUMBER' },
        USER_NAME: { name: 'USER_NAME' },
        WEIGHT: { name: 'WEIGHT' },
        YEARS_OF_EXPERIENCE: { name: 'YEARS_OF_EXPERIENCE' },
    },
    nS = {
        SEAL: { name: 'SEAL', value: 'seal' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unknown' },
        UNSEAL: { name: 'UNSEAL', value: 'unseal' },
    },
    DS = {
        AVAILABLE: { name: 'AVAILABLE' },
        UNAVAILABLE: { name: 'UNAVAILABLE' },
        UNKNOWN: { name: 'UNKNOWN' },
    },
    LS = {
        HIGH_PRIORITY: { name: 'HIGH_PRIORITY', value: 'HIGH_PRIORITY' },
        LOW_PRIORITY: { name: 'LOW_PRIORITY', value: 'LOW_PRIORITY' },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    mS = {
        HALT: { name: 'HALT' },
        HEALTHY: { name: 'HEALTHY' },
        THROTTLE: { name: 'THROTTLE' },
        UNKNOWN: { name: 'UNKNOWN' },
    },
    lS = {
        AUTHENTICATION_FAILED: { name: 'AUTHENTICATION_FAILED' },
        CIPHERTEXT_TOO_SHORT: { name: 'CIPHERTEXT_TOO_SHORT' },
        MASTER_KEY_UNUSABLE: { name: 'MASTER_KEY_UNUSABLE' },
        NO_CIPHERTEXT: { name: 'NO_CIPHERTEXT' },
        PLAINTEXT_TOO_LONG: { name: 'PLAINTEXT_TOO_LONG' },
    },
    uS = {
        AGGRAVATED_ASSAULT_ON_YOUNGER_11: { name: 'AGGRAVATED_ASSAULT_ON_YOUNGER_11' },
        AGGRAVATED_HARASSMENT_1: { name: 'AGGRAVATED_HARASSMENT_1' },
        AGGRAVATED_HARASSMENT_1_CROSS_FIRE: { name: 'AGGRAVATED_HARASSMENT_1_CROSS_FIRE' },
        AGGRAVATED_HARASSMENT_1_NOOSE_ON_PROP: { name: 'AGGRAVATED_HARASSMENT_1_NOOSE_ON_PROP' },
        AGGRAVATED_HARASSMENT_1_PRIOR_CONV: { name: 'AGGRAVATED_HARASSMENT_1_PRIOR_CONV' },
        AGGRAVATED_HARASSMENT_1_RELIGIOUS_PREM: { name: 'AGGRAVATED_HARASSMENT_1_RELIGIOUS_PREM' },
        AGGRAVATED_HARASSMENT_1_SWASTIKA_PROP: { name: 'AGGRAVATED_HARASSMENT_1_SWASTIKA_PROP' },
        AGG_ASSAULT_UNDER_11_HC: { name: 'AGG_ASSAULT_UNDER_11_HC' },
        AGG_HARASSMENT_2_HC: { name: 'AGG_HARASSMENT_2_HC' },
        AGG_HARASSMENT_2_HC_01: { name: 'AGG_HARASSMENT_2_HC_01' },
        AGG_HARASSMENT_2_HC_01A: { name: 'AGG_HARASSMENT_2_HC_01A' },
        AGG_HARASSMENT_2_HC_01B: { name: 'AGG_HARASSMENT_2_HC_01B' },
        AGG_HARASSMENT_2_HC_02: { name: 'AGG_HARASSMENT_2_HC_02' },
        AGG_HARASSMENT_2_HC_04: { name: 'AGG_HARASSMENT_2_HC_04' },
        AGG_SEXUAL_ABUSE_1: { name: 'AGG_SEXUAL_ABUSE_1' },
        AGG_SEXUAL_ABUSE_1_01: { name: 'AGG_SEXUAL_ABUSE_1_01' },
        AGG_SEXUAL_ABUSE_2: { name: 'AGG_SEXUAL_ABUSE_2' },
        AGG_SEXUAL_ABUSE_2_01: { name: 'AGG_SEXUAL_ABUSE_2_01' },
        ARSON_1: { name: 'ARSON_1' },
        ARSON_1_01: { name: 'ARSON_1_01' },
        ARSON_2: { name: 'ARSON_2' },
        ARSON_3: { name: 'ARSON_3' },
        ARSON_3_01: { name: 'ARSON_3_01' },
        ARSON_4: { name: 'ARSON_4' },
        ARSON_4_01: { name: 'ARSON_4_01' },
        ASSAULT_1: { name: 'ASSAULT_1' },
        ASSAULT_1_02: { name: 'ASSAULT_1_02' },
        ASSAULT_1_03: { name: 'ASSAULT_1_03' },
        ASSAULT_1_04: { name: 'ASSAULT_1_04' },
        ASSAULT_1_INJURY_WEAPON: { name: 'ASSAULT_1_INJURY_WEAPON' },
        ASSAULT_2: { name: 'ASSAULT_2' },
        ASSAULT_2_AUTH_EMPLOYEE: { name: 'ASSAULT_2_AUTH_EMPLOYEE' },
        ASSAULT_2_AUTH_EMPLOYEE_2: { name: 'ASSAULT_2_AUTH_EMPLOYEE_2' },
        ASSAULT_2_CORRECTIONAL: { name: 'ASSAULT_2_CORRECTIONAL' },
        ASSAULT_2_CORRECTIONAL_FACILITY: { name: 'ASSAULT_2_CORRECTIONAL_FACILITY' },
        ASSAULT_2_DIRECT_PATIENT_CARE: { name: 'ASSAULT_2_DIRECT_PATIENT_CARE' },
        ASSAULT_2_EMPLOYEE_SCHOOL: { name: 'ASSAULT_2_EMPLOYEE_SCHOOL' },
        ASSAULT_2_EMPLOYEE_SECURE: { name: 'ASSAULT_2_EMPLOYEE_SECURE' },
        ASSAULT_2_IMPAIR_DRUG: { name: 'ASSAULT_2_IMPAIR_DRUG' },
        ASSAULT_2_INJURY_CHILD: { name: 'ASSAULT_2_INJURY_CHILD' },
        ASSAULT_2_INJURY_CHILD_YOUNGER_11: { name: 'ASSAULT_2_INJURY_CHILD_YOUNGER_11' },
        ASSAULT_2_INJURY_CHILD_YOUNGER_7: { name: 'ASSAULT_2_INJURY_CHILD_YOUNGER_7' },
        ASSAULT_2_INJURY_INTENT: { name: 'ASSAULT_2_INJURY_INTENT' },
        ASSAULT_2_NON_PART_FEL: { name: 'ASSAULT_2_NON_PART_FEL' },
        ASSAULT_2_PATIENT_CARE_PROVIDER: { name: 'ASSAULT_2_PATIENT_CARE_PROVIDER' },
        ASSAULT_2_PERSON_UNDER_11: { name: 'ASSAULT_2_PERSON_UNDER_11' },
        ASSAULT_2_PERSON_UNDER_7: { name: 'ASSAULT_2_PERSON_UNDER_7' },
        ASSAULT_2_POLICE_FIREMAN: { name: 'ASSAULT_2_POLICE_FIREMAN' },
        ASSAULT_2_PROCESS_SERVER: { name: 'ASSAULT_2_PROCESS_SERVER' },
        ASSAULT_2_SCHOOL: { name: 'ASSAULT_2_SCHOOL' },
        ASSAULT_2_SEVERE_INJURY: { name: 'ASSAULT_2_SEVERE_INJURY' },
        ASSAULT_2_SOCIAL_SERV_EMPLOYEE: { name: 'ASSAULT_2_SOCIAL_SERV_EMPLOYEE' },
        ASSAULT_2_SOCIAL_SERV_EMPLOYEE_2: { name: 'ASSAULT_2_SOCIAL_SERV_EMPLOYEE_2' },
        ASSAULT_2_STUDENT_SCHOOL: { name: 'ASSAULT_2_STUDENT_SCHOOL' },
        ASSAULT_2_TRANSIT_EMPLOYEE: { name: 'ASSAULT_2_TRANSIT_EMPLOYEE' },
        ASSAULT_2_VIC_OVER_65_DEF_10_YOUNGER: { name: 'ASSAULT_2_VIC_OVER_65_DEF_10_YOUNGER' },
        ASSAULT_2_WITH_WEAPON: { name: 'ASSAULT_2_WITH_WEAPON' },
        ASSAULT_3: { name: 'ASSAULT_3' },
        ASSAULT_3_INJURY_INTENT: { name: 'ASSAULT_3_INJURY_INTENT' },
        ASSAULT_3_PHYSICAL_INJURY: { name: 'ASSAULT_3_PHYSICAL_INJURY' },
        ASSAULT_3_WITH_WEAPON: { name: 'ASSAULT_3_WITH_WEAPON' },
        AUTO_STRIPPING_1: { name: 'AUTO_STRIPPING_1' },
        AUTO_STRIPPING_2: { name: 'AUTO_STRIPPING_2' },
        AUTO_STRIPPING_2_1: { name: 'AUTO_STRIPPING_2_1' },
        AUTO_STRIPPING_2_2: { name: 'AUTO_STRIPPING_2_2' },
        AUTO_STRIPPING_3: { name: 'AUTO_STRIPPING_3' },
        AUTO_STRIPPING_3_1: { name: 'AUTO_STRIPPING_3_1' },
        AUTO_STRIPPING_3_2: { name: 'AUTO_STRIPPING_3_2' },
        BURGLARY_1: { name: 'BURGLARY_1' },
        BURGLARY_1_01: { name: 'BURGLARY_1_01' },
        BURGLARY_1_02: { name: 'BURGLARY_1_02' },
        BURGLARY_1_03: { name: 'BURGLARY_1_03' },
        BURGLARY_1_04: { name: 'BURGLARY_1_04' },
        BURGLARY_2: { name: 'BURGLARY_2' },
        BURGLARY_2_01: { name: 'BURGLARY_2_01' },
        BURGLARY_2_02: { name: 'BURGLARY_2_02' },
        BURGLARY_3: { name: 'BURGLARY_3' },
        COERCION_1: { name: 'COERCION_1' },
        COERCION_1_01: { name: 'COERCION_1_01' },
        COERCION_1_02: { name: 'COERCION_1_02' },
        COERCION_2: { name: 'COERCION_2' },
        COERCION_3: { name: 'COERCION_3' },
        COERCION_3_01: { name: 'COERCION_3_01' },
        COERCION_3_02: { name: 'COERCION_3_02' },
        COERCION_3_03: { name: 'COERCION_3_03' },
        COERCION_3_05: { name: 'COERCION_3_05' },
        COERCION_3_06: { name: 'COERCION_3_06' },
        COERCION_3_07: { name: 'COERCION_3_07' },
        COERCION_3_08: { name: 'COERCION_3_08' },
        COERCION_3_09: { name: 'COERCION_3_09' },
        COERCION_3_10: { name: 'COERCION_3_10' },
        COERCION_3_4: { name: 'COERCION_3_4' },
        COMPUTER_TEMPERING_1: { name: 'COMPUTER_TEMPERING_1' },
        COMPUTER_TEMPERING_3: { name: 'COMPUTER_TEMPERING_3' },
        COMPUTER_TEMPERING_3_DATA_DESTROY: { name: 'COMPUTER_TEMPERING_3_DATA_DESTROY' },
        CONSPIRACY_1_DEFENDANT_OVER_18: { name: 'CONSPIRACY_1_DEFENDANT_OVER_18' },
        CONSPIRACY_2: { name: 'CONSPIRACY_2' },
        CONSPIRACY_3_DEFENDANT_OVER_18: { name: 'CONSPIRACY_3_DEFENDANT_OVER_18' },
        CONSPIRACY_4: { name: 'CONSPIRACY_4' },
        CONSPIRACY_4_AS_HATE_CRIME: { name: 'CONSPIRACY_4_AS_HATE_CRIME' },
        CONSPIRACY_4_DEFENDANT_OVER_18: { name: 'CONSPIRACY_4_DEFENDANT_OVER_18' },
        CONSPIRACY_5_1: { name: 'CONSPIRACY_5_1' },
        CONSPIRACY_5_2: { name: 'CONSPIRACY_5_2' },
        CONSPIRACY_5_FELONY: { name: 'CONSPIRACY_5_FELONY' },
        CONSPIRACY_6: { name: 'CONSPIRACY_6' },
        CRIMINAL_MISCHIEF_1_HC: { name: 'CRIMINAL_MISCHIEF_1_HC' },
        CRIMINAL_MISCHIEF_2: { name: 'CRIMINAL_MISCHIEF_2' },
        CRIMINAL_MISCHIEF_2_HC: { name: 'CRIMINAL_MISCHIEF_2_HC' },
        CRIMINAL_MISCHIEF_3: { name: 'CRIMINAL_MISCHIEF_3' },
        CRIMINAL_MISCHIEF_3_HC: { name: 'CRIMINAL_MISCHIEF_3_HC' },
        CRIMINAL_MISCHIEF_3_HC_01: { name: 'CRIMINAL_MISCHIEF_3_HC_01' },
        CRIMINAL_MISCHIEF_3_HC_02: { name: 'CRIMINAL_MISCHIEF_3_HC_02' },
        CRIMINAL_MISCHIEF_4: { name: 'CRIMINAL_MISCHIEF_4' },
        CRIMINAL_MISCHIEF_4_HC: { name: 'CRIMINAL_MISCHIEF_4_HC' },
        CRIMINAL_MISCHIEF_4_HC_01: { name: 'CRIMINAL_MISCHIEF_4_HC_01' },
        CRIMINAL_MISCHIEF_4_HC_02: { name: 'CRIMINAL_MISCHIEF_4_HC_02' },
        CRIMINAL_MISCHIEF_4_HC_03: { name: 'CRIMINAL_MISCHIEF_4_HC_03' },
        CRIMINAL_MISCHIEF_4_HC_04: { name: 'CRIMINAL_MISCHIEF_4_HC_04' },
        CRIMINAL_MISCHIEF_4_HC_04A: { name: 'CRIMINAL_MISCHIEF_4_HC_04A' },
        CRIMINAL_MISCHIEF_4_HC_04B: { name: 'CRIMINAL_MISCHIEF_4_HC_04B' },
        CRIMINAL_POSSESSION_WEAPON_SCHOOL: { name: 'CRIMINAL_POSSESSION_WEAPON_SCHOOL' },
        CRIMINAL_POSS_COCAINE_5TH_DEGREE: { name: 'CRIMINAL_POSS_COCAINE_5TH_DEGREE' },
        CRIMINAL_POSS_DANGEROUS_DEPRESSANT_4TH_DEGREE: {
            name: 'CRIMINAL_POSS_DANGEROUS_DEPRESSANT_4TH_DEGREE',
        },
        CRIMINAL_POSS_DEPRESSANT_4TH_DEGREE: { name: 'CRIMINAL_POSS_DEPRESSANT_4TH_DEGREE' },
        CRIMINAL_POSS_HALLUCINOGEN_2ND_DEGREE: { name: 'CRIMINAL_POSS_HALLUCINOGEN_2ND_DEGREE' },
        CRIMINAL_POSS_HALLUCINOGEN_3RD_DEGREE: { name: 'CRIMINAL_POSS_HALLUCINOGEN_3RD_DEGREE' },
        CRIMINAL_POSS_HALLUCINOGEN_4TH_DEGREE: { name: 'CRIMINAL_POSS_HALLUCINOGEN_4TH_DEGREE' },
        CRIMINAL_POSS_HALLUCINOGEN_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_HALLUCINOGEN_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_2ND_DEGREE: {
            name: 'CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_2ND_DEGREE',
        },
        CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_3RD_DEGREE',
        },
        CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_4TH_DEGREE: {
            name: 'CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_4TH_DEGREE',
        },
        CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_HALLUCINOGEN_SUBSTANCE_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_POSS_LSD_2ND_DEGREE: { name: 'CRIMINAL_POSS_LSD_2ND_DEGREE' },
        CRIMINAL_POSS_LSD_3RD_DEGREE: { name: 'CRIMINAL_POSS_LSD_3RD_DEGREE' },
        CRIMINAL_POSS_LSD_4TH_DEGREE: { name: 'CRIMINAL_POSS_LSD_4TH_DEGREE' },
        CRIMINAL_POSS_LSD_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_LSD_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_POSS_METHADONE_1ST_DEGREE: { name: 'CRIMINAL_POSS_METHADONE_1ST_DEGREE' },
        CRIMINAL_POSS_METHADONE_2ND_DEGREE: { name: 'CRIMINAL_POSS_METHADONE_2ND_DEGREE' },
        CRIMINAL_POSS_METHADONE_4TH_DEGREE: { name: 'CRIMINAL_POSS_METHADONE_4TH_DEGREE' },
        CRIMINAL_POSS_METHAMPHETAMINE_2ND_DEGREE: {
            name: 'CRIMINAL_POSS_METHAMPHETAMINE_2ND_DEGREE',
        },
        CRIMINAL_POSS_METHAMPHETAMINE_4TH_DEGREE: {
            name: 'CRIMINAL_POSS_METHAMPHETAMINE_4TH_DEGREE',
        },
        CRIMINAL_POSS_METHAMPHETAMINE_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_METHAMPHETAMINE_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_POSS_NARCOTIC_1ST_DEGREE: { name: 'CRIMINAL_POSS_NARCOTIC_1ST_DEGREE' },
        CRIMINAL_POSS_NARCOTIC_2ND_DEGREE: { name: 'CRIMINAL_POSS_NARCOTIC_2ND_DEGREE' },
        CRIMINAL_POSS_NARCOTIC_3RD_DEGREE: { name: 'CRIMINAL_POSS_NARCOTIC_3RD_DEGREE' },
        CRIMINAL_POSS_NARCOTIC_4TH_DEGREE: { name: 'CRIMINAL_POSS_NARCOTIC_4TH_DEGREE' },
        CRIMINAL_POSS_NARCOTIC_PREPARATION_4TH_DEGREE: {
            name: 'CRIMINAL_POSS_NARCOTIC_PREPARATION_4TH_DEGREE',
        },
        CRIMINAL_POSS_NARCOTIC_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_NARCOTIC_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_POSS_NARCOTIC_SELL_INTENT_CONVICTED_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_NARCOTIC_SELL_INTENT_CONVICTED_3RD_DEGREE',
        },
        CRIMINAL_POSS_STIMULANT_2ND_DEGREE: { name: 'CRIMINAL_POSS_STIMULANT_2ND_DEGREE' },
        CRIMINAL_POSS_STIMULANT_3RD_DEGREE: { name: 'CRIMINAL_POSS_STIMULANT_3RD_DEGREE' },
        CRIMINAL_POSS_STIMULANT_4TH_DEGREE: { name: 'CRIMINAL_POSS_STIMULANT_4TH_DEGREE' },
        CRIMINAL_POSS_STIMULANT_SELL_INTENT_3RD_DEGREE: {
            name: 'CRIMINAL_POSS_STIMULANT_SELL_INTENT_3RD_DEGREE',
        },
        CRIMINAL_SALE_CANNABIS_4TH_DEGREE: { name: 'CRIMINAL_SALE_CANNABIS_4TH_DEGREE' },
        CRIMINAL_SALE_DEPRESSANT_4TH_DEGREE: { name: 'CRIMINAL_SALE_DEPRESSANT_4TH_DEGREE' },
        CRIMINAL_SALE_HALLUCINOGEN_2ND_DEGREE: { name: 'CRIMINAL_SALE_HALLUCINOGEN_2ND_DEGREE' },
        CRIMINAL_SALE_HALLUCINOGEN_3RD_DEGREE: { name: 'CRIMINAL_SALE_HALLUCINOGEN_3RD_DEGREE' },
        CRIMINAL_SALE_HALLUCINOGEN_STIMULANT_3RD_DEGREE: {
            name: 'CRIMINAL_SALE_HALLUCINOGEN_STIMULANT_3RD_DEGREE',
        },
        CRIMINAL_SALE_HALLUCINOGEN_SUBSTANCE_2ND_DEGREE: {
            name: 'CRIMINAL_SALE_HALLUCINOGEN_SUBSTANCE_2ND_DEGREE',
        },
        CRIMINAL_SALE_HALLUCINOGEN_SUBSTANCE_3RD_DEGREE: {
            name: 'CRIMINAL_SALE_HALLUCINOGEN_SUBSTANCE_3RD_DEGREE',
        },
        CRIMINAL_SALE_LSD_2ND_DEGREE: { name: 'CRIMINAL_SALE_LSD_2ND_DEGREE' },
        CRIMINAL_SALE_LSD_3RD_DEGREE: { name: 'CRIMINAL_SALE_LSD_3RD_DEGREE' },
        CRIMINAL_SALE_METHADONE_1ST_DEGREE: { name: 'CRIMINAL_SALE_METHADONE_1ST_DEGREE' },
        CRIMINAL_SALE_METHADONE_2ND_DEGREE: { name: 'CRIMINAL_SALE_METHADONE_2ND_DEGREE' },
        CRIMINAL_SALE_METHADONE_4TH_DEGREE: { name: 'CRIMINAL_SALE_METHADONE_4TH_DEGREE' },
        CRIMINAL_SALE_METHAMPHETAMINE_2ND_DEGREE: {
            name: 'CRIMINAL_SALE_METHAMPHETAMINE_2ND_DEGREE',
        },
        CRIMINAL_SALE_METHAMPHETAMINE_3RD_DEGREE: {
            name: 'CRIMINAL_SALE_METHAMPHETAMINE_3RD_DEGREE',
        },
        CRIMINAL_SALE_NARCOTIC_1ST_DEGREE: { name: 'CRIMINAL_SALE_NARCOTIC_1ST_DEGREE' },
        CRIMINAL_SALE_NARCOTIC_2ND_DEGREE: { name: 'CRIMINAL_SALE_NARCOTIC_2ND_DEGREE' },
        CRIMINAL_SALE_NARCOTIC_3RD_DEGREE: { name: 'CRIMINAL_SALE_NARCOTIC_3RD_DEGREE' },
        CRIMINAL_SALE_NARCOTIC_PREPARATION_4TH_DEGREE: {
            name: 'CRIMINAL_SALE_NARCOTIC_PREPARATION_4TH_DEGREE',
        },
        CRIMINAL_SALE_STIMULANT_2ND_DEGREE: { name: 'CRIMINAL_SALE_STIMULANT_2ND_DEGREE' },
        CRIMINAL_SALE_STIMULANT_3RD_DEGREE: { name: 'CRIMINAL_SALE_STIMULANT_3RD_DEGREE' },
        CRIMINAL_SEXUAL_ACT_1: { name: 'CRIMINAL_SEXUAL_ACT_1' },
        CRIMINAL_SEXUAL_ACT_1_01: { name: 'CRIMINAL_SEXUAL_ACT_1_01' },
        CRIMINAL_TRESPASS_1: { name: 'CRIMINAL_TRESPASS_1' },
        CRIMINAL_TRESPASS_1_01: { name: 'CRIMINAL_TRESPASS_1_01' },
        CRIMINAL_TRESPASS_1_02: { name: 'CRIMINAL_TRESPASS_1_02' },
        CRIMINAL_TRESPASS_1_03: { name: 'CRIMINAL_TRESPASS_1_03' },
        CRIMINAL_TRESPASS_2: { name: 'CRIMINAL_TRESPASS_2' },
        CRIMINAL_TRESPASS_2_01: { name: 'CRIMINAL_TRESPASS_2_01' },
        CRIMINAL_TRESPASS_2_02: { name: 'CRIMINAL_TRESPASS_2_02' },
        CRIMINAL_TRESPASS_3: { name: 'CRIMINAL_TRESPASS_3' },
        CRIMINAL_TRESPASS_3_0A: { name: 'CRIMINAL_TRESPASS_3_0A' },
        CRIMINAL_TRESPASS_3_0B: { name: 'CRIMINAL_TRESPASS_3_0B' },
        CRIMINAL_TRESPASS_3_0C: { name: 'CRIMINAL_TRESPASS_3_0C' },
        CRIMINAL_TRESPASS_3_0D: { name: 'CRIMINAL_TRESPASS_3_0D' },
        CRIMINAL_TRESPASS_3_0E: { name: 'CRIMINAL_TRESPASS_3_0E' },
        CRIMINAL_TRESPASS_3_0F: { name: 'CRIMINAL_TRESPASS_3_0F' },
        CRIMINAL_TRESPASS_3_0G: { name: 'CRIMINAL_TRESPASS_3_0G' },
        DOMESTIC_ACT_TERRORISM_1: { name: 'DOMESTIC_ACT_TERRORISM_1' },
        DOMESTIC_ACT_TERRORISM_2: { name: 'DOMESTIC_ACT_TERRORISM_2' },
        DUPLICATE_COMPUTER_MATERIAL: { name: 'DUPLICATE_COMPUTER_MATERIAL' },
        GRAND_LARCENY_1: { name: 'GRAND_LARCENY_1' },
        GRAND_LARCENY_1_HC: { name: 'GRAND_LARCENY_1_HC' },
        GRAND_LARCENY_2: { name: 'GRAND_LARCENY_2' },
        GRAND_LARCENY_2_HC: { name: 'GRAND_LARCENY_2_HC' },
        GRAND_LARCENY_2_HC_01: { name: 'GRAND_LARCENY_2_HC_01' },
        GRAND_LARCENY_2_HC_02: { name: 'GRAND_LARCENY_2_HC_02' },
        GRAND_LARCENY_3: { name: 'GRAND_LARCENY_3' },
        GRAND_LARCENY_3_HC: { name: 'GRAND_LARCENY_3_HC' },
        GRAND_LARCENY_3_HC_01: { name: 'GRAND_LARCENY_3_HC_01' },
        GRAND_LARCENY_3_HC_02: { name: 'GRAND_LARCENY_3_HC_02' },
        GRAND_LARCENY_4: { name: 'GRAND_LARCENY_4' },
        GRAND_LARCENY_4_AUTO: { name: 'GRAND_LARCENY_4_AUTO' },
        GRAND_LARCENY_4_CREDIT_CARD: { name: 'GRAND_LARCENY_4_CREDIT_CARD' },
        GRAND_LARCENY_4_FIREARMS: { name: 'GRAND_LARCENY_4_FIREARMS' },
        GRAND_LARCENY_4_HC: { name: 'GRAND_LARCENY_4_HC' },
        GRAND_LARCENY_4_HC_01: { name: 'GRAND_LARCENY_4_HC_01' },
        GRAND_LARCENY_4_HC_02: { name: 'GRAND_LARCENY_4_HC_02' },
        GRAND_LARCENY_4_HC_03: { name: 'GRAND_LARCENY_4_HC_03' },
        GRAND_LARCENY_4_HC_04: { name: 'GRAND_LARCENY_4_HC_04' },
        GRAND_LARCENY_4_HC_05: { name: 'GRAND_LARCENY_4_HC_05' },
        GRAND_LARCENY_4_HC_06: { name: 'GRAND_LARCENY_4_HC_06' },
        GRAND_LARCENY_4_HC_07: { name: 'GRAND_LARCENY_4_HC_07' },
        GRAND_LARCENY_4_HC_08: { name: 'GRAND_LARCENY_4_HC_08' },
        GRAND_LARCENY_4_HC_09: { name: 'GRAND_LARCENY_4_HC_09' },
        GRAND_LARCENY_4_HC_10: { name: 'GRAND_LARCENY_4_HC_10' },
        GRAND_LARCENY_4_HC_11: { name: 'GRAND_LARCENY_4_HC_11' },
        HARASSMENT_1_HC: { name: 'HARASSMENT_1_HC' },
        HINDERING_PROSECUTION_TERRORISM_1: { name: 'HINDERING_PROSECUTION_TERRORISM_1' },
        HINDERING_PROSECUTION_TERRORISM_2: { name: 'HINDERING_PROSECUTION_TERRORISM_2' },
        INSURANCE_FRAUD_1: { name: 'INSURANCE_FRAUD_1' },
        INSURANCE_FRAUD_2: { name: 'INSURANCE_FRAUD_2' },
        INSURANCE_FRAUD_3: { name: 'INSURANCE_FRAUD_3' },
        INSURANCE_FRAUD_4: { name: 'INSURANCE_FRAUD_4' },
        KIDNAPPING_1: { name: 'KIDNAPPING_1' },
        KIDNAPPING_1_01: { name: 'KIDNAPPING_1_01' },
        KIDNAPPING_1_02: { name: 'KIDNAPPING_1_02' },
        KIDNAPPING_1_03: { name: 'KIDNAPPING_1_03' },
        KIDNAPPING_2: { name: 'KIDNAPPING_2' },
        MANSLAUGHTER_1: { name: 'MANSLAUGHTER_1' },
        MANSLAUGHTER_1_01: { name: 'MANSLAUGHTER_1_01' },
        MANSLAUGHTER_1_02: { name: 'MANSLAUGHTER_1_02' },
        MANSLAUGHTER_1_04: { name: 'MANSLAUGHTER_1_04' },
        MANSLAUGHTER_2: { name: 'MANSLAUGHTER_2' },
        MANSLAUGHTER_2_01: { name: 'MANSLAUGHTER_2_01' },
        MENACING_1: { name: 'MENACING_1' },
        MENACING_2: { name: 'MENACING_2' },
        MENACING_2_01: { name: 'MENACING_2_01' },
        MENACING_2_02: { name: 'MENACING_2_02' },
        MENACING_2_03: { name: 'MENACING_2_03' },
        MENACING_3: { name: 'MENACING_3' },
        MURDER_2: { name: 'MURDER_2' },
        MURDER_2_01: { name: 'MURDER_2_01' },
        MURDER_2_02: { name: 'MURDER_2_02' },
        MURDER_2_03: { name: 'MURDER_2_03' },
        MURDER_2_04: { name: 'MURDER_2_04' },
        MURDER_2_05: { name: 'MURDER_2_05' },
        PETIT_LARCENY_HC: { name: 'PETIT_LARCENY_HC' },
        POSSESSION_CHEMICAL_BIOL_WEAPON_1: { name: 'POSSESSION_CHEMICAL_BIOL_WEAPON_1' },
        POSSESSION_CHEMICAL_BIOL_WEAPON_2: { name: 'POSSESSION_CHEMICAL_BIOL_WEAPON_2' },
        POSSESSION_CHEMICAL_BIOL_WEAPON_3: { name: 'POSSESSION_CHEMICAL_BIOL_WEAPON_3' },
        RACE_RELIGION_HARASSMENT: { name: 'RACE_RELIGION_HARASSMENT' },
        RAPE_1: { name: 'RAPE_1' },
        RAPE_1_01: { name: 'RAPE_1_01' },
        RECKLESS_ENDANGERMENT_1: { name: 'RECKLESS_ENDANGERMENT_1' },
        RECKLESS_ENDANGERMENT_2: { name: 'RECKLESS_ENDANGERMENT_2' },
        ROBBERY_1_HC: { name: 'ROBBERY_1_HC' },
        ROBBERY_1_HC_01: { name: 'ROBBERY_1_HC_01' },
        ROBBERY_1_HC_02: { name: 'ROBBERY_1_HC_02' },
        ROBBERY_1_HC_03: { name: 'ROBBERY_1_HC_03' },
        ROBBERY_1_HC_04: { name: 'ROBBERY_1_HC_04' },
        ROBBERY_2: { name: 'ROBBERY_2' },
        ROBBERY_2_HC: { name: 'ROBBERY_2_HC' },
        ROBBERY_2_HC_01: { name: 'ROBBERY_2_HC_01' },
        ROBBERY_2_HC_02: { name: 'ROBBERY_2_HC_02' },
        ROBBERY_2_HC_02A: { name: 'ROBBERY_2_HC_02A' },
        ROBBERY_2_HC_02B: { name: 'ROBBERY_2_HC_02B' },
        ROBBERY_2_HC_03: { name: 'ROBBERY_2_HC_03' },
        ROBBERY_3: { name: 'ROBBERY_3' },
        ROBBERY_INJURY: { name: 'ROBBERY_INJURY' },
        ROBBERY_SERIOUS_INJURY: { name: 'ROBBERY_SERIOUS_INJURY' },
        SEXUAL_ABUSE_1: { name: 'SEXUAL_ABUSE_1' },
        SEXUAL_ABUSE_1_01: { name: 'SEXUAL_ABUSE_1_01' },
        STALKING_1: { name: 'STALKING_1' },
        STALKING_1_01: { name: 'STALKING_1_01' },
        STALKING_1_02: { name: 'STALKING_1_02' },
        STALKING_2: { name: 'STALKING_2' },
        STALKING_2_01: { name: 'STALKING_2_01' },
        STALKING_2_02: { name: 'STALKING_2_02' },
        STALKING_2_03: { name: 'STALKING_2_03' },
        STALKING_2_04: { name: 'STALKING_2_04' },
        STALKING_2_05: { name: 'STALKING_2_05' },
        STALKING_3: { name: 'STALKING_3' },
        STALKING_3_01: { name: 'STALKING_3_01' },
        STALKING_3_02: { name: 'STALKING_3_02' },
        STALKING_3_03: { name: 'STALKING_3_03' },
        STALKING_3_04: { name: 'STALKING_3_04' },
        STALKING_4: { name: 'STALKING_4' },
        STALKING_4_01: { name: 'STALKING_4_01' },
        STALKING_4_02: { name: 'STALKING_4_02' },
        STALKING_4_03: { name: 'STALKING_4_03' },
        STATUTORY_RAPE_2ND_DEGREE: { name: 'STATUTORY_RAPE_2ND_DEGREE' },
        STATUTORY_RAPE_3RD_DEGREE: { name: 'STATUTORY_RAPE_3RD_DEGREE' },
        STATUTORY_RAPE_3RD_DEGREE_2: { name: 'STATUTORY_RAPE_3RD_DEGREE_2' },
        STRANGULATION_1: { name: 'STRANGULATION_1' },
        STRANGULATION_2: { name: 'STRANGULATION_2' },
        SUPPORT_ACT_TERRORISM_1: { name: 'SUPPORT_ACT_TERRORISM_1' },
        SUPPORT_ACT_TERRORISM_2: { name: 'SUPPORT_ACT_TERRORISM_2' },
        TERRORISM_FELONY: { name: 'TERRORISM_FELONY' },
        TERRORISM_THREAT: { name: 'TERRORISM_THREAT' },
        UNLAWFUL_IMPRISONMENT_1: { name: 'UNLAWFUL_IMPRISONMENT_1' },
        UNLAWFUL_IMPRISONMENT_2: { name: 'UNLAWFUL_IMPRISONMENT_2' },
        USE_CHEMICAL_BIOL_WEAPON_1: { name: 'USE_CHEMICAL_BIOL_WEAPON_1' },
        USE_CHEMICAL_BIOL_WEAPON_2: { name: 'USE_CHEMICAL_BIOL_WEAPON_2' },
        USE_CHEMICAL_BIOL_WEAPON_3: { name: 'USE_CHEMICAL_BIOL_WEAPON_3' },
        WELFARE_FRAUD_1: { name: 'WELFARE_FRAUD_1' },
        WELFARE_FRAUD_2: { name: 'WELFARE_FRAUD_2' },
        WELFARE_FRAUD_3: { name: 'WELFARE_FRAUD_3' },
        WELFARE_FRAUD_4: { name: 'WELFARE_FRAUD_4' },
    },
    PS = {
        ALERT: { name: 'ALERT', value: 'sensor_alert' },
        ALERT_ARCHIVE: { name: 'ALERT_ARCHIVE', value: 'sensor_alert_archive' },
        ALERT_PRIORITY: { name: 'ALERT_PRIORITY', value: 'sensor_alert_priority' },
        TENANT_FANOUT: { name: 'TENANT_FANOUT', value: 'sensor_tenant_fanout' },
        TRACE: { name: 'TRACE', value: 'sensor_trace' },
    },
    US = {
        CLASSIFIER_FAILED: { name: 'CLASSIFIER_FAILED', value: 'classifier_failed' },
        QUEUE_FAILED: { name: 'QUEUE_FAILED', value: 'queue_failed' },
        SKIPPED_ALREADY_CLASSIFIED: {
            name: 'SKIPPED_ALREADY_CLASSIFIED',
            value: 'skipped_already_classified',
        },
        SKIPPED_NOT_IN_DIRECTORY: {
            name: 'SKIPPED_NOT_IN_DIRECTORY',
            value: 'skipped_not_in_directory',
        },
        SKIPPED_NO_COORDINATES: { name: 'SKIPPED_NO_COORDINATES', value: 'skipped_no_coordinates' },
        SKIPPED_STALE: { name: 'SKIPPED_STALE', value: 'skipped_stale' },
        WRITE_FAILED: { name: 'WRITE_FAILED', value: 'write_failed' },
        WRITTEN: { name: 'WRITTEN', value: 'written' },
    },
    MS = {
        ACCEPTED: { name: 'ACCEPTED', value: 'accepted' },
        ATTRIBUTED: { name: 'ATTRIBUTED', value: 'attributed' },
        AUTHENTICATED: { name: 'AUTHENTICATED', value: 'authenticated' },
        CACHED: { name: 'CACHED', value: 'cached' },
        CONSUMED: { name: 'CONSUMED', value: 'consumed' },
        PUBLISHED: { name: 'PUBLISHED', value: 'published' },
        RECEIVED: { name: 'RECEIVED', value: 'received' },
        STREAM_PUBLISHED: { name: 'STREAM_PUBLISHED', value: 'stream_published' },
    },
    vS = {
        MALFORMED_SIGNATURE_HEADER: { name: 'MALFORMED_SIGNATURE_HEADER' },
        MISSING_SIGNATURE_HEADER: { name: 'MISSING_SIGNATURE_HEADER' },
        MISSING_VENDOR_ORG_ID: { name: 'MISSING_VENDOR_ORG_ID' },
        NONE: { name: 'NONE' },
        SECRET_DECRYPT_FAILED: { name: 'SECRET_DECRYPT_FAILED' },
        SECRET_NOT_CONFIGURED: { name: 'SECRET_NOT_CONFIGURED' },
        SIGNATURE_MISMATCH: { name: 'SIGNATURE_MISMATCH' },
        TIMESTAMP_SKEW: { name: 'TIMESTAMP_SKEW' },
        UNMAPPED_VENDOR_ORG: { name: 'UNMAPPED_VENDOR_ORG' },
        UNPARSEABLE_TIMESTAMP: { name: 'UNPARSEABLE_TIMESTAMP' },
        UNUSABLE_BODY: { name: 'UNUSABLE_BODY' },
    },
    FS = {
        DEDUP_DUPLICATE: { name: 'DEDUP_DUPLICATE', value: 'DUPLICATE' },
        DEDUP_NEW: { name: 'DEDUP_NEW', value: 'NEW' },
        DEDUP_UNKEYED: { name: 'DEDUP_UNKEYED', value: 'UNKEYED' },
        ENRICHMENT_DEACTIVATED: { name: 'ENRICHMENT_DEACTIVATED', value: 'SENSOR_DEACTIVATED' },
        ENRICHMENT_ENRICHED: { name: 'ENRICHMENT_ENRICHED', value: 'ENRICHED' },
        ENRICHMENT_SENSOR_NOT_FOUND: {
            name: 'ENRICHMENT_SENSOR_NOT_FOUND',
            value: 'SENSOR_NOT_FOUND',
        },
        NOT_ATTEMPTED: { name: 'NOT_ATTEMPTED', value: 'NOT_ATTEMPTED' },
        OUTCOME_ACCEPTED: { name: 'OUTCOME_ACCEPTED', value: 'ACCEPTED' },
        OUTCOME_DISCARDED: { name: 'OUTCOME_DISCARDED', value: 'DISCARDED' },
        OUTCOME_FEATURE_DISABLED: { name: 'OUTCOME_FEATURE_DISABLED', value: 'FEATURE_DISABLED' },
        OUTCOME_MALFORMED_MESSAGE: {
            name: 'OUTCOME_MALFORMED_MESSAGE',
            value: 'MALFORMED_MESSAGE',
        },
        OUTCOME_PROCESSED: { name: 'OUTCOME_PROCESSED', value: 'PROCESSED' },
        OUTCOME_PUBLISH_FAILED: { name: 'OUTCOME_PUBLISH_FAILED', value: 'PUBLISH_FAILED' },
        OUTCOME_REJECTED_SIGNATURE: {
            name: 'OUTCOME_REJECTED_SIGNATURE',
            value: 'REJECTED_SIGNATURE',
        },
        OUTCOME_SECRET_DECRYPT_FAILED: {
            name: 'OUTCOME_SECRET_DECRYPT_FAILED',
            value: 'SECRET_DECRYPT_FAILED',
        },
        OUTCOME_UNMAPPABLE_PAYLOAD: {
            name: 'OUTCOME_UNMAPPABLE_PAYLOAD',
            value: 'UNMAPPABLE_PAYLOAD',
        },
        OUTCOME_UNMAPPED_VENDOR_ORG: {
            name: 'OUTCOME_UNMAPPED_VENDOR_ORG',
            value: 'UNMAPPED_VENDOR_ORG',
        },
        UNKNOWN: { name: 'UNKNOWN', value: 'UNKNOWN' },
    },
    GS = { VERKADA_CAMERA: { name: 'VERKADA_CAMERA', value: 1 } },
    HS = { VERKADA_CAMERA: { name: 'VERKADA_CAMERA', value: 1 } },
    YS = {
        FAILED: { name: 'FAILED', value: 2 },
        PARTIAL_SUCCESS: { name: 'PARTIAL_SUCCESS', value: 3 },
        PENDING: { name: 'PENDING', value: 0 },
        SENT: { name: 'SENT', value: 1 },
    },
    tS = {
        ADMIRAL: { name: 'ADMIRAL', value: 9 },
        ALL: { name: 'ALL', value: 1 },
        AML: { name: 'AML', value: 35 },
        API_GATEWAY: { name: 'API_GATEWAY', value: 37 },
        ARMADA_WEBSOCKET: { name: 'ARMADA_WEBSOCKET', value: 17 },
        ATTACHMENTS: { name: 'ATTACHMENTS', value: 39 },
        BLACKSMITH: { name: 'BLACKSMITH', value: 22 },
        CAD_FIRST_RESPONDER: { name: 'CAD_FIRST_RESPONDER', value: 27 },
        CAD_NEXT: { name: 'CAD_NEXT', value: 36 },
        CAD_WARSHIP: { name: 'CAD_WARSHIP', value: 13 },
        COBALT_ARMADA: { name: 'COBALT_ARMADA', value: 10 },
        COBALT_CAD: { name: 'COBALT_CAD', value: 7 },
        COBALT_CAD_REALTIME: { name: 'COBALT_CAD_REALTIME', value: 11 },
        COBALT_CAD_SYNC: { name: 'COBALT_CAD_SYNC', value: 28 },
        COBALT_EVIDENCE: { name: 'COBALT_EVIDENCE', value: 8 },
        COBALT_RMS: { name: 'COBALT_RMS', value: 2 },
        DATA_EXCHANGE: { name: 'DATA_EXCHANGE', value: 20 },
        DRAGON: { name: 'DRAGON', value: 31 },
        DRAGON_FORMS_ADMIN: { name: 'DRAGON_FORMS_ADMIN', value: 29 },
        FIRST_RESPONDER_NEXT: { name: 'FIRST_RESPONDER_NEXT', value: 38 },
        FOUNDATION_MODELS: { name: 'FOUNDATION_MODELS', value: 40 },
        GLOBAL_WARSHIP: { name: 'GLOBAL_WARSHIP', value: 18 },
        GPS_PINGER: { name: 'GPS_PINGER', value: 25 },
        INTEGRATIONS_APP: { name: 'INTEGRATIONS_APP', value: 32 },
        IRONCLAD: { name: 'IRONCLAD', value: 4 },
        JMS: { name: 'JMS', value: 43 },
        LOCATIONS: { name: 'LOCATIONS', value: 44 },
        LOW_GLOBAL_WARSHIP: { name: 'LOW_GLOBAL_WARSHIP', value: 19 },
        LOW_PRIORITY_IRONCLAD: { name: 'LOW_PRIORITY_IRONCLAD', value: 15 },
        MESSAGING: { name: 'MESSAGING', value: 26 },
        NOTIFICATIONS: { name: 'NOTIFICATIONS', value: 12 },
        PARTNERSHIPS: { name: 'PARTNERSHIPS', value: 21 },
        RECORDS_ARCHIVE: { name: 'RECORDS_ARCHIVE', value: 41 },
        RMS_AI: { name: 'RMS_AI', value: 42 },
        SEARCH: { name: 'SEARCH', value: 24 },
        SECURITY: { name: 'SECURITY', value: 6 },
        SETTINGS: { name: 'SETTINGS', value: 5 },
        THIRD_PARTY_SEARCH: { name: 'THIRD_PARTY_SEARCH', value: 14 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USAGE_LOGS: { name: 'USAGE_LOGS', value: 16 },
        USER_PROFILE: { name: 'USER_PROFILE', value: 33 },
        WARSHIP: { name: 'WARSHIP', value: 3 },
        WORKFLOW: { name: 'WORKFLOW', value: 34 },
    },
    VS = {
        AGGRAVATED_SEXUAL_ASSAULT: { name: 'AGGRAVATED_SEXUAL_ASSAULT' },
        CONTINUOUS_SEXUAL_ABUSE_OF_YOUNG_CHILD_OR_CHILDREN: {
            name: 'CONTINUOUS_SEXUAL_ABUSE_OF_YOUNG_CHILD_OR_CHILDREN',
        },
        INDECENCY_WITH_A_CHILD_BY_CONTACT: { name: 'INDECENCY_WITH_A_CHILD_BY_CONTACT' },
        INDECENCY_WITH_A_CHILD_BY_EXPOSURE: { name: 'INDECENCY_WITH_A_CHILD_BY_EXPOSURE' },
        INDECENCY_WITH_A_CHILD_NEW_CODE: { name: 'INDECENCY_WITH_A_CHILD_NEW_CODE' },
        SEXUAL_ASSAULT: { name: 'SEXUAL_ASSAULT' },
        SEXUAL_PERFORMANCE_BY_A_CHILD: { name: 'SEXUAL_PERFORMANCE_BY_A_CHILD' },
    },
    oS = {
        ALL_EVENTS: { name: 'ALL_EVENTS', value: 55 },
        ASSIGNED_EVENTS: { name: 'ASSIGNED_EVENTS', value: 30 },
        AT_SCENE: { name: 'AT_SCENE', value: 34 },
        AVL_MAP: { name: 'AVL_MAP', value: 9 },
        CAD_SEARCH: { name: 'CAD_SEARCH', value: 4 },
        CHANGE_UNIT_STATE: { name: 'CHANGE_UNIT_STATE', value: 54 },
        CHECK_FOR_UPDATES: { name: 'CHECK_FOR_UPDATES', value: 11 },
        CLEAR_ALL_UPDATES_FOR_EVENT: { name: 'CLEAR_ALL_UPDATES_FOR_EVENT', value: 44 },
        CLOSE_PANEL: { name: 'CLOSE_PANEL', value: 48 },
        COMMAND_LINE: { name: 'COMMAND_LINE', value: 2 },
        COMMAND_LINE_COMPACT_TOGGLE: { name: 'COMMAND_LINE_COMPACT_TOGGLE', value: 40 },
        CURRENT_ASSIGNMENT: { name: 'CURRENT_ASSIGNMENT', value: 46 },
        DATA_EXCHANGE_CLEAR_RESULTS: { name: 'DATA_EXCHANGE_CLEAR_RESULTS', value: 41 },
        DATA_EXCHANGE_OPEN_FORM_PERSON_BY_LICENSE: {
            name: 'DATA_EXCHANGE_OPEN_FORM_PERSON_BY_LICENSE',
            value: 37,
        },
        DATA_EXCHANGE_OPEN_FORM_PERSON_BY_NAME: {
            name: 'DATA_EXCHANGE_OPEN_FORM_PERSON_BY_NAME',
            value: 38,
        },
        DATA_EXCHANGE_OPEN_FORM_VEHICLE_BY_PLATE: {
            name: 'DATA_EXCHANGE_OPEN_FORM_VEHICLE_BY_PLATE',
            value: 36,
        },
        DATA_EXCHANGE_OPEN_PANELS: { name: 'DATA_EXCHANGE_OPEN_PANELS', value: 35 },
        DATA_EXCHANGE_OPEN_RESULTS: { name: 'DATA_EXCHANGE_OPEN_RESULTS', value: 39 },
        DEX_UPDATE_TO_EVENT: { name: 'DEX_UPDATE_TO_EVENT', value: 51 },
        EDIT_UNIT: { name: 'EDIT_UNIT', value: 33 },
        EVENTS: { name: 'EVENTS', value: 8 },
        EVENT_ALI_TO_LOCATION: { name: 'EVENT_ALI_TO_LOCATION', value: 22 },
        EVENT_ANI_TO_REPORTING_PERSON: { name: 'EVENT_ANI_TO_REPORTING_PERSON', value: 21 },
        EVENT_ASSIGN: { name: 'EVENT_ASSIGN', value: 24 },
        EVENT_CALL: { name: 'EVENT_CALL', value: 18 },
        EVENT_CAUTIONS_TAB: { name: 'EVENT_CAUTIONS_TAB', value: 43 },
        EVENT_CLEAR: { name: 'EVENT_CLEAR', value: 19 },
        EVENT_EDIT: { name: 'EVENT_EDIT', value: 25 },
        EVENT_EMERGENCY: { name: 'EVENT_EMERGENCY', value: 14 },
        EVENT_EVENT_LOG: { name: 'EVENT_EVENT_LOG', value: 17 },
        EVENT_GENERATE_REN: { name: 'EVENT_GENERATE_REN', value: 27 },
        EVENT_IMPORT_ANI_ALI_TO_EVENT: { name: 'EVENT_IMPORT_ANI_ALI_TO_EVENT', value: 23 },
        EVENT_LINKED_EVENTS: { name: 'EVENT_LINKED_EVENTS', value: 16 },
        EVENT_PDF: { name: 'EVENT_PDF', value: 26 },
        EVENT_RELATED_DATA: { name: 'EVENT_RELATED_DATA', value: 15 },
        EVENT_REMOVE_ALL_DATA: { name: 'EVENT_REMOVE_ALL_DATA', value: 20 },
        EVENT_SAVE: { name: 'EVENT_SAVE', value: 13 },
        FIRST_RESPONDER_MAP: { name: 'FIRST_RESPONDER_MAP', value: 31 },
        GO_TO_M43_RMS: { name: 'GO_TO_M43_RMS', value: 3 },
        LOGON_UNIT: { name: 'LOGON_UNIT', value: 42 },
        LOGOUT: { name: 'LOGOUT', value: 12 },
        NEW_EVENT: { name: 'NEW_EVENT', value: 1 },
        NOTIFICATION_CENTER: { name: 'NOTIFICATION_CENTER', value: 50 },
        REPOSSESSION: { name: 'REPOSSESSION', value: 10 },
        SAVED_SEARCHES: { name: 'SAVED_SEARCHES', value: 5 },
        SELF_INITIATE: { name: 'SELF_INITIATE', value: 28 },
        SHOW_CURRENT_LOCATION: { name: 'SHOW_CURRENT_LOCATION', value: 56 },
        TOGGLE_LIGHT_DARK_MODE: { name: 'TOGGLE_LIGHT_DARK_MODE', value: 57 },
        TOGGLE_MESSAGING_PANEL: { name: 'TOGGLE_MESSAGING_PANEL', value: 45 },
        TOGGLE_PINNED_MESSAGES_VIEW: { name: 'TOGGLE_PINNED_MESSAGES_VIEW', value: 59 },
        UNASSIGNED_EVENTS: { name: 'UNASSIGNED_EVENTS', value: 29 },
        UNITS: { name: 'UNITS', value: 32 },
        UNITS_LIST_EXPANDED: { name: 'UNITS_LIST_EXPANDED', value: 58 },
        UNIT_EMERGENCY: { name: 'UNIT_EMERGENCY', value: 52 },
        UNIT_EMERGENCY_CANCEL: { name: 'UNIT_EMERGENCY_CANCEL', value: 53 },
        UNIT_STATUS_SAVED_SEARCHES: { name: 'UNIT_STATUS_SAVED_SEARCHES', value: 7 },
        UNIT_STATUS_SEARCH: { name: 'UNIT_STATUS_SEARCH', value: 6 },
        UPDATE_UNIT_LOCATION: { name: 'UPDATE_UNIT_LOCATION', value: 47 },
    },
    BS = {
        DISPATCHER: { name: 'DISPATCHER', value: 1 },
        DISPATCHER_EVENT_PANEL: { name: 'DISPATCHER_EVENT_PANEL', value: 4 },
        DISPATCHER_EVENT_WINDOW: { name: 'DISPATCHER_EVENT_WINDOW', value: 2 },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER', value: 3 },
    },
    rS = {
        ABOUT: { name: 'ABOUT', value: 1 },
        COURT_ORDERS: { name: 'COURT_ORDERS', value: 4 },
        CURRENTLY_VIEWING: { name: 'CURRENTLY_VIEWING', value: 16 },
        DETENTION_DISPOSITION: { name: 'DETENTION_DISPOSITION', value: 2 },
        EVENT_INFO: { name: 'EVENT_INFO', value: 128 },
        EVENT_NUMBER_RECORDS: { name: 'EVENT_NUMBER_RECORDS', value: 32 },
        INVOLVED_PROFILES: { name: 'INVOLVED_PROFILES', value: 64 },
        LABELS: { name: 'LABELS', value: 8 },
        MULTIMEDIA: { name: 'MULTIMEDIA', value: 1024 },
        SUBMISSIONS: { name: 'SUBMISSIONS', value: 512 },
        TASKS: { name: 'TASKS', value: 256 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    sS = {
        ABILITY_NAME: { name: 'ABILITY_NAME', value: 70 },
        AGENCY: { name: 'AGENCY', value: 37 },
        ATTRIBUTE: { name: 'ATTRIBUTE', value: 12 },
        ATTRIBUTE_IS_OTHER_AND_IS_NONE: { name: 'ATTRIBUTE_IS_OTHER_AND_IS_NONE', value: 25 },
        ATTRIBUTE_TYPE_EXISTS: { name: 'ATTRIBUTE_TYPE_EXISTS', value: 19 },
        ATTRIBUTE_TYPE_IS_NOT_EDITABLE: { name: 'ATTRIBUTE_TYPE_IS_NOT_EDITABLE', value: 20 },
        CAD_INTEGRATION_PROFILE_NAME: { name: 'CAD_INTEGRATION_PROFILE_NAME', value: 59 },
        CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION: {
            name: 'CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION',
            value: 60,
        },
        CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_DEFAULT_ANSWER: {
            name: 'CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_DEFAULT_ANSWER',
            value: 61,
        },
        CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_SEQUENCE: {
            name: 'CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_SEQUENCE',
            value: 62,
        },
        CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_TYPE: {
            name: 'CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_TYPE',
            value: 63,
        },
        CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_VERSION: {
            name: 'CAD_INTEGRATION_PROFILE_TRIAGE_QUESTION_VERSION',
            value: 64,
        },
        CALL_FOR_SERVICE: { name: 'CALL_FOR_SERVICE', value: 41 },
        CLASS_TYPE_MISMATCH: { name: 'CLASS_TYPE_MISMATCH', value: 68 },
        CODE: { name: 'CODE', value: 24 },
        CODE_SET_MAPPING_DOES_NOT_EXIST: { name: 'CODE_SET_MAPPING_DOES_NOT_EXIST', value: 28 },
        CODE_TYPE: { name: 'CODE_TYPE', value: 23 },
        CODE_TYPE_SOURCE: { name: 'CODE_TYPE_SOURCE', value: 22 },
        CROSS_TENANT: { name: 'CROSS_TENANT', value: 75 },
        CSV_BOOLEAN: { name: 'CSV_BOOLEAN', value: 21 },
        CSV_HEADER_ROW: { name: 'CSV_HEADER_ROW', value: 5 },
        DATE: { name: 'DATE', value: 7 },
        DISPATCH_AREA: { name: 'DISPATCH_AREA', value: 40 },
        DOLLAR_FORMAT: { name: 'DOLLAR_FORMAT', value: 17 },
        DUPLICATE_ATTRIBUTE_FOR_TABLE_UNIQUE_KEY: {
            name: 'DUPLICATE_ATTRIBUTE_FOR_TABLE_UNIQUE_KEY',
            value: 29,
        },
        DUPLICATE_CSV_PRIMARY_KEY: { name: 'DUPLICATE_CSV_PRIMARY_KEY', value: 3 },
        DUPLICATE_EXISTING_ATTRIBUTE: { name: 'DUPLICATE_EXISTING_ATTRIBUTE', value: 6 },
        DUPLICATE_EXISTING_DEFAULT_RETENTION_POLICY: {
            name: 'DUPLICATE_EXISTING_DEFAULT_RETENTION_POLICY',
            value: 44,
        },
        DUPLICATE_EXISTING_DOJ_SCHOOL: { name: 'DUPLICATE_EXISTING_DOJ_SCHOOL', value: 77 },
        DUPLICATE_EXISTING_OFFENSE_CODE: { name: 'DUPLICATE_EXISTING_OFFENSE_CODE', value: 45 },
        DUPLICATE_EXISTING_PARENT_ATTRIBUTE: {
            name: 'DUPLICATE_EXISTING_PARENT_ATTRIBUTE',
            value: 27,
        },
        DUPLICATE_REQUIRED_FIELDS: { name: 'DUPLICATE_REQUIRED_FIELDS', value: 4 },
        DUPLICATE_ROW: { name: 'DUPLICATE_ROW', value: 32 },
        EMAIL: { name: 'EMAIL', value: 8 },
        EMPTY_FILE: { name: 'EMPTY_FILE', value: 66 },
        ENTITY: { name: 'ENTITY', value: 14 },
        ENUM: { name: 'ENUM', value: 10 },
        EVENT_LABEL_NAME: { name: 'EVENT_LABEL_NAME', value: 58 },
        FIELD_RANGE: { name: 'FIELD_RANGE', value: 18 },
        FIELD_SIZE: { name: 'FIELD_SIZE', value: 33 },
        FILE_EXTENSION: { name: 'FILE_EXTENSION', value: 1 },
        GENERAL_VALIDATION_IMPORT_ERROR: { name: 'GENERAL_VALIDATION_IMPORT_ERROR', value: 57 },
        HOME_OFFICE_CLASSIFICATION: { name: 'HOME_OFFICE_CLASSIFICATION', value: 74 },
        INCORRECT_TYPE: { name: 'INCORRECT_TYPE', value: 65 },
        INVALID_APPROVAL_LEVEL: { name: 'INVALID_APPROVAL_LEVEL', value: 42 },
        LOCATION: { name: 'LOCATION', value: 49 },
        MISSING_FACILITY: { name: 'MISSING_FACILITY', value: 35 },
        MISSING_FIELD_DEPENDENCY: { name: 'MISSING_FIELD_DEPENDENCY', value: 13 },
        MISSING_PARENT_ROW: { name: 'MISSING_PARENT_ROW', value: 31 },
        MISSING_REQUIRED_FIELD: { name: 'MISSING_REQUIRED_FIELD', value: 2 },
        NIBRS_CODE_ID: { name: 'NIBRS_CODE_ID', value: 54 },
        NIBRS_OFFENSE_CODE: { name: 'NIBRS_OFFENSE_CODE', value: 15 },
        NUMBER_VALUE_OUTSIDE_BOUNDS: { name: 'NUMBER_VALUE_OUTSIDE_BOUNDS', value: 38 },
        OFFENSE_CODE: { name: 'OFFENSE_CODE', value: 43 },
        OFFENSE_CODE_FLAGS_REQUIRE_DEPENDENT_FIELDS: {
            name: 'OFFENSE_CODE_FLAGS_REQUIRE_DEPENDENT_FIELDS',
            value: 36,
        },
        OFFENSE_CODE_OVERLAPPING_ACTIVE_PERIOD: {
            name: 'OFFENSE_CODE_OVERLAPPING_ACTIVE_PERIOD',
            value: 76,
        },
        OFFENSE_CODE_REQUIRES_CATEGORIZATION: {
            name: 'OFFENSE_CODE_REQUIRES_CATEGORIZATION',
            value: 30,
        },
        OFFENSE_CODE_WORDING_PARENTHESIS: { name: 'OFFENSE_CODE_WORDING_PARENTHESIS', value: 71 },
        ORI_ALIAS: { name: 'ORI_ALIAS', value: 78 },
        PARENT_ATTRIBUTE_DOES_NOT_EXIST: { name: 'PARENT_ATTRIBUTE_DOES_NOT_EXIST', value: 26 },
        PHONE_NUMBER: { name: 'PHONE_NUMBER', value: 9 },
        PREEXISTING_DATA: { name: 'PREEXISTING_DATA', value: 34 },
        RADIO_CHANNEL_NAME: { name: 'RADIO_CHANNEL_NAME', value: 56 },
        RADIO_CHANNEL_STATUS: { name: 'RADIO_CHANNEL_STATUS', value: 55 },
        ROLE: { name: 'ROLE', value: 11 },
        ROLE_NAME: { name: 'ROLE_NAME', value: 69 },
        STATION: { name: 'STATION', value: 46 },
        STREET_ALIAS: { name: 'STREET_ALIAS', value: 50 },
        STREET_SEGMENT: { name: 'STREET_SEGMENT', value: 53 },
        SUB_PREMISE_NAME: { name: 'SUB_PREMISE_NAME', value: 72 },
        SUB_PREMISE_VALUE: { name: 'SUB_PREMISE_VALUE', value: 73 },
        UCR_SUMMARY_OFFENSE_CODE: { name: 'UCR_SUMMARY_OFFENSE_CODE', value: 16 },
        UNIT: { name: 'UNIT', value: 52 },
        UNIT_STATE: { name: 'UNIT_STATE', value: 47 },
        UNIT_STATE_TRANSITION: { name: 'UNIT_STATE_TRANSITION', value: 48 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        URL: { name: 'URL', value: 67 },
        USER: { name: 'USER', value: 55 },
        USER_UPDATE_PERMISSIONS: { name: 'USER_UPDATE_PERMISSIONS', value: 51 },
        YEAR_FORMAT: { name: 'YEAR_FORMAT', value: 39 },
    },
    iS = {
        NSW_MULESOFT: { name: 'NSW_MULESOFT', value: 2 },
        TWILIO: { name: 'TWILIO', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    WS = {
        TEST: { name: 'TEST', value: 'testTemplate' },
        UNKNOWN: { name: 'UNKNOWN', value: 'Unknown' },
    },
    cS = {
        ACTIVATION_DATE: { name: 'ACTIVATION_DATE' },
        CREATED_DATE: { name: 'CREATED_DATE' },
        DEACTIVATION_DATE: { name: 'DEACTIVATION_DATE' },
    },
    KS = { Asc: { name: 'Asc', value: 1 }, Desc: { name: 'Desc', value: 2 } },
    dS = { ASC: { name: 'ASC' }, DESC: { name: 'DESC' } },
    pS = { ASC: { name: 'ASC', value: 'ascending' }, DESC: { name: 'DESC', value: 'descending' } },
    yS = {
        AED_ATTEMPTING_ACCEPTING: { name: 'AED_ATTEMPTING_ACCEPTING', value: 4 },
        DEX_HOT_HIT_ALERT: { name: 'DEX_HOT_HIT_ALERT', value: 5 },
        DRAFT_EVENT_TIMER_ALERT: { name: 'DRAFT_EVENT_TIMER_ALERT', value: 3 },
        EMERGENCY_SIREN: { name: 'EMERGENCY_SIREN', value: 9 },
        FIRST_RESPONDER_INCOMING_BOLO: { name: 'FIRST_RESPONDER_INCOMING_BOLO', value: 8 },
        FIRST_RESPONDER_INCOMING_MESSAGE: { name: 'FIRST_RESPONDER_INCOMING_MESSAGE', value: 7 },
        NEW_EVENT_ALERT: { name: 'NEW_EVENT_ALERT', value: 1 },
        NEW_MESSAGE_RECEIVED: { name: 'NEW_MESSAGE_RECEIVED', value: 6 },
        UNIT_TIMER_ALERT: { name: 'UNIT_TIMER_ALERT', value: 2 },
    },
    XS = { RMS: { name: 'RMS', value: 'RMS' } },
    QS = {
        ESRI_DISTANCE_MARKER: { name: 'ESRI_DISTANCE_MARKER' },
        ESRI_LAT_LONG: { name: 'ESRI_LAT_LONG' },
        ESRI_LOCALITY: { name: 'ESRI_LOCALITY' },
        ESRI_MGRS: { name: 'ESRI_MGRS' },
        ESRI_POI: { name: 'ESRI_POI' },
        ESRI_POINT_ADDRESS: { name: 'ESRI_POINT_ADDRESS' },
        ESRI_POSTAL: { name: 'ESRI_POSTAL' },
        ESRI_POSTAL_EXT: { name: 'ESRI_POSTAL_EXT' },
        ESRI_POSTAL_LOC: { name: 'ESRI_POSTAL_LOC' },
        ESRI_STREET_ADDRESS: { name: 'ESRI_STREET_ADDRESS' },
        ESRI_STREET_ADDRESS_EXT: { name: 'ESRI_STREET_ADDRESS_EXT' },
        ESRI_STREET_INT: { name: 'ESRI_STREET_INT' },
        ESRI_STREET_MID_BLOCK: { name: 'ESRI_STREET_MID_BLOCK' },
        ESRI_STREET_NAME: { name: 'ESRI_STREET_NAME' },
        ESRI_SUB_ADDRESS: { name: 'ESRI_SUB_ADDRESS' },
        ESRI_XY: { name: 'ESRI_XY' },
        ESRI_YX: { name: 'ESRI_YX' },
        MARK43_GEO_ADDRESS_POINT: { name: 'MARK43_GEO_ADDRESS_POINT' },
        MARK43_GEO_ALIAS: { name: 'MARK43_GEO_ALIAS' },
        MARK43_GEO_CAUTION: { name: 'MARK43_GEO_CAUTION' },
        MARK43_POINT_LOCATION: { name: 'MARK43_POINT_LOCATION' },
        MARK43_STREET_CENTERLINE: { name: 'MARK43_STREET_CENTERLINE' },
        MAR_ADDRESS: { name: 'MAR_ADDRESS' },
        MAR_BLOCK: { name: 'MAR_BLOCK' },
        MAR_INTERSECTION: { name: 'MAR_INTERSECTION' },
    },
    bS = {
        Auth0: { name: 'Auth0', value: 0 },
        AzureADB2C: { name: 'AzureADB2C', value: 1 },
        Descope: { name: 'Descope', value: 2 },
    },
    fS = {
        ALREADY_ON_EVENT: { name: 'ALREADY_ON_EVENT' },
        COUNT_CHANGED: { name: 'COUNT_CHANGED' },
        ERROR: { name: 'ERROR' },
        INVALID_COUNT: { name: 'INVALID_COUNT' },
        NOT_ON_EVENT: { name: 'NOT_ON_EVENT' },
        NO_SHIFT: { name: 'NO_SHIFT' },
    },
    gS = { CLOSED: { name: 'CLOSED' }, HALF_OPEN: { name: 'HALF_OPEN' }, OPEN: { name: 'OPEN' } },
    JS = {
        ALABAMA_EAST: { name: 'ALABAMA_EAST', value: '0101' },
        ALABAMA_WEST: { name: 'ALABAMA_WEST', value: '0102' },
        ALASKA_ZONE_1: { name: 'ALASKA_ZONE_1', value: '5001' },
        ALASKA_ZONE_10: { name: 'ALASKA_ZONE_10', value: '5010' },
        ALASKA_ZONE_2: { name: 'ALASKA_ZONE_2', value: '5002' },
        ALASKA_ZONE_3: { name: 'ALASKA_ZONE_3', value: '5003' },
        ALASKA_ZONE_4: { name: 'ALASKA_ZONE_4', value: '5004' },
        ALASKA_ZONE_5: { name: 'ALASKA_ZONE_5', value: '5005' },
        ALASKA_ZONE_6: { name: 'ALASKA_ZONE_6', value: '5006' },
        ALASKA_ZONE_7: { name: 'ALASKA_ZONE_7', value: '5007' },
        ALASKA_ZONE_8: { name: 'ALASKA_ZONE_8', value: '5008' },
        ALASKA_ZONE_9: { name: 'ALASKA_ZONE_9', value: '5009' },
        ARIZONA_CENTRAL: { name: 'ARIZONA_CENTRAL', value: '0202' },
        ARIZONA_EAST: { name: 'ARIZONA_EAST', value: '0201' },
        ARIZONA_WEST: { name: 'ARIZONA_WEST', value: '0203' },
        ARKANSAS_NORTH: { name: 'ARKANSAS_NORTH', value: '0301' },
        ARKANSAS_SOUTH: { name: 'ARKANSAS_SOUTH', value: '0302' },
        CALIFORNIA_ZONE_1: { name: 'CALIFORNIA_ZONE_1', value: '0401' },
        CALIFORNIA_ZONE_2: { name: 'CALIFORNIA_ZONE_2', value: '0402' },
        CALIFORNIA_ZONE_3: { name: 'CALIFORNIA_ZONE_3', value: '0403' },
        CALIFORNIA_ZONE_4: { name: 'CALIFORNIA_ZONE_4', value: '0404' },
        CALIFORNIA_ZONE_5: { name: 'CALIFORNIA_ZONE_5', value: '0405' },
        CALIFORNIA_ZONE_6: { name: 'CALIFORNIA_ZONE_6', value: '0406' },
        COLORADO_CENTRAL: { name: 'COLORADO_CENTRAL', value: '0502' },
        COLORADO_NORTH: { name: 'COLORADO_NORTH', value: '0501' },
        COLORADO_SOUTH: { name: 'COLORADO_SOUTH', value: '0503' },
        CONNECTICUT: { name: 'CONNECTICUT', value: '0600' },
        DELAWARE: { name: 'DELAWARE', value: '0700' },
        FLORIDA_EAST: { name: 'FLORIDA_EAST', value: '0901' },
        FLORIDA_NORTH: { name: 'FLORIDA_NORTH', value: '0903' },
        FLORIDA_WEST: { name: 'FLORIDA_WEST', value: '0902' },
        GEORGIA_EAST: { name: 'GEORGIA_EAST', value: '1001' },
        GEORGIA_WEST: { name: 'GEORGIA_WEST', value: '1002' },
        HAWAII_ZONE_1: { name: 'HAWAII_ZONE_1', value: '5101' },
        HAWAII_ZONE_2: { name: 'HAWAII_ZONE_2', value: '5102' },
        HAWAII_ZONE_3: { name: 'HAWAII_ZONE_3', value: '5103' },
        HAWAII_ZONE_4: { name: 'HAWAII_ZONE_4', value: '5104' },
        HAWAII_ZONE_5: { name: 'HAWAII_ZONE_5', value: '5105' },
        IDAHO_CENTRAL: { name: 'IDAHO_CENTRAL', value: '1102' },
        IDAHO_EAST: { name: 'IDAHO_EAST', value: '1101' },
        IDAHO_WEST: { name: 'IDAHO_WEST', value: '1103' },
        ILLINOIS_EAST: { name: 'ILLINOIS_EAST', value: '1201' },
        ILLINOIS_WEST: { name: 'ILLINOIS_WEST', value: '1202' },
        INDIANA_EAST: { name: 'INDIANA_EAST', value: '1301' },
        INDIANA_WEST: { name: 'INDIANA_WEST', value: '1302' },
        IOWA_NORTH: { name: 'IOWA_NORTH', value: '1401' },
        IOWA_SOUTH: { name: 'IOWA_SOUTH', value: '1402' },
        KANSAS_NORTH: { name: 'KANSAS_NORTH', value: '1501' },
        KANSAS_SOUTH: { name: 'KANSAS_SOUTH', value: '1502' },
        KENTUCKY_NORTH: { name: 'KENTUCKY_NORTH', value: '1601' },
        KENTUCKY_SINGLE_ZONE: { name: 'KENTUCKY_SINGLE_ZONE', value: '1600' },
        KENTUCKY_SOUTH: { name: 'KENTUCKY_SOUTH', value: '1602' },
        LOUISIANA_NORTH: { name: 'LOUISIANA_NORTH', value: '1701' },
        LOUISIANA_OFFSHORE: { name: 'LOUISIANA_OFFSHORE', value: '1703' },
        LOUISIANA_SOUTH: { name: 'LOUISIANA_SOUTH', value: '1702' },
        MAINE_CENTRAL_2000: { name: 'MAINE_CENTRAL_2000', value: '1812' },
        MAINE_EAST_1983: { name: 'MAINE_EAST_1983', value: '1801' },
        MAINE_EAST_2000: { name: 'MAINE_EAST_2000', value: '1811' },
        MAINE_WEST_1983: { name: 'MAINE_WEST_1983', value: '1802' },
        MAINE_WEST_2000: { name: 'MAINE_WEST_2000', value: '1813' },
        MARYLAND: { name: 'MARYLAND', value: '1900' },
        MASSACHUSETTS_ISLAND: { name: 'MASSACHUSETTS_ISLAND', value: '2002' },
        MASSACHUSETTS_MAINLAND: { name: 'MASSACHUSETTS_MAINLAND', value: '2001' },
        MICHIGAN_CENTRAL: { name: 'MICHIGAN_CENTRAL', value: '2112' },
        MICHIGAN_NORTH: { name: 'MICHIGAN_NORTH', value: '2111' },
        MICHIGAN_SOUTH: { name: 'MICHIGAN_SOUTH', value: '2113' },
        MINNESOTA_CENTRAL: { name: 'MINNESOTA_CENTRAL', value: '2202' },
        MINNESOTA_NORTH: { name: 'MINNESOTA_NORTH', value: '2201' },
        MINNESOTA_SOUTH: { name: 'MINNESOTA_SOUTH', value: '2203' },
        MISSISSIPPI_EAST: { name: 'MISSISSIPPI_EAST', value: '2301' },
        MISSISSIPPI_WEST: { name: 'MISSISSIPPI_WEST', value: '2302' },
        MISSOURI_CENTRAL: { name: 'MISSOURI_CENTRAL', value: '2402' },
        MISSOURI_EAST: { name: 'MISSOURI_EAST', value: '2401' },
        MISSOURI_WEST: { name: 'MISSOURI_WEST', value: '2403' },
        MONTANA: { name: 'MONTANA', value: '2500' },
        NEBRASKA: { name: 'NEBRASKA', value: '2600' },
        NEVADA_CENTRAL: { name: 'NEVADA_CENTRAL', value: '2702' },
        NEVADA_EAST: { name: 'NEVADA_EAST', value: '2701' },
        NEVADA_WEST: { name: 'NEVADA_WEST', value: '2703' },
        NEW_HAMPSHIRE: { name: 'NEW_HAMPSHIRE', value: '2800' },
        NEW_JERSEY: { name: 'NEW_JERSEY', value: '2900' },
        NEW_MEXICO_CENTRAL: { name: 'NEW_MEXICO_CENTRAL', value: '3002' },
        NEW_MEXICO_EAST: { name: 'NEW_MEXICO_EAST', value: '3001' },
        NEW_MEXICO_WEST: { name: 'NEW_MEXICO_WEST', value: '3003' },
        NEW_YORK_CENTRAL: { name: 'NEW_YORK_CENTRAL', value: '3102' },
        NEW_YORK_EAST: { name: 'NEW_YORK_EAST', value: '3101' },
        NEW_YORK_LONG_ISLAND: { name: 'NEW_YORK_LONG_ISLAND', value: '3104' },
        NEW_YORK_WEST: { name: 'NEW_YORK_WEST', value: '3103' },
        NORTH_CAROLINA: { name: 'NORTH_CAROLINA', value: '3200' },
        NORTH_DAKOTA_NORTH: { name: 'NORTH_DAKOTA_NORTH', value: '3301' },
        NORTH_DAKOTA_SOUTH: { name: 'NORTH_DAKOTA_SOUTH', value: '3302' },
        OHIO_NORTH: { name: 'OHIO_NORTH', value: '3401' },
        OHIO_SOUTH: { name: 'OHIO_SOUTH', value: '3402' },
        OKLAHOMA_NORTH: { name: 'OKLAHOMA_NORTH', value: '3501' },
        OKLAHOMA_SOUTH: { name: 'OKLAHOMA_SOUTH', value: '3502' },
        OREGON_NORTH: { name: 'OREGON_NORTH', value: '3601' },
        OREGON_SOUTH: { name: 'OREGON_SOUTH', value: '3602' },
        PENNSYLVANIA_NORTH: { name: 'PENNSYLVANIA_NORTH', value: '3701' },
        PENNSYLVANIA_SOUTH: { name: 'PENNSYLVANIA_SOUTH', value: '3702' },
        PUERTO_RICO_AND_VIRGIN_ISLANDS: { name: 'PUERTO_RICO_AND_VIRGIN_ISLANDS', value: '5200' },
        RHODE_ISLAND: { name: 'RHODE_ISLAND', value: '3800' },
        SOUTH_CAROLINA: { name: 'SOUTH_CAROLINA', value: '3900' },
        SOUTH_DAKOTA_NORTH: { name: 'SOUTH_DAKOTA_NORTH', value: '4001' },
        SOUTH_DAKOTA_SOUTH: { name: 'SOUTH_DAKOTA_SOUTH', value: '4002' },
        TENNESSEE: { name: 'TENNESSEE', value: '4100' },
        TEXAS_CENTRAL: { name: 'TEXAS_CENTRAL', value: '4203' },
        TEXAS_NORTH: { name: 'TEXAS_NORTH', value: '4201' },
        TEXAS_NORTH_CENTRAL: { name: 'TEXAS_NORTH_CENTRAL', value: '4202' },
        TEXAS_SOUTH: { name: 'TEXAS_SOUTH', value: '4205' },
        TEXAS_SOUTH_CENTRAL: { name: 'TEXAS_SOUTH_CENTRAL', value: '4204' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unkn' },
        UTAH_CENTRAL: { name: 'UTAH_CENTRAL', value: '4302' },
        UTAH_NORTH: { name: 'UTAH_NORTH', value: '4301' },
        UTAH_SOUTH: { name: 'UTAH_SOUTH', value: '4303' },
        VERMONT: { name: 'VERMONT', value: '4400' },
        VIRGINIA_NORTH: { name: 'VIRGINIA_NORTH', value: '4501' },
        VIRGINIA_SOUTH: { name: 'VIRGINIA_SOUTH', value: '4502' },
        WASHINGTON_NORTH: { name: 'WASHINGTON_NORTH', value: '4601' },
        WASHINGTON_SOUTH: { name: 'WASHINGTON_SOUTH', value: '4602' },
        WEST_VIRGINIA_NORTH: { name: 'WEST_VIRGINIA_NORTH', value: '4701' },
        WEST_VIRGINIA_SOUTH: { name: 'WEST_VIRGINIA_SOUTH', value: '4702' },
        WISCONSIN_CENTRAL: { name: 'WISCONSIN_CENTRAL', value: '4802' },
        WISCONSIN_NORTH: { name: 'WISCONSIN_NORTH', value: '4801' },
        WISCONSIN_SOUTH: { name: 'WISCONSIN_SOUTH', value: '4803' },
        WYOMING_EAST: { name: 'WYOMING_EAST', value: '4901' },
        WYOMING_EAST_CENTRAL: { name: 'WYOMING_EAST_CENTRAL', value: '4902' },
        WYOMING_WEST: { name: 'WYOMING_WEST', value: '4904' },
        WYOMING_WEST_CENTRAL: { name: 'WYOMING_WEST_CENTRAL', value: '4903' },
    },
    hS = { DELIVERED: { name: 'DELIVERED' }, FAILED: { name: 'FAILED' } },
    ZS = {
        HELD: { name: 'HELD', value: 'HELD' },
        RELEASED: { name: 'RELEASED', value: 'RELEASED' },
        TRANSFERRED: { name: 'TRANSFERRED', value: 'TRANSFERRED' },
    },
    jS = {
        ARCHIVED: { name: 'ARCHIVED', value: 'ARCHIVED' },
        DISABLED: { name: 'DISABLED', value: 'DISABLED' },
        ENABLED: { name: 'ENABLED', value: 'ENABLED' },
    },
    xS = { PERMANENT: { name: 'PERMANENT', value: 1 }, TEMPORARY: { name: 'TEMPORARY', value: 2 } },
    kS = {
        CIRCUIT_BREAKER: { name: 'CIRCUIT_BREAKER', value: 6 },
        DEPARTMENT: { name: 'DEPARTMENT', value: 2 },
        DEPARTMENT_TOPIC: { name: 'DEPARTMENT_TOPIC', value: 1 },
        GLOBAL: { name: 'GLOBAL', value: 4 },
        TOPIC: { name: 'TOPIC', value: 3 },
        UNCONFIGURED: { name: 'UNCONFIGURED', value: 5 },
    },
    wS = {
        BOTH: { name: 'BOTH', value: 3 },
        EVEN: { name: 'EVEN', value: 1 },
        ODD: { name: 'ODD', value: 2 },
    },
    zS = { LEFT: { name: 'LEFT', value: 2 }, RIGHT: { name: 'RIGHT', value: 1 } },
    qS = {
        CFS_TYPE: { name: 'CFS_TYPE', value: 4 },
        EVENT_PRIORITY: { name: 'EVENT_PRIORITY', value: 2 },
        MESSAGE_PRIORITY: { name: 'MESSAGE_PRIORITY', value: 5 },
        NONE: { name: 'NONE', value: 1 },
        UNIT_STATE: { name: 'UNIT_STATE', value: 3 },
    },
    $S = { PROMPTED: { name: 'PROMPTED', value: 1 }, STORED: { name: 'STORED', value: 2 } },
    EC = {
        FLAT_FILE: { name: 'FLAT_FILE', value: 3 },
        JSON: { name: 'JSON', value: 2 },
        XML: { name: 'XML', value: 1 },
    },
    _C = {
        REST: { name: 'REST', value: 1 },
        SFTP: { name: 'SFTP', value: 2 },
        SOAP: { name: 'SOAP', value: 3 },
    },
    TC = {
        FLORIDA: { name: 'FLORIDA', value: 3 },
        GENERIC_HTTP: { name: 'GENERIC_HTTP', value: 4 },
        MARYLAND: { name: 'MARYLAND', value: 2 },
        SWIFT: { name: 'SWIFT', value: 1 },
    },
    eC = {
        DRAFT: { name: 'DRAFT', value: 'draft' },
        SUBMITTED: { name: 'SUBMITTED', value: 'submitted' },
    },
    AC = {
        CREATE: { name: 'CREATE', value: 'CREATE' },
        DELETE: { name: 'DELETE', value: 'DELETE' },
        UPDATE: { name: 'UPDATE', value: 'UPDATE' },
    },
    NC = {
        ALPHABETIC: { name: 'ALPHABETIC', value: 2 },
        DASHED_NUMERIC: { name: 'DASHED_NUMERIC', value: 1 },
    },
    IC = {
        EMS_EVENT_ASSIGNED: { name: 'EMS_EVENT_ASSIGNED', value: 20 },
        EMS_EVENT_SCHEDULED: { name: 'EMS_EVENT_SCHEDULED', value: 22 },
        EMS_EVENT_UNASSIGNED: { name: 'EMS_EVENT_UNASSIGNED', value: 21 },
        EMS_STATIONS: { name: 'EMS_STATIONS', value: 26 },
        EMS_UNIT_ASSIGNED: { name: 'EMS_UNIT_ASSIGNED', value: 25 },
        EMS_UNIT_AVAILABLE: { name: 'EMS_UNIT_AVAILABLE', value: 23 },
        EMS_UNIT_UNAVAILABLE: { name: 'EMS_UNIT_UNAVAILABLE', value: 24 },
        EVENT_ASSIGNED: { name: 'EVENT_ASSIGNED', value: 0 },
        EVENT_SCHEDULED: { name: 'EVENT_SCHEDULED', value: 2 },
        EVENT_UNASSIGNED: { name: 'EVENT_UNASSIGNED', value: 1 },
        FIRE_EVENT_ASSIGNED: { name: 'FIRE_EVENT_ASSIGNED', value: 12 },
        FIRE_EVENT_SCHEDULED: { name: 'FIRE_EVENT_SCHEDULED', value: 14 },
        FIRE_EVENT_UNASSIGNED: { name: 'FIRE_EVENT_UNASSIGNED', value: 13 },
        FIRE_STATIONS: { name: 'FIRE_STATIONS', value: 19 },
        FIRE_UNIT_ASSIGNED: { name: 'FIRE_UNIT_ASSIGNED', value: 17 },
        FIRE_UNIT_AVAILABLE: { name: 'FIRE_UNIT_AVAILABLE', value: 15 },
        FIRE_UNIT_UNAVAILABLE: { name: 'FIRE_UNIT_UNAVAILABLE', value: 16 },
        FIRE_UNIT_UNMANNED: { name: 'FIRE_UNIT_UNMANNED', value: 18 },
        UNIT_ADMIN: { name: 'UNIT_ADMIN', value: 5 },
        UNIT_ASSIGNED: { name: 'UNIT_ASSIGNED', value: 6 },
        UNIT_AVAILABLE: { name: 'UNIT_AVAILABLE', value: 3 },
        UNIT_DIRECTED_PATROL: { name: 'UNIT_DIRECTED_PATROL', value: 9 },
        UNIT_SPECIAL_ASSIGNMENT: { name: 'UNIT_SPECIAL_ASSIGNMENT', value: 11 },
        UNIT_UNAVAILABLE: { name: 'UNIT_UNAVAILABLE', value: 4 },
        UNIT_UNMANNED: { name: 'UNIT_UNMANNED', value: 7 },
        UNIT_UNTRACKED: { name: 'UNIT_UNTRACKED', value: 8 },
        UNIT_VIRTUAL_PATROL: { name: 'UNIT_VIRTUAL_PATROL', value: 10 },
    },
    RC = {
        BOOKING: { name: 'BOOKING', value: 'booking' },
        CASE: { name: 'CASE', value: 'case' },
        REPORT: { name: 'REPORT', value: 'report' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unknown' },
    },
    aC = {
        CONFLICT: { name: 'CONFLICT', value: 'conflict' },
        NOT_FOUND: { name: 'NOT_FOUND', value: 'not_found' },
        SERVER_ERROR: { name: 'SERVER_ERROR', value: 'server_error' },
        VALIDATION: { name: 'VALIDATION', value: 'validation' },
    },
    OC = {
        ALREADY_IN_SYNC: { name: 'ALREADY_IN_SYNC', value: 'already_in_sync' },
        CONFLICT: { name: 'CONFLICT', value: 'conflict' },
        ERROR: { name: 'ERROR', value: 'error' },
        SUCCESS: { name: 'SUCCESS', value: 'success' },
    },
    SC = {
        CASE_DETAILS_ASSIGNED_UNIT_REQUIRED_IF_NO_ASSIGNEE: {
            name: 'CASE_DETAILS_ASSIGNED_UNIT_REQUIRED_IF_NO_ASSIGNEE',
            value: 387,
        },
        CASE_DETAILS_ASSIGNEE_REQUIRED_IF_NO_ASSIGNED_UNIT: {
            name: 'CASE_DETAILS_ASSIGNEE_REQUIRED_IF_NO_ASSIGNED_UNIT',
            value: 386,
        },
        CASE_DETAILS_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name: 'CASE_DETAILS_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 380,
        },
        CASE_DETAILS_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name: 'CASE_DETAILS_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 381,
        },
        CASE_DETAILS_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED: {
            name: 'CASE_DETAILS_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED',
            value: 382,
        },
        CASE_DETAILS_LOCAL_ID_REQUIRED_IF_NOT_NEW_CASE: {
            name: 'CASE_DETAILS_LOCAL_ID_REQUIRED_IF_NOT_NEW_CASE',
            value: 509,
        },
        CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS: {
            name: 'CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS',
            value: 369,
        },
        CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS_ASSIGNEE_ASSISTING_INVESTIGATOR: {
            name: 'CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS_ASSIGNEE_ASSISTING_INVESTIGATOR',
            value: 578,
        },
        CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS_ASSISTING_INVESTIGATOR_SUPERVISOR: {
            name: 'CASE_DETAILS_NO_DUPLICATE_CASE_ROLE_LINKS_ASSISTING_INVESTIGATOR_SUPERVISOR',
            value: 579,
        },
        CASE_DETAILS_REPORT_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name:
                'CASE_DETAILS_REPORT_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 383,
        },
        CASE_DETAILS_REPORT_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name:
                'CASE_DETAILS_REPORT_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 384,
        },
        CASE_DETAILS_REPORT_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED: {
            name: 'CASE_DETAILS_REPORT_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED',
            value: 385,
        },
        CASE_REVIEW_MIN_LENGTH_REQUIRED_IF_REJECTED: {
            name: 'CASE_REVIEW_MIN_LENGTH_REQUIRED_IF_REJECTED',
            value: 388,
        },
        CHAIN_EVENT_CHECKED_IN_MAIN_REQUIRES_STORAGE_LOCATION: {
            name: 'CHAIN_EVENT_CHECKED_IN_MAIN_REQUIRES_STORAGE_LOCATION',
            value: 523,
        },
        CHAIN_EVENT_CHECKED_IN_TEMP_REQUIRES_STORAGE_LOCATION: {
            name: 'CHAIN_EVENT_CHECKED_IN_TEMP_REQUIRES_STORAGE_LOCATION',
            value: 576,
        },
        CHAIN_EVENT_CHECKED_OUT_LAB_REQUIRES_FACILITY: {
            name: 'CHAIN_EVENT_CHECKED_OUT_LAB_REQUIRES_FACILITY',
            value: 524,
        },
        CHAIN_EVENT_CHECKED_OUT_PERSON_REQUIRES_RECEIVED_BY_NAME: {
            name: 'CHAIN_EVENT_CHECKED_OUT_PERSON_REQUIRES_RECEIVED_BY_NAME',
            value: 528,
        },
        CHAIN_EVENT_ID_SCAN_REQUIRES_ID_SCAN_ENABLED: {
            name: 'CHAIN_EVENT_ID_SCAN_REQUIRES_ID_SCAN_ENABLED',
            value: 527,
        },
        CHAIN_EVENT_LOCATION_UPDATED_REQUIRES_STORAGE_LOCATION: {
            name: 'CHAIN_EVENT_LOCATION_UPDATED_REQUIRES_STORAGE_LOCATION',
            value: 525,
        },
        CHAIN_EVENT_RELEASED_REQUIRES_RECEIVED_BY_NAME: {
            name: 'CHAIN_EVENT_RELEASED_REQUIRES_RECEIVED_BY_NAME',
            value: 530,
        },
        CHAIN_EVENT_SIGNATURE_REQUIRES_SIGNATURE_ENABLED: {
            name: 'CHAIN_EVENT_SIGNATURE_REQUIRES_SIGNATURE_ENABLED',
            value: 526,
        },
        CHAIN_EVENT_TRANSFERRED_REQUIRES_RECEIVED_BY_NAME: {
            name: 'CHAIN_EVENT_TRANSFERRED_REQUIRES_RECEIVED_BY_NAME',
            value: 529,
        },
        CREATE_REPORT_REPORTING_EVENT_NUMBER_MUST_BE_INT: {
            name: 'CREATE_REPORT_REPORTING_EVENT_NUMBER_MUST_BE_INT',
            value: 363,
        },
        DATE_OF_BIRTH_RANGE: { name: 'DATE_OF_BIRTH_RANGE', value: 92 },
        DEFENDANT_ADDRESS_REQUIRED: { name: 'DEFENDANT_ADDRESS_REQUIRED', value: 206 },
        DEFENDANT_DOB_REQUIRED: { name: 'DEFENDANT_DOB_REQUIRED', value: 304 },
        DEFENDANT_RACE_REQUIRED: { name: 'DEFENDANT_RACE_REQUIRED', value: 302 },
        EMAIL_TYPE_REQUIRED_IF_EMAIL_FILLED: {
            name: 'EMAIL_TYPE_REQUIRED_IF_EMAIL_FILLED',
            value: 202,
        },
        EMPLOYER_NAME_REQUIRED: { name: 'EMPLOYER_NAME_REQUIRED', value: 204 },
        EXPORT_RELEASE_RELEASED_TO_OTHER_REQUIRED: {
            name: 'EXPORT_RELEASE_RELEASED_TO_OTHER_REQUIRED',
            value: 554,
        },
        FIELD_CONFIGURATION_ADMIN_DATE_MIN_MAX_CANNOT_BOTH_BE_NOW: {
            name: 'FIELD_CONFIGURATION_ADMIN_DATE_MIN_MAX_CANNOT_BOTH_BE_NOW',
            value: 548,
        },
        FIELD_CONFIGURATION_ADMIN_MAX_LESS_THAN_OR_EQUAL_TO_FIELD_DETAIL_MAX: {
            name: 'FIELD_CONFIGURATION_ADMIN_MAX_LESS_THAN_OR_EQUAL_TO_FIELD_DETAIL_MAX',
            value: 543,
        },
        FIELD_CONFIGURATION_ADMIN_MIN_GREATER_THAN_OR_EQUAL_TO_FIELD_DETAIL_MIN: {
            name: 'FIELD_CONFIGURATION_ADMIN_MIN_GREATER_THAN_OR_EQUAL_TO_FIELD_DETAIL_MIN',
            value: 542,
        },
        FIELD_CONFIGURATION_ADMIN_MIN_LESS_THAN_OR_EQUAL_TO_MAX: {
            name: 'FIELD_CONFIGURATION_ADMIN_MIN_LESS_THAN_OR_EQUAL_TO_MAX',
            value: 541,
        },
        ID_TYPE_REQUIRED_IF_IDENTIFIER_FILLED: {
            name: 'ID_TYPE_REQUIRED_IF_IDENTIFIER_FILLED',
            value: 203,
        },
        INCIDENT_LOCATION_REQUIRED: { name: 'INCIDENT_LOCATION_REQUIRED', value: 93 },
        INJURIES_CANNOT_HAVE_TYPE_NONE_AND_OTHER_INJURIES: {
            name: 'INJURIES_CANNOT_HAVE_TYPE_NONE_AND_OTHER_INJURIES',
            value: 329,
        },
        INJURY_TYPE_ON_INJURY_OFFENSES_REQUIRED: {
            name: 'INJURY_TYPE_ON_INJURY_OFFENSES_REQUIRED',
            value: 421,
        },
        ITEM_FACILITY_LINK_STORAGE_LOCATION_ID_REQUIRED_FOR_EVIDENCE_WITHOUT_CHAIN_OF_CUSTODY: {
            name:
                'ITEM_FACILITY_LINK_STORAGE_LOCATION_ID_REQUIRED_FOR_EVIDENCE_WITHOUT_CHAIN_OF_CUSTODY',
            value: 574,
        },
        ITEM_IDENTIFIER_BAG_NUMBER_REQUIRED_FOR_EVIDENCE: {
            name: 'ITEM_IDENTIFIER_BAG_NUMBER_REQUIRED_FOR_EVIDENCE',
            value: 563,
        },
        ITEM_PROOF_OF_OWNERSHIP_OTHER_REQUIRED: {
            name: 'ITEM_PROOF_OF_OWNERSHIP_OTHER_REQUIRED',
            value: 359,
        },
        ITEM_PROOF_OF_OWNERSHIP_REQUIRED: { name: 'ITEM_PROOF_OF_OWNERSHIP_REQUIRED', value: 358 },
        ITEM_VEHICLE_BODY_STYLE_OTHER_REQUIRED: {
            name: 'ITEM_VEHICLE_BODY_STYLE_OTHER_REQUIRED',
            value: 361,
        },
        ITEM_VEHICLE_BODY_STYLE_REQUIRED: { name: 'ITEM_VEHICLE_BODY_STYLE_REQUIRED', value: 360 },
        KNOWN_PERSON_DATE_OF_EMANCIPATION_MUST_BE_AFTER_DOB: {
            name: 'KNOWN_PERSON_DATE_OF_EMANCIPATION_MUST_BE_AFTER_DOB',
            value: 340,
        },
        KNOWN_PERSON_SEX_REQUIRED: { name: 'KNOWN_PERSON_SEX_REQUIRED', value: 305 },
        LOCATION_LINK_REQUIRE_DEPARTMENT_SUBDIVISIONS: {
            name: 'LOCATION_LINK_REQUIRE_DEPARTMENT_SUBDIVISIONS',
            value: 338,
        },
        LOCATION_STREET_ADDRESS_OR_CROSS_STREET_REQUIRED: {
            name: 'LOCATION_STREET_ADDRESS_OR_CROSS_STREET_REQUIRED',
            value: 80,
        },
        MILITARY_BRANCH_REQUIRED: { name: 'MILITARY_BRANCH_REQUIRED', value: 205 },
        MISSING_PERSON_DOB_OR_EQUIV_REQUIRED: {
            name: 'MISSING_PERSON_DOB_OR_EQUIV_REQUIRED',
            value: 303,
        },
        MISSING_PERSON_HOME_ADDRESS_REQUIRED: {
            name: 'MISSING_PERSON_HOME_ADDRESS_REQUIRED',
            value: 9,
        },
        MISSING_PERSON_RACE_REQUIRED: { name: 'MISSING_PERSON_RACE_REQUIRED', value: 301 },
        NO_MUTUALLY_EXCLUSIVE_OFFENSES_FOR_SAME_VICTIM: {
            name: 'NO_MUTUALLY_EXCLUSIVE_OFFENSES_FOR_SAME_VICTIM',
            value: 420,
        },
        OFFENSE_AGGRAVATED_ASSAULT_REQUIRED: {
            name: 'OFFENSE_AGGRAVATED_ASSAULT_REQUIRED',
            value: 29,
        },
        OFFENSE_ANIMAL_CRUELTY_REQUIRED: { name: 'OFFENSE_ANIMAL_CRUELTY_REQUIRED', value: 47 },
        OFFENSE_ARSON_BUILDING_INHABITED_REQUIRED_IF_ARSON: {
            name: 'OFFENSE_ARSON_BUILDING_INHABITED_REQUIRED_IF_ARSON',
            value: 496,
        },
        OFFENSE_ARSON_COMPLETED_PROPERTY_STATUS_BURNED: {
            name: 'OFFENSE_ARSON_COMPLETED_PROPERTY_STATUS_BURNED',
            value: 395,
        },
        OFFENSE_ASSAULT_HOMICIDE_COMPLETED_REQUIRED: {
            name: 'OFFENSE_ASSAULT_HOMICIDE_COMPLETED_REQUIRED',
            value: 389,
        },
        OFFENSE_ATTEMPTED_REQUIRES_PROPERTY_STATUS_NONE_UNKNOWN: {
            name: 'OFFENSE_ATTEMPTED_REQUIRES_PROPERTY_STATUS_NONE_UNKNOWN',
            value: 391,
        },
        OFFENSE_ATTRIBUTES_OTHER_REQUIRED: { name: 'OFFENSE_ATTRIBUTES_OTHER_REQUIRED', value: 13 },
        OFFENSE_BNE_ABDUCTION_BRIBERY_COMPLETED_PROPERTY_STATUS_NONE_RECOVERED_STOLEN_UNKNOWN: {
            name:
                'OFFENSE_BNE_ABDUCTION_BRIBERY_COMPLETED_PROPERTY_STATUS_NONE_RECOVERED_STOLEN_UNKNOWN',
            value: 393,
        },
        OFFENSE_BRIBERY_REQUIRES_PROPERTY: {
            name: 'OFFENSE_BRIBERY_REQUIRES_PROPERTY',
            value: 413,
        },
        OFFENSE_BURGLARY_CANNOT_HAVE_SOCIETY_VICTIM: {
            name: 'OFFENSE_BURGLARY_CANNOT_HAVE_SOCIETY_VICTIM',
            value: 317,
        },
        OFFENSE_BURGLARY_REQUIRES_PROPERTY: {
            name: 'OFFENSE_BURGLARY_REQUIRES_PROPERTY',
            value: 414,
        },
        OFFENSE_BURG_NUMBER_OF_PREMISES_ENTERED_REQUIRED: {
            name: 'OFFENSE_BURG_NUMBER_OF_PREMISES_ENTERED_REQUIRED',
            value: 318,
        },
        OFFENSE_BURG_WAS_METHOD_OF_ENTRY_FORCED_REQUIRED: {
            name: 'OFFENSE_BURG_WAS_METHOD_OF_ENTRY_FORCED_REQUIRED',
            value: 19,
        },
        OFFENSE_CERTAIN_OFFENSES_IS_DOMESTIC_VIOLENCE_REQUIRED: {
            name: 'OFFENSE_CERTAIN_OFFENSES_IS_DOMESTIC_VIOLENCE_REQUIRED',
            value: 409,
        },
        OFFENSE_CODE_REQUIRED: { name: 'OFFENSE_CODE_REQUIRED', value: 323 },
        OFFENSE_CRIME_AGAINST_PERSON_HAS_PERSON_VICTIM: {
            name: 'OFFENSE_CRIME_AGAINST_PERSON_HAS_PERSON_VICTIM',
            value: 312,
        },
        OFFENSE_CRIME_AGAINST_PROPERTY_VICTIM_IS_NOT_SOCIETY: {
            name: 'OFFENSE_CRIME_AGAINST_PROPERTY_VICTIM_IS_NOT_SOCIETY',
            value: 311,
        },
        OFFENSE_CRIMINAL_ACTIVITY_CATEGORY_REQUIRED: {
            name: 'OFFENSE_CRIMINAL_ACTIVITY_CATEGORY_REQUIRED',
            value: 33,
        },
        OFFENSE_DAMAGE_COMPLETED_PROPERTY_STATUS_DAMAGED: {
            name: 'OFFENSE_DAMAGE_COMPLETED_PROPERTY_STATUS_DAMAGED',
            value: 397,
        },
        OFFENSE_DATE_OR_DATE_UNKNOWN_REQUIRED: {
            name: 'OFFENSE_DATE_OR_DATE_UNKNOWN_REQUIRED',
            value: 495,
        },
        OFFENSE_DATE_REQUIRED_FOR_LAW_ENFORCEMENT_AS_VICTIM_NIBRS: {
            name: 'OFFENSE_DATE_REQUIRED_FOR_LAW_ENFORCEMENT_AS_VICTIM_NIBRS',
            value: 552,
        },
        OFFENSE_DOMESTIC_VIOLENCE_HAS_KNOWN_PERSON_VICTIM: {
            name: 'OFFENSE_DOMESTIC_VIOLENCE_HAS_KNOWN_PERSON_VICTIM',
            value: 314,
        },
        OFFENSE_DRUGS_COMPLETED_PROPERTY_STATUS_NONE_SEIZED: {
            name: 'OFFENSE_DRUGS_COMPLETED_PROPERTY_STATUS_NONE_SEIZED',
            value: 394,
        },
        OFFENSE_FORGERY_COMPLETED_PROPERTY_STATUS_FORGED_RECOVERED_SEIZED: {
            name: 'OFFENSE_FORGERY_COMPLETED_PROPERTY_STATUS_FORGED_RECOVERED_SEIZED',
            value: 396,
        },
        OFFENSE_GAMBLING_COMPLETED_PROPERTY_STATUS_SEIZED: {
            name: 'OFFENSE_GAMBLING_COMPLETED_PROPERTY_STATUS_SEIZED',
            value: 399,
        },
        OFFENSE_GANG_INFO_REQUIRED: { name: 'OFFENSE_GANG_INFO_REQUIRED', value: 32 },
        OFFENSE_HATE_BIAS: { name: 'OFFENSE_HATE_BIAS', value: 28 },
        OFFENSE_HOMICIDE_CIRCUMSTANCE_REQUIRED: {
            name: 'OFFENSE_HOMICIDE_CIRCUMSTANCE_REQUIRED',
            value: 30,
        },
        OFFENSE_INCLUDES_CARGO_THEFT_REQUIRED: {
            name: 'OFFENSE_INCLUDES_CARGO_THEFT_REQUIRED',
            value: 18,
        },
        OFFENSE_IS_LEOKA_REQUIRED: { name: 'OFFENSE_IS_LEOKA_REQUIRED', value: 34 },
        OFFENSE_ITEM_CATEGORY_DOCUMENTS_CREDIT_CARDS_DECLARED_VALUE_ZERO: {
            name: 'OFFENSE_ITEM_CATEGORY_DOCUMENTS_CREDIT_CARDS_DECLARED_VALUE_ZERO',
            value: 404,
        },
        OFFENSE_ITEM_CATEGORY_VEHICLE_QUANTITY_ONE: {
            name: 'OFFENSE_ITEM_CATEGORY_VEHICLE_QUANTITY_ONE',
            value: 405,
        },
        OFFENSE_JUSTIFIABLE_HOMICIDE_HATE_CRIME_NONE: {
            name: 'OFFENSE_JUSTIFIABLE_HOMICIDE_HATE_CRIME_NONE',
            value: 390,
        },
        OFFENSE_JUSTIFIABLE_HOMICIDE_REQUIRED: {
            name: 'OFFENSE_JUSTIFIABLE_HOMICIDE_REQUIRED',
            value: 14,
        },
        OFFENSE_KIDNAPPING_ABDUCTION_REQUIRES_PROPERTY: {
            name: 'OFFENSE_KIDNAPPING_ABDUCTION_REQUIRES_PROPERTY',
            value: 412,
        },
        OFFENSE_LARCENY_CANNOT_HAVE_STOLEN_VEHICLE: {
            name: 'OFFENSE_LARCENY_CANNOT_HAVE_STOLEN_VEHICLE',
            value: 319,
        },
        OFFENSE_LEOKA_ACTIVITY_REQUIRED: { name: 'OFFENSE_LEOKA_ACTIVITY_REQUIRED', value: 135 },
        OFFENSE_LEOKA_ASSIGNMENT_TYPE_REQUIRED: {
            name: 'OFFENSE_LEOKA_ASSIGNMENT_TYPE_REQUIRED',
            value: 36,
        },
        OFFENSE_LOCATION_REQUIRED: { name: 'OFFENSE_LOCATION_REQUIRED', value: 21 },
        OFFENSE_MARIJUANA_OPIUM_HALLUCINOGENS_NUMBER_OF_PLANTS: {
            name: 'OFFENSE_MARIJUANA_OPIUM_HALLUCINOGENS_NUMBER_OF_PLANTS',
            value: 406,
        },
        OFFENSE_NEGLIGENT_MANSLAUGHTER_REQUIRED: {
            name: 'OFFENSE_NEGLIGENT_MANSLAUGHTER_REQUIRED',
            value: 15,
        },
        OFFENSE_PROPERTY_LOSS_DECLARED_VALUE_REQUIRED: {
            name: 'OFFENSE_PROPERTY_LOSS_DECLARED_VALUE_REQUIRED',
            value: 400,
        },
        OFFENSE_PROPERTY_STATUSES_REQUIRED: {
            name: 'OFFENSE_PROPERTY_STATUSES_REQUIRED',
            value: 24,
        },
        OFFENSE_RAPE_VICTIM_SEX_MALE_FEMALE_REQUIRED: {
            name: 'OFFENSE_RAPE_VICTIM_SEX_MALE_FEMALE_REQUIRED',
            value: 408,
        },
        OFFENSE_REPORT_OFFENSE_OR_INCIDENT_REQUIRED: {
            name: 'OFFENSE_REPORT_OFFENSE_OR_INCIDENT_REQUIRED',
            value: 346,
        },
        OFFENSE_SEX_ASSAULT_HAS_KNOWN_PERSON_VICTIM: {
            name: 'OFFENSE_SEX_ASSAULT_HAS_KNOWN_PERSON_VICTIM',
            value: 313,
        },
        OFFENSE_STATEMENT_TAKEN_REQUIRED: { name: 'OFFENSE_STATEMENT_TAKEN_REQUIRED', value: 137 },
        OFFENSE_STOLEN_PROPERTY_COMPLETED_PROPERTY_STATUS_NONE_RECOVERED: {
            name: 'OFFENSE_STOLEN_PROPERTY_COMPLETED_PROPERTY_STATUS_NONE_RECOVERED',
            value: 392,
        },
        OFFENSE_SUSPECTED_HATE_CRIME_REQUIRED: {
            name: 'OFFENSE_SUSPECTED_HATE_CRIME_REQUIRED',
            value: 309,
        },
        OFFENSE_SUSPECT_DOB_OR_EQUIV_REQUIRED: {
            name: 'OFFENSE_SUSPECT_DOB_OR_EQUIV_REQUIRED',
            value: 27,
        },
        OFFENSE_SUSPECT_REQUIRED: { name: 'OFFENSE_SUSPECT_REQUIRED', value: 23 },
        OFFENSE_THEFT_FRAUD_COMPLETED_PROPERTY_STATUS_RECOVERED_STOLEN: {
            name: 'OFFENSE_THEFT_FRAUD_COMPLETED_PROPERTY_STATUS_RECOVERED_STOLEN',
            value: 398,
        },
        OFFENSE_VICTIM_ADDRESS_REQUIRED: { name: 'OFFENSE_VICTIM_ADDRESS_REQUIRED', value: 25 },
        OFFENSE_VICTIM_DOB_OR_EQUIV_REQUIRED: {
            name: 'OFFENSE_VICTIM_DOB_OR_EQUIV_REQUIRED',
            value: 26,
        },
        OFFENSE_VICTIM_REQUIRED: { name: 'OFFENSE_VICTIM_REQUIRED', value: 22 },
        OFFENSE_WEAPON_OR_FORCE_INVOLVED_REQUIRED: {
            name: 'OFFENSE_WEAPON_OR_FORCE_INVOLVED_REQUIRED',
            value: 31,
        },
        ORG_INDUSTRY_OTHER_REQUIRED: { name: 'ORG_INDUSTRY_OTHER_REQUIRED', value: 328 },
        ORG_PHONE_SPECIAL_MAX_LENGTH: { name: 'ORG_PHONE_SPECIAL_MAX_LENGTH', value: 208 },
        ORG_PHONE_TYPE_REQUIRED_IF_NUMBER_FILLED: {
            name: 'ORG_PHONE_TYPE_REQUIRED_IF_NUMBER_FILLED',
            value: 209,
        },
        ORG_VICTIMS_ADDRESS_REQUIRED: { name: 'ORG_VICTIMS_ADDRESS_REQUIRED', value: 306 },
        PERSON_DRIVER_LICENSE_OTHER_REQUIRED: {
            name: 'PERSON_DRIVER_LICENSE_OTHER_REQUIRED',
            value: 82,
        },
        PERSON_RAPE_VICTIM_SEX_MALE_FEMALE_REQUIRED: {
            name: 'PERSON_RAPE_VICTIM_SEX_MALE_FEMALE_REQUIRED',
            value: 407,
        },
        PERSON_SCHOOL_HISTORY_DISPLAY_NUMBER_SPECIAL_MAX_LENGTH: {
            name: 'PERSON_SCHOOL_HISTORY_DISPLAY_NUMBER_SPECIAL_MAX_LENGTH',
            value: 88,
        },
        PHONE_SPECIAL_MAX_LENGTH: { name: 'PHONE_SPECIAL_MAX_LENGTH', value: 200 },
        PHONE_TYPE_REQUIRED_IF_NUMBER_FILLED: {
            name: 'PHONE_TYPE_REQUIRED_IF_NUMBER_FILLED',
            value: 201,
        },
        PROPERTY_STATUS_RECOVERED_BY_OTHER_NAME_REQUIRED: {
            name: 'PROPERTY_STATUS_RECOVERED_BY_OTHER_NAME_REQUIRED',
            value: 86,
        },
        PROPERTY_STATUS_VEHICLE_SEARCH_CONSENT_REQUIRED: {
            name: 'PROPERTY_STATUS_VEHICLE_SEARCH_CONSENT_REQUIRED',
            value: 356,
        },
        RELATIONSHIP_ON_RELATIONSHIP_OFFENSES_REQUIRED: {
            name: 'RELATIONSHIP_ON_RELATIONSHIP_OFFENSES_REQUIRED',
            value: 494,
        },
        RELATIONSHIP_ON_RELATIONSHIP_OFFENSES_REQUIRED_NIBRS: {
            name: 'RELATIONSHIP_ON_RELATIONSHIP_OFFENSES_REQUIRED_NIBRS',
            value: 564,
        },
        REPORT_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name: 'REPORT_CASE_STATUS_CLOSED_BY_DIVISION_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 565,
        },
        REPORT_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED: {
            name: 'REPORT_CASE_STATUS_CLOSED_BY_UNIT_ATTR_ID_REQUIRED_IF_STATUS_CLOSED',
            value: 566,
        },
        REPORT_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED: {
            name: 'REPORT_CASE_STATUS_STATUS_DATE_UTC_REQUIRED_IF_STATUS_CLOSED',
            value: 567,
        },
        RETENTION_POLICY_REQUIRES_PERIOD_OR_IS_INFINITE: {
            name: 'RETENTION_POLICY_REQUIRES_PERIOD_OR_IS_INFINITE',
            value: 537,
        },
        TOW_VEHICLE_OWNER_REQUIRES_HOME_ADDRESS: {
            name: 'TOW_VEHICLE_OWNER_REQUIRES_HOME_ADDRESS',
            value: 482,
        },
        TOW_VEHICLE_OWNER_REQUIRES_PHONE_NUMBER: {
            name: 'TOW_VEHICLE_OWNER_REQUIRES_PHONE_NUMBER',
            value: 481,
        },
        TOW_VEHICLE_REQUIRES_OWNER: { name: 'TOW_VEHICLE_REQUIRES_OWNER', value: 480 },
        UCR_EVENT_NUMBER_OF_SENIOR_CITIZEN_VICTIMS_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_EVENT_NUMBER_OF_SENIOR_CITIZEN_VICTIMS_REQUIRED_WHEN_SHOWN',
            value: 553,
        },
        UCR_EVENT_WEAPON_OR_FORCE_INVOLVED_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_EVENT_WEAPON_OR_FORCE_INVOLVED_REQUIRED_WHEN_SHOWN',
            value: 510,
        },
        UCR_IS_DOMESTIC_VIOLENCE_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_IS_DOMESTIC_VIOLENCE_REQUIRED_WHEN_SHOWN',
            value: 580,
        },
        UCR_OFFENSE_ADDITIONAL_UCR_CODES_MUST_BE_ARSON_HUMAN_TRAFFICKING_OR_HOMICIDE: {
            name: 'UCR_OFFENSE_ADDITIONAL_UCR_CODES_MUST_BE_ARSON_HUMAN_TRAFFICKING_OR_HOMICIDE',
            value: 532,
        },
        UCR_OFFENSE_ADDITIONAL_UCR_CODE_HOMICIDE_MUST_HAVE_UCR_STATUS_UNFOUNDED: {
            name: 'UCR_OFFENSE_ADDITIONAL_UCR_CODE_HOMICIDE_MUST_HAVE_UCR_STATUS_UNFOUNDED',
            value: 533,
        },
        UCR_OFFENSE_ARSON_LOCATION_CODE_ID_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_ARSON_LOCATION_CODE_ID_REQUIRED_WHEN_SHOWN',
            value: 583,
        },
        UCR_OFFENSE_BUILDING_INHABITED_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_BUILDING_INHABITED_REQUIRED_WHEN_SHOWN',
            value: 513,
        },
        UCR_OFFENSE_BURGLARY_RESIDENCE_TYPE_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_BURGLARY_RESIDENCE_TYPE_REQUIRED_WHEN_SHOWN',
            value: 514,
        },
        UCR_OFFENSE_BURGLARY_TIME_AND_PLACE: {
            name: 'UCR_OFFENSE_BURGLARY_TIME_AND_PLACE',
            value: 518,
        },
        UCR_OFFENSE_BURGLARY_TIME_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_BURGLARY_TIME_REQUIRED_WHEN_SHOWN',
            value: 550,
        },
        UCR_OFFENSE_HOMICIDE_CODE_ID_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_HOMICIDE_CODE_ID_REQUIRED_WHEN_SHOWN',
            value: 584,
        },
        UCR_OFFENSE_HOMICIDE_WEAPON_OR_FORCE_INVOLVED_CODE_ID_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_HOMICIDE_WEAPON_OR_FORCE_INVOLVED_CODE_ID_REQUIRED_WHEN_SHOWN',
            value: 582,
        },
        UCR_OFFENSE_LARCENY_AMOUNT_MATCHES_STOLEN_PROPERTY: {
            name: 'UCR_OFFENSE_LARCENY_AMOUNT_MATCHES_STOLEN_PROPERTY',
            value: 534,
        },
        UCR_OFFENSE_LARCENY_THEFT_CATEGORY_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_LARCENY_THEFT_CATEGORY_REQUIRED_WHEN_SHOWN',
            value: 515,
        },
        UCR_OFFENSE_NEGLIGENT_MANSLAUGHTER_CODE_ID_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_NEGLIGENT_MANSLAUGHTER_CODE_ID_REQUIRED_WHEN_SHOWN',
            value: 585,
        },
        UCR_OFFENSE_NO_DUPLICATE_CODES: { name: 'UCR_OFFENSE_NO_DUPLICATE_CODES', value: 531 },
        UCR_OFFENSE_ONLY_ONE_ARSON_OFFENSE_PER_REPORT: {
            name: 'UCR_OFFENSE_ONLY_ONE_ARSON_OFFENSE_PER_REPORT',
            value: 536,
        },
        UCR_OFFENSE_ONLY_ONE_LARCENY: { name: 'UCR_OFFENSE_ONLY_ONE_LARCENY', value: 517 },
        UCR_OFFENSE_OR_EVENT_CLASSIFICATION_REQUIRED: {
            name: 'UCR_OFFENSE_OR_EVENT_CLASSIFICATION_REQUIRED',
            value: 516,
        },
        UCR_OFFENSE_RELATIONSHIP_CODE_ID_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_RELATIONSHIP_CODE_ID_REQUIRED_WHEN_SHOWN',
            value: 581,
        },
        UCR_OFFENSE_ROBBERY_LOCATION_TYPE_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_OFFENSE_ROBBERY_LOCATION_TYPE_REQUIRED_WHEN_SHOWN',
            value: 511,
        },
        UCR_OFFENSE_ROBBERY_PLACE: { name: 'UCR_OFFENSE_ROBBERY_PLACE', value: 519 },
        UCR_PROPERTY_BURNED_REQUIRE_ONE_UCR_OFFENSE_ARSON: {
            name: 'UCR_PROPERTY_BURNED_REQUIRE_ONE_UCR_OFFENSE_ARSON',
            value: 522,
        },
        UCR_PROPERTY_NO_STOLEN_PROPERTY_IF_OFFENSE_IS_ASSAULT: {
            name: 'UCR_PROPERTY_NO_STOLEN_PROPERTY_IF_OFFENSE_IS_ASSAULT',
            value: 535,
        },
        UCR_PROPERTY_RECOVERY_DATE_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_PROPERTY_RECOVERY_DATE_REQUIRED_WHEN_SHOWN',
            value: 521,
        },
        UCR_PROPERTY_RECOVERY_TYPE_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_PROPERTY_RECOVERY_TYPE_REQUIRED_WHEN_SHOWN',
            value: 520,
        },
        UCR_SUFFOCATION_OR_STRANGULATION_REQUIRED_WHEN_SHOWN: {
            name: 'UCR_SUFFOCATION_OR_STRANGULATION_REQUIRED_WHEN_SHOWN',
            value: 575,
        },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        USE_OF_FORCE_REPORT_SUBJECT_CARD_REQUIRED: {
            name: 'USE_OF_FORCE_REPORT_SUBJECT_CARD_REQUIRED',
            value: 342,
        },
        USE_OF_FORCE_REPORT_SUBJECT_OR_OFFICER_MUST_HAVE_USED_FORCE: {
            name: 'USE_OF_FORCE_REPORT_SUBJECT_OR_OFFICER_MUST_HAVE_USED_FORCE',
            value: 434,
        },
        VICTIM_RACE_REQUIRED: { name: 'VICTIM_RACE_REQUIRED', value: 300 },
        WARRANT_REQUIRES_CHARGES: { name: 'WARRANT_REQUIRES_CHARGES', value: 545 },
    },
    CC = {
        BOAT: { name: 'BOAT' },
        CASE: { name: 'CASE' },
        DRIVERLICENSE: { name: 'DRIVERLICENSE' },
        GUN: { name: 'GUN' },
        IMAGE: { name: 'IMAGE' },
        LICENSEPLATE: { name: 'LICENSEPLATE' },
        PERSON: { name: 'PERSON' },
        PROPERTY: { name: 'PROPERTY' },
        REGISTRATION: { name: 'REGISTRATION' },
        TRANSACTION: { name: 'TRANSACTION' },
        VEHICLE: { name: 'VEHICLE' },
    },
    nC = {
        FAILED: { name: 'FAILED' },
        IMMUTABLE_CONTENT_CHANGED: { name: 'IMMUTABLE_CONTENT_CHANGED' },
        SUCCESS: { name: 'SUCCESS' },
    },
    DC = {
        DEPT_CONFIG: { name: 'DEPT_CONFIG' },
        ENGINE_CONTENT: { name: 'ENGINE_CONTENT' },
        GENERATED_LOADER: { name: 'GENERATED_LOADER' },
        GOLDEN: { name: 'GOLDEN' },
        PLATFORM_ENGINE_SIBLING: { name: 'PLATFORM_ENGINE_SIBLING' },
        UNKNOWN: { name: 'UNKNOWN' },
    },
    LC = { REDIS: { name: 'REDIS' }, SYSTEM: { name: 'SYSTEM' } },
    mC = {
        COMPLETED: { name: 'COMPLETED', value: 2 },
        EXECUTING: { name: 'EXECUTING', value: 3 },
        QUEUED: { name: 'QUEUED', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    lC = { EVENT_PRIORITY: { name: 'EVENT_PRIORITY' }, UNIT_STATE: { name: 'UNIT_STATE' } },
    uC = {
        ADD_TO_INVESTIGATIONS: { name: 'ADD_TO_INVESTIGATIONS', value: 134217728 },
        BOOKING: { name: 'BOOKING', value: 8 },
        CHANGE_EVENT_NUMBER: { name: 'CHANGE_EVENT_NUMBER', value: 1024 },
        CHANGE_OWNER: { name: 'CHANGE_OWNER', value: 512 },
        CHANGE_RECORD_ID: { name: 'CHANGE_RECORD_ID', value: 8192 },
        CREATE_LINKED_REPORT: { name: 'CREATE_LINKED_REPORT', value: 32 },
        CREATE_NEW_E_FILE: { name: 'CREATE_NEW_E_FILE', value: 262144 },
        CREATE_NEW_INVESTIGATION: { name: 'CREATE_NEW_INVESTIGATION', value: 67108864 },
        CREATE_SUBMISSION: { name: 'CREATE_SUBMISSION', value: 524288 },
        CREATE_TASK: { name: 'CREATE_TASK', value: 268435456 },
        DELETE_REPORT: { name: 'DELETE_REPORT', value: 68719476736 },
        DUPLICATE: { name: 'DUPLICATE', value: 64 },
        EDIT_ARREST_UCR_CLASSIFICATION: {
            name: 'EDIT_ARREST_UCR_CLASSIFICATION',
            value: 4294967296,
        },
        EDIT_ASSOCIATED_RECORDS: { name: 'EDIT_ASSOCIATED_RECORDS', value: 131072 },
        EDIT_ATTACHMENTS: { name: 'EDIT_ATTACHMENTS', value: 65536 },
        EDIT_CHARGES: { name: 'EDIT_CHARGES', value: 1048576 },
        EDIT_CRIMINAL_STREET_GANG_TRACKING: {
            name: 'EDIT_CRIMINAL_STREET_GANG_TRACKING',
            value: 17179869184,
        },
        EDIT_DETENTION_DISPOSITION: { name: 'EDIT_DETENTION_DISPOSITION', value: 4194304 },
        EDIT_REPORT_STATUS: { name: 'EDIT_REPORT_STATUS', value: 33554432 },
        EDIT_SECURITY_CLASSIFICATIONS: { name: 'EDIT_SECURITY_CLASSIFICATIONS', value: 32768 },
        EDIT_TOW_VEHICLE_CHECK_IN: { name: 'EDIT_TOW_VEHICLE_CHECK_IN', value: 8388608 },
        EDIT_TOW_VEHICLE_RELEASE: { name: 'EDIT_TOW_VEHICLE_RELEASE', value: 16777216 },
        EDIT_UCR_CLASSIFICATION: { name: 'EDIT_UCR_CLASSIFICATION', value: 8589934592 },
        EXPORT: { name: 'EXPORT', value: 1 },
        HISTORY: { name: 'HISTORY', value: 4 },
        MORE_OPTIONS: { name: 'MORE_OPTIONS', value: 128 },
        OTHER_VIEWERS: { name: 'OTHER_VIEWERS', value: 16 },
        PERMISSIONS: { name: 'PERMISSIONS', value: 2 },
        REMOVE_RECORD_ID: { name: 'REMOVE_RECORD_ID', value: 4096 },
        REMOVE_REN: { name: 'REMOVE_REN', value: 2048 },
        RETURN_TO_DRAFT: { name: 'RETURN_TO_DRAFT', value: 256 },
        RETURN_TO_UNASSIGNED_QUEUE: { name: 'RETURN_TO_UNASSIGNED_QUEUE', value: 16384 },
        SEAL: { name: 'SEAL', value: 536870912 },
        SEND_ARREST_TO_BOOKING: { name: 'SEND_ARREST_TO_BOOKING', value: 2097152 },
        SEND_TO_CLIPS: { name: 'SEND_TO_CLIPS', value: 34359738368 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        UNSEAL: { name: 'UNSEAL', value: 1073741824 },
        VACATE_CHARGES: { name: 'VACATE_CHARGES', value: 2147483648 },
    },
    PC = { CREATED: { name: 'CREATED' }, PREEXISTING: { name: 'PREEXISTING' } },
    UC = {
        ASSIGN_USER_TO_EVENT: { name: 'ASSIGN_USER_TO_EVENT', value: 2 },
        VIEW_EVENT: { name: 'VIEW_EVENT', value: 1 },
    },
    MC = {
        EXPORT_GENERATION_ERROR: {
            name: 'EXPORT_GENERATION_ERROR',
            value: 'EXPORT_GENERATION_ERROR',
        },
        HISTORY_TRACKING_ERROR: { name: 'HISTORY_TRACKING_ERROR', value: 'HISTORY_TRACKING_ERROR' },
        IMAGE_ATTACHMENT_ERROR: { name: 'IMAGE_ATTACHMENT_ERROR', value: 'IMAGE_ATTACHMENT_ERROR' },
        STATE_AUTHENTICATION_ERROR: {
            name: 'STATE_AUTHENTICATION_ERROR',
            value: 'STATE_AUTHENTICATION_ERROR',
        },
        STATE_AUTHORIZATION_ERROR: {
            name: 'STATE_AUTHORIZATION_ERROR',
            value: 'STATE_AUTHORIZATION_ERROR',
        },
        STATE_SUBMISSION_ERROR: { name: 'STATE_SUBMISSION_ERROR', value: 'STATE_SUBMISSION_ERROR' },
        VALIDATION_ERROR: { name: 'VALIDATION_ERROR', value: 'VALIDATION_ERROR' },
    },
    vC = {
        INCLUDE_EVENT_LOCATION: { name: 'INCLUDE_EVENT_LOCATION', value: 'INCLUDE_EVENT_LOCATION' },
        ORIGINAL_EVENT_RMS_EVENT_ID: {
            name: 'ORIGINAL_EVENT_RMS_EVENT_ID',
            value: 'ORIGINAL_EVENT_RMS_EVENT_ID',
        },
    },
    FC = {
        AED_ASSIGNED_TO_MY_UNIT: { name: 'AED_ASSIGNED_TO_MY_UNIT', value: 12 },
        AED_ATTEMPTING_ACCEPTING: { name: 'AED_ATTEMPTING_ACCEPTING', value: 7 },
        BOLO_RECEIVED: { name: 'BOLO_RECEIVED', value: 4 },
        DEX_HOT_HIT: { name: 'DEX_HOT_HIT', value: 5 },
        DRAFT_EVENT_TIMER_EXPIRED: { name: 'DRAFT_EVENT_TIMER_EXPIRED', value: 9 },
        EMERGENCY: { name: 'EMERGENCY', value: 6 },
        ENTERED_STATE: { name: 'ENTERED_STATE', value: 11 },
        EVENT_ASSIGNED_TO_MY_UNIT: { name: 'EVENT_ASSIGNED_TO_MY_UNIT', value: 2 },
        EVENT_UNASSIGNED_TIMER_EXPIRED: { name: 'EVENT_UNASSIGNED_TIMER_EXPIRED', value: 10 },
        MESSAGE_RECEIVED: { name: 'MESSAGE_RECEIVED', value: 3 },
        NEW_EVENT: { name: 'NEW_EVENT', value: 1 },
        UNIT_TIMER_EXPIRED: { name: 'UNIT_TIMER_EXPIRED', value: 8 },
    },
    GC = { OCCURRENCE: { name: 'OCCURRENCE' }, TRANSITION: { name: 'TRANSITION' } },
    HC = {
        EMAIL: { name: 'EMAIL', value: 2 },
        PHONE_NUMBER: { name: 'PHONE_NUMBER', value: 1 },
        SECURITY_QUESTION: { name: 'SECURITY_QUESTION', value: 3 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    YC = {
        COUNTER: { name: 'COUNTER' },
        GAUGE: { name: 'GAUGE' },
        HISTOGRAM: { name: 'HISTOGRAM' },
    },
    tC = {
        HOME: { name: 'HOME', value: 'home' },
        MOBILE: { name: 'MOBILE', value: 'mobile' },
        WORK: { name: 'WORK', value: 'work' },
    },
    VC = {
        _1: { name: '_1' },
        _2: { name: '_2' },
        _3: { name: '_3' },
        _4: { name: '_4' },
        _5: { name: '_5' },
        _6: { name: '_6' },
        _7: { name: '_7' },
        _8: { name: '_8' },
        _X: { name: '_X' },
    },
    oC = {
        I: { name: 'I', value: 1 },
        II: { name: 'II', value: 2 },
        III: { name: 'III', value: 3 },
        IV: { name: 'IV', value: 4 },
        IX: { name: 'IX', value: 9 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        V: { name: 'V', value: 5 },
        VI: { name: 'VI', value: 6 },
        VII: { name: 'VII', value: 7 },
        VIII: { name: 'VIII', value: 8 },
        X: { name: 'X', value: 10 },
        XI: { name: 'XI', value: 11 },
        XII: { name: 'XII', value: 12 },
        XIII: { name: 'XIII', value: 13 },
        XIV: { name: 'XIV', value: 14 },
        XIX: { name: 'XIX', value: 19 },
        XV: { name: 'XV', value: 15 },
        XVI: { name: 'XVI', value: 16 },
        XVII: { name: 'XVII', value: 17 },
        XVIII: { name: 'XVIII', value: 18 },
        XX: { name: 'XX', value: 20 },
        XXI: { name: 'XXI', value: 21 },
        XXII: { name: 'XXII', value: 22 },
        XXIII: { name: 'XXIII', value: 23 },
        XXIV: { name: 'XXIV', value: 24 },
        XXIX: { name: 'XXIX', value: 29 },
        XXV: { name: 'XXV', value: 25 },
        XXVI: { name: 'XXVI', value: 26 },
        XXVII: { name: 'XXVII', value: 27 },
        XXVIII: { name: 'XXVIII', value: 28 },
        XXX: { name: 'XXX', value: 30 },
        XXXI: { name: 'XXXI', value: 31 },
    },
    BC = {
        FL_10A: { name: 'FL_10A', value: 85 },
        FL_10B: { name: 'FL_10B', value: 86 },
        FL_11: { name: 'FL_11', value: 87 },
        FL_13A: { name: 'FL_13A', value: 88 },
        FL_13B: { name: 'FL_13B', value: 89 },
        FL_13C: { name: 'FL_13C', value: 90 },
        FL_13D: { name: 'FL_13D', value: 91 },
        FL_13E: { name: 'FL_13E', value: 92 },
        FL_14: { name: 'FL_14', value: 93 },
        FL_15: { name: 'FL_15', value: 94 },
        FL_17: { name: 'FL_17', value: 95 },
        FL_18A: { name: 'FL_18A', value: 96 },
        FL_18B: { name: 'FL_18B', value: 97 },
        FL_19: { name: 'FL_19', value: 98 },
        FL_1C: { name: 'FL_1C', value: 75 },
        FL_20: { name: 'FL_20', value: 99 },
        FL_21: { name: 'FL_21', value: 100 },
        FL_22: { name: 'FL_22', value: 101 },
        FL_23: { name: 'FL_23', value: 102 },
        FL_24: { name: 'FL_24', value: 103 },
        FL_25_M: { name: 'FL_25_M', value: 104 },
        FL_2C: { name: 'FL_2C', value: 108 },
        FL_2D: { name: 'FL_2D', value: 76 },
        FL_3: { name: 'FL_3', value: 107 },
        FL_4A: { name: 'FL_4A', value: 77 },
        FL_4B: { name: 'FL_4B', value: 78 },
        FL_4C: { name: 'FL_4C', value: 79 },
        FL_4D: { name: 'FL_4D', value: 80 },
        FL_4E: { name: 'FL_4E', value: 81 },
        FL_7C: { name: 'FL_7C', value: 82 },
        FL_7D: { name: 'FL_7D', value: 83 },
        FL_8: { name: 'FL_8', value: 84 },
        FL_8A: { name: 'FL_8A', value: 105 },
        FL_8B: { name: 'FL_8B', value: 106 },
        NY_1: { name: 'NY_1', value: 109 },
        NY_10: { name: 'NY_10', value: 118 },
        NY_11: { name: 'NY_11', value: 119 },
        NY_12: { name: 'NY_12', value: 120 },
        NY_13: { name: 'NY_13', value: 121 },
        NY_14: { name: 'NY_14', value: 122 },
        NY_15: { name: 'NY_15', value: 123 },
        NY_16: { name: 'NY_16', value: 124 },
        NY_17: { name: 'NY_17', value: 125 },
        NY_18: { name: 'NY_18', value: 126 },
        NY_19: { name: 'NY_19', value: 127 },
        NY_2: { name: 'NY_2', value: 110 },
        NY_20: { name: 'NY_20', value: 128 },
        NY_21: { name: 'NY_21', value: 129 },
        NY_22: { name: 'NY_22', value: 130 },
        NY_23: { name: 'NY_23', value: 131 },
        NY_24: { name: 'NY_24', value: 132 },
        NY_25: { name: 'NY_25', value: 133 },
        NY_26: { name: 'NY_26', value: 134 },
        NY_27: { name: 'NY_27', value: 135 },
        NY_28: { name: 'NY_28', value: 136 },
        NY_29: { name: 'NY_29', value: 137 },
        NY_3: { name: 'NY_3', value: 111 },
        NY_30: { name: 'NY_30', value: 138 },
        NY_31: { name: 'NY_31', value: 139 },
        NY_32: { name: 'NY_32', value: 140 },
        NY_33: { name: 'NY_33', value: 141 },
        NY_34: { name: 'NY_34', value: 142 },
        NY_35: { name: 'NY_35', value: 143 },
        NY_36: { name: 'NY_36', value: 144 },
        NY_37: { name: 'NY_37', value: 145 },
        NY_38: { name: 'NY_38', value: 146 },
        NY_39: { name: 'NY_39', value: 147 },
        NY_4: { name: 'NY_4', value: 112 },
        NY_40: { name: 'NY_40', value: 148 },
        NY_41: { name: 'NY_41', value: 149 },
        NY_42: { name: 'NY_42', value: 150 },
        NY_43: { name: 'NY_43', value: 151 },
        NY_44: { name: 'NY_44', value: 152 },
        NY_45: { name: 'NY_45', value: 153 },
        NY_46: { name: 'NY_46', value: 154 },
        NY_47: { name: 'NY_47', value: 155 },
        NY_49: { name: 'NY_49', value: 156 },
        NY_5: { name: 'NY_5', value: 113 },
        NY_50: { name: 'NY_50', value: 158 },
        NY_6: { name: 'NY_6', value: 114 },
        NY_7: { name: 'NY_7', value: 115 },
        NY_8: { name: 'NY_8', value: 116 },
        NY_9: { name: 'NY_9', value: 117 },
        NY_99: { name: 'NY_99', value: 157 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        _10: { name: '_10', value: 41 },
        _11: { name: '_11', value: 42 },
        _12: { name: '_12', value: 43 },
        _13: { name: '_13', value: 44 },
        _14: { name: '_14', value: 45 },
        _15: { name: '_15', value: 46 },
        _16A: { name: '_16A', value: 47 },
        _16B: { name: '_16B', value: 48 },
        _16C: { name: '_16C', value: 49 },
        _17: { name: '_17', value: 50 },
        _18A: { name: '_18A', value: 51 },
        _18B: { name: '_18B', value: 52 },
        _18C: { name: '_18C', value: 53 },
        _18D: { name: '_18D', value: 54 },
        _18E: { name: '_18E', value: 55 },
        _18F: { name: '_18F', value: 56 },
        _18G: { name: '_18G', value: 57 },
        _18H: { name: '_18H', value: 58 },
        _19A: { name: '_19A', value: 59 },
        _19B: { name: '_19B', value: 60 },
        _19C: { name: '_19C', value: 61 },
        _1A: { name: '_1A', value: 1 },
        _1B: { name: '_1B', value: 2 },
        _20: { name: '_20', value: 62 },
        _21: { name: '_21', value: 63 },
        _22: { name: '_22', value: 64 },
        _23: { name: '_23', value: 65 },
        _24: { name: '_24', value: 66 },
        _25: { name: '_25', value: 67 },
        _26: { name: '_26', value: 68 },
        _27: { name: '_27', value: 69 },
        _28: { name: '_28', value: 70 },
        _29: { name: '_29', value: 71 },
        _2A: { name: '_2A', value: 3 },
        _2B: { name: '_2B', value: 4 },
        _2C: { name: '_2C', value: 5 },
        _30: { name: '_30', value: 72 },
        _31: { name: '_31', value: 73 },
        _3A: { name: '_3A', value: 6 },
        _3B: { name: '_3B', value: 7 },
        _3C: { name: '_3C', value: 8 },
        _3D: { name: '_3D', value: 9 },
        _4A: { name: '_4A', value: 10 },
        _4B: { name: '_4B', value: 11 },
        _4C: { name: '_4C', value: 12 },
        _4D: { name: '_4D', value: 13 },
        _4E: { name: '_4E', value: 14 },
        _5A: { name: '_5A', value: 15 },
        _5B: { name: '_5B', value: 16 },
        _5C: { name: '_5C', value: 17 },
        _6A: { name: '_6A', value: 18 },
        _6B: { name: '_6B', value: 19 },
        _6C: { name: '_6C', value: 20 },
        _6D: { name: '_6D', value: 21 },
        _6E: { name: '_6E', value: 22 },
        _6F: { name: '_6F', value: 23 },
        _6G: { name: '_6G', value: 24 },
        _6H: { name: '_6H', value: 25 },
        _6I: { name: '_6I', value: 26 },
        _7A: { name: '_7A', value: 27 },
        _7B: { name: '_7B', value: 28 },
        _7C: { name: '_7C', value: 29 },
        _8A: { name: '_8A', value: 30 },
        _8B: { name: '_8B', value: 31 },
        _8C: { name: '_8C', value: 32 },
        _8D: { name: '_8D', value: 33 },
        _8E: { name: '_8E', value: 34 },
        _8F: { name: '_8F', value: 35 },
        _8G: { name: '_8G', value: 36 },
        _8H: { name: '_8H', value: 37 },
        _8I: { name: '_8I', value: 38 },
        _8J: { name: '_8J', value: 39 },
        _9: { name: '_9', value: 40 },
        _999: { name: '_999', value: 74 },
    },
    rC = {
        I: { name: 'I', value: 1 },
        II: { name: 'II', value: 2 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    sC = {
        FIELD: { name: 'FIELD', value: 1 },
        FIELDSET: { name: 'FIELDSET', value: 2 },
        FORM_REFERENCE: { name: 'FORM_REFERENCE', value: 4 },
        INLINE_FORM_REFERENCE: { name: 'INLINE_FORM_REFERENCE', value: 5 },
        ROOT: { name: 'ROOT', value: 6 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    iC = {
        ADMIN: { name: 'ADMIN', value: 5 },
        AT_SCENE: { name: 'AT_SCENE', value: 8 },
        AVAILABLE: { name: 'AVAILABLE', value: 3 },
        AVAILABLE_EVENT_RELATED: { name: 'AVAILABLE_EVENT_RELATED', value: 22 },
        AVAILABLE_NON_EVENT_RELATED: { name: 'AVAILABLE_NON_EVENT_RELATED', value: 23 },
        DIRECTED_PATROL: { name: 'DIRECTED_PATROL', value: 4 },
        DISPATCHED: { name: 'DISPATCHED', value: 6 },
        EN_ROUTE: { name: 'EN_ROUTE', value: 7 },
        EN_ROUTE_ALTERNATE: { name: 'EN_ROUTE_ALTERNATE', value: 25 },
        HOSPITAL_TRANSPORT_ARRIVED: { name: 'HOSPITAL_TRANSPORT_ARRIVED', value: 27 },
        HOSPITAL_TRANSPORT_EN_ROUTE: { name: 'HOSPITAL_TRANSPORT_EN_ROUTE', value: 26 },
        OFF_DUTY: { name: 'OFF_DUTY', value: 19 },
        OUT_OF_SERVICE: { name: 'OUT_OF_SERVICE', value: 24 },
        PURSUIT_ARRIVED: { name: 'PURSUIT_ARRIVED', value: 13 },
        PURSUIT_EN_ROUTE: { name: 'PURSUIT_EN_ROUTE', value: 12 },
        REPORT_WRITING: { name: 'REPORT_WRITING', value: 9 },
        RESPONDING_COURT_ARRIVED: { name: 'RESPONDING_COURT_ARRIVED', value: 15 },
        RESPONDING_COURT_EN_ROUTE: { name: 'RESPONDING_COURT_EN_ROUTE', value: 14 },
        SERVICE_ASSIGNMENT: { name: 'SERVICE_ASSIGNMENT', value: 16 },
        SPECIAL_ASSIGNMENT: { name: 'SPECIAL_ASSIGNMENT', value: 18 },
        STAGING: { name: 'STAGING', value: 21 },
        SYSTEM_DISPATCHED: { name: 'SYSTEM_DISPATCHED', value: 20 },
        TRANSPORT_ARRIVED: { name: 'TRANSPORT_ARRIVED', value: 11 },
        TRANSPORT_EN_ROUTE: { name: 'TRANSPORT_EN_ROUTE', value: 10 },
        UNAVAILABLE: { name: 'UNAVAILABLE', value: 1 },
        UNIT_EMERGENCY: { name: 'UNIT_EMERGENCY', value: 28 },
        UNMANNED: { name: 'UNMANNED', value: 2 },
        VIRTUAL_PATROL: { name: 'VIRTUAL_PATROL', value: 17 },
    },
    WC = {
        DISPATCHER: { name: 'DISPATCHER', value: 1 },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER', value: 2 },
        SYSTEM: { name: 'SYSTEM', value: 4 },
        TEST: { name: 'TEST', value: 8 },
    },
    cC = { INCHES: { name: 'INCHES' }, POUNDS: { name: 'POUNDS' } },
    KC = {
        ADDED_ABILITY_ROLE_LINK: { name: 'ADDED_ABILITY_ROLE_LINK', value: 48 },
        ADDED_ROLE_TO_USER: { name: 'ADDED_ROLE_TO_USER', value: 52 },
        CREATED_USER_PROFILE: { name: 'CREATED_USER_PROFILE', value: 50 },
        DELETED_CASE: { name: 'DELETED_CASE', value: 65 },
        DELETED_MASTER_ENTITY: { name: 'DELETED_MASTER_ENTITY', value: 59 },
        DELETED_REPORT: { name: 'DELETED_REPORT', value: 46 },
        DISABLED_USER: { name: 'DISABLED_USER', value: 45 },
        DOWNLOADED_ATTACHMENT: { name: 'DOWNLOADED_ATTACHMENT', value: 26 },
        DOWNLOADED_BULK_ATTACHMENTS: { name: 'DOWNLOADED_BULK_ATTACHMENTS', value: 27 },
        EMAILED_REPORT: { name: 'EMAILED_REPORT', value: 64 },
        ENABLED_USER: { name: 'ENABLED_USER', value: 54 },
        EXPORTED_ATTACHMENT: { name: 'EXPORTED_ATTACHMENT', value: 63 },
        EXPORTED_BOLO: { name: 'EXPORTED_BOLO', value: 62 },
        EXPORTED_CAD_AGENCY_EVENT: { name: 'EXPORTED_CAD_AGENCY_EVENT', value: 61 },
        EXPORTED_CASE_JACKET_PDF: { name: 'EXPORTED_CASE_JACKET_PDF', value: 8 },
        EXPORTED_CASE_NOTE_PDF: { name: 'EXPORTED_CASE_NOTE_PDF', value: 9 },
        EXPORTED_INVENTORIES: { name: 'EXPORTED_INVENTORIES', value: 39 },
        EXPORTED_INVENTORY: { name: 'EXPORTED_INVENTORY', value: 40 },
        EXPORTED_PERSON_PROFILE: { name: 'EXPORTED_PERSON_PROFILE', value: 19 },
        EXPORTED_REPORT: { name: 'EXPORTED_REPORT', value: 14 },
        EXPORTED_WARRANT: { name: 'EXPORTED_WARRANT', value: 12 },
        EXPUNGED_MASTER_ENTITY: { name: 'EXPUNGED_MASTER_ENTITY', value: 60 },
        LOGGED_IN: { name: 'LOGGED_IN', value: 43 },
        LOGGED_OUT: { name: 'LOGGED_OUT', value: 44 },
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 56 },
        REMOVED_ABILITY_ROLE_LINK: { name: 'REMOVED_ABILITY_ROLE_LINK', value: 49 },
        REMOVED_ROLE_FROM_USER: { name: 'REMOVED_ROLE_FROM_USER', value: 53 },
        REQUESTED_PASSWORD_RESET: { name: 'REQUESTED_PASSWORD_RESET', value: 55 },
        UPDATED_USER_PROFILE: { name: 'UPDATED_USER_PROFILE', value: 57 },
        VIEWED_ALL_CASES_DASHBOARD: { name: 'VIEWED_ALL_CASES_DASHBOARD', value: 24 },
        VIEWED_ATTACHMENT: { name: 'VIEWED_ATTACHMENT', value: 28 },
        VIEWED_BOOKING: { name: 'VIEWED_BOOKING', value: 47 },
        VIEWED_CASE: { name: 'VIEWED_CASE', value: 1 },
        VIEWED_CASE_ASSOCIATED_RECORDS: { name: 'VIEWED_CASE_ASSOCIATED_RECORDS', value: 29 },
        VIEWED_CASE_ATTACHMENTS: { name: 'VIEWED_CASE_ATTACHMENTS', value: 25 },
        VIEWED_CASE_E_FILES: { name: 'VIEWED_CASE_E_FILES', value: 41 },
        VIEWED_CASE_FORENSICS: { name: 'VIEWED_CASE_FORENSICS', value: 38 },
        VIEWED_CASE_HISTORY: { name: 'VIEWED_CASE_HISTORY', value: 7 },
        VIEWED_CASE_LINKED_PROFILE: { name: 'VIEWED_CASE_LINKED_PROFILE', value: 5 },
        VIEWED_CASE_NOTE: { name: 'VIEWED_CASE_NOTE', value: 4 },
        VIEWED_CASE_NOTES_LIST: { name: 'VIEWED_CASE_NOTES_LIST', value: 3 },
        VIEWED_CASE_SUMMARY: { name: 'VIEWED_CASE_SUMMARY', value: 2 },
        VIEWED_CASE_TASK_LIST: { name: 'VIEWED_CASE_TASK_LIST', value: 6 },
        VIEWED_EVENT: { name: 'VIEWED_EVENT', value: 42 },
        VIEWED_MOBILE_COLLECTION: { name: 'VIEWED_MOBILE_COLLECTION', value: 31 },
        VIEWED_MOBILE_COLLECTIONS: { name: 'VIEWED_MOBILE_COLLECTIONS', value: 36 },
        VIEWED_MOBILE_COLLECTION_ARCHIVE: { name: 'VIEWED_MOBILE_COLLECTION_ARCHIVE', value: 30 },
        VIEWED_MY_CASES_DASHBOARD: { name: 'VIEWED_MY_CASES_DASHBOARD', value: 23 },
        VIEWED_NOTIFICATION_ALERTS: { name: 'VIEWED_NOTIFICATION_ALERTS', value: 34 },
        VIEWED_NOTIFICATION_ARCHIVE: { name: 'VIEWED_NOTIFICATION_ARCHIVE', value: 33 },
        VIEWED_NOTIFICATION_INBOX: { name: 'VIEWED_NOTIFICATION_INBOX', value: 32 },
        VIEWED_ORGANIZATION_PROFILE: { name: 'VIEWED_ORGANIZATION_PROFILE', value: 15 },
        VIEWED_PERSONAL_DASHBOARD: { name: 'VIEWED_PERSONAL_DASHBOARD', value: 35 },
        VIEWED_PERSON_PROFILE: { name: 'VIEWED_PERSON_PROFILE', value: 18 },
        VIEWED_PROPERTY_PROFILE: { name: 'VIEWED_PROPERTY_PROFILE', value: 17 },
        VIEWED_REPORT: { name: 'VIEWED_REPORT', value: 13 },
        VIEWED_REPORTS_DASHBOARD: { name: 'VIEWED_REPORTS_DASHBOARD', value: 21 },
        VIEWED_REPORT_HISTORY: { name: 'VIEWED_REPORT_HISTORY', value: 20 },
        VIEWED_TASKS_DASHBOARD: { name: 'VIEWED_TASKS_DASHBOARD', value: 37 },
        VIEWED_UNASSIGNED_CASES_DASHBOARD: { name: 'VIEWED_UNASSIGNED_CASES_DASHBOARD', value: 22 },
        VIEWED_USAGE_LOGS: { name: 'VIEWED_USAGE_LOGS', value: 51 },
        VIEWED_VEHICLE_PROFILE: { name: 'VIEWED_VEHICLE_PROFILE', value: 16 },
        VOIDED_REPORT: { name: 'VOIDED_REPORT', value: 58 },
        WARRANTS_DASHBOARD_VIEWED: { name: 'WARRANTS_DASHBOARD_VIEWED', value: 10 },
        WARRANT_RECORD_VIEWED: { name: 'WARRANT_RECORD_VIEWED', value: 11 },
    },
    dC = {
        FEATURE_FLAGGED_OFF: { name: 'FEATURE_FLAGGED_OFF', value: 5 },
        INSUFFICIENT_PERMISSIONS: { name: 'INSUFFICIENT_PERMISSIONS', value: 3 },
        SERVER_ERROR: { name: 'SERVER_ERROR', value: 2 },
        SUCCEEDED: { name: 'SUCCEEDED', value: 1 },
        UNAUTHORIZED: { name: 'UNAUTHORIZED', value: 4 },
    },
    pC = {
        PRIVATE: { name: 'PRIVATE', value: 3 },
        PROTECTED: { name: 'PROTECTED', value: 2 },
        PUBLIC: { name: 'PUBLIC', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    yC = {
        CAD: { name: 'CAD', value: 3 },
        FIRST_RESPONDER: { name: 'FIRST_RESPONDER', value: 4 },
        JMS: { name: 'JMS', value: 6 },
        MOBILE_RMS: { name: 'MOBILE_RMS', value: 2 },
        ON_SCENE: { name: 'ON_SCENE', value: 5 },
        RMS: { name: 'RMS', value: 1 },
    },
    XC = {
        ADMIN: { name: 'ADMIN', value: 10 },
        ANALYTICS: { name: 'ANALYTICS', value: 9 },
        BOLO: { name: 'BOLO', value: 15 },
        CAD_EVENTS: { name: 'CAD_EVENTS', value: 13 },
        CASE_MANAGEMENT: { name: 'CASE_MANAGEMENT', value: 1 },
        ENTITY_PROFILES: { name: 'ENTITY_PROFILES', value: 4 },
        EVIDENCE: { name: 'EVIDENCE', value: 8 },
        JMS: { name: 'JMS', value: 14 },
        NOTIFICATIONS: { name: 'NOTIFICATIONS', value: 5 },
        REPORTS: { name: 'REPORTS', value: 3 },
        RMS_GENERAL: { name: 'RMS_GENERAL', value: 6 },
        RMS_MOBILE: { name: 'RMS_MOBILE', value: 7 },
        SEARCH: { name: 'SEARCH', value: 11 },
        TASKS: { name: 'TASKS', value: 12 },
        WARRANTS: { name: 'WARRANTS', value: 2 },
    },
    QC = {
        BADGE_NUMBER: { name: 'BADGE_NUMBER' },
        EMAIL: { name: 'EMAIL' },
        EXTERNAL_ID: { name: 'EXTERNAL_ID' },
        HR_ID: { name: 'HR_ID' },
    },
    bC = {
        CALL_TAKER: { name: 'CALL_TAKER', value: 1 },
        COMMAND_STAFF: { name: 'COMMAND_STAFF', value: 2 },
        CORRECTIONS: { name: 'CORRECTIONS', value: 3 },
        CRIME_ANALYST: { name: 'CRIME_ANALYST', value: 4 },
        DISPATCHER: { name: 'DISPATCHER', value: 5 },
        DISPATCHER_SUPERVISOR: { name: 'DISPATCHER_SUPERVISOR', value: 6 },
        EVIDENCE_CLERK: { name: 'EVIDENCE_CLERK', value: 7 },
        EVIDENCE_SUPERVISOR: { name: 'EVIDENCE_SUPERVISOR', value: 8 },
        INVESTIGATOR: { name: 'INVESTIGATOR', value: 9 },
        INVESTIGATOR_SUPERVISOR: { name: 'INVESTIGATOR_SUPERVISOR', value: 10 },
        IT: { name: 'IT', value: 11 },
        MARK43_INTERNAL: { name: 'MARK43_INTERNAL', value: 12 },
        OTHER: { name: 'OTHER', value: 13 },
        PATROL: { name: 'PATROL', value: 14 },
        PATROL_SUPERVISOR: { name: 'PATROL_SUPERVISOR', value: 15 },
        PROSECUTOR: { name: 'PROSECUTOR', value: 16 },
        RECORDS: { name: 'RECORDS', value: 17 },
        RECORDS_SUPERVISOR: { name: 'RECORDS_SUPERVISOR', value: 18 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    fC = { CREATED: { name: 'CREATED', value: 1 }, UPDATED: { name: 'UPDATED', value: 2 } },
    gC = { ADDED: { name: 'ADDED', value: 1 }, REMOVED: { name: 'REMOVED', value: 2 } },
    JC = {
        AUTHENTICATION: { name: 'AUTHENTICATION', value: 'authentication' },
        CONFIRM_EMAIL: { name: 'CONFIRM_EMAIL', value: 'confirm_email' },
        CROSS_LOGIN: { name: 'CROSS_LOGIN', value: 'cross_login' },
        CSRF_AUTHENTICATION: { name: 'CSRF_AUTHENTICATION', value: 'csrf_authentication' },
        INACTIVITY: { name: 'INACTIVITY', value: 'inactivity' },
        ONE_FACTOR_SUCCESSFUL: { name: 'ONE_FACTOR_SUCCESSFUL', value: 'one_factor_successful' },
        PASSWORD_EXPIRED: { name: 'PASSWORD_EXPIRED', value: 'password_expired' },
        PASSWORD_RESET: { name: 'PASSWORD_RESET', value: 'password_reset' },
        RECOGNIZED_DEVICE: { name: 'RECOGNIZED_DEVICE', value: 'recognized_device' },
        REFRESH: { name: 'REFRESH', value: 'refresh' },
        UNKNOWN: { name: 'UNKNOWN', value: 'unknown' },
    },
    hC = {
        BIGINT: { name: 'BIGINT', value: 2 },
        BOOLEAN: { name: 'BOOLEAN', value: 6 },
        DATETIME: { name: 'DATETIME', value: 4 },
        DECIMAL: { name: 'DECIMAL', value: 3 },
        ID: { name: 'ID', value: 5 },
        STRING: { name: 'STRING', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    ZC = {
        ABBREVIATED_EXCLUDE_VIN: { name: 'ABBREVIATED_EXCLUDE_VIN' },
        SEQUENTIAL_ALL_FIELDS: { name: 'SEQUENTIAL_ALL_FIELDS' },
    },
    jC = {
        EXPORT_TO_BEXAR: { name: 'EXPORT_TO_BEXAR' },
        NONE: { name: 'NONE' },
        VERIFY_ACCEPTANCE_AND_REEXPORT_TO_BEXAR: {
            name: 'VERIFY_ACCEPTANCE_AND_REEXPORT_TO_BEXAR',
        },
    },
    xC = {
        ERROR: { name: 'ERROR', value: 4 },
        MATCH: { name: 'MATCH', value: 2 },
        MISMATCH: { name: 'MISMATCH', value: 3 },
        NOT_RUN: { name: 'NOT_RUN', value: 1 },
    },
    kC = {
        CANCELLED: { name: 'CANCELLED', value: 'CANCELLED' },
        COMPLETED: { name: 'COMPLETED', value: 'COMPLETED' },
        SCHEDULED: { name: 'SCHEDULED', value: 'SCHEDULED' },
    },
    wC = {
        CANCEL: { name: 'CANCEL', value: 2 },
        ENTRY: { name: 'ENTRY', value: 1 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
    },
    zC = {
        HTTPS: { name: 'HTTPS', value: 2 },
        REDIS: { name: 'REDIS', value: 5 },
        UNKNOWN: { name: 'UNKNOWN', value: -1 },
        WEBSOCKET: { name: 'WEBSOCKET', value: 4 },
    },
    qC = {
        FAILED_DEPENDENCY: { name: 'FAILED_DEPENDENCY' },
        INSUFFICIENT_STORAGE: { name: 'INSUFFICIENT_STORAGE' },
        LOCKED: { name: 'LOCKED' },
        MULTI_STATUS: { name: 'MULTI_STATUS' },
        UNPROCESSABLE_ENTITY: { name: 'UNPROCESSABLE_ENTITY' },
    },
    $C = {
        FAIL: { name: 'FAIL', value: 3 },
        NOT_RUN: { name: 'NOT_RUN', value: 1 },
        PASS: { name: 'PASS', value: 2 },
    },
    En = { HANDLEBAR: { name: 'HANDLEBAR', value: 1 }, MADLIBS: { name: 'MADLIBS', value: 2 } },
    _n = {
        ATTRIBUTES: { name: 'ATTRIBUTES', value: 2 },
        INDEXED_DB: { name: 'INDEXED_DB', value: 1 },
        MAP_DATA: { name: 'MAP_DATA', value: 7 },
        METADATA: { name: 'METADATA', value: 3 },
        NETWORK: { name: 'NETWORK', value: 10 },
        PROCESSES: { name: 'PROCESSES', value: 9 },
        SCREENSHOT: { name: 'SCREENSHOT', value: 5 },
        SYSTEM_INFO: { name: 'SYSTEM_INFO', value: 8 },
        TEXT: { name: 'TEXT', value: 6 },
        WORLD_V2: { name: 'WORLD_V2', value: 4 },
    },
    Tn = {
        ELECTRON: { name: 'ELECTRON', value: 2 },
        FIRST_RESPONDER_ELECTRON: { name: 'FIRST_RESPONDER_ELECTRON', value: 4 },
        FIRST_RESPONDER_WEB: { name: 'FIRST_RESPONDER_WEB', value: 3 },
        WEB: { name: 'WEB', value: 1 },
    },
    en = {
        ENTITY: { name: 'ENTITY', value: 1 },
        MULTI_INSTANCE: { name: 'MULTI_INSTANCE', value: 4 },
        SINGLE_INSTANCE: { name: 'SINGLE_INSTANCE', value: 2 },
        SINGLE_INSTANCE_PER_WINDOW: { name: 'SINGLE_INSTANCE_PER_WINDOW', value: 3 },
    },
    An = {
        BOLO: { name: 'BOLO', value: 11, workspacePanelCategory: 'ENTITY' },
        BOLO_SEARCH: { name: 'BOLO_SEARCH', value: 12, workspacePanelCategory: 'ENTITY' },
        COMMAND_LINE: {
            name: 'COMMAND_LINE',
            value: 3,
            workspacePanelCategory: 'SINGLE_INSTANCE_PER_WINDOW',
        },
        CONTACT_LIST: { name: 'CONTACT_LIST', value: 5, workspacePanelCategory: 'SINGLE_INSTANCE' },
        DATA_EXCHANGE_FORM: {
            name: 'DATA_EXCHANGE_FORM',
            value: 9,
            workspacePanelCategory: 'SINGLE_INSTANCE',
        },
        DATA_EXCHANGE_FORMS: {
            name: 'DATA_EXCHANGE_FORMS',
            value: 7,
            workspacePanelCategory: 'SINGLE_INSTANCE',
        },
        DATA_EXCHANGE_RESULTS: {
            name: 'DATA_EXCHANGE_RESULTS',
            value: 8,
            workspacePanelCategory: 'SINGLE_INSTANCE',
        },
        DEV_TOOLS: {
            name: 'DEV_TOOLS',
            value: 16,
            workspacePanelCategory: 'SINGLE_INSTANCE_PER_WINDOW',
        },
        EVENT: { name: 'EVENT', value: 2, workspacePanelCategory: 'ENTITY' },
        EXPUNGEMENTS: {
            name: 'EXPUNGEMENTS',
            value: 17,
            workspacePanelCategory: 'SINGLE_INSTANCE_PER_WINDOW',
        },
        MEDIA_ATTACHMENTS: {
            name: 'MEDIA_ATTACHMENTS',
            value: 18,
            workspacePanelCategory: 'ENTITY',
        },
        MESSAGING: { name: 'MESSAGING', value: 4, workspacePanelCategory: 'SINGLE_INSTANCE' },
        NOTIFICATION_CENTER: {
            name: 'NOTIFICATION_CENTER',
            value: 14,
            workspacePanelCategory: 'SINGLE_INSTANCE_PER_WINDOW',
        },
        QUEUE: { name: 'QUEUE', value: 1, workspacePanelCategory: 'ENTITY' },
        QUEUE_FORM: { name: 'QUEUE_FORM', value: 15, workspacePanelCategory: 'MULTI_INSTANCE' },
        REQUEST_FOR_ASSISTANCE_FORM: {
            name: 'REQUEST_FOR_ASSISTANCE_FORM',
            value: 13,
            workspacePanelCategory: 'ENTITY',
        },
        SCHEDULED_EVENT: { name: 'SCHEDULED_EVENT', value: 10, workspacePanelCategory: 'ENTITY' },
        UNIT_HISTORY: { name: 'UNIT_HISTORY', value: 6, workspacePanelCategory: 'SINGLE_INSTANCE' },
    },
    Nn = {
        AVL: { isCadNext: !1, name: 'AVL', panelsPermitted: !1, value: 3 },
        BOLO: { isCadNext: !1, name: 'BOLO', panelsPermitted: !0, value: 6 },
        BOLO_SEARCH: { isCadNext: !0, name: 'BOLO_SEARCH', panelsPermitted: !1, value: 7 },
        CAD_SEARCH: { isCadNext: !1, name: 'CAD_SEARCH', panelsPermitted: !1, value: 4 },
        EVENT: { isCadNext: !1, name: 'EVENT', panelsPermitted: !0, value: 2 },
        EVENT_SEARCH_V2: { isCadNext: !0, name: 'EVENT_SEARCH_V2', panelsPermitted: !1, value: 10 },
        EVENT_V2: { isCadNext: !0, name: 'EVENT_V2', panelsPermitted: !0, value: 9 },
        MAP_V2: { isCadNext: !0, name: 'MAP_V2', panelsPermitted: !1, value: 12 },
        QUEUE: { isCadNext: !1, name: 'QUEUE', panelsPermitted: !0, value: 1 },
        QUEUE_V2: { isCadNext: !0, name: 'QUEUE_V2', panelsPermitted: !0, value: 8 },
        UNIT_STATUS_SEARCH: {
            isCadNext: !1,
            name: 'UNIT_STATUS_SEARCH',
            panelsPermitted: !1,
            value: 5,
        },
        UNIT_STATUS_SEARCH_V2: {
            isCadNext: !0,
            name: 'UNIT_STATUS_SEARCH_V2',
            panelsPermitted: !1,
            value: 11,
        },
    };
export {
    d_ as AbilityRoleLinkEventTypeEnum,
    p_ as AccessorTypeEnum,
    y_ as ActionEnum,
    X_ as ActionTypeEnum,
    Q_ as AdditionalInfoPriorityEnum,
    J as AdditionalInfoSystemMessageConfigResource,
    b_ as AdditionalInfoSystemMessageTypeEnum,
    f_ as AdditionalInfoTypeEnum,
    jE as AdminResource,
    g_ as AdminVersionStatusEnum,
    J_ as AedLogTypeEnum,
    h_ as AedStateEnum,
    Z_ as AgencyAssistanceStatusEnum,
    j_ as AgencyEventRadioChannelTypeEnum,
    x_ as AlternateQueueStyleEnum,
    T_ as AmlResource,
    k_ as AmlSourceEnum,
    w_ as ApiBailAttributeTypeEnum,
    z_ as ApiBailTypeEnum,
    q_ as ApiEFileActionTypeEnum,
    $_ as ApiEFileCpsCaseStatusEnum,
    ET as ApiEFileMessageCodeEnum,
    _T as ApiEFileOffenseAttributeTypeEnum,
    TT as ApiEFileOffenseDateRangeEnum,
    eT as ApiEFileSubmissionTypeEnum,
    AT as ApiEFileWitnessOrVictimReasonTypeEnum,
    NT as ApiItemInvolvementTypeEnum,
    IT as ApiLiveScanIntegrationStatusEnum,
    RT as ApiOffenseDateRangeEnum,
    aT as AppNameEnum,
    OT as ApplicationEnum,
    ST as ApplicationNameEnum,
    CT as ApplicationSettingCacheKeyTypeEnum,
    nT as ApprovalLevelEnum,
    DT as ApprovalStatusEnum,
    LT as ApprovalStatusForCaseEnum,
    mT as AssignedToTypeEnumEnum,
    A as AssigneventResource,
    lT as AttachmentLogTypeEnum,
    uT as AttachmentSourceTypeEnum,
    m as AttachmentsResource,
    PT as AttributeCsvFieldStringsEnum,
    UT as AttributeLabelOptionEnum,
    MT as AttributeStatusEnum,
    vT as AttributeTypeEnum,
    FT as AudioAlertPreferenceMigrationSkipReasonEnum,
    NE as AuthcadResource,
    GT as AuthenticationTypeEnum,
    xE as AutomaticRenGenerationResource,
    HT as AxonEvidenceFileTypeEnum,
    YT as BailTypeEnum,
    tT as BatchOperationItemStatusEnum,
    VT as BexarPersonOfInterestReportTypeEnum,
    oT as BlacksmithTagEnum,
    BT as BlacksmithTypeEnum,
    rT as BoloAdditionalInfoChangeTypeEnum,
    C as BoloResource,
    sT as BookingStatusEnum,
    iT as BookingWorkflowTypeEnum,
    WT as BootstrapFetchModeEnumEnum,
    KE as BootstrapResource,
    cT as BriefingStateEnum,
    KT as BufferMinutesTimerMigrationSkipReasonEnum,
    dT as BuildEnvironmentEnum,
    pT as BulkImportTypeEnum,
    c_ as BulkResource,
    yT as CadChannelAppNameEnum,
    XT as CadChannelChannelNameEnum,
    QT as CadFeatureEnum,
    bT as CadIntegrationProfileMetaConfigKeyEnum,
    fT as CadIntegrationProtocolEnum,
    gT as CadIntegrationTriageQuestionTypeEnum,
    JT as CadNextNotificationActionEnum,
    hT as CadNextNotificationEntityEnum,
    ZT as CadNextNotificationPriorityEnum,
    jT as CadNextNotificationTypeEnum,
    xT as CadPlatformEnum,
    RE as CadPrintResource,
    kT as CadSchemaVersionTableEnum,
    LE as CadSearchResource,
    SE as CadSearchsaveResource,
    p as CaddepartmentResource,
    wT as CalendarEventStatusEnum,
    S as CallTakerStationResource,
    zT as CaseMyInvolvementEnum,
    qT as CategoryEnumEnum,
    $T as CategoryStringEnumEnum,
    dE as CautionsTabResource,
    Ee as CdcEntityUpdateOperationTypeEnum,
    _e as CdcFileProcessingStatusTypeEnum,
    ME as CfsResource,
    Te as ChangeTypeEnum,
    ee as ChangeTypeEnumEnum,
    Ae as ChangeTypesEnumEnum,
    o as ChannelsResource,
    P as ClearEventResource,
    Ne as CliArgumentEnum,
    Ie as CliArgumentTypeEnum,
    Re as CliArgumentUsageTypeEnum,
    ae as CliAuditStatusEnum,
    Oe as CliClientActionTypeEnum,
    Se as CliExecutionResponseTokenTypeEnum,
    n as CliResource,
    Ce as ClientApprovalStatusEnum,
    ne as ClrkPReportExportTypeEnum,
    De as ClrkPReportExtractTypeEnum,
    Le as ClrkPReportFilterTypeEnum,
    me as CodeTypeCategoryEnum,
    le as CodeTypeSourceEnum,
    ue as CollectionItemTypeEnum,
    YE as ColorSoundConfigResource,
    Pe as ColumnDefinitionEnum,
    Ue as CommandNameEnum,
    Me as CommandStatusEnum,
    ve as CommunicationRequestStatusEnum,
    Fe as ComparisonTypeEnumEnum,
    Ge as CompleteLinkTypesEnum,
    He as ComplianceExportErrorCodeEnum,
    Ye as ComplianceExportProgressPhaseEnum,
    te as ComplianceExportTypeEnum,
    Ve as ComplianceFinalExportStateEnum,
    oe as ComplianceGroupEnum,
    Be as ComponentEnum,
    re as ConcernRouterStatusEnum,
    se as ConfigurableNamesEnum,
    ie as ConfiguredRuleEffectTargetContextEnum,
    We as ConfiguredRuleEffectTypeEnum,
    ce as ConfiguredRuleMessageReferenceTypeEnum,
    Ke as ConfiguredRuleOperatorEnum,
    de as ConfiguredRuleOperatorValueTypeEnum,
    pe as ConfiguredRuleOutcomeTypeEnum,
    ye as ConnectionStatusEnum,
    Xe as ConnectionStatusSourceEnum,
    Qe as ConsumerTypeEnum,
    be as ContactEnumEnum,
    hE as ContextMenuResource,
    fe as ContextTypeEnum,
    ge as ConversationMemberTypeEnum,
    Je as ConversationParticipantTypeEnum,
    he as ConversationStatusEnum,
    j as ConversationViewResource,
    b as CopyCallResource,
    Ze as CoreModelEnum,
    je as CoronialTypeEnum,
    xe as CountryCodeEnum,
    ke as CourtRoomTimeSlotBookingTypeEnum,
    we as CpsCaseStatusEnum,
    ze as CrimeReportsAddressFormatEnum,
    qe as DashboardAreaEnum,
    $e as DashboardSectionEnum,
    EA as DataExchangeCliCommandEnum,
    _A as DataExchangeEntryPointEnum,
    TA as DataRetentionPolicyTypeEnum,
    eA as DataTableEnum,
    AA as DatasliceBlacksmithOptionEnum,
    N as DebugResource,
    NA as DebugStatusEnum,
    P_ as DebugquartzResource,
    IA as DeduplicatePersonProfileDecisionEnum,
    RA as DeliveryMethodEnum,
    aA as DeliveryPathEnum,
    X as DepartmentConfigurationResource,
    OA as DepartmentLocalTypeEnum,
    SA as DepartmentLoginDisclaimerEnum,
    pE as DepartmentResource,
    CA as DepartmentStatusEnum,
    nA as DependencyKindEnum,
    QE as DexActivityTabResource,
    DA as DexDispatcherFormEnum,
    LA as DexEntityTypeEnum,
    mA as DexFieldWidthEnum,
    bE as DexFormsResource,
    V as DexIntegrationResource,
    lA as DexQueryEnum,
    uA as DexRegionEnum,
    PA as DexVendorEnum,
    UA as DiagnosticContextEnum,
    MA as DiagramCategoryEnum,
    vA as DiagramTypeEnum,
    FA as DirectionEnum,
    GA as DiscardReasonEnum,
    HA as DispatchAreaOwnershipEnum,
    YA as DispatchAreaStatusEnum,
    tA as DispatchAreaUserTypeEnum,
    AE as DispatchAreasResource,
    VA as DisplayModeEnum,
    U as DispositionResource,
    oA as DispositionStatusEnum,
    fE as DispositionsTabResource,
    BA as DlqPolicyEnum,
    yE as DuplicateEventSearchConfigResource,
    t_ as DuplicateEventSearchResource,
    rA as DurationParamConverterEnum,
    sA as DutyStatusEnum,
    iA as DynamicCardTypeEnum,
    WA as DynamicEnumTypeEnum,
    cA as EFileAbpStatusEnum,
    KA as EFileDocumentBundleSectionEnum,
    dA as EFileDocumentTypeEnum,
    pA as EFileOffenseDecisionModuleEnum,
    yA as EFileOffenseDecisionTypeOptionsEnum,
    XA as EFileRelatedEntityActionEnum,
    l as EditUnitResource,
    QA as ElasticCobaltSortKeyEnum,
    bA as ElasticCobaltSortTypeEnum,
    fA as ElasticMultifieldTypeEnum,
    IE as ElasticSearchResource,
    gA as ElasticSearchTypeEnum,
    D as ElasticSearchsavedSearchesResource,
    D_ as ElasticSearchsearchUsageStatsResource,
    JA as ElectronAppNamesEnum,
    u_ as ElectronVersionResource,
    hA as EmailRateLimitReservationStatusEnum,
    ZA as EmailRequestStatusEnum,
    jA as EmailTemplateEnum,
    xA as EmailTypeEnum,
    kA as EmptyCheckStrategyEnum,
    wA as EncryptionTypeEnum,
    zA as EntityContainerEnum,
    qA as EntityLinkLimitDecisionEnum,
    $A as EntityLinkPaginationModeEnum,
    EN as EntityLinkReadOutcomeEnum,
    B as EntityPermissionsResource,
    _N as EntityTypeEnum,
    TN as EsriAddressComponentTypeEnum,
    eN as EsriCredentialSourceEnum,
    AN as EsriLocationTypeEnum,
    NN as EventActionEnumEnum,
    IN as EventAssociationTypeEnum,
    RN as EventBackfillStatusEnum,
    ZE as EventDetailsTabResource,
    aN as EventEntityLinkCategoryEnum,
    L_ as EventEntityLinkTypeResource,
    ON as EventPanelFocusFieldEnum,
    DE as EventPanelResource,
    SN as EventQueueEnum,
    T as EventResource,
    CN as EventTypeEnumEnum,
    g as EventadditionalInfoResource,
    k as EventlabelsResource,
    nN as ExcelCellStyleTypeEnum,
    uE as ExecutecliResource,
    DN as ExportEntityModeEnum,
    LN as ExportEntityStatusEnum,
    mN as ExportIntervalTypeEnum,
    lN as ExportOptionTypeEnum,
    uN as ExportReleaseTypeEnum,
    PN as ExportReportVersionEnum,
    UN as ExportsStreamMessageTypeEnum,
    MN as ExpungementChangeTypeEnum,
    PE as ExpungementsResource,
    vN as ExternalActionSeverityEnum,
    FN as ExternalActionTypeEnum,
    GN as ExternalAgencyActionContextKeyEnum,
    w as ExternalAgencyActionResource,
    HN as ExternalAgencyEventActionTypeEnum,
    YN as ExternalCadActivityTypeEnum,
    tN as ExternalCadOnlineStatusTypeEnum,
    VN as ExternalCaseApprovalStatusEnum,
    oN as ExternalEventOriginEnum,
    BN as ExternalEventStatusEnum,
    rN as ExternalEventUnitStatusEnum,
    sN as ExternalOutboxMessageProcessingStatusEnum,
    iN as ExternalReportApprovalStatusEnum,
    WN as ExternalReportCreationStatusEnum,
    cN as ExternalReportRetrievalStatusEnum,
    KN as ExternalReportTypeEnum,
    dN as ExternalSourceTypeEnum,
    pN as ExternalTypesEnum,
    yN as FFSourceEnum,
    XN as FederalJudicialDistrictCodeEnum,
    QN as FederatedSearchEntryPointEnum,
    bN as FederatedSearchQueryLinkTypeEnum,
    fN as FederatedSearchQueryStatusEnumEnum,
    gN as FederatedSearchQueryableEntityTypeEnum,
    oE as FederatedSearchResource,
    JN as FieldAccessStrategyEnum,
    hN as FieldAndTagCategoryEnum,
    ZN as FieldAndTagTypeEnum,
    jN as FieldCauseEnum,
    xN as FieldNameEnum,
    kN as FieldTypeEnum,
    wN as FieldTypeEnumEnum,
    zN as FileCategoryEnum,
    qN as FileSourceEnum,
    $N as FileStatusEnum,
    EI as FileTypeEnum,
    _I as FilterTypeEnum,
    TI as ForensicResultStatusEnum,
    eI as FormDisplayEnumEnum,
    AI as FormEnum,
    O as FormResource,
    NI as FormStatusEnum,
    II as FormTypeEnum,
    RI as FormTypeEnumEnum,
    aI as FormValueTypeEnum,
    OI as FrequencyTypeEnum,
    SI as GateConfigTierEnum,
    CI as GenericFieldTypeEnum,
    nI as GeoFileUploadStatusEnum,
    DI as GeoFileUploadTypeEnum,
    z as GeofenceResource,
    LI as GeofenceRuleTypeEnum,
    mI as GisDataSourceProcessStatusEnum,
    lI as GrafanaAlertStateEnum,
    uI as HateCrimeOffenseCodeEnum,
    vE as HeldVehicleAuditResource,
    PI as HistoryEventCategoryEnum,
    UI as HistoryEventTypeEnum,
    MI as HistoryValueTypeEnum,
    vI as HitTypeEnum,
    wE as HoldEventResource,
    FI as HoldEventUnitGroupEnum,
    nE as HospitalsResource,
    GI as HydrationOptionsEnum,
    HI as IdFormatTypeEnum,
    YI as IdTypeEnum,
    tI as IdempotencyStatusEnum,
    VI as ImageSizeEnum,
    oI as IncidentSeverityEnum,
    BI as IncidentSourceEnum,
    rI as IndeterminateBlacksmithStateEnum,
    sI as IndexNamesEnum,
    iI as InlineCommentStatusEnum,
    WI as InputTypeEnum,
    cI as IntegrationStatusEnum,
    KI as InvolvementStatusEnum,
    dI as ItemInvolvementTypeEnum,
    pI as JmsBookingStatusEnum,
    yI as JmsLocationStatusEnum,
    XI as JmsLocationTypeEnum,
    QI as JmsTimerStatusEnum,
    bI as JsonApiDataSourcePermissionEnum,
    fI as JsonApiOriginTypeEnum,
    gI as JsonApiTypeEnum,
    JI as JsonApiUserAttributeTypeEnum,
    hI as JsonApiWorkspaceAttributeTypeEnum,
    ZI as JsonApiWorkspacePermissionEnum,
    jI as KafkaClusterEnum,
    xI as KafkaProducerRoleEnum,
    kI as KafkaTopicEnum,
    wI as KindEnum,
    s_ as LatestSeenDexIncomingMessageResource,
    zI as LegacyEntityTypeEnum,
    qI as LinkTypesEnum,
    $I as LiveScanEventTypeEnum,
    R as LoadTestingResource,
    ER as LocationClassificationProviderEnum,
    _R as LocationSourceEnum,
    TR as LocationTypeEnum,
    eR as LocationTypeEnumEnum,
    H_ as LocationsResource,
    AR as LoginResultTypeEnum,
    NR as LookerEmbeddableSectionTypeEnum,
    IR as LookerEmbeddableTypeEnum,
    RR as M43FormCoreEntityKeyNameEnum,
    aR as M43FormSyncOperationEnum,
    zE as ManageDispatchAreasResource,
    iE as ManageUnitsResource,
    OR as ManageUnitsUnitGroupEnum,
    SR as MapFilterTypeEnum,
    CR as MapGpsTypeEnum,
    JE as MapViewsResource,
    nR as Mark43LouisianaNibrsErrorCodeEnum,
    DR as Mark43NibrsErrorCodeEnum,
    LR as MasterEntityDeleteExpungeOperationEnum,
    mR as MasterProfileCriteriaTypeEnum,
    lR as MasterProfilePreferenceTypeEnum,
    uR as MasterProfilePropertyEnum,
    M as MasterProfileResource,
    PR as MaterializedLocationSubTypeEnum,
    UR as MaterializedLocationTypeEnum,
    WE as MaterializedUserActionsResource,
    MR as MeasurementSystemEnum,
    vR as MeasurementUnitEnum,
    FR as MentionCategoryEnum,
    cE as MergeEventViewsResource,
    $E as MergedEventsTabResource,
    GR as MessageDirectionEnum,
    HR as MessagePriorityEnum,
    YR as MessageStatusEnum,
    tR as MessageTopicNameEnum,
    UE as MessagingResource,
    VR as MetricTypeEnum,
    l_ as MetricsResource,
    C_ as MetricsTestResource,
    oR as MigrationErrorCodeEnum,
    BR as MobileApplicationEnum,
    rR as MobilePlatformEnum,
    E_ as MobiledepartmentResource,
    $ as MobileeventResource,
    sR as ModeEnum,
    iR as ModelTypeEnum,
    WR as ModuleGroupEnum,
    cR as MonitorActionEnum,
    KR as MoveUpCommitRejectReasonEnum,
    dR as MoveUpCommitStatusEnum,
    pR as MugshotViewTypeEnum,
    yR as MysqlConnectionModeEnum,
    XR as NarrativeCreationKindEnum,
    QR as NarrativePriorityEnum,
    EE as NarrativeResource,
    _E as NeighboringSubdivisionsResource,
    bR as NibrsCrimeAgainstCategoryEnum,
    fR as NibrsErrorTypeEnum,
    gR as NibrsFinalExportStateEnum,
    JR as NibrsFlagEnum,
    hR as NibrsOffenseCodeEnum,
    ZR as NibrsOffenseGroupEnum,
    jR as NibrsTranslatorErrorCodeEnum,
    xR as NotificationCategoryEnum,
    kR as NotificationCenterFilterTypeEnum,
    wR as NotificationCenterSortTypeEnum,
    zR as NotificationPriorityEnum,
    qR as NotificationStatusEnum,
    $R as NotificationTypeEnum,
    Ea as NotificationViewTypeEnum,
    eE as NotificationsResource,
    _a as NudgeKeyValuesEnum,
    m_ as ObservabilityResource,
    Ta as OffenseCodeEnum,
    ea as OffenseCodeWordingTypeEnum,
    Aa as OffenseDateRangeEnum,
    Na as OfficerInvolvementEnum,
    Ia as OfficerTypeEnum,
    Ra as OpEnumEnum,
    aa as OpenApiValidationErrorsEnum,
    Oa as OperatingSystemTypeEnum,
    Sa as OperationEnum,
    Ca as OperationTypeEnum,
    na as OptionEnum,
    Da as PaletteColorEnum,
    La as PaperFormatEnum,
    v as ParsedCodeMappingsResource,
    ma as ParsedUnmappedCodeSourceEnum,
    W_ as PartnerResource,
    la as PasswordResetEventTypeEnum,
    F as PatrolResource,
    ua as PersonsSearchResultsDefaultEnum,
    Pa as PhoneCallAckActionTakenEnum,
    E as PhoneCallsResource,
    Ua as PhoneCountryCodeEnum,
    Ma as PhoneNumberTypeEnum,
    va as PhoneTypeEnum,
    Fa as PhotoLineupViewOptionEnum,
    Ga as PinActionEnum,
    Ha as PostcoderResolutionModeEnum,
    Ya as PreconditionHttpStatusEnum,
    ta as PreferenceEnum,
    Va as PreferenceGroupEnum,
    oa as PreferencePermissionEnum,
    __ as PreferencesResource,
    Ba as PrintingDataTypeEnum,
    ra as PrintingTemplateTypeEnum,
    sa as PriorityEnumEnum,
    ia as ProQaDescriptionSectionTypeEnum,
    Wa as ProQaEventsActionEnum,
    Q as ProQaResource,
    ca as ProQaSettingTypeEnum,
    Ka as ProQaStateEnum,
    da as ProductModuleEnum,
    pa as ProfessionalProfileTypeEnum,
    ya as PrologBundleFileOwnerEnum,
    Xa as PrologCanonicalEngineStateEnum,
    Qa as PrologConfigStatusEnum,
    ba as PrologEngineReplayRunStateEnum,
    fa as PrologEngineReplayRunStatusEnum,
    ga as PrologEngineReplayVerdictEnum,
    Ja as PrologEngineStatusEnum,
    ha as PrologEvalReplyStatusEnum,
    Za as PrologEvaluationCapturedReasonEnum,
    ja as PrologEvaluationErrorKindEnum,
    xa as PrologEvaluationPurposeEnum,
    ka as PrologEvaluationStatusEnum,
    wa as PrologGateVerdictEnum,
    za as PrologPreviewWarningTypeEnum,
    qa as PrologReplayDivergenceKindEnum,
    $a as PrologReplayEventStatusEnum,
    EO as PrologReplaySkipReasonEnum,
    _O as PrologShadowDivergenceEnum,
    TO as PrologValidationRunStatusEnum,
    eO as PrologValidationStatusEnum,
    N_ as PrologadminResource,
    Z as PrologadminbundleResource,
    XE as PrologadmindepartmentsResource,
    e as PrologadmindeploymentsResource,
    gE as PrologadminengineReplayResource,
    x as PrologadminengineversionsResource,
    S_ as PrologadminvalidationResource,
    AO as PropertyDescriptionCodeEnum,
    A_ as ProqaadminsettingResource,
    NO as QueryValueStrategyEnum,
    IO as QueueClassEnum,
    RO as QueueDisplayDensityEnum,
    aO as QueueSortEnum,
    u as QueueViewsResource,
    I as QueuesResource,
    OO as QuickCrashNarrativeTypeEnum,
    TE as RadioChannelResource,
    SO as RadioChannelStatusEnum,
    e_ as RapidsosResource,
    s as ReactivateEventResource,
    CO as RealtimeStreamClassificationEnum,
    nO as RealtimeUpdateTypeEnum,
    DO as ReasonEnum,
    LO as RedactionModeEnum,
    mO as RedisAckBehaviorEnum,
    lO as RedisClusterEnum,
    uO as RedisStreamLengthLimitEnum,
    PO as RefContextEnum,
    UO as RegionEnum,
    MO as RegionalGroupEnum,
    I_ as RelatedDataResource,
    vO as RelatedToTypeEnumEnum,
    FO as RelationshipOfVictimToOffenderCodeEnum,
    F_ as ReleaseUnitsResource,
    GO as RenConfigurationEnum,
    HO as ReportAreaEnum,
    YO as ReportBeamCsvUserTypeEnum,
    tO as ReportCommentTypeEnum,
    VO as ReportHistoryVisibilityLevelEnum,
    oO as ReportTitleFormatEnum,
    sE as ReportingEventNumberResource,
    G_ as RequestAssistanceResource,
    q as RequestForAssistanceResource,
    BO as ResizePaddingTypeEnumEnum,
    rO as ResourcePatternTypeEnum,
    sO as ResponsePlanBarrierTypeEnum,
    iO as ResponsePlanCsvValidationErrorTypeEnum,
    WO as ResponsePlanFileTypeEnum,
    cO as ResponsePlanNodeTypeEnum,
    KO as ResponsePlanRequestActionReasonEnum,
    dO as ResponsePlanSourceEnum,
    pO as ResponsePlanTieBreakTypeEnum,
    yO as ResponsePlanTreeTypeEnum,
    aE as ResponsePlansResource,
    FE as ResponsePlanscsvResource,
    GE as ResponsePlanscsvmockResource,
    Y_ as RestartnotificationResource,
    XO as RestrictedReportOwnerFilterEnum,
    QO as ResubmissionStatusEnum,
    bO as RetryEventTypeEnum,
    fO as RetryFailureTypeEnum,
    gO as RfaActionPriorityEnum,
    JO as RfaActionTypeEnum,
    hO as RfaErrorTypeEnum,
    ZO as RfaTimeoutStateEnum,
    c as RfaincomingResource,
    v_ as RfatestingResource,
    rE as RmsIntegrationResource,
    qE as RmsResource,
    jO as RoleTypeEnum,
    xO as RolloutStateEnum,
    OE as RolodexResource,
    kO as RootCauseEnum,
    wO as RotationActionEnum,
    W as RotationResource,
    zO as RoutingGateStateEnum,
    qO as RoutingTransportEnum,
    $O as RuleBooleanOperatorEnum,
    ES as RuleComparisonOperatorEnum,
    _S as RuleConditionArgTypeEnum,
    TS as RuleFieldGetterEnum,
    eS as RuleTypeEnum,
    AS as RunOrderComponentTypeEnumEnum,
    NS as RunOrderTypeEnum,
    IS as ScheduleRecurrenceTypeEnum,
    RS as ScheduledEventInstanceStatusEnum,
    aS as ScheduledInstanceTypeEnum,
    OS as ScimGroupFieldEnum,
    SS as ScimSchemasEnum,
    CS as ScimUserFieldEnum,
    nS as SealingActionEnum,
    DS as SearchSyncMetricStatusEnum,
    LS as SearchSyncQueuePriorityEnum,
    mS as SearchSyncThrottleEnum,
    lS as SecretCipherFailureEnum,
    uS as SegmentOffenseCodesEnum,
    PS as SensorCacheKeyEnum,
    US as SensorClassificationOutcomesEnum,
    MS as SensorFunnelStagesEnum,
    vS as SensorRejectionReasonEnum,
    FS as SensorTraceOutcomesEnum,
    GS as SensorTypeDtoEnum,
    HS as SensorTypeEnum,
    R_ as SensorsResource,
    YS as SentStatusEnum,
    tS as ServiceNameEnum,
    VS as SexualAssaultOffenseCodeEnum,
    oS as ShortcutCommandEnum,
    BS as ShortcutContextEnum,
    CE as ShortcutKeysResource,
    rS as SideBarOptionsEnum,
    sS as SimpleValidationErrorTypeEnum,
    f as SmartPhoneResource,
    iS as SmsMessageProviderTypeEnum,
    WS as SmsTemplateEnum,
    cS as SortCriteriaEnum,
    KS as SortDirectionEnum,
    dS as SortOrderEnum,
    pS as SortOrderEnumEnum,
    yS as SoundEnum,
    XS as SourceEnumEnum,
    QS as SourceTypeEnum,
    bS as SsoServiceNameEnum,
    fS as StaffCountSkipReasonEnum,
    gS as StateEnum,
    JS as StatePlaneZoneEnum,
    G as StationsResource,
    hS as StatusEnum,
    ZS as StatusEnumEnum,
    jS as StatusStringEnumEnum,
    xS as StorageLocationTypeEnum,
    kS as StreamTopicConfigResolvedSourceEnum,
    o_ as StreamTopicConfigResource,
    wS as StreetSegmentParityEnum,
    zS as StreetSegmentSideEnum,
    HE as SubjectDatasResource,
    H as SubjectStopResource,
    qS as SubjectTypeEnum,
    $S as SubmissionCredentialModeEnum,
    EC as SubmissionFormatEnum,
    _C as SubmissionProtocolEnum,
    TC as SubmissionResponseParserEnum,
    eC as SubmissionStateEnumEnum,
    AC as SubmissionSyncOperationEnumEnum,
    NC as SuffixTypeEnum,
    IC as SummaryCategoryEnum,
    mE as SupportadminccsRolloutResource,
    r as SupportadminexpungementsResource,
    B_ as SupportcrashInfoResource,
    lE as SupporteventBackfillResource,
    n_ as SupportintegrationResource,
    K as SupportmigrationResource,
    BE as SupportsearchResource,
    RC as SyncDomainEnum,
    aC as SyncErrorCategoryEnum,
    OC as SyncOutcomeEnum,
    d as SystemResource,
    SC as SystemRuleEnum,
    CC as TagCategoryEnum,
    nC as TemplateMigrationStatusEnum,
    DC as TierEnum,
    LC as TimeSourceEnum,
    mC as TimeredEventStatusEnum,
    lC as TimersHistoryItemTypeEnum,
    kE as TimersResource,
    uC as TitleBarOptionsEnum,
    PC as TopicCreateStatusEnum,
    M_ as TracingResource,
    L as TrackedClientActionResource,
    UC as TrackedClientActionTypeEnum,
    MC as TrafficCrashComplianceExportFailureTypeEnum,
    vC as TransactionMetadataEnum,
    Y as TransportResource,
    FC as TriggerEnum,
    GC as TriggerFamilyEnum,
    HC as TwoFactorMethodEnum,
    YC as TypeEnum,
    tC as TypeOfNumberEnumEnum,
    VC as TypeOfPropertyLossCodeEnum,
    oC as UcrCategoryEnum,
    BC as UcrSummaryCodeEnum,
    rC as UcrSummaryOffensePartEnum,
    sC as UiTypeEnum,
    V_ as UnitHistoryResource,
    t as UnitLocationResource,
    _ as UnitResource,
    iC as UnitStateGroupEnum,
    WC as UnitStateTransitionPermissionEnum,
    VE as UnitTimerPolicyResource,
    r_ as UnitTimerResource,
    cC as UnitsEnum,
    O_ as UnitsTabResource,
    tE as UnitstateResource,
    i_ as UpdateToEventResource,
    KC as UsageActionEnum,
    dC as UsageCompletionEnum,
    pC as UsageLevelEnum,
    yC as UsageSourceApplicationEnum,
    XC as UsageSourceModuleEnum,
    K_ as UserAssignmentResource,
    QC as UserCompareByFieldEnum,
    bC as UserGroupEnum,
    fC as UserProfileEventTypeEnum,
    gC as UserRoleEventTypeEnum,
    JC as UserTokenTypeEnum,
    i as UserpollResource,
    a_ as UsxIntegrationResource,
    y as V2Resource,
    a as V2TestingResource,
    hC as ValueTypeEnum,
    ZC as VehicleParagraphFormatEnum,
    jC as VendorReleaseExportTypeEnum,
    xC as VerifyJavaVerdictEnum,
    kC as VoluntaryAttendanceAppointmentStatusEnum,
    wC as WarrantDexSendTypeEnum,
    zC as WarshipCommunicationsTypeEnum,
    qC as WebDavHttpStatusEnum,
    U_ as WebhooksverkadaResource,
    $C as WireSmokeVerdictEnum,
    En as WordingTemplateTypeEnum,
    _n as WorkflowFileTypeEnum,
    Tn as WorkspaceModeEnum,
    en as WorkspacePanelCategoryEnum,
    An as WorkspacePanelTypeEnum,
    Nn as WorkspaceWindowTypeEnum,
    h as WorkspacesResource,
};
